/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		2: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + ({}[chunkId]||chunkId) + "." + {"0":"43ff3dc184bd6bc5b086","1":"ab589a24e2a29f29b886"}[chunkId] + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/build/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 169);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var core = __webpack_require__(20);
var hide = __webpack_require__(12);
var redefine = __webpack_require__(13);
var ctx = __webpack_require__(21);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(5);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v2.2.0
 * http://jquery.com/
 *
 * Includes Sizzle.js
 * http://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-01-08T20:02Z
 */

(function( global, factory ) {

	if ( typeof module === "object" && typeof module.exports === "object" ) {
		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Support: Firefox 18+
// Can't be in strict mode, several libs including ASP.NET trace
// the stack via arguments.caller.callee and Firefox dies if
// you try to trace through "use strict" call chains. (#13335)
//"use strict";
var arr = [];

var document = window.document;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var support = {};



var
	version = "2.2.0",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android<4.1
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,

	// Matches dashed string for camelizing
	rmsPrefix = /^-ms-/,
	rdashAlpha = /-([\da-z])/gi,

	// Used by jQuery.camelCase as callback to replace()
	fcamelCase = function( all, letter ) {
		return letter.toUpperCase();
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// Start with an empty selector
	selector: "",

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {
		return num != null ?

			// Return just the one element from the set
			( num < 0 ? this[ num + this.length ] : this[ num ] ) :

			// Return all the elements in a clean array
			slice.call( this );
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;
		ret.context = this.context;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = jQuery.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && jQuery.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isFunction: function( obj ) {
		return jQuery.type( obj ) === "function";
	},

	isArray: Array.isArray,

	isWindow: function( obj ) {
		return obj != null && obj === obj.window;
	},

	isNumeric: function( obj ) {

		// parseFloat NaNs numeric-cast false positives (null|true|false|"")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		// adding 1 corrects loss of precision from parseFloat (#15100)
		var realStringObj = obj && obj.toString();
		return !jQuery.isArray( obj ) && ( realStringObj - parseFloat( realStringObj ) + 1 ) >= 0;
	},

	isPlainObject: function( obj ) {

		// Not plain objects:
		// - Any object or value whose internal [[Class]] property is not "[object Object]"
		// - DOM nodes
		// - window
		if ( jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
			return false;
		}

		if ( obj.constructor &&
				!hasOwn.call( obj.constructor.prototype, "isPrototypeOf" ) ) {
			return false;
		}

		// If the function hasn't returned already, we're confident that
		// |obj| is a plain object, created by {} or constructed with new Object
		return true;
	},

	isEmptyObject: function( obj ) {
		var name;
		for ( name in obj ) {
			return false;
		}
		return true;
	},

	type: function( obj ) {
		if ( obj == null ) {
			return obj + "";
		}

		// Support: Android<4.0, iOS<6 (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		var script,
			indirect = eval;

		code = jQuery.trim( code );

		if ( code ) {

			// If the code includes a valid, prologue position
			// strict mode pragma, execute code by injecting a
			// script tag into the document.
			if ( code.indexOf( "use strict" ) === 1 ) {
				script = document.createElement( "script" );
				script.text = code;
				document.head.appendChild( script ).parentNode.removeChild( script );
			} else {

				// Otherwise, avoid the DOM node creation, insertion
				// and removal by using an indirect global eval

				indirect( code );
			}
		}
	},

	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE9-11+
	// Microsoft forgot to hump their vendor prefix (#9572)
	camelCase: function( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	},

	nodeName: function( elem, name ) {
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android<4.1
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// Bind a function to a context, optionally partially applying any
	// arguments.
	proxy: function( fn, context ) {
		var tmp, args, proxy;

		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !jQuery.isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	},

	now: Date.now,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

// JSHint would error on this code due to the Symbol not being defined in ES5.
// Defining this global in .jshintrc would create a danger of using the global
// unguarded in another place, it seems safer to just disable JSHint for these
// three lines.
/* jshint ignore: start */
if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}
/* jshint ignore: end */

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: iOS 8.2 (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = jQuery.type( obj );

	if ( type === "function" || jQuery.isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.2.1
 * http://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2015-10-17
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// General-purpose constants
	MAX_NEGATIVE = 1 << 31,

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// http://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,
	rescape = /'|\\/g,

	// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	};

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, nidselect, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rescape, "\\$&" );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					nidselect = ridentifier.test( nid ) ? "#" + nid : "[id='" + nid + "']";
					while ( i-- ) {
						groups[i] = nidselect + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created div and expects a boolean result
 */
function assert( fn ) {
	var div = document.createElement("div");

	try {
		return !!fn( div );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( div.parentNode ) {
			div.parentNode.removeChild( div );
		}
		// release memory in IE
		div = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			( ~b.sourceIndex || MAX_NEGATIVE ) -
			( ~a.sourceIndex || MAX_NEGATIVE );

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, parent,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( (parent = document.defaultView) && parent.top !== parent ) {
		// Support: IE 11
		if ( parent.addEventListener ) {
			parent.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( parent.attachEvent ) {
			parent.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( div ) {
		div.className = "i";
		return !div.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( div ) {
		div.appendChild( document.createComment("") );
		return !div.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( div ) {
		docElem.appendChild( div ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID find and filter
	if ( support.getById ) {
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var m = context.getElementById( id );
				return m ? [ m ] : [];
			}
		};
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
	} else {
		// Support: IE6/7
		// getElementById is not reliable as a find shortcut
		delete Expr.find["ID"];

		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See http://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( div ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// http://bugs.jquery.com/ticket/12359
			docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( div.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !div.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !div.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibing-combinator selector` fails
			if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( div ) {
			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			div.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( div.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( !div.querySelectorAll(":enabled").length ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			div.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( div ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( div, "div" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( div, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": function( elem ) {
			return elem.disabled === false;
		},

		"disabled": function( elem ) {
			return elem.disabled === true;
		},

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		checkNonElements = base && dir === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( (oldCache = uniqueCache[ dir ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ dir ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				support.getById && context.nodeType === 9 && documentIsHTML &&
				Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( div1 ) {
	// Should return 1, but returns 4 (following)
	return div1.compareDocumentPosition( document.createElement("div") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( div ) {
	div.innerHTML = "<a href='#'></a>";
	return div.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( div ) {
	div.innerHTML = "<input/>";
	div.firstChild.setAttribute( "value", "" );
	return div.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( div ) {
	return div.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;



var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = ( /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/ );



var risSimple = /^.[^:#\[\.,]*$/;

// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( jQuery.isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			/* jshint -W018 */
			return !!qualifier.call( elem, i, elem ) !== not;
		} );

	}

	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );

	}

	if ( typeof qualifier === "string" ) {
		if ( risSimple.test( qualifier ) ) {
			return jQuery.filter( qualifier, elements, not );
		}

		qualifier = jQuery.filter( qualifier, elements );
	}

	return jQuery.grep( elements, function( elem ) {
		return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
	} );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	return elems.length === 1 && elem.nodeType === 1 ?
		jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
		jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i,
			len = this.length,
			ret = [],
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		// Needed because $( selector, context ) becomes $( context ).find( selector )
		ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
		ret.selector = this.selector ? this.selector + " " + selector : selector;
		return ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( jQuery.isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					// Support: Blackberry 4.6
					// gEBID returns nodes no longer in the document (#6963)
					if ( elem && elem.parentNode ) {

						// Inject the element directly into the jQuery object
						this.length = 1;
						this[ 0 ] = elem;
					}

					this.context = document;
					this.selector = selector;
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this.context = this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( jQuery.isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		if ( selector.selector !== undefined ) {
			this.selector = selector.selector;
			this.context = selector.context;
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
				jQuery( selectors, context || this.context ) :
				0;

		for ( ; i < l; i++ ) {
			for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

				// Always skip document fragments
				if ( cur.nodeType < 11 && ( pos ?
					pos.index( cur ) > -1 :

					// Don't pass non-elements to Sizzle
					cur.nodeType === 1 &&
						jQuery.find.matchesSelector( cur, selectors ) ) ) {

					matched.push( cur );
					break;
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		return elem.contentDocument || jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnotwhite = ( /\S+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( jQuery.isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, listener list, final state
				[ "resolve", "done", jQuery.Callbacks( "once memory" ), "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ), "rejected" ],
				[ "notify", "progress", jQuery.Callbacks( "memory" ) ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				then: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;
					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {
							var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];

							// deferred[ done | fail | progress ] for forwarding actions to newDefer
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && jQuery.isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this === promise ? newDefer.promise() : this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Keep pipe for back-compat
		promise.pipe = promise.then;

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 3 ];

			// promise[ done | fail | progress ] = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add( function() {

					// state = [ resolved | rejected ]
					state = stateString;

				// [ reject_list | resolve_list ].disable; progress_list.lock
				}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
			}

			// deferred[ resolve | reject | notify ]
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? promise : this, arguments );
				return this;
			};
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( subordinate /* , ..., subordinateN */ ) {
		var i = 0,
			resolveValues = slice.call( arguments ),
			length = resolveValues.length,

			// the count of uncompleted subordinates
			remaining = length !== 1 ||
				( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,

			// the master Deferred.
			// If resolveValues consist of only a single Deferred, just use that.
			deferred = remaining === 1 ? subordinate : jQuery.Deferred(),

			// Update function for both resolve and progress values
			updateFunc = function( i, contexts, values ) {
				return function( value ) {
					contexts[ i ] = this;
					values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( values === progressValues ) {
						deferred.notifyWith( contexts, values );
					} else if ( !( --remaining ) ) {
						deferred.resolveWith( contexts, values );
					}
				};
			},

			progressValues, progressContexts, resolveContexts;

		// Add listeners to Deferred subordinates; treat others as resolved
		if ( length > 1 ) {
			progressValues = new Array( length );
			progressContexts = new Array( length );
			resolveContexts = new Array( length );
			for ( ; i < length; i++ ) {
				if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
					resolveValues[ i ].promise()
						.progress( updateFunc( i, progressContexts, progressValues ) )
						.done( updateFunc( i, resolveContexts, resolveValues ) )
						.fail( deferred.reject );
				} else {
					--remaining;
				}
			}
		}

		// If we're not waiting on anything, resolve the master
		if ( !remaining ) {
			deferred.resolveWith( resolveContexts, resolveValues );
		}

		return deferred.promise();
	}
} );


// The deferred used on DOM ready
var readyList;

jQuery.fn.ready = function( fn ) {

	// Add the callback
	jQuery.ready.promise().done( fn );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Hold (or release) the ready event
	holdReady: function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	},

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );

		// Trigger any bound ready events
		if ( jQuery.fn.triggerHandler ) {
			jQuery( document ).triggerHandler( "ready" );
			jQuery( document ).off( "ready" );
		}
	}
} );

/**
 * The ready event handler and self cleanup method
 */
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

jQuery.ready.promise = function( obj ) {
	if ( !readyList ) {

		readyList = jQuery.Deferred();

		// Catch cases where $(document).ready() is called
		// after the browser event has already occurred.
		// Support: IE9-10 only
		// Older IE sometimes signals "interactive" too soon
		if ( document.readyState === "complete" ||
			( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

			// Handle it asynchronously to allow scripts the opportunity to delay ready
			window.setTimeout( jQuery.ready );

		} else {

			// Use the handy event callback
			document.addEventListener( "DOMContentLoaded", completed );

			// A fallback to window.onload, that will always work
			window.addEventListener( "load", completed );
		}
	}
	return readyList.promise( obj );
};

// Kick off the DOM ready check even if the user does not
jQuery.ready.promise();




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( jQuery.type( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !jQuery.isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	return chainable ?
		elems :

		// Gets
		bulk ?
			fn.call( elems ) :
			len ? fn( elems[ 0 ], key ) : emptyGet;
};
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	/* jshint -W018 */
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	register: function( owner, initial ) {
		var value = initial || {};

		// If it is a node unlikely to be stringify-ed or looped over
		// use plain assignment
		if ( owner.nodeType ) {
			owner[ this.expando ] = value;

		// Otherwise secure it in a non-enumerable, non-writable property
		// configurability must be true to allow the property to be
		// deleted with the delete operator
		} else {
			Object.defineProperty( owner, this.expando, {
				value: value,
				writable: true,
				configurable: true
			} );
		}
		return owner[ this.expando ];
	},
	cache: function( owner ) {

		// We can accept data for non-element nodes in modern browsers,
		// but we should not, see #8335.
		// Always return an empty object.
		if ( !acceptData( owner ) ) {
			return {};
		}

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		if ( typeof data === "string" ) {
			cache[ data ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ prop ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :
			owner[ this.expando ] && owner[ this.expando ][ key ];
	},
	access: function( owner, key, value ) {
		var stored;

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			stored = this.get( owner, key );

			return stored !== undefined ?
				stored : this.get( owner, jQuery.camelCase( key ) );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i, name, camel,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key === undefined ) {
			this.register( owner );

		} else {

			// Support array or space separated string of keys
			if ( jQuery.isArray( key ) ) {

				// If "name" is an array of keys...
				// When data is initially created, via ("key", "val") signature,
				// keys will be converted to camelCase.
				// Since there is no way to tell _how_ a key was added, remove
				// both plain key and camelCase key. #12786
				// This will only penalize the array argument path.
				name = key.concat( key.map( jQuery.camelCase ) );
			} else {
				camel = jQuery.camelCase( key );

				// Try the string as a key before any manipulation
				if ( key in cache ) {
					name = [ key, camel ];
				} else {

					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					name = camel;
					name = name in cache ?
						[ name ] : ( name.match( rnotwhite ) || [] );
				}
			}

			i = name.length;

			while ( i-- ) {
				delete cache[ name[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <= 35-45+
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://code.google.com/p/chromium/issues/detail?id=378607
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = data === "true" ? true :
					data === "false" ? false :
					data === "null" ? null :

					// Only convert to a number if it doesn't change the string
					+data + "" === data ? +data :
					rbrace.test( data ) ? jQuery.parseJSON( data ) :
					data;
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE11+
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = jQuery.camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data, camelKey;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// with the key as-is
				data = dataUser.get( elem, key ) ||

					// Try to find dashed key if it exists (gh-2779)
					// This is for 2.2.x only
					dataUser.get( elem, key.replace( rmultiDash, "-$&" ).toLowerCase() );

				if ( data !== undefined ) {
					return data;
				}

				camelKey = jQuery.camelCase( key );

				// Attempt to get data from the cache
				// with the key camelized
				data = dataUser.get( elem, camelKey );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, camelKey, undefined );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			camelKey = jQuery.camelCase( key );
			this.each( function() {

				// First, attempt to store a copy or reference of any
				// data that might've been store with a camelCased key.
				var data = dataUser.get( this, camelKey );

				// For HTML5 data-* attribute interop, we have to
				// store property names with dashes in a camelCase form.
				// This might not apply to all properties...*
				dataUser.set( this, camelKey, value );

				// *... In the case of properties that might _actually_
				// have dashes, we need to also store a copy of that
				// unchanged property.
				if ( key.indexOf( "-" ) > -1 && data !== undefined ) {
					dataUser.set( this, key, value );
				}
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || jQuery.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHidden = function( elem, el ) {

		// isHidden might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;
		return jQuery.css( elem, "display" ) === "none" ||
			!jQuery.contains( elem.ownerDocument, elem );
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted,
		scale = 1,
		maxIterations = 20,
		currentValue = tween ?
			function() { return tween.cur(); } :
			function() { return jQuery.css( elem, prop, "" ); },
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		do {

			// If previous iteration zeroed out, double until we get *something*.
			// Use string for doubling so we don't accidentally see scale as unchanged below
			scale = scale || ".5";

			// Adjust and apply
			initialInUnit = initialInUnit / scale;
			jQuery.style( elem, prop, initialInUnit + unit );

		// Update scale, tolerating zero or NaN from tween.cur()
		// Break the loop if scale is unchanged or perfect, or if we've just had enough.
		} while (
			scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
		);
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([\w:-]+)/ );

var rscriptType = ( /^$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE9
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE9
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE9-11+
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret = typeof context.getElementsByTagName !== "undefined" ?
			context.getElementsByTagName( tag || "*" ) :
			typeof context.querySelectorAll !== "undefined" ?
				context.querySelectorAll( tag || "*" ) :
			[];

	return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
		jQuery.merge( [ context ], ret ) :
		ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( jQuery.type( elem ) === "object" ) {

				// Support: Android<4.1, PhantomJS<2
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android<4.1, PhantomJS<2
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0-4.3, Safari<=5.1
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Safari<=5.1, Android<4.2
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE<=11+
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();


var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE9
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return this;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnotwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnotwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( event ) {

		// Make a writable jQuery.Event from the native event object
		event = jQuery.event.fix( event );

		var i, j, ret, matched, handleObj,
			handlerQueue = [],
			args = slice.call( arguments ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;
		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, matches, sel, handleObj,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Support (at least): Chrome, IE9
		// Find delegate handlers
		// Black-hole SVG <use> instance trees (#13180)
		//
		// Support: Firefox<=42+
		// Avoid non-left-click in FF but don't block IE radio events (#3861, gh-2343)
		if ( delegateCount && cur.nodeType &&
			( event.type !== "click" || isNaN( event.button ) || event.button < 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && ( cur.disabled !== true || event.type !== "click" ) ) {
					matches = [];
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matches[ sel ] === undefined ) {
							matches[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matches[ sel ] ) {
							matches.push( handleObj );
						}
					}
					if ( matches.length ) {
						handlerQueue.push( { elem: cur, handlers: matches } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: this, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	// Includes some event props shared by KeyEvent and MouseEvent
	props: ( "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase " +
		"metaKey relatedTarget shiftKey target timeStamp view which" ).split( " " ),

	fixHooks: {},

	keyHooks: {
		props: "char charCode key keyCode".split( " " ),
		filter: function( event, original ) {

			// Add which for key events
			if ( event.which == null ) {
				event.which = original.charCode != null ? original.charCode : original.keyCode;
			}

			return event;
		}
	},

	mouseHooks: {
		props: ( "button buttons clientX clientY offsetX offsetY pageX pageY " +
			"screenX screenY toElement" ).split( " " ),
		filter: function( event, original ) {
			var eventDoc, doc, body,
				button = original.button;

			// Calculate pageX/Y if missing and clientX/Y available
			if ( event.pageX == null && original.clientX != null ) {
				eventDoc = event.target.ownerDocument || document;
				doc = eventDoc.documentElement;
				body = eventDoc.body;

				event.pageX = original.clientX +
					( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) -
					( doc && doc.clientLeft || body && body.clientLeft || 0 );
				event.pageY = original.clientY +
					( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) -
					( doc && doc.clientTop  || body && body.clientTop  || 0 );
			}

			// Add which for click: 1 === left; 2 === middle; 3 === right
			// Note: button is not normalized, so don't use it
			if ( !event.which && button !== undefined ) {
				event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
			}

			return event;
		}
	},

	fix: function( event ) {
		if ( event[ jQuery.expando ] ) {
			return event;
		}

		// Create a writable copy of the event object and normalize some properties
		var i, prop, copy,
			type = event.type,
			originalEvent = event,
			fixHook = this.fixHooks[ type ];

		if ( !fixHook ) {
			this.fixHooks[ type ] = fixHook =
				rmouseEvent.test( type ) ? this.mouseHooks :
				rkeyEvent.test( type ) ? this.keyHooks :
				{};
		}
		copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;

		event = new jQuery.Event( originalEvent );

		i = copy.length;
		while ( i-- ) {
			prop = copy[ i ];
			event[ prop ] = originalEvent[ prop ];
		}

		// Support: Cordova 2.5 (WebKit) (#13255)
		// All events should have a target; Cordova deviceready doesn't
		if ( !event.target ) {
			event.target = document;
		}

		// Support: Safari 6.0+, Chrome<28
		// Target should not be a text node (#504, #13143)
		if ( event.target.nodeType === 3 ) {
			event.target = event.target.parentNode;
		}

		return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return jQuery.nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android<4.0
				src.returnValue === false ?
			returnTrue :
			returnFalse;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || jQuery.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://code.google.com/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {
	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,

	// Support: IE 10-11, Edge 10240+
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rscriptTypeMasked = /^true\/(.*)/,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

function manipulationTarget( elem, content ) {
	if ( jQuery.nodeName( elem, "table" ) &&
		jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return elem.getElementsByTagName( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	var match = rscriptTypeMasked.exec( elem.type );

	if ( match ) {
		elem.type = match[ 1 ];
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		isFunction = jQuery.isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( isFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( isFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android<4.1, PhantomJS<2
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							jQuery.globalEval( node.textContent.replace( rcleanScript, "" ) );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <= 35-45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <= 35-45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {

	// Keep domManip exposed until 3.0 (gh-2225)
	domManip: domManip,

	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: QtWebKit
			// .get() because push.apply(_, arraylike) throws
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );


var iframe,
	elemdisplay = {

		// Support: Firefox
		// We have to pre-define these values for FF (#10227)
		HTML: "block",
		BODY: "block"
	};

/**
 * Retrieve the actual display of a element
 * @param {String} name nodeName of the element
 * @param {Object} doc Document object
 */

// Called only from within defaultDisplay
function actualDisplay( name, doc ) {
	var elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),

		display = jQuery.css( elem[ 0 ], "display" );

	// We don't have any data stored on the element,
	// so use "detach" method as fast way to get rid of the element
	elem.detach();

	return display;
}

/**
 * Try to determine the default display value of an element
 * @param {String} nodeName
 */
function defaultDisplay( nodeName ) {
	var doc = document,
		display = elemdisplay[ nodeName ];

	if ( !display ) {
		display = actualDisplay( nodeName, doc );

		// If the simple way fails, read from inside an iframe
		if ( display === "none" || !display ) {

			// Use the already-created iframe if possible
			iframe = ( iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" ) )
				.appendTo( doc.documentElement );

			// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
			doc = iframe[ 0 ].contentDocument;

			// Support: IE
			doc.write();
			doc.close();

			display = actualDisplay( nodeName, doc );
			iframe.detach();
		}

		// Store the correct default display
		elemdisplay[ nodeName ] = display;
	}

	return display;
}
var rmargin = ( /^margin/ );

var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var documentElement = document.documentElement;



( function() {
	var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE9-11+
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
		"padding:0;margin-top:1px;position:absolute";
	container.appendChild( div );

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {
		div.style.cssText =

			// Support: Firefox<29, Android 2.3
			// Vendor-prefix box-sizing
			"-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;" +
			"position:relative;display:block;" +
			"margin:auto;border:1px;padding:1px;" +
			"top:1%;width:50%";
		div.innerHTML = "";
		documentElement.appendChild( container );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";
		reliableMarginLeftVal = divStyle.marginLeft === "2px";
		boxSizingReliableVal = divStyle.width === "4px";

		// Support: Android 4.0 - 4.3 only
		// Some styles come back with percentage values, even though they shouldn't
		div.style.marginRight = "50%";
		pixelMarginRightVal = divStyle.marginRight === "4px";

		documentElement.removeChild( container );
	}

	jQuery.extend( support, {
		pixelPosition: function() {

			// This test is executed only once but we still do memoizing
			// since we can use the boxSizingReliable pre-computing.
			// No need to check if the test was already performed, though.
			computeStyleTests();
			return pixelPositionVal;
		},
		boxSizingReliable: function() {
			if ( boxSizingReliableVal == null ) {
				computeStyleTests();
			}
			return boxSizingReliableVal;
		},
		pixelMarginRight: function() {

			// Support: Android 4.0-4.3
			// We're checking for boxSizingReliableVal here instead of pixelMarginRightVal
			// since that compresses better and they're computed together anyway.
			if ( boxSizingReliableVal == null ) {
				computeStyleTests();
			}
			return pixelMarginRightVal;
		},
		reliableMarginLeft: function() {

			// Support: IE <=8 only, Android 4.0 - 4.3 only, Firefox <=3 - 37
			if ( boxSizingReliableVal == null ) {
				computeStyleTests();
			}
			return reliableMarginLeftVal;
		},
		reliableMarginRight: function() {

			// Support: Android 2.3
			// Check if div with explicit width and no margin-right incorrectly
			// gets computed margin-right based on width of container. (#3333)
			// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
			// This support function is only executed once so no memoizing is needed.
			var ret,
				marginDiv = div.appendChild( document.createElement( "div" ) );

			// Reset CSS: box-sizing; display; margin; border; padding
			marginDiv.style.cssText = div.style.cssText =

				// Support: Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:content-box;box-sizing:content-box;" +
				"display:block;margin:0;border:0;padding:0";
			marginDiv.style.marginRight = marginDiv.style.width = "0";
			div.style.width = "1px";
			documentElement.appendChild( container );

			ret = !parseFloat( window.getComputedStyle( marginDiv ).marginRight );

			documentElement.removeChild( container );
			div.removeChild( marginDiv );

			return ret;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,
		style = elem.style;

	computed = computed || getStyles( elem );

	// Support: IE9
	// getPropertyValue is only needed for .css('filter') (#12537)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// http://dev.w3.org/csswg/cssom/#resolved-values
		if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE9-11+
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,

	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "O", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	var i = extra === ( isBorderBox ? "border" : "content" ) ?

		// If we already have the right measurement, avoid augmentation
		4 :

		// Otherwise initialize for horizontal or vertical properties
		name === "width" ? 1 : 0,

		val = 0;

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin, so add it if we want it
		if ( extra === "margin" ) {
			val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
		}

		if ( isBorderBox ) {

			// border-box includes padding, so remove it if we want content
			if ( extra === "content" ) {
				val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// At this point, extra isn't border nor margin, so remove border
			if ( extra !== "margin" ) {
				val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		} else {

			// At this point, extra isn't content, so add padding
			val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// At this point, extra isn't content nor padding, so add border
			if ( extra !== "padding" ) {
				val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	return val;
}

function getWidthOrHeight( elem, name, extra ) {

	// Start with offset property, which is equivalent to the border-box value
	var valueIsBorderBox = true,
		val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
		styles = getStyles( elem ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

	// Support: IE11 only
	// In IE 11 fullscreen elements inside of an iframe have
	// 100x too small dimensions (gh-1764).
	if ( document.msFullscreenElement && window.top !== window ) {

		// Support: IE11 only
		// Running getBoundingClientRect on a disconnected node
		// in IE throws an error.
		if ( elem.getClientRects().length ) {
			val = Math.round( elem.getBoundingClientRect()[ name ] * 100 );
		}
	}

	// Some non-html elements return undefined for offsetWidth, so check for null/undefined
	// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
	// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
	if ( val <= 0 || val == null ) {

		// Fall back to computed then uncomputed css if necessary
		val = curCSS( elem, name, styles );
		if ( val < 0 || val == null ) {
			val = elem.style[ name ];
		}

		// Computed unit is not pixels. Stop here and return.
		if ( rnumnonpx.test( val ) ) {
			return val;
		}

		// Check for style in case a browser which returns unreliable values
		// for getComputedStyle silently falls back to the reliable elem.style
		valueIsBorderBox = isBorderBox &&
			( support.boxSizingReliable() || val === elem.style[ name ] );

		// Normalize "", auto, and prepare for extra
		val = parseFloat( val ) || 0;
	}

	// Use the active box-sizing model to add/subtract irrelevant styles
	return ( val +
		augmentWidthOrHeight(
			elem,
			name,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles
		)
	) + "px";
}

function showHide( elements, show ) {
	var display, elem, hidden,
		values = [],
		index = 0,
		length = elements.length;

	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		values[ index ] = dataPriv.get( elem, "olddisplay" );
		display = elem.style.display;
		if ( show ) {

			// Reset the inline display of this element to learn if it is
			// being hidden by cascaded rules or not
			if ( !values[ index ] && display === "none" ) {
				elem.style.display = "";
			}

			// Set elements which have been overridden with display: none
			// in a stylesheet to whatever the default browser style is
			// for such an element
			if ( elem.style.display === "" && isHidden( elem ) ) {
				values[ index ] = dataPriv.access(
					elem,
					"olddisplay",
					defaultDisplay( elem.nodeName )
				);
			}
		} else {
			hidden = isHidden( elem );

			if ( display !== "none" || !hidden ) {
				dataPriv.set(
					elem,
					"olddisplay",
					hidden ? display : jQuery.css( elem, "display" )
				);
			}
		}
	}

	// Set the display of most of the elements in a second loop
	// to avoid the constant reflow
	for ( index = 0; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}
		if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
			elem.style.display = show ? values[ index ] || "" : "none";
		}
	}

	return elements;
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {
		"float": "cssFloat"
	},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = jQuery.camelCase( name ),
			style = elem.style;

		name = jQuery.cssProps[ origName ] ||
			( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// Support: IE9-11+
			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				style[ name ] = value;
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = jQuery.camelCase( name );

		// Make sure that we're working with the right name
		name = jQuery.cssProps[ origName ] ||
			( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}
		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, name ) {
	jQuery.cssHooks[ name ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
					elem.offsetWidth === 0 ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, name, extra );
						} ) :
						getWidthOrHeight( elem, name, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = extra && getStyles( elem ),
				subtract = extra && augmentWidthOrHeight(
					elem,
					name,
					extra,
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					styles
				);

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ name ] = value;
				value = jQuery.css( elem, name );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// Support: Android 2.3
jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
	function( elem, computed ) {
		if ( computed ) {
			return swap( elem, { "display": "inline-block" },
				curCSS, [ elem, "marginRight" ] );
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( !rmargin.test( prefix ) ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( jQuery.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	},
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHidden( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE9
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back Compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, timerId,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = jQuery.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4 ; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	/* jshint validthis: true */
	var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHidden( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Handle queue: false promises
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Height/width overflow pass
	if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {

		// Make sure that nothing sneaks out
		// Record all 3 overflow attributes because IE9-10 do not
		// change the overflow attribute when overflowX and
		// overflowY are set to the same value
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Set display property to inline-block for height/width
		// animations on inline elements that are having width/height animated
		display = jQuery.css( elem, "display" );

		// Test default display if display is currently "none"
		checkDisplay = display === "none" ?
			dataPriv.get( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;

		if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {
			style.display = "inline-block";
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// show/hide pass
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.exec( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// If there is dataShow left over from a stopped hide or show
				// and we are going to proceed with show, we should pretend to be hidden
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );

		// Any non-fx value stops us from restoring the original display value
		} else {
			display = undefined;
		}
	}

	if ( !jQuery.isEmptyObject( orig ) ) {
		if ( dataShow ) {
			if ( "hidden" in dataShow ) {
				hidden = dataShow.hidden;
			}
		} else {
			dataShow = dataPriv.access( elem, "fxshow", {} );
		}

		// Store state if its toggle - enables .stop().toggle() to "reverse"
		if ( toggle ) {
			dataShow.hidden = !hidden;
		}
		if ( hidden ) {
			jQuery( elem ).show();
		} else {
			anim.done( function() {
				jQuery( elem ).hide();
			} );
		}
		anim.done( function() {
			var prop;

			dataPriv.remove( elem, "fxshow" );
			for ( prop in orig ) {
				jQuery.style( elem, prop, orig[ prop ] );
			}
		} );
		for ( prop in orig ) {
			tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );

			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = tween.start;
				if ( hidden ) {
					tween.end = tween.start;
					tween.start = prop === "width" || prop === "height" ? 1 : 0;
				}
			}
		}

	// If this is a noop like .hide().hide(), restore an overwritten display value
	} else if ( ( display === "none" ? defaultDisplay( elem.nodeName ) : display ) === "inline" ) {
		style.display = display;
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = jQuery.camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( jQuery.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length ; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			if ( percent < 1 && length ) {
				return remaining;
			} else {
				deferred.resolveWith( elem, [ animation ] );
				return false;
			}
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length ; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( jQuery.isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					jQuery.proxy( result.stop, result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( jQuery.isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	// attach callbacks from options
	return animation.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );
}

jQuery.Animation = jQuery.extend( Animation, {
	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( jQuery.isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnotwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length ; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			jQuery.isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
	};

	opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ?
		opt.duration : opt.duration in jQuery.fx.speeds ?
			jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( jQuery.isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHidden ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = jQuery.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Checks the timer has not already been removed
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	if ( timer() ) {
		jQuery.fx.start();
	} else {
		jQuery.timers.pop();
	}
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( !timerId ) {
		timerId = window.setInterval( jQuery.fx.tick, jQuery.fx.interval );
	}
};

jQuery.fx.stop = function() {
	window.clearInterval( timerId );

	timerId = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// http://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: iOS<=5.1, Android<=4.2+
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE<=11+
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: Android<=2.3
	// Options inside disabled selects are incorrectly marked as disabled
	select.disabled = true;
	support.optDisabled = !opt.disabled;

	// Support: IE<=11+
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// All attributes are lowercase
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			name = name.toLowerCase();
			hooks = jQuery.attrHooks[ name ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					jQuery.nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name, propName,
			i = 0,
			attrNames = value && value.match( rnotwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				propName = jQuery.propFix[ name ] || name;

				// Boolean attributes get special treatment (#10870)
				if ( jQuery.expr.match.bool.test( name ) ) {

					// Set corresponding property to false
					elem[ propName ] = false;
				}

				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};
jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle;
		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ name ];
			attrHandle[ name ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				name.toLowerCase() :
				null;
			attrHandle[ name ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				return tabindex ?
					parseInt( tabindex, 10 ) :
					rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) && elem.href ?
							0 :
							-1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {
			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




var rclass = /[\t\r\n\f]/g;

function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnotwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 &&
					( " " + curValue + " " ).replace( rclass, " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = jQuery.trim( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnotwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 &&
					( " " + curValue + " " ).replace( rclass, " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = jQuery.trim( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value;

		if ( typeof stateVal === "boolean" && type === "string" ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( type === "string" ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = value.match( rnotwhite ) || [];

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + getClass( elem ) + " " ).replace( rclass, " " )
					.indexOf( className ) > -1
			) {
				return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, isFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				return typeof ret === "string" ?

					// Handle most common string cases
					ret.replace( rreturn, "" ) :

					// Handle cases where value is null/undef or number
					ret == null ? "" : ret;
			}

			return;
		}

		isFunction = jQuery.isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( isFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( jQuery.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				// Support: IE<11
				// option.value not trimmed (#14858)
				return jQuery.trim( elem.value );
			}
		},
		select: {
			get: function( elem ) {
				var value, option,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one" || index < 0,
					values = one ? null : [],
					max = one ? index + 1 : options.length,
					i = index < 0 ?
						max :
						one ? index : 0;

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							( support.optDisabled ?
								!option.disabled : option.getAttribute( "disabled" ) === null ) &&
							( !option.parentNode.disabled ||
								!jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];
					if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( jQuery.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {

			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;
					elem[ type ]();
					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true

				// Previously, `originalEvent: {}` was set here, so stopPropagation call
				// would not be triggered on donor event, since in our own
				// jQuery.event.stopPropagation function we had a check for existence of
				// originalEvent.stopPropagation method, so, consequently it would be a noop.
				//
				// But now, this "simulate" function is used only for events
				// for which stopPropagation() is noop, so there is no need for that anymore.
				//
				// For the compat branch though, guard for "click" and "submit"
				// events is still used, but was moved to jQuery.event.stopPropagation function
				// because `originalEvent` should point to the original event for the constancy
				// with other events and for more focused logic
			}
		);

		jQuery.event.trigger( e, null, elem );

		if ( e.isDefaultPrevented() ) {
			event.preventDefault();
		}
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


jQuery.each( ( "blur focus focusin focusout load resize scroll unload click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup error contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




support.focusin = "onfocusin" in window;


// Support: Firefox
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome, Safari
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://code.google.com/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = jQuery.now();

var rquery = ( /\?/ );



// Support: Android 2.3
// Workaround failure to string-cast null input
jQuery.parseJSON = function( data ) {
	return JSON.parse( data + "" );
};


// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE9
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rhash = /#.*$/,
	rts = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];

		if ( jQuery.isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

		// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",
		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": jQuery.parseJSON,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// The jqXHR state
			state = 0,

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( state === 2 ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return state === 2 ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					var lname = name.toLowerCase();
					if ( !state ) {
						name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( !state ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( state < 2 ) {
							for ( code in map ) {

								// Lazy-add the new callback in a way that preserves old ones
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						} else {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR ).complete = completeDeferred.add;
		jqXHR.success = jqXHR.done;
		jqXHR.error = jqXHR.fail;

		// Remove hash character (#7531: and string promotion)
		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" ).replace( rhash, "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE8-11+
			// IE throws exception if url is malformed, e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE8-11+
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( state === 2 ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		cacheURL = s.url;

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// If data is available, append data to url
			if ( s.data ) {
				cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add anti-cache in url if needed
			if ( s.cache === false ) {
				s.url = rts.test( cacheURL ) ?

					// If there is already a '_' parameter, set its value
					cacheURL.replace( rts, "$1_=" + nonce++ ) :

					// Otherwise add one to the end
					cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
			}
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		for ( i in { success: 1, error: 1, complete: 1 } ) {
			jqXHR[ i ]( s[ i ] );
		}

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( state === 2 ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				state = 1;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Propagate exception as error if not done
				if ( state < 2 ) {
					done( -1, e );

				// Simply rethrow otherwise
				} else {
					throw e;
				}
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Called once
			if ( state === 2 ) {
				return;
			}

			// State is "done" now
			state = 2;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( jQuery.isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( jQuery.isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapAll( html.call( this, i ) );
			} );
		}

		if ( this[ 0 ] ) {

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var isFunction = jQuery.isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function() {
		return this.parent().each( function() {
			if ( !jQuery.nodeName( this, "body" ) ) {
				jQuery( this ).replaceWith( this.childNodes );
			}
		} ).end();
	}
} );


jQuery.expr.filters.hidden = function( elem ) {
	return !jQuery.expr.filters.visible( elem );
};
jQuery.expr.filters.visible = function( elem ) {

	// Support: Opera <= 12.12
	// Opera reports offsetWidths and offsetHeights less than zero on some elements
	// Use OR instead of AND as the element is not visible if either is true
	// See tickets #10406 and #13132
	return elem.offsetWidth > 0 || elem.offsetHeight > 0 || elem.getClientRects().length > 0;
};




var r20 = /%20/g,
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( jQuery.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && jQuery.type( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, value ) {

			// If value is a function, invoke it and return its value
			value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
			s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
		};

	// Set traditional to true for jQuery <= 1.3.2 behavior.
	if ( traditional === undefined ) {
		traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" ).replace( r20, "+" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			return val == null ?
				null :
				jQuery.isArray( val ) ?
					jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} ) :
					{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE9
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE9
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = callback( "error" );

				// Support: IE9
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && jQuery.isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8+
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( !data || typeof data !== "string" ) {
		return null;
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	// Stop scripts or inline event handlers from being executed immediately
	// by using document.implementation
	context = context || ( support.createHTMLDocument ?
		document.implementation.createHTMLDocument( "" ) :
		document );

	var parsed = rsingleTag.exec( data ),
		scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


// Keep a copy of the old load method
var _load = jQuery.fn.load;

/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	if ( typeof url !== "string" && _load ) {
		return _load.apply( this, arguments );
	}

	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = jQuery.trim( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( jQuery.isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( self, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.filters.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




/**
 * Gets a window from an element
 */
function getWindow( elem ) {
	return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
}

jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( jQuery.isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {
	offset: function( options ) {
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var docElem, win,
			elem = this[ 0 ],
			box = { top: 0, left: 0 },
			doc = elem && elem.ownerDocument;

		if ( !doc ) {
			return;
		}

		docElem = doc.documentElement;

		// Make sure it's not a disconnected DOM node
		if ( !jQuery.contains( docElem, elem ) ) {
			return box;
		}

		box = elem.getBoundingClientRect();
		win = getWindow( doc );
		return {
			top: box.top + win.pageYOffset - docElem.clientTop,
			left: box.left + win.pageXOffset - docElem.clientLeft
		};
	},

	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
		// because it is its only offset parent
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume getBoundingClientRect is there when computed position is fixed
			offset = elem.getBoundingClientRect();

		} else {

			// Get *real* offsetParent
			offsetParent = this.offsetParent();

			// Get correct offsets
			offset = this.offset();
			if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
				parentOffset = offsetParent.offset();
			}

			// Add offsetParent borders
			// Subtract offsetParent scroll positions
			parentOffset.top += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true ) -
				offsetParent.scrollTop();
			parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true ) -
				offsetParent.scrollLeft();
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {
			var win = getWindow( elem );

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari<7-8+, Chrome<37-44+
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://code.google.com/p/chromium/issues/detail?id=229280
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( jQuery.isWindow( elem ) ) {

					// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
					// isn't a whole lot we can do. See pull request at this URL for discussion:
					// https://github.com/jquery/jquery/pull/764
					return elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable, null );
		};
	} );
} );


jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},
	size: function() {
		return this.length;
	}
} );

jQuery.fn.andSelf = jQuery.fn.addBack;




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
		return jQuery;
	}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}



var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}

return jQuery;
}));


/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(52)('wks');
var uid = __webpack_require__(35);
var Symbol = __webpack_require__(2).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(23);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(4)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(1);
var IE8_DOM_DEFINE = __webpack_require__(114);
var toPrimitive = __webpack_require__(25);
var dP = Object.defineProperty;

exports.f = __webpack_require__(8) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(26);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(9);
var createDesc = __webpack_require__(34);
module.exports = __webpack_require__(8) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var hide = __webpack_require__(12);
var has = __webpack_require__(16);
var SRC = __webpack_require__(35)('src');
var $toString = __webpack_require__(175);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(20).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var fails = __webpack_require__(4);
var defined = __webpack_require__(26);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // 


var _dom = __webpack_require__(76);

var _idGenerator = __webpack_require__(409);

var _partialUpdate = __webpack_require__(45);

var _inlineHOCUtils = __webpack_require__(412);

var _string = __webpack_require__(107);

var _shallowEqual = __webpack_require__(414);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _partialUpdate2 = __webpack_require__(167);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WebComponent = function () {
  function WebComponent(optProps) {
    var optInitialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, WebComponent);

    this.state = _extends({
      wasDecorated: false,
      inDocument: false,
      changed: false,
      open: false,
      progress: 0,
      normalizedRefreshEvents: null,
      processStateTokenEvents: null,
      formElement: null,
      layerElement: null,
      gridElement: null,
      processStateTokenProgress: null
    }, optInitialState);
    this.handlers = [];
    /**
     *
     * @type {Object}
     */

    this.props = _extends({}, WebComponent.defaultProps, this.constructor.defaultProps, optProps, {
      messages: _extends({}, this.constructor.defaultProps.messages, optProps.messages)
    });
    this.handleUiPush = this.handleUiPush.bind(this);
  }

  /**
   * Vrátí id, které je na dekorovaném elementu nebo vygeneruje unikátní ID, které se po celou existenci komponenty nemění
   */


  _createClass(WebComponent, [{
    key: 'getId',
    value: function getId() {
      if (!this.id) {
        this.id = (0, _idGenerator.getNextUniqueId)();
      }
      return this.id;
    }

    /**
     * Nastaví
     * Nikdy nevolat mimo instanci třídy. Pouze uvnitř instance.
     */

  }, {
    key: 'setState',
    value: function setState(state) {
      var prevState = _extends({}, this.state);
      this.state = _extends({}, this.state, state);
      this.updateInternal(this.props, prevState);
    }

    /**
     * Nastaví vlastnosti komponentě
     * Nikdy nevolat v instanci třídy.
     */

  }, {
    key: 'setProps',
    value: function setProps(props) {
      var prevProps = _extends({}, this.props);
      this.props = _extends({}, this.props, props);
      this.updateInternal(prevProps, this.state);
    }

    /**
     * Volá se na elemntu který chceme nadekorovat.
     */

  }, {
    key: 'decorate',
    value: function decorate(element) {
      var _this = this;

      if (this.state.inDocument) {
        throw Error('Component already rendered');
      } else if (element && this.canDecorate(element)) {
        this.setState({
          wasDecorated: true
        });

        // Call specific component decorate logic.
        var idAttr = element.getAttribute('id');
        if (idAttr) {
          this.id = idAttr;
        }
        this.setState({
          element: element,
          layerElement: element.closest('.corpus-frame') || document.body,
          gridElement: element.closest('[data-fragment="grid"]'),
          formElement: element.closest('form')
        });

        this.decorateInternal(element);

        this.elements = {};
        if (this.constructor.fragments) {
          Object.keys(this.constructor.fragments).forEach(function (key) {
            var selector = _this.constructor.fragments[key];
            _this.elements[key] = _this.element.querySelector(selector);
          });
        }

        this.connectRefreshEvents();
        this.enterDocument();
        this.didMount();

        this.setState({
          inDocument: true
        });
        this.update({}, {}, false);
      }
    }
  }, {
    key: 'connectRefreshEvents',
    value: function connectRefreshEvents() {
      var _props = this.props,
          refreshEvent = _props.refreshEvent,
          processStateToken = _props.processStateToken;


      var processStateTokenEvents = [];
      if (processStateToken) {
        if (Array.isArray(processStateToken)) {
          processStateToken.forEach(function (processStateTokenItem) {
            processStateTokenEvents.push(processStateTokenItem.toLowerCase() + 'processstate');
          });
        } else {
          processStateTokenEvents.push(processStateToken.toLowerCase() + 'processstate');
        }
      }

      var normalizedRefreshEvents = (0, _inlineHOCUtils.getNormalizedRefreshEvents)(refreshEvent);
      if (normalizedRefreshEvents.length > 0 || processStateTokenEvents.length > 0) {
        this.setState({
          normalizedRefreshEvents: normalizedRefreshEvents,
          processStateTokenEvents: processStateTokenEvents
        });
        document.addEventListener('uiPush', this.handleUiPush);
      }
    }
  }, {
    key: 'handleUiPush',
    value: function handleUiPush(e) {
      var _e$detail = e.detail,
          attr = _e$detail.attr,
          eventName = _e$detail.eventName,
          eventNameOnlyType = _e$detail.eventNameOnlyType,
          id = _e$detail.id;
      var _state = this.state,
          normalizedRefreshEvents = _state.normalizedRefreshEvents,
          processStateTokenEvents = _state.processStateTokenEvents;


      if (normalizedRefreshEvents.includes(eventNameOnlyType)) {
        this.handleRefreshEventFromProcessManager({
          type: eventNameOnlyType,
          attr: attr,
          id: id
        });
      }
      if (normalizedRefreshEvents && normalizedRefreshEvents.includes(eventName)) {
        this.handleRefreshEventFromProcessManager({
          type: eventName,
          attr: attr,
          id: id
        });
      }
      if (processStateTokenEvents && processStateTokenEvents.includes(eventName)) {
        this.handleProcessStateToken({
          type: eventName,
          attr: attr,
          id: id
        });
      }
    }
  }, {
    key: 'handleRefreshEventInternal',
    value: function handleRefreshEventInternal() {
      var refreshEvent = this.props.refreshEvent;


      var settings = {
        target: this.id,
        alterHistory: false,
        mergeWithTargetSettings: false,
        includeToProgress: false,
        rememberPagination: true,
        onError: function onError() {},
        omit: ['[data-fragment="messages"]'],
        headers: {
          'RamJet-WithUiEvent': true
        }
      };

      if (refreshEvent && refreshEvent.removeWidgetData != null) {
        settings.removeContainerWidgetData = refreshEvent.removeWidgetData;
      }
      if (refreshEvent && refreshEvent.puSettings != null) {
        settings = _extends({}, settings, refreshEvent.puSettings);
      }
      (0, _partialUpdate.resolveExecute)(document.getElementById(this.id), settings);
    }
  }, {
    key: 'handleProcessStateToken',
    value: function handleProcessStateToken(e) {
      var attr = e.attr;
      if (attr) {
        var message = attr.message;
        var progress = attr.progress;
        var callPUAfterProcessStateTokenRefresh = this.props.callPUAfterProcessStateTokenRefresh;

        if (message) {
          this.setState({
            processStateTokenMessage: message
          });
        }
        if (progress) {
          this.setState({
            processStateTokenProgress: progress
          });
        }
        if (callPUAfterProcessStateTokenRefresh && progress && progress >= 100) {
          this.handleRefreshEventInternal();
        }
      }
    }
  }, {
    key: 'handleRefreshEventFromProcessManager',
    value: function handleRefreshEventFromProcessManager(event) {
      var _props2 = this.props,
          value = _props2.value,
          refreshEvent = _props2.refreshEvent;

      var isInActivePU = (0, _partialUpdate2.isInActivePUContainer)(this.element, true);
      if (!isInActivePU && (0, _inlineHOCUtils.isValidForRefresh)(event, refreshEvent, value)) {
        // pokud na komponentě je implementovaná metoda handleRefreshEvent, tak se zavolá ta

        if (this.wrappedComponent && this.wrappedComponent.handleRefreshEvent) {
          this.wrappedComponent.handleRefreshEvent(event);
        } else {
          this.handleRefreshEventInternal();
        }
      }
    }
  }, {
    key: 'decorateInternal',
    value: function decorateInternal(element) {
      this.element = element;

      var existsEdeeDecorateMethods = window.fg && window.fg.ui && window.fg.ui.decorate;
      if (existsEdeeDecorateMethods && this.props.allowDecorateInnerElements) {
        this.decorateInnerElements();
      }
    }
  }, {
    key: 'decorateInnerElements',
    value: function decorateInnerElements() {
      var _window = window,
          fg = _window.fg;
      var decorateSkip_ = this.props.decorateSkip_;

      if (fg && fg.ui && fg.ui.decorate) {
        this.decoratedInnerElements = fg.ui.decorate.decorateInnerElements(this.element, undefined, undefined, decorateSkip_);
      }
    }

    /**
     *
     * @param eventType
     * @param selector
     * @param handler
     */

  }, {
    key: 'on',
    value: function on(eventType, selector, handler) {
      var _this2 = this;

      if (typeof selector === 'string') {
        var eventHandler = function eventHandler(e) {
          var closest = e.target.closest(selector);
          if (closest) {
            // change event currentTarget to closest
            // IE11 z currentTarget nepřepíše
            Object.defineProperty(e, 'currentTarget', {
              value: closest,
              writable: false,
              configurable: true
            });
            // IE11 z currentTarget nepřepíše
            // proto se zapíše nová vlastnost closestTarget
            Object.defineProperty(e, 'closestTarget', {
              value: closest,
              writable: false,
              configurable: true
            });
            handler(e);
          }
        };

        this.element.addEventListener(eventType, eventHandler, eventType === 'blur');
        this.handlers.push({
          eventType: eventType,
          eventHandler: eventHandler,
          selector: selector
        });
      } else {
        var _eventHandler = selector;
        var blurEventHandler = void 0;
        if (eventType === 'blur') {
          blurEventHandler = function blurEventHandler(e) {
            setTimeout(function () {
              if (_this2.element && !_this2.element.contains(document.activeElement)) {
                _eventHandler(e);
              }
            }, 1);
          };
        }
        this.element.addEventListener(eventType, blurEventHandler || _eventHandler, eventType === 'blur' || eventType === 'focus');
        this.handlers.push({
          eventType: eventType,
          eventHandler: blurEventHandler || _eventHandler
        });
      }
    }

    /**
     * dispatchne/vystřelí na elment komponenty požadovaný event.
     * type properta definuje typ eventu
     * ostatní property eventObjectu jsou předány do detailu [CustomEventu]{@link https://developer.mozilla.org/cs/docs/Web/API/CustomEvent}
     */

  }, {
    key: 'dispatchEvent',
    value: function dispatchEvent(eventObject) {
      /*window.$(this.element).trigger({
        ...eventObject,
        targetComponent: this,
      });*/
      (0, _dom.dispatchEvent)(this.element, eventObject.type, _extends({
        targetComponent: this
      }, eventObject));
    }

    /**
     * Dispatchne change event
     */

  }, {
    key: 'dispatchChangeEvent',
    value: function dispatchChangeEvent(value) {
      if (this.props.dispatchChangeEvent) {
        this.dispatchEvent({ type: 'change', value: value });
        this.setState({
          changed: true
        });
      }
    }
  }, {
    key: 'updateInternal',


    /**
     *
     * @private
     */
    value: function updateInternal(prevProps, prevState) {
      var _this3 = this;

      if (this.state.inDocument && (!(0, _shallowEqual2.default)(this.state, prevState) || !(0, _shallowEqual2.default)(this.props, prevProps))) {
        clearTimeout(this.updateTimeOut);
        this.updateTimeOut = setTimeout(function () {
          _this3.updateInfoMessages(prevProps, prevState, true);
          _this3.update(prevProps, prevState, true);
        }, 2);
      }
    }

    /**
     * Metoda která slouží pro zobrazování např. validačních chyb a informací pro vyplnění komponenty
     * @param prevProps
     * @param prevState
     */

  }, {
    key: 'updateInfoMessages',
    value: function updateInfoMessages(prevProps, prevState) {}
    /**
     * V teto metodě by se měla vykonávat všechna logika nahrazování DOMu
     * Volá se vždy po aktualizaci stavu nebo props pomocí
     * metod setState a setProps a po nadekorování elementu
     */

  }, {
    key: 'update',
    value: function update(prevProps, prevState, inDocument) {}
  }, {
    key: 'canDecorate',
    value: function canDecorate() {
      return true;
    }

    /**
     * Zavolá se po úspěšném mountnutí na dekorovaný element
     * Od této fáze je dostupný this.element a properties z data attributů
     */

  }, {
    key: 'didMount',
    value: function didMount() {}

    /**
     * @deprecated
     * didMount alias
     */

  }, {
    key: 'enterDocument',
    value: function enterDocument() {}

    /**
     * Volá se před tím než je komponenta smazána
     * V této metodě by se měly smazat všechny vnitřní proměnné
     * a event listenery, které nebyly přidány pomocí metody @see {#on}
     */

  }, {
    key: 'willUnMount',
    value: function willUnMount() {}
  }, {
    key: 'exitDocument',
    value: function exitDocument() {
      this.willUnMount();
      this.setState({
        inDocument: false
      });
    }
  }, {
    key: 'dispose',
    value: function dispose() {
      var _this4 = this;

      this.exitDocument();
      if (this.decoratedInnerElements && this.decoratedInnerElements.length > 0) {
        this.decoratedInnerElements.forEach(function (component, index) {
          if (component && component.dispose) {
            component.dispose();
          }
        });
        this.decoratedInnerElements = null;
      }
      this.handlers.forEach(function (_ref) {
        var eventHandler = _ref.eventHandler,
            eventType = _ref.eventType;

        _this4.element.removeEventListener(eventType, eventHandler);
      });
      document.removeEventListener('uiPush', this.handleUiPush);
      this.id = null;
      this.element = null;
    }

    /**
     * Vrátí form data parentího formuláře
     */

  }, {
    key: 'DOMGetParentFormData',
    value: function DOMGetParentFormData(remove) {
      var formElement = this.state.formElement;

      if (formElement) {
        var formData = {};
        $(formElement).serializeArray().forEach(function (_ref2) {
          var value = _ref2.value,
              name = _ref2.name;

          if (!remove || remove && !remove.includes(name)) {
            if (!formData[name]) {
              formData[name] = [];
            }
            formData[name].push(value);
          }
        });
        return formData;
      }
      return {};
    }
  }, {
    key: 'i18n',
    value: function i18n(message, optValues) {
      var _props$messages = this.props.messages,
          messages = _props$messages === undefined ? {} : _props$messages;

      return (0, _string.i18n)(message, optValues, this.constructor.name, messages);
    }
  }]);

  return WebComponent;
}();

/**
 * Výchozí vlastnosti WebComponenty
 * Vždy jsou mergovány do vlastností zděděných komponent
 */


WebComponent.defaultProps = {
  messages: null,
  ignoreChanges: false,
  refreshEvent: null,
  lang: 'cs',
  /**
   * [cs] registrace tokenu podle ktereho se komponenta sama aktualizuje. Vyuziva se pro zobrazeni
   * progesu RamJet commandu.
   * @type {string?}
   */
  processStateToken: null,
  allowDecorateInnerElements: true,
  dispatchChangeEvent: true,
  callPUAfterProcessStateTokenRefresh: true,
  tooltip: null,
  error: null
};

exports.default = WebComponent;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(53);
var defined = __webpack_require__(26);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(54);
var createDesc = __webpack_require__(34);
var toIObject = __webpack_require__(17);
var toPrimitive = __webpack_require__(25);
var has = __webpack_require__(16);
var IE8_DOM_DEFINE = __webpack_require__(114);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(8) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(16);
var toObject = __webpack_require__(10);
var IE_PROTO = __webpack_require__(81)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(11);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 22 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 23 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(4);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(5);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 26 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(0);
var core = __webpack_require__(20);
var fails = __webpack_require__(4);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(21);
var IObject = __webpack_require__(53);
var toObject = __webpack_require__(10);
var toLength = __webpack_require__(7);
var asc = __webpack_require__(97);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(8)) {
  var LIBRARY = __webpack_require__(31);
  var global = __webpack_require__(2);
  var fails = __webpack_require__(4);
  var $export = __webpack_require__(0);
  var $typed = __webpack_require__(72);
  var $buffer = __webpack_require__(105);
  var ctx = __webpack_require__(21);
  var anInstance = __webpack_require__(41);
  var propertyDesc = __webpack_require__(34);
  var hide = __webpack_require__(12);
  var redefineAll = __webpack_require__(43);
  var toInteger = __webpack_require__(23);
  var toLength = __webpack_require__(7);
  var toIndex = __webpack_require__(142);
  var toAbsoluteIndex = __webpack_require__(37);
  var toPrimitive = __webpack_require__(25);
  var has = __webpack_require__(16);
  var classof = __webpack_require__(48);
  var isObject = __webpack_require__(5);
  var toObject = __webpack_require__(10);
  var isArrayIter = __webpack_require__(94);
  var create = __webpack_require__(38);
  var getPrototypeOf = __webpack_require__(19);
  var gOPN = __webpack_require__(39).f;
  var getIterFn = __webpack_require__(96);
  var uid = __webpack_require__(35);
  var wks = __webpack_require__(6);
  var createArrayMethod = __webpack_require__(28);
  var createArrayIncludes = __webpack_require__(62);
  var speciesConstructor = __webpack_require__(56);
  var ArrayIterators = __webpack_require__(99);
  var Iterators = __webpack_require__(50);
  var $iterDetect = __webpack_require__(67);
  var setSpecies = __webpack_require__(40);
  var arrayFill = __webpack_require__(98);
  var arrayCopyWithin = __webpack_require__(131);
  var $DP = __webpack_require__(9);
  var $GOPD = __webpack_require__(18);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(137);
var $export = __webpack_require__(0);
var shared = __webpack_require__(52)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(140))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(35)('meta');
var isObject = __webpack_require__(5);
var has = __webpack_require__(16);
var setDesc = __webpack_require__(9).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(4)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(6)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(12)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 35 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(116);
var enumBugKeys = __webpack_require__(82);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(23);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(1);
var dPs = __webpack_require__(117);
var enumBugKeys = __webpack_require__(82);
var IE_PROTO = __webpack_require__(81)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(79)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(83).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(116);
var hiddenKeys = __webpack_require__(82).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(2);
var dP = __webpack_require__(9);
var DESCRIPTORS = __webpack_require__(8);
var SPECIES = __webpack_require__(6)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 41 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(21);
var call = __webpack_require__(129);
var isArrayIter = __webpack_require__(94);
var anObject = __webpack_require__(1);
var toLength = __webpack_require__(7);
var getIterFn = __webpack_require__(96);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(13);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(5);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolveExecute = exports.submitToIFrameOrBrowserTab = exports.clear = exports.abortExecute = exports.execute = exports.executeSubmit = exports.executeAjax = exports.removeDataInputs = exports.composeAjaxSettings = exports.replaceContents = exports.partialUpdateAfterReplaceContents = exports.partialUpdateCalculateResultForReplacing = exports.partialUpdateBeforeReplaceContents = exports.throwPUError = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // 


var _PartialUpdateSettings = __webpack_require__(51);

var _jquery = __webpack_require__(3);

var _jquery2 = _interopRequireDefault(_jquery);

var _partialUpdateUtils = __webpack_require__(46);

var _XHRQueue = __webpack_require__(110);

var _formsChangesChecker = __webpack_require__(157);

var _urijs = __webpack_require__(57);

var _urijs2 = _interopRequireDefault(_urijs);

var _urlAndLink = __webpack_require__(111);

var _decorate = __webpack_require__(152);

var _dom = __webpack_require__(76);

var _form = __webpack_require__(109);

var _lodash = __webpack_require__(411);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var RAMJET_SPECIFIC_PARAMETERS = {
  HISTORY_SCOPE: 'RamJet-HistoryScope-Level',
  SUPPRESS_REDIRECT: 'RamJet-Suppress-Redirect',
  CONTEXT: 'ramJetParameterContext', // Využívá se v publish modulu
  LAYOUT_CONTEXT: 'ramJetLayoutContext'
};

var RAMJET_RESPONSE_HEADERS = {
  RAMJET_ERROR: 'RamJet-Error',
  RAMJET_REQUESTEDPARAMETERS: 'RamJet-RequestedParameters',
  RAMJET_REQUESTEDURL: 'RamJet-RequestedUrl'
};

var throwPUError = exports.throwPUError = function throwPUError(_ref) {
  var message = _ref.message,
      settings = _ref.settings,
      jqXHR = _ref.jqXHR,
      textStatus = _ref.textStatus,
      errorThrown = _ref.errorThrown;

  var globalPUSettings = (0, _PartialUpdateSettings.getGlobalPartialUpdateSettings)();
  var onError = settings.onError || globalPUSettings.onError;
  if (onError) {
    onError({
      message: message,
      settings: settings,
      globalPUSettings: globalPUSettings,
      jqXHR: jqXHR,
      xhr: jqXHR,
      textStatus: textStatus,
      errorThrown: errorThrown
    });
    throw new Error(message);
  } else {
    throw new Error(message);
  }
};

var replaceStartTime = void 0;
var disposeTime = void 0;
var partialUpdateBeforeReplaceContents = exports.partialUpdateBeforeReplaceContents = function partialUpdateBeforeReplaceContents(settings, skip) {
  var targetElement = settings.targetElement,
      disposeAndDecorateLifecycle = settings.settings.disposeAndDecorateLifecycle;

  var measureDecorating = window.measurePerformance;
  replaceStartTime = new Date().getTime();
  // použito pouze v Edeem
  var existsEdeeDecorateMethods = window.fg && window.fg.ui && window.fg.ui.decorate;
  if (disposeAndDecorateLifecycle) {
    if (existsEdeeDecorateMethods) {
      window.fg.ui.decorate.disposeDecoratedComponents(targetElement, undefined, skip);
      /*    ownerEdeeComponent =
       ownerEdeeComponent ||
       window.fg.ui.decorate.getDecoratedOwnerComponent(targetElement);*/
    } else {
      (0, _decorate.disposeInnerComponents)(targetElement, skip);
    }
  }
  disposeTime = new Date().getTime() - replaceStartTime;
  if (measureDecorating) {
    // eslint-disable-next-line
    console.log('Dispose time: ' + disposeTime);
  }

  // použito pouze v Edeem
  // vymazat frontu inline funkcí
  // fronta funkcí je potřeba volat až po nadekorování všech elementů, aby bylo možno si getnout
  // instance komponent
  if (existsEdeeDecorateMethods) {
    window.q = [];
  }
};

var partialUpdateCalculateResultForReplacing = exports.partialUpdateCalculateResultForReplacing = function partialUpdateCalculateResultForReplacing(props) {
  var targetElement = props.targetElement,
      result = props.result,
      settings = props.settings;
  var ownerEdeeComponent = settings.ownerEdeeComponent,
      requestTarget = settings.requestTarget;
  var originalTarget = settings.originalTarget,
      omit = settings.omit;

  var target = (0, _partialUpdateUtils.getTarget)(settings);
  var requestTargetWithoutContext = requestTarget ? (0, _partialUpdateUtils.getDynamicAreaIdWithoutContext)(requestTarget) : null;
  var originalTargetWithoutContext = originalTarget ? (0, _partialUpdateUtils.getDynamicAreaIdWithoutContext)(originalTarget) : null;

  var computedRequestTarget = requestTarget === originalTarget ? target : (0, _partialUpdateUtils.getRequestTarget)(settings);

  var actTarget = targetElement.getAttribute('id');

  // pokud je suppressRedirect==true, tak se ze serveru vrátí kompletní HTML i s HEAD a BODY a
  // znovu se nalinkují a vykonají všechny javascripty. V následujícím kodu se response text omezí
  // pouze na požadovaný
  // div snipet of code is from jQuery.load Create a dummy div to hold the results
  if (result.lastIndexOf('<!DOCTYPE', 0) === 0) {
    var rscript = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
    result = result.replace(rscript, '');
    result = (0, _jquery2.default)('<div>')
    // inject the contents of the document in, removing the scripts
    // to avoid any 'Permission Denied' errors in IE
    .append(result)
    // Locate the specified elements
    .find('#' + (computedRequestTarget || (0, _partialUpdateUtils.getTarget)(settings) || actTarget));
  }

  result = (0, _jquery2.default)(result);
  if (result.length === 0) {
    // throw Error bez přerušení běhu kodu
    var responseError = new Error('In server response wasn\'t find element with id\n      attribute "' + (computedRequestTarget || (0, _partialUpdateUtils.getTarget)(settings) || actTarget) + '".');
    setTimeout(function () {
      throw responseError;
    }, 0);
    // aby nepřestal web správně fungovat, tak se vytvoří div element s požadovaným id
    result = (0, _jquery2.default)('<div id="' + (target || actTarget) + '"></div>');
  }

  result.attr('id', target || actTarget);

  if (computedRequestTarget && !(0, _lodash2.default)(requestTargetWithoutContext, originalTargetWithoutContext)) {
    result.attr('data-partial-update-request-target', computedRequestTarget);
  }

  if (omit && omit.length > 0) {
    omit.forEach(function (omitSelector) {
      var inResult = result.find(omitSelector);
      var inDOM = (0, _jquery2.default)(targetElement).find(omitSelector).clone();
      if (inDOM.length > 0 && inResult.length > 0) {
        inResult.replaceWith(inDOM);
      }
    });
  }
  /*  if (result[0].nodeType !== 1 || result[0] == null) {
      throw new Error('Něco je v response špatně. První element z response není Element. Zkontroluj response ze serveru.');
    }*/
  return result;
};

var partialUpdateAfterReplaceContents = exports.partialUpdateAfterReplaceContents = function partialUpdateAfterReplaceContents(props, result, skip) {
  var focusAnchor = props.focusAnchor,
      _props$settings = props.settings,
      persistFocus = _props$settings.persistFocus,
      disposeAndDecorateLifecycle = _props$settings.disposeAndDecorateLifecycle;

  if (persistFocus) {
    (0, _dom.setFocusAnchor)(focusAnchor);
  }

  var results = (result instanceof _jquery2.default ? result.toArray() : [result]).filter(function (element) {
    return element.nodeType === 1;
  });
  var measureDecorating = window.measurePerformance;
  var existsEdeeDecorateMethods = window.fg && window.fg.ui && window.fg.ui.decorate;
  results.forEach(function (element) {
    if (disposeAndDecorateLifecycle) {
      if (existsEdeeDecorateMethods) {
        window.fg.ui.decorate.decorateInnerElements(element, undefined, true, skip);
      } else {
        (0, _decorate.decorateInnerElements)(element, skip);
      }
    }
  });

  // TODO použito pouze v Edeem
  if (window.q) {
    window.q.forEach(function (f) {
      f();
    });
    window.q = [];
  }
  var decorateTime = new Date().getTime() - replaceStartTime;
  if (measureDecorating) {
    // eslint-disable-next-line
    console.log('Decorating time: ' + (decorateTime - disposeTime - replaceTime));
    // eslint-disable-next-line
    console.log('Decorating time all: ' + decorateTime);
  }
};

var replaceTime = 0;

var replaceTargetContent = function replaceTargetContent(targetElement, newContentElement) {
  (0, _jquery2.default)(targetElement).replaceWith(newContentElement);
};

var getDOMElement = function getDOMElement(element) {
  if (element instanceof _jquery2.default) {
    return element[0];
  }
  return element;
};

var replaceContents = exports.replaceContents = function replaceContents(props) {
  var targetElement = props.targetElement,
      pick = props.settings.pick,
      settings = props.settings;


  var result = partialUpdateCalculateResultForReplacing(props);

  var replaceContentFunction = settings.replaceTargetContent || replaceTargetContent;
  if (pick && pick.length > 0) {
    pick.forEach(function (selector) {
      var newElement = (0, _jquery2.default)('' + selector, result);
      var newTargetEl = (0, _jquery2.default)('' + selector, targetElement);
      if (newTargetEl[0]) {
        partialUpdateBeforeReplaceContents(_extends({}, props, {
          targetElement: newTargetEl[0]
        }));
      }
      replaceContentFunction(getDOMElement(newTargetEl), getDOMElement(newElement), props);
      partialUpdateAfterReplaceContents(props, newElement);
    });
  } else {
    partialUpdateBeforeReplaceContents(props);
    replaceContentFunction(getDOMElement(targetElement), getDOMElement(result), props);
    replaceTime = new Date().getTime() - disposeTime - replaceStartTime;

    var measureDecorating = window.measurePerformance;
    if (measureDecorating) {
      // eslint-disable-next-line
      console.log('Replace time: ' + replaceTime);
    }
    partialUpdateAfterReplaceContents(props, result);
  }
};

var scrollIfScrollAnchorExists = function scrollIfScrollAnchorExists(element) {
  var anchorElement = element.closest('.partial-update-scroll-anchor');
  if (anchorElement.length > 0) {
    var fixedOffset = anchorElement.attr('data-partial-update-scroll-fixed-offset');
    var wantedScrollTop = anchorElement.offset().top + (fixedOffset ? parseInt(fixedOffset, 10) : 0);
    if ((0, _jquery2.default)(window).scrollTop() > wantedScrollTop) {
      (0, _jquery2.default)('html, body').animate({
        scrollTop: wantedScrollTop
      }, 250);
    }
  }
};

var getTargetElement = function getTargetElement(settings) {
  var target = (0, _partialUpdateUtils.getTarget)(settings);
  // TODO JNO zapřičiňuje load ze serveru pouze base componenty. Proto jsem zakomentoval
  /* const containerCnt = $(`#${target}__container`);
  if (containerCnt.length > 0) {
    // prefer container elements before target ones
    elementId = `${target}__container`;
  } else {
    // elementId = target;
   } */
  var targetElement = document.getElementById(target);
  if (targetElement == null) {
    (0, _XHRQueue.abortXHR)(target);
    throwPUError({
      message: 'Cannot perform partial update of the container id ' + target + ' is not present.',
      settings: settings
    });
  }
  return targetElement;
};

var handleSuccess = function handleSuccess(_ref2) {
  var result = _ref2.result,
      settings = _ref2.settings,
      textStatus = _ref2.textStatus,
      jqXHR = _ref2.jqXHR;
  var target = settings.target,
      containerId = settings.containerId;

  var originalTarget = target || containerId;
  var targets = (0, _partialUpdateUtils.getTargets)(settings);
  /*  let targets = containerId || target;
  if (!Array.isArray(targets)) {
    targets.replace(/,/g, '+');
    targets = targets.split('+');
  } */
  var newAccessibleTargets = [];
  var results = (0, _partialUpdateUtils.parseResultsFromAjaxResult)(settings, result);
  targets.forEach(function (simpleTarget) {
    // settings with simple target
    var oneTargetSettings = _extends({}, settings, {
      target: simpleTarget,
      originalTarget: originalTarget,
      containerId: null
    });
    result = results[simpleTarget];
    var targetElement = getTargetElement(oneTargetSettings);

    var beforeContentsReplacedEvent = (0, _dom.dispatchEvent)(targetElement, 'beforeContentsReplaced', {
      result: result,
      textStatus: textStatus,
      xhr: jqXHR,
      settings: oneTargetSettings,
      targetElement: targetElement
    });
    if (settings.onBeforeContentsReplaced) {
      settings.onBeforeContentsReplaced({
        result: result,
        settings: oneTargetSettings,
        xhr: jqXHR,
        textStatus: textStatus,
        targetElement: targetElement
      });
    }
    var newAccessibleTarget = null;

    if (!beforeContentsReplacedEvent.defaultPrevented) {
      try {
        (oneTargetSettings.replaceContents || replaceContents)({
          targetElement: targetElement,
          result: result,
          settings: oneTargetSettings,
          xhr: jqXHR,
          textStatus: textStatus,
          focusAnchor: (0, _dom.getFocusAnchor)()
        });
      } catch (e) {
        // throw Error bez přerušení běhu kodu
        setTimeout(function () {
          throw e;
        }, 0);
      }

      newAccessibleTarget = (0, _jquery2.default)(document.getElementById(targetElement.getAttribute('id')));
      if (newAccessibleTarget.length > 0) {
        scrollIfScrollAnchorExists(newAccessibleTarget);
        if (oneTargetSettings.onAfterContentsReplace) {
          oneTargetSettings.onAfterContentsReplace({
            targetElement: targetElement,
            newAccessibleTarget: newAccessibleTarget[0],
            result: result,
            settings: oneTargetSettings,
            jqXHR: jqXHR,
            xhr: jqXHR,
            textStatus: textStatus
          });
        }

        (0, _dom.dispatchEvent)(newAccessibleTarget[0], 'afterContentsReplaced', {
          settings: oneTargetSettings,
          result: result,
          textStatus: textStatus,
          xhr: jqXHR,
          targetElement: targetElement,
          newAccessibleTarget: newAccessibleTarget[0]
        });
      }
    }
    newAccessibleTargets.push(newAccessibleTarget);
  });

  var scroll = settings.scroll,
      scrollDuration = settings.scrollDuration,
      scrollOffset = settings.scrollOffset;


  if (scroll) {
    var targetToScroll = (0, _partialUpdateUtils.getTargetElements)(settings)[0];
    if (targetToScroll) {
      var yPosition = (0, _jquery2.default)(targetToScroll).offset()[scroll === true ? 'top' : scroll];
      (0, _jquery2.default)('html, body').animate({ scrollTop: yPosition - scrollOffset }, scrollDuration);
      // targetToScroll.scrollIntoView({ block: 'start',  behavior: 'smooth' });
    }
  }

  return newAccessibleTargets;
};

var composeAjaxSettings = exports.composeAjaxSettings = function composeAjaxSettings(predefinedAjaxSettings, partialUpdateSettings, form, button, contextElement) {
  var target = (0, _partialUpdateUtils.getTarget)(partialUpdateSettings);
  var globalPUSettings = (0, _PartialUpdateSettings.getGlobalPartialUpdateSettings)();
  if (partialUpdateSettings.data) {
    partialUpdateSettings.data = (0, _form.mapToSubmitDataIfNeeded)(partialUpdateSettings.data);
  }

  var puSettingsMergedWithGlobal = _extends({}, globalPUSettings, partialUpdateSettings);
  contextElement = contextElement || (0, _jquery2.default)(window.document.body);

  var url = puSettingsMergedWithGlobal.url,
      removeContainerWidgetData = puSettingsMergedWithGlobal.removeContainerWidgetData,
      requestTarget = puSettingsMergedWithGlobal.requestTarget,
      eventName = puSettingsMergedWithGlobal.eventName,
      type = puSettingsMergedWithGlobal.type;
  var ajax = puSettingsMergedWithGlobal.ajax,
      alterHistory = puSettingsMergedWithGlobal.alterHistory,
      data = puSettingsMergedWithGlobal.data,
      dataMerge = puSettingsMergedWithGlobal.dataMerge,
      historyScope = puSettingsMergedWithGlobal.historyScope,
      layoutContext = puSettingsMergedWithGlobal.layoutContext,
      removeFormWidgetData = puSettingsMergedWithGlobal.removeFormWidgetData,
      suppressRedirect = puSettingsMergedWithGlobal.suppressRedirect,
      dataType = puSettingsMergedWithGlobal.dataType,
      command = puSettingsMergedWithGlobal.command,
      exceptParams = puSettingsMergedWithGlobal.exceptParams,
      removeFormId = puSettingsMergedWithGlobal.removeFormId,
      rememberPagination = puSettingsMergedWithGlobal.rememberPagination,
      dataFromAllFormsInDocument = puSettingsMergedWithGlobal.dataFromAllFormsInDocument,
      moveUrlQueryParamsToFormDataOnPost = puSettingsMergedWithGlobal.moveUrlQueryParamsToFormDataOnPost,
      headers = puSettingsMergedWithGlobal.headers,
      collectFormData = puSettingsMergedWithGlobal.collectFormData;


  var computedData = [];
  var composedSettings = {};

  if (dataType) {
    composedSettings.dataType = dataType;
  }

  if (type) {
    type = type.toUpperCase();
    composedSettings.type = type;
  }

  eventName = command || eventName;

  if (form && form.length > 0) {
    var formPartialUpdateUrl = form.data('partialUpdateUrl');
    url = url || formPartialUpdateUrl || form.attr('action');
    requestTarget = (0, _partialUpdateUtils.getRequestTarget)(puSettingsMergedWithGlobal) || target || form.attr('id');

    var formParentPUContainer = (0, _partialUpdateUtils.getParentPartialUpdateContainer)(form[0]);

    if (collectFormData) {
      // na server se pošlou všechna data z formulářů v jsPartialUpdate konteineru,
      // které mají stejný atribut action
      var forms = dataFromAllFormsInDocument && formParentPUContainer ? formParentPUContainer.querySelectorAll('form[action="' + form.attr('action') + '"]') : [form[0]];
      computedData = (0, _form.serializeForms)(forms);

      computedData = (0, _form.removeFromData)(computedData, removeFormWidgetData, true);
      if (removeFormId) {
        computedData = (0, _partialUpdateUtils.removeFormIdFromData)(computedData);
      }
    }
    url = (0, _partialUpdateUtils.removeDataFromUrl)(url, removeFormWidgetData, true);
  } else {
    requestTarget = (0, _partialUpdateUtils.getRequestTarget)(puSettingsMergedWithGlobal) || target;
  }
  if (target && removeContainerWidgetData) {
    if (removeContainerWidgetData === true) {
      var container = (0, _jquery2.default)('#' + target, contextElement);
      removeContainerWidgetData = container.find('[name^="frm."]').toArray().map(function (input) {
        return input.name.replace('frm.', '');
      });
    }
    computedData = (0, _form.removeFromData)(computedData, removeContainerWidgetData, true);
    url = (0, _partialUpdateUtils.removeDataFromUrl)(url, removeContainerWidgetData, true);
  }

  computedData = (0, _form.removeFromData)(computedData, exceptParams, false);
  if (url) {
    url = (0, _partialUpdateUtils.removeDataFromUrl)(url, exceptParams, false);
    if (removeFormId) {
      url = (0, _partialUpdateUtils.removeFormIdFromUrl)(url);
    }
    url = (0, _partialUpdateUtils.getComposedUrl)(url, requestTarget);
  }
  if (moveUrlQueryParamsToFormDataOnPost && type === 'POST' && url) {
    var uri = new _urijs2.default(url);
    var queryData = _urijs2.default.parseQuery(uri.query());
    url = uri.search('').toString();
    computedData = [].concat(_toConsumableArray(computedData), _toConsumableArray((0, _form.mapToSubmitDataIfNeeded)(queryData)));
  }

  if (data) {
    computedData = [].concat(_toConsumableArray(computedData), _toConsumableArray((0, _form.mapToSubmitDataIfNeeded)(data)));
  }
  if (dataMerge) {
    computedData = (0, _form.mergeSubmitData)(computedData, dataMerge);
  }

  if (suppressRedirect) {
    computedData.push({
      name: RAMJET_SPECIFIC_PARAMETERS.SUPPRESS_REDIRECT,
      value: 'true'
    });
  }
  if (alterHistory) {
    computedData.push({
      name: RAMJET_SPECIFIC_PARAMETERS.HISTORY_SCOPE,
      value: historyScope
    });
  }

  if (layoutContext) {
    computedData.push({
      name: RAMJET_SPECIFIC_PARAMETERS.LAYOUT_CONTEXT,
      value: layoutContext
    });
  }

  if (ajax && ajax.data) {
    computedData = [].concat(_toConsumableArray((0, _form.mapToSubmitDataIfNeeded)(ajax.data)), _toConsumableArray(computedData));
  }

  if (eventName) {
    computedData.push({
      name: eventName.startsWith('eventName.') ? eventName : 'eventName.' + eventName,
      value: ''
    });
  }

  if (rememberPagination) {
    computedData = (0, _form.mergeSubmitData)(computedData, (0, _PartialUpdateSettings.getPaginationSubmitData)(puSettingsMergedWithGlobal));
  }

  // musí být na konci po všech výpočtech nad daty

  if (button && button.length > 0) {
    var buttonNameAttribute = button.attr('name');
    var buttonEvent = {
      name: buttonNameAttribute,
      value: ''
    };

    // prevent event duplicity
    var dataNames = computedData.map(function (item) {
      return item.name;
    });
    if (!dataNames.includes(buttonNameAttribute)) {
      computedData.push(buttonEvent);
    }
  }

  if (url) {
    composedSettings.url = url;
  }

  if (headers) {
    composedSettings.headers = headers;
    if (ajax && ajax.headers) {
      composedSettings.headers = _extends({}, headers, ajax.headers);
    }
  }
  if (computedData && computedData.length > 0) {
    // při POSTu nebo PUTu a pokud je ve formuláři fileinput je třeba data poslat jako FormData
    // https://stackoverflow.com/questions/45594504/upload-file-and-json-data-in-the-same-post-request-using-jquery-ajax
    // https://developer.mozilla.org/en-US/docs/Web/API/FormData/append
    if ((type === 'POST' || type === 'PUT') && form && (0, _partialUpdateUtils.isMultipart)(form)) {
      var formData = new FormData();

      computedData.forEach(function (_ref3) {
        var name = _ref3.name,
            value = _ref3.value;

        formData.append(name, value);
      });

      // přidat fileInputy

      var fileInputs = (0, _partialUpdateUtils.getFileInputs)(form);
      fileInputs.toArray().forEach(function (input) {
        var name = input.getAttribute('name');
        var isMultiple = !!input.getAttribute('multiple');
        // Convert FileList to array and iterate
        [].concat(_toConsumableArray(input.files)).forEach(function (file) {
          formData.append('' + name + (isMultiple ? '[]' : ''), file, file.name);
        });
      });

      composedSettings.data = formData;
      composedSettings.contentType = false;
      composedSettings.processData = false;
      composedSettings.cache = false;
    } else {
      composedSettings.data = computedData;
    }
  }

  return _extends({
    cache: globalPUSettings.cache,
    timeout: globalPUSettings.timeout
  }, ajax, predefinedAjaxSettings, composedSettings);
};

// obstraní hidden inputy, které byly přidány na základě property data v settings
var removeDataInputs = exports.removeDataInputs = function removeDataInputs(settings) {
  var data = settings.data;
  /* if (submitId) {
    const form = $(`#${getSubmitId(settings)}`).closest('form');
    if (form.length > 0) {
      data.forEach(({ name, value }) => {
        $(`[type="hidden"][name="${name}"]`, form)
          .remove();
      });
      // remove timestamp hidden input
      $('[type="hidden"][name="_"]', form)
        .remove();
    }
  } */

  var targetElement = document.getElementById((0, _partialUpdateUtils.getTarget)(settings));
  if (targetElement) {
    if (data) {
      data.forEach(function (_ref4) {
        var name = _ref4.name;

        (0, _jquery2.default)('[type="hidden"][name="' + name + '"]', targetElement).remove();
      });
    }
    // remove timestamp hidden input
    (0, _jquery2.default)('[type="hidden"][name="_"]', targetElement).remove();
  }
};

var executeAjax = exports.executeAjax = function executeAjax(_ref5) {
  var settings = _ref5.settings,
      form = _ref5.form,
      button = _ref5.button;

  var target = (0, _partialUpdateUtils.getTarget)(settings);
  var _settings = settings,
      partialUpdateType = _settings.partialUpdateType;

  var closestPuSettings = partialUpdateType === 'submit' ? (0, _PartialUpdateSettings.getClosestPartialUpdateSettings)(settings, ['url']) : (0, _PartialUpdateSettings.getClosestPartialUpdateSettings)(settings);

  settings = _extends({}, (0, _PartialUpdateSettings.getGlobalPartialUpdateSettings)(), closestPuSettings, settings);

  // pokud není definovaná url, tak se vezme z location
  // pouze u jiných typů než 'submit'
  if (partialUpdateType !== 'submit' && settings.url == null) {
    settings.url = window.location.href;
  }

  // normalizace url do settings
  // seřadí se parametry
  // odebere se domena
  if (settings.url) {
    var settingsUri = new _urijs2.default((0, _urlAndLink.normalizeUrl)(settings.url));
    settings.url = settingsUri.authority('').origin('').toString();
  }

  var _settings2 = settings,
      formsChangesDetection = _settings2.formsChangesDetection,
      onComplete = _settings2.onComplete,
      alterHistory = _settings2.alterHistory,
      onFormsChangesDetect = _settings2.onFormsChangesDetect,
      onBeforeExecute = _settings2.onBeforeExecute;


  (0, _XHRQueue.abortXHR)(target);

  if (formsChangesDetection && onFormsChangesDetect != null && (0, _formsChangesChecker.containsChangedForm)(target)) {
    onFormsChangesDetect({
      settings: settings
    });
  } else {
    var targetElements = (0, _partialUpdateUtils.getTargetElements)(settings);
    var isAnyPuStartEventDefaultPrevented = false;
    targetElements.forEach(function (targetElement) {
      var puStartEvent = (0, _dom.dispatchEvent)(targetElement, 'partialUpdateStart', {
        settings: settings
      });
      if (puStartEvent.defaultPrevented) {
        isAnyPuStartEventDefaultPrevented = true;
      }
    });

    if (isAnyPuStartEventDefaultPrevented) {
      return;
    }

    (0, _formsChangesChecker.clearChangedFlagForContainedForm)(target);

    var performComplete = function performComplete(jqXHR, textStatus, newAccessibleTarget, settings) {
      (0, _XHRQueue.removeXHR)(target);
      var alterHistoryUrl = null;
      var actualUrl = null;
      var actualParams = null;
      if (newAccessibleTarget && alterHistory) {
        // dopočítání url z z XHR hlaviček
        // může se využít pro zaznamenávání/manipulování historie prohlížeče
        actualUrl = jqXHR.getResponseHeader(RAMJET_RESPONSE_HEADERS.RAMJET_REQUESTEDURL) || settings.url;
        actualParams = jqXHR.getResponseHeader(RAMJET_RESPONSE_HEADERS.RAMJET_REQUESTEDPARAMETERS);
        //if (!actualParams) {
        /*          const targetElement = document.getElementById(getTarget(settings));
                  console.log(document.getElementById(getTarget(settings)));
                  const inputsScopeContainer =
                    getParentPartialUpdateContainer(targetElement) ||
                    document.getElementById(getTarget(settings.target));
                  console.log($(inputsScopeContainer))
                  console.log($(inputsScopeContainer).find('form').serializeArray())
                  */
        // }
        var data = settings.data;

        if (actualUrl) {
          var actualUri = new _urijs2.default(actualUrl);
          if (actualParams) {
            actualUri.search(actualParams);
          }
          actualUri.removeSearch('_');
          actualUri.removeSearch(RAMJET_SPECIFIC_PARAMETERS.SUPPRESS_REDIRECT);
          actualUri.removeSearch(RAMJET_SPECIFIC_PARAMETERS.HISTORY_SCOPE);
          actualUri.removeSearch(RAMJET_SPECIFIC_PARAMETERS.CONTEXT);
          actualUri.removeSearch(RAMJET_SPECIFIC_PARAMETERS.LAYOUT_CONTEXT);

          if (data) {
            data.forEach(function (_ref6) {
              var name = _ref6.name;

              actualUri.removeSearch(name);
            });
          }
          actualUri.authority('').origin('');
          alterHistoryUrl = (0, _partialUpdateUtils.getCleanUrl)(actualUri.toString());
          alterHistoryUrl = (0, _partialUpdateUtils.removeFormIdFromUrl)(alterHistoryUrl);
          // alterHistoryUrl = removeDataFromUrl(alterHistoryUrl, true, true);
          alterHistoryUrl = (0, _urlAndLink.normalizeUrl)(alterHistoryUrl);
        }
      }

      removeDataInputs(settings);

      var hasError = jqXHR.getResponseHeader(RAMJET_RESPONSE_HEADERS.RAMJET_ERROR) === 'true';

      var layoutContext = settings.layoutContext,
          url = settings.url,
          onAlterHistory = settings.onAlterHistory,
          onComplete = settings.onComplete;

      // complete se volá ještě před execute innerPUsettings, které se parsuje z url

      if (newAccessibleTarget && newAccessibleTarget.length > 0) {
        (0, _dom.dispatchEvent)(newAccessibleTarget[0], 'partialUpdateComplete', {
          settings: settings,
          xhr: jqXHR,
          params: actualParams,
          url: actualUrl,
          alterHistoryUrl: alterHistoryUrl,
          newAccessibleTarget: newAccessibleTarget[0],
          hasError: hasError,
          textStatus: textStatus
        });

        if (onComplete) {
          onComplete({
            xhr: jqXHR,
            settings: settings,
            textStatus: textStatus,
            alterHistoryUrl: alterHistoryUrl,
            hasError: hasError,
            newAccessibleTarget: newAccessibleTarget[0]
          });
        }
      }

      var innerPUsettings = void 0;

      if (url) {
        innerPUsettings = (0, _partialUpdateUtils.parsePartialUpdateSettingsFromUrl)(url);
        if (innerPUsettings) {
          // eslint-disable-next-line
          execute(_extends({}, innerPUsettings, {
            layoutContext: layoutContext,
            onAlterHistory: onAlterHistory,
            onComplete: onComplete
          }));
        }
      }
      if (!innerPUsettings) {
        if (alterHistory && alterHistoryUrl && onAlterHistory) {
          onAlterHistory({
            settings: settings,
            xhr: jqXHR,
            params: actualParams,
            url: actualUrl,
            alterHistoryUrl: alterHistoryUrl,
            newAccessibleTarget: newAccessibleTarget[0],
            hasError: hasError,
            textStatus: textStatus
          });
        }
      }
    };
    if (onBeforeExecute) {
      onBeforeExecute({
        settings: settings
      });
    }

    var ajaxSettings = composeAjaxSettings({
      success: function success(result, textStatus, jqXHR) {
        if (window.measurePerformance) {
          // eslint-disable-next-line
          console.log('Partial update request time: ' + (new Date().getTime() - ajaxStartTime));
        }
        if (result != null && jqXHR.status === 200) {

          if (jqXHR.getResponseHeader('FULL_PAGE_REDIRECT')) {
            var location = jqXHR.getResponseHeader('FULL_PAGE_REDIRECT');
            var targets = (0, _partialUpdateUtils.getTargets)(settings);

            // pokud je v nastavení více targetů, tak se event firuje pouze na první
            var targetElement = document.getElementById(targets[0]);
            var beforeFullPageRedirect = (0, _dom.dispatchEvent)(targetElement, 'beforeFullPageRedirect', {
              location: location,
              result: result,
              textStatus: textStatus,
              xhr: jqXHR,
              settings: settings,
              targetElement: targetElement
            });
            if (!beforeFullPageRedirect.defaultPrevented) {
              window.location = location;
            }
            (0, _XHRQueue.removeXHR)(target);
            return;
          }

          var newAccessibleTargets = handleSuccess({
            result: result,
            settings: settings,
            jqXHR: jqXHR,
            textStatus: textStatus
          });
          newAccessibleTargets.forEach(function (newAccessibleTarget) {
            performComplete(jqXHR, textStatus, newAccessibleTarget, settings);
          });
        } else {
          performComplete(jqXHR, textStatus, null, settings);
          throwPUError({
            message: 'Server returned HTTP: ' + jqXHR.status + ' (no partial update performed)',
            settings: settings,
            jqXHR: jqXHR
          });
        }
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        performComplete(jqXHR, textStatus, null, settings);
        if (jqXHR.statusText !== 'abort') {
          throwPUError({
            message: 'Server returned HTTP: ' + jqXHR.status + ' ' + textStatus + ' (' + errorThrown + '). No partial update performed.',
            settings: settings,
            jqXHR: jqXHR,
            textStatus: textStatus,
            errorThrown: errorThrown
          });
        }
      }
    }, settings, form, button);
    var ajaxStartTime = new Date().getTime();
    var xhr = _jquery2.default.ajax(ajaxSettings);
    (0, _XHRQueue.addXHR)(target, xhr, settings);
  }
};

/**
 * Vyvolá PU s vlastním nastavením.
 * Request je volán POST metodou.
 * V requestu jsou odesílána všechna form data ze všech formůlářů, které jsou v parentím
 * jsPartialUpdate Form data z formulářů které jsou mimo parentí jsPartialUpdate a jsou na stejné
 * stránce se neodesílají
 */
var executeSubmit = exports.executeSubmit = function executeSubmit(settings) {
  var submitId = settings.submitId;


  var submitElement = (0, _jquery2.default)('#' + submitId);
  if (submitElement.length === 0) {
    throwPUError({
      message: 'Cannot perform partial update - submit or form with id ' + submitId + ' is not present.',
      settings: settings
    });
  }
  var isForm = submitElement.is('form');
  var isButton = (0, _partialUpdateUtils.isButtonElement)(submitElement);
  var form = isForm ? submitElement : submitElement.parents('form');

  if (form.length === 0) {
    if (submitElement.length === 0) {
      throwPUError({
        message: 'Cannot perform partial update - form not found.',
        settings: settings
      });
    }
  }
  var button = isButton ? submitElement : null;

  var formPartialUpdateUrl = form.data('partialUpdateUrl');
  var url = settings.url || formPartialUpdateUrl || form.attr('action');

  return executeAjax({
    settings: _extends({
      type: 'POST',
      dataType: 'html',
      partialUpdateType: 'submit'
    }, settings, {
      url: url
    }),
    form: form,
    button: button
  });
};

/**
 * Vyvolá PU s vlastním nastavením.
 * Request je volán GET.
 * Nejsou odesílána widget data
 * Pouze se odesílá url a vlastní data z nastavení data
 */
var execute = exports.execute = function execute(settings) {
  if (settings.target == null && settings.containerId == null) {
    settings.target = (0, _PartialUpdateSettings.getGlobalPartialUpdateSettings)().globalTarget;
  }

  executeAjax({
    settings: _extends({
      type: 'GET',
      dataType: 'html'
    }, settings)
  });
};

/**
 * přeruší execute partial updatu včetně přerušení XHR
 */
var abortExecute = exports.abortExecute = function abortExecute(settings) {
  var target = (0, _partialUpdateUtils.getTarget)(settings);
  (0, _XHRQueue.abortXHR)(target);
};

/**
 * Doporučuji volat např. při zavírání modal dialogu
 * Zajistí destroy všech vnitřních komponent a do targetu bude nasetováno prázné HTML
 */
var puClearTimeout = void 0;
var clear = exports.clear = function clear(settings) {
  clearTimeout(clearTimeout);
  var globalPUSettings = (0, _PartialUpdateSettings.getGlobalPartialUpdateSettings)();
  settings = _extends({}, globalPUSettings, settings, {
    partialUpdateType: 'clear'
  });
  var target = (0, _partialUpdateUtils.getTarget)(settings);
  var _settings3 = settings,
      formsChangesDetection = _settings3.formsChangesDetection,
      onFormsChangesDetect = _settings3.onFormsChangesDetect,
      onComplete = _settings3.onComplete;

  (0, _XHRQueue.abortXHR)(target);
  var targetEl = document.getElementById(target);
  if (formsChangesDetection && onFormsChangesDetect != null && (0, _formsChangesChecker.containsChangedForm)(target)) {
    onFormsChangesDetect({
      settings: settings
    });
  } else if (targetEl) {
    var existsEdeeDecorateMethods = window.fg && window.fg.ui && window.fg.ui.decorate;
    if (existsEdeeDecorateMethods) {
      window.fg.ui.decorate.disposeDecoratedComponents(targetEl);
    } else {
      (0, _decorate.disposeInnerComponents)(targetEl);
    }

    // pro vymazání HTML je potřeba dát zpoždění
    // pokud je PU použit v reactu, tak se může stát že PU by smazal elemnty dříve
    // než by se nad nimi unmoutly react komponenty
    puClearTimeout = setTimeout(function () {
      targetEl.innerHTML = '';
      if (onComplete) {
        onComplete({
          settings: settings
        });
      }
    }, 1);
  }
};

/**
 * Formulář se neodešle pomocí AJAXu. Ale bude odeslán do iframu nebo nového tabu prohlížeče.
 * ID iframu se definuje do target vlastnoti
 * Pokud je target _blank nebo není definovaný tak se formulář odešle do nového okna prohlížeče
 */
var submitToIFrameOrBrowserTab = exports.submitToIFrameOrBrowserTab = function submitToIFrameOrBrowserTab(submitSettings) {
  var submitId = submitSettings.submitId,
      url = submitSettings.url,
      data = submitSettings.data;
  var target = submitSettings.target;

  if (!target) {
    target = '_blank';
  }
  var submitElement = (0, _jquery2.default)('#' + submitId);
  if (submitElement.length === 0) {
    throwPUError({
      message: 'Cannot perform submit to iframe - submit or form with id ' + submitId + ' is not present.',
      settings: submitSettings
    });
  }
  var isForm = submitElement.is('form');
  var isButton = (0, _partialUpdateUtils.isButtonElement)(submitElement);
  var form = isForm ? submitElement : submitElement.parents('form');
  if (form.length === 0) {
    throwPUError({
      message: 'Cannot perform submit to iframe - form not found.',
      settings: submitSettings
    });
  }
  var button = isButton ? submitElement : null;
  var settings = composeAjaxSettings({}, {
    url: url,
    submitId: submitId,
    data: data
  }, form, button);

  // TODO DRY
  // normalizace url do settings
  // seřadí se parametry
  // odebere se domena
  if (settings.url) {
    var settingsUri = new _urijs2.default((0, _urlAndLink.normalizeUrl)(settings.url));
    settings.url = (0, _partialUpdateUtils.getCleanUrl)(settingsUri.authority('').origin('').toString());
  }

  var actualAction = form.attr('action');
  var formElement = form[0];

  // odfiltruje inputy kter0 ve formuláři už jsou
  // potom se vyrenderují inputy které ve formuláři nejsou
  // po odeslání se dorenderované inputy smažou
  var inputsForRendering = settings.data.filter(function (inputAttributes) {
    var name = inputAttributes.name;

    return formElement.querySelector('[name="' + name + '"]:not(button)') == null;
  });

  var renderedInputs = [];
  inputsForRendering.forEach(function (_ref7) {
    var name = _ref7.name,
        value = _ref7.value;

    var input = document.createElement('input');
    input.setAttribute('name', name);
    input.setAttribute('value', value);
    input.setAttribute('type', 'hidden');
    formElement.appendChild(input);
    renderedInputs.push(input);
  });

  form.attr('action', settings.url);
  form.attr('target', target);
  formElement.submit();
  form.attr('target', '');
  form.attr('action', actualAction);
  renderedInputs.forEach(function (input) {
    formElement.removeChild(input);
  });
};

/**
 * Podle toho kde se nachází element ze vstupního parametru se automaticky
 * rozhodne jak a jakým nastavením bude PU vyvolán.
 * Do nastavení se mergne PU nastavení, které je na elementu přidáno pomocí dsata atributů.
 */
var resolveExecute = exports.resolveExecute = function resolveExecute(element, customSettings) {
  var settings = void 0;
  if (customSettings == null || customSettings.mergeWithTargetSettings == null || customSettings.mergeWithTargetSettings === true) {
    // target a request target brát pouze z elementu, na kterém resolve potřebujeme
    var closestSettingsWithoutTargetAndRequestTarget = (0, _PartialUpdateSettings.getClosestPartialUpdateSettings)(element, ['target', 'requestTarget', 'url']);

    settings = _extends({}, closestSettingsWithoutTargetAndRequestTarget, (0, _PartialUpdateSettings.getElementPartialUpdateSettings)(element), {
      source: element.closest('[id]').getAttribute('id')
    }, customSettings);
  } else {
    settings = customSettings || {};
  }

  var targets = (0, _partialUpdateUtils.getTargets)(settings);

  targets.forEach(function (targetFromTargets) {
    if (targetFromTargets && !document.getElementById(targetFromTargets)) {
      throwPUError({
        message: 'Widget s id atributem "' + targetFromTargets + '" nebyl v DOMu nalezen. Prov\u011B\u0159te, \u017Ee id m\xE1te v HTML vygenerovan\xE9 spr\xE1vn\u011B.',
        settings: settings
      });
    }
  });

  var _settings4 = settings,
      target = _settings4.target,
      requestTarget = _settings4.requestTarget;
  var _settings5 = settings,
      removeContainerWidgetData = _settings5.removeContainerWidgetData;

  // po kliknutí na odkaz IE11 vrací event.target jako elemnty uvnitř, je potřeba zjistit closest odkaz

  var closestHref = element.closest('a');
  var hrefUrl = closestHref ? closestHref.getAttribute('href') : null;

  var url = settings.url || hrefUrl;
  var form = element.closest('form');
  var parentPUContainer = (0, _partialUpdateUtils.getParentPartialUpdateContainer)(element);
  var parentPUContainerId = parentPUContainer ? parentPUContainer.getAttribute('id') : null;
  var parentPUSettings = parentPUContainer ? (0, _PartialUpdateSettings.getElementPartialUpdateSettings)(parentPUContainer) : {};

  if (form && !hrefUrl && !(removeContainerWidgetData && target === form.getAttribute('id'))) {
    var formId = form.getAttribute('id');
    settings.target = target || parentPUContainerId || formId;
    settings.requestTarget = requestTarget || target || parentPUSettings.requestTarget || parentPUContainerId || formId;
    executeSubmit(_extends({
      submitId: formId
    }, settings));
  } else {
    if (!target) {
      if (parentPUContainerId) {
        target = parentPUContainerId;
        if (!requestTarget) {
          requestTarget = parentPUSettings.requestTarget;
        }
      } else {
        throwPUError({
          message: 'Specifikujte pomocí data-partial-update-target atributu id elementu, který chcete aktualizovat',
          settings: settings
        });
      }
    }
    var closestSetting = (0, _PartialUpdateSettings.getClosestPartialUpdateSettings)(settings);
    settings.url = url || closestSetting.url;
    if (settings.removeContainerWidgetData && form) {
      var noFrmData = (0, _jquery2.default)('input[name]:not([name^="frm."])', form).serializeArray();
      noFrmData = noFrmData.filter(function (_ref8) {
        var name = _ref8.name;
        return name !== 'formId';
      });
      var uri = new _urijs2.default(settings.url);
      var query = {};
      noFrmData.forEach(function (_ref9) {
        var name = _ref9.name,
            value = _ref9.value;

        query[name] = value;
      });
      uri.addQuery(query);
      settings.url = uri.toString();
    }

    settings.target = target;
    settings.requestTarget = requestTarget || target;
    execute(_extends({
      alterHistory: false
    }, settings));
  }
};

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTargetElements = exports.isButtonElement = exports.isMultipart = exports.getFileInputs = exports.getParentPartialUpdateContainer = exports.getJQuery = exports.parseResultsFromAjaxResult = exports.parsePartialUpdateSettingsFromUrl = exports.removeFormIdFromData = exports.removeFormIdFromUrl = exports.removeDataFromUrl = exports.getSubmitId = exports.getTarget = exports.getTargets = exports.getRequestTarget = exports.getCleanUrl = exports.getElementIdWithContext = exports.getDynamicAreaIdWithoutContextFromUrl = exports.getDynamicAreaIdWithoutContext = exports.getDynamicAreaId = exports.getComposedUrl = undefined;

var _urijs = __webpack_require__(57);

var _urijs2 = _interopRequireDefault(_urijs);

var _jquery = __webpack_require__(3);

var _jquery2 = _interopRequireDefault(_jquery);

var _PartialUpdateSettings = __webpack_require__(51);

var _form = __webpack_require__(109);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // 
/**
 *
 * @author Jakub Ruffer <ruffer@fg.cz>
 */


var getComposedUrl = exports.getComposedUrl = function getComposedUrl(url, target) {
  if (Array.isArray(target)) {
    target = target.join('+');
  }
  target = encodeURIComponent(target);
  var index = url.indexOf('?');
  var indexHash = url.indexOf('#');
  if (indexHash > -1 && (indexHash < index || index === -1)) {
    index = indexHash;
  }
  if (index > -1) {
    return url.substr(0, index) + '@' + target + url.substr(index);
  }
  return url + '@' + target;
};

var getDynamicAreaId = exports.getDynamicAreaId = function getDynamicAreaId(uri) {
  var hashIndex = uri.indexOf('#');
  var questionMarkIndex = uri.indexOf('?');
  var atIndex = uri.indexOf('@');
  var match = uri.match(/(@)(.*?(?=\?|#|$))/);

  if (atIndex > hashIndex && atIndex > questionMarkIndex && (hashIndex > -1 || questionMarkIndex > -1)) {
    return null;
  }
  if (questionMarkIndex > -1 && atIndex > questionMarkIndex) {
    return null;
  }
  if (match && match.length > 2) {
    return match[2];
  }
  return null;
};

var getDynamicAreaIdWithoutContextFromString = function getDynamicAreaIdWithoutContextFromString(areaId) {
  var match = areaId.match(/ramJetLayoutContext_(.*)_(.*)/);
  return match && match[2] ? match[2] : areaId;
};

var getDynamicAreaIdWithoutContext = exports.getDynamicAreaIdWithoutContext = function getDynamicAreaIdWithoutContext(areaId) {
  if (Array.isArray(areaId)) {
    return areaId.map(function (area) {
      return getDynamicAreaIdWithoutContextFromString(area);
    }).sort();
  }
  return getDynamicAreaIdWithoutContextFromString(areaId);
};

var getDynamicAreaIdWithoutContextFromUrl = exports.getDynamicAreaIdWithoutContextFromUrl = function getDynamicAreaIdWithoutContextFromUrl(uri) {
  var areaId = getDynamicAreaId(uri);
  if (areaId) {
    return getDynamicAreaIdWithoutContext(areaId);
  }
  return areaId;
};

var getElementIdWithContext = exports.getElementIdWithContext = function getElementIdWithContext(target, contextId) {
  return 'ramJetLayoutContext_' + contextId + '_' + getDynamicAreaIdWithoutContext(target);
};

var getCleanUrl = exports.getCleanUrl = function getCleanUrl(uri, optRemoveOrigin) {
  var hashIndex = uri.indexOf('#');
  var questionMarkIndex = uri.indexOf('?');
  var atIndex = uri.indexOf('@');

  // jestliže se první index zavináče nachází za otazníkem nebo hashem, tak se nejedná o
  // indetifikátor widgetu, ale je pouze součástí hodnoty parametru nebo samotného názvu parametru
  if (atIndex > hashIndex && atIndex > questionMarkIndex && (hashIndex > -1 || questionMarkIndex > -1)) {
    return uri;
  }
  if (questionMarkIndex > -1 && atIndex > questionMarkIndex) {
    return uri;
  }

  if (optRemoveOrigin) {
    // eslint-disable-next-line
    uri = uri.replace(/^.*\/\/[^\/]+/, '');
  }

  return uri.replace(/(@.*?)(?=\?|#|$)/, '');
};

var getRequestTarget = exports.getRequestTarget = function getRequestTarget(_ref) {
  var layoutContext = _ref.layoutContext,
      requestTarget = _ref.requestTarget;

  if (requestTarget && layoutContext) {
    requestTarget = getElementIdWithContext(requestTarget, layoutContext);
  }
  return requestTarget;
};
var getTargets = exports.getTargets = function getTargets(_ref2) {
  var layoutContext = _ref2.layoutContext,
      target = _ref2.target,
      containerId = _ref2.containerId;

  var targets = target || containerId;
  if (targets == null) {
    return [];
  }
  if (!Array.isArray(targets)) {
    targets.replace(/,/g, '+');
    targets = targets.split('+');
  }
  if (layoutContext) {
    targets = targets.map(function (computedTarget) {
      return getElementIdWithContext(computedTarget, layoutContext);
    });
  }
  return targets;
};
var getTarget = exports.getTarget = function getTarget(settings) {
  return getTargets(settings).join('+');
};
var getSubmitId = exports.getSubmitId = function getSubmitId(_ref3) {
  var layoutContext = _ref3.layoutContext,
      submitId = _ref3.submitId;

  if (submitId && layoutContext) {
    submitId = getElementIdWithContext(submitId, layoutContext);
  }
  return submitId;
};

var removeDataFromUrl = exports.removeDataFromUrl = function removeDataFromUrl(url, remove, likeWidgetData) {
  if (!remove) {
    return url;
  }
  var uri = new _urijs2.default(url);
  var query = _urijs2.default.parseQuery(uri.query());
  var queryFormData = Object.keys(query).map(function (key) {
    return {
      name: key,
      value: query[key]
    };
  });
  queryFormData = (0, _form.removeFromData)(queryFormData, remove, likeWidgetData);
  var newQuery = {};
  queryFormData.forEach(function (_ref4) {
    var name = _ref4.name,
        value = _ref4.value;

    newQuery[name] = value;
  });
  uri.query(newQuery);

  return uri.toString();
};

var removeFormIdFromUrl = exports.removeFormIdFromUrl = function removeFormIdFromUrl(url) {
  var uri = new _urijs2.default(url);
  uri.removeQuery('formId');
  return uri.toString();
};

var removeFormIdFromData = exports.removeFormIdFromData = function removeFormIdFromData(data) {
  return data.filter(function (_ref5) {
    var name = _ref5.name;
    return name !== 'formId';
  });
};

var parsePartialUpdateSettingsFromUrl = exports.parsePartialUpdateSettingsFromUrl = function parsePartialUpdateSettingsFromUrl(url) {
  var frameUri = new _urijs2.default(url);
  var innerPartialUpdate = null;
  if (frameUri.hasQuery('pu')) {
    var query = _urijs2.default.parseQuery(frameUri.query());
    var pu = query.pu;

    try {
      innerPartialUpdate = JSON.parse(pu);
      // eslint-disable-next-line
    } catch (err) {}
    return innerPartialUpdate;
  }
  return innerPartialUpdate;
};

var parseResultsFromAjaxResult = exports.parseResultsFromAjaxResult = function parseResultsFromAjaxResult(settings, result) {
  var target = settings.target;

  target = getTargets(settings);
  if (target.length > 1) {
    var prefix = '<!-- RamJet-WidgetDelimiters:';
    var suffix = ' -->';
    var pIndex = result.indexOf(prefix);
    var sIndex = result.indexOf(suffix, pIndex + prefix.length);
    var results = {};
    if (pIndex > -1 && sIndex > -1) {
      var multipleWidgetDelimiters = result.substr(pIndex + prefix.length, sIndex - (pIndex + prefix.length));
      var widgetResultDelimiters = multipleWidgetDelimiters.split(',');
      var lastIndex = sIndex + suffix.length;
      widgetResultDelimiters.forEach(function (delimiter, index) {
        var delimiterInHTMLComments = '<!-- ' + delimiter + ' -->';
        var nextIndex = result.indexOf(delimiterInHTMLComments);
        var singleResult = result.substr(lastIndex, nextIndex - lastIndex);
        lastIndex = nextIndex + delimiterInHTMLComments.length;
        results[target[index]] = singleResult;
      });
    } else {
      throw new Error('Server returned unparseable result - expected response starting with: ' + prefix + ' ' + suffix);
    }
    return results;
  }

  return _defineProperty({}, target[0], result);
};

var getJQuery = exports.getJQuery = function getJQuery(element) {
  if (typeof element === 'string') {
    return (0, _jquery2.default)('#' + element);
  }
  if (element instanceof _jquery2.default) {
    return element;
  }
  return (0, _jquery2.default)(element);
};

var getParentPartialUpdateContainer = exports.getParentPartialUpdateContainer = function getParentPartialUpdateContainer(element) {
  return element.closest('.isPartialUpdateContainer');
};

var getFileInputs = exports.getFileInputs = function getFileInputs(form) {
  // nebrat file inputy vyuzivane pluploadem, tedy ty co jsou uvnir elementu s css tridou plupload
  return (0, _jquery2.default)('input:file', form).not('.plupload input:file');
};

var isMultipart = exports.isMultipart = function isMultipart(jForm) {
  if (jForm.hasClass('noFileUpload')) {
    return false;
  }
  var hasFileInputs = getFileInputs(jForm).length > 0;
  var mp = 'multipart/form-data';
  var multipart = jForm.attr('enctype') === mp || jForm.attr('encoding') === mp;
  return hasFileInputs || multipart;
};
var isButtonElement = exports.isButtonElement = function isButtonElement(element) {
  return element.is('input[type="submit"], input[type="image"], button[type="submit"], button[type="button"]');
};

var getTargetElements = exports.getTargetElements = function getTargetElements(settings) {
  var targets = getTargets(settings);
  return targets.map(function (tar) {
    return document.getElementById(tar);
  });
};

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(9).f;
var has = __webpack_require__(16);
var TAG = __webpack_require__(6)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(22);
var TAG = __webpack_require__(6)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var defined = __webpack_require__(26);
var fails = __webpack_require__(4);
var spaces = __webpack_require__(85);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 50 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPaginationSubmitData = exports.getClosestPartialUpdateSettings = exports.getElementPartialUpdateSettings = exports.settingsDataAttributesMap = exports.setPartialUpdateDefaultSettings = exports.getGlobalPartialUpdateSettings = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // 


var _defaultSettings = __webpack_require__(410);

var _defaultSettings2 = _interopRequireDefault(_defaultSettings);

var _dataset = __webpack_require__(106);

var _partialUpdateUtils = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 Definice nastavení Partial Updatu.

 Data atributy ze kterých se parsují settings.

 Klíč je data atribut a hodnota určuje o jakou vlastnost nastavení se jedná:
 <pre>{
  'data-partial-update-request-target': 'requestTarget',
  'data-pu-request-target': 'requestTarget',
  'data-partial-update-target-html-container': 'requestTarget',
  'data-pu-target-html-container': 'requestTarget',
  'data-partial-update-target': 'target',
  'data-pu-target': 'target',
  'data-partial-update-widget': 'target',
  'data-pu-widget': 'target',
  'data-partial-update-command': 'eventName',
  'data-pu-command': 'eventName',
  'data-partial-update-event-name': 'eventName',
  'data-pu-event-name': 'eventName',
  'data-partial-update-data': 'data',
  'data-pu-data': 'data',
  'data-partial-update-url': 'url',
  'data-pu-url': 'url',
  'data-partial-update-alter-history': 'alterHistory',
  'data-pu-alter-history': 'alterHistory',
  'data-partial-update-settings': 'settings',
  'data-pu-settings': 'settings',
  }</pre>
 */

window.partialUpdateGlobalSettings = _extends({}, _defaultSettings2.default);
var getGlobalPartialUpdateSettings = exports.getGlobalPartialUpdateSettings = function getGlobalPartialUpdateSettings() {
  return window.partialUpdateGlobalSettings;
};

/**
 * Na defaultní nastavení pro celí projekt
 */
var setPartialUpdateDefaultSettings = exports.setPartialUpdateDefaultSettings = function setPartialUpdateDefaultSettings(settings) {
  window.partialUpdateGlobalSettings = _extends({}, _defaultSettings2.default, settings);
};

var settingsDataAttributesMap = exports.settingsDataAttributesMap = {
  'data-partial-update-request-target': 'requestTarget',
  'data-pu-request-target': 'requestTarget',
  'data-partial-update-target-html-container': 'requestTarget',
  'data-pu-target-html-container': 'requestTarget',
  'data-partial-update-target': 'target',
  'data-pu-target': 'target',
  'data-partial-update-widget': 'target',
  'data-pu-widget': 'target',
  'data-partial-update-command': 'eventName',
  'data-pu-command': 'eventName',
  'data-partial-update-event-name': 'eventName',
  'data-pu-event-name': 'eventName',
  'data-partial-update-data': 'data',
  'data-pu-data': 'data',
  'data-partial-update-url': 'url',
  'data-pu-url': 'url',
  'data-partial-update-alter-history': 'alterHistory',
  'data-pu-alter-history': 'alterHistory',
  'data-partial-update-data-merge': 'dataMerge',
  'data-pu-data-merge': 'dataMerge',
  // nechat na konci. Settings se mergují do všech nasbíraných
  'data-partial-update-settings': 'settings',
  'data-pu-settings': 'settings'
};

var getElementPartialUpdateSettings = exports.getElementPartialUpdateSettings = function getElementPartialUpdateSettings(element) {
  var settings = {};
  if (element) {
    Object.keys(settingsDataAttributesMap).forEach(function (dataset) {
      var prop = settingsDataAttributesMap[dataset];
      var datasetValue = (0, _dataset.getDataSet)(element, dataset.replace(/^data-/, ''));
      if (datasetValue != null) {
        if (prop === 'settings') {
          settings = _extends({}, settings, datasetValue);
        } else {
          settings[prop] = datasetValue;
        }
      }
    });
  }
  return settings;
};

// Přečte nastavení partial update ze všech closest
// elementů a mergne je do sebe
// - excludePartialUpdateContainerSettings - pokud je true,
// tak vynechá všechna nastavení z parentího partial update containeru
// - excludePartialUpdateContainerSettings - pokud je Array<String>,
// tak vynechá jen specifikovaná nastavení z parentího partial update containeru
var getClosestPartialUpdateSettings = exports.getClosestPartialUpdateSettings = function getClosestPartialUpdateSettings(settings, excludePartialUpdateContainerSettings) {
  var targetElement = void 0;
  var mergeWithTargetSettings = void 0;
  var closestSettings = {};

  if (settings instanceof HTMLElement) {
    targetElement = settings;
  } else {
    var submitId = settings.submitId;

    mergeWithTargetSettings = settings.mergeWithTargetSettings;
    var firstTarget = (0, _partialUpdateUtils.getTargets)(settings)[0];
    targetElement = document.getElementById(firstTarget || submitId);
  }

  var startClosestElement = mergeWithTargetSettings == null || mergeWithTargetSettings === true ? targetElement : targetElement.parentElement;

  if (targetElement) {
    Object.keys(settingsDataAttributesMap).forEach(function (dataset) {
      var prop = settingsDataAttributesMap[dataset];
      var closestDatasetElement = void 0;
      if (excludePartialUpdateContainerSettings) {
        if (Array.isArray(excludePartialUpdateContainerSettings)) {
          if (excludePartialUpdateContainerSettings.includes(prop)) {
            closestDatasetElement = startClosestElement.closest('[' + dataset + ']:not(.isPartialUpdateContainer)');
          } else {
            closestDatasetElement = startClosestElement.closest('[' + dataset + ']');
          }
        } else {
          closestDatasetElement = startClosestElement.closest('[' + dataset + ']:not(.isPartialUpdateContainer)');
        }
      } else {
        closestDatasetElement = startClosestElement.closest('[' + dataset + ']');
      }
      if (closestDatasetElement) {
        var datasetValue = (0, _dataset.getDataSet)(closestDatasetElement, dataset.replace(/^data-/, ''));
        if (prop === 'settings') {
          closestSettings = _extends({}, closestSettings, datasetValue);
        } else {
          closestSettings[prop] = datasetValue;
        }
      }
    });
  }
  return closestSettings;
};

var getPaginationSubmitData = exports.getPaginationSubmitData = function getPaginationSubmitData(settings) {
  var element = void 0;

  if (settings instanceof HTMLElement) {
    element = settings;
  } else {
    var submitId = settings.submitId;

    var firstTarget = (0, _partialUpdateUtils.getTargets)(settings)[0];
    element = document.getElementById(firstTarget || submitId);
  }
  // jestliže je uvnitř widgetu pagination widget,
  // tak z něj získá aktuální počet načtených stránek
  // a obsah refreshne s parametrem pageSize
  var pagination = element.querySelector('[data-fragment="pagination"]');
  var data = [];
  if (pagination) {
    var paginationProps = (0, _dataset.getDataSet)(pagination);
    var loadedPagesParameterName = paginationProps.loadedPagesParameterName,
        loadedPages = paginationProps.loadedPages,
        pageSize = paginationProps.pageSize,
        pageSizeParameterName = paginationProps.pageSizeParameterName,
        pageNumber = paginationProps.pageNumber,
        pageNumberParameterName = paginationProps.pageNumberParameterName;


    if (loadedPagesParameterName && loadedPages != null && pageSize != null && pageNumber != null) {
      data.push({
        name: pageSizeParameterName,
        value: pageSize * loadedPages
      });
      data.push({
        name: pageNumberParameterName,
        value: pageNumber - loadedPages + 1
      });
    }
  }
  return data;
};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(20);
var global = __webpack_require__(2);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(31) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(22);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(1);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(1);
var aFunction = __webpack_require__(11);
var SPECIES = __webpack_require__(6)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * URI.js - Mutating URLs
 *
 * Version: 1.19.11
 *
 * Author: Rodney Rehm
 * Web: http://medialize.github.io/URI.js/
 *
 * Licensed under
 *   MIT License http://www.opensource.org/licenses/mit-license
 *
 */
(function (root, factory) {
  'use strict';
  // https://github.com/umdjs/umd/blob/master/returnExports.js

  if (( false ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
    // Node
    module.exports = factory(__webpack_require__(153), __webpack_require__(155), __webpack_require__(156));
  } else if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(153), __webpack_require__(155), __webpack_require__(156)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {
    // Browser globals (root is window)
    root.URI = factory(root.punycode, root.IPv6, root.SecondLevelDomains, root);
  }
})(undefined, function (punycode, IPv6, SLD, root) {
  'use strict';
  /*global location, escape, unescape */
  // FIXME: v2.0.0 renamce non-camelCase properties to uppercase
  /*jshint camelcase: false */

  // save current URI variable, if any

  var _URI = root && root.URI;

  function URI(url, base) {
    var _urlSupplied = arguments.length >= 1;
    var _baseSupplied = arguments.length >= 2;

    // Allow instantiation without the 'new' keyword
    if (!(this instanceof URI)) {
      if (_urlSupplied) {
        if (_baseSupplied) {
          return new URI(url, base);
        }

        return new URI(url);
      }

      return new URI();
    }

    if (url === undefined) {
      if (_urlSupplied) {
        throw new TypeError('undefined is not a valid argument for URI');
      }

      if (typeof location !== 'undefined') {
        url = location.href + '';
      } else {
        url = '';
      }
    }

    if (url === null) {
      if (_urlSupplied) {
        throw new TypeError('null is not a valid argument for URI');
      }
    }

    this.href(url);

    // resolve to base according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#constructor
    if (base !== undefined) {
      return this.absoluteTo(base);
    }

    return this;
  }

  function isInteger(value) {
    return (/^[0-9]+$/.test(value)
    );
  }

  URI.version = '1.19.11';

  var p = URI.prototype;
  var hasOwn = Object.prototype.hasOwnProperty;

  function escapeRegEx(string) {
    // https://github.com/medialize/URI.js/commit/85ac21783c11f8ccab06106dba9735a31a86924d#commitcomment-821963
    return string.replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
  }

  function getType(value) {
    // IE8 doesn't return [Object Undefined] but [Object Object] for undefined value
    if (value === undefined) {
      return 'Undefined';
    }

    return String(Object.prototype.toString.call(value)).slice(8, -1);
  }

  function isArray(obj) {
    return getType(obj) === 'Array';
  }

  function filterArrayValues(data, value) {
    var lookup = {};
    var i, length;

    if (getType(value) === 'RegExp') {
      lookup = null;
    } else if (isArray(value)) {
      for (i = 0, length = value.length; i < length; i++) {
        lookup[value[i]] = true;
      }
    } else {
      lookup[value] = true;
    }

    for (i = 0, length = data.length; i < length; i++) {
      /*jshint laxbreak: true */
      var _match = lookup && lookup[data[i]] !== undefined || !lookup && value.test(data[i]);
      /*jshint laxbreak: false */
      if (_match) {
        data.splice(i, 1);
        length--;
        i--;
      }
    }

    return data;
  }

  function arrayContains(list, value) {
    var i, length;

    // value may be string, number, array, regexp
    if (isArray(value)) {
      // Note: this can be optimized to O(n) (instead of current O(m * n))
      for (i = 0, length = value.length; i < length; i++) {
        if (!arrayContains(list, value[i])) {
          return false;
        }
      }

      return true;
    }

    var _type = getType(value);
    for (i = 0, length = list.length; i < length; i++) {
      if (_type === 'RegExp') {
        if (typeof list[i] === 'string' && list[i].match(value)) {
          return true;
        }
      } else if (list[i] === value) {
        return true;
      }
    }

    return false;
  }

  function arraysEqual(one, two) {
    if (!isArray(one) || !isArray(two)) {
      return false;
    }

    // arrays can't be equal if they have different amount of content
    if (one.length !== two.length) {
      return false;
    }

    one.sort();
    two.sort();

    for (var i = 0, l = one.length; i < l; i++) {
      if (one[i] !== two[i]) {
        return false;
      }
    }

    return true;
  }

  function trimSlashes(text) {
    var trim_expression = /^\/+|\/+$/g;
    return text.replace(trim_expression, '');
  }

  URI._parts = function () {
    return {
      protocol: null,
      username: null,
      password: null,
      hostname: null,
      urn: null,
      port: null,
      path: null,
      query: null,
      fragment: null,
      // state
      preventInvalidHostname: URI.preventInvalidHostname,
      duplicateQueryParameters: URI.duplicateQueryParameters,
      escapeQuerySpace: URI.escapeQuerySpace
    };
  };
  // state: throw on invalid hostname
  // see https://github.com/medialize/URI.js/pull/345
  // and https://github.com/medialize/URI.js/issues/354
  URI.preventInvalidHostname = false;
  // state: allow duplicate query parameters (a=1&a=1)
  URI.duplicateQueryParameters = false;
  // state: replaces + with %20 (space in query strings)
  URI.escapeQuerySpace = true;
  // static properties
  URI.protocol_expression = /^[a-z][a-z0-9.+-]*$/i;
  URI.idn_expression = /[^a-z0-9\._-]/i;
  URI.punycode_expression = /(xn--)/i;
  // well, 333.444.555.666 matches, but it sure ain't no IPv4 - do we care?
  URI.ip4_expression = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
  // credits to Rich Brown
  // source: http://forums.intermapper.com/viewtopic.php?p=1096#1096
  // specification: http://www.ietf.org/rfc/rfc4291.txt
  URI.ip6_expression = /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/;
  // expression used is "gruber revised" (@gruber v2) determined to be the
  // best solution in a regex-golf we did a couple of ages ago at
  // * http://mathiasbynens.be/demo/url-regex
  // * http://rodneyrehm.de/t/url-regex.html
  URI.find_uri_expression = /\b((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))/ig;
  URI.findUri = {
    // valid "scheme://" or "www."
    start: /\b(?:([a-z][a-z0-9.+-]*:\/\/)|www\.)/gi,
    // everything up to the next whitespace
    end: /[\s\r\n]|$/,
    // trim trailing punctuation captured by end RegExp
    trim: /[`!()\[\]{};:'".,<>?«»“”„‘’]+$/,
    // balanced parens inclusion (), [], {}, <>
    parens: /(\([^\)]*\)|\[[^\]]*\]|\{[^}]*\}|<[^>]*>)/g
  };
  URI.leading_whitespace_expression = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/;
  // https://infra.spec.whatwg.org/#ascii-tab-or-newline
  URI.ascii_tab_whitespace = /[\u0009\u000A\u000D]+/g;
  // http://www.iana.org/assignments/uri-schemes.html
  // http://en.wikipedia.org/wiki/List_of_TCP_and_UDP_port_numbers#Well-known_ports
  URI.defaultPorts = {
    http: '80',
    https: '443',
    ftp: '21',
    gopher: '70',
    ws: '80',
    wss: '443'
  };
  // list of protocols which always require a hostname
  URI.hostProtocols = ['http', 'https'];

  // allowed hostname characters according to RFC 3986
  // ALPHA DIGIT "-" "." "_" "~" "!" "$" "&" "'" "(" ")" "*" "+" "," ";" "=" %encoded
  // I've never seen a (non-IDN) hostname other than: ALPHA DIGIT . - _
  URI.invalid_hostname_characters = /[^a-zA-Z0-9\.\-:_]/;
  // map DOM Elements to their URI attribute
  URI.domAttributes = {
    'a': 'href',
    'blockquote': 'cite',
    'link': 'href',
    'base': 'href',
    'script': 'src',
    'form': 'action',
    'img': 'src',
    'area': 'href',
    'iframe': 'src',
    'embed': 'src',
    'source': 'src',
    'track': 'src',
    'input': 'src', // but only if type="image"
    'audio': 'src',
    'video': 'src'
  };
  URI.getDomAttribute = function (node) {
    if (!node || !node.nodeName) {
      return undefined;
    }

    var nodeName = node.nodeName.toLowerCase();
    // <input> should only expose src for type="image"
    if (nodeName === 'input' && node.type !== 'image') {
      return undefined;
    }

    return URI.domAttributes[nodeName];
  };

  function escapeForDumbFirefox36(value) {
    // https://github.com/medialize/URI.js/issues/91
    return escape(value);
  }

  // encoding / decoding according to RFC3986
  function strictEncodeURIComponent(string) {
    // see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/encodeURIComponent
    return encodeURIComponent(string).replace(/[!'()*]/g, escapeForDumbFirefox36).replace(/\*/g, '%2A');
  }
  URI.encode = strictEncodeURIComponent;
  URI.decode = decodeURIComponent;
  URI.iso8859 = function () {
    URI.encode = escape;
    URI.decode = unescape;
  };
  URI.unicode = function () {
    URI.encode = strictEncodeURIComponent;
    URI.decode = decodeURIComponent;
  };
  URI.characters = {
    pathname: {
      encode: {
        // RFC3986 2.1: For consistency, URI producers and normalizers should
        // use uppercase hexadecimal digits for all percent-encodings.
        expression: /%(24|26|2B|2C|3B|3D|3A|40)/ig,
        map: {
          // -._~!'()*
          '%24': '$',
          '%26': '&',
          '%2B': '+',
          '%2C': ',',
          '%3B': ';',
          '%3D': '=',
          '%3A': ':',
          '%40': '@'
        }
      },
      decode: {
        expression: /[\/\?#]/g,
        map: {
          '/': '%2F',
          '?': '%3F',
          '#': '%23'
        }
      }
    },
    reserved: {
      encode: {
        // RFC3986 2.1: For consistency, URI producers and normalizers should
        // use uppercase hexadecimal digits for all percent-encodings.
        expression: /%(21|23|24|26|27|28|29|2A|2B|2C|2F|3A|3B|3D|3F|40|5B|5D)/ig,
        map: {
          // gen-delims
          '%3A': ':',
          '%2F': '/',
          '%3F': '?',
          '%23': '#',
          '%5B': '[',
          '%5D': ']',
          '%40': '@',
          // sub-delims
          '%21': '!',
          '%24': '$',
          '%26': '&',
          '%27': '\'',
          '%28': '(',
          '%29': ')',
          '%2A': '*',
          '%2B': '+',
          '%2C': ',',
          '%3B': ';',
          '%3D': '='
        }
      }
    },
    urnpath: {
      // The characters under `encode` are the characters called out by RFC 2141 as being acceptable
      // for usage in a URN. RFC2141 also calls out "-", ".", and "_" as acceptable characters, but
      // these aren't encoded by encodeURIComponent, so we don't have to call them out here. Also
      // note that the colon character is not featured in the encoding map; this is because URI.js
      // gives the colons in URNs semantic meaning as the delimiters of path segements, and so it
      // should not appear unencoded in a segment itself.
      // See also the note above about RFC3986 and capitalalized hex digits.
      encode: {
        expression: /%(21|24|27|28|29|2A|2B|2C|3B|3D|40)/ig,
        map: {
          '%21': '!',
          '%24': '$',
          '%27': '\'',
          '%28': '(',
          '%29': ')',
          '%2A': '*',
          '%2B': '+',
          '%2C': ',',
          '%3B': ';',
          '%3D': '=',
          '%40': '@'
        }
      },
      // These characters are the characters called out by RFC2141 as "reserved" characters that
      // should never appear in a URN, plus the colon character (see note above).
      decode: {
        expression: /[\/\?#:]/g,
        map: {
          '/': '%2F',
          '?': '%3F',
          '#': '%23',
          ':': '%3A'
        }
      }
    }
  };
  URI.encodeQuery = function (string, escapeQuerySpace) {
    var escaped = URI.encode(string + '');
    if (escapeQuerySpace === undefined) {
      escapeQuerySpace = URI.escapeQuerySpace;
    }

    return escapeQuerySpace ? escaped.replace(/%20/g, '+') : escaped;
  };
  URI.decodeQuery = function (string, escapeQuerySpace) {
    string += '';
    if (escapeQuerySpace === undefined) {
      escapeQuerySpace = URI.escapeQuerySpace;
    }

    try {
      return URI.decode(escapeQuerySpace ? string.replace(/\+/g, '%20') : string);
    } catch (e) {
      // we're not going to mess with weird encodings,
      // give up and return the undecoded original string
      // see https://github.com/medialize/URI.js/issues/87
      // see https://github.com/medialize/URI.js/issues/92
      return string;
    }
  };
  // generate encode/decode path functions
  var _parts = { 'encode': 'encode', 'decode': 'decode' };
  var _part;
  var generateAccessor = function generateAccessor(_group, _part) {
    return function (string) {
      try {
        return URI[_part](string + '').replace(URI.characters[_group][_part].expression, function (c) {
          return URI.characters[_group][_part].map[c];
        });
      } catch (e) {
        // we're not going to mess with weird encodings,
        // give up and return the undecoded original string
        // see https://github.com/medialize/URI.js/issues/87
        // see https://github.com/medialize/URI.js/issues/92
        return string;
      }
    };
  };

  for (_part in _parts) {
    URI[_part + 'PathSegment'] = generateAccessor('pathname', _parts[_part]);
    URI[_part + 'UrnPathSegment'] = generateAccessor('urnpath', _parts[_part]);
  }

  var generateSegmentedPathFunction = function generateSegmentedPathFunction(_sep, _codingFuncName, _innerCodingFuncName) {
    return function (string) {
      // Why pass in names of functions, rather than the function objects themselves? The
      // definitions of some functions (but in particular, URI.decode) will occasionally change due
      // to URI.js having ISO8859 and Unicode modes. Passing in the name and getting it will ensure
      // that the functions we use here are "fresh".
      var actualCodingFunc;
      if (!_innerCodingFuncName) {
        actualCodingFunc = URI[_codingFuncName];
      } else {
        actualCodingFunc = function actualCodingFunc(string) {
          return URI[_codingFuncName](URI[_innerCodingFuncName](string));
        };
      }

      var segments = (string + '').split(_sep);

      for (var i = 0, length = segments.length; i < length; i++) {
        segments[i] = actualCodingFunc(segments[i]);
      }

      return segments.join(_sep);
    };
  };

  // This takes place outside the above loop because we don't want, e.g., encodeUrnPath functions.
  URI.decodePath = generateSegmentedPathFunction('/', 'decodePathSegment');
  URI.decodeUrnPath = generateSegmentedPathFunction(':', 'decodeUrnPathSegment');
  URI.recodePath = generateSegmentedPathFunction('/', 'encodePathSegment', 'decode');
  URI.recodeUrnPath = generateSegmentedPathFunction(':', 'encodeUrnPathSegment', 'decode');

  URI.encodeReserved = generateAccessor('reserved', 'encode');

  URI.parse = function (string, parts) {
    var pos;
    if (!parts) {
      parts = {
        preventInvalidHostname: URI.preventInvalidHostname
      };
    }

    string = string.replace(URI.leading_whitespace_expression, '');
    // https://infra.spec.whatwg.org/#ascii-tab-or-newline
    string = string.replace(URI.ascii_tab_whitespace, '');

    // [protocol"://"[username[":"password]"@"]hostname[":"port]"/"?][path]["?"querystring]["#"fragment]

    // extract fragment
    pos = string.indexOf('#');
    if (pos > -1) {
      // escaping?
      parts.fragment = string.substring(pos + 1) || null;
      string = string.substring(0, pos);
    }

    // extract query
    pos = string.indexOf('?');
    if (pos > -1) {
      // escaping?
      parts.query = string.substring(pos + 1) || null;
      string = string.substring(0, pos);
    }

    // slashes and backslashes have lost all meaning for the web protocols (https, http, wss, ws)
    string = string.replace(/^(https?|ftp|wss?)?:+[/\\]*/i, '$1://');
    // slashes and backslashes have lost all meaning for scheme relative URLs
    string = string.replace(/^[/\\]{2,}/i, '//');

    // extract protocol
    if (string.substring(0, 2) === '//') {
      // relative-scheme
      parts.protocol = null;
      string = string.substring(2);
      // extract "user:pass@host:port"
      string = URI.parseAuthority(string, parts);
    } else {
      pos = string.indexOf(':');
      if (pos > -1) {
        parts.protocol = string.substring(0, pos) || null;
        if (parts.protocol && !parts.protocol.match(URI.protocol_expression)) {
          // : may be within the path
          parts.protocol = undefined;
        } else if (string.substring(pos + 1, pos + 3).replace(/\\/g, '/') === '//') {
          string = string.substring(pos + 3);

          // extract "user:pass@host:port"
          string = URI.parseAuthority(string, parts);
        } else {
          string = string.substring(pos + 1);
          parts.urn = true;
        }
      }
    }

    // what's left must be the path
    parts.path = string;

    // and we're done
    return parts;
  };
  URI.parseHost = function (string, parts) {
    if (!string) {
      string = '';
    }

    // Copy chrome, IE, opera backslash-handling behavior.
    // Back slashes before the query string get converted to forward slashes
    // See: https://github.com/joyent/node/blob/386fd24f49b0e9d1a8a076592a404168faeecc34/lib/url.js#L115-L124
    // See: https://code.google.com/p/chromium/issues/detail?id=25916
    // https://github.com/medialize/URI.js/pull/233
    string = string.replace(/\\/g, '/');

    // extract host:port
    var pos = string.indexOf('/');
    var bracketPos;
    var t;

    if (pos === -1) {
      pos = string.length;
    }

    if (string.charAt(0) === '[') {
      // IPv6 host - http://tools.ietf.org/html/draft-ietf-6man-text-addr-representation-04#section-6
      // I claim most client software breaks on IPv6 anyways. To simplify things, URI only accepts
      // IPv6+port in the format [2001:db8::1]:80 (for the time being)
      bracketPos = string.indexOf(']');
      parts.hostname = string.substring(1, bracketPos) || null;
      parts.port = string.substring(bracketPos + 2, pos) || null;
      if (parts.port === '/') {
        parts.port = null;
      }
    } else {
      var firstColon = string.indexOf(':');
      var firstSlash = string.indexOf('/');
      var nextColon = string.indexOf(':', firstColon + 1);
      if (nextColon !== -1 && (firstSlash === -1 || nextColon < firstSlash)) {
        // IPv6 host contains multiple colons - but no port
        // this notation is actually not allowed by RFC 3986, but we're a liberal parser
        parts.hostname = string.substring(0, pos) || null;
        parts.port = null;
      } else {
        t = string.substring(0, pos).split(':');
        parts.hostname = t[0] || null;
        parts.port = t[1] || null;
      }
    }

    if (parts.hostname && string.substring(pos).charAt(0) !== '/') {
      pos++;
      string = '/' + string;
    }

    if (parts.preventInvalidHostname) {
      URI.ensureValidHostname(parts.hostname, parts.protocol);
    }

    if (parts.port) {
      URI.ensureValidPort(parts.port);
    }

    return string.substring(pos) || '/';
  };
  URI.parseAuthority = function (string, parts) {
    string = URI.parseUserinfo(string, parts);
    return URI.parseHost(string, parts);
  };
  URI.parseUserinfo = function (string, parts) {
    // extract username:password
    var _string = string;
    var firstBackSlash = string.indexOf('\\');
    if (firstBackSlash !== -1) {
      string = string.replace(/\\/g, '/');
    }
    var firstSlash = string.indexOf('/');
    var pos = string.lastIndexOf('@', firstSlash > -1 ? firstSlash : string.length - 1);
    var t;

    // authority@ must come before /path or \path
    if (pos > -1 && (firstSlash === -1 || pos < firstSlash)) {
      t = string.substring(0, pos).split(':');
      parts.username = t[0] ? URI.decode(t[0]) : null;
      t.shift();
      parts.password = t[0] ? URI.decode(t.join(':')) : null;
      string = _string.substring(pos + 1);
    } else {
      parts.username = null;
      parts.password = null;
    }

    return string;
  };
  URI.parseQuery = function (string, escapeQuerySpace) {
    if (!string) {
      return {};
    }

    // throw out the funky business - "?"[name"="value"&"]+
    string = string.replace(/&+/g, '&').replace(/^\?*&*|&+$/g, '');

    if (!string) {
      return {};
    }

    var items = {};
    var splits = string.split('&');
    var length = splits.length;
    var v, name, value;

    for (var i = 0; i < length; i++) {
      v = splits[i].split('=');
      name = URI.decodeQuery(v.shift(), escapeQuerySpace);
      // no "=" is null according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#collect-url-parameters
      value = v.length ? URI.decodeQuery(v.join('='), escapeQuerySpace) : null;

      if (name === '__proto__') {
        // ignore attempt at exploiting JavaScript internals
        continue;
      } else if (hasOwn.call(items, name)) {
        if (typeof items[name] === 'string' || items[name] === null) {
          items[name] = [items[name]];
        }

        items[name].push(value);
      } else {
        items[name] = value;
      }
    }

    return items;
  };

  URI.build = function (parts) {
    var t = '';
    var requireAbsolutePath = false;

    if (parts.protocol) {
      t += parts.protocol + ':';
    }

    if (!parts.urn && (t || parts.hostname)) {
      t += '//';
      requireAbsolutePath = true;
    }

    t += URI.buildAuthority(parts) || '';

    if (typeof parts.path === 'string') {
      if (parts.path.charAt(0) !== '/' && requireAbsolutePath) {
        t += '/';
      }

      t += parts.path;
    }

    if (typeof parts.query === 'string' && parts.query) {
      t += '?' + parts.query;
    }

    if (typeof parts.fragment === 'string' && parts.fragment) {
      t += '#' + parts.fragment;
    }
    return t;
  };
  URI.buildHost = function (parts) {
    var t = '';

    if (!parts.hostname) {
      return '';
    } else if (URI.ip6_expression.test(parts.hostname)) {
      t += '[' + parts.hostname + ']';
    } else {
      t += parts.hostname;
    }

    if (parts.port) {
      t += ':' + parts.port;
    }

    return t;
  };
  URI.buildAuthority = function (parts) {
    return URI.buildUserinfo(parts) + URI.buildHost(parts);
  };
  URI.buildUserinfo = function (parts) {
    var t = '';

    if (parts.username) {
      t += URI.encode(parts.username);
    }

    if (parts.password) {
      t += ':' + URI.encode(parts.password);
    }

    if (t) {
      t += '@';
    }

    return t;
  };
  URI.buildQuery = function (data, duplicateQueryParameters, escapeQuerySpace) {
    // according to http://tools.ietf.org/html/rfc3986 or http://labs.apache.org/webarch/uri/rfc/rfc3986.html
    // being »-._~!$&'()*+,;=:@/?« %HEX and alnum are allowed
    // the RFC explicitly states ?/foo being a valid use case, no mention of parameter syntax!
    // URI.js treats the query string as being application/x-www-form-urlencoded
    // see http://www.w3.org/TR/REC-html40/interact/forms.html#form-content-type

    var t = '';
    var unique, key, i, length;
    for (key in data) {
      if (key === '__proto__') {
        // ignore attempt at exploiting JavaScript internals
        continue;
      } else if (hasOwn.call(data, key)) {
        if (isArray(data[key])) {
          unique = {};
          for (i = 0, length = data[key].length; i < length; i++) {
            if (data[key][i] !== undefined && unique[data[key][i] + ''] === undefined) {
              t += '&' + URI.buildQueryParameter(key, data[key][i], escapeQuerySpace);
              if (duplicateQueryParameters !== true) {
                unique[data[key][i] + ''] = true;
              }
            }
          }
        } else if (data[key] !== undefined) {
          t += '&' + URI.buildQueryParameter(key, data[key], escapeQuerySpace);
        }
      }
    }

    return t.substring(1);
  };
  URI.buildQueryParameter = function (name, value, escapeQuerySpace) {
    // http://www.w3.org/TR/REC-html40/interact/forms.html#form-content-type -- application/x-www-form-urlencoded
    // don't append "=" for null values, according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#url-parameter-serialization
    return URI.encodeQuery(name, escapeQuerySpace) + (value !== null ? '=' + URI.encodeQuery(value, escapeQuerySpace) : '');
  };

  URI.addQuery = function (data, name, value) {
    if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
      for (var key in name) {
        if (hasOwn.call(name, key)) {
          URI.addQuery(data, key, name[key]);
        }
      }
    } else if (typeof name === 'string') {
      if (data[name] === undefined) {
        data[name] = value;
        return;
      } else if (typeof data[name] === 'string') {
        data[name] = [data[name]];
      }

      if (!isArray(value)) {
        value = [value];
      }

      data[name] = (data[name] || []).concat(value);
    } else {
      throw new TypeError('URI.addQuery() accepts an object, string as the name parameter');
    }
  };

  URI.setQuery = function (data, name, value) {
    if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
      for (var key in name) {
        if (hasOwn.call(name, key)) {
          URI.setQuery(data, key, name[key]);
        }
      }
    } else if (typeof name === 'string') {
      data[name] = value === undefined ? null : value;
    } else {
      throw new TypeError('URI.setQuery() accepts an object, string as the name parameter');
    }
  };

  URI.removeQuery = function (data, name, value) {
    var i, length, key;

    if (isArray(name)) {
      for (i = 0, length = name.length; i < length; i++) {
        data[name[i]] = undefined;
      }
    } else if (getType(name) === 'RegExp') {
      for (key in data) {
        if (name.test(key)) {
          data[key] = undefined;
        }
      }
    } else if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
      for (key in name) {
        if (hasOwn.call(name, key)) {
          URI.removeQuery(data, key, name[key]);
        }
      }
    } else if (typeof name === 'string') {
      if (value !== undefined) {
        if (getType(value) === 'RegExp') {
          if (!isArray(data[name]) && value.test(data[name])) {
            data[name] = undefined;
          } else {
            data[name] = filterArrayValues(data[name], value);
          }
        } else if (data[name] === String(value) && (!isArray(value) || value.length === 1)) {
          data[name] = undefined;
        } else if (isArray(data[name])) {
          data[name] = filterArrayValues(data[name], value);
        }
      } else {
        data[name] = undefined;
      }
    } else {
      throw new TypeError('URI.removeQuery() accepts an object, string, RegExp as the first parameter');
    }
  };
  URI.hasQuery = function (data, name, value, withinArray) {
    switch (getType(name)) {
      case 'String':
        // Nothing to do here
        break;

      case 'RegExp':
        for (var key in data) {
          if (hasOwn.call(data, key)) {
            if (name.test(key) && (value === undefined || URI.hasQuery(data, key, value))) {
              return true;
            }
          }
        }

        return false;

      case 'Object':
        for (var _key in name) {
          if (hasOwn.call(name, _key)) {
            if (!URI.hasQuery(data, _key, name[_key])) {
              return false;
            }
          }
        }

        return true;

      default:
        throw new TypeError('URI.hasQuery() accepts a string, regular expression or object as the name parameter');
    }

    switch (getType(value)) {
      case 'Undefined':
        // true if exists (but may be empty)
        return name in data; // data[name] !== undefined;

      case 'Boolean':
        // true if exists and non-empty
        var _booly = Boolean(isArray(data[name]) ? data[name].length : data[name]);
        return value === _booly;

      case 'Function':
        // allow complex comparison
        return !!value(data[name], name, data);

      case 'Array':
        if (!isArray(data[name])) {
          return false;
        }

        var op = withinArray ? arrayContains : arraysEqual;
        return op(data[name], value);

      case 'RegExp':
        if (!isArray(data[name])) {
          return Boolean(data[name] && data[name].match(value));
        }

        if (!withinArray) {
          return false;
        }

        return arrayContains(data[name], value);

      case 'Number':
        value = String(value);
      /* falls through */
      case 'String':
        if (!isArray(data[name])) {
          return data[name] === value;
        }

        if (!withinArray) {
          return false;
        }

        return arrayContains(data[name], value);

      default:
        throw new TypeError('URI.hasQuery() accepts undefined, boolean, string, number, RegExp, Function as the value parameter');
    }
  };

  URI.joinPaths = function () {
    var input = [];
    var segments = [];
    var nonEmptySegments = 0;

    for (var i = 0; i < arguments.length; i++) {
      var url = new URI(arguments[i]);
      input.push(url);
      var _segments = url.segment();
      for (var s = 0; s < _segments.length; s++) {
        if (typeof _segments[s] === 'string') {
          segments.push(_segments[s]);
        }

        if (_segments[s]) {
          nonEmptySegments++;
        }
      }
    }

    if (!segments.length || !nonEmptySegments) {
      return new URI('');
    }

    var uri = new URI('').segment(segments);

    if (input[0].path() === '' || input[0].path().slice(0, 1) === '/') {
      uri.path('/' + uri.path());
    }

    return uri.normalize();
  };

  URI.commonPath = function (one, two) {
    var length = Math.min(one.length, two.length);
    var pos;

    // find first non-matching character
    for (pos = 0; pos < length; pos++) {
      if (one.charAt(pos) !== two.charAt(pos)) {
        pos--;
        break;
      }
    }

    if (pos < 1) {
      return one.charAt(0) === two.charAt(0) && one.charAt(0) === '/' ? '/' : '';
    }

    // revert to last /
    if (one.charAt(pos) !== '/' || two.charAt(pos) !== '/') {
      pos = one.substring(0, pos).lastIndexOf('/');
    }

    return one.substring(0, pos + 1);
  };

  URI.withinString = function (string, callback, options) {
    options || (options = {});
    var _start = options.start || URI.findUri.start;
    var _end = options.end || URI.findUri.end;
    var _trim = options.trim || URI.findUri.trim;
    var _parens = options.parens || URI.findUri.parens;
    var _attributeOpen = /[a-z0-9-]=["']?$/i;

    _start.lastIndex = 0;
    while (true) {
      var match = _start.exec(string);
      if (!match) {
        break;
      }

      var start = match.index;
      if (options.ignoreHtml) {
        // attribut(e=["']?$)
        var attributeOpen = string.slice(Math.max(start - 3, 0), start);
        if (attributeOpen && _attributeOpen.test(attributeOpen)) {
          continue;
        }
      }

      var end = start + string.slice(start).search(_end);
      var slice = string.slice(start, end);
      // make sure we include well balanced parens
      var parensEnd = -1;
      while (true) {
        var parensMatch = _parens.exec(slice);
        if (!parensMatch) {
          break;
        }

        var parensMatchEnd = parensMatch.index + parensMatch[0].length;
        parensEnd = Math.max(parensEnd, parensMatchEnd);
      }

      if (parensEnd > -1) {
        slice = slice.slice(0, parensEnd) + slice.slice(parensEnd).replace(_trim, '');
      } else {
        slice = slice.replace(_trim, '');
      }

      if (slice.length <= match[0].length) {
        // the extract only contains the starting marker of a URI,
        // e.g. "www" or "http://"
        continue;
      }

      if (options.ignore && options.ignore.test(slice)) {
        continue;
      }

      end = start + slice.length;
      var result = callback(slice, start, end, string);
      if (result === undefined) {
        _start.lastIndex = end;
        continue;
      }

      result = String(result);
      string = string.slice(0, start) + result + string.slice(end);
      _start.lastIndex = start + result.length;
    }

    _start.lastIndex = 0;
    return string;
  };

  URI.ensureValidHostname = function (v, protocol) {
    // Theoretically URIs allow percent-encoding in Hostnames (according to RFC 3986)
    // they are not part of DNS and therefore ignored by URI.js

    var hasHostname = !!v; // not null and not an empty string
    var hasProtocol = !!protocol;
    var rejectEmptyHostname = false;

    if (hasProtocol) {
      rejectEmptyHostname = arrayContains(URI.hostProtocols, protocol);
    }

    if (rejectEmptyHostname && !hasHostname) {
      throw new TypeError('Hostname cannot be empty, if protocol is ' + protocol);
    } else if (v && v.match(URI.invalid_hostname_characters)) {
      // test punycode
      if (!punycode) {
        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-:_] and Punycode.js is not available');
      }
      if (punycode.toASCII(v).match(URI.invalid_hostname_characters)) {
        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-:_]');
      }
    }
  };

  URI.ensureValidPort = function (v) {
    if (!v) {
      return;
    }

    var port = Number(v);
    if (isInteger(port) && port > 0 && port < 65536) {
      return;
    }

    throw new TypeError('Port "' + v + '" is not a valid port');
  };

  // noConflict
  URI.noConflict = function (removeAll) {
    if (removeAll) {
      var unconflicted = {
        URI: this.noConflict()
      };

      if (root.URITemplate && typeof root.URITemplate.noConflict === 'function') {
        unconflicted.URITemplate = root.URITemplate.noConflict();
      }

      if (root.IPv6 && typeof root.IPv6.noConflict === 'function') {
        unconflicted.IPv6 = root.IPv6.noConflict();
      }

      if (root.SecondLevelDomains && typeof root.SecondLevelDomains.noConflict === 'function') {
        unconflicted.SecondLevelDomains = root.SecondLevelDomains.noConflict();
      }

      return unconflicted;
    } else if (root.URI === this) {
      root.URI = _URI;
    }

    return this;
  };

  p.build = function (deferBuild) {
    if (deferBuild === true) {
      this._deferred_build = true;
    } else if (deferBuild === undefined || this._deferred_build) {
      this._string = URI.build(this._parts);
      this._deferred_build = false;
    }

    return this;
  };

  p.clone = function () {
    return new URI(this);
  };

  p.valueOf = p.toString = function () {
    return this.build(false)._string;
  };

  function generateSimpleAccessor(_part) {
    return function (v, build) {
      if (v === undefined) {
        return this._parts[_part] || '';
      } else {
        this._parts[_part] = v || null;
        this.build(!build);
        return this;
      }
    };
  }

  function generatePrefixAccessor(_part, _key) {
    return function (v, build) {
      if (v === undefined) {
        return this._parts[_part] || '';
      } else {
        if (v !== null) {
          v = v + '';
          if (v.charAt(0) === _key) {
            v = v.substring(1);
          }
        }

        this._parts[_part] = v;
        this.build(!build);
        return this;
      }
    };
  }

  p.protocol = generateSimpleAccessor('protocol');
  p.username = generateSimpleAccessor('username');
  p.password = generateSimpleAccessor('password');
  p.hostname = generateSimpleAccessor('hostname');
  p.port = generateSimpleAccessor('port');
  p.query = generatePrefixAccessor('query', '?');
  p.fragment = generatePrefixAccessor('fragment', '#');

  p.search = function (v, build) {
    var t = this.query(v, build);
    return typeof t === 'string' && t.length ? '?' + t : t;
  };
  p.hash = function (v, build) {
    var t = this.fragment(v, build);
    return typeof t === 'string' && t.length ? '#' + t : t;
  };

  p.pathname = function (v, build) {
    if (v === undefined || v === true) {
      var res = this._parts.path || (this._parts.hostname ? '/' : '');
      return v ? (this._parts.urn ? URI.decodeUrnPath : URI.decodePath)(res) : res;
    } else {
      if (this._parts.urn) {
        this._parts.path = v ? URI.recodeUrnPath(v) : '';
      } else {
        this._parts.path = v ? URI.recodePath(v) : '/';
      }
      this.build(!build);
      return this;
    }
  };
  p.path = p.pathname;
  p.href = function (href, build) {
    var key;

    if (href === undefined) {
      return this.toString();
    }

    this._string = '';
    this._parts = URI._parts();

    var _URI = href instanceof URI;
    var _object = (typeof href === 'undefined' ? 'undefined' : _typeof(href)) === 'object' && (href.hostname || href.path || href.pathname);
    if (href.nodeName) {
      var attribute = URI.getDomAttribute(href);
      href = href[attribute] || '';
      _object = false;
    }

    // window.location is reported to be an object, but it's not the sort
    // of object we're looking for:
    // * location.protocol ends with a colon
    // * location.query != object.search
    // * location.hash != object.fragment
    // simply serializing the unknown object should do the trick
    // (for location, not for everything...)
    if (!_URI && _object && href.pathname !== undefined) {
      href = href.toString();
    }

    if (typeof href === 'string' || href instanceof String) {
      this._parts = URI.parse(String(href), this._parts);
    } else if (_URI || _object) {
      var src = _URI ? href._parts : href;
      for (key in src) {
        if (key === 'query') {
          continue;
        }
        if (hasOwn.call(this._parts, key)) {
          this._parts[key] = src[key];
        }
      }
      if (src.query) {
        this.query(src.query, false);
      }
    } else {
      throw new TypeError('invalid input');
    }

    this.build(!build);
    return this;
  };

  // identification accessors
  p.is = function (what) {
    var ip = false;
    var ip4 = false;
    var ip6 = false;
    var name = false;
    var sld = false;
    var idn = false;
    var punycode = false;
    var relative = !this._parts.urn;

    if (this._parts.hostname) {
      relative = false;
      ip4 = URI.ip4_expression.test(this._parts.hostname);
      ip6 = URI.ip6_expression.test(this._parts.hostname);
      ip = ip4 || ip6;
      name = !ip;
      sld = name && SLD && SLD.has(this._parts.hostname);
      idn = name && URI.idn_expression.test(this._parts.hostname);
      punycode = name && URI.punycode_expression.test(this._parts.hostname);
    }

    switch (what.toLowerCase()) {
      case 'relative':
        return relative;

      case 'absolute':
        return !relative;

      // hostname identification
      case 'domain':
      case 'name':
        return name;

      case 'sld':
        return sld;

      case 'ip':
        return ip;

      case 'ip4':
      case 'ipv4':
      case 'inet4':
        return ip4;

      case 'ip6':
      case 'ipv6':
      case 'inet6':
        return ip6;

      case 'idn':
        return idn;

      case 'url':
        return !this._parts.urn;

      case 'urn':
        return !!this._parts.urn;

      case 'punycode':
        return punycode;
    }

    return null;
  };

  // component specific input validation
  var _protocol = p.protocol;
  var _port = p.port;
  var _hostname = p.hostname;

  p.protocol = function (v, build) {
    if (v) {
      // accept trailing ://
      v = v.replace(/:(\/\/)?$/, '');

      if (!v.match(URI.protocol_expression)) {
        throw new TypeError('Protocol "' + v + '" contains characters other than [A-Z0-9.+-] or doesn\'t start with [A-Z]');
      }
    }

    return _protocol.call(this, v, build);
  };
  p.scheme = p.protocol;
  p.port = function (v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v !== undefined) {
      if (v === 0) {
        v = null;
      }

      if (v) {
        v += '';
        if (v.charAt(0) === ':') {
          v = v.substring(1);
        }

        URI.ensureValidPort(v);
      }
    }
    return _port.call(this, v, build);
  };
  p.hostname = function (v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v !== undefined) {
      var x = { preventInvalidHostname: this._parts.preventInvalidHostname };
      var res = URI.parseHost(v, x);
      if (res !== '/') {
        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
      }

      v = x.hostname;
      if (this._parts.preventInvalidHostname) {
        URI.ensureValidHostname(v, this._parts.protocol);
      }
    }

    return _hostname.call(this, v, build);
  };

  // compound accessors
  p.origin = function (v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined) {
      var protocol = this.protocol();
      var authority = this.authority();
      if (!authority) {
        return '';
      }

      return (protocol ? protocol + '://' : '') + this.authority();
    } else {
      var origin = URI(v);
      this.protocol(origin.protocol()).authority(origin.authority()).build(!build);
      return this;
    }
  };
  p.host = function (v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined) {
      return this._parts.hostname ? URI.buildHost(this._parts) : '';
    } else {
      var res = URI.parseHost(v, this._parts);
      if (res !== '/') {
        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
      }

      this.build(!build);
      return this;
    }
  };
  p.authority = function (v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined) {
      return this._parts.hostname ? URI.buildAuthority(this._parts) : '';
    } else {
      var res = URI.parseAuthority(v, this._parts);
      if (res !== '/') {
        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
      }

      this.build(!build);
      return this;
    }
  };
  p.userinfo = function (v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined) {
      var t = URI.buildUserinfo(this._parts);
      return t ? t.substring(0, t.length - 1) : t;
    } else {
      if (v[v.length - 1] !== '@') {
        v += '@';
      }

      URI.parseUserinfo(v, this._parts);
      this.build(!build);
      return this;
    }
  };
  p.resource = function (v, build) {
    var parts;

    if (v === undefined) {
      return this.path() + this.search() + this.hash();
    }

    parts = URI.parse(v);
    this._parts.path = parts.path;
    this._parts.query = parts.query;
    this._parts.fragment = parts.fragment;
    this.build(!build);
    return this;
  };

  // fraction accessors
  p.subdomain = function (v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    // convenience, return "www" from "www.example.org"
    if (v === undefined) {
      if (!this._parts.hostname || this.is('IP')) {
        return '';
      }

      // grab domain and add another segment
      var end = this._parts.hostname.length - this.domain().length - 1;
      return this._parts.hostname.substring(0, end) || '';
    } else {
      var e = this._parts.hostname.length - this.domain().length;
      var sub = this._parts.hostname.substring(0, e);
      var replace = new RegExp('^' + escapeRegEx(sub));

      if (v && v.charAt(v.length - 1) !== '.') {
        v += '.';
      }

      if (v.indexOf(':') !== -1) {
        throw new TypeError('Domains cannot contain colons');
      }

      if (v) {
        URI.ensureValidHostname(v, this._parts.protocol);
      }

      this._parts.hostname = this._parts.hostname.replace(replace, v);
      this.build(!build);
      return this;
    }
  };
  p.domain = function (v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (typeof v === 'boolean') {
      build = v;
      v = undefined;
    }

    // convenience, return "example.org" from "www.example.org"
    if (v === undefined) {
      if (!this._parts.hostname || this.is('IP')) {
        return '';
      }

      // if hostname consists of 1 or 2 segments, it must be the domain
      var t = this._parts.hostname.match(/\./g);
      if (t && t.length < 2) {
        return this._parts.hostname;
      }

      // grab tld and add another segment
      var end = this._parts.hostname.length - this.tld(build).length - 1;
      end = this._parts.hostname.lastIndexOf('.', end - 1) + 1;
      return this._parts.hostname.substring(end) || '';
    } else {
      if (!v) {
        throw new TypeError('cannot set domain empty');
      }

      if (v.indexOf(':') !== -1) {
        throw new TypeError('Domains cannot contain colons');
      }

      URI.ensureValidHostname(v, this._parts.protocol);

      if (!this._parts.hostname || this.is('IP')) {
        this._parts.hostname = v;
      } else {
        var replace = new RegExp(escapeRegEx(this.domain()) + '$');
        this._parts.hostname = this._parts.hostname.replace(replace, v);
      }

      this.build(!build);
      return this;
    }
  };
  p.tld = function (v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (typeof v === 'boolean') {
      build = v;
      v = undefined;
    }

    // return "org" from "www.example.org"
    if (v === undefined) {
      if (!this._parts.hostname || this.is('IP')) {
        return '';
      }

      var pos = this._parts.hostname.lastIndexOf('.');
      var tld = this._parts.hostname.substring(pos + 1);

      if (build !== true && SLD && SLD.list[tld.toLowerCase()]) {
        return SLD.get(this._parts.hostname) || tld;
      }

      return tld;
    } else {
      var replace;

      if (!v) {
        throw new TypeError('cannot set TLD empty');
      } else if (v.match(/[^a-zA-Z0-9-]/)) {
        if (SLD && SLD.is(v)) {
          replace = new RegExp(escapeRegEx(this.tld()) + '$');
          this._parts.hostname = this._parts.hostname.replace(replace, v);
        } else {
          throw new TypeError('TLD "' + v + '" contains characters other than [A-Z0-9]');
        }
      } else if (!this._parts.hostname || this.is('IP')) {
        throw new ReferenceError('cannot set TLD on non-domain host');
      } else {
        replace = new RegExp(escapeRegEx(this.tld()) + '$');
        this._parts.hostname = this._parts.hostname.replace(replace, v);
      }

      this.build(!build);
      return this;
    }
  };
  p.directory = function (v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined || v === true) {
      if (!this._parts.path && !this._parts.hostname) {
        return '';
      }

      if (this._parts.path === '/') {
        return '/';
      }

      var end = this._parts.path.length - this.filename().length - 1;
      var res = this._parts.path.substring(0, end) || (this._parts.hostname ? '/' : '');

      return v ? URI.decodePath(res) : res;
    } else {
      var e = this._parts.path.length - this.filename().length;
      var directory = this._parts.path.substring(0, e);
      var replace = new RegExp('^' + escapeRegEx(directory));

      // fully qualifier directories begin with a slash
      if (!this.is('relative')) {
        if (!v) {
          v = '/';
        }

        if (v.charAt(0) !== '/') {
          v = '/' + v;
        }
      }

      // directories always end with a slash
      if (v && v.charAt(v.length - 1) !== '/') {
        v += '/';
      }

      v = URI.recodePath(v);
      this._parts.path = this._parts.path.replace(replace, v);
      this.build(!build);
      return this;
    }
  };
  p.filename = function (v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (typeof v !== 'string') {
      if (!this._parts.path || this._parts.path === '/') {
        return '';
      }

      var pos = this._parts.path.lastIndexOf('/');
      var res = this._parts.path.substring(pos + 1);

      return v ? URI.decodePathSegment(res) : res;
    } else {
      var mutatedDirectory = false;

      if (v.charAt(0) === '/') {
        v = v.substring(1);
      }

      if (v.match(/\.?\//)) {
        mutatedDirectory = true;
      }

      var replace = new RegExp(escapeRegEx(this.filename()) + '$');
      v = URI.recodePath(v);
      this._parts.path = this._parts.path.replace(replace, v);

      if (mutatedDirectory) {
        this.normalizePath(build);
      } else {
        this.build(!build);
      }

      return this;
    }
  };
  p.suffix = function (v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined || v === true) {
      if (!this._parts.path || this._parts.path === '/') {
        return '';
      }

      var filename = this.filename();
      var pos = filename.lastIndexOf('.');
      var s, res;

      if (pos === -1) {
        return '';
      }

      // suffix may only contain alnum characters (yup, I made this up.)
      s = filename.substring(pos + 1);
      res = /^[a-z0-9%]+$/i.test(s) ? s : '';
      return v ? URI.decodePathSegment(res) : res;
    } else {
      if (v.charAt(0) === '.') {
        v = v.substring(1);
      }

      var suffix = this.suffix();
      var replace;

      if (!suffix) {
        if (!v) {
          return this;
        }

        this._parts.path += '.' + URI.recodePath(v);
      } else if (!v) {
        replace = new RegExp(escapeRegEx('.' + suffix) + '$');
      } else {
        replace = new RegExp(escapeRegEx(suffix) + '$');
      }

      if (replace) {
        v = URI.recodePath(v);
        this._parts.path = this._parts.path.replace(replace, v);
      }

      this.build(!build);
      return this;
    }
  };
  p.segment = function (segment, v, build) {
    var separator = this._parts.urn ? ':' : '/';
    var path = this.path();
    var absolute = path.substring(0, 1) === '/';
    var segments = path.split(separator);

    if (segment !== undefined && typeof segment !== 'number') {
      build = v;
      v = segment;
      segment = undefined;
    }

    if (segment !== undefined && typeof segment !== 'number') {
      throw new Error('Bad segment "' + segment + '", must be 0-based integer');
    }

    if (absolute) {
      segments.shift();
    }

    if (segment < 0) {
      // allow negative indexes to address from the end
      segment = Math.max(segments.length + segment, 0);
    }

    if (v === undefined) {
      /*jshint laxbreak: true */
      return segment === undefined ? segments : segments[segment];
      /*jshint laxbreak: false */
    } else if (segment === null || segments[segment] === undefined) {
      if (isArray(v)) {
        segments = [];
        // collapse empty elements within array
        for (var i = 0, l = v.length; i < l; i++) {
          if (!v[i].length && (!segments.length || !segments[segments.length - 1].length)) {
            continue;
          }

          if (segments.length && !segments[segments.length - 1].length) {
            segments.pop();
          }

          segments.push(trimSlashes(v[i]));
        }
      } else if (v || typeof v === 'string') {
        v = trimSlashes(v);
        if (segments[segments.length - 1] === '') {
          // empty trailing elements have to be overwritten
          // to prevent results such as /foo//bar
          segments[segments.length - 1] = v;
        } else {
          segments.push(v);
        }
      }
    } else {
      if (v) {
        segments[segment] = trimSlashes(v);
      } else {
        segments.splice(segment, 1);
      }
    }

    if (absolute) {
      segments.unshift('');
    }

    return this.path(segments.join(separator), build);
  };
  p.segmentCoded = function (segment, v, build) {
    var segments, i, l;

    if (typeof segment !== 'number') {
      build = v;
      v = segment;
      segment = undefined;
    }

    if (v === undefined) {
      segments = this.segment(segment, v, build);
      if (!isArray(segments)) {
        segments = segments !== undefined ? URI.decode(segments) : undefined;
      } else {
        for (i = 0, l = segments.length; i < l; i++) {
          segments[i] = URI.decode(segments[i]);
        }
      }

      return segments;
    }

    if (!isArray(v)) {
      v = typeof v === 'string' || v instanceof String ? URI.encode(v) : v;
    } else {
      for (i = 0, l = v.length; i < l; i++) {
        v[i] = URI.encode(v[i]);
      }
    }

    return this.segment(segment, v, build);
  };

  // mutating query string
  var q = p.query;
  p.query = function (v, build) {
    if (v === true) {
      return URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
    } else if (typeof v === 'function') {
      var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
      var result = v.call(this, data);
      this._parts.query = URI.buildQuery(result || data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
      this.build(!build);
      return this;
    } else if (v !== undefined && typeof v !== 'string') {
      this._parts.query = URI.buildQuery(v, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
      this.build(!build);
      return this;
    } else {
      return q.call(this, v, build);
    }
  };
  p.setQuery = function (name, value, build) {
    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);

    if (typeof name === 'string' || name instanceof String) {
      data[name] = value !== undefined ? value : null;
    } else if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
      for (var key in name) {
        if (hasOwn.call(name, key)) {
          data[key] = name[key];
        }
      }
    } else {
      throw new TypeError('URI.addQuery() accepts an object, string as the name parameter');
    }

    this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
    if (typeof name !== 'string') {
      build = value;
    }

    this.build(!build);
    return this;
  };
  p.addQuery = function (name, value, build) {
    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
    URI.addQuery(data, name, value === undefined ? null : value);
    this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
    if (typeof name !== 'string') {
      build = value;
    }

    this.build(!build);
    return this;
  };
  p.removeQuery = function (name, value, build) {
    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
    URI.removeQuery(data, name, value);
    this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
    if (typeof name !== 'string') {
      build = value;
    }

    this.build(!build);
    return this;
  };
  p.hasQuery = function (name, value, withinArray) {
    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
    return URI.hasQuery(data, name, value, withinArray);
  };
  p.setSearch = p.setQuery;
  p.addSearch = p.addQuery;
  p.removeSearch = p.removeQuery;
  p.hasSearch = p.hasQuery;

  // sanitizing URLs
  p.normalize = function () {
    if (this._parts.urn) {
      return this.normalizeProtocol(false).normalizePath(false).normalizeQuery(false).normalizeFragment(false).build();
    }

    return this.normalizeProtocol(false).normalizeHostname(false).normalizePort(false).normalizePath(false).normalizeQuery(false).normalizeFragment(false).build();
  };
  p.normalizeProtocol = function (build) {
    if (typeof this._parts.protocol === 'string') {
      this._parts.protocol = this._parts.protocol.toLowerCase();
      this.build(!build);
    }

    return this;
  };
  p.normalizeHostname = function (build) {
    if (this._parts.hostname) {
      if (this.is('IDN') && punycode) {
        this._parts.hostname = punycode.toASCII(this._parts.hostname);
      } else if (this.is('IPv6') && IPv6) {
        this._parts.hostname = IPv6.best(this._parts.hostname);
      }

      this._parts.hostname = this._parts.hostname.toLowerCase();
      this.build(!build);
    }

    return this;
  };
  p.normalizePort = function (build) {
    // remove port of it's the protocol's default
    if (typeof this._parts.protocol === 'string' && this._parts.port === URI.defaultPorts[this._parts.protocol]) {
      this._parts.port = null;
      this.build(!build);
    }

    return this;
  };
  p.normalizePath = function (build) {
    var _path = this._parts.path;
    if (!_path) {
      return this;
    }

    if (this._parts.urn) {
      this._parts.path = URI.recodeUrnPath(this._parts.path);
      this.build(!build);
      return this;
    }

    if (this._parts.path === '/') {
      return this;
    }

    _path = URI.recodePath(_path);

    var _was_relative;
    var _leadingParents = '';
    var _parent, _pos;

    // handle relative paths
    if (_path.charAt(0) !== '/') {
      _was_relative = true;
      _path = '/' + _path;
    }

    // handle relative files (as opposed to directories)
    if (_path.slice(-3) === '/..' || _path.slice(-2) === '/.') {
      _path += '/';
    }

    // resolve simples
    _path = _path.replace(/(\/(\.\/)+)|(\/\.$)/g, '/').replace(/\/{2,}/g, '/');

    // remember leading parents
    if (_was_relative) {
      _leadingParents = _path.substring(1).match(/^(\.\.\/)+/) || '';
      if (_leadingParents) {
        _leadingParents = _leadingParents[0];
      }
    }

    // resolve parents
    while (true) {
      _parent = _path.search(/\/\.\.(\/|$)/);
      if (_parent === -1) {
        // no more ../ to resolve
        break;
      } else if (_parent === 0) {
        // top level cannot be relative, skip it
        _path = _path.substring(3);
        continue;
      }

      _pos = _path.substring(0, _parent).lastIndexOf('/');
      if (_pos === -1) {
        _pos = _parent;
      }
      _path = _path.substring(0, _pos) + _path.substring(_parent + 3);
    }

    // revert to relative
    if (_was_relative && this.is('relative')) {
      _path = _leadingParents + _path.substring(1);
    }

    this._parts.path = _path;
    this.build(!build);
    return this;
  };
  p.normalizePathname = p.normalizePath;
  p.normalizeQuery = function (build) {
    if (typeof this._parts.query === 'string') {
      if (!this._parts.query.length) {
        this._parts.query = null;
      } else {
        this.query(URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace));
      }

      this.build(!build);
    }

    return this;
  };
  p.normalizeFragment = function (build) {
    if (!this._parts.fragment) {
      this._parts.fragment = null;
      this.build(!build);
    }

    return this;
  };
  p.normalizeSearch = p.normalizeQuery;
  p.normalizeHash = p.normalizeFragment;

  p.iso8859 = function () {
    // expect unicode input, iso8859 output
    var e = URI.encode;
    var d = URI.decode;

    URI.encode = escape;
    URI.decode = decodeURIComponent;
    try {
      this.normalize();
    } finally {
      URI.encode = e;
      URI.decode = d;
    }
    return this;
  };

  p.unicode = function () {
    // expect iso8859 input, unicode output
    var e = URI.encode;
    var d = URI.decode;

    URI.encode = strictEncodeURIComponent;
    URI.decode = unescape;
    try {
      this.normalize();
    } finally {
      URI.encode = e;
      URI.decode = d;
    }
    return this;
  };

  p.readable = function () {
    var uri = this.clone();
    // removing username, password, because they shouldn't be displayed according to RFC 3986
    uri.username('').password('').normalize();
    var t = '';
    if (uri._parts.protocol) {
      t += uri._parts.protocol + '://';
    }

    if (uri._parts.hostname) {
      if (uri.is('punycode') && punycode) {
        t += punycode.toUnicode(uri._parts.hostname);
        if (uri._parts.port) {
          t += ':' + uri._parts.port;
        }
      } else {
        t += uri.host();
      }
    }

    if (uri._parts.hostname && uri._parts.path && uri._parts.path.charAt(0) !== '/') {
      t += '/';
    }

    t += uri.path(true);
    if (uri._parts.query) {
      var q = '';
      for (var i = 0, qp = uri._parts.query.split('&'), l = qp.length; i < l; i++) {
        var kv = (qp[i] || '').split('=');
        q += '&' + URI.decodeQuery(kv[0], this._parts.escapeQuerySpace).replace(/&/g, '%26');

        if (kv[1] !== undefined) {
          q += '=' + URI.decodeQuery(kv[1], this._parts.escapeQuerySpace).replace(/&/g, '%26');
        }
      }
      t += '?' + q.substring(1);
    }

    t += URI.decodeQuery(uri.hash(), true);
    return t;
  };

  // resolving relative and absolute URLs
  p.absoluteTo = function (base) {
    var resolved = this.clone();
    var properties = ['protocol', 'username', 'password', 'hostname', 'port'];
    var basedir, i, p;

    if (this._parts.urn) {
      throw new Error('URNs do not have any generally defined hierarchical components');
    }

    if (!(base instanceof URI)) {
      base = new URI(base);
    }

    if (resolved._parts.protocol) {
      // Directly returns even if this._parts.hostname is empty.
      return resolved;
    } else {
      resolved._parts.protocol = base._parts.protocol;
    }

    if (this._parts.hostname) {
      return resolved;
    }

    for (i = 0; p = properties[i]; i++) {
      resolved._parts[p] = base._parts[p];
    }

    if (!resolved._parts.path) {
      resolved._parts.path = base._parts.path;
      if (!resolved._parts.query) {
        resolved._parts.query = base._parts.query;
      }
    } else {
      if (resolved._parts.path.substring(-2) === '..') {
        resolved._parts.path += '/';
      }

      if (resolved.path().charAt(0) !== '/') {
        basedir = base.directory();
        basedir = basedir ? basedir : base.path().indexOf('/') === 0 ? '/' : '';
        resolved._parts.path = (basedir ? basedir + '/' : '') + resolved._parts.path;
        resolved.normalizePath();
      }
    }

    resolved.build();
    return resolved;
  };
  p.relativeTo = function (base) {
    var relative = this.clone().normalize();
    var relativeParts, baseParts, common, relativePath, basePath;

    if (relative._parts.urn) {
      throw new Error('URNs do not have any generally defined hierarchical components');
    }

    base = new URI(base).normalize();
    relativeParts = relative._parts;
    baseParts = base._parts;
    relativePath = relative.path();
    basePath = base.path();

    if (relativePath.charAt(0) !== '/') {
      throw new Error('URI is already relative');
    }

    if (basePath.charAt(0) !== '/') {
      throw new Error('Cannot calculate a URI relative to another relative URI');
    }

    if (relativeParts.protocol === baseParts.protocol) {
      relativeParts.protocol = null;
    }

    if (relativeParts.username !== baseParts.username || relativeParts.password !== baseParts.password) {
      return relative.build();
    }

    if (relativeParts.protocol !== null || relativeParts.username !== null || relativeParts.password !== null) {
      return relative.build();
    }

    if (relativeParts.hostname === baseParts.hostname && relativeParts.port === baseParts.port) {
      relativeParts.hostname = null;
      relativeParts.port = null;
    } else {
      return relative.build();
    }

    if (relativePath === basePath) {
      relativeParts.path = '';
      return relative.build();
    }

    // determine common sub path
    common = URI.commonPath(relativePath, basePath);

    // If the paths have nothing in common, return a relative URL with the absolute path.
    if (!common) {
      return relative.build();
    }

    var parents = baseParts.path.substring(common.length).replace(/[^\/]*$/, '').replace(/.*?\//g, '../');

    relativeParts.path = parents + relativeParts.path.substring(common.length) || './';

    return relative.build();
  };

  // comparing URIs
  p.equals = function (uri) {
    var one = this.clone();
    var two = new URI(uri);
    var one_map = {};
    var two_map = {};
    var checked = {};
    var one_query, two_query, key;

    one.normalize();
    two.normalize();

    // exact match
    if (one.toString() === two.toString()) {
      return true;
    }

    // extract query string
    one_query = one.query();
    two_query = two.query();
    one.query('');
    two.query('');

    // definitely not equal if not even non-query parts match
    if (one.toString() !== two.toString()) {
      return false;
    }

    // query parameters have the same length, even if they're permuted
    if (one_query.length !== two_query.length) {
      return false;
    }

    one_map = URI.parseQuery(one_query, this._parts.escapeQuerySpace);
    two_map = URI.parseQuery(two_query, this._parts.escapeQuerySpace);

    for (key in one_map) {
      if (hasOwn.call(one_map, key)) {
        if (!isArray(one_map[key])) {
          if (one_map[key] !== two_map[key]) {
            return false;
          }
        } else if (!arraysEqual(one_map[key], two_map[key])) {
          return false;
        }

        checked[key] = true;
      }
    }

    for (key in two_map) {
      if (hasOwn.call(two_map, key)) {
        if (!checked[key]) {
          // two contains a parameter not present in one
          return false;
        }
      }
    }

    return true;
  };

  // state
  p.preventInvalidHostname = function (v) {
    this._parts.preventInvalidHostname = !!v;
    return this;
  };

  p.duplicateQueryParameters = function (v) {
    this._parts.duplicateQueryParameters = !!v;
    return this;
  };

  p.escapeQuerySpace = function (v) {
    this._parts.escapeQuerySpace = !!v;
    return this;
  };

  return URI;
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58)(module)))

/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 59 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 60 */
/***/ (function(module, exports) {

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 61 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(17);
var toLength = __webpack_require__(7);
var toAbsoluteIndex = __webpack_require__(37);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 63 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(22);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(23);
var defined = __webpack_require__(26);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(5);
var cof = __webpack_require__(22);
var MATCH = __webpack_require__(6)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(6)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(48);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(133);
var redefine = __webpack_require__(13);
var hide = __webpack_require__(12);
var fails = __webpack_require__(4);
var defined = __webpack_require__(26);
var wks = __webpack_require__(6);
var regexpExec = __webpack_require__(100);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(2);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(13);
var redefineAll = __webpack_require__(43);
var meta = __webpack_require__(32);
var forOf = __webpack_require__(42);
var anInstance = __webpack_require__(41);
var isObject = __webpack_require__(5);
var fails = __webpack_require__(4);
var $iterDetect = __webpack_require__(67);
var setToStringTag = __webpack_require__(47);
var inheritIfRequired = __webpack_require__(86);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var hide = __webpack_require__(12);
var uid = __webpack_require__(35);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(31) || !__webpack_require__(4)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(2)[K];
});


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(11);
var ctx = __webpack_require__(21);
var forOf = __webpack_require__(42);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// 

var getParents = exports.getParents = function getParents(element) {
  var parents = [];
  while (element) {
    parents.push(element);
    element = element.parentNode;
  }
  return parents;
};

var getParentScrollableElement = exports.getParentScrollableElement = function getParentScrollableElement(element) {
  if (element === null) {
    return null;
  }

  if (element.scrollHeight > element.clientHeight && window.getComputedStyle(element).overflowX !== 'visible') {
    return element;
  }

  return getParentScrollableElement(element.parentNode);
};

var dispatchEvent = exports.dispatchEvent = function dispatchEvent(element, eventName, detail) {
  var canBubble = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var cancelable = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

  if (!element) {
    throw new Error('Element is not defined');
  }
  var event = document.createEvent('CustomEvent');
  event.initCustomEvent(eventName, canBubble, cancelable, detail);
  element.dispatchEvent(event);
  return event;
};

/**
 * Map of tags which have predefined values with regard to whitespace.
 */
var predefinedTagsValues = {
  IMG: ' ',
  BR: '\n'
};

var tagsToIgnore = {
  SCRIPT: 1,
  STYLE: 1,
  HEAD: 1,
  IFRAME: 1,
  OBJECT: 1
};

var getTextContentOfPart = function getTextContentOfPart(node, buf, normalizeWhitespace) {
  if (node.nodeName in tagsToIgnore) {
    // ignore certain tags
  } else if (node.nodeType === 3) {
    if (normalizeWhitespace) {
      buf.push(String(node.nodeValue).replace(/(\r\n|\r|\n)/g, ''));
    } else {
      buf.push(node.nodeValue);
    }
  } else if (node.nodeName in predefinedTagsValues) {
    buf.push(predefinedTagsValues[node.nodeName]);
  } else {
    var child = node.firstChild;
    while (child) {
      getTextContentOfPart(child, buf, normalizeWhitespace);
      child = child.nextSibling;
    }
  }
};

var textContent = exports.textContent = function textContent(element, optValue) {
  var text = element.textContent != null ? 'textContent' : 'innerText';

  if (typeof optValue !== 'undefined') {
    element[text] = optValue;
  }

  var textContent = element[text];
  var buf = [];
  getTextContentOfPart(element, buf, true);
  textContent = buf.join('');

  // Strip &shy; entities. goog.format.insertWordBreaks inserts them in Opera.
  textContent = textContent.replace(/ \xAD /g, ' ').replace(/\xAD/g, '');
  // Strip &#8203; entities. goog.format.insertWordBreaks inserts them in IE8.
  textContent = textContent.replace(/\u200B/g, '');

  // Skip this replacement on old browsers with working innerText, which
  // automatically turns &nbsp; into ' ' and / +/ into ' ' when reading
  // innerText.
  if (!element.textContent != null) {
    textContent = textContent.replace(/ +/g, ' ');
  }
  if (textContent !== ' ') {
    textContent = textContent.replace(/^\s*/, '');
  }

  return textContent;
};

var textFieldTypes = ['date', 'datetime', 'datetime-local', 'email', 'month', 'number', 'password', 'search', 'tel', 'text', 'time', 'url', 'week'];

// @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/setSelectionRange
var selectableFieldTypes = ['password', 'search', 'tel', 'text', 'url'];

var isTextField = exports.isTextField = function isTextField(element) {
  if (!element) {
    return false;
  }
  var tagName = element.tagName.toLowerCase();
  return tagName === 'textarea' || tagName === 'input' && textFieldTypes.includes(element.getAttribute('type'));
};

var isSelectableField = exports.isSelectableField = function isSelectableField(element) {
  return isTextField(element) && selectableFieldTypes.includes(element.getAttribute('type'));
};

var isVisible = exports.isVisible = function isVisible(element) {
  return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
};

var isFocusable = exports.isFocusable = function isFocusable(element) {
  var tabIndexSelector = ':not([tabindex="-1"])';
  var notDisabledSelector = ':not([disabled])';
  var focusableSelector = ['button', 'href', 'input', 'select', 'textarea', '[tabindex]'].map(function (selector) {
    return '' + selector + tabIndexSelector + notDisabledSelector;
  }).join(',');

  return isVisible(element) && element.matches(focusableSelector);
};

var getFocusAnchor = exports.getFocusAnchor = function getFocusAnchor() {
  var activeElement = document.activeElement;
  var textField = isTextField(activeElement);
  var startPosition = -1;
  var endPosition = -1;
  if (textField) {
    try {
      startPosition = activeElement.selectionStart;
    } catch (e) {
      // na ios dochází k chybě na type date dateinput time a nevím kde dále
      // silent
    }
  }

  return {
    id: activeElement ? activeElement.getAttribute('id') : null,
    textField: textField,
    startPosition: startPosition,
    // zatím -1
    endPosition: endPosition
  };
};

var setFocusAnchor = exports.setFocusAnchor = function setFocusAnchor(focusAnchor) {
  if (!focusAnchor) {
    return;
  }

  var id = focusAnchor.id,
      startPosition = focusAnchor.startPosition,
      endPosition = focusAnchor.endPosition,
      textField = focusAnchor.textField;


  if (id) {
    var newElement = document.getElementById(id);
    if (newElement) {
      if (isFocusable(newElement) && newElement.focus) {
        newElement.focus();
        if (isSelectableField(newElement) && startPosition > -1) {
          newElement.setSelectionRange(startPosition, endPosition === -1 ? startPosition : endPosition);
        }
      }
    }
  }
};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// 
exports.default = function (element, classNames) {
  var classList = element.classList;

  Object.keys(classNames).forEach(function (className) {
    var valid = classNames[className];
    if (valid) {
      classList.add(className);
    } else {
      classList.remove(className);
    }
  });
};

/***/ }),
/* 78 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(5);
var document = __webpack_require__(2).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var core = __webpack_require__(20);
var LIBRARY = __webpack_require__(31);
var wksExt = __webpack_require__(115);
var defineProperty = __webpack_require__(9).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(52)('keys');
var uid = __webpack_require__(35);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 82 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(2).document;
module.exports = document && document.documentElement;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(5);
var anObject = __webpack_require__(1);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(21)(Function.call, __webpack_require__(18).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(5);
var setPrototypeOf = __webpack_require__(84).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(23);
var defined = __webpack_require__(26);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 88 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 89 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(31);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(13);
var hide = __webpack_require__(12);
var Iterators = __webpack_require__(50);
var $iterCreate = __webpack_require__(91);
var setToStringTag = __webpack_require__(47);
var getPrototypeOf = __webpack_require__(19);
var ITERATOR = __webpack_require__(6)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(38);
var descriptor = __webpack_require__(34);
var setToStringTag = __webpack_require__(47);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(12)(IteratorPrototype, __webpack_require__(6)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(66);
var defined = __webpack_require__(26);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(6)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(50);
var ITERATOR = __webpack_require__(6)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(9);
var createDesc = __webpack_require__(34);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(48);
var ITERATOR = __webpack_require__(6)('iterator');
var Iterators = __webpack_require__(50);
module.exports = __webpack_require__(20).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(264);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(10);
var toAbsoluteIndex = __webpack_require__(37);
var toLength = __webpack_require__(7);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(33);
var step = __webpack_require__(132);
var Iterators = __webpack_require__(50);
var toIObject = __webpack_require__(17);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(90)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(55);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(65)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(21);
var invoke = __webpack_require__(122);
var html = __webpack_require__(83);
var cel = __webpack_require__(79);
var global = __webpack_require__(2);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(22)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var macrotask = __webpack_require__(102).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(22)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(11);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(2);
var DESCRIPTORS = __webpack_require__(8);
var LIBRARY = __webpack_require__(31);
var $typed = __webpack_require__(72);
var hide = __webpack_require__(12);
var redefineAll = __webpack_require__(43);
var fails = __webpack_require__(4);
var anInstance = __webpack_require__(41);
var toInteger = __webpack_require__(23);
var toLength = __webpack_require__(7);
var toIndex = __webpack_require__(142);
var gOPN = __webpack_require__(39).f;
var dP = __webpack_require__(9).f;
var arrayFill = __webpack_require__(98);
var setToStringTag = __webpack_require__(47);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDataSet = exports.parseDataset = undefined;

var _string = __webpack_require__(107);

var RBRACE = /^(?:\{.*\}|\[.*\])$/; // 

var NUMBER_REG = /^\d*\.?\d*$/;
var PREFIX = 'data-';

var parseDataset = exports.parseDataset = function parseDataset(dataset) {
  var data = dataset;
  var parser = JSON.parse;

  if (typeof data === 'string') {
    try {
      if (data === 'true') {
        data = true;
      } else if (data === 'false') {
        data = false;
      } else if (data === 'null') {
        data = null;
      } else if (data === 'undefined') {
        data = undefined;
      } else if (NUMBER_REG.test(data)) {
        data = parseFloat(data);
      } else if (RBRACE.test(data)) {
        data = parser(data);
      }
    } catch (e) {
      data = undefined;
    }
  } else {
    data = undefined;
  }
  return data;
};

var getAllDatasetsAndParse = function getAllDatasetsAndParse(element) {
  var dataSet = {};
  var attributes = element.attributes;

  for (var i = 0; i < attributes.length; i += 1) {
    var attribute = attributes[i];
    if ((0, _string.startsWith)(attribute.name, PREFIX)) {
      // We use substr(5), since it's faster than replacing 'data-' with ''.
      var key = (0, _string.toCamelCase)(attribute.name.substr(5));
      dataSet[key] = parseDataset(attribute.value);
    }
  }
  // odstaneni vsech klicu, ktere maji hodnotu undefined.
  // http://stackoverflow.com/questions/286141/remove-blank-attributes-from-an-object-in-javascript
  return JSON.parse(JSON.stringify(dataSet));
};

// Naparsuje všechny nebo volitelný dataset na elementu do základných JS datových typů
var getDataSet = exports.getDataSet = function getDataSet(element, optDataSet) {
  if (optDataSet) {
    return parseDataset(element.getAttribute(PREFIX + (0, _string.toSelectorCase)(optDataSet)));
  }
  return getAllDatasetsAndParse(element);
};

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.i18n = exports.isString = exports.replaceParameters = exports.startsWith = exports.toSelectorCase = exports.toCamelCase = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _object = __webpack_require__(108);

var toCamelCase = exports.toCamelCase = function toCamelCase(str) {
  return String(str).replace(/-([a-z])/g, function (all, match) {
    return match.toUpperCase();
  });
};

var toSelectorCase = exports.toSelectorCase = function toSelectorCase(str) {
  return String(str).replace(/([A-Z])/g, '-$1').toLowerCase();
};

var startsWith = exports.startsWith = function startsWith(str, prefix) {
  return str.lastIndexOf(prefix, 0) === 0;
};

var replaceParameters = exports.replaceParameters = function replaceParameters(str, optParams, optNotFound) {
  if (optParams && (Array.isArray(optParams) || (typeof optParams === 'undefined' ? 'undefined' : _typeof(optParams)) === 'object')) {
    var re = new RegExp('\\$?((\\{)|(%7B))(.*?)((\\})|(%7D))', 'g');
    var paramsInStr = str.match(re);
    if (paramsInStr) {
      // eslint-disable-next-line
      for (var i in paramsInStr) {
        var key = paramsInStr[i];
        var clearKey = key.toString().replace(re, '$4');
        var value = (0, _object.getObjectByName)(clearKey, optParams);
        var newValue = value != null ? value : optNotFound || key;
        str = str.replace(key, newValue);
      }
    }
  }
  return str;
};

var isString = exports.isString = function isString(val) {
  return typeof val === 'string';
};

/**
 * @param {string} type
 * @param {Array|Object=} optValues
 * @param {string=} optPrefix
 * @param {Object=} optMessages
 * @return {string}
 */
var i18n = exports.i18n = function i18n(type, optValues, optPrefix, optMessages) {
  var values = optValues || {};
  var messages = optMessages || {};
  var computedType = optPrefix ? optPrefix + '.' + type : type;
  var str = void 0;
  var hasMessage = true;

  if (messages[computedType]) {
    str = messages[computedType];
  } else if (messages[type] != null) {
    str = messages[type];
  } else {
    if (window.clientMessages && window.clientMessages[computedType]) {
      str = window.clientMessages[computedType];
    } else if (window.clientMessages && window.clientMessages[type]) {
      str = window.clientMessages[type];
    } else {
      str = '!!!.' + computedType + '.!!!';
      hasMessage = false;
    }
  }
  if (hasMessage) {
    // message může být i object {"title": "obsah message", "param": string|Array.<string>}
    if ((0, _object.isObject)(str)) {
      values = str.param ? isString(str.param) ? [str.param] : str.param : [];
      str = str.title;
    }
    // eslint-disable-next-line
    for (var key in values) {
      // eslint-disable-next-line
      var value = ('' + values[key]).replace(/\$/g, '$$$$');
      // eslint-disable-next-line
      str = str.replace(new RegExp('\\$\\{' + key + '\\}', 'gi'), value);
    }
  } else {
    // eslint-disable-next-line
    for (var _key in values) {
      // eslint-disable-next-line
      str += '${' + _key + '}';
    }
  }
  return str;
};

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// 

// zeserializuje object key/value do stringu použitelného jako parametry v url
var serializeToParamsString = exports.serializeToParamsString = function serializeToParamsString(obj) {
  return Object.keys(obj).map(function (key) {
    var value = obj[key];
    if (Array.isArray(value)) {
      return value.map(function (subValue) {
        return encodeURIComponent(key) + '=' + encodeURIComponent(subValue);
      }).join('&');
    }
    return encodeURIComponent(key) + '=' + encodeURIComponent(value);
  }).join('&');
};

/*
seřadí klíče v objectu podle názvu vzestupně
*/
var sortObject = exports.sortObject = function sortObject(o) {
  return Object.keys(o).sort().reduce(function (r, k) {
    r[k] = o[k];
    return r;
  }, {});
};

var getObjectByName = exports.getObjectByName = function getObjectByName(name, obj) {
  var parts = name.split('.');
  var cur = obj;
  // eslint-disable-next-line
  for (var part; part = parts.shift();) {
    if (cur[part] != null) {
      cur = cur[part];
    } else {
      return null;
    }
  }
  return cur;
};

/**
 * Returns true if the specified value is an object.  This includes arrays and
 * functions.
 */
var isObject = exports.isObject = function isObject(val) {
  var type = typeof val === 'undefined' ? 'undefined' : _typeof(val);
  return type === 'object' && (val != null || type === 'function');
  // return Object(val) === val also works, but is slower, especially if val is
  // not an object.
};

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeSubmitData = exports.mapToSubmitDataIfNeeded = exports.serializeForms = exports.removeFromData = exports.getNamesArray = undefined;

var _jquery = __webpack_require__(3);

var _jquery2 = _interopRequireDefault(_jquery);

var _object = __webpack_require__(108);

var _urijs = __webpack_require__(57);

var _urijs2 = _interopRequireDefault(_urijs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } // 

var getNamesArray = exports.getNamesArray = function getNamesArray(names, likeWidgetData) {
  var namesForRemove = [];
  if (Array.isArray(names)) {
    namesForRemove = names;
  }
  if (typeof names === 'string') {
    namesForRemove = names.replace(/\s*[,;]\s*/g, ',').split(',');
  }
  if (likeWidgetData) {
    namesForRemove = namesForRemove.map(function (name) {
      return 'frm.' + name;
    });
  }
  return namesForRemove;
};

/**
 * Remove all or defined data from form data object
 */
var removeFromData = exports.removeFromData = function removeFromData(data, remove, likeWidgetData) {
  if (!remove) {
    return data;
  }
  if (remove === true) {
    return data.filter(function (item) {
      return likeWidgetData ? !item.name.startsWith('frm.') : item.name.startsWith('frm.') || item.name === 'formId';
    });
  }
  var forRemove = getNamesArray(remove, likeWidgetData);
  return data.filter(function (item) {
    return !forRemove.includes(item.name);
  });
};

/**
 * Serialize form data from more forms (elements) with data prevent duplicity
 */
var serializeForms = exports.serializeForms = function serializeForms(elements) {
  var data = [];
  [].concat(_toConsumableArray(elements)).forEach(function (element) {
    var namesForRemove = data.map(function (_ref) {
      var name = _ref.name;
      return name;
    });
    var formData = removeFromData((0, _jquery2.default)(element).serializeArray(), namesForRemove);
    data = [].concat(_toConsumableArray(data), _toConsumableArray(formData));
  });
  return data;
};

/**
 *  Maps object to objects array with pairs name and value
 */
var mapToSubmitDataIfNeeded = exports.mapToSubmitDataIfNeeded = function mapToSubmitDataIfNeeded(data) {

  if (typeof data === 'string') {
    data = _urijs2.default.parseQuery(data);
  }

  if ((0, _object.isObject)(data) && !Array.isArray(data)) {
    var transformedSubmitData = [];
    Object.keys(data).forEach(function (name) {
      var values = data[name];
      if (Array.isArray(values)) {
        values.forEach(function (value) {
          transformedSubmitData.push({
            name: name,
            value: value
          });
        });
      } else {
        transformedSubmitData.push({
          name: name,
          value: values
        });
      }
    });
    return transformedSubmitData;
  }
  return data;
};

var mergeSubmitData = exports.mergeSubmitData = function mergeSubmitData(data1, data2) {
  data1 = mapToSubmitDataIfNeeded(data1);
  data2 = mapToSubmitDataIfNeeded(data2);
  var submitDataMergeNames = data2.map(function (_ref2) {
    var name = _ref2.name;
    return name;
  });
  data1 = removeFromData(data1, submitDataMergeNames, false);
  return [].concat(_toConsumableArray(data1), _toConsumableArray(data2));
};

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// 
var XHRQueue = {};

var activeXHRSelector = '[data-active-xhr="true"]';

var isInProgress = exports.isInProgress = function isInProgress() {
  return Object.values(XHRQueue).filter(function (_ref) {
    var settings = _ref.settings;
    return settings.includeToProgress === true;
  }).length > 0;
};

var removeXHR = exports.removeXHR = function removeXHR(target) {
  if (Array.isArray(target)) {
    target = target.join('+');
  }
  var isExists = XHRQueue[target] != null;
  delete XHRQueue[target];
  if (isExists && window.partialUpdateGlobalSettings.onChangeXHRQueue) {
    window.partialUpdateGlobalSettings.onChangeXHRQueue(XHRQueue);
  }

  if (!Array.isArray(target)) {
    target.replace(/,/g, '+');
    target = target.split('+');
  }
  target.forEach(function (targetId) {
    var targetElement = document.getElementById(targetId);
    if (targetElement) {
      delete targetElement.dataset.activeXhr;
    }
  });
};

var addXHR = exports.addXHR = function addXHR(target, xhr, settings) {
  if (Array.isArray(target)) {
    target = target.join('+');
  }
  target.replace(/,/g, '+');
  XHRQueue[target] = { xhr: xhr, settings: settings };
  if (window.partialUpdateGlobalSettings.onChangeXHRQueue) {
    window.partialUpdateGlobalSettings.onChangeXHRQueue(XHRQueue);
  }
  if (!Array.isArray(target)) {
    target.replace(/,/g, '+');
    target = target.split('+');
  }
  target.forEach(function (targetId) {
    var targetElement = document.getElementById(targetId);
    if (targetElement) {
      targetElement.dataset.activeXhr = true;
    }
  });
};

var abortXHR = exports.abortXHR = function abortXHR(target) {
  if (!Array.isArray(target)) {
    target.replace(/,/g, '+');
    target = target.split('+');
  }

  target.forEach(function (targetId) {
    var targetXhr = XHRQueue[targetId];
    if (targetXhr) {
      targetXhr.xhr.abort();
    }
    removeXHR(targetId);
    var container = document.getElementById(targetId);
    if (container) {
      var idsForAborting = Object.keys(XHRQueue).filter(function (xhrId) {
        var containsClosest = xhrId.split('+').map(function (id) {
          var innerElement = document.getElementById(id);
          if (!innerElement) {
            return true;
          }
          return container.contains(innerElement);
        }).filter(function (isClosest) {
          return isClosest === true;
        });
        return containsClosest.length > 0;
      });
      idsForAborting.forEach(function (id) {
        var xhr = XHRQueue[id];
        if (xhr) {
          xhr.xhr.abort();
        }
        removeXHR(id);
      });
    }
  });
};

var isInActivePUContainer = exports.isInActivePUContainer = function isInActivePUContainer(element, excludeUiEvents) {
  if (!element) {
    return false;
  }
  var activeClosestContainer = element.closest(activeXHRSelector);
  if (!activeClosestContainer) {
    return false;
  }
  /*if (activeClosestContainer === element) {
    return false;
  }*/
  if (!excludeUiEvents) {
    return true;
  }

  var _ref2 = XHRQueue[activeClosestContainer.id] || {},
      closestSettings = _ref2.closestSettings;

  if (closestSettings && closestSettings.headers['RamJet-WithUiEvent']) {
    return false;
  }
  return true;
};

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isRoutingAnchor = exports.getOrigin = exports.normalizeUrl = undefined;

var _urijs = __webpack_require__(57);

var _urijs2 = _interopRequireDefault(_urijs);

var _object = __webpack_require__(108);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// sort parameters in Uri
// 
var normalizeUrl = exports.normalizeUrl = function normalizeUrl(url) {
  var uri = (0, _urijs2.default)(url);
  var uriQuery = uri.query();
  uri.query('');
  var newQuery = (0, _object.sortObject)(_urijs2.default.parseQuery(uriQuery));
  uri.query(newQuery);
  return uri.toString();
};

var getOrigin = exports.getOrigin = function getOrigin() {
  return window.location.origin ? window.location.origin : window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
};

var isRoutingAnchor = exports.isRoutingAnchor = function isRoutingAnchor(anchor) {
  // Ignore anchor with target.
  var targetAttribute = anchor.getAttribute('target');
  if (targetAttribute && targetAttribute !== '') {
    return false;
  }
  // ignore tree nodes
  if (anchor.classList.contains('treeRowHref')) {
    return false;
  }

  if (anchor.closest('.noPartialUpdate') != null) {
    return false;
  }

  if (anchor.getAttribute('data-pu') != null || anchor.getAttribute('data-partial-update') != null) {
    return false;
  }

  var href = anchor.getAttribute('href').replace(getOrigin(), '');

  // Ignore hrefs start with hash
  if (href.startsWith('filebrowser?')) {
    return false;
  }
  if (href.lastIndexOf('#', 0) === 0) {
    return false;
  }
  // Ignore hrefs start with javascript:
  if (href.lastIndexOf('javascript:', 0) === 0) {
    return false;
  }
  // ignore http and https
  if (href.lastIndexOf('http', 0) === 0 || href.lastIndexOf('https', 0) === 0) {
    return false;
  }
  // Ignore mailto
  if (href.lastIndexOf('mailto:', 0) === 0) {
    return false;
  }
  return true;
};

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(163),
    isLength = __webpack_require__(60),
    isObjectLike = __webpack_require__(59);

/** `Object#toString` result references. */
var arrayTag = '[object Array]';

/** Used for native method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/* Native method references for those with the same name as other `lodash` methods. */
var nativeIsArray = getNative(Array, 'isArray');

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(function() { return arguments; }());
 * // => false
 */
var isArray = nativeIsArray || function(value) {
  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
};

module.exports = isArray;


/***/ }),
/* 113 */,
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(8) && !__webpack_require__(4)(function () {
  return Object.defineProperty(__webpack_require__(79)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(6);


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(16);
var toIObject = __webpack_require__(17);
var arrayIndexOf = __webpack_require__(62)(false);
var IE_PROTO = __webpack_require__(81)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(9);
var anObject = __webpack_require__(1);
var getKeys = __webpack_require__(36);

module.exports = __webpack_require__(8) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(17);
var gOPN = __webpack_require__(39).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(8);
var getKeys = __webpack_require__(36);
var gOPS = __webpack_require__(63);
var pIE = __webpack_require__(54);
var toObject = __webpack_require__(10);
var IObject = __webpack_require__(53);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(4)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 120 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(11);
var isObject = __webpack_require__(5);
var invoke = __webpack_require__(122);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 122 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(2).parseInt;
var $trim = __webpack_require__(49).trim;
var ws = __webpack_require__(85);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(2).parseFloat;
var $trim = __webpack_require__(49).trim;

module.exports = 1 / $parseFloat(__webpack_require__(85) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(22);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(5);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 127 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(88);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(1);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(11);
var toObject = __webpack_require__(10);
var IObject = __webpack_require__(53);
var toLength = __webpack_require__(7);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(10);
var toAbsoluteIndex = __webpack_require__(37);
var toLength = __webpack_require__(7);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(100);
__webpack_require__(0)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(8) && /./g.flags != 'g') __webpack_require__(9).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(55)
});


/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(1);
var isObject = __webpack_require__(5);
var newPromiseCapability = __webpack_require__(104);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(138);
var validate = __webpack_require__(44);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(71)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(9).f;
var create = __webpack_require__(38);
var redefineAll = __webpack_require__(43);
var ctx = __webpack_require__(21);
var anInstance = __webpack_require__(41);
var forOf = __webpack_require__(42);
var $iterDefine = __webpack_require__(90);
var step = __webpack_require__(132);
var setSpecies = __webpack_require__(40);
var DESCRIPTORS = __webpack_require__(8);
var fastKey = __webpack_require__(32).fastKey;
var validate = __webpack_require__(44);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(138);
var validate = __webpack_require__(44);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(71)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(2);
var each = __webpack_require__(28)(0);
var redefine = __webpack_require__(13);
var meta = __webpack_require__(32);
var assign = __webpack_require__(119);
var weak = __webpack_require__(141);
var isObject = __webpack_require__(5);
var validate = __webpack_require__(44);
var NATIVE_WEAK_MAP = __webpack_require__(44);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(71)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(43);
var getWeak = __webpack_require__(32).getWeak;
var anObject = __webpack_require__(1);
var isObject = __webpack_require__(5);
var anInstance = __webpack_require__(41);
var forOf = __webpack_require__(42);
var createArrayMethod = __webpack_require__(28);
var $has = __webpack_require__(16);
var validate = __webpack_require__(44);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(23);
var toLength = __webpack_require__(7);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(39);
var gOPS = __webpack_require__(63);
var anObject = __webpack_require__(1);
var Reflect = __webpack_require__(2).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(64);
var isObject = __webpack_require__(5);
var toLength = __webpack_require__(7);
var ctx = __webpack_require__(21);
var IS_CONCAT_SPREADABLE = __webpack_require__(6)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(7);
var repeat = __webpack_require__(87);
var defined = __webpack_require__(26);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(8);
var getKeys = __webpack_require__(36);
var toIObject = __webpack_require__(17);
var isEnum = __webpack_require__(54).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(48);
var from = __webpack_require__(148);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(42);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 149 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * selectize.js (v0.12.1)
 * Copyright (c) 2013–2015 Brian Reavis & contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
 * file except in compliance with the License. You may obtain a copy of the License at:
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 *
 * @author Brian Reavis <brian@thirdroute.com>
 */

/*jshint curly:false */
/*jshint browser:true */

(function(root, factory) {
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3),__webpack_require__(403),__webpack_require__(404)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof exports === 'object') {
		module.exports = factory(require('jquery'), require('sifter'), require('microplugin'));
	} else {
		root.Selectize = factory(root.jQuery, root.Sifter, root.MicroPlugin);
	}
}(this, function($, Sifter, MicroPlugin) {
	'use strict';

	var highlight = function($element, pattern) {
		if (typeof pattern === 'string' && !pattern.length) return;
		var regex = (typeof pattern === 'string') ? new RegExp(pattern, 'i') : pattern;
	
		var highlight = function(node) {
			var skip = 0;
			if (node.nodeType === 3) {
				var pos = node.data.search(regex);
				if (pos >= 0 && node.data.length > 0) {
					var match = node.data.match(regex);
					var spannode = document.createElement('span');
					spannode.className = 'highlight';
					var middlebit = node.splitText(pos);
					var endbit = middlebit.splitText(match[0].length);
					var middleclone = middlebit.cloneNode(true);
					spannode.appendChild(middleclone);
					middlebit.parentNode.replaceChild(spannode, middlebit);
					skip = 1;
				}
			} else if (node.nodeType === 1 && node.childNodes && !/(script|style)/i.test(node.tagName)) {
				for (var i = 0; i < node.childNodes.length; ++i) {
					i += highlight(node.childNodes[i]);
				}
			}
			return skip;
		};
	
		return $element.each(function() {
			highlight(this);
		});
	};
	
	var MicroEvent = function() {};
	MicroEvent.prototype = {
		on: function(event, fct){
			this._events = this._events || {};
			this._events[event] = this._events[event] || [];
			this._events[event].push(fct);
		},
		off: function(event, fct){
			var n = arguments.length;
			if (n === 0) return delete this._events;
			if (n === 1) return delete this._events[event];
	
			this._events = this._events || {};
			if (event in this._events === false) return;
			this._events[event].splice(this._events[event].indexOf(fct), 1);
		},
		trigger: function(event /* , args... */){
			this._events = this._events || {};
			if (event in this._events === false) return;
			for (var i = 0; i < this._events[event].length; i++){
				this._events[event][i].apply(this, Array.prototype.slice.call(arguments, 1));
			}
		}
	};
	
	/**
	 * Mixin will delegate all MicroEvent.js function in the destination object.
	 *
	 * - MicroEvent.mixin(Foobar) will make Foobar able to use MicroEvent
	 *
	 * @param {object} the object which will support MicroEvent
	 */
	MicroEvent.mixin = function(destObject){
		var props = ['on', 'off', 'trigger'];
		for (var i = 0; i < props.length; i++){
			destObject.prototype[props[i]] = MicroEvent.prototype[props[i]];
		}
	};
	
	var IS_MAC        = /Mac/.test(navigator.userAgent);
	
	var KEY_A         = 65;
	var KEY_COMMA     = 188;
	var KEY_RETURN    = 13;
	var KEY_ESC       = 27;
	var KEY_LEFT      = 37;
	var KEY_UP        = 38;
	var KEY_P         = 80;
	var KEY_RIGHT     = 39;
	var KEY_DOWN      = 40;
	var KEY_N         = 78;
	var KEY_BACKSPACE = 8;
	var KEY_DELETE    = 46;
	var KEY_SHIFT     = 16;
	var KEY_CMD       = IS_MAC ? 91 : 17;
	var KEY_CTRL      = IS_MAC ? 18 : 17;
	var KEY_TAB       = 9;
	
	var TAG_SELECT    = 1;
	var TAG_INPUT     = 2;
	
	// for now, android support in general is too spotty to support validity
	var SUPPORTS_VALIDITY_API = !/android/i.test(window.navigator.userAgent) && !!document.createElement('form').validity;
	
	var isset = function(object) {
		return typeof object !== 'undefined';
	};
	
	/**
	 * Converts a scalar to its best string representation
	 * for hash keys and HTML attribute values.
	 *
	 * Transformations:
	 *   'str'     -> 'str'
	 *   null      -> ''
	 *   undefined -> ''
	 *   true      -> '1'
	 *   false     -> '0'
	 *   0         -> '0'
	 *   1         -> '1'
	 *
	 * @param {string} value
	 * @returns {string|null}
	 */
	var hash_key = function(value) {
		if (typeof value === 'undefined' || value === null) return null;
		if (typeof value === 'boolean') return value ? '1' : '0';
		return value + '';
	};
	
	/**
	 * Escapes a string for use within HTML.
	 *
	 * @param {string} str
	 * @returns {string}
	 */
	var escape_html = function(str) {
		return (str + '')
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	};
	
	/**
	 * Escapes "$" characters in replacement strings.
	 *
	 * @param {string} str
	 * @returns {string}
	 */
	var escape_replace = function(str) {
		return (str + '').replace(/\$/g, '$$$$');
	};
	
	var hook = {};
	
	/**
	 * Wraps `method` on `self` so that `fn`
	 * is invoked before the original method.
	 *
	 * @param {object} self
	 * @param {string} method
	 * @param {function} fn
	 */
	hook.before = function(self, method, fn) {
		var original = self[method];
		self[method] = function() {
			fn.apply(self, arguments);
			return original.apply(self, arguments);
		};
	};
	
	/**
	 * Wraps `method` on `self` so that `fn`
	 * is invoked after the original method.
	 *
	 * @param {object} self
	 * @param {string} method
	 * @param {function} fn
	 */
	hook.after = function(self, method, fn) {
		var original = self[method];
		self[method] = function() {
			var result = original.apply(self, arguments);
			fn.apply(self, arguments);
			return result;
		};
	};
	
	/**
	 * Wraps `fn` so that it can only be invoked once.
	 *
	 * @param {function} fn
	 * @returns {function}
	 */
	var once = function(fn) {
		var called = false;
		return function() {
			if (called) return;
			called = true;
			fn.apply(this, arguments);
		};
	};
	
	/**
	 * Wraps `fn` so that it can only be called once
	 * every `delay` milliseconds (invoked on the falling edge).
	 *
	 * @param {function} fn
	 * @param {int} delay
	 * @returns {function}
	 */
	var debounce = function(fn, delay) {
		var timeout;
		return function() {
			var self = this;
			var args = arguments;
			window.clearTimeout(timeout);
			timeout = window.setTimeout(function() {
				fn.apply(self, args);
			}, delay);
		};
	};
	
	/**
	 * Debounce all fired events types listed in `types`
	 * while executing the provided `fn`.
	 *
	 * @param {object} self
	 * @param {array} types
	 * @param {function} fn
	 */
	var debounce_events = function(self, types, fn) {
		var type;
		var trigger = self.trigger;
		var event_args = {};
	
		// override trigger method
		self.trigger = function() {
			var type = arguments[0];
			if (types.indexOf(type) !== -1) {
				event_args[type] = arguments;
			} else {
				return trigger.apply(self, arguments);
			}
		};
	
		// invoke provided function
		fn.apply(self, []);
		self.trigger = trigger;
	
		// trigger queued events
		for (type in event_args) {
			if (event_args.hasOwnProperty(type)) {
				trigger.apply(self, event_args[type]);
			}
		}
	};
	
	/**
	 * A workaround for http://bugs.jquery.com/ticket/6696
	 *
	 * @param {object} $parent - Parent element to listen on.
	 * @param {string} event - Event name.
	 * @param {string} selector - Descendant selector to filter by.
	 * @param {function} fn - Event handler.
	 */
	var watchChildEvent = function($parent, event, selector, fn) {
		$parent.on(event, selector, function(e) {
			var child = e.target;
			while (child && child.parentNode !== $parent[0]) {
				child = child.parentNode;
			}
			e.currentTarget = child;
			return fn.apply(this, [e]);
		});
	};
	
	/**
	 * Determines the current selection within a text input control.
	 * Returns an object containing:
	 *   - start
	 *   - length
	 *
	 * @param {object} input
	 * @returns {object}
	 */
	var getSelection = function(input) {
		var result = {};
		if ('selectionStart' in input) {
			result.start = input.selectionStart;
			result.length = input.selectionEnd - result.start;
		} else if (document.selection) {
			input.focus();
			var sel = document.selection.createRange();
			var selLen = document.selection.createRange().text.length;
			sel.moveStart('character', -input.value.length);
			result.start = sel.text.length - selLen;
			result.length = selLen;
		}
		return result;
	};
	
	/**
	 * Copies CSS properties from one element to another.
	 *
	 * @param {object} $from
	 * @param {object} $to
	 * @param {array} properties
	 */
	var transferStyles = function($from, $to, properties) {
		var i, n, styles = {};
		if (properties) {
			for (i = 0, n = properties.length; i < n; i++) {
				styles[properties[i]] = $from.css(properties[i]);
			}
		} else {
			styles = $from.css();
		}
		$to.css(styles);
	};
	
	/**
	 * Measures the width of a string within a
	 * parent element (in pixels).
	 *
	 * @param {string} str
	 * @param {object} $parent
	 * @returns {int}
	 */
	var measureString = function(str, $parent) {
		if (!str) {
			return 0;
		}
	
		var $test = $('<test>').css({
			position: 'absolute',
			top: -99999,
			left: -99999,
			width: 'auto',
			padding: 0,
			whiteSpace: 'pre'
		}).text(str).appendTo('body');
	
		transferStyles($parent, $test, [
			'letterSpacing',
			'fontSize',
			'fontFamily',
			'fontWeight',
			'textTransform'
		]);
	
		var width = $test.width();
		$test.remove();
	
		return width;
	};
	
	/**
	 * Sets up an input to grow horizontally as the user
	 * types. If the value is changed manually, you can
	 * trigger the "update" handler to resize:
	 *
	 * $input.trigger('update');
	 *
	 * @param {object} $input
	 */
	var autoGrow = function($input) {
		var currentWidth = null;
	
		var update = function(e, options) {
			var value, keyCode, printable, placeholder, width;
			var shift, character, selection;
			e = e || window.event || {};
			options = options || {};
	
			if (e.metaKey || e.altKey) return;
			if (!options.force && $input.data('grow') === false) return;
	
			value = $input.val();
			if (e.type && e.type.toLowerCase() === 'keydown') {
				keyCode = e.keyCode;
				printable = (
					(keyCode >= 97 && keyCode <= 122) || // a-z
					(keyCode >= 65 && keyCode <= 90)  || // A-Z
					(keyCode >= 48 && keyCode <= 57)  || // 0-9
					keyCode === 32 // space
				);
	
				if (keyCode === KEY_DELETE || keyCode === KEY_BACKSPACE) {
					selection = getSelection($input[0]);
					if (selection.length) {
						value = value.substring(0, selection.start) + value.substring(selection.start + selection.length);
					} else if (keyCode === KEY_BACKSPACE && selection.start) {
						value = value.substring(0, selection.start - 1) + value.substring(selection.start + 1);
					} else if (keyCode === KEY_DELETE && typeof selection.start !== 'undefined') {
						value = value.substring(0, selection.start) + value.substring(selection.start + 1);
					}
				} else if (printable) {
					shift = e.shiftKey;
					character = String.fromCharCode(e.keyCode);
					if (shift) character = character.toUpperCase();
					else character = character.toLowerCase();
					value += character;
				}
			}
	
			placeholder = $input.attr('placeholder');
			if (!value && placeholder) {
				value = placeholder;
			}
	
			width = measureString(value, $input) + 4;
			if (width !== currentWidth) {
				currentWidth = width;
				$input.width(width);
				$input.triggerHandler('resize');
			}
		};
	
		$input.on('keydown keyup update blur', update);
		update();
	};
	
	var Selectize = function($input, settings) {
		var key, i, n, dir, input, self = this;
		input = $input[0];
		input.selectize = self;
	
		// detect rtl environment
		var computedStyle = window.getComputedStyle && window.getComputedStyle(input, null);
		dir = computedStyle ? computedStyle.getPropertyValue('direction') : input.currentStyle && input.currentStyle.direction;
		dir = dir || $input.parents('[dir]:first').attr('dir') || '';
	
		// setup default state
		$.extend(self, {
			order            : 0,
			settings         : settings,
			$input           : $input,
			tabIndex         : $input.attr('tabindex') || '',
			tagType          : input.tagName.toLowerCase() === 'select' ? TAG_SELECT : TAG_INPUT,
			rtl              : /rtl/i.test(dir),
	
			eventNS          : '.selectize' + (++Selectize.count),
			highlightedValue : null,
			isOpen           : false,
			isDisabled       : false,
			isRequired       : $input.is('[required]'),
			isInvalid        : false,
			isLocked         : false,
			isFocused        : false,
			isInputHidden    : false,
			isSetup          : false,
			isShiftDown      : false,
			isCmdDown        : false,
			isCtrlDown       : false,
			ignoreFocus      : false,
			ignoreBlur       : false,
			ignoreHover      : false,
			hasOptions       : false,
			currentResults   : null,
			lastValue        : '',
			caretPos         : 0,
			loading          : 0,
			loadedSearches   : {},
	
			$activeOption    : null,
			$activeItems     : [],
	
			optgroups        : {},
			options          : {},
			userOptions      : {},
			items            : [],
			renderCache      : {},
			onSearchChange   : settings.loadThrottle === null ? self.onSearchChange : debounce(self.onSearchChange, settings.loadThrottle)
		});
	
		// search system
		self.sifter = new Sifter(this.options, {diacritics: settings.diacritics});
	
		// build options table
		if (self.settings.options) {
			for (i = 0, n = self.settings.options.length; i < n; i++) {
				self.registerOption(self.settings.options[i]);
			}
			delete self.settings.options;
		}
	
		// build optgroup table
		if (self.settings.optgroups) {
			for (i = 0, n = self.settings.optgroups.length; i < n; i++) {
				self.registerOptionGroup(self.settings.optgroups[i]);
			}
			delete self.settings.optgroups;
		}
	
		// option-dependent defaults
		self.settings.mode = self.settings.mode || (self.settings.maxItems === 1 ? 'single' : 'multi');
		if (typeof self.settings.hideSelected !== 'boolean') {
			self.settings.hideSelected = self.settings.mode === 'multi';
		}
	
		self.initializePlugins(self.settings.plugins);
		self.setupCallbacks();
		self.setupTemplates();
		self.setup();
	};
	
	// mixins
	// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	
	MicroEvent.mixin(Selectize);
	MicroPlugin.mixin(Selectize);
	
	// methods
	// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	
	$.extend(Selectize.prototype, {
	
		/**
		 * Creates all elements and sets up event bindings.
		 */
		setup: function() {
			var self      = this;
			var settings  = self.settings;
			var eventNS   = self.eventNS;
			var $window   = $(window);
			var $document = $(document);
			var $input    = self.$input;
	
			var $wrapper;
			var $control;
			var $control_input;
			var $dropdown;
			var $dropdown_content;
			var $dropdown_parent;
			var inputMode;
			var timeout_blur;
			var timeout_focus;
			var classes;
			var classes_plugins;
	
			inputMode         = self.settings.mode;
			classes           = $input.attr('class') || '';
	
			$wrapper          = $('<div>').addClass(settings.wrapperClass).addClass(classes).addClass(inputMode);
			$control          = $('<div>').addClass(settings.inputClass).addClass('items').appendTo($wrapper);
			$control_input    = $('<input type="text" autocomplete="off" />').appendTo($control).attr('tabindex', $input.is(':disabled') ? '-1' : self.tabIndex);
			$dropdown_parent  = $(settings.dropdownParent || $wrapper);
			$dropdown         = $('<div>').addClass(settings.dropdownClass).addClass(inputMode).hide().appendTo($dropdown_parent);
			$dropdown_content = $('<div>').addClass(settings.dropdownContentClass).appendTo($dropdown);
	
			if(self.settings.copyClassesToDropdown) {
				$dropdown.addClass(classes);
			}
	
			$wrapper.css({
				width: $input[0].style.width
			});
	
			if (self.plugins.names.length) {
				classes_plugins = 'plugin-' + self.plugins.names.join(' plugin-');
				$wrapper.addClass(classes_plugins);
				$dropdown.addClass(classes_plugins);
			}
	
			if ((settings.maxItems === null || settings.maxItems > 1) && self.tagType === TAG_SELECT) {
				$input.attr('multiple', 'multiple');
			}
	
			if (self.settings.placeholder) {
				$control_input.attr('placeholder', settings.placeholder);
			}
	
			// if splitOn was not passed in, construct it from the delimiter to allow pasting universally
			if (!self.settings.splitOn && self.settings.delimiter) {
				var delimiterEscaped = self.settings.delimiter.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
				self.settings.splitOn = new RegExp('\\s*' + delimiterEscaped + '+\\s*');
			}
	
			if ($input.attr('autocorrect')) {
				$control_input.attr('autocorrect', $input.attr('autocorrect'));
			}
	
			if ($input.attr('autocapitalize')) {
				$control_input.attr('autocapitalize', $input.attr('autocapitalize'));
			}
	
			self.$wrapper          = $wrapper;
			self.$control          = $control;
			self.$control_input    = $control_input;
			self.$dropdown         = $dropdown;
			self.$dropdown_content = $dropdown_content;
	
			$dropdown.on('mouseenter', '[data-selectable]', function() { return self.onOptionHover.apply(self, arguments); });
			$dropdown.on('mousedown click', '[data-selectable]', function() { return self.onOptionSelect.apply(self, arguments); });
			watchChildEvent($control, 'mousedown', '*:not(input)', function() { return self.onItemSelect.apply(self, arguments); });
			autoGrow($control_input);
	
			$control.on({
				mousedown : function() { return self.onMouseDown.apply(self, arguments); },
				click     : function() { return self.onClick.apply(self, arguments); }
			});
	
			$control_input.on({
				mousedown : function(e) { e.stopPropagation(); },
				keydown   : function() { return self.onKeyDown.apply(self, arguments); },
				keyup     : function() { return self.onKeyUp.apply(self, arguments); },
				keypress  : function() { return self.onKeyPress.apply(self, arguments); },
				resize    : function() { self.positionDropdown.apply(self, []); },
				blur      : function() { return self.onBlur.apply(self, arguments); },
				focus     : function() { self.ignoreBlur = false; return self.onFocus.apply(self, arguments); },
				paste     : function() { return self.onPaste.apply(self, arguments); }
			});
	
			$document.on('keydown' + eventNS, function(e) {
				self.isCmdDown = e[IS_MAC ? 'metaKey' : 'ctrlKey'];
				self.isCtrlDown = e[IS_MAC ? 'altKey' : 'ctrlKey'];
				self.isShiftDown = e.shiftKey;
			});
	
			$document.on('keyup' + eventNS, function(e) {
				if (e.keyCode === KEY_CTRL) self.isCtrlDown = false;
				if (e.keyCode === KEY_SHIFT) self.isShiftDown = false;
				if (e.keyCode === KEY_CMD) self.isCmdDown = false;
			});
	
			$document.on('mousedown' + eventNS, function(e) {
				if (self.isFocused) {
					// prevent events on the dropdown scrollbar from causing the control to blur
					if (e.target === self.$dropdown[0] || e.target.parentNode === self.$dropdown[0]) {
						return false;
					}
					// blur on click outside
					if (!self.$control.has(e.target).length && e.target !== self.$control[0]) {
						self.blur(e.target);
					}
				}
			});
	
			$window.on(['scroll' + eventNS, 'resize' + eventNS].join(' '), function() {
				if (self.isOpen) {
					self.positionDropdown.apply(self, arguments);
				}
			});
			$window.on('mousemove' + eventNS, function() {
				self.ignoreHover = false;
			});
	
			// store original children and tab index so that they can be
			// restored when the destroy() method is called.
			this.revertSettings = {
				$children : $input.children().detach(),
				tabindex  : $input.attr('tabindex')
			};
	
			$input.attr('tabindex', -1).hide().after(self.$wrapper);
	
			if ($.isArray(settings.items)) {
				self.setValue(settings.items);
				delete settings.items;
			}
	
			// feature detect for the validation API
			if (SUPPORTS_VALIDITY_API) {
				$input.on('invalid' + eventNS, function(e) {
					e.preventDefault();
					self.isInvalid = true;
					self.refreshState();
				});
			}
	
			self.updateOriginalInput();
			self.refreshItems();
			self.refreshState();
			self.updatePlaceholder();
			self.isSetup = true;
	
			if ($input.is(':disabled')) {
				self.disable();
			}
	
			self.on('change', this.onChange);
	
			$input.data('selectize', self);
			$input.addClass('selectized');
			self.trigger('initialize');
	
			// preload options
			if (settings.preload === true) {
				self.onSearchChange('');
			}
	
		},
	
		/**
		 * Sets up default rendering functions.
		 */
		setupTemplates: function() {
			var self = this;
			var field_label = self.settings.labelField;
			var field_optgroup = self.settings.optgroupLabelField;
	
			var templates = {
				'optgroup': function(data) {
					return '<div class="optgroup">' + data.html + '</div>';
				},
				'optgroup_header': function(data, escape) {
					return '<div class="optgroup-header">' + escape(data[field_optgroup]) + '</div>';
				},
				'option': function(data, escape) {
					return '<div class="option">' + escape(data[field_label]) + '</div>';
				},
				'item': function(data, escape) {
					return '<div class="item">' + escape(data[field_label]) + '</div>';
				},
				'option_create': function(data, escape) {
					return '<div class="create">Add <strong>' + escape(data.input) + '</strong>&hellip;</div>';
				}
			};
	
			self.settings.render = $.extend({}, templates, self.settings.render);
		},
	
		/**
		 * Maps fired events to callbacks provided
		 * in the settings used when creating the control.
		 */
		setupCallbacks: function() {
			var key, fn, callbacks = {
				'initialize'      : 'onInitialize',
				'change'          : 'onChange',
				'item_add'        : 'onItemAdd',
				'item_remove'     : 'onItemRemove',
				'clear'           : 'onClear',
				'option_add'      : 'onOptionAdd',
				'option_remove'   : 'onOptionRemove',
				'option_clear'    : 'onOptionClear',
				'optgroup_add'    : 'onOptionGroupAdd',
				'optgroup_remove' : 'onOptionGroupRemove',
				'optgroup_clear'  : 'onOptionGroupClear',
				'dropdown_open'   : 'onDropdownOpen',
				'dropdown_close'  : 'onDropdownClose',
				'type'            : 'onType',
				'load'            : 'onLoad',
				'focus'           : 'onFocus',
				'blur'            : 'onBlur'
			};
	
			for (key in callbacks) {
				if (callbacks.hasOwnProperty(key)) {
					fn = this.settings[callbacks[key]];
					if (fn) this.on(key, fn);
				}
			}
		},
	
		/**
		 * Triggered when the main control element
		 * has a click event.
		 *
		 * @param {object} e
		 * @return {boolean}
		 */
		onClick: function(e) {
			var self = this;
	
			// necessary for mobile webkit devices (manual focus triggering
			// is ignored unless invoked within a click event)
			if (!self.isFocused) {
				self.focus();
				e.preventDefault();
			}
		},
	
		/**
		 * Triggered when the main control element
		 * has a mouse down event.
		 *
		 * @param {object} e
		 * @return {boolean}
		 */
		onMouseDown: function(e) {
			var self = this;
			var defaultPrevented = e.isDefaultPrevented();
			var $target = $(e.target);
	
			if (self.isFocused) {
				// retain focus by preventing native handling. if the
				// event target is the input it should not be modified.
				// otherwise, text selection within the input won't work.
				if (e.target !== self.$control_input[0]) {
					if (self.settings.mode === 'single') {
						// toggle dropdown
						self.isOpen ? self.close() : self.open();
					} else if (!defaultPrevented) {
						self.setActiveItem(null);
					}
					return false;
				}
			} else {
				// give control focus
				if (!defaultPrevented) {
					window.setTimeout(function() {
						self.focus();
					}, 0);
				}
			}
		},
	
		/**
		 * Triggered when the value of the control has been changed.
		 * This should propagate the event to the original DOM
		 * input / select element.
		 */
		onChange: function() {
			this.$input.trigger('change');
		},
	
		/**
		 * Triggered on <input> paste.
		 *
		 * @param {object} e
		 * @returns {boolean}
		 */
		onPaste: function(e) {
			var self = this;
			if (self.isFull() || self.isInputHidden || self.isLocked) {
				e.preventDefault();
			} else {
				// If a regex or string is included, this will split the pasted
				// input and create Items for each separate value
				if (self.settings.splitOn) {
					setTimeout(function() {
						var splitInput = $.trim(self.$control_input.val() || '').split(self.settings.splitOn);
						for (var i = 0, n = splitInput.length; i < n; i++) {
							self.createItem(splitInput[i]);
						}
					}, 0);
				}
			}
		},
	
		/**
		 * Triggered on <input> keypress.
		 *
		 * @param {object} e
		 * @returns {boolean}
		 */
		onKeyPress: function(e) {
			if (this.isLocked) return e && e.preventDefault();
			var character = String.fromCharCode(e.keyCode || e.which);
			if (this.settings.create && this.settings.mode === 'multi' && character === this.settings.delimiter) {
				this.createItem();
				e.preventDefault();
				return false;
			}
		},
	
		/**
		 * Triggered on <input> keydown.
		 *
		 * @param {object} e
		 * @returns {boolean}
		 */
		onKeyDown: function(e) {
			var isInput = e.target === this.$control_input[0];
			var self = this;
	
			if (self.isLocked) {
				if (e.keyCode !== KEY_TAB) {
					e.preventDefault();
				}
				return;
			}
	
			switch (e.keyCode) {
				case KEY_A:
					if (self.isCmdDown) {
						self.selectAll();
						return;
					}
					break;
				case KEY_ESC:
					if (self.isOpen) {
						e.preventDefault();
						e.stopPropagation();
						self.close();
					}
					return;
				case KEY_N:
					if (!e.ctrlKey || e.altKey) break;
				case KEY_DOWN:
					if (!self.isOpen && self.hasOptions) {
						self.open();
					} else if (self.$activeOption) {
						self.ignoreHover = true;
						var $next = self.getAdjacentOption(self.$activeOption, 1);
						if ($next.length) self.setActiveOption($next, true, true);
					}
					e.preventDefault();
					return;
				case KEY_P:
					if (!e.ctrlKey || e.altKey) break;
				case KEY_UP:
					if (self.$activeOption) {
						self.ignoreHover = true;
						var $prev = self.getAdjacentOption(self.$activeOption, -1);
						if ($prev.length) self.setActiveOption($prev, true, true);
					}
					e.preventDefault();
					return;
				case KEY_RETURN:
					if (self.isOpen && self.$activeOption) {
						self.onOptionSelect({currentTarget: self.$activeOption});
						e.preventDefault();
					}
					return;
				case KEY_LEFT:
					self.advanceSelection(-1, e);
					return;
				case KEY_RIGHT:
					self.advanceSelection(1, e);
					return;
				case KEY_TAB:
					if (self.settings.selectOnTab && self.isOpen && self.$activeOption) {
						self.onOptionSelect({currentTarget: self.$activeOption});
	
						// Default behaviour is to jump to the next field, we only want this
						// if the current field doesn't accept any more entries
						if (!self.isFull()) {
							e.preventDefault();
						}
					}
					if (self.settings.create && self.createItem()) {
						e.preventDefault();
					}
					return;
				case KEY_BACKSPACE:
				case KEY_DELETE:
					self.deleteSelection(e);
					return;
			}
	
			if ((self.isFull() || self.isInputHidden) && !(IS_MAC ? e.metaKey : e.ctrlKey)) {
				e.preventDefault();
				return;
			}
		},
	
		/**
		 * Triggered on <input> keyup.
		 *
		 * @param {object} e
		 * @returns {boolean}
		 */
		onKeyUp: function(e) {
			var self = this;
	
			if (self.isLocked) return e && e.preventDefault();
			var value = self.$control_input.val() || '';
			if (self.lastValue !== value) {
				self.lastValue = value;
				self.onSearchChange(value);
				self.refreshOptions();
				self.trigger('type', value);
			}
		},
	
		/**
		 * Invokes the user-provide option provider / loader.
		 *
		 * Note: this function is debounced in the Selectize
		 * constructor (by `settings.loadDelay` milliseconds)
		 *
		 * @param {string} value
		 */
		onSearchChange: function(value) {
			var self = this;
			var fn = self.settings.load;
			if (!fn) return;
			if (self.loadedSearches.hasOwnProperty(value)) return;
			self.loadedSearches[value] = true;
			self.load(function(callback) {
				fn.apply(self, [value, callback]);
			});
		},
	
		/**
		 * Triggered on <input> focus.
		 *
		 * @param {object} e (optional)
		 * @returns {boolean}
		 */
		onFocus: function(e) {
			var self = this;
			var wasFocused = self.isFocused;
	
			if (self.isDisabled) {
				self.blur();
				e && e.preventDefault();
				return false;
			}
	
			if (self.ignoreFocus) return;
			self.isFocused = true;
			if (self.settings.preload === 'focus') self.onSearchChange('');
	
			if (!wasFocused) self.trigger('focus');
	
			if (!self.$activeItems.length) {
				self.showInput();
				self.setActiveItem(null);
				self.refreshOptions(!!self.settings.openOnFocus);
			}
	
			self.refreshState();
		},
	
		/**
		 * Triggered on <input> blur.
		 *
		 * @param {object} e
		 * @param {Element} dest
		 */
		onBlur: function(e, dest) {
			var self = this;
			if (!self.isFocused) return;
			self.isFocused = false;
	
			if (self.ignoreFocus) {
				return;
			} else if (!self.ignoreBlur && document.activeElement === self.$dropdown_content[0]) {
				// necessary to prevent IE closing the dropdown when the scrollbar is clicked
				self.ignoreBlur = true;
				self.onFocus(e);
				return;
			}
	
			var deactivate = function() {
				self.close();
				self.setTextboxValue('');
				self.setActiveItem(null);
				self.setActiveOption(null);
				self.setCaret(self.items.length);
				self.refreshState();
	
				// IE11 bug: element still marked as active
				(dest || document.body).focus();
	
				self.ignoreFocus = false;
				self.trigger('blur');
			};
	
			self.ignoreFocus = true;
			if (self.settings.create && self.settings.createOnBlur) {
				self.createItem(null, false, deactivate);
			} else {
				deactivate();
			}
		},
	
		/**
		 * Triggered when the user rolls over
		 * an option in the autocomplete dropdown menu.
		 *
		 * @param {object} e
		 * @returns {boolean}
		 */
		onOptionHover: function(e) {
			if (this.ignoreHover) return;
			this.setActiveOption(e.currentTarget, false);
		},
	
		/**
		 * Triggered when the user clicks on an option
		 * in the autocomplete dropdown menu.
		 *
		 * @param {object} e
		 * @returns {boolean}
		 */
		onOptionSelect: function(e) {
			var value, $target, $option, self = this;
	
			if (e.preventDefault) {
				e.preventDefault();
				e.stopPropagation();
			}
	
			$target = $(e.currentTarget);
			if ($target.hasClass('create')) {
				self.createItem(null, function() {
					if (self.settings.closeAfterSelect) {
						self.close();
					}
				});
			} else {
				value = $target.attr('data-value');
				if (typeof value !== 'undefined') {
					self.lastQuery = null;
					self.setTextboxValue('');
					self.addItem(value);
					if (self.settings.closeAfterSelect) {
						self.close();
					} else if (!self.settings.hideSelected && e.type && /mouse/.test(e.type)) {
						self.setActiveOption(self.getOption(value));
					}
				}
			}
		},
	
		/**
		 * Triggered when the user clicks on an item
		 * that has been selected.
		 *
		 * @param {object} e
		 * @returns {boolean}
		 */
		onItemSelect: function(e) {
			var self = this;
	
			if (self.isLocked) return;
			if (self.settings.mode === 'multi') {
				e.preventDefault();
				self.setActiveItem(e.currentTarget, e);
			}
		},
	
		/**
		 * Invokes the provided method that provides
		 * results to a callback---which are then added
		 * as options to the control.
		 *
		 * @param {function} fn
		 */
		load: function(fn) {
			var self = this;
			var $wrapper = self.$wrapper.addClass(self.settings.loadingClass);
	
			self.loading++;
			fn.apply(self, [function(results) {
				self.loading = Math.max(self.loading - 1, 0);
				if (results && results.length) {
					self.addOption(results);
					self.refreshOptions(self.isFocused && !self.isInputHidden);
				}
				if (!self.loading) {
					$wrapper.removeClass(self.settings.loadingClass);
				}
				self.trigger('load', results);
			}]);
		},
	
		/**
		 * Sets the input field of the control to the specified value.
		 *
		 * @param {string} value
		 */
		setTextboxValue: function(value) {
			var $input = this.$control_input;
			var changed = $input.val() !== value;
			if (changed) {
				$input.val(value).triggerHandler('update');
				this.lastValue = value;
			}
		},
	
		/**
		 * Returns the value of the control. If multiple items
		 * can be selected (e.g. <select multiple>), this returns
		 * an array. If only one item can be selected, this
		 * returns a string.
		 *
		 * @returns {mixed}
		 */
		getValue: function() {
			if (this.tagType === TAG_SELECT && this.$input.attr('multiple')) {
				return this.items;
			} else {
				return this.items.join(this.settings.delimiter);
			}
		},
	
		/**
		 * Resets the selected items to the given value.
		 *
		 * @param {mixed} value
		 */
		setValue: function(value, silent) {
			var events = silent ? [] : ['change'];
	
			debounce_events(this, events, function() {
				this.clear(silent);
				this.addItems(value, silent);
			});
		},
	
		/**
		 * Sets the selected item.
		 *
		 * @param {object} $item
		 * @param {object} e (optional)
		 */
		setActiveItem: function($item, e) {
			var self = this;
			var eventName;
			var i, idx, begin, end, item, swap;
			var $last;
	
			if (self.settings.mode === 'single') return;
			$item = $($item);
	
			// clear the active selection
			if (!$item.length) {
				$(self.$activeItems).removeClass('active');
				self.$activeItems = [];
				if (self.isFocused) {
					self.showInput();
				}
				return;
			}
	
			// modify selection
			eventName = e && e.type.toLowerCase();
	
			if (eventName === 'mousedown' && self.isShiftDown && self.$activeItems.length) {
				$last = self.$control.children('.active:last');
				begin = Array.prototype.indexOf.apply(self.$control[0].childNodes, [$last[0]]);
				end   = Array.prototype.indexOf.apply(self.$control[0].childNodes, [$item[0]]);
				if (begin > end) {
					swap  = begin;
					begin = end;
					end   = swap;
				}
				for (i = begin; i <= end; i++) {
					item = self.$control[0].childNodes[i];
					if (self.$activeItems.indexOf(item) === -1) {
						$(item).addClass('active');
						self.$activeItems.push(item);
					}
				}
				e.preventDefault();
			} else if ((eventName === 'mousedown' && self.isCtrlDown) || (eventName === 'keydown' && this.isShiftDown)) {
				if ($item.hasClass('active')) {
					idx = self.$activeItems.indexOf($item[0]);
					self.$activeItems.splice(idx, 1);
					$item.removeClass('active');
				} else {
					self.$activeItems.push($item.addClass('active')[0]);
				}
			} else {
				$(self.$activeItems).removeClass('active');
				self.$activeItems = [$item.addClass('active')[0]];
			}
	
			// ensure control has focus
			self.hideInput();
			if (!this.isFocused) {
				self.focus();
			}
		},
	
		/**
		 * Sets the selected item in the dropdown menu
		 * of available options.
		 *
		 * @param {object} $object
		 * @param {boolean} scroll
		 * @param {boolean} animate
		 */
		setActiveOption: function($option, scroll, animate) {
			var height_menu, height_item, y;
			var scroll_top, scroll_bottom;
			var self = this;
	
			if (self.$activeOption) self.$activeOption.removeClass('active');
			self.$activeOption = null;
	
			$option = $($option);
			if (!$option.length) return;
	
			self.$activeOption = $option.addClass('active');
	
			if (scroll || !isset(scroll)) {
	
				height_menu   = self.$dropdown_content.height();
				height_item   = self.$activeOption.outerHeight(true);
				scroll        = self.$dropdown_content.scrollTop() || 0;
				y             = self.$activeOption.offset().top - self.$dropdown_content.offset().top + scroll;
				scroll_top    = y;
				scroll_bottom = y - height_menu + height_item;
	
				if (y + height_item > height_menu + scroll) {
					self.$dropdown_content.stop().animate({scrollTop: scroll_bottom}, animate ? self.settings.scrollDuration : 0);
				} else if (y < scroll) {
					self.$dropdown_content.stop().animate({scrollTop: scroll_top}, animate ? self.settings.scrollDuration : 0);
				}
	
			}
		},
	
		/**
		 * Selects all items (CTRL + A).
		 */
		selectAll: function() {
			var self = this;
			if (self.settings.mode === 'single') return;
	
			self.$activeItems = Array.prototype.slice.apply(self.$control.children(':not(input)').addClass('active'));
			if (self.$activeItems.length) {
				self.hideInput();
				self.close();
			}
			self.focus();
		},
	
		/**
		 * Hides the input element out of view, while
		 * retaining its focus.
		 */
		hideInput: function() {
			var self = this;
	
			self.setTextboxValue('');
			self.$control_input.css({opacity: 0, position: 'absolute', left: self.rtl ? 10000 : -10000});
			self.isInputHidden = true;
		},
	
		/**
		 * Restores input visibility.
		 */
		showInput: function() {
			this.$control_input.css({opacity: 1, position: 'relative', left: 0});
			this.isInputHidden = false;
		},
	
		/**
		 * Gives the control focus.
		 */
		focus: function() {
			var self = this;
			if (self.isDisabled) return;
	
			self.ignoreFocus = true;
			self.$control_input[0].focus();
			window.setTimeout(function() {
				self.ignoreFocus = false;
				self.onFocus();
			}, 0);
		},
	
		/**
		 * Forces the control out of focus.
		 *
		 * @param {Element} dest
		 */
		blur: function(dest) {
			this.$control_input[0].blur();
			this.onBlur(null, dest);
		},
	
		/**
		 * Returns a function that scores an object
		 * to show how good of a match it is to the
		 * provided query.
		 *
		 * @param {string} query
		 * @param {object} options
		 * @return {function}
		 */
		getScoreFunction: function(query) {
			return this.sifter.getScoreFunction(query, this.getSearchOptions());
		},
	
		/**
		 * Returns search options for sifter (the system
		 * for scoring and sorting results).
		 *
		 * @see https://github.com/brianreavis/sifter.js
		 * @return {object}
		 */
		getSearchOptions: function() {
			var settings = this.settings;
			var sort = settings.sortField;
			if (typeof sort === 'string') {
				sort = [{field: sort}];
			}
	
			return {
				fields      : settings.searchField,
				conjunction : settings.searchConjunction,
				sort        : sort
			};
		},
	
		/**
		 * Searches through available options and returns
		 * a sorted array of matches.
		 *
		 * Returns an object containing:
		 *
		 *   - query {string}
		 *   - tokens {array}
		 *   - total {int}
		 *   - items {array}
		 *
		 * @param {string} query
		 * @returns {object}
		 */
		search: function(query) {
			var i, value, score, result, calculateScore;
			var self     = this;
			var settings = self.settings;
			var options  = this.getSearchOptions();
	
			// validate user-provided result scoring function
			if (settings.score) {
				calculateScore = self.settings.score.apply(this, [query]);
				if (typeof calculateScore !== 'function') {
					throw new Error('Selectize "score" setting must be a function that returns a function');
				}
			}
	
			// perform search
			if (query !== self.lastQuery) {
				self.lastQuery = query;
				result = self.sifter.search(query, $.extend(options, {score: calculateScore}));
				self.currentResults = result;
			} else {
				result = $.extend(true, {}, self.currentResults);
			}
	
			// filter out selected items
			if (settings.hideSelected) {
				for (i = result.items.length - 1; i >= 0; i--) {
					if (self.items.indexOf(hash_key(result.items[i].id)) !== -1) {
						result.items.splice(i, 1);
					}
				}
			}
	
			return result;
		},
	
		/**
		 * Refreshes the list of available options shown
		 * in the autocomplete dropdown menu.
		 *
		 * @param {boolean} triggerDropdown
		 */
		refreshOptions: function(triggerDropdown) {
			var i, j, k, n, groups, groups_order, option, option_html, optgroup, optgroups, html, html_children, has_create_option;
			var $active, $active_before, $create;
	
			if (typeof triggerDropdown === 'undefined') {
				triggerDropdown = true;
			}
	
			var self              = this;
			var query             = $.trim(self.$control_input.val());
			var results           = self.search(query);
			var $dropdown_content = self.$dropdown_content;
			var active_before     = self.$activeOption && hash_key(self.$activeOption.attr('data-value'));
	
			// build markup
			n = results.items.length;
			if (typeof self.settings.maxOptions === 'number') {
				n = Math.min(n, self.settings.maxOptions);
			}
	
			// render and group available options individually
			groups = {};
			groups_order = [];
	
			for (i = 0; i < n; i++) {
				option      = self.options[results.items[i].id];
				option_html = self.render('option', option);
				optgroup    = option[self.settings.optgroupField] || '';
				optgroups   = $.isArray(optgroup) ? optgroup : [optgroup];
	
				for (j = 0, k = optgroups && optgroups.length; j < k; j++) {
					optgroup = optgroups[j];
					if (!self.optgroups.hasOwnProperty(optgroup)) {
						optgroup = '';
					}
					if (!groups.hasOwnProperty(optgroup)) {
						groups[optgroup] = [];
						groups_order.push(optgroup);
					}
					groups[optgroup].push(option_html);
				}
			}
	
			// sort optgroups
			if (this.settings.lockOptgroupOrder) {
				groups_order.sort(function(a, b) {
					var a_order = self.optgroups[a].$order || 0;
					var b_order = self.optgroups[b].$order || 0;
					return a_order - b_order;
				});
			}
	
			// render optgroup headers & join groups
			html = [];
			for (i = 0, n = groups_order.length; i < n; i++) {
				optgroup = groups_order[i];
				if (self.optgroups.hasOwnProperty(optgroup) && groups[optgroup].length) {
					// render the optgroup header and options within it,
					// then pass it to the wrapper template
					html_children = self.render('optgroup_header', self.optgroups[optgroup]) || '';
					html_children += groups[optgroup].join('');
					html.push(self.render('optgroup', $.extend({}, self.optgroups[optgroup], {
						html: html_children
					})));
				} else {
					html.push(groups[optgroup].join(''));
				}
			}
	
			$dropdown_content.html(html.join(''));
	
			// highlight matching terms inline
			if (self.settings.highlight && results.query.length && results.tokens.length) {
				for (i = 0, n = results.tokens.length; i < n; i++) {
					highlight($dropdown_content, results.tokens[i].regex);
				}
			}
	
			// add "selected" class to selected options
			if (!self.settings.hideSelected) {
				for (i = 0, n = self.items.length; i < n; i++) {
					self.getOption(self.items[i]).addClass('selected');
				}
			}
	
			// add create option
			has_create_option = self.canCreate(query);
			if (has_create_option) {
				$dropdown_content.prepend(self.render('option_create', {input: query}));
				$create = $($dropdown_content[0].childNodes[0]);
			}
	
			// activate
			self.hasOptions = results.items.length > 0 || has_create_option;
			if (self.hasOptions) {
				if (results.items.length > 0) {
					$active_before = active_before && self.getOption(active_before);
					if ($active_before && $active_before.length) {
						$active = $active_before;
					} else if (self.settings.mode === 'single' && self.items.length) {
						$active = self.getOption(self.items[0]);
					}
					if (!$active || !$active.length) {
						if ($create && !self.settings.addPrecedence) {
							$active = self.getAdjacentOption($create, 1);
						} else {
							$active = $dropdown_content.find('[data-selectable]:first');
						}
					}
				} else {
					$active = $create;
				}
				self.setActiveOption($active);
				if (triggerDropdown && !self.isOpen) { self.open(); }
			} else {
				self.setActiveOption(null);
				if (triggerDropdown && self.isOpen) { self.close(); }
			}
		},
	
		/**
		 * Adds an available option. If it already exists,
		 * nothing will happen. Note: this does not refresh
		 * the options list dropdown (use `refreshOptions`
		 * for that).
		 *
		 * Usage:
		 *
		 *   this.addOption(data)
		 *
		 * @param {object|array} data
		 */
		addOption: function(data) {
			var i, n, value, self = this;
	
			if ($.isArray(data)) {
				for (i = 0, n = data.length; i < n; i++) {
					self.addOption(data[i]);
				}
				return;
			}
	
			if (value = self.registerOption(data)) {
				self.userOptions[value] = true;
				self.lastQuery = null;
				self.trigger('option_add', value, data);
			}
		},
	
		/**
		 * Registers an option to the pool of options.
		 *
		 * @param {object} data
		 * @return {boolean|string}
		 */
		registerOption: function(data) {
			var key = hash_key(data[this.settings.valueField]);
			if (!key || this.options.hasOwnProperty(key)) return false;
			data.$order = data.$order || ++this.order;
			this.options[key] = data;
			return key;
		},
	
		/**
		 * Registers an option group to the pool of option groups.
		 *
		 * @param {object} data
		 * @return {boolean|string}
		 */
		registerOptionGroup: function(data) {
			var key = hash_key(data[this.settings.optgroupValueField]);
			if (!key) return false;
	
			data.$order = data.$order || ++this.order;
			this.optgroups[key] = data;
			return key;
		},
	
		/**
		 * Registers a new optgroup for options
		 * to be bucketed into.
		 *
		 * @param {string} id
		 * @param {object} data
		 */
		addOptionGroup: function(id, data) {
			data[this.settings.optgroupValueField] = id;
			if (id = this.registerOptionGroup(data)) {
				this.trigger('optgroup_add', id, data);
			}
		},
	
		/**
		 * Removes an existing option group.
		 *
		 * @param {string} id
		 */
		removeOptionGroup: function(id) {
			if (this.optgroups.hasOwnProperty(id)) {
				delete this.optgroups[id];
				this.renderCache = {};
				this.trigger('optgroup_remove', id);
			}
		},
	
		/**
		 * Clears all existing option groups.
		 */
		clearOptionGroups: function() {
			this.optgroups = {};
			this.renderCache = {};
			this.trigger('optgroup_clear');
		},
	
		/**
		 * Updates an option available for selection. If
		 * it is visible in the selected items or options
		 * dropdown, it will be re-rendered automatically.
		 *
		 * @param {string} value
		 * @param {object} data
		 */
		updateOption: function(value, data) {
			var self = this;
			var $item, $item_new;
			var value_new, index_item, cache_items, cache_options, order_old;
	
			value     = hash_key(value);
			value_new = hash_key(data[self.settings.valueField]);
	
			// sanity checks
			if (value === null) return;
			if (!self.options.hasOwnProperty(value)) return;
			if (typeof value_new !== 'string') throw new Error('Value must be set in option data');
	
			order_old = self.options[value].$order;
	
			// update references
			if (value_new !== value) {
				delete self.options[value];
				index_item = self.items.indexOf(value);
				if (index_item !== -1) {
					self.items.splice(index_item, 1, value_new);
				}
			}
			data.$order = data.$order || order_old;
			self.options[value_new] = data;
	
			// invalidate render cache
			cache_items = self.renderCache['item'];
			cache_options = self.renderCache['option'];
	
			if (cache_items) {
				delete cache_items[value];
				delete cache_items[value_new];
			}
			if (cache_options) {
				delete cache_options[value];
				delete cache_options[value_new];
			}
	
			// update the item if it's selected
			if (self.items.indexOf(value_new) !== -1) {
				$item = self.getItem(value);
				$item_new = $(self.render('item', data));
				if ($item.hasClass('active')) $item_new.addClass('active');
				$item.replaceWith($item_new);
			}
	
			// invalidate last query because we might have updated the sortField
			self.lastQuery = null;
	
			// update dropdown contents
			if (self.isOpen) {
				self.refreshOptions(false);
			}
		},
	
		/**
		 * Removes a single option.
		 *
		 * @param {string} value
		 * @param {boolean} silent
		 */
		removeOption: function(value, silent) {
			var self = this;
			value = hash_key(value);
	
			var cache_items = self.renderCache['item'];
			var cache_options = self.renderCache['option'];
			if (cache_items) delete cache_items[value];
			if (cache_options) delete cache_options[value];
	
			delete self.userOptions[value];
			delete self.options[value];
			self.lastQuery = null;
			self.trigger('option_remove', value);
			self.removeItem(value, silent);
		},
	
		/**
		 * Clears all options.
		 */
		clearOptions: function() {
			var self = this;
	
			self.loadedSearches = {};
			self.userOptions = {};
			self.renderCache = {};
			self.options = self.sifter.items = {};
			self.lastQuery = null;
			self.trigger('option_clear');
			self.clear();
		},
	
		/**
		 * Returns the jQuery element of the option
		 * matching the given value.
		 *
		 * @param {string} value
		 * @returns {object}
		 */
		getOption: function(value) {
			return this.getElementWithValue(value, this.$dropdown_content.find('[data-selectable]'));
		},
	
		/**
		 * Returns the jQuery element of the next or
		 * previous selectable option.
		 *
		 * @param {object} $option
		 * @param {int} direction  can be 1 for next or -1 for previous
		 * @return {object}
		 */
		getAdjacentOption: function($option, direction) {
			var $options = this.$dropdown.find('[data-selectable]');
			var index    = $options.index($option) + direction;
	
			return index >= 0 && index < $options.length ? $options.eq(index) : $();
		},
	
		/**
		 * Finds the first element with a "data-value" attribute
		 * that matches the given value.
		 *
		 * @param {mixed} value
		 * @param {object} $els
		 * @return {object}
		 */
		getElementWithValue: function(value, $els) {
			value = hash_key(value);
	
			if (typeof value !== 'undefined' && value !== null) {
				for (var i = 0, n = $els.length; i < n; i++) {
					if ($els[i].getAttribute('data-value') === value) {
						return $($els[i]);
					}
				}
			}
	
			return $();
		},
	
		/**
		 * Returns the jQuery element of the item
		 * matching the given value.
		 *
		 * @param {string} value
		 * @returns {object}
		 */
		getItem: function(value) {
			return this.getElementWithValue(value, this.$control.children());
		},
	
		/**
		 * "Selects" multiple items at once. Adds them to the list
		 * at the current caret position.
		 *
		 * @param {string} value
		 * @param {boolean} silent
		 */
		addItems: function(values, silent) {
			var items = $.isArray(values) ? values : [values];
			for (var i = 0, n = items.length; i < n; i++) {
				this.isPending = (i < n - 1);
				this.addItem(items[i], silent);
			}
		},
	
		/**
		 * "Selects" an item. Adds it to the list
		 * at the current caret position.
		 *
		 * @param {string} value
		 * @param {boolean} silent
		 */
		addItem: function(value, silent) {
			var events = silent ? [] : ['change'];
	
			debounce_events(this, events, function() {
				var $item, $option, $options;
				var self = this;
				var inputMode = self.settings.mode;
				var i, active, value_next, wasFull;
				value = hash_key(value);
	
				if (self.items.indexOf(value) !== -1) {
					if (inputMode === 'single') self.close();
					return;
				}
	
				if (!self.options.hasOwnProperty(value)) return;
				if (inputMode === 'single') self.clear(silent);
				if (inputMode === 'multi' && self.isFull()) return;
	
				$item = $(self.render('item', self.options[value]));
				wasFull = self.isFull();
				self.items.splice(self.caretPos, 0, value);
				self.insertAtCaret($item);
				if (!self.isPending || (!wasFull && self.isFull())) {
					self.refreshState();
				}
	
				if (self.isSetup) {
					$options = self.$dropdown_content.find('[data-selectable]');
	
					// update menu / remove the option (if this is not one item being added as part of series)
					if (!self.isPending) {
						$option = self.getOption(value);
						value_next = self.getAdjacentOption($option, 1).attr('data-value');
						self.refreshOptions(self.isFocused && inputMode !== 'single');
						if (value_next) {
							self.setActiveOption(self.getOption(value_next));
						}
					}
	
					// hide the menu if the maximum number of items have been selected or no options are left
					if (!$options.length || self.isFull()) {
						self.close();
					} else {
						self.positionDropdown();
					}
	
					self.updatePlaceholder();
					self.trigger('item_add', value, $item);
					self.updateOriginalInput({silent: silent});
				}
			});
		},
	
		/**
		 * Removes the selected item matching
		 * the provided value.
		 *
		 * @param {string} value
		 */
		removeItem: function(value, silent) {
			var self = this;
			var $item, i, idx;
	
			$item = (typeof value === 'object') ? value : self.getItem(value);
			value = hash_key($item.attr('data-value'));
			i = self.items.indexOf(value);
	
			if (i !== -1) {
				$item.remove();
				if ($item.hasClass('active')) {
					idx = self.$activeItems.indexOf($item[0]);
					self.$activeItems.splice(idx, 1);
				}
	
				self.items.splice(i, 1);
				self.lastQuery = null;
				if (!self.settings.persist && self.userOptions.hasOwnProperty(value)) {
					self.removeOption(value, silent);
				}
	
				if (i < self.caretPos) {
					self.setCaret(self.caretPos - 1);
				}
	
				self.refreshState();
				self.updatePlaceholder();
				self.updateOriginalInput({silent: silent});
				self.positionDropdown();
				self.trigger('item_remove', value, $item);
			}
		},
	
		/**
		 * Invokes the `create` method provided in the
		 * selectize options that should provide the data
		 * for the new item, given the user input.
		 *
		 * Once this completes, it will be added
		 * to the item list.
		 *
		 * @param {string} value
		 * @param {boolean} [triggerDropdown]
		 * @param {function} [callback]
		 * @return {boolean}
		 */
		createItem: function(input, triggerDropdown) {
			var self  = this;
			var caret = self.caretPos;
			input = input || $.trim(self.$control_input.val() || '');
	
			var callback = arguments[arguments.length - 1];
			if (typeof callback !== 'function') callback = function() {};
	
			if (typeof triggerDropdown !== 'boolean') {
				triggerDropdown = true;
			}
	
			if (!self.canCreate(input)) {
				callback();
				return false;
			}
	
			self.lock();
	
			var setup = (typeof self.settings.create === 'function') ? this.settings.create : function(input) {
				var data = {};
				data[self.settings.labelField] = input;
				data[self.settings.valueField] = input;
				return data;
			};
	
			var create = once(function(data) {
				self.unlock();
	
				if (!data || typeof data !== 'object') return callback();
				var value = hash_key(data[self.settings.valueField]);
				if (typeof value !== 'string') return callback();
	
				self.setTextboxValue('');
				self.addOption(data);
				self.setCaret(caret);
				self.addItem(value);
				self.refreshOptions(triggerDropdown && self.settings.mode !== 'single');
				callback(data);
			});
	
			var output = setup.apply(this, [input, create]);
			if (typeof output !== 'undefined') {
				create(output);
			}
	
			return true;
		},
	
		/**
		 * Re-renders the selected item lists.
		 */
		refreshItems: function() {
			this.lastQuery = null;
	
			if (this.isSetup) {
				this.addItem(this.items);
			}
	
			this.refreshState();
			this.updateOriginalInput();
		},
	
		/**
		 * Updates all state-dependent attributes
		 * and CSS classes.
		 */
		refreshState: function() {
			var invalid, self = this;
			if (self.isRequired) {
				if (self.items.length) self.isInvalid = false;
				self.$control_input.prop('required', invalid);
			}
			self.refreshClasses();
		},
	
		/**
		 * Updates all state-dependent CSS classes.
		 */
		refreshClasses: function() {
			var self     = this;
			var isFull   = self.isFull();
			var isLocked = self.isLocked;
	
			self.$wrapper
				.toggleClass('rtl', self.rtl);
	
			self.$control
				.toggleClass('focus', self.isFocused)
				.toggleClass('disabled', self.isDisabled)
				.toggleClass('required', self.isRequired)
				.toggleClass('invalid', self.isInvalid)
				.toggleClass('locked', isLocked)
				.toggleClass('full', isFull).toggleClass('not-full', !isFull)
				.toggleClass('input-active', self.isFocused && !self.isInputHidden)
				.toggleClass('dropdown-active', self.isOpen)
				.toggleClass('has-options', !$.isEmptyObject(self.options))
				.toggleClass('has-items', self.items.length > 0);
	
			self.$control_input.data('grow', !isFull && !isLocked);
		},
	
		/**
		 * Determines whether or not more items can be added
		 * to the control without exceeding the user-defined maximum.
		 *
		 * @returns {boolean}
		 */
		isFull: function() {
			return this.settings.maxItems !== null && this.items.length >= this.settings.maxItems;
		},
	
		/**
		 * Refreshes the original <select> or <input>
		 * element to reflect the current state.
		 */
		updateOriginalInput: function(opts) {
			var i, n, options, label, self = this;
			opts = opts || {};
	
			if (self.tagType === TAG_SELECT) {
				options = [];
				for (i = 0, n = self.items.length; i < n; i++) {
					label = self.options[self.items[i]][self.settings.labelField] || '';
					options.push('<option value="' + escape_html(self.items[i]) + '" selected="selected">' + escape_html(label) + '</option>');
				}
				if (!options.length && !this.$input.attr('multiple')) {
					options.push('<option value="" selected="selected"></option>');
				}
				self.$input.html(options.join(''));
			} else {
				self.$input.val(self.getValue());
				self.$input.attr('value',self.$input.val());
			}
	
			if (self.isSetup) {
				if (!opts.silent) {
					self.trigger('change', self.$input.val());
				}
			}
		},
	
		/**
		 * Shows/hide the input placeholder depending
		 * on if there items in the list already.
		 */
		updatePlaceholder: function() {
			if (!this.settings.placeholder) return;
			var $input = this.$control_input;
	
			if (this.items.length) {
				$input.removeAttr('placeholder');
			} else {
				$input.attr('placeholder', this.settings.placeholder);
			}
			$input.triggerHandler('update', {force: true});
		},
	
		/**
		 * Shows the autocomplete dropdown containing
		 * the available options.
		 */
		open: function() {
			var self = this;
	
			if (self.isLocked || self.isOpen || (self.settings.mode === 'multi' && self.isFull())) return;
			self.focus();
			self.isOpen = true;
			self.refreshState();
			self.$dropdown.css({visibility: 'hidden', display: 'block'});
			self.positionDropdown();
			self.$dropdown.css({visibility: 'visible'});
			self.trigger('dropdown_open', self.$dropdown);
		},
	
		/**
		 * Closes the autocomplete dropdown menu.
		 */
		close: function() {
			var self = this;
			var trigger = self.isOpen;
	
			if (self.settings.mode === 'single' && self.items.length) {
				self.hideInput();
			}
	
			self.isOpen = false;
			self.$dropdown.hide();
			self.setActiveOption(null);
			self.refreshState();
	
			if (trigger) self.trigger('dropdown_close', self.$dropdown);
		},
	
		/**
		 * Calculates and applies the appropriate
		 * position of the dropdown.
		 */
		positionDropdown: function() {
			var $control = this.$control;
			var offset = this.settings.dropdownParent === 'body' ? $control.offset() : $control.position();
			offset.top += $control.outerHeight(true);
	
			this.$dropdown.css({
				width : $control.outerWidth(),
				top   : offset.top,
				left  : offset.left
			});
		},
	
		/**
		 * Resets / clears all selected items
		 * from the control.
		 *
		 * @param {boolean} silent
		 */
		clear: function(silent) {
			var self = this;
	
			if (!self.items.length) return;
			self.$control.children(':not(input)').remove();
			self.items = [];
			self.lastQuery = null;
			self.setCaret(0);
			self.setActiveItem(null);
			self.updatePlaceholder();
			self.updateOriginalInput({silent: silent});
			self.refreshState();
			self.showInput();
			self.trigger('clear');
		},
	
		/**
		 * A helper method for inserting an element
		 * at the current caret position.
		 *
		 * @param {object} $el
		 */
		insertAtCaret: function($el) {
			var caret = Math.min(this.caretPos, this.items.length);
			if (caret === 0) {
				this.$control.prepend($el);
			} else {
				$(this.$control[0].childNodes[caret]).before($el);
			}
			this.setCaret(caret + 1);
		},
	
		/**
		 * Removes the current selected item(s).
		 *
		 * @param {object} e (optional)
		 * @returns {boolean}
		 */
		deleteSelection: function(e) {
			var i, n, direction, selection, values, caret, option_select, $option_select, $tail;
			var self = this;
	
			direction = (e && e.keyCode === KEY_BACKSPACE) ? -1 : 1;
			selection = getSelection(self.$control_input[0]);
	
			if (self.$activeOption && !self.settings.hideSelected) {
				option_select = self.getAdjacentOption(self.$activeOption, -1).attr('data-value');
			}
	
			// determine items that will be removed
			values = [];
	
			if (self.$activeItems.length) {
				$tail = self.$control.children('.active:' + (direction > 0 ? 'last' : 'first'));
				caret = self.$control.children(':not(input)').index($tail);
				if (direction > 0) { caret++; }
	
				for (i = 0, n = self.$activeItems.length; i < n; i++) {
					values.push($(self.$activeItems[i]).attr('data-value'));
				}
				if (e) {
					e.preventDefault();
					e.stopPropagation();
				}
			} else if ((self.isFocused || self.settings.mode === 'single') && self.items.length) {
				if (direction < 0 && selection.start === 0 && selection.length === 0) {
					values.push(self.items[self.caretPos - 1]);
				} else if (direction > 0 && selection.start === self.$control_input.val().length) {
					values.push(self.items[self.caretPos]);
				}
			}
	
			// allow the callback to abort
			if (!values.length || (typeof self.settings.onDelete === 'function' && self.settings.onDelete.apply(self, [values]) === false)) {
				return false;
			}
	
			// perform removal
			if (typeof caret !== 'undefined') {
				self.setCaret(caret);
			}
			while (values.length) {
				self.removeItem(values.pop());
			}
	
			self.showInput();
			self.positionDropdown();
			self.refreshOptions(true);
	
			// select previous option
			if (option_select) {
				$option_select = self.getOption(option_select);
				if ($option_select.length) {
					self.setActiveOption($option_select);
				}
			}
	
			return true;
		},
	
		/**
		 * Selects the previous / next item (depending
		 * on the `direction` argument).
		 *
		 * > 0 - right
		 * < 0 - left
		 *
		 * @param {int} direction
		 * @param {object} e (optional)
		 */
		advanceSelection: function(direction, e) {
			var tail, selection, idx, valueLength, cursorAtEdge, $tail;
			var self = this;
	
			if (direction === 0) return;
			if (self.rtl) direction *= -1;
	
			tail = direction > 0 ? 'last' : 'first';
			selection = getSelection(self.$control_input[0]);
	
			if (self.isFocused && !self.isInputHidden) {
				valueLength = self.$control_input.val().length;
				cursorAtEdge = direction < 0
					? selection.start === 0 && selection.length === 0
					: selection.start === valueLength;
	
				if (cursorAtEdge && !valueLength) {
					self.advanceCaret(direction, e);
				}
			} else {
				$tail = self.$control.children('.active:' + tail);
				if ($tail.length) {
					idx = self.$control.children(':not(input)').index($tail);
					self.setActiveItem(null);
					self.setCaret(direction > 0 ? idx + 1 : idx);
				}
			}
		},
	
		/**
		 * Moves the caret left / right.
		 *
		 * @param {int} direction
		 * @param {object} e (optional)
		 */
		advanceCaret: function(direction, e) {
			var self = this, fn, $adj;
	
			if (direction === 0) return;
	
			fn = direction > 0 ? 'next' : 'prev';
			if (self.isShiftDown) {
				$adj = self.$control_input[fn]();
				if ($adj.length) {
					self.hideInput();
					self.setActiveItem($adj);
					e && e.preventDefault();
				}
			} else {
				self.setCaret(self.caretPos + direction);
			}
		},
	
		/**
		 * Moves the caret to the specified index.
		 *
		 * @param {int} i
		 */
		setCaret: function(i) {
			var self = this;
	
			if (self.settings.mode === 'single') {
				i = self.items.length;
			} else {
				i = Math.max(0, Math.min(self.items.length, i));
			}
	
			if(!self.isPending) {
				// the input must be moved by leaving it in place and moving the
				// siblings, due to the fact that focus cannot be restored once lost
				// on mobile webkit devices
				var j, n, fn, $children, $child;
				$children = self.$control.children(':not(input)');
				for (j = 0, n = $children.length; j < n; j++) {
					$child = $($children[j]).detach();
					if (j <  i) {
						self.$control_input.before($child);
					} else {
						self.$control.append($child);
					}
				}
			}
	
			self.caretPos = i;
		},
	
		/**
		 * Disables user input on the control. Used while
		 * items are being asynchronously created.
		 */
		lock: function() {
			this.close();
			this.isLocked = true;
			this.refreshState();
		},
	
		/**
		 * Re-enables user input on the control.
		 */
		unlock: function() {
			this.isLocked = false;
			this.refreshState();
		},
	
		/**
		 * Disables user input on the control completely.
		 * While disabled, it cannot receive focus.
		 */
		disable: function() {
			var self = this;
			self.$input.prop('disabled', true);
			self.$control_input.prop('disabled', true).prop('tabindex', -1);
			self.isDisabled = true;
			self.lock();
		},
	
		/**
		 * Enables the control so that it can respond
		 * to focus and user input.
		 */
		enable: function() {
			var self = this;
			self.$input.prop('disabled', false);
			self.$control_input.prop('disabled', false).prop('tabindex', self.tabIndex);
			self.isDisabled = false;
			self.unlock();
		},
	
		/**
		 * Completely destroys the control and
		 * unbinds all event listeners so that it can
		 * be garbage collected.
		 */
		destroy: function() {
			var self = this;
			var eventNS = self.eventNS;
			var revertSettings = self.revertSettings;
	
			self.trigger('destroy');
			self.off();
			self.$wrapper.remove();
			self.$dropdown.remove();
	
			self.$input
				.html('')
				.append(revertSettings.$children)
				.removeAttr('tabindex')
				.removeClass('selectized')
				.attr({tabindex: revertSettings.tabindex})
				.show();
	
			self.$control_input.removeData('grow');
			self.$input.removeData('selectize');
	
			$(window).off(eventNS);
			$(document).off(eventNS);
			$(document.body).off(eventNS);
	
			delete self.$input[0].selectize;
		},
	
		/**
		 * A helper method for rendering "item" and
		 * "option" templates, given the data.
		 *
		 * @param {string} templateName
		 * @param {object} data
		 * @returns {string}
		 */
		render: function(templateName, data) {
			var value, id, label;
			var html = '';
			var cache = false;
			var self = this;
			var regex_tag = /^[\t \r\n]*<([a-z][a-z0-9\-_]*(?:\:[a-z][a-z0-9\-_]*)?)/i;
	
			if (templateName === 'option' || templateName === 'item') {
				value = hash_key(data[self.settings.valueField]);
				cache = !!value;
			}
	
			// pull markup from cache if it exists
			if (cache) {
				if (!isset(self.renderCache[templateName])) {
					self.renderCache[templateName] = {};
				}
				if (self.renderCache[templateName].hasOwnProperty(value)) {
					return self.renderCache[templateName][value];
				}
			}
	
			// render markup
			html = self.settings.render[templateName].apply(this, [data, escape_html]);
	
			// add mandatory attributes
			if (templateName === 'option' || templateName === 'option_create') {
				html = html.replace(regex_tag, '<$1 data-selectable');
			}
			if (templateName === 'optgroup') {
				id = data[self.settings.optgroupValueField] || '';
				html = html.replace(regex_tag, '<$1 data-group="' + escape_replace(escape_html(id)) + '"');
			}
			if (templateName === 'option' || templateName === 'item') {
				html = html.replace(regex_tag, '<$1 data-value="' + escape_replace(escape_html(value || '')) + '"');
			}
	
			// update cache
			if (cache) {
				self.renderCache[templateName][value] = html;
			}
	
			return html;
		},
	
		/**
		 * Clears the render cache for a template. If
		 * no template is given, clears all render
		 * caches.
		 *
		 * @param {string} templateName
		 */
		clearCache: function(templateName) {
			var self = this;
			if (typeof templateName === 'undefined') {
				self.renderCache = {};
			} else {
				delete self.renderCache[templateName];
			}
		},
	
		/**
		 * Determines whether or not to display the
		 * create item prompt, given a user input.
		 *
		 * @param {string} input
		 * @return {boolean}
		 */
		canCreate: function(input) {
			var self = this;
			if (!self.settings.create) return false;
			var filter = self.settings.createFilter;
			return input.length
				&& (typeof filter !== 'function' || filter.apply(self, [input]))
				&& (typeof filter !== 'string' || new RegExp(filter).test(input))
				&& (!(filter instanceof RegExp) || filter.test(input));
		}
	
	});
	
	
	Selectize.count = 0;
	Selectize.defaults = {
		options: [],
		optgroups: [],
	
		plugins: [],
		delimiter: ',',
		splitOn: null, // regexp or string for splitting up values from a paste command
		persist: true,
		diacritics: true,
		create: false,
		createOnBlur: false,
		createFilter: null,
		highlight: true,
		openOnFocus: true,
		maxOptions: 1000,
		maxItems: null,
		hideSelected: null,
		addPrecedence: false,
		selectOnTab: false,
		preload: false,
		allowEmptyOption: false,
		closeAfterSelect: false,
	
		scrollDuration: 60,
		loadThrottle: 300,
		loadingClass: 'loading',
	
		dataAttr: 'data-data',
		optgroupField: 'optgroup',
		valueField: 'value',
		labelField: 'text',
		optgroupLabelField: 'label',
		optgroupValueField: 'value',
		lockOptgroupOrder: false,
	
		sortField: '$order',
		searchField: ['text'],
		searchConjunction: 'and',
	
		mode: null,
		wrapperClass: 'selectize-control',
		inputClass: 'selectize-input',
		dropdownClass: 'selectize-dropdown',
		dropdownContentClass: 'selectize-dropdown-content',
	
		dropdownParent: null,
	
		copyClassesToDropdown: true,
	
		/*
		load                 : null, // function(query, callback) { ... }
		score                : null, // function(search) { ... }
		onInitialize         : null, // function() { ... }
		onChange             : null, // function(value) { ... }
		onItemAdd            : null, // function(value, $item) { ... }
		onItemRemove         : null, // function(value) { ... }
		onClear              : null, // function() { ... }
		onOptionAdd          : null, // function(value, data) { ... }
		onOptionRemove       : null, // function(value) { ... }
		onOptionClear        : null, // function() { ... }
		onOptionGroupAdd     : null, // function(id, data) { ... }
		onOptionGroupRemove  : null, // function(id) { ... }
		onOptionGroupClear   : null, // function() { ... }
		onDropdownOpen       : null, // function($dropdown) { ... }
		onDropdownClose      : null, // function($dropdown) { ... }
		onType               : null, // function(str) { ... }
		onDelete             : null, // function(values) { ... }
		*/
	
		render: {
			/*
			item: null,
			optgroup: null,
			optgroup_header: null,
			option: null,
			option_create: null
			*/
		}
	};
	
	
	$.fn.selectize = function(settings_user) {
		var defaults             = $.fn.selectize.defaults;
		var settings             = $.extend({}, defaults, settings_user);
		var attr_data            = settings.dataAttr;
		var field_label          = settings.labelField;
		var field_value          = settings.valueField;
		var field_optgroup       = settings.optgroupField;
		var field_optgroup_label = settings.optgroupLabelField;
		var field_optgroup_value = settings.optgroupValueField;
	
		/**
		 * Initializes selectize from a <input type="text"> element.
		 *
		 * @param {object} $input
		 * @param {object} settings_element
		 */
		var init_textbox = function($input, settings_element) {
			var i, n, values, option;
	
			var data_raw = $input.attr(attr_data);
	
			if (!data_raw) {
				var value = $.trim($input.val() || '');
				if (!settings.allowEmptyOption && !value.length) return;
				values = value.split(settings.delimiter);
				for (i = 0, n = values.length; i < n; i++) {
					option = {};
					option[field_label] = values[i];
					option[field_value] = values[i];
					settings_element.options.push(option);
				}
				settings_element.items = values;
			} else {
				settings_element.options = JSON.parse(data_raw);
				for (i = 0, n = settings_element.options.length; i < n; i++) {
					settings_element.items.push(settings_element.options[i][field_value]);
				}
			}
		};
	
		/**
		 * Initializes selectize from a <select> element.
		 *
		 * @param {object} $input
		 * @param {object} settings_element
		 */
		var init_select = function($input, settings_element) {
			var i, n, tagName, $children, order = 0;
			var options = settings_element.options;
			var optionsMap = {};
	
			var readData = function($el) {
				var data = attr_data && $el.attr(attr_data);
				if (typeof data === 'string' && data.length) {
					return JSON.parse(data);
				}
				return null;
			};
	
			var addOption = function($option, group) {
				$option = $($option);
	
				var value = hash_key($option.attr('value'));
				if (!value && !settings.allowEmptyOption) return;
	
				// if the option already exists, it's probably been
				// duplicated in another optgroup. in this case, push
				// the current group to the "optgroup" property on the
				// existing option so that it's rendered in both places.
				if (optionsMap.hasOwnProperty(value)) {
					if (group) {
						var arr = optionsMap[value][field_optgroup];
						if (!arr) {
							optionsMap[value][field_optgroup] = group;
						} else if (!$.isArray(arr)) {
							optionsMap[value][field_optgroup] = [arr, group];
						} else {
							arr.push(group);
						}
					}
					return;
				}
	
				var option             = readData($option) || {};
				option[field_label]    = option[field_label] || $option.text();
				option[field_value]    = option[field_value] || value;
				option[field_optgroup] = option[field_optgroup] || group;
	
				optionsMap[value] = option;
				options.push(option);
	
				if ($option.is(':selected')) {
					settings_element.items.push(value);
				}
			};
	
			var addGroup = function($optgroup) {
				var i, n, id, optgroup, $options;
	
				$optgroup = $($optgroup);
				id = $optgroup.attr('label');
	
				if (id) {
					optgroup = readData($optgroup) || {};
					optgroup[field_optgroup_label] = id;
					optgroup[field_optgroup_value] = id;
					settings_element.optgroups.push(optgroup);
				}
	
				$options = $('option', $optgroup);
				for (i = 0, n = $options.length; i < n; i++) {
					addOption($options[i], id);
				}
			};
	
			settings_element.maxItems = $input.attr('multiple') ? null : 1;
	
			$children = $input.children();
			for (i = 0, n = $children.length; i < n; i++) {
				tagName = $children[i].tagName.toLowerCase();
				if (tagName === 'optgroup') {
					addGroup($children[i]);
				} else if (tagName === 'option') {
					addOption($children[i]);
				}
			}
		};
	
		return this.each(function() {
			if (this.selectize) return;
	
			var instance;
			var $input = $(this);
			var tag_name = this.tagName.toLowerCase();
			var placeholder = $input.attr('placeholder') || $input.attr('data-placeholder');
			if (!placeholder && !settings.allowEmptyOption) {
				placeholder = $input.children('option[value=""]').text();
			}
	
			var settings_element = {
				'placeholder' : placeholder,
				'options'     : [],
				'optgroups'   : [],
				'items'       : []
			};
	
			if (tag_name === 'select') {
				init_select($input, settings_element);
			} else {
				init_textbox($input, settings_element);
			}
	
			instance = new Selectize($input, $.extend(true, {}, defaults, settings_element, settings_user));
		});
	};
	
	$.fn.selectize.defaults = Selectize.defaults;
	$.fn.selectize.support = {
		validity: SUPPORTS_VALIDITY_API
	};
	
	
	Selectize.define('drag_drop', function(options) {
		if (!$.fn.sortable) throw new Error('The "drag_drop" plugin requires jQuery UI "sortable".');
		if (this.settings.mode !== 'multi') return;
		var self = this;
	
		self.lock = (function() {
			var original = self.lock;
			return function() {
				var sortable = self.$control.data('sortable');
				if (sortable) sortable.disable();
				return original.apply(self, arguments);
			};
		})();
	
		self.unlock = (function() {
			var original = self.unlock;
			return function() {
				var sortable = self.$control.data('sortable');
				if (sortable) sortable.enable();
				return original.apply(self, arguments);
			};
		})();
	
		self.setup = (function() {
			var original = self.setup;
			return function() {
				original.apply(this, arguments);
	
				var $control = self.$control.sortable({
					items: '[data-value]',
					forcePlaceholderSize: true,
					disabled: self.isLocked,
					start: function(e, ui) {
						ui.placeholder.css('width', ui.helper.css('width'));
						$control.css({overflow: 'visible'});
					},
					stop: function() {
						$control.css({overflow: 'hidden'});
						var active = self.$activeItems ? self.$activeItems.slice() : null;
						var values = [];
						$control.children('[data-value]').each(function() {
							values.push($(this).attr('data-value'));
						});
						self.setValue(values);
						self.setActiveItem(active);
					}
				});
			};
		})();
	
	});
	
	Selectize.define('dropdown_header', function(options) {
		var self = this;
	
		options = $.extend({
			title         : 'Untitled',
			headerClass   : 'selectize-dropdown-header',
			titleRowClass : 'selectize-dropdown-header-title',
			labelClass    : 'selectize-dropdown-header-label',
			closeClass    : 'selectize-dropdown-header-close',
	
			html: function(data) {
				return (
					'<div class="' + data.headerClass + '">' +
						'<div class="' + data.titleRowClass + '">' +
							'<span class="' + data.labelClass + '">' + data.title + '</span>' +
							'<a href="javascript:void(0)" class="' + data.closeClass + '">&times;</a>' +
						'</div>' +
					'</div>'
				);
			}
		}, options);
	
		self.setup = (function() {
			var original = self.setup;
			return function() {
				original.apply(self, arguments);
				self.$dropdown_header = $(options.html(options));
				self.$dropdown.prepend(self.$dropdown_header);
			};
		})();
	
	});
	
	Selectize.define('optgroup_columns', function(options) {
		var self = this;
	
		options = $.extend({
			equalizeWidth  : true,
			equalizeHeight : true
		}, options);
	
		this.getAdjacentOption = function($option, direction) {
			var $options = $option.closest('[data-group]').find('[data-selectable]');
			var index    = $options.index($option) + direction;
	
			return index >= 0 && index < $options.length ? $options.eq(index) : $();
		};
	
		this.onKeyDown = (function() {
			var original = self.onKeyDown;
			return function(e) {
				var index, $option, $options, $optgroup;
	
				if (this.isOpen && (e.keyCode === KEY_LEFT || e.keyCode === KEY_RIGHT)) {
					self.ignoreHover = true;
					$optgroup = this.$activeOption.closest('[data-group]');
					index = $optgroup.find('[data-selectable]').index(this.$activeOption);
	
					if(e.keyCode === KEY_LEFT) {
						$optgroup = $optgroup.prev('[data-group]');
					} else {
						$optgroup = $optgroup.next('[data-group]');
					}
	
					$options = $optgroup.find('[data-selectable]');
					$option  = $options.eq(Math.min($options.length - 1, index));
					if ($option.length) {
						this.setActiveOption($option);
					}
					return;
				}
	
				return original.apply(this, arguments);
			};
		})();
	
		var getScrollbarWidth = function() {
			var div;
			var width = getScrollbarWidth.width;
			var doc = document;
	
			if (typeof width === 'undefined') {
				div = doc.createElement('div');
				div.innerHTML = '<div style="width:50px;height:50px;position:absolute;left:-50px;top:-50px;overflow:auto;"><div style="width:1px;height:100px;"></div></div>';
				div = div.firstChild;
				doc.body.appendChild(div);
				width = getScrollbarWidth.width = div.offsetWidth - div.clientWidth;
				doc.body.removeChild(div);
			}
			return width;
		};
	
		var equalizeSizes = function() {
			var i, n, height_max, width, width_last, width_parent, $optgroups;
	
			$optgroups = $('[data-group]', self.$dropdown_content);
			n = $optgroups.length;
			if (!n || !self.$dropdown_content.width()) return;
	
			if (options.equalizeHeight) {
				height_max = 0;
				for (i = 0; i < n; i++) {
					height_max = Math.max(height_max, $optgroups.eq(i).height());
				}
				$optgroups.css({height: height_max});
			}
	
			if (options.equalizeWidth) {
				width_parent = self.$dropdown_content.innerWidth() - getScrollbarWidth();
				width = Math.round(width_parent / n);
				$optgroups.css({width: width});
				if (n > 1) {
					width_last = width_parent - width * (n - 1);
					$optgroups.eq(n - 1).css({width: width_last});
				}
			}
		};
	
		if (options.equalizeHeight || options.equalizeWidth) {
			hook.after(this, 'positionDropdown', equalizeSizes);
			hook.after(this, 'refreshOptions', equalizeSizes);
		}
	
	
	});
	
	Selectize.define('remove_button', function(options) {
		if (this.settings.mode === 'single') return;
	
		options = $.extend({
			label     : '&times;',
			title     : 'Remove',
			className : 'remove',
			append    : true
		}, options);
	
		var self = this;
		var html = '<a href="javascript:void(0)" class="' + options.className + '" tabindex="-1" title="' + escape_html(options.title) + '">' + options.label + '</a>';
	
		/**
		 * Appends an element as a child (with raw HTML).
		 *
		 * @param {string} html_container
		 * @param {string} html_element
		 * @return {string}
		 */
		var append = function(html_container, html_element) {
			var pos = html_container.search(/(<\/[^>]+>\s*)$/);
			return html_container.substring(0, pos) + html_element + html_container.substring(pos);
		};
	
		this.setup = (function() {
			var original = self.setup;
			return function() {
				// override the item rendering method to add the button to each
				if (options.append) {
					var render_item = self.settings.render.item;
					self.settings.render.item = function(data) {
						return append(render_item.apply(this, arguments), html);
					};
				}
	
				original.apply(this, arguments);
	
				// add event listener
				this.$control.on('click', '.' + options.className, function(e) {
					e.preventDefault();
					if (self.isLocked) return;
	
					var $item = $(e.currentTarget).parent();
					self.setActiveItem($item);
					if (self.deleteSelection()) {
						self.setCaret(self.items.length);
					}
				});
	
			};
		})();
	
	});
	
	Selectize.define('restore_on_backspace', function(options) {
		var self = this;
	
		options.text = options.text || function(option) {
			return option[this.settings.labelField];
		};
	
		this.onKeyDown = (function() {
			var original = self.onKeyDown;
			return function(e) {
				var index, option;
				if (e.keyCode === KEY_BACKSPACE && this.$control_input.val() === '' && !this.$activeItems.length) {
					index = this.caretPos - 1;
					if (index >= 0 && index < this.items.length) {
						option = this.options[this.items[index]];
						if (this.deleteSelection(e)) {
							this.setTextboxValue(options.text.apply(this, [option]));
							this.refreshOptions(true);
						}
						e.preventDefault();
						return;
					}
				}
				return original.apply(this, arguments);
			};
		})();
	});
	

	return Selectize;
}));

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/**
 * isMobile.js v0.4.0
 *
 * A simple library to detect Apple phones and tablets,
 * Android phones and tablets, other mobile devices (like blackberry, mini-opera and windows phone),
 * and any kind of seven inch device, via user agent sniffing.
 *
 * @author: Kai Mallea (kmallea@gmail.com)
 *
 * @license: http://creativecommons.org/publicdomain/zero/1.0/
 */
(function (global) {

  var apple_phone = /iPhone/i,
      apple_ipod = /iPod/i,
      apple_tablet = /iPad/i,
      android_phone = /(?=.*\bAndroid\b)(?=.*\bMobile\b)/i,
      // Match 'Android' AND 'Mobile'
  android_tablet = /Android/i,
      amazon_phone = /(?=.*\bAndroid\b)(?=.*\bSD4930UR\b)/i,
      amazon_tablet = /(?=.*\bAndroid\b)(?=.*\b(?:KFOT|KFTT|KFJWI|KFJWA|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|KFARWI|KFASWI|KFSAWI|KFSAWA)\b)/i,
      windows_phone = /IEMobile/i,
      windows_tablet = /(?=.*\bWindows\b)(?=.*\bARM\b)/i,
      // Match 'Windows' AND 'ARM'
  other_blackberry = /BlackBerry/i,
      other_blackberry_10 = /BB10/i,
      other_opera = /Opera Mini/i,
      other_chrome = /(CriOS|Chrome)(?=.*\bMobile\b)/i,
      other_firefox = /(?=.*\bFirefox\b)(?=.*\bMobile\b)/i,
      // Match 'Firefox' AND 'Mobile'
  seven_inch = new RegExp('(?:' + // Non-capturing group

  'Nexus 7' + // Nexus 7

  '|' + // OR

  'BNTV250' + // B&N Nook Tablet 7 inch

  '|' + // OR

  'Kindle Fire' + // Kindle Fire

  '|' + // OR

  'Silk' + // Kindle Fire, Silk Accelerated

  '|' + // OR

  'GT-P1000' + // Galaxy Tab 7 inch

  ')', // End non-capturing group

  'i'); // Case-insensitive matching

  var match = function match(regex, userAgent) {
    return regex.test(userAgent);
  };

  var IsMobileClass = function IsMobileClass(userAgent) {
    var ua = userAgent || navigator.userAgent;

    // Facebook mobile app's integrated browser adds a bunch of strings that
    // match everything. Strip it out if it exists.
    var tmp = ua.split('[FBAN');
    if (typeof tmp[1] !== 'undefined') {
      ua = tmp[0];
    }

    // Twitter mobile app's integrated browser on iPad adds a "Twitter for
    // iPhone" string. Same probable happens on other tablet platforms.
    // This will confuse detection so strip it out if it exists.
    tmp = ua.split('Twitter');
    if (typeof tmp[1] !== 'undefined') {
      ua = tmp[0];
    }

    this.apple = {
      phone: match(apple_phone, ua),
      ipod: match(apple_ipod, ua),
      tablet: !match(apple_phone, ua) && match(apple_tablet, ua),
      device: match(apple_phone, ua) || match(apple_ipod, ua) || match(apple_tablet, ua)
    };
    this.amazon = {
      phone: match(amazon_phone, ua),
      tablet: !match(amazon_phone, ua) && match(amazon_tablet, ua),
      device: match(amazon_phone, ua) || match(amazon_tablet, ua)
    };
    this.android = {
      phone: match(amazon_phone, ua) || match(android_phone, ua),
      tablet: !match(amazon_phone, ua) && !match(android_phone, ua) && (match(amazon_tablet, ua) || match(android_tablet, ua)),
      device: match(amazon_phone, ua) || match(amazon_tablet, ua) || match(android_phone, ua) || match(android_tablet, ua)
    };
    this.windows = {
      phone: match(windows_phone, ua),
      tablet: match(windows_tablet, ua),
      device: match(windows_phone, ua) || match(windows_tablet, ua)
    };
    this.other = {
      blackberry: match(other_blackberry, ua),
      blackberry10: match(other_blackberry_10, ua),
      opera: match(other_opera, ua),
      firefox: match(other_firefox, ua),
      chrome: match(other_chrome, ua),
      device: match(other_blackberry, ua) || match(other_blackberry_10, ua) || match(other_opera, ua) || match(other_firefox, ua) || match(other_chrome, ua)
    };
    this.seven_inch = match(seven_inch, ua);
    this.any = this.apple.device || this.android.device || this.windows.device || this.other.device || this.seven_inch;

    // excludes 'other' devices and ipods, targeting touchscreen phones
    this.phone = this.apple.phone || this.android.phone || this.windows.phone;

    // excludes 7 inch devices, classifying as phone or tablet is left to the user
    this.tablet = this.apple.tablet || this.android.tablet || this.windows.tablet;

    if (typeof window === 'undefined') {
      return this;
    }
  };

  var instantiate = function instantiate() {
    var IM = new IsMobileClass();
    IM.Class = IsMobileClass;
    return IM;
  };

  if (typeof module !== 'undefined' && module.exports && typeof window === 'undefined') {
    //node
    module.exports = IsMobileClass;
  } else if (typeof module !== 'undefined' && module.exports && typeof window !== 'undefined') {
    //browserify
    module.exports = instantiate();
  } else if (true) {
    //AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (global.isMobile = instantiate()),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {
    global.isMobile = instantiate();
  }
})(undefined);

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setValue = exports.getWebComponentInstance = exports.decorateInnerElements = exports.disposeInnerComponents = exports.disposeDecoratedComponent = exports.removeDecoratedReactComponent = exports.decorateElement = exports.connectWebComponents = exports.connectInlineComponents = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // 


var _dataset = __webpack_require__(106);

var _actions = __webpack_require__(408);

var _WebComponent = __webpack_require__(15);

var _WebComponent2 = _interopRequireDefault(_WebComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var store = null;

var connectInlineComponents = exports.connectInlineComponents = function connectInlineComponents(reduxStore) {
  store = reduxStore;
};

var getWebComponent = null;
var decoratedWebComponents = {};

/**
 * Připojí do dekorovacího mechanismu funkci, která rozhodne
 * na jaký element bude použita jaká komponenta
 */
var connectWebComponents = exports.connectWebComponents = function connectWebComponents(configureWebComponents, skipDecorateInnerElements) {
  getWebComponent = configureWebComponents;
  if (!skipDecorateInnerElements) {
    decorateInnerElements(document.body);
  }
};

var webComponentFactory = function webComponentFactory(WebComponentClass, element, props) {
  var webComponent = new WebComponentClass(props);
  element.setAttribute('data-web-component', '');
  var id = element.getAttribute('id');
  if (!id) {
    setTimeout(function () {
      throw new Error('Element na kter\xE9m inicializujete web componentu ' + webComponent.constructor.name + ' nem\xE1 ID attribute. Dopl\u0148te jej.');
    }, 0);
  }
  if (id) {
    decoratedWebComponents[id] = webComponent;
  }
  webComponent.decorate(element);
  return webComponent;
};

var decorateElement = exports.decorateElement = function decorateElement(element, skip) {
  var dataset = _extends({}, (0, _dataset.getDataSet)(element), { decorateSkip_: skip });
  var webComponent = void 0;
  if (getWebComponent) {
    var WebComponentClass = getWebComponent(dataset);
    if (WebComponentClass) {
      webComponent = true;
      var isPromise = typeof WebComponentClass.then === 'function';
      if (isPromise) {
        WebComponentClass.then(function (WebComponentClassAfterPromise) {
          webComponentFactory(WebComponentClassAfterPromise.default, element, dataset);
          return true;
        });
      } else {
        webComponent = webComponentFactory(WebComponentClass, element, dataset);
      }
    }
  }
  if (!webComponent && store) {
    var id = element.getAttribute('id');
    store.dispatch((0, _actions.decorateAdd)(id, dataset, element));
    element.setAttribute('data-react-component', '');
  }
};

var removeDecoratedReactComponent = exports.removeDecoratedReactComponent = function removeDecoratedReactComponent(element) {
  var id = element.getAttribute('id');
  if (store) {
    store.dispatch((0, _actions.decorateRemove)(id));
  }
};

var disposeDecoratedComponent = exports.disposeDecoratedComponent = function disposeDecoratedComponent(element) {
  var id = element.getAttribute('id');
  var hasReactWebComponent = element.getAttribute('data-react-component') != null;
  if (hasReactWebComponent) {
    removeDecoratedReactComponent(element);
  } else {
    var webComponent = decoratedWebComponents[id];
    if (webComponent) {
      webComponent.dispose();
      delete decoratedWebComponents[id];
    }
  }
};

/**
 * Zavolá destruktor na všech komponentách, které jsou nadekorovány uvnitř definovaného elementu
 * Využívá se pokud se z domu maže nějaký element tak, aby bylo zajištěno vyčištění garbage
 * collectoru a odstranění event listenerů spojených s komponentou
 */
var disposeInnerComponents = exports.disposeInnerComponents = function disposeInnerComponents(element, skip) {
  var elements = [].concat(_toConsumableArray(element.querySelectorAll('[data-web-component], [data-react-component]')));
  if (element.getAttribute('data-web-component') != null || element.getAttribute('data-react-component') != null) {
    elements.unshift(element);
  }

  elements.forEach(function (element) {
    if (!(skip && skip.includes(element.id))) {
      disposeDecoratedComponent(element);
    }
  });
};

/**
 * Nadekoruje všechny elementy s data attribteb data-is nebo data-decorator
 * uvnitř contextElementu včetně
 */
var decorateInnerElements = exports.decorateInnerElements = function decorateInnerElements(contextElement, skip) {
  var elements = [].concat(_toConsumableArray(contextElement.querySelectorAll('[data-is], [data-decorator]')));
  if (contextElement.getAttribute('data-is') != null || contextElement.getAttribute('data-decorator') != null) {
    elements.unshift(contextElement);
  }
  elements.forEach(function (element) {
    if (!(skip && skip.includes(element.id))) {
      decorateElement(element, skip);
    }
  });
};

/**
 * Získá instanci komponenty na specifikovaném elementu
 */
var getWebComponentInstance = exports.getWebComponentInstance = function getWebComponentInstance(element) {
  if (element) {
    var id = element.getAttribute('id');
    var hasValidDataAttribute = element.getAttribute('data-web-component') != null;
    var hasValidDataAttributeForReact = element.getAttribute('data-react-component') != null;
    if (hasValidDataAttribute && id) {
      return decoratedWebComponents[id] || null;
    }
    if (hasValidDataAttributeForReact) {
      var componentsState = store.getState()['inlineComponents'];
      return componentsState[id] && componentsState[id].instance && componentsState[id].instance.wrappedComponent ? componentsState[id].instance.wrappedComponent : null;
    }
  }
  return null;
};

var setValue = exports.setValue = function setValue(elementId, value, arrayLike) {
  if (arrayLike) {
    value = value == null ? [] : Array.isArray(value) ? value.map(function (value) {
      return value.toString();
    }) : [value.toString()];
  }
  store.dispatch((0, _actions.decorateSetValue)(elementId, value));
};

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*! https://mths.be/punycode v1.4.0 by @mathias */
;(function (root) {

	/** Detect free variables */
	var freeExports = ( false ? 'undefined' : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;
	var freeModule = ( false ? 'undefined' : _typeof(module)) == 'object' && module && !module.nodeType && module;
	var freeGlobal = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) == 'object' && global;
	if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) {
		root = freeGlobal;
	}

	/**
  * The `punycode` object.
  * @name punycode
  * @type Object
  */
	var punycode,


	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647,
	    // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	    tMin = 1,
	    tMax = 26,
	    skew = 38,
	    damp = 700,
	    initialBias = 72,
	    initialN = 128,
	    // 0x80
	delimiter = '-',
	    // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	    regexNonASCII = /[^\x20-\x7E]/,
	    // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g,
	    // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},


	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	    floor = Math.floor,
	    stringFromCharCode = String.fromCharCode,


	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
  * A generic error utility function.
  * @private
  * @param {String} type The error type.
  * @returns {Error} Throws a `RangeError` with the applicable error message.
  */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
  * A generic `Array#map` utility function.
  * @private
  * @param {Array} array The array to iterate over.
  * @param {Function} callback The function that gets called for every array
  * item.
  * @returns {Array} A new array of values returned by the callback function.
  */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
  * A simple `Array#map`-like wrapper to work with domain name strings or email
  * addresses.
  * @private
  * @param {String} domain The domain name or email address.
  * @param {Function} callback The function that gets called for every
  * character.
  * @returns {Array} A new string of characters returned by the callback
  * function.
  */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
  * Creates an array containing the numeric code points of each Unicode
  * character in the string. While JavaScript uses UCS-2 internally,
  * this function will convert a pair of surrogate halves (each of which
  * UCS-2 exposes as separate characters) into a single code point,
  * matching UTF-16.
  * @see `punycode.ucs2.encode`
  * @see <https://mathiasbynens.be/notes/javascript-encoding>
  * @memberOf punycode.ucs2
  * @name decode
  * @param {String} string The Unicode input string (UCS-2).
  * @returns {Array} The new array of code points.
  */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) {
					// low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
  * Creates a string based on an array of numeric code points.
  * @see `punycode.ucs2.decode`
  * @memberOf punycode.ucs2
  * @name encode
  * @param {Array} codePoints The array of numeric code points.
  * @returns {String} The new Unicode string (UCS-2).
  */
	function ucs2encode(array) {
		return map(array, function (value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
  * Converts a basic code point into a digit/integer.
  * @see `digitToBasic()`
  * @private
  * @param {Number} codePoint The basic numeric code point value.
  * @returns {Number} The numeric value of a basic code point (for use in
  * representing integers) in the range `0` to `base - 1`, or `base` if
  * the code point does not represent a value.
  */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
  * Converts a digit/integer into a basic code point.
  * @see `basicToDigit()`
  * @private
  * @param {Number} digit The numeric value of a basic code point.
  * @returns {Number} The basic code point whose value (when used for
  * representing integers) is `digit`, which needs to be in the range
  * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
  * used; else, the lowercase form is used. The behavior is undefined
  * if `flag` is non-zero and `digit` has no uppercase form.
  */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
  * Bias adaptation function as per section 3.4 of RFC 3492.
  * https://tools.ietf.org/html/rfc3492#section-3.4
  * @private
  */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (; /* no initialization */delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
  * Converts a Punycode string of ASCII-only symbols to a string of Unicode
  * symbols.
  * @memberOf punycode
  * @param {String} input The Punycode string of ASCII-only symbols.
  * @returns {String} The resulting string of Unicode symbols.
  */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,

		/** Cached calculation results */
		baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength;) /* no final expression */{

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base;; /* no condition */k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;
			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);
		}

		return ucs2encode(output);
	}

	/**
  * Converts a string of Unicode symbols (e.g. a domain name label) to a
  * Punycode string of ASCII-only symbols.
  * @memberOf punycode
  * @param {String} input The string of Unicode symbols.
  * @returns {String} The resulting Punycode string of ASCII-only symbols.
  */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],

		/** `inputLength` will hold the number of code points in `input`. */
		inputLength,

		/** Cached calculation results */
		handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base;; /* no condition */k += base) {
						t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;
		}
		return output.join('');
	}

	/**
  * Converts a Punycode string representing a domain name or an email address
  * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
  * it doesn't matter if you call it on a string that has already been
  * converted to Unicode.
  * @memberOf punycode
  * @param {String} input The Punycoded domain name or email address to
  * convert to Unicode.
  * @returns {String} The Unicode representation of the given Punycode
  * string.
  */
	function toUnicode(input) {
		return mapDomain(input, function (string) {
			return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
		});
	}

	/**
  * Converts a Unicode string representing a domain name or an email address to
  * Punycode. Only the non-ASCII parts of the domain name will be converted,
  * i.e. it doesn't matter if you call it with a domain that's already in
  * ASCII.
  * @memberOf punycode
  * @param {String} input The domain name or email address to convert, as a
  * Unicode string.
  * @returns {String} The Punycode representation of the given domain name or
  * email address.
  */
	function toASCII(input) {
		return mapDomain(input, function (string) {
			return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
   * A string representing the current Punycode.js version number.
   * @memberOf punycode
   * @type String
   */
		'version': '1.3.2',
		/**
   * An object of methods to convert from JavaScript's internal character
   * representation (UCS-2) to Unicode code points, and back.
   * @see <https://mathiasbynens.be/notes/javascript-encoding>
   * @memberOf punycode
   * @type Object
   */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if ("function" == 'function' && _typeof(__webpack_require__(154)) == 'object' && __webpack_require__(154)) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return punycode;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}
})(undefined);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58)(module), __webpack_require__(61)))

/***/ }),
/* 154 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * URI.js - Mutating URLs
 * IPv6 Support
 *
 * Version: 1.19.11
 *
 * Author: Rodney Rehm
 * Web: http://medialize.github.io/URI.js/
 *
 * Licensed under
 *   MIT License http://www.opensource.org/licenses/mit-license
 *
 */

(function (root, factory) {
  'use strict';
  // https://github.com/umdjs/umd/blob/master/returnExports.js

  if (( false ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
    // Node
    module.exports = factory();
  } else if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {
    // Browser globals (root is window)
    root.IPv6 = factory(root);
  }
})(undefined, function (root) {
  'use strict';

  /*
  var _in = "fe80:0000:0000:0000:0204:61ff:fe9d:f156";
  var _out = IPv6.best(_in);
  var _expected = "fe80::204:61ff:fe9d:f156";
   console.log(_in, _out, _expected, _out === _expected);
  */

  // save current IPv6 variable, if any

  var _IPv6 = root && root.IPv6;

  function bestPresentation(address) {
    // based on:
    // Javascript to test an IPv6 address for proper format, and to
    // present the "best text representation" according to IETF Draft RFC at
    // http://tools.ietf.org/html/draft-ietf-6man-text-addr-representation-04
    // 8 Feb 2010 Rich Brown, Dartware, LLC
    // Please feel free to use this code as long as you provide a link to
    // http://www.intermapper.com
    // http://intermapper.com/support/tools/IPV6-Validator.aspx
    // http://download.dartware.com/thirdparty/ipv6validator.js

    var _address = address.toLowerCase();
    var segments = _address.split(':');
    var length = segments.length;
    var total = 8;

    // trim colons (:: or ::a:b:c… or …a:b:c::)
    if (segments[0] === '' && segments[1] === '' && segments[2] === '') {
      // must have been ::
      // remove first two items
      segments.shift();
      segments.shift();
    } else if (segments[0] === '' && segments[1] === '') {
      // must have been ::xxxx
      // remove the first item
      segments.shift();
    } else if (segments[length - 1] === '' && segments[length - 2] === '') {
      // must have been xxxx::
      segments.pop();
    }

    length = segments.length;

    // adjust total segments for IPv4 trailer
    if (segments[length - 1].indexOf('.') !== -1) {
      // found a "." which means IPv4
      total = 7;
    }

    // fill empty segments them with "0000"
    var pos;
    for (pos = 0; pos < length; pos++) {
      if (segments[pos] === '') {
        break;
      }
    }

    if (pos < total) {
      segments.splice(pos, 1, '0000');
      while (segments.length < total) {
        segments.splice(pos, 0, '0000');
      }
    }

    // strip leading zeros
    var _segments;
    for (var i = 0; i < total; i++) {
      _segments = segments[i].split('');
      for (var j = 0; j < 3; j++) {
        if (_segments[0] === '0' && _segments.length > 1) {
          _segments.splice(0, 1);
        } else {
          break;
        }
      }

      segments[i] = _segments.join('');
    }

    // find longest sequence of zeroes and coalesce them into one segment
    var best = -1;
    var _best = 0;
    var _current = 0;
    var current = -1;
    var inzeroes = false;
    // i; already declared

    for (i = 0; i < total; i++) {
      if (inzeroes) {
        if (segments[i] === '0') {
          _current += 1;
        } else {
          inzeroes = false;
          if (_current > _best) {
            best = current;
            _best = _current;
          }
        }
      } else {
        if (segments[i] === '0') {
          inzeroes = true;
          current = i;
          _current = 1;
        }
      }
    }

    if (_current > _best) {
      best = current;
      _best = _current;
    }

    if (_best > 1) {
      segments.splice(best, _best, '');
    }

    length = segments.length;

    // assemble remaining segments
    var result = '';
    if (segments[0] === '') {
      result = ':';
    }

    for (i = 0; i < length; i++) {
      result += segments[i];
      if (i === length - 1) {
        break;
      }

      result += ':';
    }

    if (segments[length - 1] === '') {
      result += ':';
    }

    return result;
  }

  function noConflict() {
    /*jshint validthis: true */
    if (root.IPv6 === this) {
      root.IPv6 = _IPv6;
    }

    return this;
  }

  return {
    best: bestPresentation,
    noConflict: noConflict
  };
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58)(module)))

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * URI.js - Mutating URLs
 * Second Level Domain (SLD) Support
 *
 * Version: 1.19.11
 *
 * Author: Rodney Rehm
 * Web: http://medialize.github.io/URI.js/
 *
 * Licensed under
 *   MIT License http://www.opensource.org/licenses/mit-license
 *
 */

(function (root, factory) {
  'use strict';
  // https://github.com/umdjs/umd/blob/master/returnExports.js

  if (( false ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
    // Node
    module.exports = factory();
  } else if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {
    // Browser globals (root is window)
    root.SecondLevelDomains = factory(root);
  }
})(undefined, function (root) {
  'use strict';

  // save current SecondLevelDomains variable, if any

  var _SecondLevelDomains = root && root.SecondLevelDomains;

  var SLD = {
    // list of known Second Level Domains
    // converted list of SLDs from https://github.com/gavingmiller/second-level-domains
    // ----
    // publicsuffix.org is more current and actually used by a couple of browsers internally.
    // downside is it also contains domains like "dyndns.org" - which is fine for the security
    // issues browser have to deal with (SOP for cookies, etc) - but is way overboard for URI.js
    // ----
    list: {
      'ac': ' com gov mil net org ',
      'ae': ' ac co gov mil name net org pro sch ',
      'af': ' com edu gov net org ',
      'al': ' com edu gov mil net org ',
      'ao': ' co ed gv it og pb ',
      'ar': ' com edu gob gov int mil net org tur ',
      'at': ' ac co gv or ',
      'au': ' asn com csiro edu gov id net org ',
      'ba': ' co com edu gov mil net org rs unbi unmo unsa untz unze ',
      'bb': ' biz co com edu gov info net org store tv ',
      'bh': ' biz cc com edu gov info net org ',
      'bn': ' com edu gov net org ',
      'bo': ' com edu gob gov int mil net org tv ',
      'br': ' adm adv agr am arq art ato b bio blog bmd cim cng cnt com coop ecn edu eng esp etc eti far flog fm fnd fot fst g12 ggf gov imb ind inf jor jus lel mat med mil mus net nom not ntr odo org ppg pro psc psi qsl rec slg srv tmp trd tur tv vet vlog wiki zlg ',
      'bs': ' com edu gov net org ',
      'bz': ' du et om ov rg ',
      'ca': ' ab bc mb nb nf nl ns nt nu on pe qc sk yk ',
      'ck': ' biz co edu gen gov info net org ',
      'cn': ' ac ah bj com cq edu fj gd gov gs gx gz ha hb he hi hl hn jl js jx ln mil net nm nx org qh sc sd sh sn sx tj tw xj xz yn zj ',
      'co': ' com edu gov mil net nom org ',
      'cr': ' ac c co ed fi go or sa ',
      'cy': ' ac biz com ekloges gov ltd name net org parliament press pro tm ',
      'do': ' art com edu gob gov mil net org sld web ',
      'dz': ' art asso com edu gov net org pol ',
      'ec': ' com edu fin gov info med mil net org pro ',
      'eg': ' com edu eun gov mil name net org sci ',
      'er': ' com edu gov ind mil net org rochest w ',
      'es': ' com edu gob nom org ',
      'et': ' biz com edu gov info name net org ',
      'fj': ' ac biz com info mil name net org pro ',
      'fk': ' ac co gov net nom org ',
      'fr': ' asso com f gouv nom prd presse tm ',
      'gg': ' co net org ',
      'gh': ' com edu gov mil org ',
      'gn': ' ac com gov net org ',
      'gr': ' com edu gov mil net org ',
      'gt': ' com edu gob ind mil net org ',
      'gu': ' com edu gov net org ',
      'hk': ' com edu gov idv net org ',
      'hu': ' 2000 agrar bolt casino city co erotica erotika film forum games hotel info ingatlan jogasz konyvelo lakas media news org priv reklam sex shop sport suli szex tm tozsde utazas video ',
      'id': ' ac co go mil net or sch web ',
      'il': ' ac co gov idf k12 muni net org ',
      'in': ' ac co edu ernet firm gen gov i ind mil net nic org res ',
      'iq': ' com edu gov i mil net org ',
      'ir': ' ac co dnssec gov i id net org sch ',
      'it': ' edu gov ',
      'je': ' co net org ',
      'jo': ' com edu gov mil name net org sch ',
      'jp': ' ac ad co ed go gr lg ne or ',
      'ke': ' ac co go info me mobi ne or sc ',
      'kh': ' com edu gov mil net org per ',
      'ki': ' biz com de edu gov info mob net org tel ',
      'km': ' asso com coop edu gouv k medecin mil nom notaires pharmaciens presse tm veterinaire ',
      'kn': ' edu gov net org ',
      'kr': ' ac busan chungbuk chungnam co daegu daejeon es gangwon go gwangju gyeongbuk gyeonggi gyeongnam hs incheon jeju jeonbuk jeonnam k kg mil ms ne or pe re sc seoul ulsan ',
      'kw': ' com edu gov net org ',
      'ky': ' com edu gov net org ',
      'kz': ' com edu gov mil net org ',
      'lb': ' com edu gov net org ',
      'lk': ' assn com edu gov grp hotel int ltd net ngo org sch soc web ',
      'lr': ' com edu gov net org ',
      'lv': ' asn com conf edu gov id mil net org ',
      'ly': ' com edu gov id med net org plc sch ',
      'ma': ' ac co gov m net org press ',
      'mc': ' asso tm ',
      'me': ' ac co edu gov its net org priv ',
      'mg': ' com edu gov mil nom org prd tm ',
      'mk': ' com edu gov inf name net org pro ',
      'ml': ' com edu gov net org presse ',
      'mn': ' edu gov org ',
      'mo': ' com edu gov net org ',
      'mt': ' com edu gov net org ',
      'mv': ' aero biz com coop edu gov info int mil museum name net org pro ',
      'mw': ' ac co com coop edu gov int museum net org ',
      'mx': ' com edu gob net org ',
      'my': ' com edu gov mil name net org sch ',
      'nf': ' arts com firm info net other per rec store web ',
      'ng': ' biz com edu gov mil mobi name net org sch ',
      'ni': ' ac co com edu gob mil net nom org ',
      'np': ' com edu gov mil net org ',
      'nr': ' biz com edu gov info net org ',
      'om': ' ac biz co com edu gov med mil museum net org pro sch ',
      'pe': ' com edu gob mil net nom org sld ',
      'ph': ' com edu gov i mil net ngo org ',
      'pk': ' biz com edu fam gob gok gon gop gos gov net org web ',
      'pl': ' art bialystok biz com edu gda gdansk gorzow gov info katowice krakow lodz lublin mil net ngo olsztyn org poznan pwr radom slupsk szczecin torun warszawa waw wroc wroclaw zgora ',
      'pr': ' ac biz com edu est gov info isla name net org pro prof ',
      'ps': ' com edu gov net org plo sec ',
      'pw': ' belau co ed go ne or ',
      'ro': ' arts com firm info nom nt org rec store tm www ',
      'rs': ' ac co edu gov in org ',
      'sb': ' com edu gov net org ',
      'sc': ' com edu gov net org ',
      'sh': ' co com edu gov net nom org ',
      'sl': ' com edu gov net org ',
      'st': ' co com consulado edu embaixada gov mil net org principe saotome store ',
      'sv': ' com edu gob org red ',
      'sz': ' ac co org ',
      'tr': ' av bbs bel biz com dr edu gen gov info k12 name net org pol tel tsk tv web ',
      'tt': ' aero biz cat co com coop edu gov info int jobs mil mobi museum name net org pro tel travel ',
      'tw': ' club com ebiz edu game gov idv mil net org ',
      'mu': ' ac co com gov net or org ',
      'mz': ' ac co edu gov org ',
      'na': ' co com ',
      'nz': ' ac co cri geek gen govt health iwi maori mil net org parliament school ',
      'pa': ' abo ac com edu gob ing med net nom org sld ',
      'pt': ' com edu gov int net nome org publ ',
      'py': ' com edu gov mil net org ',
      'qa': ' com edu gov mil net org ',
      're': ' asso com nom ',
      'ru': ' ac adygeya altai amur arkhangelsk astrakhan bashkiria belgorod bir bryansk buryatia cbg chel chelyabinsk chita chukotka chuvashia com dagestan e-burg edu gov grozny int irkutsk ivanovo izhevsk jar joshkar-ola kalmykia kaluga kamchatka karelia kazan kchr kemerovo khabarovsk khakassia khv kirov koenig komi kostroma kranoyarsk kuban kurgan kursk lipetsk magadan mari mari-el marine mil mordovia mosreg msk murmansk nalchik net nnov nov novosibirsk nsk omsk orenburg org oryol penza perm pp pskov ptz rnd ryazan sakhalin samara saratov simbirsk smolensk spb stavropol stv surgut tambov tatarstan tom tomsk tsaritsyn tsk tula tuva tver tyumen udm udmurtia ulan-ude vladikavkaz vladimir vladivostok volgograd vologda voronezh vrn vyatka yakutia yamal yekaterinburg yuzhno-sakhalinsk ',
      'rw': ' ac co com edu gouv gov int mil net ',
      'sa': ' com edu gov med net org pub sch ',
      'sd': ' com edu gov info med net org tv ',
      'se': ' a ac b bd c d e f g h i k l m n o org p parti pp press r s t tm u w x y z ',
      'sg': ' com edu gov idn net org per ',
      'sn': ' art com edu gouv org perso univ ',
      'sy': ' com edu gov mil net news org ',
      'th': ' ac co go in mi net or ',
      'tj': ' ac biz co com edu go gov info int mil name net nic org test web ',
      'tn': ' agrinet com defense edunet ens fin gov ind info intl mincom nat net org perso rnrt rns rnu tourism ',
      'tz': ' ac co go ne or ',
      'ua': ' biz cherkassy chernigov chernovtsy ck cn co com crimea cv dn dnepropetrovsk donetsk dp edu gov if in ivano-frankivsk kh kharkov kherson khmelnitskiy kiev kirovograd km kr ks kv lg lugansk lutsk lviv me mk net nikolaev od odessa org pl poltava pp rovno rv sebastopol sumy te ternopil uzhgorod vinnica vn zaporizhzhe zhitomir zp zt ',
      'ug': ' ac co go ne or org sc ',
      'uk': ' ac bl british-library co cym gov govt icnet jet lea ltd me mil mod national-library-scotland nel net nhs nic nls org orgn parliament plc police sch scot soc ',
      'us': ' dni fed isa kids nsn ',
      'uy': ' com edu gub mil net org ',
      've': ' co com edu gob info mil net org web ',
      'vi': ' co com k12 net org ',
      'vn': ' ac biz com edu gov health info int name net org pro ',
      'ye': ' co com gov ltd me net org plc ',
      'yu': ' ac co edu gov org ',
      'za': ' ac agric alt bourse city co cybernet db edu gov grondar iaccess imt inca landesign law mil net ngo nis nom olivetti org pix school tm web ',
      'zm': ' ac co com edu gov net org sch ',
      // https://en.wikipedia.org/wiki/CentralNic#Second-level_domains
      'com': 'ar br cn de eu gb gr hu jpn kr no qc ru sa se uk us uy za ',
      'net': 'gb jp se uk ',
      'org': 'ae',
      'de': 'com '
    },
    // gorhill 2013-10-25: Using indexOf() instead Regexp(). Significant boost
    // in both performance and memory footprint. No initialization required.
    // http://jsperf.com/uri-js-sld-regex-vs-binary-search/4
    // Following methods use lastIndexOf() rather than array.split() in order
    // to avoid any memory allocations.
    has: function has(domain) {
      var tldOffset = domain.lastIndexOf('.');
      if (tldOffset <= 0 || tldOffset >= domain.length - 1) {
        return false;
      }
      var sldOffset = domain.lastIndexOf('.', tldOffset - 1);
      if (sldOffset <= 0 || sldOffset >= tldOffset - 1) {
        return false;
      }
      var sldList = SLD.list[domain.slice(tldOffset + 1)];
      if (!sldList) {
        return false;
      }
      return sldList.indexOf(' ' + domain.slice(sldOffset + 1, tldOffset) + ' ') >= 0;
    },
    is: function is(domain) {
      var tldOffset = domain.lastIndexOf('.');
      if (tldOffset <= 0 || tldOffset >= domain.length - 1) {
        return false;
      }
      var sldOffset = domain.lastIndexOf('.', tldOffset - 1);
      if (sldOffset >= 0) {
        return false;
      }
      var sldList = SLD.list[domain.slice(tldOffset + 1)];
      if (!sldList) {
        return false;
      }
      return sldList.indexOf(' ' + domain.slice(0, tldOffset) + ' ') >= 0;
    },
    get: function get(domain) {
      var tldOffset = domain.lastIndexOf('.');
      if (tldOffset <= 0 || tldOffset >= domain.length - 1) {
        return null;
      }
      var sldOffset = domain.lastIndexOf('.', tldOffset - 1);
      if (sldOffset <= 0 || sldOffset >= tldOffset - 1) {
        return null;
      }
      var sldList = SLD.list[domain.slice(tldOffset + 1)];
      if (!sldList) {
        return null;
      }
      if (sldList.indexOf(' ' + domain.slice(sldOffset + 1, tldOffset) + ' ') < 0) {
        return null;
      }
      return domain.slice(sldOffset + 1);
    },
    noConflict: function noConflict() {
      if (root.SecondLevelDomains === this) {
        root.SecondLevelDomains = _SecondLevelDomains;
      }
      return this;
    }
  };

  return SLD;
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58)(module)))

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearChangedFlagForContainedForm = exports.containsChangedForm = exports.partialUpdateMountChangesChecker = undefined;

var _jquery = __webpack_require__(3);

var _jquery2 = _interopRequireDefault(_jquery);

var _partialUpdateUtils = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 
var changedForms = {};
var CHANGED_HTML_CLASS = 'changed';

/**
 * Zapne chcekování změn ve formulářích.
 * Tj. pokud jsou změny ve formuláři, tak se PU přeruší.
 * Jsou ignorované změny z komponent a inputů, které jsou uvnitř
 * elementu s dattributem data-ignore-changes="true" nebo ten atribut přímo mají.
 */
var partialUpdateMountChangesChecker = exports.partialUpdateMountChangesChecker = function partialUpdateMountChangesChecker() {
  /*
    document.body.addEventListener('change', (e) => {
      console.log(e);
    });
  */

  (0, _jquery2.default)(document.body).on('change', 'form', function (e) {
    var componentEl = (0, _jquery2.default)(e.target);
    var form = (0, _jquery2.default)(e.currentTarget);
    var formId = e.currentTarget.getAttribute('id');
    if (changedForms[formId] == null) {
      var componentIgnoreChangesDataset = componentEl.closest('[data-ignore-changes="true"]');
      var allowChangeDetection = componentIgnoreChangesDataset.length === 0;
      changedForms[formId] = allowChangeDetection;
      if (allowChangeDetection) {
        form.addClass(CHANGED_HTML_CLASS);
      }
    }
  });
};

/**
 * Zjištění jestli uvnitř elementu byly ůrovodené změny
 */
var containsChangedForm = exports.containsChangedForm = function containsChangedForm(element) {
  element = (0, _partialUpdateUtils.getJQuery)(element);
  var isForm = element.is('form');
  var childForms = isForm ? element : element.find('form');
  var containsChangedForms = false;
  if (childForms.length > 0) {
    childForms.toArray().forEach(function (childForm) {
      var formId = childForm.getAttribute('id');
      if (!containsChangedForms) {
        containsChangedForms = !!changedForms[formId];
      }
    });
  }
  return containsChangedForms;
};

/**
 * Smaže příznak změny
 */
var clearChangedFlagForContainedForm = exports.clearChangedFlagForContainedForm = function clearChangedFlagForContainedForm(element) {
  element = (0, _partialUpdateUtils.getJQuery)(element);
  var isForm = element.is('form');
  var forms = isForm ? element : element.find('form');
  forms.toArray().forEach(function (form) {
    var $form = (0, _jquery2.default)(form);
    var formId = $form.attr('id');
    $form.removeClass(CHANGED_HTML_CLASS);
    delete changedForms[formId];
  });
};

// export for use in fg-library
window.clearChangedFlagForContainedForm = clearChangedFlagForContainedForm;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.partialUpdateConnectDatasetListeners = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _partialUpdate = __webpack_require__(45);

var _dom = __webpack_require__(76);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var events = ['add', 'blur', 'change', 'input', 'click', 'debounce', 'focus', 'keydown', 'keyup', 'select', 'submit', 'selectionChange', // grid v Edee
'uploadcomplete'];

var values = {};

var handlePartialUpdateEvent = function handlePartialUpdateEvent(event) {
  // nereagovat na eventy z input elementů, které nemají definovaný name attribut
  // ponejvíce se jedná jen o pomocné inputy, které mohou firovat event v nežádoucí době
  if (event.target && event.target.tagName === 'INPUT' && (event.target.getAttribute('name') == null || event.target.getAttribute('name') === '')) {
    return;
  }
  var _window = window,
      $ = _window.$;

  var isJQEvent = $ && event instanceof $.Event;
  var target = isJQEvent ? event.currentTarget : event.target;
  (0, _partialUpdate.resolveExecute)(target);
};

var debounceTimers = {};

var handleChangeEvent = function handleChangeEvent(event) {
  event.preventDefault();
  var _window2 = window,
      $ = _window2.$;

  var isJQEvent = $ && event instanceof $.Event;
  var target = isJQEvent ? event.currentTarget : event.target;
  var isDebounced = (target.getAttribute('data-pu') || target.getAttribute('data-partial-update')) === 'debounce';
  if (isDebounced) {
    // https://stackoverflow.com/questions/44831556/why-does-e-currenttarget-change-with-jquerys-event-delegation
    // z toho důvodu se udělá clone eventu
    if (isJQEvent) {
      event = _extends({}, event);
      target = event.currentTarget;
    }

    var id = target.getAttribute('id');
    clearTimeout(debounceTimers[id]);
    // TODO mezi timeoutem a dalším vyvoláním PU abortnout související PU
    debounceTimers[id] = setTimeout(function () {
      clearTimeout(debounceTimers[id]);
      delete debounceTimers[id];
      handlePartialUpdateEvent(event);
    }, 300);
  } else {
    handlePartialUpdateEvent(event);
  }
};

var handleOtherEvent = function handleOtherEvent(event) {
  event.preventDefault();
  handlePartialUpdateEvent(event);
};

/**
 * Nastaví listenery na data-partial-update attributy v documentu.
 * PU bude reagovat na event, který je definován v data-partial-update atributu
 * Automaticky naslouchá na tyto eventy
 * <em>'add','blur','change','click','debounce','focus','keydown','keyup','select','submit','selectionChange','uploadcomplete'</em>
 * Další eventy je nutno definovat parametru customEvents
 * @param customEvents
 */
var partialUpdateConnectDatasetListeners = exports.partialUpdateConnectDatasetListeners = function partialUpdateConnectDatasetListeners(customEvents) {
  var allEvents = [].concat(events, _toConsumableArray(customEvents));
  var indexOfDebounce = allEvents.indexOf('debounce');
  var _window3 = window,
      $ = _window3.$;

  var reducedEvents = [].concat(_toConsumableArray(allEvents));
  if (indexOfDebounce !== -1) {
    reducedEvents.splice(indexOfDebounce, 1);
  }
  reducedEvents.forEach(function (eventForDelegation) {
    var selector = '[data-pu="' + eventForDelegation + '"], [data-partial-update="' + eventForDelegation + '"]';
    if (eventForDelegation === 'change') {
      if (indexOfDebounce !== -1) {
        selector = selector + ', [data-pu="debounce"], [data-partial-update="debounce"]';
      }
      document.addEventListener('change', function (e) {
        var closest = e.target.closest(selector);
        // change event target to closest
        if (closest) {
          var canHandle = true;

          // prevent change event při bluru na textových polích
          // change PU se provede jen v případě, že se změní hodnota
          // https://ep.fg.cz/issues/83732
          if ((0, _dom.isTextField)(e.target)) {
            var id = closest.getAttribute('id');
            var lastValue = values[id];
            var actValue = closest.value;
            canHandle = actValue !== lastValue;
            values[id] = actValue;
          }

          Object.defineProperty(e, 'target', {
            value: closest,
            writable: false
          });
          if (canHandle) {
            handleChangeEvent(e);
          }
        }
      });

      if ($ && $.fn) {
        $(document).on('change', selector, function (e) {
          var isJQEvent = e instanceof $.Event;
          // reagovat jen na jQuery eventy v opačném případě je event odchycen nativním listenerem
          // https://ep.fg.cz/issues/89448
          if (isJQEvent && e.originalEvent == null) {
            var canHandle = true;
            // prevent change event při bluru na textových polích
            // change PU se provede jen v případě, že se změní hodnota
            // https://ep.fg.cz/issues/83732
            if ((0, _dom.isTextField)(e.target)) {
              var id = e.target.getAttribute('id');
              var lastValue = values[id];
              var actValue = e.target.value;
              canHandle = actValue !== lastValue;
              values[id] = actValue;
            }

            if (canHandle) {
              handleChangeEvent(e);
            }
          }
        });
      }
    } else {
      document.addEventListener(eventForDelegation, function (e) {
        // FF throw error
        if (e.target === document) {
          return;
        }
        var closest = e.target.closest(selector);
        if (closest) {
          // change event target to closest
          Object.defineProperty(e, 'target', {
            value: closest,
            writable: false
          });
          handleOtherEvent(e);
        }
      });
      if ($ && $.fn) {
        $(document).on(eventForDelegation, selector, function (e) {
          var isJQEvent = e instanceof $.Event;
          if (isJQEvent && e.originalEvent == null) {
            handleOtherEvent(e);
          }
        });
      }
    }
  });
};

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; // 


var _urlAndLink = __webpack_require__(111);

var _urijs = __webpack_require__(57);

var _urijs2 = _interopRequireDefault(_urijs);

var _partialUpdateUtils = __webpack_require__(46);

var _partialUpdate = __webpack_require__(45);

var _PartialUpdateSettings = __webpack_require__(51);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var lastExecutedUrl = void 0;

/**
 * Připojí
 */

exports.default = function () {
  var _getGlobalPartialUpda = (0, _PartialUpdateSettings.getGlobalPartialUpdateSettings)(),
      globalTarget = _getGlobalPartialUpda.globalTarget;

  if (!lastExecutedUrl) {
    lastExecutedUrl = window.location.href;
  }
  // let lastPartialUpdateTarget = null;
  // pomocí historyStatePageNumber lze zjistit jakým směrem se uživatel v historii pohybuje
  var historyStatePageNumber = window.history.state && window.history.state.pageNumber ? window.history.state.pageNumber : 0;

  window.addEventListener('popstate', function (event) {
    var url = new _urijs2.default((0, _urlAndLink.normalizeUrl)(window.location.href));
    lastExecutedUrl = new _urijs2.default((0, _urlAndLink.normalizeUrl)(lastExecutedUrl));
    lastExecutedUrl = lastExecutedUrl.toString();

    if (window.history.state && window.history.state.partialUpdate) {
      var settings = window.history.state && window.history.state.puSettings ? window.history.state.puSettings : {};

      var target = settings.target;


      if (lastExecutedUrl !== url.toString()) {
        var pageNumber = event.state && event.state.pageNumber ? event.state.pageNumber : 0;
        var direction = 'next';
        if (pageNumber < historyStatePageNumber) {
          direction = 'prev';
        }
        historyStatePageNumber = pageNumber;
        (0, _partialUpdate.execute)({
          target: target || globalTarget,
          url: url.toString(),
          historyPopState: true,
          historyDirection: direction
        });
      }
    }
  });

  var puSettings = (0, _partialUpdateUtils.parsePartialUpdateSettingsFromUrl)(window.location.href);
  if (puSettings) {
    (0, _partialUpdate.execute)(puSettings);
    // lastPartialUpdateTarget = puSettings.target;
  }

  var handlePartialUpdateHistory = function handlePartialUpdateHistory(settings, alterHistoryUrl) {
    if (settings.alterHistory && alterHistoryUrl && alterHistoryUrl !== '') {
      var url = (0, _urlAndLink.normalizeUrl)(window.location.href);
      var frameUri = new _urijs2.default(url || '');

      var target = settings.target,
          containerId = settings.containerId,
          requestTarget = settings.requestTarget,
          historyReplaceState = settings.historyReplaceState,
          historyPopState = settings.historyPopState;


      var targetWithoutContext = target || containerId ? (0, _partialUpdateUtils.getDynamicAreaIdWithoutContext)(target || containerId) : null;
      var requestTargetWithoutContext = requestTarget && (0, _partialUpdateUtils.getDynamicAreaIdWithoutContext)(requestTarget);

      var replaceState = false;
      if (requestTargetWithoutContext && requestTargetWithoutContext === globalTarget && requestTargetWithoutContext !== targetWithoutContext) {
        frameUri.setQuery('pu', JSON.stringify({
          requestTarget: requestTargetWithoutContext,
          target: targetWithoutContext,
          url: alterHistoryUrl
        }));
      } else {
        frameUri = new _urijs2.default(alterHistoryUrl);
        replaceState = historyReplaceState;
      }

      if (!historyPopState && url !== frameUri.toString()) {

        // do stavu historie se mohou pushovat pouze primitivní typy
        var settingsForState = {};
        Object.keys(settings).forEach(function (key) {
          var property = settings[key];
          if (typeof property === 'boolean' || typeof property === 'string' || Array.isArray(property) || typeof property !== 'function' && (typeof property === 'undefined' ? 'undefined' : _typeof(property)) === 'object') {
            settingsForState[key] = property;
          }
        });

        if (replaceState) {
          // s replacem se pageNumber nemění
          window.history.replaceState({
            partialUpdate: true,
            pageNumber: historyStatePageNumber,
            puSettings: settingsForState
          }, undefined, frameUri.toString());
        } else {
          // pro push se historyStatePageNumber incrementuje;
          historyStatePageNumber = historyStatePageNumber + 1;

          // pokud ještě nebzl do historie udělaný push nebo replace,
          // tak se poprvé do něj replacne, abz se do historz state uložilo pu setting
          // a při návratu se načetl target při kterém byla stránka opouštěna
          if (!(window.history.state && window.history.state.partialUpdate)) {
            window.history.replaceState({
              partialUpdate: true,
              pageNumber: 0,
              puSettings: settingsForState
            }, undefined);
          }

          window.history.pushState({
            partialUpdate: true,
            pageNumber: historyStatePageNumber,
            puSettings: settingsForState
          }, undefined, frameUri.toString());
        }
      }
      lastExecutedUrl = frameUri.toString();
    }
  };

  document.addEventListener('partialUpdateComplete', function (e) {
    var _e$detail = e.detail,
        alterHistoryUrl = _e$detail.alterHistoryUrl,
        settings = _e$detail.settings;


    if (alterHistoryUrl) {
      handlePartialUpdateHistory(settings, alterHistoryUrl);
    } else {
      lastExecutedUrl = window.location.href;
    }
  });
};

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // 


var _urlAndLink = __webpack_require__(111);

var _partialUpdate = __webpack_require__(45);

var _partialUpdateUtils = __webpack_require__(46);

var _PartialUpdateSettings = __webpack_require__(51);

/**
  Automaticky nabinduje partial update na všechny odkazy
  Pokud odkaz odpavídá kritériím, že se jedná o odkay webu a je uvnitř partial updatu
*/
exports.default = function (settings) {
  document.addEventListener('click', function (e) {
    if (!e.defaultPrevented) {
      var closestHrefElement = e.target.closest('a');
      if (closestHrefElement) {
        if ((0, _urlAndLink.isRoutingAnchor)(closestHrefElement) && (0, _partialUpdateUtils.getParentPartialUpdateContainer)(closestHrefElement) != null) {
          e.preventDefault();
          (0, _partialUpdate.resolveExecute)(closestHrefElement, _extends({}, settings, (0, _PartialUpdateSettings.getClosestPartialUpdateSettings)(closestHrefElement, ['target', 'requestTarget', 'url']), (0, _PartialUpdateSettings.getElementPartialUpdateSettings)(closestHrefElement)));
        }
      }
    }
  });
};

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _partialUpdateUtils = __webpack_require__(46);

var _partialUpdate = __webpack_require__(45);

var submitButtonSelectors = ['input[type="submit"]', 'button[type="submit"]', 'input[type="image"]', 'button[type="image"]', 'input[type="button"]'];

/**
 * Přidá na všechny submit tlačítka v documentu clik listener.
 * Po kliknutí na tlačítko se vyvolá executeSubmit.
 * Všechy tlačítka která jsou uvnitř elementu s třídou nebo mají noPartialUpdate budou ignorovány.
 */

exports.default = function (settings) {
  document.addEventListener('click', function (e) {
    if (!e.defaultPrevented) {
      var submitButton = e.target.closest(submitButtonSelectors.join(','));
      if (submitButton && !submitButton.disabled) {
        var closestForm = submitButton.closest('form');
        var closestNoPartialUpdate = submitButton.closest('.noPartialUpdate');
        var parentPUContainer = (0, _partialUpdateUtils.getParentPartialUpdateContainer)(submitButton);
        if (parentPUContainer && closestForm && closestNoPartialUpdate == null) {
          e.preventDefault();
          (0, _partialUpdate.resolveExecute)(submitButton, _extends({
            eventName: submitButton.getAttribute('name')
          }, settings));
        }
      }
    }
  });
};

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/*
 * anime.js v3.2.1
 * (c) 2020 Julian Garnier
 * Released under the MIT license
 * animejs.com
 */

// Defaults

var defaultInstanceSettings = {
  update: null,
  begin: null,
  loopBegin: null,
  changeBegin: null,
  change: null,
  changeComplete: null,
  loopComplete: null,
  complete: null,
  loop: 1,
  direction: 'normal',
  autoplay: true,
  timelineOffset: 0
};

var defaultTweenSettings = {
  duration: 1000,
  delay: 0,
  endDelay: 0,
  easing: 'easeOutElastic(1, .5)',
  round: 0
};

var validTransforms = ['translateX', 'translateY', 'translateZ', 'rotate', 'rotateX', 'rotateY', 'rotateZ', 'scale', 'scaleX', 'scaleY', 'scaleZ', 'skew', 'skewX', 'skewY', 'perspective', 'matrix', 'matrix3d'];

// Caching

var cache = {
  CSS: {},
  springs: {}
};

// Utils

function minMax(val, min, max) {
  return Math.min(Math.max(val, min), max);
}

function stringContains(str, text) {
  return str.indexOf(text) > -1;
}

function applyArguments(func, args) {
  return func.apply(null, args);
}

var is = {
  arr: function (a) { return Array.isArray(a); },
  obj: function (a) { return stringContains(Object.prototype.toString.call(a), 'Object'); },
  pth: function (a) { return is.obj(a) && a.hasOwnProperty('totalLength'); },
  svg: function (a) { return a instanceof SVGElement; },
  inp: function (a) { return a instanceof HTMLInputElement; },
  dom: function (a) { return a.nodeType || is.svg(a); },
  str: function (a) { return typeof a === 'string'; },
  fnc: function (a) { return typeof a === 'function'; },
  und: function (a) { return typeof a === 'undefined'; },
  nil: function (a) { return is.und(a) || a === null; },
  hex: function (a) { return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(a); },
  rgb: function (a) { return /^rgb/.test(a); },
  hsl: function (a) { return /^hsl/.test(a); },
  col: function (a) { return (is.hex(a) || is.rgb(a) || is.hsl(a)); },
  key: function (a) { return !defaultInstanceSettings.hasOwnProperty(a) && !defaultTweenSettings.hasOwnProperty(a) && a !== 'targets' && a !== 'keyframes'; },
};

// Easings

function parseEasingParameters(string) {
  var match = /\(([^)]+)\)/.exec(string);
  return match ? match[1].split(',').map(function (p) { return parseFloat(p); }) : [];
}

// Spring solver inspired by Webkit Copyright © 2016 Apple Inc. All rights reserved. https://webkit.org/demos/spring/spring.js

function spring(string, duration) {

  var params = parseEasingParameters(string);
  var mass = minMax(is.und(params[0]) ? 1 : params[0], .1, 100);
  var stiffness = minMax(is.und(params[1]) ? 100 : params[1], .1, 100);
  var damping = minMax(is.und(params[2]) ? 10 : params[2], .1, 100);
  var velocity =  minMax(is.und(params[3]) ? 0 : params[3], .1, 100);
  var w0 = Math.sqrt(stiffness / mass);
  var zeta = damping / (2 * Math.sqrt(stiffness * mass));
  var wd = zeta < 1 ? w0 * Math.sqrt(1 - zeta * zeta) : 0;
  var a = 1;
  var b = zeta < 1 ? (zeta * w0 + -velocity) / wd : -velocity + w0;

  function solver(t) {
    var progress = duration ? (duration * t) / 1000 : t;
    if (zeta < 1) {
      progress = Math.exp(-progress * zeta * w0) * (a * Math.cos(wd * progress) + b * Math.sin(wd * progress));
    } else {
      progress = (a + b * progress) * Math.exp(-progress * w0);
    }
    if (t === 0 || t === 1) { return t; }
    return 1 - progress;
  }

  function getDuration() {
    var cached = cache.springs[string];
    if (cached) { return cached; }
    var frame = 1/6;
    var elapsed = 0;
    var rest = 0;
    while(true) {
      elapsed += frame;
      if (solver(elapsed) === 1) {
        rest++;
        if (rest >= 16) { break; }
      } else {
        rest = 0;
      }
    }
    var duration = elapsed * frame * 1000;
    cache.springs[string] = duration;
    return duration;
  }

  return duration ? solver : getDuration;

}

// Basic steps easing implementation https://developer.mozilla.org/fr/docs/Web/CSS/transition-timing-function

function steps(steps) {
  if ( steps === void 0 ) steps = 10;

  return function (t) { return Math.ceil((minMax(t, 0.000001, 1)) * steps) * (1 / steps); };
}

// BezierEasing https://github.com/gre/bezier-easing

var bezier = (function () {

  var kSplineTableSize = 11;
  var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);

  function A(aA1, aA2) { return 1.0 - 3.0 * aA2 + 3.0 * aA1 }
  function B(aA1, aA2) { return 3.0 * aA2 - 6.0 * aA1 }
  function C(aA1)      { return 3.0 * aA1 }

  function calcBezier(aT, aA1, aA2) { return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT }
  function getSlope(aT, aA1, aA2) { return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1) }

  function binarySubdivide(aX, aA, aB, mX1, mX2) {
    var currentX, currentT, i = 0;
    do {
      currentT = aA + (aB - aA) / 2.0;
      currentX = calcBezier(currentT, mX1, mX2) - aX;
      if (currentX > 0.0) { aB = currentT; } else { aA = currentT; }
    } while (Math.abs(currentX) > 0.0000001 && ++i < 10);
    return currentT;
  }

  function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
    for (var i = 0; i < 4; ++i) {
      var currentSlope = getSlope(aGuessT, mX1, mX2);
      if (currentSlope === 0.0) { return aGuessT; }
      var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
      aGuessT -= currentX / currentSlope;
    }
    return aGuessT;
  }

  function bezier(mX1, mY1, mX2, mY2) {

    if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) { return; }
    var sampleValues = new Float32Array(kSplineTableSize);

    if (mX1 !== mY1 || mX2 !== mY2) {
      for (var i = 0; i < kSplineTableSize; ++i) {
        sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
      }
    }

    function getTForX(aX) {

      var intervalStart = 0;
      var currentSample = 1;
      var lastSample = kSplineTableSize - 1;

      for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
        intervalStart += kSampleStepSize;
      }

      --currentSample;

      var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
      var guessForT = intervalStart + dist * kSampleStepSize;
      var initialSlope = getSlope(guessForT, mX1, mX2);

      if (initialSlope >= 0.001) {
        return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
      } else if (initialSlope === 0.0) {
        return guessForT;
      } else {
        return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
      }

    }

    return function (x) {
      if (mX1 === mY1 && mX2 === mY2) { return x; }
      if (x === 0 || x === 1) { return x; }
      return calcBezier(getTForX(x), mY1, mY2);
    }

  }

  return bezier;

})();

var penner = (function () {

  // Based on jQuery UI's implemenation of easing equations from Robert Penner (http://www.robertpenner.com/easing)

  var eases = { linear: function () { return function (t) { return t; }; } };

  var functionEasings = {
    Sine: function () { return function (t) { return 1 - Math.cos(t * Math.PI / 2); }; },
    Circ: function () { return function (t) { return 1 - Math.sqrt(1 - t * t); }; },
    Back: function () { return function (t) { return t * t * (3 * t - 2); }; },
    Bounce: function () { return function (t) {
      var pow2, b = 4;
      while (t < (( pow2 = Math.pow(2, --b)) - 1) / 11) {}
      return 1 / Math.pow(4, 3 - b) - 7.5625 * Math.pow(( pow2 * 3 - 2 ) / 22 - t, 2)
    }; },
    Elastic: function (amplitude, period) {
      if ( amplitude === void 0 ) amplitude = 1;
      if ( period === void 0 ) period = .5;

      var a = minMax(amplitude, 1, 10);
      var p = minMax(period, .1, 2);
      return function (t) {
        return (t === 0 || t === 1) ? t : 
          -a * Math.pow(2, 10 * (t - 1)) * Math.sin((((t - 1) - (p / (Math.PI * 2) * Math.asin(1 / a))) * (Math.PI * 2)) / p);
      }
    }
  };

  var baseEasings = ['Quad', 'Cubic', 'Quart', 'Quint', 'Expo'];

  baseEasings.forEach(function (name, i) {
    functionEasings[name] = function () { return function (t) { return Math.pow(t, i + 2); }; };
  });

  Object.keys(functionEasings).forEach(function (name) {
    var easeIn = functionEasings[name];
    eases['easeIn' + name] = easeIn;
    eases['easeOut' + name] = function (a, b) { return function (t) { return 1 - easeIn(a, b)(1 - t); }; };
    eases['easeInOut' + name] = function (a, b) { return function (t) { return t < 0.5 ? easeIn(a, b)(t * 2) / 2 : 
      1 - easeIn(a, b)(t * -2 + 2) / 2; }; };
    eases['easeOutIn' + name] = function (a, b) { return function (t) { return t < 0.5 ? (1 - easeIn(a, b)(1 - t * 2)) / 2 : 
      (easeIn(a, b)(t * 2 - 1) + 1) / 2; }; };
  });

  return eases;

})();

function parseEasings(easing, duration) {
  if (is.fnc(easing)) { return easing; }
  var name = easing.split('(')[0];
  var ease = penner[name];
  var args = parseEasingParameters(easing);
  switch (name) {
    case 'spring' : return spring(easing, duration);
    case 'cubicBezier' : return applyArguments(bezier, args);
    case 'steps' : return applyArguments(steps, args);
    default : return applyArguments(ease, args);
  }
}

// Strings

function selectString(str) {
  try {
    var nodes = document.querySelectorAll(str);
    return nodes;
  } catch(e) {
    return;
  }
}

// Arrays

function filterArray(arr, callback) {
  var len = arr.length;
  var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
  var result = [];
  for (var i = 0; i < len; i++) {
    if (i in arr) {
      var val = arr[i];
      if (callback.call(thisArg, val, i, arr)) {
        result.push(val);
      }
    }
  }
  return result;
}

function flattenArray(arr) {
  return arr.reduce(function (a, b) { return a.concat(is.arr(b) ? flattenArray(b) : b); }, []);
}

function toArray(o) {
  if (is.arr(o)) { return o; }
  if (is.str(o)) { o = selectString(o) || o; }
  if (o instanceof NodeList || o instanceof HTMLCollection) { return [].slice.call(o); }
  return [o];
}

function arrayContains(arr, val) {
  return arr.some(function (a) { return a === val; });
}

// Objects

function cloneObject(o) {
  var clone = {};
  for (var p in o) { clone[p] = o[p]; }
  return clone;
}

function replaceObjectProps(o1, o2) {
  var o = cloneObject(o1);
  for (var p in o1) { o[p] = o2.hasOwnProperty(p) ? o2[p] : o1[p]; }
  return o;
}

function mergeObjects(o1, o2) {
  var o = cloneObject(o1);
  for (var p in o2) { o[p] = is.und(o1[p]) ? o2[p] : o1[p]; }
  return o;
}

// Colors

function rgbToRgba(rgbValue) {
  var rgb = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(rgbValue);
  return rgb ? ("rgba(" + (rgb[1]) + ",1)") : rgbValue;
}

function hexToRgba(hexValue) {
  var rgx = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  var hex = hexValue.replace(rgx, function (m, r, g, b) { return r + r + g + g + b + b; } );
  var rgb = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  var r = parseInt(rgb[1], 16);
  var g = parseInt(rgb[2], 16);
  var b = parseInt(rgb[3], 16);
  return ("rgba(" + r + "," + g + "," + b + ",1)");
}

function hslToRgba(hslValue) {
  var hsl = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(hslValue) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(hslValue);
  var h = parseInt(hsl[1], 10) / 360;
  var s = parseInt(hsl[2], 10) / 100;
  var l = parseInt(hsl[3], 10) / 100;
  var a = hsl[4] || 1;
  function hue2rgb(p, q, t) {
    if (t < 0) { t += 1; }
    if (t > 1) { t -= 1; }
    if (t < 1/6) { return p + (q - p) * 6 * t; }
    if (t < 1/2) { return q; }
    if (t < 2/3) { return p + (q - p) * (2/3 - t) * 6; }
    return p;
  }
  var r, g, b;
  if (s == 0) {
    r = g = b = l;
  } else {
    var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    var p = 2 * l - q;
    r = hue2rgb(p, q, h + 1/3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1/3);
  }
  return ("rgba(" + (r * 255) + "," + (g * 255) + "," + (b * 255) + "," + a + ")");
}

function colorToRgb(val) {
  if (is.rgb(val)) { return rgbToRgba(val); }
  if (is.hex(val)) { return hexToRgba(val); }
  if (is.hsl(val)) { return hslToRgba(val); }
}

// Units

function getUnit(val) {
  var split = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(val);
  if (split) { return split[1]; }
}

function getTransformUnit(propName) {
  if (stringContains(propName, 'translate') || propName === 'perspective') { return 'px'; }
  if (stringContains(propName, 'rotate') || stringContains(propName, 'skew')) { return 'deg'; }
}

// Values

function getFunctionValue(val, animatable) {
  if (!is.fnc(val)) { return val; }
  return val(animatable.target, animatable.id, animatable.total);
}

function getAttribute(el, prop) {
  return el.getAttribute(prop);
}

function convertPxToUnit(el, value, unit) {
  var valueUnit = getUnit(value);
  if (arrayContains([unit, 'deg', 'rad', 'turn'], valueUnit)) { return value; }
  var cached = cache.CSS[value + unit];
  if (!is.und(cached)) { return cached; }
  var baseline = 100;
  var tempEl = document.createElement(el.tagName);
  var parentEl = (el.parentNode && (el.parentNode !== document)) ? el.parentNode : document.body;
  parentEl.appendChild(tempEl);
  tempEl.style.position = 'absolute';
  tempEl.style.width = baseline + unit;
  var factor = baseline / tempEl.offsetWidth;
  parentEl.removeChild(tempEl);
  var convertedUnit = factor * parseFloat(value);
  cache.CSS[value + unit] = convertedUnit;
  return convertedUnit;
}

function getCSSValue(el, prop, unit) {
  if (prop in el.style) {
    var uppercasePropName = prop.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
    var value = el.style[prop] || getComputedStyle(el).getPropertyValue(uppercasePropName) || '0';
    return unit ? convertPxToUnit(el, value, unit) : value;
  }
}

function getAnimationType(el, prop) {
  if (is.dom(el) && !is.inp(el) && (!is.nil(getAttribute(el, prop)) || (is.svg(el) && el[prop]))) { return 'attribute'; }
  if (is.dom(el) && arrayContains(validTransforms, prop)) { return 'transform'; }
  if (is.dom(el) && (prop !== 'transform' && getCSSValue(el, prop))) { return 'css'; }
  if (el[prop] != null) { return 'object'; }
}

function getElementTransforms(el) {
  if (!is.dom(el)) { return; }
  var str = el.style.transform || '';
  var reg  = /(\w+)\(([^)]*)\)/g;
  var transforms = new Map();
  var m; while (m = reg.exec(str)) { transforms.set(m[1], m[2]); }
  return transforms;
}

function getTransformValue(el, propName, animatable, unit) {
  var defaultVal = stringContains(propName, 'scale') ? 1 : 0 + getTransformUnit(propName);
  var value = getElementTransforms(el).get(propName) || defaultVal;
  if (animatable) {
    animatable.transforms.list.set(propName, value);
    animatable.transforms['last'] = propName;
  }
  return unit ? convertPxToUnit(el, value, unit) : value;
}

function getOriginalTargetValue(target, propName, unit, animatable) {
  switch (getAnimationType(target, propName)) {
    case 'transform': return getTransformValue(target, propName, animatable, unit);
    case 'css': return getCSSValue(target, propName, unit);
    case 'attribute': return getAttribute(target, propName);
    default: return target[propName] || 0;
  }
}

function getRelativeValue(to, from) {
  var operator = /^(\*=|\+=|-=)/.exec(to);
  if (!operator) { return to; }
  var u = getUnit(to) || 0;
  var x = parseFloat(from);
  var y = parseFloat(to.replace(operator[0], ''));
  switch (operator[0][0]) {
    case '+': return x + y + u;
    case '-': return x - y + u;
    case '*': return x * y + u;
  }
}

function validateValue(val, unit) {
  if (is.col(val)) { return colorToRgb(val); }
  if (/\s/g.test(val)) { return val; }
  var originalUnit = getUnit(val);
  var unitLess = originalUnit ? val.substr(0, val.length - originalUnit.length) : val;
  if (unit) { return unitLess + unit; }
  return unitLess;
}

// getTotalLength() equivalent for circle, rect, polyline, polygon and line shapes
// adapted from https://gist.github.com/SebLambla/3e0550c496c236709744

function getDistance(p1, p2) {
  return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
}

function getCircleLength(el) {
  return Math.PI * 2 * getAttribute(el, 'r');
}

function getRectLength(el) {
  return (getAttribute(el, 'width') * 2) + (getAttribute(el, 'height') * 2);
}

function getLineLength(el) {
  return getDistance(
    {x: getAttribute(el, 'x1'), y: getAttribute(el, 'y1')}, 
    {x: getAttribute(el, 'x2'), y: getAttribute(el, 'y2')}
  );
}

function getPolylineLength(el) {
  var points = el.points;
  var totalLength = 0;
  var previousPos;
  for (var i = 0 ; i < points.numberOfItems; i++) {
    var currentPos = points.getItem(i);
    if (i > 0) { totalLength += getDistance(previousPos, currentPos); }
    previousPos = currentPos;
  }
  return totalLength;
}

function getPolygonLength(el) {
  var points = el.points;
  return getPolylineLength(el) + getDistance(points.getItem(points.numberOfItems - 1), points.getItem(0));
}

// Path animation

function getTotalLength(el) {
  if (el.getTotalLength) { return el.getTotalLength(); }
  switch(el.tagName.toLowerCase()) {
    case 'circle': return getCircleLength(el);
    case 'rect': return getRectLength(el);
    case 'line': return getLineLength(el);
    case 'polyline': return getPolylineLength(el);
    case 'polygon': return getPolygonLength(el);
  }
}

function setDashoffset(el) {
  var pathLength = getTotalLength(el);
  el.setAttribute('stroke-dasharray', pathLength);
  return pathLength;
}

// Motion path

function getParentSvgEl(el) {
  var parentEl = el.parentNode;
  while (is.svg(parentEl)) {
    if (!is.svg(parentEl.parentNode)) { break; }
    parentEl = parentEl.parentNode;
  }
  return parentEl;
}

function getParentSvg(pathEl, svgData) {
  var svg = svgData || {};
  var parentSvgEl = svg.el || getParentSvgEl(pathEl);
  var rect = parentSvgEl.getBoundingClientRect();
  var viewBoxAttr = getAttribute(parentSvgEl, 'viewBox');
  var width = rect.width;
  var height = rect.height;
  var viewBox = svg.viewBox || (viewBoxAttr ? viewBoxAttr.split(' ') : [0, 0, width, height]);
  return {
    el: parentSvgEl,
    viewBox: viewBox,
    x: viewBox[0] / 1,
    y: viewBox[1] / 1,
    w: width,
    h: height,
    vW: viewBox[2],
    vH: viewBox[3]
  }
}

function getPath(path, percent) {
  var pathEl = is.str(path) ? selectString(path)[0] : path;
  var p = percent || 100;
  return function(property) {
    return {
      property: property,
      el: pathEl,
      svg: getParentSvg(pathEl),
      totalLength: getTotalLength(pathEl) * (p / 100)
    }
  }
}

function getPathProgress(path, progress, isPathTargetInsideSVG) {
  function point(offset) {
    if ( offset === void 0 ) offset = 0;

    var l = progress + offset >= 1 ? progress + offset : 0;
    return path.el.getPointAtLength(l);
  }
  var svg = getParentSvg(path.el, path.svg);
  var p = point();
  var p0 = point(-1);
  var p1 = point(+1);
  var scaleX = isPathTargetInsideSVG ? 1 : svg.w / svg.vW;
  var scaleY = isPathTargetInsideSVG ? 1 : svg.h / svg.vH;
  switch (path.property) {
    case 'x': return (p.x - svg.x) * scaleX;
    case 'y': return (p.y - svg.y) * scaleY;
    case 'angle': return Math.atan2(p1.y - p0.y, p1.x - p0.x) * 180 / Math.PI;
  }
}

// Decompose value

function decomposeValue(val, unit) {
  // const rgx = /-?\d*\.?\d+/g; // handles basic numbers
  // const rgx = /[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g; // handles exponents notation
  var rgx = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g; // handles exponents notation
  var value = validateValue((is.pth(val) ? val.totalLength : val), unit) + '';
  return {
    original: value,
    numbers: value.match(rgx) ? value.match(rgx).map(Number) : [0],
    strings: (is.str(val) || unit) ? value.split(rgx) : []
  }
}

// Animatables

function parseTargets(targets) {
  var targetsArray = targets ? (flattenArray(is.arr(targets) ? targets.map(toArray) : toArray(targets))) : [];
  return filterArray(targetsArray, function (item, pos, self) { return self.indexOf(item) === pos; });
}

function getAnimatables(targets) {
  var parsed = parseTargets(targets);
  return parsed.map(function (t, i) {
    return {target: t, id: i, total: parsed.length, transforms: { list: getElementTransforms(t) } };
  });
}

// Properties

function normalizePropertyTweens(prop, tweenSettings) {
  var settings = cloneObject(tweenSettings);
  // Override duration if easing is a spring
  if (/^spring/.test(settings.easing)) { settings.duration = spring(settings.easing); }
  if (is.arr(prop)) {
    var l = prop.length;
    var isFromTo = (l === 2 && !is.obj(prop[0]));
    if (!isFromTo) {
      // Duration divided by the number of tweens
      if (!is.fnc(tweenSettings.duration)) { settings.duration = tweenSettings.duration / l; }
    } else {
      // Transform [from, to] values shorthand to a valid tween value
      prop = {value: prop};
    }
  }
  var propArray = is.arr(prop) ? prop : [prop];
  return propArray.map(function (v, i) {
    var obj = (is.obj(v) && !is.pth(v)) ? v : {value: v};
    // Default delay value should only be applied to the first tween
    if (is.und(obj.delay)) { obj.delay = !i ? tweenSettings.delay : 0; }
    // Default endDelay value should only be applied to the last tween
    if (is.und(obj.endDelay)) { obj.endDelay = i === propArray.length - 1 ? tweenSettings.endDelay : 0; }
    return obj;
  }).map(function (k) { return mergeObjects(k, settings); });
}


function flattenKeyframes(keyframes) {
  var propertyNames = filterArray(flattenArray(keyframes.map(function (key) { return Object.keys(key); })), function (p) { return is.key(p); })
  .reduce(function (a,b) { if (a.indexOf(b) < 0) { a.push(b); } return a; }, []);
  var properties = {};
  var loop = function ( i ) {
    var propName = propertyNames[i];
    properties[propName] = keyframes.map(function (key) {
      var newKey = {};
      for (var p in key) {
        if (is.key(p)) {
          if (p == propName) { newKey.value = key[p]; }
        } else {
          newKey[p] = key[p];
        }
      }
      return newKey;
    });
  };

  for (var i = 0; i < propertyNames.length; i++) loop( i );
  return properties;
}

function getProperties(tweenSettings, params) {
  var properties = [];
  var keyframes = params.keyframes;
  if (keyframes) { params = mergeObjects(flattenKeyframes(keyframes), params); }
  for (var p in params) {
    if (is.key(p)) {
      properties.push({
        name: p,
        tweens: normalizePropertyTweens(params[p], tweenSettings)
      });
    }
  }
  return properties;
}

// Tweens

function normalizeTweenValues(tween, animatable) {
  var t = {};
  for (var p in tween) {
    var value = getFunctionValue(tween[p], animatable);
    if (is.arr(value)) {
      value = value.map(function (v) { return getFunctionValue(v, animatable); });
      if (value.length === 1) { value = value[0]; }
    }
    t[p] = value;
  }
  t.duration = parseFloat(t.duration);
  t.delay = parseFloat(t.delay);
  return t;
}

function normalizeTweens(prop, animatable) {
  var previousTween;
  return prop.tweens.map(function (t) {
    var tween = normalizeTweenValues(t, animatable);
    var tweenValue = tween.value;
    var to = is.arr(tweenValue) ? tweenValue[1] : tweenValue;
    var toUnit = getUnit(to);
    var originalValue = getOriginalTargetValue(animatable.target, prop.name, toUnit, animatable);
    var previousValue = previousTween ? previousTween.to.original : originalValue;
    var from = is.arr(tweenValue) ? tweenValue[0] : previousValue;
    var fromUnit = getUnit(from) || getUnit(originalValue);
    var unit = toUnit || fromUnit;
    if (is.und(to)) { to = previousValue; }
    tween.from = decomposeValue(from, unit);
    tween.to = decomposeValue(getRelativeValue(to, from), unit);
    tween.start = previousTween ? previousTween.end : 0;
    tween.end = tween.start + tween.delay + tween.duration + tween.endDelay;
    tween.easing = parseEasings(tween.easing, tween.duration);
    tween.isPath = is.pth(tweenValue);
    tween.isPathTargetInsideSVG = tween.isPath && is.svg(animatable.target);
    tween.isColor = is.col(tween.from.original);
    if (tween.isColor) { tween.round = 1; }
    previousTween = tween;
    return tween;
  });
}

// Tween progress

var setProgressValue = {
  css: function (t, p, v) { return t.style[p] = v; },
  attribute: function (t, p, v) { return t.setAttribute(p, v); },
  object: function (t, p, v) { return t[p] = v; },
  transform: function (t, p, v, transforms, manual) {
    transforms.list.set(p, v);
    if (p === transforms.last || manual) {
      var str = '';
      transforms.list.forEach(function (value, prop) { str += prop + "(" + value + ") "; });
      t.style.transform = str;
    }
  }
};

// Set Value helper

function setTargetsValue(targets, properties) {
  var animatables = getAnimatables(targets);
  animatables.forEach(function (animatable) {
    for (var property in properties) {
      var value = getFunctionValue(properties[property], animatable);
      var target = animatable.target;
      var valueUnit = getUnit(value);
      var originalValue = getOriginalTargetValue(target, property, valueUnit, animatable);
      var unit = valueUnit || getUnit(originalValue);
      var to = getRelativeValue(validateValue(value, unit), originalValue);
      var animType = getAnimationType(target, property);
      setProgressValue[animType](target, property, to, animatable.transforms, true);
    }
  });
}

// Animations

function createAnimation(animatable, prop) {
  var animType = getAnimationType(animatable.target, prop.name);
  if (animType) {
    var tweens = normalizeTweens(prop, animatable);
    var lastTween = tweens[tweens.length - 1];
    return {
      type: animType,
      property: prop.name,
      animatable: animatable,
      tweens: tweens,
      duration: lastTween.end,
      delay: tweens[0].delay,
      endDelay: lastTween.endDelay
    }
  }
}

function getAnimations(animatables, properties) {
  return filterArray(flattenArray(animatables.map(function (animatable) {
    return properties.map(function (prop) {
      return createAnimation(animatable, prop);
    });
  })), function (a) { return !is.und(a); });
}

// Create Instance

function getInstanceTimings(animations, tweenSettings) {
  var animLength = animations.length;
  var getTlOffset = function (anim) { return anim.timelineOffset ? anim.timelineOffset : 0; };
  var timings = {};
  timings.duration = animLength ? Math.max.apply(Math, animations.map(function (anim) { return getTlOffset(anim) + anim.duration; })) : tweenSettings.duration;
  timings.delay = animLength ? Math.min.apply(Math, animations.map(function (anim) { return getTlOffset(anim) + anim.delay; })) : tweenSettings.delay;
  timings.endDelay = animLength ? timings.duration - Math.max.apply(Math, animations.map(function (anim) { return getTlOffset(anim) + anim.duration - anim.endDelay; })) : tweenSettings.endDelay;
  return timings;
}

var instanceID = 0;

function createNewInstance(params) {
  var instanceSettings = replaceObjectProps(defaultInstanceSettings, params);
  var tweenSettings = replaceObjectProps(defaultTweenSettings, params);
  var properties = getProperties(tweenSettings, params);
  var animatables = getAnimatables(params.targets);
  var animations = getAnimations(animatables, properties);
  var timings = getInstanceTimings(animations, tweenSettings);
  var id = instanceID;
  instanceID++;
  return mergeObjects(instanceSettings, {
    id: id,
    children: [],
    animatables: animatables,
    animations: animations,
    duration: timings.duration,
    delay: timings.delay,
    endDelay: timings.endDelay
  });
}

// Core

var activeInstances = [];

var engine = (function () {
  var raf;

  function play() {
    if (!raf && (!isDocumentHidden() || !anime.suspendWhenDocumentHidden) && activeInstances.length > 0) {
      raf = requestAnimationFrame(step);
    }
  }
  function step(t) {
    // memo on algorithm issue:
    // dangerous iteration over mutable `activeInstances`
    // (that collection may be updated from within callbacks of `tick`-ed animation instances)
    var activeInstancesLength = activeInstances.length;
    var i = 0;
    while (i < activeInstancesLength) {
      var activeInstance = activeInstances[i];
      if (!activeInstance.paused) {
        activeInstance.tick(t);
        i++;
      } else {
        activeInstances.splice(i, 1);
        activeInstancesLength--;
      }
    }
    raf = i > 0 ? requestAnimationFrame(step) : undefined;
  }

  function handleVisibilityChange() {
    if (!anime.suspendWhenDocumentHidden) { return; }

    if (isDocumentHidden()) {
      // suspend ticks
      raf = cancelAnimationFrame(raf);
    } else { // is back to active tab
      // first adjust animations to consider the time that ticks were suspended
      activeInstances.forEach(
        function (instance) { return instance ._onDocumentVisibility(); }
      );
      engine();
    }
  }
  if (typeof document !== 'undefined') {
    document.addEventListener('visibilitychange', handleVisibilityChange);
  }

  return play;
})();

function isDocumentHidden() {
  return !!document && document.hidden;
}

// Public Instance

function anime(params) {
  if ( params === void 0 ) params = {};


  var startTime = 0, lastTime = 0, now = 0;
  var children, childrenLength = 0;
  var resolve = null;

  function makePromise(instance) {
    var promise = window.Promise && new Promise(function (_resolve) { return resolve = _resolve; });
    instance.finished = promise;
    return promise;
  }

  var instance = createNewInstance(params);
  var promise = makePromise(instance);

  function toggleInstanceDirection() {
    var direction = instance.direction;
    if (direction !== 'alternate') {
      instance.direction = direction !== 'normal' ? 'normal' : 'reverse';
    }
    instance.reversed = !instance.reversed;
    children.forEach(function (child) { return child.reversed = instance.reversed; });
  }

  function adjustTime(time) {
    return instance.reversed ? instance.duration - time : time;
  }

  function resetTime() {
    startTime = 0;
    lastTime = adjustTime(instance.currentTime) * (1 / anime.speed);
  }

  function seekChild(time, child) {
    if (child) { child.seek(time - child.timelineOffset); }
  }

  function syncInstanceChildren(time) {
    if (!instance.reversePlayback) {
      for (var i = 0; i < childrenLength; i++) { seekChild(time, children[i]); }
    } else {
      for (var i$1 = childrenLength; i$1--;) { seekChild(time, children[i$1]); }
    }
  }

  function setAnimationsProgress(insTime) {
    var i = 0;
    var animations = instance.animations;
    var animationsLength = animations.length;
    while (i < animationsLength) {
      var anim = animations[i];
      var animatable = anim.animatable;
      var tweens = anim.tweens;
      var tweenLength = tweens.length - 1;
      var tween = tweens[tweenLength];
      // Only check for keyframes if there is more than one tween
      if (tweenLength) { tween = filterArray(tweens, function (t) { return (insTime < t.end); })[0] || tween; }
      var elapsed = minMax(insTime - tween.start - tween.delay, 0, tween.duration) / tween.duration;
      var eased = isNaN(elapsed) ? 1 : tween.easing(elapsed);
      var strings = tween.to.strings;
      var round = tween.round;
      var numbers = [];
      var toNumbersLength = tween.to.numbers.length;
      var progress = (void 0);
      for (var n = 0; n < toNumbersLength; n++) {
        var value = (void 0);
        var toNumber = tween.to.numbers[n];
        var fromNumber = tween.from.numbers[n] || 0;
        if (!tween.isPath) {
          value = fromNumber + (eased * (toNumber - fromNumber));
        } else {
          value = getPathProgress(tween.value, eased * toNumber, tween.isPathTargetInsideSVG);
        }
        if (round) {
          if (!(tween.isColor && n > 2)) {
            value = Math.round(value * round) / round;
          }
        }
        numbers.push(value);
      }
      // Manual Array.reduce for better performances
      var stringsLength = strings.length;
      if (!stringsLength) {
        progress = numbers[0];
      } else {
        progress = strings[0];
        for (var s = 0; s < stringsLength; s++) {
          var a = strings[s];
          var b = strings[s + 1];
          var n$1 = numbers[s];
          if (!isNaN(n$1)) {
            if (!b) {
              progress += n$1 + ' ';
            } else {
              progress += n$1 + b;
            }
          }
        }
      }
      setProgressValue[anim.type](animatable.target, anim.property, progress, animatable.transforms);
      anim.currentValue = progress;
      i++;
    }
  }

  function setCallback(cb) {
    if (instance[cb] && !instance.passThrough) { instance[cb](instance); }
  }

  function countIteration() {
    if (instance.remaining && instance.remaining !== true) {
      instance.remaining--;
    }
  }

  function setInstanceProgress(engineTime) {
    var insDuration = instance.duration;
    var insDelay = instance.delay;
    var insEndDelay = insDuration - instance.endDelay;
    var insTime = adjustTime(engineTime);
    instance.progress = minMax((insTime / insDuration) * 100, 0, 100);
    instance.reversePlayback = insTime < instance.currentTime;
    if (children) { syncInstanceChildren(insTime); }
    if (!instance.began && instance.currentTime > 0) {
      instance.began = true;
      setCallback('begin');
    }
    if (!instance.loopBegan && instance.currentTime > 0) {
      instance.loopBegan = true;
      setCallback('loopBegin');
    }
    if (insTime <= insDelay && instance.currentTime !== 0) {
      setAnimationsProgress(0);
    }
    if ((insTime >= insEndDelay && instance.currentTime !== insDuration) || !insDuration) {
      setAnimationsProgress(insDuration);
    }
    if (insTime > insDelay && insTime < insEndDelay) {
      if (!instance.changeBegan) {
        instance.changeBegan = true;
        instance.changeCompleted = false;
        setCallback('changeBegin');
      }
      setCallback('change');
      setAnimationsProgress(insTime);
    } else {
      if (instance.changeBegan) {
        instance.changeCompleted = true;
        instance.changeBegan = false;
        setCallback('changeComplete');
      }
    }
    instance.currentTime = minMax(insTime, 0, insDuration);
    if (instance.began) { setCallback('update'); }
    if (engineTime >= insDuration) {
      lastTime = 0;
      countIteration();
      if (!instance.remaining) {
        instance.paused = true;
        if (!instance.completed) {
          instance.completed = true;
          setCallback('loopComplete');
          setCallback('complete');
          if (!instance.passThrough && 'Promise' in window) {
            resolve();
            promise = makePromise(instance);
          }
        }
      } else {
        startTime = now;
        setCallback('loopComplete');
        instance.loopBegan = false;
        if (instance.direction === 'alternate') {
          toggleInstanceDirection();
        }
      }
    }
  }

  instance.reset = function() {
    var direction = instance.direction;
    instance.passThrough = false;
    instance.currentTime = 0;
    instance.progress = 0;
    instance.paused = true;
    instance.began = false;
    instance.loopBegan = false;
    instance.changeBegan = false;
    instance.completed = false;
    instance.changeCompleted = false;
    instance.reversePlayback = false;
    instance.reversed = direction === 'reverse';
    instance.remaining = instance.loop;
    children = instance.children;
    childrenLength = children.length;
    for (var i = childrenLength; i--;) { instance.children[i].reset(); }
    if (instance.reversed && instance.loop !== true || (direction === 'alternate' && instance.loop === 1)) { instance.remaining++; }
    setAnimationsProgress(instance.reversed ? instance.duration : 0);
  };

  // internal method (for engine) to adjust animation timings before restoring engine ticks (rAF)
  instance._onDocumentVisibility = resetTime;

  // Set Value helper

  instance.set = function(targets, properties) {
    setTargetsValue(targets, properties);
    return instance;
  };

  instance.tick = function(t) {
    now = t;
    if (!startTime) { startTime = now; }
    setInstanceProgress((now + (lastTime - startTime)) * anime.speed);
  };

  instance.seek = function(time) {
    setInstanceProgress(adjustTime(time));
  };

  instance.pause = function() {
    instance.paused = true;
    resetTime();
  };

  instance.play = function() {
    if (!instance.paused) { return; }
    if (instance.completed) { instance.reset(); }
    instance.paused = false;
    activeInstances.push(instance);
    resetTime();
    engine();
  };

  instance.reverse = function() {
    toggleInstanceDirection();
    instance.completed = instance.reversed ? false : true;
    resetTime();
  };

  instance.restart = function() {
    instance.reset();
    instance.play();
  };

  instance.remove = function(targets) {
    var targetsArray = parseTargets(targets);
    removeTargetsFromInstance(targetsArray, instance);
  };

  instance.reset();

  if (instance.autoplay) { instance.play(); }

  return instance;

}

// Remove targets from animation

function removeTargetsFromAnimations(targetsArray, animations) {
  for (var a = animations.length; a--;) {
    if (arrayContains(targetsArray, animations[a].animatable.target)) {
      animations.splice(a, 1);
    }
  }
}

function removeTargetsFromInstance(targetsArray, instance) {
  var animations = instance.animations;
  var children = instance.children;
  removeTargetsFromAnimations(targetsArray, animations);
  for (var c = children.length; c--;) {
    var child = children[c];
    var childAnimations = child.animations;
    removeTargetsFromAnimations(targetsArray, childAnimations);
    if (!childAnimations.length && !child.children.length) { children.splice(c, 1); }
  }
  if (!animations.length && !children.length) { instance.pause(); }
}

function removeTargetsFromActiveInstances(targets) {
  var targetsArray = parseTargets(targets);
  for (var i = activeInstances.length; i--;) {
    var instance = activeInstances[i];
    removeTargetsFromInstance(targetsArray, instance);
  }
}

// Stagger helpers

function stagger(val, params) {
  if ( params === void 0 ) params = {};

  var direction = params.direction || 'normal';
  var easing = params.easing ? parseEasings(params.easing) : null;
  var grid = params.grid;
  var axis = params.axis;
  var fromIndex = params.from || 0;
  var fromFirst = fromIndex === 'first';
  var fromCenter = fromIndex === 'center';
  var fromLast = fromIndex === 'last';
  var isRange = is.arr(val);
  var val1 = isRange ? parseFloat(val[0]) : parseFloat(val);
  var val2 = isRange ? parseFloat(val[1]) : 0;
  var unit = getUnit(isRange ? val[1] : val) || 0;
  var start = params.start || 0 + (isRange ? val1 : 0);
  var values = [];
  var maxValue = 0;
  return function (el, i, t) {
    if (fromFirst) { fromIndex = 0; }
    if (fromCenter) { fromIndex = (t - 1) / 2; }
    if (fromLast) { fromIndex = t - 1; }
    if (!values.length) {
      for (var index = 0; index < t; index++) {
        if (!grid) {
          values.push(Math.abs(fromIndex - index));
        } else {
          var fromX = !fromCenter ? fromIndex%grid[0] : (grid[0]-1)/2;
          var fromY = !fromCenter ? Math.floor(fromIndex/grid[0]) : (grid[1]-1)/2;
          var toX = index%grid[0];
          var toY = Math.floor(index/grid[0]);
          var distanceX = fromX - toX;
          var distanceY = fromY - toY;
          var value = Math.sqrt(distanceX * distanceX + distanceY * distanceY);
          if (axis === 'x') { value = -distanceX; }
          if (axis === 'y') { value = -distanceY; }
          values.push(value);
        }
        maxValue = Math.max.apply(Math, values);
      }
      if (easing) { values = values.map(function (val) { return easing(val / maxValue) * maxValue; }); }
      if (direction === 'reverse') { values = values.map(function (val) { return axis ? (val < 0) ? val * -1 : -val : Math.abs(maxValue - val); }); }
    }
    var spacing = isRange ? (val2 - val1) / maxValue : val1;
    return start + (spacing * (Math.round(values[i] * 100) / 100)) + unit;
  }
}

// Timeline

function timeline(params) {
  if ( params === void 0 ) params = {};

  var tl = anime(params);
  tl.duration = 0;
  tl.add = function(instanceParams, timelineOffset) {
    var tlIndex = activeInstances.indexOf(tl);
    var children = tl.children;
    if (tlIndex > -1) { activeInstances.splice(tlIndex, 1); }
    function passThrough(ins) { ins.passThrough = true; }
    for (var i = 0; i < children.length; i++) { passThrough(children[i]); }
    var insParams = mergeObjects(instanceParams, replaceObjectProps(defaultTweenSettings, params));
    insParams.targets = insParams.targets || params.targets;
    var tlDuration = tl.duration;
    insParams.autoplay = false;
    insParams.direction = tl.direction;
    insParams.timelineOffset = is.und(timelineOffset) ? tlDuration : getRelativeValue(timelineOffset, tlDuration);
    passThrough(tl);
    tl.seek(insParams.timelineOffset);
    var ins = anime(insParams);
    passThrough(ins);
    children.push(ins);
    var timings = getInstanceTimings(children, params);
    tl.delay = timings.delay;
    tl.endDelay = timings.endDelay;
    tl.duration = timings.duration;
    tl.seek(0);
    tl.reset();
    if (tl.autoplay) { tl.play(); }
    return tl;
  };
  return tl;
}

anime.version = '3.2.1';
anime.speed = 1;
// TODO:#review: naming, documentation
anime.suspendWhenDocumentHidden = true;
anime.running = activeInstances;
anime.remove = removeTargetsFromActiveInstances;
anime.get = getOriginalTargetValue;
anime.set = setTargetsValue;
anime.convertPx = convertPxToUnit;
anime.path = getPath;
anime.setDashoffset = setDashoffset;
anime.stagger = stagger;
anime.timeline = timeline;
anime.easing = parseEasings;
anime.penner = penner;
anime.random = function (min, max) { return Math.floor(Math.random() * (max - min + 1)) + min; };

/* harmony default export */ __webpack_exports__["default"] = (anime);


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var isNative = __webpack_require__(442);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var getLength = __webpack_require__(444),
    isLength = __webpack_require__(60);

/**
 * Checks if `value` is array-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value));
}

module.exports = isArrayLike;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(164),
    isObjectLike = __webpack_require__(59);

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Native method references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is classified as an `arguments` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  return isObjectLike(value) && isArrayLike(value) &&
    hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
}

module.exports = isArguments;


/***/ }),
/* 166 */
/***/ (function(module, exports) {

/** Used to detect unsigned integer values. */
var reIsUint = /^\d+$/;

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
  length = length == null ? MAX_SAFE_INTEGER : length;
  return value > -1 && value % 1 == 0 && value < length;
}

module.exports = isIndex;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _partialUpdate = __webpack_require__(45);

Object.keys(_partialUpdate).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _partialUpdate[key];
    }
  });
});

var _XHRQueue = __webpack_require__(110);

Object.keys(_XHRQueue).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _XHRQueue[key];
    }
  });
});

var _PartialUpdateSettings = __webpack_require__(51);

Object.keys(_PartialUpdateSettings).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _PartialUpdateSettings[key];
    }
  });
});

var _partialUpdateUtils = __webpack_require__(46);

Object.keys(_partialUpdateUtils).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _partialUpdateUtils[key];
    }
  });
});

var _formsChangesChecker = __webpack_require__(157);

Object.keys(_formsChangesChecker).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _formsChangesChecker[key];
    }
  });
});

var _eventsFromDOMDatasetsRegister = __webpack_require__(158);

Object.keys(_eventsFromDOMDatasetsRegister).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _eventsFromDOMDatasetsRegister[key];
    }
  });
});

var _connectHistory = __webpack_require__(159);

Object.defineProperty(exports, 'partialUpdateConnectHistory', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_connectHistory).default;
  }
});

var _connectLinksListeners = __webpack_require__(160);

Object.defineProperty(exports, 'partialUpdateConnectLinksListeners', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_connectLinksListeners).default;
  }
});

var _connectFormsSubmitListeners = __webpack_require__(161);

Object.defineProperty(exports, 'partialUpdateConnectFormsSubmitListeners', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_connectFormsSubmitListeners).default;
  }
});

var _index = __webpack_require__(109);

Object.defineProperty(exports, 'getNamesArray', {
  enumerable: true,
  get: function get() {
    return _index.getNamesArray;
  }
});
Object.defineProperty(exports, 'removeFromData', {
  enumerable: true,
  get: function get() {
    return _index.removeFromData;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onChangeXHRQueue = exports.removeFromQueue = exports.pushToQueue = exports.setCursorState = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // 


var _XHRQueue = __webpack_require__(110);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var cursorState = {
  left: 10,
  top: 10,
  visible: true,
  show: false,
  progresses: []
};
var cursorElement = void 0;

var setCursorState = exports.setCursorState = function setCursorState(newState) {
  cursorState = _extends({}, cursorState, newState);

  var _cursorState = cursorState,
      left = _cursorState.left,
      top = _cursorState.top,
      visible = _cursorState.visible,
      show = _cursorState.show,
      progresses = _cursorState.progresses;

  var hidden = (!show || !visible) && progresses.length === 0;

  if (hidden) {
    if (cursorElement) {
      cursorElement.remove();
      cursorElement = null;
    }
    return;
  }

  if (!cursorElement) {
    cursorElement = document.createElement('div');
    cursorElement.classList.add('cursor-spinner');
    cursorElement.innerHTML = '<span class="cursor-spinner__1"></span><span class="cursor-spinner__2"></span><span class="cursor-spinner__3"></span><img class="cursor-spinner__img" src="data:image/gif;base64,R0lGODlhEAAQAKIGANjY2O7u7mRkZAQEBE5OTr6+vv///wAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQFAAAGACwAAAAAEAAQAAADKWi63P4wykkVuMBijUPIBuCB4leSozWe6tdeaRifrOza2MWRW+X/wEYCACH5BAkKAAYALAAAAwAEAAsAAAMLOKpE7KO9GaGsdCUAIfkECQoABgAsAAAAABAAEAAAAzFoutz+MMZBhxNYqEGIbUJRaAbnXSJpfkw4bh27uGqMvqUNpvC546tLpieDVIqSpDIBACH5BAkKAAYALAAAAAAQABAAAAM9aLrc/jDKNupwIgs1CBlACChCUWxG9wFBMBrlyXlg+8aoWrukmdMsHsw3W9l6shRQhPx9MJriZWKZTq6PBAAh+QQFCgAGACwAAAAAEAAQAAADMmi63P4wyimFFSADpbcRRYEFgQeQHiieJYcq6tgabBrK5vvdtTvHHY4GdqNcBJSkMpIAACH5BAkKAAYALAYAAwAKAAsAAAMYODrWPoQw16CkNU5q99OY0YUjVnKguYQJACH5BAkKAAYALAAAAAAQABAAAAM8aLrc/jCuQYdUgxBrhBdOtilCUYAGoAIiV54KEASs5pqoTLckHs+1UceXAvKGsOLO1kuugq5PqHKpWiEJACH5BAkKAAYALAAAAAAQABAAAAMzaLrc/jDKKKqYRpRyDfiAAgIaJwZB6KHk1gHsmZZvvM6urMK4ee8smgg0/Fg6mKRyyUgAACH5BAUKAAYALAAAAAAQABAAAAMpaLrc/jDKSRW4wGKNQ8gG4IHiV5KjNZ7q115pGJ+s7NrYxZFb5f/ARgIAIfkEBSMABgAsAAAAAAEAAQAAAwJoCQA7" style="width:16px;height:16px;" />';
    cursorElement.style.position = 'fixed';
    cursorElement.style.overflow = 'hidden';
    cursorElement.style.zIndex = 1000000;
    document.body.appendChild(cursorElement);
  }

  cursorElement.style.display = hidden ? 'none' : 'block';
  cursorElement.style.left = left + 'px';
  cursorElement.style.top = top + 'px';
};

var handleMouseMove = function handleMouseMove(_ref) {
  var clientX = _ref.clientX,
      clientY = _ref.clientY;

  var newState = {
    left: clientX + 18,
    top: clientY + 18,
    visible: true
  };
  if (clientX < 10 || clientY < 10) {
    newState.visible = false;
  }
  if (clientX >= window.innerWidth - 50 || clientY >= window.innerHeight - 50) {
    newState.visible = false;
  }
  setCursorState(newState);
};

document.addEventListener('mousemove', handleMouseMove);

// Na základě stavu se zobrazuje loader
// loader se zobrazí jen pokud akce trvá déle než 210ms
// je to doba po které uživatel registruje prodlevu
var progressUpdateTimeout = void 0;

/**
 *  Přidání procesu do fronty spinneru.
 *  Spinner se zobrazuje pokud fronta obsahuje alespoň jedenu položku
 */
var pushToQueue = exports.pushToQueue = function pushToQueue(progressId) {
  var newProgress = [].concat(_toConsumableArray(cursorState.progresses));
  newProgress.push(progressId);
  setCursorState({
    progresses: newProgress
  });
};

/**
 * Odebrání prosesu z fronty spinneru
 */
var removeFromQueue = exports.removeFromQueue = function removeFromQueue(progressId) {
  setCursorState({
    progresses: [].concat(_toConsumableArray(cursorState.progresses)).filter(function (item) {
      return item !== progressId;
    })
  });
};

/**
 * Handler pro změnu fronty XHR z partial updatu
 */
var onChangeXHRQueue = exports.onChangeXHRQueue = function onChangeXHRQueue() {
  clearTimeout(progressUpdateTimeout);
  var progress = (0, _XHRQueue.isInProgress)();
  if (progress) {
    progressUpdateTimeout = setTimeout(function () {
      setCursorState({ show: (0, _XHRQueue.isInProgress)() });
    }, 210);
  } else {
    setCursorState({ show: (0, _XHRQueue.isInProgress)() });
  }
};

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(170);


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(171);

__webpack_require__(172);

__webpack_require__(374);

__webpack_require__(375);

__webpack_require__(376);

__webpack_require__(377);

__webpack_require__(406);

__webpack_require__(458);

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1749448655837
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(173);

__webpack_require__(370);

__webpack_require__(371);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61)))

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(174);
__webpack_require__(177);
__webpack_require__(178);
__webpack_require__(179);
__webpack_require__(180);
__webpack_require__(181);
__webpack_require__(182);
__webpack_require__(183);
__webpack_require__(184);
__webpack_require__(185);
__webpack_require__(186);
__webpack_require__(187);
__webpack_require__(188);
__webpack_require__(189);
__webpack_require__(190);
__webpack_require__(191);
__webpack_require__(192);
__webpack_require__(193);
__webpack_require__(194);
__webpack_require__(195);
__webpack_require__(196);
__webpack_require__(197);
__webpack_require__(198);
__webpack_require__(199);
__webpack_require__(200);
__webpack_require__(201);
__webpack_require__(202);
__webpack_require__(203);
__webpack_require__(204);
__webpack_require__(205);
__webpack_require__(206);
__webpack_require__(207);
__webpack_require__(208);
__webpack_require__(209);
__webpack_require__(210);
__webpack_require__(211);
__webpack_require__(212);
__webpack_require__(213);
__webpack_require__(214);
__webpack_require__(215);
__webpack_require__(216);
__webpack_require__(217);
__webpack_require__(218);
__webpack_require__(219);
__webpack_require__(220);
__webpack_require__(221);
__webpack_require__(222);
__webpack_require__(223);
__webpack_require__(224);
__webpack_require__(225);
__webpack_require__(226);
__webpack_require__(227);
__webpack_require__(228);
__webpack_require__(229);
__webpack_require__(230);
__webpack_require__(231);
__webpack_require__(232);
__webpack_require__(233);
__webpack_require__(234);
__webpack_require__(235);
__webpack_require__(236);
__webpack_require__(237);
__webpack_require__(238);
__webpack_require__(239);
__webpack_require__(240);
__webpack_require__(241);
__webpack_require__(242);
__webpack_require__(243);
__webpack_require__(244);
__webpack_require__(245);
__webpack_require__(246);
__webpack_require__(247);
__webpack_require__(248);
__webpack_require__(249);
__webpack_require__(250);
__webpack_require__(251);
__webpack_require__(252);
__webpack_require__(254);
__webpack_require__(255);
__webpack_require__(257);
__webpack_require__(258);
__webpack_require__(259);
__webpack_require__(260);
__webpack_require__(261);
__webpack_require__(262);
__webpack_require__(263);
__webpack_require__(265);
__webpack_require__(266);
__webpack_require__(267);
__webpack_require__(268);
__webpack_require__(269);
__webpack_require__(270);
__webpack_require__(271);
__webpack_require__(272);
__webpack_require__(273);
__webpack_require__(274);
__webpack_require__(275);
__webpack_require__(276);
__webpack_require__(277);
__webpack_require__(99);
__webpack_require__(278);
__webpack_require__(133);
__webpack_require__(279);
__webpack_require__(134);
__webpack_require__(280);
__webpack_require__(281);
__webpack_require__(282);
__webpack_require__(283);
__webpack_require__(284);
__webpack_require__(137);
__webpack_require__(139);
__webpack_require__(140);
__webpack_require__(285);
__webpack_require__(286);
__webpack_require__(287);
__webpack_require__(288);
__webpack_require__(289);
__webpack_require__(290);
__webpack_require__(291);
__webpack_require__(292);
__webpack_require__(293);
__webpack_require__(294);
__webpack_require__(295);
__webpack_require__(296);
__webpack_require__(297);
__webpack_require__(298);
__webpack_require__(299);
__webpack_require__(300);
__webpack_require__(301);
__webpack_require__(302);
__webpack_require__(303);
__webpack_require__(304);
__webpack_require__(305);
__webpack_require__(306);
__webpack_require__(307);
__webpack_require__(308);
__webpack_require__(309);
__webpack_require__(310);
__webpack_require__(311);
__webpack_require__(312);
__webpack_require__(313);
__webpack_require__(314);
__webpack_require__(315);
__webpack_require__(316);
__webpack_require__(317);
__webpack_require__(318);
__webpack_require__(319);
__webpack_require__(320);
__webpack_require__(321);
__webpack_require__(322);
__webpack_require__(323);
__webpack_require__(324);
__webpack_require__(325);
__webpack_require__(326);
__webpack_require__(327);
__webpack_require__(328);
__webpack_require__(329);
__webpack_require__(330);
__webpack_require__(331);
__webpack_require__(332);
__webpack_require__(333);
__webpack_require__(334);
__webpack_require__(335);
__webpack_require__(336);
__webpack_require__(337);
__webpack_require__(338);
__webpack_require__(339);
__webpack_require__(340);
__webpack_require__(341);
__webpack_require__(342);
__webpack_require__(343);
__webpack_require__(344);
__webpack_require__(345);
__webpack_require__(346);
__webpack_require__(347);
__webpack_require__(348);
__webpack_require__(349);
__webpack_require__(350);
__webpack_require__(351);
__webpack_require__(352);
__webpack_require__(353);
__webpack_require__(354);
__webpack_require__(355);
__webpack_require__(356);
__webpack_require__(357);
__webpack_require__(358);
__webpack_require__(359);
__webpack_require__(360);
__webpack_require__(361);
__webpack_require__(362);
__webpack_require__(363);
__webpack_require__(364);
__webpack_require__(365);
__webpack_require__(366);
__webpack_require__(367);
__webpack_require__(368);
__webpack_require__(369);
module.exports = __webpack_require__(20);


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(2);
var has = __webpack_require__(16);
var DESCRIPTORS = __webpack_require__(8);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(13);
var META = __webpack_require__(32).KEY;
var $fails = __webpack_require__(4);
var shared = __webpack_require__(52);
var setToStringTag = __webpack_require__(47);
var uid = __webpack_require__(35);
var wks = __webpack_require__(6);
var wksExt = __webpack_require__(115);
var wksDefine = __webpack_require__(80);
var enumKeys = __webpack_require__(176);
var isArray = __webpack_require__(64);
var anObject = __webpack_require__(1);
var isObject = __webpack_require__(5);
var toObject = __webpack_require__(10);
var toIObject = __webpack_require__(17);
var toPrimitive = __webpack_require__(25);
var createDesc = __webpack_require__(34);
var _create = __webpack_require__(38);
var gOPNExt = __webpack_require__(118);
var $GOPD = __webpack_require__(18);
var $GOPS = __webpack_require__(63);
var $DP = __webpack_require__(9);
var $keys = __webpack_require__(36);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(39).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(54).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(31)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(12)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(52)('native-function-to-string', Function.toString);


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(36);
var gOPS = __webpack_require__(63);
var pIE = __webpack_require__(54);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(38) });


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(8), 'Object', { defineProperty: __webpack_require__(9).f });


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(8), 'Object', { defineProperties: __webpack_require__(117) });


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(17);
var $getOwnPropertyDescriptor = __webpack_require__(18).f;

__webpack_require__(27)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(10);
var $getPrototypeOf = __webpack_require__(19);

__webpack_require__(27)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(10);
var $keys = __webpack_require__(36);

__webpack_require__(27)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(27)('getOwnPropertyNames', function () {
  return __webpack_require__(118).f;
});


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(5);
var meta = __webpack_require__(32).onFreeze;

__webpack_require__(27)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(5);
var meta = __webpack_require__(32).onFreeze;

__webpack_require__(27)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(5);
var meta = __webpack_require__(32).onFreeze;

__webpack_require__(27)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(5);

__webpack_require__(27)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(5);

__webpack_require__(27)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(5);

__webpack_require__(27)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(0);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(119) });


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { is: __webpack_require__(120) });


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(84).set });


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(48);
var test = {};
test[__webpack_require__(6)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(13)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(0);

$export($export.P, 'Function', { bind: __webpack_require__(121) });


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(9).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(8) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(5);
var getPrototypeOf = __webpack_require__(19);
var HAS_INSTANCE = __webpack_require__(6)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(9).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(123);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(124);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(2);
var has = __webpack_require__(16);
var cof = __webpack_require__(22);
var inheritIfRequired = __webpack_require__(86);
var toPrimitive = __webpack_require__(25);
var fails = __webpack_require__(4);
var gOPN = __webpack_require__(39).f;
var gOPD = __webpack_require__(18).f;
var dP = __webpack_require__(9).f;
var $trim = __webpack_require__(49).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(38)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(8) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(13)(global, NUMBER, $Number);
}


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toInteger = __webpack_require__(23);
var aNumberValue = __webpack_require__(125);
var repeat = __webpack_require__(87);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(4)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $fails = __webpack_require__(4);
var aNumberValue = __webpack_require__(125);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(0);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(0);
var _isFinite = __webpack_require__(2).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', { isInteger: __webpack_require__(126) });


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(0);
var isInteger = __webpack_require__(126);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(124);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(123);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(0);
var log1p = __webpack_require__(127);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(0);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(0);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(0);
var sign = __webpack_require__(88);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(0);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(0);
var $expm1 = __webpack_require__(89);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { fround: __webpack_require__(128) });


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(0);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(0);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(4)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { log1p: __webpack_require__(127) });


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { sign: __webpack_require__(88) });


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(89);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(4)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(89);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toAbsoluteIndex = __webpack_require__(37);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(17);
var toLength = __webpack_require__(7);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(49)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(65)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(90)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $at = __webpack_require__(65)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(7);
var context = __webpack_require__(92);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(93)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(0);
var context = __webpack_require__(92);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(93)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(87)
});


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(7);
var context = __webpack_require__(92);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(93)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(14)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(14)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(14)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(14)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(14)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(14)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(14)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(14)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(14)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(14)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(14)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(14)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(14)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(0);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(10);
var toPrimitive = __webpack_require__(25);

$export($export.P + $export.F * __webpack_require__(4)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(0);
var toISOString = __webpack_require__(253);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(4);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(13)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(6)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(12)(proto, TO_PRIMITIVE, __webpack_require__(256));


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(1);
var toPrimitive = __webpack_require__(25);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(0);

$export($export.S, 'Array', { isArray: __webpack_require__(64) });


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(21);
var $export = __webpack_require__(0);
var toObject = __webpack_require__(10);
var call = __webpack_require__(129);
var isArrayIter = __webpack_require__(94);
var toLength = __webpack_require__(7);
var createProperty = __webpack_require__(95);
var getIterFn = __webpack_require__(96);

$export($export.S + $export.F * !__webpack_require__(67)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var createProperty = __webpack_require__(95);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(4)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(0);
var toIObject = __webpack_require__(17);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(53) != Object || !__webpack_require__(24)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var html = __webpack_require__(83);
var cof = __webpack_require__(22);
var toAbsoluteIndex = __webpack_require__(37);
var toLength = __webpack_require__(7);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(4)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var aFunction = __webpack_require__(11);
var toObject = __webpack_require__(10);
var fails = __webpack_require__(4);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(24)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $forEach = __webpack_require__(28)(0);
var STRICT = __webpack_require__(24)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(5);
var isArray = __webpack_require__(64);
var SPECIES = __webpack_require__(6)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $map = __webpack_require__(28)(1);

$export($export.P + $export.F * !__webpack_require__(24)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $filter = __webpack_require__(28)(2);

$export($export.P + $export.F * !__webpack_require__(24)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $some = __webpack_require__(28)(3);

$export($export.P + $export.F * !__webpack_require__(24)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $every = __webpack_require__(28)(4);

$export($export.P + $export.F * !__webpack_require__(24)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(130);

$export($export.P + $export.F * !__webpack_require__(24)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(130);

$export($export.P + $export.F * !__webpack_require__(24)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $indexOf = __webpack_require__(62)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(24)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(17);
var toInteger = __webpack_require__(23);
var toLength = __webpack_require__(7);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(24)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { copyWithin: __webpack_require__(131) });

__webpack_require__(33)('copyWithin');


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { fill: __webpack_require__(98) });

__webpack_require__(33)('fill');


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(28)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(33)(KEY);


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(28)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(33)(KEY);


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(40)('Array');


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var inheritIfRequired = __webpack_require__(86);
var dP = __webpack_require__(9).f;
var gOPN = __webpack_require__(39).f;
var isRegExp = __webpack_require__(66);
var $flags = __webpack_require__(55);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(8) && (!CORRECT_NEW || __webpack_require__(4)(function () {
  re2[__webpack_require__(6)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(13)(global, 'RegExp', $RegExp);
}

__webpack_require__(40)('RegExp');


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(134);
var anObject = __webpack_require__(1);
var $flags = __webpack_require__(55);
var DESCRIPTORS = __webpack_require__(8);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(13)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(4)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(1);
var toLength = __webpack_require__(7);
var advanceStringIndex = __webpack_require__(101);
var regExpExec = __webpack_require__(68);

// @@match logic
__webpack_require__(69)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(1);
var toObject = __webpack_require__(10);
var toLength = __webpack_require__(7);
var toInteger = __webpack_require__(23);
var advanceStringIndex = __webpack_require__(101);
var regExpExec = __webpack_require__(68);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(69)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(1);
var sameValue = __webpack_require__(120);
var regExpExec = __webpack_require__(68);

// @@search logic
__webpack_require__(69)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(66);
var anObject = __webpack_require__(1);
var speciesConstructor = __webpack_require__(56);
var advanceStringIndex = __webpack_require__(101);
var toLength = __webpack_require__(7);
var callRegExpExec = __webpack_require__(68);
var regexpExec = __webpack_require__(100);
var fails = __webpack_require__(4);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(69)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(31);
var global = __webpack_require__(2);
var ctx = __webpack_require__(21);
var classof = __webpack_require__(48);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(5);
var aFunction = __webpack_require__(11);
var anInstance = __webpack_require__(41);
var forOf = __webpack_require__(42);
var speciesConstructor = __webpack_require__(56);
var task = __webpack_require__(102).set;
var microtask = __webpack_require__(103)();
var newPromiseCapabilityModule = __webpack_require__(104);
var perform = __webpack_require__(135);
var userAgent = __webpack_require__(70);
var promiseResolve = __webpack_require__(136);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(6)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(43)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(47)($Promise, PROMISE);
__webpack_require__(40)(PROMISE);
Wrapper = __webpack_require__(20)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(67)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(141);
var validate = __webpack_require__(44);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(71)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $typed = __webpack_require__(72);
var buffer = __webpack_require__(105);
var anObject = __webpack_require__(1);
var toAbsoluteIndex = __webpack_require__(37);
var toLength = __webpack_require__(7);
var isObject = __webpack_require__(5);
var ArrayBuffer = __webpack_require__(2).ArrayBuffer;
var speciesConstructor = __webpack_require__(56);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(4)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(40)(ARRAY_BUFFER);


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
$export($export.G + $export.W + $export.F * !__webpack_require__(72).ABV, {
  DataView: __webpack_require__(105).DataView
});


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(29)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(29)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(29)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(29)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(29)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(29)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(29)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(29)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(29)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(11);
var anObject = __webpack_require__(1);
var rApply = (__webpack_require__(2).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(4)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(0);
var create = __webpack_require__(38);
var aFunction = __webpack_require__(11);
var anObject = __webpack_require__(1);
var isObject = __webpack_require__(5);
var fails = __webpack_require__(4);
var bind = __webpack_require__(121);
var rConstruct = (__webpack_require__(2).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(9);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(1);
var toPrimitive = __webpack_require__(25);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(4)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(0);
var gOPD = __webpack_require__(18).f;
var anObject = __webpack_require__(1);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(1);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(91)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(18);
var getPrototypeOf = __webpack_require__(19);
var has = __webpack_require__(16);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(5);
var anObject = __webpack_require__(1);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(18);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(1);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(0);
var getProto = __webpack_require__(19);
var anObject = __webpack_require__(1);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(1);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(143) });


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(1);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(9);
var gOPD = __webpack_require__(18);
var getPrototypeOf = __webpack_require__(19);
var has = __webpack_require__(16);
var $export = __webpack_require__(0);
var createDesc = __webpack_require__(34);
var anObject = __webpack_require__(1);
var isObject = __webpack_require__(5);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(0);
var setProto = __webpack_require__(84);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(0);
var $includes = __webpack_require__(62)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(33)('includes');


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(144);
var toObject = __webpack_require__(10);
var toLength = __webpack_require__(7);
var aFunction = __webpack_require__(11);
var arraySpeciesCreate = __webpack_require__(97);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(33)('flatMap');


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(144);
var toObject = __webpack_require__(10);
var toLength = __webpack_require__(7);
var toInteger = __webpack_require__(23);
var arraySpeciesCreate = __webpack_require__(97);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(33)('flatten');


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(0);
var $at = __webpack_require__(65)(true);
var $fails = __webpack_require__(4);

var FORCED = $fails(function () {
  return '𠮷'.at(0) !== '𠮷';
});

$export($export.P + $export.F * FORCED, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(145);
var userAgent = __webpack_require__(70);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(145);
var userAgent = __webpack_require__(70);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(49)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(49)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(0);
var defined = __webpack_require__(26);
var toLength = __webpack_require__(7);
var isRegExp = __webpack_require__(66);
var getFlags = __webpack_require__(55);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(91)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(80)('asyncIterator');


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(80)('observable');


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(0);
var ownKeys = __webpack_require__(143);
var toIObject = __webpack_require__(17);
var gOPD = __webpack_require__(18);
var createProperty = __webpack_require__(95);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $values = __webpack_require__(146)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $entries = __webpack_require__(146)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(10);
var aFunction = __webpack_require__(11);
var $defineProperty = __webpack_require__(9);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(8) && $export($export.P + __webpack_require__(73), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(10);
var aFunction = __webpack_require__(11);
var $defineProperty = __webpack_require__(9);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(8) && $export($export.P + __webpack_require__(73), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(10);
var toPrimitive = __webpack_require__(25);
var getPrototypeOf = __webpack_require__(19);
var getOwnPropertyDescriptor = __webpack_require__(18).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(8) && $export($export.P + __webpack_require__(73), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(10);
var toPrimitive = __webpack_require__(25);
var getPrototypeOf = __webpack_require__(19);
var getOwnPropertyDescriptor = __webpack_require__(18).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(8) && $export($export.P + __webpack_require__(73), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(147)('Map') });


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(147)('Set') });


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(74)('Map');


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(74)('Set');


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(74)('WeakMap');


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(74)('WeakSet');


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(75)('Map');


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(75)('Set');


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(75)('WeakMap');


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(75)('WeakSet');


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.G, { global: __webpack_require__(2) });


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.S, 'System', { global: __webpack_require__(2) });


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(0);
var cof = __webpack_require__(22);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var scale = __webpack_require__(149);
var fround = __webpack_require__(128);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { scale: __webpack_require__(149) });


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(0);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(0);
var core = __webpack_require__(20);
var global = __webpack_require__(2);
var speciesConstructor = __webpack_require__(56);
var promiseResolve = __webpack_require__(136);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(0);
var newPromiseCapability = __webpack_require__(104);
var perform = __webpack_require__(135);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(30);
var anObject = __webpack_require__(1);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(30);
var anObject = __webpack_require__(1);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(30);
var anObject = __webpack_require__(1);
var getPrototypeOf = __webpack_require__(19);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(139);
var from = __webpack_require__(148);
var metadata = __webpack_require__(30);
var anObject = __webpack_require__(1);
var getPrototypeOf = __webpack_require__(19);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(30);
var anObject = __webpack_require__(1);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(30);
var anObject = __webpack_require__(1);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(30);
var anObject = __webpack_require__(1);
var getPrototypeOf = __webpack_require__(19);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(30);
var anObject = __webpack_require__(1);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(30);
var anObject = __webpack_require__(1);
var aFunction = __webpack_require__(11);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(0);
var microtask = __webpack_require__(103)();
var process = __webpack_require__(2).process;
var isNode = __webpack_require__(22)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(0);
var global = __webpack_require__(2);
var core = __webpack_require__(20);
var microtask = __webpack_require__(103)();
var OBSERVABLE = __webpack_require__(6)('observable');
var aFunction = __webpack_require__(11);
var anObject = __webpack_require__(1);
var anInstance = __webpack_require__(41);
var redefineAll = __webpack_require__(43);
var hide = __webpack_require__(12);
var forOf = __webpack_require__(42);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(40)('Observable');


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(2);
var $export = __webpack_require__(0);
var userAgent = __webpack_require__(70);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $task = __webpack_require__(102);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(99);
var getKeys = __webpack_require__(36);
var redefine = __webpack_require__(13);
var global = __webpack_require__(2);
var hide = __webpack_require__(12);
var Iterators = __webpack_require__(50);
var wks = __webpack_require__(6);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61)))

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(372);
module.exports = __webpack_require__(20).RegExp.escape;


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(0);
var $re = __webpack_require__(373)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 373 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 374 */
/***/ (function(module, exports) {

// element-closest | CC0-1.0 | github.com/jonathantneal/closest

(function (ElementProto) {
	if (typeof ElementProto.matches !== 'function') {
		ElementProto.matches = ElementProto.msMatchesSelector || ElementProto.mozMatchesSelector || ElementProto.webkitMatchesSelector || function matches(selector) {
			var element = this;
			var elements = (element.document || element.ownerDocument).querySelectorAll(selector);
			var index = 0;

			while (elements[index] && elements[index] !== element) {
				++index;
			}

			return Boolean(elements[index]);
		};
	}

	if (typeof ElementProto.closest !== 'function') {
		ElementProto.closest = function closest(selector) {
			var element = this;

			while (element && element.nodeType === 1) {
				if (element.matches(selector)) {
					return element;
				}

				element = element.parentNode;
			}

			return null;
		};
	}
})(window.Element.prototype);


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Internet Explorer 9 and higher
(function (arr) {
  arr.forEach(function (item) {
    if (item.hasOwnProperty('remove')) {
      return;
    }
    Object.defineProperty(item, 'remove', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function remove() {
        if (this.parentNode !== null) {
          this.parentNode.removeChild(this);
        }
      }
    });
  });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(3);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// export to window
window.$ = _jquery2.default; /**
                              * @deprecated
                              */

window.jQuery = _jquery2.default;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(3);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//shimované pluginy většinou nemají export, většinou extendují jQuery object
__webpack_require__(378); /**
                                              * @deprecated
                                              */

__webpack_require__(384);
__webpack_require__(386);

__webpack_require__(388);
__webpack_require__(389);
__webpack_require__(390);
//require('./web/jquery.scrollSpeed');
__webpack_require__(391);
__webpack_require__(392);
// require('./web/jquery.webslider.client');
__webpack_require__(395);
__webpack_require__(396);
__webpack_require__(397);
// require('./web/referencesPopup');
__webpack_require__(399);
__webpack_require__(402);
__webpack_require__(150);
var isMobile = __webpack_require__(151);
var PageLoader = __webpack_require__(405);

//export to window
web.googlemaps = window.web.googlemaps || {};
window.PageLoader = PageLoader; // used in nonHP carousel


var $b = (0, _jquery2.default)('body');
var $w = (0, _jquery2.default)(window);

/* menu pro mobilní zařízení */
var controlMenu = function controlMenu() {
	var visitedMenu = false;

	var init = function init() {
		$b.on('click', '.js_menuBurger', function (e) {
			(0, _jquery2.default)(this).toggleClass('close');
			toggleMenu();
			e.preventDefault();
		});
	};

	var cloneMenu = function cloneMenu() {
		(0, _jquery2.default)('#page-header').before('<div class="help-menu" id="help-menu"></div>');
		(0, _jquery2.default)('.navigation').clone().appendTo('.help-menu');
		var heightNavigationList = (0, _jquery2.default)('#help-menu .navigation-list').height();

		(0, _jquery2.default)('#help-menu .navigation').removeClass().addClass('navigation');
		(0, _jquery2.default)('#help-menu .menu-burger').addClass('close');
		(0, _jquery2.default)('#help-menu .main-menu').attr('id', 'main-menu').addClass('in').addClass('main-menu-open');

		if (window.innerHeight - 40 >= heightNavigationList + 40) {
			(0, _jquery2.default)('#help-menu .main-menu').css('height', window.innerHeight - 40 + 'px');
		} else {
			(0, _jquery2.default)('#help-menu .main-menu').css('height', heightNavigationList + 40 + 'px');
		}
		(0, _jquery2.default)('#help-menu').animate({
			height: window.innerHeight
		}, 1000, 'easeInOutCubic', function () {
			//}, 1000, function() {
			(0, _jquery2.default)('#help-menu').css('min-height', heightNavigationList + 80 + 'px');
		});
	};

	var destroyMenu = function destroyMenu() {
		(0, _jquery2.default)('.help-menu').remove();
	};

	var toggleMenu = function toggleMenu() {
		if (visitedMenu == false) {
			cloneMenu();
			visitedMenu = true;
		} else {
			(0, _jquery2.default)('#help-menu').css('min-height', 0);
			(0, _jquery2.default)('.help-menu').animate({
				height: 0
			}, 1000, 'easeInOutCubic', function () {
				//}, 1000, function() {
				destroyMenu();
				visitedMenu = false;
			});
		}
	};

	init();
};

/* nastavení výšky obsahu ve fotogalerie */
function setGalleryTeamHeight() {
	(0, _jquery2.default)('.photogallery').each(function () {
		var $t = (0, _jquery2.default)(this);

		(0, _jquery2.default)('.team, .year', $t).each(function () {
			(0, _jquery2.default)(this).height((0, _jquery2.default)(this).width() - 1);
		});
	});
};

/* styled file input */
(0, _jquery2.default)(document).on('change', '.button-file :file', function () {
	var input = (0, _jquery2.default)(this),
	    numFiles = input.get(0).files ? input.get(0).files.length : 1,
	    label = input.val().replace(/\\/g, '/').replace(/.*\//, '');
	input.trigger('fileselect', [input, numFiles, label]);
});
(0, _jquery2.default)(document).on('fileselect', function (event, input, numFiles, label) {
	var log = numFiles > 1 ? numFiles + ' files selected' : label;
	if (input.length) {
		input.parents('.form-group').find('.file-label').html(log);
	}
});

(0, _jquery2.default)(document).on('click', '.plupload label', function (e) {
	e.preventDefault();
});

/* nastavení výšky elementu s motivovým obrázkem */
function setMatrixHeight() {
	(0, _jquery2.default)('.content-matrix').each(function () {
		var $t = (0, _jquery2.default)(this);

		if (window.innerWidth >= 1052) {
			(0, _jquery2.default)('.image', $t).height($t.height());
		} else {
			(0, _jquery2.default)('.image', $t).css('height', 'auto');
		}
	});
}

window.setMatrixHeight = setMatrixHeight;

/* nastavení roztačení google mapy v pobočkách */
function branchGoogleMap() {
	(0, _jquery2.default)('.js_google-map-pobocka').each(function () {
		var $t = (0, _jquery2.default)(this);
		var bodyWidth = $b.width();
		var containerWidth = $t.parents('.container').width();
		var gmOffset = Math.floor((bodyWidth - containerWidth) / 2 - 20);

		if (window.innerWidth >= 481 && window.innerWidth <= 1052) {
			$t.css('margin-left', -gmOffset + 'px').css('margin-right', -gmOffset + 'px');
		} else if (window.innerWidth >= 1053) {
			$t.css('margin-left', -gmOffset + 'px').css('margin-right', 0);
		} else {
			$t.css('margin-left', 0).css('margin-right', 0);
		}
	});
}
window.branchGoogleMap = branchGoogleMap;

/* initialization lazy loading */
var lazyLoading = function lazyLoading() {
	// var $lazyLoadingElements = $('.photogallery .image, .list-case-study .image, .lazyloading');
	var $lazyLoadingElements = (0, _jquery2.default)('.lazyloading');
	$lazyLoadingElements.unveil(0);

	//scroll pro nacitani lazyloadingu
	if ($lazyLoadingElements.length > 0) {
		var topOffset = $w.scrollTop();
		$w.scrollTop(topOffset + 1);$w.scrollTop(topOffset);
	}
};
window.lazyLoading = lazyLoading;

/* google map */
_jquery2.default.googlemap.setDefaults({
	mapOptions: {
		scrollwheel: false,
		styles: [{ "featureType": "landscape", "stylers": [{ "visibility": "off" }] }, { "featureType": "poi", "stylers": [{ "visibility": "off" }] }, { "featureType": "administrative.province", "stylers": [{ "visibility": "off" }] }, { "featureType": "administrative.land_parcel", "stylers": [{ "visibility": "off" }] }, { "featureType": "administrative.neighborhood", "stylers": [{ "visibility": "off" }] }, { "featureType": "road.local", "stylers": [{ "visibility": "off" }] }, { "featureType": "road.arterial", "stylers": [{ "visibility": "simplified" }] }, { "featureType": "water", "stylers": [{ "visibility": "on" }, { "hue": "#00ccff" }, { "saturation": -83 }, { "lightness": -15 }] }, { "featureType": "road", "elementType": "labels", "stylers": [{ "visibility": "off" }] }, { "featureType": "transit", "stylers": [{ "visibility": "off" }] }, { "featureType": "administrative.locality", "elementType": "labels.text.stroke", "stylers": [{ "visibility": "off" }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "visibility": "off" }] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "lightness": 100 }, { "weight": 2.9 }] }, { "featureType": "road.local", "stylers": [{ "visibility": "on" }] }, { "featureType": "administrative.locality" }]
	},
	markerTypes: [{}, {
		icon: {
			url: '/img/google-map/marker-01.png',
			size: new google.maps.Size(48, 64),
			origin: new google.maps.Point(0, 0),
			anchor: new google.maps.Point(24, 64)
		},
		shape: {
			coords: [0, 0, 48, 64],
			type: 'rect'
		}
	}, {
		icon: {
			url: '/img/google-map/marker-02.png',
			size: new google.maps.Size(48, 64),
			origin: new google.maps.Point(0, 0),
			anchor: new google.maps.Point(24, 64)
		},
		shape: {
			coords: [0, 0, 48, 64],
			type: 'rect'
		}
	}],
	bubbleContentFormatter: function bubbleContentFormatter(mData) {
		var str = '';
		if (mData.title) {
			str = '';
		}
		if (mData.bubbleContent) {
			str += mData.bubbleContent;
		}
		return str;
	}
});

/* přepínání co o nás řekli klienti na HP */
var carouselClientsSay = function carouselClientsSay(selector, item) {
	var $selector = (0, _jquery2.default)('.' + selector);
	var $item = (0, _jquery2.default)('.' + item, $t);
	var $t;
	var countSlides;
	var animateTime = 800;
	var actualSlide = 0;
	var slideTimer = null;

	var init = function init() {
		if ((0, _jquery2.default)('.' + selector).length) {
			set();
		}
		(0, _jquery2.default)('.control-item', $selector).on('click', function (e) {
			click((0, _jquery2.default)(this), e);
		});
	};

	var set = function set() {
		$selector.each(function () {
			var control;
			$t = (0, _jquery2.default)(this);
			countSlides = $item.length;

			control = '<div class="control">\n';
			for (var i = 1; i <= countSlides; i++) {
				control += i == 1 ? '\t<a class="control-item active" href="#">' + i + '</a>\n' : '\t<a class="control-item" href="#">' + i + '</a>\n';
			}
			control += '</div>\n';
			$selector.append(control);
		});

		//changeSlide();
	};

	var animateSlide = function animateSlide(index) {
		var self = this;
		(0, _jquery2.default)('.control-item', $selector).removeClass('active');
		$item.eq(actualSlide).fadeToggle(animateTime, 'linear', function () {
			actualSlide++;
			actualSlide = actualSlide == countSlides ? 0 : actualSlide;
			if (index >= 0) {
				actualSlide = index;
			}
			(0, _jquery2.default)('.control-item', $selector).eq(actualSlide).addClass('active');
			$item.eq(actualSlide).fadeToggle(animateTime, 'linear');
			(0, _jquery2.default)('.homepage .list-boxies').rowHeight("setRowHeight");
			changeSlide();
		});
	};

	var changeSlide = function changeSlide() {
		var self = this;

		clearTimeout(slideTimer);
		slideTimer = setTimeout(function () {
			animateSlide();
		}, 10000);
	};

	var click = function click(obj, e) {
		e.preventDefault();
		var index = obj.index();
		clearTimeout(slideTimer);
		animateSlide(index);
	};

	init();
};

/* Dynamicky donačtený obsah s postupným dojezem na stránku */
var dynamicLoadedContent = function dynamicLoadedContent() {

	var init = function init() {
		checkElementInViewportAndSetClass(0);
		$w.on('scroll', function () {
			checkElementInViewportAndSetClass(200);
		});
	};

	var isElementInViewport = function isElementInViewport(el) {
		var top = el.offsetTop;
		var left = el.offsetLeft;
		var width = el.offsetWidth;
		var height = el.offsetHeight;

		while (el.offsetParent) {
			el = el.offsetParent;
			top += el.offsetTop;
			left += el.offsetLeft;
		}

		return top < window.pageYOffset + window.innerHeight * 0.8 && left < window.pageXOffset + window.innerWidth && top + height > window.pageYOffset && left + width > window.pageXOffset;
	};

	var checkElementInViewportAndSetClass = function checkElementInViewportAndSetClass(time) {
		var addClassWhenIsInUserViewElements = document.querySelectorAll('.js_addClassWhenIsInUserView');
		for (var i = 0; i < addClassWhenIsInUserViewElements.length; i++) {
			if (isElementInViewport(addClassWhenIsInUserViewElements[i]) === true) {
				window.setTimeout(function (i) {
					addClassWhenIsInUserViewElements[i].classList.add('show-and-move-up');
				}, time, i);
			}
		}
	};

	init();
};

/*
	inicializace funkcí
==================================================*/
$w.on('load', function () {
	(0, _jquery2.default)('.list-cards, .boxies, .set-row-height, .list-case-study, .list-description, .homepage .list-boxies').rowHeight({
		selector: '.item'
	});
	(0, _jquery2.default)('.nasi-klienti .list-boxies, .nasi-klienti-projects').rowHeight({
		selector: '.wrapper'
	});
	carouselClientsSay('js_carouselClientsSay', 'blockquote-wrapper');
	//carousel();

	if ((0, _jquery2.default)('.js_carouselSlideInfoboxTitle').length) {
		var $t = (0, _jquery2.default)('.js_carouselSlideInfoboxTitle');

		$t.each(function () {
			if ((0, _jquery2.default)(this).height() > 180) {
				(0, _jquery2.default)(this).addClass('carousel__infobox-title--smaller');
			}
		});
	}

	if ((0, _jquery2.default)('.js_slideInfoboxTitle').length) {
		var $t = (0, _jquery2.default)('.js_slideInfoboxTitle');

		$t.each(function () {
			if ((0, _jquery2.default)(this).height() > 180) {
				(0, _jquery2.default)(this).addClass('slide__infobox__title--smaller');
			}
		});
	}

	if ((0, _jquery2.default)('.js_slideInfobox').length) {
		var $t = (0, _jquery2.default)('.js_slideInfobox');

		$t.each(function () {
			(0, _jquery2.default)(this).addClass('slide__infobox--js');
		});
	}

	if ((0, _jquery2.default)('.js_benefitsList').length) {
		benefitsListContent();
	}

	if ((0, _jquery2.default)('.landingpage-webs').length) {
		stickyButton();
	}

	if ((0, _jquery2.default)('.js_scrollToAnchor').length) {
		var hashId = window.location.hash.substr(1);
		if (hashId !== '') {
			scrollToElement(hashId);
		}
	}
});

function scrollToElement(elementId) {
	var element = document.getElementById(elementId);
	if (element != null) {
		var elementOffsetTop = element.getBoundingClientRect().top + window.pageYOffset;
		window.scroll({
			top: elementOffsetTop, // could be negative value
			left: 0,
			behavior: 'smooth'
		});
	}
}

$w.on('resize', function () {
	setGalleryTeamHeight();
	setMatrixHeight();
	branchGoogleMap();
	//carousel();
});

$w.on('beforeunload', function () {
	(0, _jquery2.default)('body').removeClass('animated-body-show');
	window.setTimeout(function () {
		(0, _jquery2.default)('body').addClass('animated-body-show');
	}, 3000);
});

(0, _jquery2.default)('.bg-rwd').rwdBackground();
controlMenu();
setGalleryTeamHeight();
setMatrixHeight();
branchGoogleMap();
lazyLoading();
dynamicLoadedContent();

(0, _jquery2.default)(document).bind('afterContentsReplaced', function () {
	if (!isMobile.phone && !isMobile.tablet) {
		(0, _jquery2.default)('.form select').selectize();
	}
});
if (!isMobile.phone && !isMobile.tablet) {
	(0, _jquery2.default)('.form select').selectize();
}

(0, _jquery2.default)('body').on('validationFailed', 'form', function () {
	if ((0, _jquery2.default)('.has-error', this).size() > 0) {
		var errorTopOffset = (0, _jquery2.default)('.has-error:first', this).offset().top;
		(0, _jquery2.default)('html, body').animate({ scrollTop: errorTopOffset });
	}
});

/* s novou verzi generatoru bude mozne nahradit timto blok vyse */
/*$('body').on('validationFailed', 'form', function() {
	var errorTopOffset = $('.has-error:first', this).offset().top;
	$('html, body').animate({ scrollTop: errorTopOffset });
});*/

if ((0, _jquery2.default)('.subListCareer .item').size() > 0) {
	(0, _jquery2.default)('.subListCareer .item').each(function () {
		if ((0, _jquery2.default)(this).children().size() > 2) {
			(0, _jquery2.default)(this).addClass('item--active');
		}
	});
}

(0, _jquery2.default)('.subListCareer').on('click', '.item--active', function () {
	// $(this).removeClass('item');
	(0, _jquery2.default)(this).toggleClass('rotate-icon');
	(0, _jquery2.default)('p', this).toggle();
	(0, _jquery2.default)('h3 + p', this).show();
});

//jQuery.scrollSpeed(300, 900);


var benefitsListContent = function benefitsListContent() {
	var $block = (0, _jquery2.default)('.js_benefitsList');
	var $element = (0, _jquery2.default)('.modalBenefits');
	var countElements = $block.children().size();
	var currentBenefit = 0;

	var init = function init() {
		(0, _jquery2.default)('body').append('<div class="modalBenefits"><div class="modalBenefits_wrapper"></div><a class="modalBenefits_close js_modalBenefitsClose" href="javascript:"></a></div>');

		if (countElements > 1) {
			(0, _jquery2.default)('.modalBenefits').prepend('<a class="modalBenefits_arrow modalBenefits_arrow-previous js_modalBenefitsArrow" href="javascript:" data-direction="-1"></a><a class="modalBenefits_arrow modalBenefits_arrow-next js_modalBenefitsArrow" href="javascript:" data-direction="1"></a>');
		}

		document.onkeydown = checkKey;

		(0, _jquery2.default)('.benefitsList_link', $block).on('click', function () {
			currentBenefit = (0, _jquery2.default)(this).parent().index();
			showBenefitsDetail((0, _jquery2.default)(this));
		});
		(0, _jquery2.default)('.js_modalBenefitsClose').on('click', function () {
			closeBenefitsDertail();
		});
		(0, _jquery2.default)('.js_modalBenefitsArrow.modalBenefits_arrow-previous').on('click', function () {
			changeBenefit('-1');
		});
		(0, _jquery2.default)('.js_modalBenefitsArrow.modalBenefits_arrow-next').on('click', function () {
			changeBenefit('+1');
		});
	};

	var checkKey = function checkKey(e) {
		e = e || window.event;

		if ((0, _jquery2.default)('.modalBenefits').is(":visible")) {
			if (e.keyCode == '27') {
				// escape
				closeBenefitsDertail();
			} else if (e.keyCode == '37') {
				// left arrow
				changeBenefit('-1');
			} else if (e.keyCode == '39') {
				// right arrow
				changeBenefit('+1');
			}
		}
	};

	var showBenefitsDetail = function showBenefitsDetail($element) {
		(0, _jquery2.default)('.modalBenefits_wrapper').html('<div class="modalBenefits_content">' + $element.html() + '</div>');
		(0, _jquery2.default)('.modalBenefits .benefitsList_body').removeClass('sr-only');
		(0, _jquery2.default)('.modalBenefits').show().css('top', (0, _jquery2.default)(window).scrollTop() + ((0, _jquery2.default)(window).height() - (0, _jquery2.default)('.modalBenefits').height()) / 2 + 'px');
	};

	var closeBenefitsDertail = function closeBenefitsDertail() {
		(0, _jquery2.default)('.modalBenefits').hide();
		(0, _jquery2.default)('.modalBenefits_wrapper').html('');
	};

	var changeBenefit = function changeBenefit(direction) {
		var newBenefit = currentBenefit;

		if (direction === '+1') {
			newBenefit++;
			newBenefit = newBenefit == countElements ? 0 : newBenefit;
		}

		if (direction === '-1') {
			newBenefit--;
			newBenefit = newBenefit == -1 ? countElements - 1 : newBenefit;
		}

		(0, _jquery2.default)('.modalBenefits_wrapper').html('');
		(0, _jquery2.default)('.modalBenefits_wrapper').html('<div class="modalBenefits_content">' + (0, _jquery2.default)('.benefitsList_link:eq(' + newBenefit + ')', $block).html() + '</div>');
		(0, _jquery2.default)('.modalBenefits .benefitsList_body').removeClass('sr-only');
		(0, _jquery2.default)('.modalBenefits').show().css('top', (0, _jquery2.default)(window).scrollTop() + ((0, _jquery2.default)(window).height() - (0, _jquery2.default)('.modalBenefits').height()) / 2 + 'px');

		currentBenefit = newBenefit;
	};

	init();
};

var stickyButton = function stickyButton() {
	var $el = (0, _jquery2.default)('.js_stickyButton');
	var time = 200;

	var init = function init() {
		var stopSticky = (0, _jquery2.default)('.js_stickyButton').offset().top + (0, _jquery2.default)('.js_stickyButton').outerHeight() - $w.height();

		onScroll(stopSticky);

		$w.on('scroll', function () {
			onScroll(stopSticky);
		});
		$w.on('resize', function () {
			onResize();
		});
	};

	var onScroll = function onScroll(stopSticky) {
		window.setTimeout(function () {
			var topOffset = $w.scrollTop();

			if (topOffset > stopSticky) {
				$el.removeClass('content__sticky');
			} else {
				$el.addClass('content__sticky');
			}
		}, time);
	};

	var onResize = function onResize() {
		window.setTimeout(function () {
			$el.removeClass('content__sticky');
			init();
		}, time);
	};

	init();
};

/*
$('.list-case-study .image').unveil(0, function() {
	$(this).load(function() {
		$('.list-case-study').rowHeight({
			selector: '.item'
		});
	});
});
*/

// rovnani boxu v hlavicce detailu reference
/*
$('.list-blocks').rowHeight({
	selector: '.item'
});
*/

/*
 * !!!NECHAT NA KONCI web.js!!!
 * V hlavičce webu je JavaScript var q = []; $ = function(f) {q.push(f)};, který zajistí,
 * že kdekoli vyskytující se inline javascript bude vykonán až po načtení stránky
 * Inline JavaScript musí být vnořen do následujícího kusu kódu
 *
 * $(function(){
 *     //inline JavaScript
 * });
 *
 * který je ve skutečnosti zkrácené volání $(document).ready() @see http://learn.jquery.com/using-jquery-core/document-ready/
 * předpokládá se tedy, že na webu bude použito jQuery
 *
 * viz http://www.slideshare.net/slideshow/embed_code/17116700?startSlide=10
 * */
if (window.q) {
	window.q.forEach(function (f) {
		(0, _jquery2.default)(f);
	});
}

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var jQuery = __webpack_require__(3);
__webpack_require__(379);
__webpack_require__(380);
__webpack_require__(381);
__webpack_require__(383);

/**
 * Partial update allows AJAX partial update of the DOM structure by communicating with component background implemented
 * in RamJet technology.
 *
 * CUSTOM SETTINGS:
 *
 * alterHistory    - boolean true - if browser history is ought to be altered,
 *                 - boolean false - if browser history should remain untouched
 *                 - (default) not set - only links/forms targeting the same page will alter the history
 * historyScope    - parameters - keeps only parameter values in history
 *                 - (default) allData - default (keeps parameters and all widget values in history - please consider this preset
 *                   when working with private data, such as passwords)
 * clearCache      - boolean true - remembered results are purged before executing call
 *                 - (default) otherwise - nothing
 * htmlContainer   - id of the HTML container to be replaces with returned content (if not set
 *                   it equals containerId passed in the method call)
 * suppressRedirect- boolean true - suppresses full page redirect even if server returns 302 (Moved Temporarily) and performs
 *                   partial update with the result returned from page servers redirects to (when target page contains
 *                   no component required for partial update, content of the update area will get removed!)
 *                 - (default) boolean false - whenever servers responds with 302 (Moved Temporarily) client performs
 *                   full page refresh
 * suppressSubmitEvent - boolean true - when executing function executeSubmit submit event on form DOM element will not be triggered
 *                 - (default) boolean false - executing this function will trigger the event
 * encrypt         - boolean true - if set all parameters will be encrypted with jCryption library when another two
 *                   prerequisities are fulfilled
 *                   a) another JS file /jCryption/jquery.jcryption.js is linked on the page
 *                   b) jCryption servlet filter is configured in the web application
 *                   [note: encryption cannot be used for forms with file inputs = ie. binary data]
 *                 - (default) boolean false
 * layoutContext   - allows to propagate or set layout context ID prefix for the RamJet server side rendering
 *
 * EVENTS:
 *
 * beforeContentsReplaced - before contents of the container are replaced, if method sets false to settings.stopReplacement
 *                          replacement logic will be stopped
 * afterContentsReplaced  - after contents of the container are replaced
 * encryptionInitiated    - before encryption process starts
 * encryptionKeysAcquired - after public key is obtained from the server and before form contents encryption starts
 * encryptionProcessed    - after encryption is finished and before ajax call really starts
 *
 * CALLBACKS:
 *
 * Each method accepts optional reference to a callback function that will be executed on server success response arrival.
 * If callback function is defined it overrides default callback function that replaces existing DOM with new DOM retrieved
 * from the server. So in case you want to add only a bit of custom logic and leave DOM replacement at place you need
 * to have callback in following form:
 *
 * function(replacementDiv, result) {
 *    //your custom logic
 *    $.partialUpdate.predefinedCallbacks.replaceContents(replacementDiv, result)
 *    //your custom logic
 * }
 *
 * @author Jan Novotny
 * @version 1.0
 */

(function ($) {

	$.partialUpdateManager = function (doQueue, showAjaxPreloader) {
		this.ajaxManager = new $.partialUpdateManager.AjaxManager(doQueue, showAjaxPreloader);
	};

	$.partialUpdateManager.prototype = {

		/**
   * Logs a text into the firebug.
   * @param text
   */
		_log: function _log(text) {
			if ($.log !== undefined) {
				$.log(text);
			} else if (window.console) {
				window.console.log(text);
			}
		},

		/**
   * Returns div that contains HTML code of the partially replaced HTML content.
   */
		_getPartialUpdateReplacementContainer: function _getPartialUpdateReplacementContainer(container) {
			/**
    * This is class constant that is appended to dynamically created divs that are used to replace content
    * of the partial updated widgets.
    */
			var partialUpdateContainerClass = "partialUpdateDynamicContainer";

			if (this.length === 0) {
				this._log("Cannot wrap container into the partial update replacement container - no container selected.");
				return null;
			}
			if (this.length > 1) {
				this._log("Cannot wrap container into the partial update replacement container - multiple containers selected.");
				return null;
			}

			var containerParentNode = container.get(0).parentNode;
			if (containerParentNode == null) {
				this._log("Cannot find parent node - another dom replacement probably runs simultaneously!");
				return null;
			}
			var replacementDivAvailable = containerParentNode.className == partialUpdateContainerClass;
			var replacementDiv = replacementDivAvailable ? containerParentNode : null;
			if (replacementDiv === null || replacementDiv === undefined) {
				replacementDiv = document.createElement("div");
				replacementDiv.className = partialUpdateContainerClass;
				container.wrap(replacementDiv);
				replacementDiv = container.get(0).parentNode;
			}
			return $(replacementDiv);
		},

		/**
   * Composes url with appendend container id at the end.
   * @param url
   * @param containerId
   */
		_composeFinalUrl: function _composeFinalUrl(url, containerId) {
			//compose final url
			var index = url.indexOf("?");
			var indexHash = url.indexOf("#");
			if (indexHash > -1 && (indexHash < index || index == -1)) {
				index = indexHash;
			}
			var requestedContainer = "";
			if ("string" === typeof containerId) {
				requestedContainer = containerId;
			} else {
				for (var i = 0; i < containerId.length; i++) {
					requestedContainer += containerId[i];
					if (i + 1 < containerId.length) {
						requestedContainer += "+";
					}
				}
			}
			if (index > -1) {
				return url.substr(0, index) + "@" + requestedContainer + url.substr(index);
			} else {
				return url + "@" + requestedContainer;
			}
		},

		/**
   * Finds parent form for sumbit id or retrieves form itself by id. Performs necessary checks for FORM presence
   * in DOM.
   * @param submitId
   */
		_findForm: function _findForm(submitId) {
			var jButton = $("#" + submitId);
			if (jButton.length === 0) {
				this._log("Cannot perform partial update - submit or form with id " + submitId + " is not present.");
				return null;
			}
			var jButtonIsForm = jButton.length == 1 && jButton.get(0).tagName.toLowerCase() == "form";
			var jForm = jButtonIsForm ? jButton : jButton.parents("form");

			if (jForm.length == 0) {
				this._log("Cannot perform partial update - form not found.");
				return null;
			}

			return jForm.get(0);
		},

		/**
   * Returns DOM submit element for passed id. Null if target element is not submit.
   * @param submitId
   */
		_findButton: function _findButton(submitId) {
			var jButton = $("#" + submitId);
			if (jButton.length === 0) {
				this._log("Cannot perform partial update - submit or form with id " + submitId + " is not present.");
				return null;
			}
			var jButtonIsButton = jButton.length == 1 && (jButton.get(0).tagName.toLowerCase() == "input" || jButton.get(0).tagName.toLowerCase() == "button") && (jButton.get(0).type.toLowerCase() == "submit" || jButton.get(0).type.toLowerCase() == "image" || jButton.get(0).type.toLowerCase() == "button");
			return jButtonIsButton ? jButton.get(0) : null;
		},

		/**
   * Returns DOM element for the container whose contents should be replaced.
   * @param containerId
   * @param settings
   */
		_getHtmlContainer: function _getHtmlContainer(containerId, settings) {
			var htmlContainer;
			if (settings && settings.htmlContainer) {
				htmlContainer = settings.htmlContainer;
			} else {
				var containerCnt = $("#" + containerId + "__container");
				if (0 < containerCnt.length) {
					//prefer container elements before target ones
					htmlContainer = containerId + "__container";
				} else {
					htmlContainer = containerId;
				}
			}
			var container = $("#" + htmlContainer);
			if (container.length === 0) {
				throw new Error("Cannot perform partial update of the container id " + htmlContainer + " is not present.");
			} else {
				return container;
			}
		},

		/**
   * Returns true if form is multipart form with file inputs.
   */
		_isMultipart: function _isMultipart(jForm) {
			var fileInputs = $('input:file', jForm).length > 0;
			var mp = 'multipart/form-data';
			var multipart = jForm.attr('enctype') == mp || jForm.attr('encoding') == mp;
			jForm.hasClass('noFileUpload');
			return !jForm.hasClass('noFileUpload') && (fileInputs || multipart);
		},

		/**
   *
   * @param container
   * @param result
   * @param textStatus
   * @param xhr
   * @param settings
   * @param callback
   * @param containerId
   * @private
   */
		_replaceContentsOfSingleWidget: function _replaceContentsOfSingleWidget(container, result, textStatus, xhr, settings, callback, containerId) {
			var me = this;
			//do only single dom manipulation at once
			if (container.get(0).parentNode !== null) {
				var replacementDiv = $.partialUpdate._getPartialUpdateReplacementContainer(container);
				if (replacementDiv === null) {
					return;
				}
				try {
					if ($.isFunction($.partialUpdate.onBeforeReplacement)) {
						var cnt = $.partialUpdate.onBeforeReplacement(replacementDiv, result);
						if (cnt !== undefined) {
							result = cnt;
						}
					}
					container.trigger("beforeContentsReplaced", [result, textStatus, xhr, settings, container]);
					if (!settings || settings && settings.stopReplacement !== true) {
						//init callback function
						var finalCallback;
						if (callback === undefined || callback === null) {
							finalCallback = $.partialUpdate.predefinedCallbacks.replaceContents;
						} else {
							finalCallback = callback;
						}
						if (result !== null) {
							if (this.ajaxManager !== undefined) {
								this.ajaxManager._storeAjaxUpdateInBrowserHistory(settings, xhr, containerId);
							}
							finalCallback(replacementDiv, result, null, containerId, settings);
						}
					}
				} catch (e) {
					this._log(e);
				}
				var afterContentsReplaced = function afterContentsReplaced() {
					var accessibleNewContainer = replacementDiv.find("#" + container.attr("id"));
					if (accessibleNewContainer.length !== 0) {
						try {
							var scrollTrigger = accessibleNewContainer.find(".partial-update-scroll-anchor");
							if (scrollTrigger.length > 0) {
								var anchorElement = $(scrollTrigger.get(0));
								var fixedOffset = anchorElement.attr("data-partial-update-scroll-fixed-offset");
								var wantedScrollTop = anchorElement.offset().top + (fixedOffset ? parseInt(fixedOffset) : 0);
								if ($(window).scrollTop() > wantedScrollTop) {
									try {
										$('html, body').animate({
											scrollTop: wantedScrollTop
										}, 250);
									} catch (e) {
										//ignore
									}
								}
							}
							accessibleNewContainer.trigger("afterContentsReplaced", [settings]);
						} catch (e) {
							this._log(e);
						}
					} else {
						setTimeout(function () {
							afterContentsReplaced.call(me);
						}, 50);
					}
				};
				setTimeout(function () {
					afterContentsReplaced.call(me);
				}, 50);
			} else {
				setTimeout(function () {
					$.partialUpdate._replaceContents.call(me, container, result, textStatus, xhr, settings, callback, containerId);
				}, 200);
			}
		},

		/**
   *
   * @param container
   * @param result
   * @param textStatus
   * @param xhr
   * @param settings
   * @param callback
   * @param containerId
   * @private
   */
		_replaceContents: function _replaceContents(result, textStatus, xhr, settings, callback, containerId) {
			var me = this;
			if (xhr.status == 200) {
				//if full page redirect is required make it
				if (xhr.getResponseHeader("FULL_PAGE_REDIRECT")) {
					window.location = xhr.getResponseHeader("FULL_PAGE_REDIRECT");
					return;
				}
				if ("string" === typeof containerId) {
					var htmlContainer = $.partialUpdate._getHtmlContainer(containerId, settings);
					me._replaceContentsOfSingleWidget(htmlContainer, result, textStatus, xhr, settings, callback, containerId);
				} else {
					var prefix = "<!-- RamJet-WidgetDelimiters:";
					var suffix = " -->";
					var pIndex = result.indexOf(prefix);
					var sIndex = result.indexOf(suffix, pIndex + prefix.length);
					if (pIndex > -1 && sIndex > -1) {
						var multipleWidgetDelimiters = result.substr(pIndex + prefix.length, sIndex - (pIndex + prefix.length));
						var widgetResultDelimiters = multipleWidgetDelimiters.split(",");
						var lastIndex = sIndex + suffix.length;
						for (var i = 0; i < widgetResultDelimiters.length; i++) {
							var delimiter = "<!-- " + widgetResultDelimiters[i] + " -->";
							var nextIndex = result.indexOf(delimiter);
							var singleResult = result.substr(lastIndex, nextIndex - lastIndex);

							var htmlContainer = $.partialUpdate._getHtmlContainer(containerId[i], settings);
							me._replaceContentsOfSingleWidget(htmlContainer, singleResult, textStatus, xhr, settings, callback, containerId[i]);

							lastIndex = nextIndex + delimiter.length;
						}
					} else {
						this._log("Server returned unparseable result - expected response starting with: " + prefix + suffix);
					}
				}
			} else {
				this._log("Server returned HTTP: " + xhr.status + " (no partial update performed)");
			}
		},

		predefinedCallbacks: {

			/**
    * This method will reload whole page if in retrieved HTML contents login dialog is found.
    * @param replacementDiv
    * @param contents
    */
			reloadOnSessionDrop: function reloadOnSessionDrop(replacementDiv, contents, detectedString) {
				if (detectedString === undefined || detectedString === null) {
					detectedString = "performLogin";
				}
				if (contents.indexOf(detectedString) > -1) {
					this._log("String '" + detectedString + "' detected - session has probably expired, forcing page reload.");
					window.location.reload();
					return null;
				}
			},

			/**
    * Immediately replaces all partially updated content with no effect.
    * @param {jQuery} container
    * @param {string} htmlResult
    * @param {Function=}
    * @param {string=} containerId
    */
			replaceContents: function replaceContents(container, htmlResult, callback, containerId, settings) {
				container.html(htmlResult);
				if (callback) {
					callback(container, htmlResult);
				}
			},
			/**
    * Replaces contents of the partially updated content in hidden (nonvisible) state.
    * @param container
    * @param htmlResult
    */
			replaceHidden: function replaceHidden(container, htmlResult, callback, containerId, settings) {
				container.hide("fast", function () {
					container.html(htmlResult);
					container.show("fast", function () {
						if (callback !== undefined) {
							callback(container, htmlResult);
						}
					});
				});
			},
			/**
    * Replaces contents of the partially updated content in hidden (nonvisible) state and
    * fades in content with specified speed.
    * @param container
    * @param htmlResult
    */
			fadeIn: function fadeIn(container, htmlResult, speed, callback) {
				var finalSpeed = speed === undefined ? "normal" : speed;
				container.fadeOut(finalSpeed, function () {
					container.html(htmlResult);
					container.fadeIn(finalSpeed, function () {
						if (callback !== undefined) {
							callback(container, htmlResult);
						}
					});
				});
			},
			/**
    * Replaces contents of the partially updated content in hidden (nonvisible) state and
    * shows content with specified speed.
    * @param container
    * @param htmlResult
    */
			show: function show(container, htmlResult, speed) {
				var finalSpeed = speed === undefined ? "normal" : speed;
				container.hide(finalSpeed, function () {
					container.html(htmlResult);
					container.show(finalSpeed, function () {
						if (callback !== undefined) {
							callback(container, htmlResult);
						}
					});
				});
			}

		},

		/**
   * This is callback handler that will be called when HTML is retrieved from the server and before it is attached
   * to the DOM.
   */
		onBeforeReplacement: function onBeforeReplacement(replacementDiv, contents) {
			return $.partialUpdate.predefinedCallbacks.reloadOnSessionDrop.call(this, replacementDiv, contents);
		},

		/**
   * This method will call server with specified url.
   * Url will be appended with @widgetId so the server side could know whit widget template it should return.
   * Returned HTML will replace current content of element with containerId.
   *
   * @submitId url that points to any of RamJet rendered pages
   * @containerId id of the HTML element, whose content should be replaced with AJAX returned content
   *              also id of the widget, whose content is expected to be rendered back
   * @callback callback function that ought to be called on successful partial form update
   * @settings additional settings passed into the ajax call - custom settings documented in the header
   */
		execute: function execute(url, containerId, callback, settings) {
			var finalUrl = $.partialUpdate._composeFinalUrl(url, containerId);
			var originalErrorFunction = settings && settings.error !== undefined ? settings.error : null;
			//execute post
			$.partialUpdate.ajaxManager.ajaxCall($.extend({}, settings, {
				url: finalUrl,
				type: 'GET',
				dataType: 'html',
				success: function success(result, textStatus, xhr) {
					$.partialUpdate._replaceContents(result, textStatus, xhr, settings, callback, containerId);
				},
				error: function error(xhr, textStatus, errorThrown) {
					$.partialUpdate._log("Server returned HTTP: " + xhr.status + " " + textStatus + " (" + errorThrown + "). No partial update performed.");
					if (originalErrorFunction !== null) {
						originalErrorFunction(xhr, textStatus, errorThrown);
					}
				}
			}));
			return false;
		},

		/**
   * This method will call server with specified url.
   * Url will be appended with @widgetId so the server side could know what widget template it should return.
   * Returned HTML will replace current content of element with containerId.
   *
   * @submitId id of the submit widget or form itself
   * @containerId id of the HTML element, whose content should be replaced with AJAX returned content
   *              also id of the widget, whose content is expected to be rendered back
   * @callback callback function that ought to be called on successful partial form update
   * @settings additional settings passed into the ajax call - custom settings documented in the header
   * @exceptWidgetData
   * @exceptWidgetData
   */
		executeSubmit: function executeSubmit(submitId, containerId, callback, settings, exceptWidgetData, exceptParams) {
			var button = $.partialUpdate._findButton(submitId);
			var form = $.partialUpdate._findForm(submitId);
			if (form === null) return false;

			var formUrl = form.action;
			var attrUrl = $(form).attr('data-partial-update-url');
			if (typeof attrUrl !== 'undefined' && attrUrl !== false) {
				formUrl = attrUrl;
			}
			var url = $.partialUpdate._composeFinalUrl(formUrl, containerId);
			var jForm = $(form);

			var submitFunction = function submitFunction() {

				var namesToRemove = [];
				exceptWidgetData = settings.removeContainerWidgetData || exceptWidgetData;
				if (exceptWidgetData && containerId) {
					namesToRemove = $('[name^="frm."]', $('#' + containerId)).map(function (index, input) {
						return input.name;
					}).get();
				}

				if (typeof exceptWidgetData == 'string') {
					//adding frm. prefix
					var widgetDataForRemove = $.map(exceptWidgetData.split(','), function (item) {
						return 'frm.' + item;
					});
					//array intersection of all widget data and those in exception
					namesToRemove = widgetDataForRemove.filter(function (n) {
						return namesToRemove.indexOf(n) != -1;
					});
				}
				exceptParams = settings.exceptParams || exceptParams;
				if (typeof exceptParams == 'string') {
					//space removal
					exceptParams.replace(/ /, '');
					$.merge(namesToRemove, exceptParams.split(','));
				}

				var originalData = $.extend({}, settings);
				var data = $.merge(jForm.serializeArray(), settings && settings.data ? settings.data : []);

				if (namesToRemove.length > 0) {
					$.each(namesToRemove, function (index, name) {
						data = $.grep(data, function (item) {
							return item.name != name;
						});
					});
				}

				if (button != null) {
					data[data.length] = { name: button.name, value: "" };
				}

				//for forms default alterHistory = false & clearCache = true
				if (!settings) {
					settings = { alterHistory: false, clearCache: true };
				} else {
					if (settings.alterHistory !== true) {
						settings.alterHistory = false;
					}
					if (settings.clearCache !== true) {
						settings.clearCache = true;
					}
				}

				var originalErrorFunction = settings && settings.error !== undefined ? settings.error : null;
				settings = $.extend({}, settings, {
					url: url,
					data: data,
					type: 'POST',
					dataType: 'html',
					success: function success(result, textStatus, xhr) {
						$.partialUpdate._replaceContents(result, textStatus, xhr, settings, callback, containerId);
					},
					error: function error(xhr, textStatus, errorThrown) {
						$.partialUpdate._log("Server returned HTTP: " + xhr.status + " " + textStatus + " (" + errorThrown + "). No partial update performed.");
						if (originalErrorFunction !== null) {
							originalErrorFunction(xhr, textStatus, errorThrown);
						}
					}
				});
				if ($.partialUpdate._isMultipart(jForm)) {
					//translate data to extraData - not to modify external copied code
					if (originalData.data) {
						settings.extraData = {};
						for (var i = 0; i < originalData.data.length; i++) {
							var paramName = originalData.data[i].name;
							var paramValue = originalData.data[i].value;
							settings.extraData[paramName] = paramValue;
						}
					}
					$.partialUpdate.ajaxManager.fileUpload(form, button, settings);
				} else {
					//execute post
					$.partialUpdate.ajaxManager.ajaxCall(settings);
				}
			};

			if (settings && settings.suppressSubmitEvent === true) {
				submitFunction();
				return false;
			} else {
				//triggerHandler doesn't work with live events
				//jForm.triggerHandler("submit");
				var submitEvent = new $.Event('submit');
				submitEvent.target = button;
				submitEvent.preventDefault();
				jForm.trigger(submitEvent, [this, submitFunction]);

				if (!submitEvent.stopPartialUpdate) {
					submitFunction();
					return false;
				}
			}
		},

		/**
   * This method will call server with specified url.
   * Url will be appended with @widgetId so the server side could know what widget template it should return.
   * Returned HTML will replace current content of element with containerId.
   *
   * @params url with parameters or parameters alone that should be combined along with form data
   * @submitId id of the submit widget or form itself
   * @containerId id of the HTML element, whose content should be replaced with AJAX returned content
   *              also id of the widget, whose content is expected to be rendered back
   * @callback callback function that ought to be called on successful partial form update
   * @settings additional settings passed into the ajax call - custom settings documented in the header
   */
		executeCombi: function executeCombi(params, submitId, containerId, callback, settings) {
			var button = $.partialUpdate._findButton(submitId);
			var form = $.partialUpdate._findForm(submitId);
			if (form === null) return false;

			//local function for this piece of code
			var replaceValue = function replaceValue(a, name, value) {
				for (var i = 0; i < a.length; i++) {
					if (a[i].name == name) {
						a[i].value = value;
						return true;
					}
				}
				return false;
			};

			var formUrl = form.action;
			var attrUrl = $(form).attr('data-partial-update-url');
			if (typeof attrUrl !== 'undefined' && attrUrl !== false) {
				formUrl = attrUrl;
			}

			var url = $.partialUpdate._composeFinalUrl(formUrl, containerId);
			var jForm = $(form);

			var submitFunction = function submitFunction() {
				//for forms default alterHistory = false & clearCache = true
				if (!settings) {
					settings = { alterHistory: false, clearCache: true };
				} else {
					if (settings.alterHistory !== true) {
						settings.alterHistory = false;
					}
					if (settings.clearCache !== true) {
						settings.clearCache = true;
					}
				}

				var data = $.merge(jForm.serializeArray(), settings && settings.data ? settings.data : []);

				var paramsIndex = params.indexOf("?");
				if (paramsIndex > -1) {
					params = params.substring(paramsIndex + 1);
				}
				var paramItems = params.replace("&amp;", "&").split("&");
				for (var i = 0; i < paramItems.length; i++) {
					var paramItem = paramItems[i];
					var nameValue = paramItem.split("=");
					var paramName = decodeURIComponent(nameValue[0] !== undefined ? nameValue[0] : "");
					var paramValue = decodeURIComponent(nameValue[1] !== undefined ? nameValue[1] : "");
					//remove all HTML entities that could be passed in RamJet generated parameters
					var decodedParamValue = $('<div />').html(paramValue).text();
					if (replaceValue(data, paramName, paramValue)) {
						continue;
					}
					data[data.length] = { name: paramName, value: decodedParamValue };
				}

				var originalErrorFunction = settings && settings.error !== undefined ? settings.error : null;
				//execute post
				$.partialUpdate.ajaxManager.ajaxCall($.extend({}, settings, {
					url: url,
					data: data,
					type: 'POST',
					dataType: 'html',
					success: function success(result, textStatus, xhr) {
						$.partialUpdate._replaceContents(result, textStatus, xhr, settings, callback, containerId);
					},
					error: function error(xhr, textStatus, errorThrown) {
						$.partialUpdate._log("Server returned HTTP: " + xhr.status + " " + textStatus + " (" + errorThrown + "). No partial update performed.");
						if (originalErrorFunction !== null) {
							originalErrorFunction(xhr, textStatus, errorThrown);
						}
					}
				}));
			};

			//triggerHandler doesn't work with live events
			//jForm.triggerHandler("submit");
			var submitEvent = new $.Event('submit');
			submitEvent.target = button;
			submitEvent.preventDefault();
			jForm.trigger(submitEvent, [this, submitFunction]);

			if (!submitEvent.stopPartialUpdate) {
				submitFunction();
				return false;
			}
		},

		/**
   * This method will add missing container for cases, when there is not yet container with partially updated
   * content. For example when it represents conditionally available part of the page, that is not loaded
   * at the first time.
   *
   * @param targetContainer
   * @param containerId
   */
		addMissingContainer: function addMissingContainer(targetContainer, containerId) {
			$("#" + targetContainer).append("<div id='" + containerId + "'></div>");
		}

	};

	/**
  * Partial update namespace.
  */

	$.partialUpdateManager.AjaxManager = function (doQueue, showAjaxPreloader) {
		this.doQueue = doQueue;
		this.showAjaxPreloader = showAjaxPreloader;
		this.historyMonitor = null;
		this.preCurrentHash = null;
		this.currentHash = null;
		var me = this;

		/**
   * Constructor logic.
   * @param settings
   */
		if ($.manageAjax !== undefined) {
			var queueName = "partialUpdateQueue";
			this.queueManager = $.manageAjax.create(queueName, {
				queue: true,
				cacheResponse: true,
				abortOld: true
			});
			if (showAjaxPreloader) {
				$(document).bind("mousemove", function (event) {
					me.moveAjaxLoader.call(me, event);
				});
				$(document).bind(queueName + "AjaxStart", function () {
					me.showAjaxLoader.call(me);
				});
				$(document).bind(queueName + "AjaxStop", function () {
					me.hideAjaxLoader.call(me);
				});
				$(document).bind("encryptionInitiated", function () {
					me.showAjaxLoader.call(me);
				});
				$(document).bind("encryptionProcessed", function () {
					me.hideAjaxLoader.call(me);
				});
			}
		} else {
			this.queueManager = null;
		}

		this._maintainBrowserHistory();
	};

	$.partialUpdateManager.AjaxManager.prototype = {

		/**
   * This part stores partial update request parameters in location.hash
   * in order to support back & forward buttons in browsers.
   * @param xhr
   */
		_storeAjaxUpdateInBrowserHistory: function _storeAjaxUpdateInBrowserHistory(settings, xhr) {
			var baseUrl = xhr.getResponseHeader("RamJet-RequestedUrl");
			var parameters = xhr.getResponseHeader("RamJet-RequestedParameters");
			if (baseUrl) {
				var cmpIndex = baseUrl.indexOf("@");
				if (cmpIndex > -1) {
					baseUrl = baseUrl.substring(0, cmpIndex);
				}
				//only partial update request on the same page are recorded
				var loc = window.location;
				var currentAbsoluteUrl = loc.protocol + "//" + loc.host + loc.pathname;
				var currentRelativeUrl = loc.pathname;

				var stripTrailingSlash = function stripTrailingSlash(str) {
					if ('/' == str.substr(-1)) {
						return str.substr(0, str.length - 1);
					}
					return str;
				};

				baseUrl = stripTrailingSlash(baseUrl);
				currentAbsoluteUrl = stripTrailingSlash(currentAbsoluteUrl);
				currentRelativeUrl = stripTrailingSlash(currentRelativeUrl);
				var samePage = currentAbsoluteUrl == baseUrl || currentRelativeUrl == baseUrl;
				//noinspection PointlessBooleanExpressionJS
				var alterHistoryRequired = settings && settings.alterHistory == true;
				//noinspection PointlessBooleanExpressionJS
				var alterHistoryPermitted = settings && settings.alterHistory == false;
				if (alterHistoryRequired || samePage && !alterHistoryPermitted) {
					var token;
					if (samePage) {
						token = parameters && parameters != "" ? parameters : "";
					} else {
						if (baseUrl.indexOf("http") == 0) {
							token = baseUrl + (parameters && parameters != "" ? "?" + parameters : "");
						} else {
							token = loc.protocol + "//" + loc.host + baseUrl + (parameters && parameters != "" ? "?" + parameters : "");
						}
					}
					var newHash = encodeURIComponent("__partialUpdate:" + token);
					if (this.currentHash && this.currentHash == newHash) {
						return;
					}
					this.preCurrentHash = newHash;
					loc.hash = this.preCurrentHash;
					this.currentHash = this.preCurrentHash;
				}
			}
		},

		/**
   * This function checks whether current page was not result of partial update logic and
   * if so it replaces current url with valid one retrieved from hash part.
   */
		_maintainBrowserHistory: function _maintainBrowserHistory() {
			var loc = window.location;
			var hash = loc.hash;
			if (hash !== undefined && hash !== null && hash !== "") {
				this.currentHash = loc.hash.substr(1);
				this.preCurrentHash = loc.hash.substr(1);
				hash = decodeURIComponent(hash);
				if (hash.indexOf("__partialUpdate:") == 1) {
					var token = hash.substring(17);
					if (token.indexOf("http") == 0) {
						loc.replace(token);
					} else {
						var params = "" === token ? "" : "?" + token;
						loc.replace(loc.protocol + "//" + loc.host + loc.pathname + params);
					}
					this.historyMonitor = null;
					return;
				}
			}
			//monitor hash changes
			if (this.historyMonitor === null) {
				var me = this;
				var closure = function closure() {
					me._checkHistoryChange.call(me);
				};
				this.historyMonitor = setInterval(closure, 500);
			}
		},

		/**
   * This method checks whether current has changed according to what is expected.
   */
		_checkHistoryChange: function _checkHistoryChange() {
			var decodedPreHash = decodeURIComponent(this.preCurrentHash);
			var decodedHash = decodeURIComponent(this.currentHash);
			var cleanWindowHash = decodeURIComponent(window.location.hash.length > 0 ? window.location.hash.substr(1) : "");
			if (cleanWindowHash !== "" && decodedHash && decodedHash != cleanWindowHash && decodedPreHash == decodedHash) {
				this._maintainBrowserHistory.call(this);
			}
		},

		/**
   * Executes call itself. No other operations are performed around the call - execution is handed over to jQuery
   * or queueManager.
   *
   * @param settings
   */
		executeAjaxCall: function executeAjaxCall(settings) {
			if (this.doQueue && this.queueManager !== null) {
				//clear cache
				if (settings.clearCache && $.manageAjax !== undefined) {
					this.queueManager.clearCache();
				}
				//queue requests
				this.queueManager.add(settings);
			} else {
				//no queuing will occur manager not accessible
				$.ajax(settings);
			}
		},

		/**
   * This performs AJAX call to the server.
   * @param settings
   */
		ajaxCall: function ajaxCall(settings) {
			//initialize empty settings if none are provided
			if (!settings) {
				settings = {};
			}
			if (!settings.data) {
				settings.data = [];
			}
			if (settings.suppressRedirect == true) {
				settings.data.push({ name: "RamJet-Suppress-Redirect", value: "true" });
			}
			if (settings.layoutContext) {
				settings.data.push({ name: 'ramJetLayoutContext', value: settings.layoutContext });
			}
			if (!settings.timeout) {
				settings.timeout = 60000; // default ajax timeout is 1 minute
			}

			//reset cache always when server event is triggered
			var eventRequired = settings.url.indexOf("eventName") > -1;
			for (paramIndex in settings.data) {
				var param = settings.data[paramIndex];
				eventRequired = eventRequired || param.name && param.name.indexOf("eventName") > -1;
			}
			var AjaxFunction = function AjaxFunction(settings, ajaxManager) {
				this.internalSettings = settings;
				this.ajaxManager = ajaxManager;
				this.performCall = function () {
					if (this.internalSettings.alterHistory != false) {
						//set historyScope to request current url and parameters from server if not defined
						if (!this.internalSettings.historyScope) {
							this.internalSettings.historyScope = "parameters";
						}
						this.internalSettings.data.push({ name: "RamJet-HistoryScope-Level", value: this.internalSettings.historyScope });
					}
					//clear cache if event is triggered
					if (eventRequired) {
						this.internalSettings.clearCache = true;
						if ($.manageAjax !== undefined) {
							this.ajaxManager.queueManager.clearCache();
						}
					}
					this.ajaxManager.executeAjaxCall.call(this.ajaxManager, this.internalSettings);
				};
				this.replaceDataAndPerformCall = function (newData) {
					this.internalSettings.data = [];
					this.internalSettings.data.push(newData);
					this.performCall();
				};
			};
			var deferredCall = new AjaxFunction(settings, this);
			//convert all params & data into the crypted form
			if (settings.encrypt) {
				//gather all data to encrypt and clear original values
				var dataToEncrypt = "";
				var paramIndex = settings.url.indexOf("?");
				if (paramIndex > -1) {
					dataToEncrypt = settings.url.substr(paramIndex + 1);
					settings.url = settings.url.substr(0, paramIndex);
				}
				for (paramIndex in settings.data) {
					if (dataToEncrypt.length > 0) {
						dataToEncrypt = dataToEncrypt + "&";
					}
					var param = settings.data[paramIndex];
					dataToEncrypt = dataToEncrypt + param.name + "=" + param.value;
				}
				settings.htmlContainer.trigger("encryptionInitiated", [settings]);
				//perform encryption and final partial update
				$.jCryption.getKeys(this.getJavaScriptBase() + "jCryption/generateKeyPair", function (keys) {
					settings.htmlContainer.trigger("encryptionKeysAcquired", [settings]);
					$.jCryption.encrypt(encodeURI(dataToEncrypt), keys, function (encryptedData) {
						settings.htmlContainer.trigger("encryptionProcessed", [settings]);
						deferredCall.replaceDataAndPerformCall({ name: "jCryption", value: encryptedData });
					});
				});
			} else {
				deferredCall.performCall();
			}
		},

		// Function for handling file uploads (hat tip to YAHOO!)
		// Originally taken from jQuery Form Plugin (http://malsup.com/jquery/form/)
		// Code is licensed under the: http://www.opensource.org/licenses/mit-license.php
		// That allows us to modify and distribute the original code
		// Thank you guys!
		fileUpload: function fileUpload(form, submit, options) {
			var me = this;
			form = $(form);
			var action = options.url || form.attr('action');
			var url = typeof action === 'string' ? $.trim(action) : '';
			if (url) {
				// clean url (don't include hash vaue)
				url = (url.match(/^([^#]+)/) || [])[1];
			}
			url = url || window.location.href || '';

			options = $.extend(true, {
				url: url,
				type: form.attr('method') || 'GET',
				iframeSrc: /^https/i.test(window.location.href || '') ? 'javascript:false' : 'about:blank'
			}, options);

			var s = $.extend(true, {}, $.ajaxSettings, options);
			if (!s.extraData) {
				s.extraData = s.extraData || {};
			}
			s.extraData["RamJet-Suppress-Redirect"] = "true";
			if (s.layoutContext) {
				s.extraData["ramJetLayoutContext"] = s.layoutContext;
			}

			s.context = s.context || s;
			var id = 'jqFormIO' + new Date().getTime(),
			    fn = '_' + id;
			window[fn] = function () {
				var f = $io.data('form-plugin-onload');
				if (f) {
					f();
					window[fn] = undefined;
					try {
						delete window[fn];
					} catch (e) {}
				}
			};
			var $io = $('<iframe id="' + id + '" name="' + id + '" src="' + s.iframeSrc + '" onload="window[\'_\'+this.id]()" />');
			var io = $io[0];

			$io.css({ position: 'absolute', top: '-1000px', left: '-1000px' });

			var xhr = { // mock object
				aborted: 0,
				responseText: null,
				responseXML: null,
				status: 0,
				statusText: 'n/a',
				getAllResponseHeaders: function getAllResponseHeaders() {},
				getResponseHeader: function getResponseHeader() {},
				setRequestHeader: function setRequestHeader() {},
				abort: function abort() {
					this.aborted = 1;
					$io.attr('src', s.iframeSrc); // abort op in progress
				}
			};

			var g = s.global;
			// trigger ajax global events so that activity/block indicators work like normal
			if (g && !$.active++) {
				$.event.trigger("ajaxStart");
			}
			if (g) {
				$.event.trigger("ajaxSend", [xhr, s]);
			}

			if (s.beforeSend && s.beforeSend.call(s.context, xhr, s) === false) {
				if (s.global) {
					$.active--;
				}
				return;
			}
			if (xhr.aborted) {
				return;
			}

			var cbInvoked = false;
			var timedOut = 0;

			// add submitting element to data if we know it
			if (submit) {
				var n = submit.name;
				if (n && !submit.disabled) {
					s.extraData = s.extraData || {};
					s.extraData[n] = submit.value;
					if (submit.type == "image") {
						s.extraData[n + '.x'] = form.clk_x;
						s.extraData[n + '.y'] = form.clk_y;
					}
				}
			}

			// take a breath so that pending repaints get some cpu time before the upload starts
			function doSubmit() {
				// make sure form attrs are set
				var t = form.attr('target'),
				    a = form.attr('action');

				// update form attrs in IE friendly way
				var nakedForm = form.get(0);
				nakedForm.setAttribute('target', id);
				if (nakedForm.getAttribute('method') != 'POST') {
					nakedForm.setAttribute('method', 'POST');
				}
				if (nakedForm.getAttribute('action') != s.url) {
					nakedForm.setAttribute('action', s.url);
				}

				// ie borks in some cases when setting encoding
				if (!s.skipEncodingOverride) {
					form.attr({
						encoding: 'multipart/form-data',
						enctype: 'multipart/form-data'
					});
				}

				// support timout
				if (s.timeout) {
					setTimeout(function () {
						timedOut = true;cb.call(me);
					}, s.timeout);
				}

				// add "extra" data to form if provided in options
				var extraInputs = [];
				try {
					if (s.extraData) {
						for (var n in s.extraData) {
							extraInputs.push($('<input type="hidden" name="' + n + '" value="' + s.extraData[n] + '" />').appendTo(form)[0]);
						}
					}

					// add iframe to doc and submit the form
					$io.appendTo('body');
					$io.data('form-plugin-onload', cb);
					form.trigger("submit", [$.partialUpdate]);
				} finally {
					// reset attrs and remove "extra" input elements
					nakedForm.setAttribute('action', a);
					if (t) {
						nakedForm.setAttribute('target', t);
					} else {
						form.removeAttr('target');
					}
					$(extraInputs).remove();
				}
			}

			if (s.forceSync) {
				doSubmit();
			} else {
				setTimeout(function () {
					doSubmit.call(me);
				}, 10); // this lets dom updates render
			}

			var data,
			    doc,
			    domCheckCount = 50;

			function cb() {
				if (cbInvoked) {
					return;
				}

				$io.removeData('form-plugin-onload');

				var ok = true;
				try {
					if (timedOut) {
						throw 'timeout';
					}
					// extract the server response from the iframe
					doc = io.contentWindow ? io.contentWindow.document : io.contentDocument ? io.contentDocument : io.document;

					var isXml = s.dataType == 'xml' || doc.XMLDocument || $.isXMLDoc(doc);
					if (!isXml && window.opera && (doc.body == null || doc.body.innerHTML == '')) {
						if (--domCheckCount) {
							// in some browsers (Opera) the iframe DOM is not always traversable when
							// the onload callback fires, so we loop a bit to accommodate
							$.partialUpdate._log('requeing onLoad callback, DOM not available');
							setTimeout(function () {
								cb.call(me);
							}, 250);
							return;
						}
					}

					cbInvoked = true;
					xhr.responseText = doc.body ? doc.body.innerHTML : null;

					/**
      * First comment gets appended before html header instead of body and we need that to detect
      * multiple widget result delimiters.
      */
					if (doc.firstChild.nodeType == 8) {
						xhr.responseText = "<!--" + doc.firstChild.nodeValue + "-->" + xhr.responseText;
					}

					xhr.responseXML = doc.XMLDocument ? doc.XMLDocument : doc;
					xhr.status = 200;
					xhr.getResponseHeader = function (header) {
						var headers = { 'content-type': s.dataType };
						return headers[header];
					};

					var scr = /(json|script)/.test(s.dataType);
					if (scr || s.textarea) {
						// see if user embedded response in textarea
						var ta = doc.getElementsByTagName('textarea')[0];
						if (ta) {
							xhr.responseText = ta.value;
						} else if (scr) {
							// account for browsers injecting pre around json response
							var pre = doc.getElementsByTagName('pre')[0];
							var b = doc.getElementsByTagName('body')[0];
							if (pre) {
								xhr.responseText = pre.textContent;
							} else if (b) {
								xhr.responseText = b.innerHTML;
							}
						}
					} else if (s.dataType == 'xml' && !xhr.responseXML && xhr.responseText != null) {
						xhr.responseXML = toXml(xhr.responseText);
					}
					data = httpData(xhr, s.dataType);
				} catch (e) {
					$.partialUpdate._log('error caught:', e);
					ok = false;
					xhr.error = e;
					$.handleError(s, xhr, 'error', e);
				}

				if (xhr.aborted) {
					$.partialUpdate._log('upload aborted');
					ok = false;
				}

				// ordering of these callbacks/triggers is odd, but that's how $.ajax does it
				if (ok) {
					s.success.call(s.context, data, 'success', xhr);
					if (g) {
						$.event.trigger("ajaxSuccess", [xhr, s]);
					}
				}
				if (g) {
					$.event.trigger("ajaxComplete", [xhr, s]);
				}
				if (g && ! --$.active) {
					$.event.trigger("ajaxStop");
				}
				if (s.complete) {
					s.complete.call(s.context, xhr, ok ? 'success' : 'error');
				}

				// clean up
				setTimeout(function () {
					$io.removeData('form-plugin-onload');
					$io.remove();
					xhr.responseXML = null;
				}, 100);
			}

			function toXml(s, doc) {
				if (window.ActiveXObject) {
					doc = new ActiveXObject('Microsoft.XMLDOM');
					doc.async = 'false';
					doc.loadXML(s);
				} else {
					doc = new DOMParser().parseFromString(s, 'text/xml');
				}
				return doc && doc.documentElement && doc.documentElement.tagName != 'parsererror' ? doc : null;
			}
			var parseJSON = JSON.parse || function (s) {
				return window['eval']('(' + s + ')');
			};

			var httpData = function httpData(xhr, type, s) {
				// mostly lifted from jq1.4.4

				var ct = xhr.getResponseHeader('content-type') || '',
				    xml = type === 'xml' || !type && ct.indexOf('xml') >= 0,
				    data = xml ? xhr.responseXML : xhr.responseText;

				if (xml && data.documentElement.nodeName === 'parsererror') {
					$.error && $.error('parsererror');
				}
				if (s && s.dataFilter) {
					data = s.dataFilter(data, type);
				}
				if (typeof data === 'string') {
					if (type === 'json' || !type && ct.indexOf('json') >= 0) {
						data = parseJSON(data);
					} else if (type === "script" || !type && ct.indexOf("javascript") >= 0) {
						$.globalEval(data);
					}
				}
				return data;
			};
		},

		/**
   * Returns base JavaScript file path based on current (this) javascript path, which is known.
   */
		getJavaScriptBase: function getJavaScriptBase() {
			var src = null;
			$("script").each(function () {
				var scriptSrc = $(this).attr("src");
				if (scriptSrc !== undefined && scriptSrc.indexOf("jquery.partialUpdate") > -1) {
					src = scriptSrc;
				}
			});
			if (src !== null) {
				return src.substring(0, src.lastIndexOf("jquery.partialUpdate"));
			} else {
				return null;
			}
		},

		/**
   * This method will render AJAX loader on the page it it's not already present.
   */
		showAjaxLoader: function showAjaxLoader() {
			var htmlLoader = $("#loader");
			if (htmlLoader.length == 0) {
				htmlLoader = $('<div id="loader" style="position: absolute; overflow: hidden; z-index: 1000000;"><img src="data:image/gif;base64,R0lGODlhEAAQAKIGANjY2O7u7mRkZAQEBE5OTr6+vv///wAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQFAAAGACwAAAAAEAAQAAADKWi63P4wykkVuMBijUPIBuCB4leSozWe6tdeaRifrOza2MWRW+X/wEYCACH5BAkKAAYALAAAAwAEAAsAAAMLOKpE7KO9GaGsdCUAIfkECQoABgAsAAAAABAAEAAAAzFoutz+MMZBhxNYqEGIbUJRaAbnXSJpfkw4bh27uGqMvqUNpvC546tLpieDVIqSpDIBACH5BAkKAAYALAAAAAAQABAAAAM9aLrc/jDKNupwIgs1CBlACChCUWxG9wFBMBrlyXlg+8aoWrukmdMsHsw3W9l6shRQhPx9MJriZWKZTq6PBAAh+QQFCgAGACwAAAAAEAAQAAADMmi63P4wyimFFSADpbcRRYEFgQeQHiieJYcq6tgabBrK5vvdtTvHHY4GdqNcBJSkMpIAACH5BAkKAAYALAYAAwAKAAsAAAMYODrWPoQw16CkNU5q99OY0YUjVnKguYQJACH5BAkKAAYALAAAAAAQABAAAAM8aLrc/jCuQYdUgxBrhBdOtilCUYAGoAIiV54KEASs5pqoTLckHs+1UceXAvKGsOLO1kuugq5PqHKpWiEJACH5BAkKAAYALAAAAAAQABAAAAMzaLrc/jDKKKqYRpRyDfiAAgIaJwZB6KHk1gHsmZZvvM6urMK4ee8smgg0/Fg6mKRyyUgAACH5BAUKAAYALAAAAAAQABAAAAMpaLrc/jDKSRW4wGKNQ8gG4IHiV5KjNZ7q115pGJ+s7NrYxZFb5f/ARgIAIfkEBSMABgAsAAAAAAEAAQAAAwJoCQA7"/></div>');
				$(document.body).append(htmlLoader);
			}
			this.positionAjaxLoader();
			$("#loader").show();
			window.__ajaxLoaderHidden = false;
		},

		/**
   * This method will hide AJAX preloader.
   */
		hideAjaxLoader: function hideAjaxLoader() {
			$("#loader").hide();
			window.__ajaxLoaderHidden = true;
		},

		/**
   * This method monitors mouse move positions and moves the AJAX preloader if it is visible. It also automatically
   * and temporarily hides preloader if the mouse gets too close to the edges of the page.
   * @param event
   */
		moveAjaxLoader: function moveAjaxLoader(event) {
			/** FOR DEBUGGING PURPOSES **/
			/**
    if ($('#monitor').length == 0) {
                $(document.body).append("<div id='monitor' style='position: absolute; top: 10px; left: 10px;'></div>");
            }
    $('#monitor').css("top", window.pageYOffset + 10 + "px").html("<b>Mouse X:</b> " + window.__mouseX + "<br><b>Mouse Y:</b> " + window.__mouseY + "<br><b>AJAX on background:</b> " + !window.__ajaxLoaderHidden + "<br><b>Close to border:</b> " + window.__ajaxLoaderHiddenDueToBorder);
    **/
			if (event.pageX !== undefined && event.pageY !== undefined) {
				window.__mouseX = event.pageX;
				window.__mouseY = event.pageY;
			}
			if (!window.__ajaxLoaderHidden) {
				if (window.__mouseX + 24 + 24 >= window.pageXOffset + $(window).width() || window.__mouseY + 24 + 24 >= window.pageYOffset + $(window).height() || window.__mouseX - 24 <= window.pageXOffset || window.__mouseY - 24 <= window.pageYOffset) {
					window.__ajaxLoaderHiddenDueToBorder = true;
					$("#loader").hide();
				} else {
					if (window.__ajaxLoaderHiddenDueToBorder) {
						window.__ajaxLoaderHiddenDueToBorder = false;
						$("#loader").show();
					}
					this.positionAjaxLoader();
				}
			}
		},

		/**
   * This method wil alter preloader position relative to the mouse position.
   */
		positionAjaxLoader: function positionAjaxLoader() {
			$("#loader").css("left", window.__mouseX + 18).css("top", window.__mouseY + 18);
		}

	};

	/**
  * This could be overwriten in case, queuing and ajax preloading is required to be off on particular site.
  * Default behaviour - AJAX partial update requests are queued and preloader image is shown when any AJAX
  * request is running.
  *
  * If you want just to change preloader image, provide your own implementation of:
  * $.partialUpdateManager.AjaxManager.prototype.getPreloaderImage = function() { return "/img/myImage.gif"; }
  */
	$.partialUpdate = $.partialUpdate === undefined ? new $.partialUpdateManager(true, true) : $.partialUpdate;

	$.fn.partialUpdate = function (domainWithProtocol, currentPageUrl, settings, callback, overridenContainerId) {
		if (!domainWithProtocol) {
			domainWithProtocol = window.location.protocol + "//" + window.location.host;
		}
		if (!currentPageUrl) {
			currentPageUrl = window.location.pathname;
		}

		var internalPaths = [currentPageUrl, domainWithProtocol + currentPageUrl];

		return this.each(function () {
			var containerId = overridenContainerId ? overridenContainerId : this.id;
			var frmCount = 0;
			var firstForm = null;

			var composeSettings = function composeSettings(settings, event) {
				var resultSettings = {};
				var additionalSettings = {};
				if ($(this).hasClass("clearCache")) {
					additionalSettings.clearCache = true;
				}
				$.extend(resultSettings, settings, additionalSettings);
				var eventTarget = $(event.target);
				var extractNearestAttribute = function extractNearestAttribute(eventTarget, attributeName) {
					var attrValue = eventTarget.attr(attributeName);
					if (typeof attrValue !== 'undefined' && attrValue !== false) {
						return attrValue;
					} else {
						var parentElements = eventTarget.parents("[" + attributeName + "]");
						if (parentElements.length > 0) {
							return $(parentElements.get(0)).attr(attributeName);
						}
					}
				};

				//withdraw partial update parameters from the event target if it is defined
				var additionalData = extractNearestAttribute(eventTarget, "data-partial-update");
				if (additionalData) {
					var dataPUJson = JSON.parse(additionalData);
					$.extend(resultSettings, dataPUJson);
				}
				//withdraw partial update target from the event target if it is defined
				var currentElmPUTarget = extractNearestAttribute(eventTarget, "data-partial-update-target");
				if (currentElmPUTarget) {
					try {
						resultSettings.containerId = JSON.parse(currentElmPUTarget);
					} catch (e) {
						resultSettings.containerId = currentElmPUTarget;
					}
				}
				//withdraw partial update target html container from the event target if it is defined
				var currentElmPUTargetContainer = extractNearestAttribute(eventTarget, "data-partial-update-target-html-container");
				if (currentElmPUTargetContainer) {
					resultSettings.htmlContainer = currentElmPUTargetContainer;
				}
				//add to result settings reference to the originating event
				resultSettings.invokedEvent = event;
				return resultSettings;
			};

			var enhance = function enhance(attribute, paths) {
				if ($.data(this, "enhancedByPartialUpdate") === true) {
					return false;
				}
				if ($(this).hasClass("partialUpdate")) {
					return true;
				}
				if (attribute) {
					for (var j = 0; j < paths.length; j++) {
						var path = paths[j];
						var hrefAttr = $(this).attr(attribute);
						if (hrefAttr && hrefAttr.indexOf(path) == 0) {
							return true;
						}
					}
					return false;
				} else {
					return true;
				}
			};

			//convert all submit buttons of the inside forms targeting same page into partial updates (except those with class "noPartialUpdate")
			var puForms = $(this).find("form").not(".noPartialUpdate");
			if (this.tagName.toLocaleLowerCase() == "form" && !$(this).hasClass("noPartialUpdate")) {
				if (!this.id || this.id == "") {
					$.partialUpdate._log("Form has no id!");
				} else {
					puForms = puForms.add("#" + this.id, document);
				}
			}
			puForms.each(function () {
				var $thisPuForm = $(this);
				if (enhance.call(this, "action", internalPaths) || enhance.call(this, "data-partial-update-url", internalPaths)) {
					frmCount = frmCount + 1;
					if (firstForm == null) {
						firstForm = this;
					}
					//bind trigger for specific event
					$thisPuForm.bind("partialUpdate", function (e) {
						if (!e.isDefaultPrevented()) {
							var $thisForm = $(this);
							var callSettings;
							if (!settings || settings.enhancedSettings === undefined) {
								var enhancedSettings = $.extend({ suppressSubmitEvent: true }, settings);
								callSettings = composeSettings.call(this, enhancedSettings, e);
							} else {
								callSettings = composeSettings.call(this, settings, e);
							}
							var callContainerId = callSettings.containerId ? callSettings.containerId : containerId;
							$.partialUpdate.executeSubmit($thisForm.attr("id"), callContainerId, callback, callSettings);
							return false;
						}
					});
					$thisPuForm.data("enhancedByPartialUpdate", true);
				}
				var buttons1 = $thisPuForm.find("input[type='submit']");
				var buttons2 = $thisPuForm.find("input[type='image']");
				var buttons3 = $thisPuForm.find("button[type='submit']");
				var buttons4 = $thisPuForm.find("button[type='image']");
				var buttons5 = $thisPuForm.find("input[type='button']");
				var buttons = buttons1.add(buttons2).add(buttons3).add(buttons4).add(buttons5);
				buttons.not(".noPartialUpdate").each(function () {
					var $thisSubmit = $(this);
					if (!$thisSubmit.parents().hasClass("noPartialUpdate")) {
						if (enhance.call(this)) {
							$.data(this, "enhancedByPartialUpdate", true);
							$thisSubmit.on("click", function (e) {
								if (!e.isDefaultPrevented()) {
									if (!this.id || this.id == "") $.partialUpdate._log("Clicked object has no id!");
									var callSettings = composeSettings.call(this, settings, e);
									var callContainerId = callSettings.containerId ? callSettings.containerId : containerId;
									$.partialUpdate.executeSubmit(this.id, callContainerId, callback, callSettings);return false;
								}
							});
						}
					}
				});
				//convert all anchors of the inside forms (relative url) targeting same page into partial updates (except those with class "noPartialUpdate")
				$(this).find("a").not(".noPartialUpdate").each(function () {
					var $this = $(this);
					if (!$this.parents().hasClass("noPartialUpdate")) {
						if (enhance.call(this, "href", internalPaths)) {
							$.data(this, "enhancedByPartialUpdate", true);
							$this.on("click", function (e) {
								if (!e.isDefaultPrevented()) {
									var id = $(this).parents("form").attr("id");
									if (!id || id == "") $.partialUpdate._log("Parent form has no id!");
									var callSettings = composeSettings.call(this, settings, e);
									var callContainerId = callSettings.containerId ? callSettings.containerId : containerId;
									$.partialUpdate.executeCombi(this.href, id, callContainerId, callback, callSettings);return false;
								}
							});
						}
					}
				});
			});

			//convert all inside anchors targeting same page into partial updates (except those with class "noPartialUpdate")
			//links with class 'bindWithForm' will be partially updated with posting all data from the single form in the container element
			$(this).find("a").not(".noPartialUpdate").each(function () {
				var $this = $(this);
				if (!$this.parents().hasClass("noPartialUpdate")) {
					if (enhance.call(this, "href", internalPaths)) {
						$.data(this, "enhancedByPartialUpdate", true);
						if ($this.hasClass("bindWithForm") && frmCount == 1) {
							$this.on("click", function (e) {
								if (!e.isDefaultPrevented()) {
									var callSettings = composeSettings.call(this, settings, e);
									var callContainerId = callSettings.containerId ? callSettings.containerId : containerId;
									$.partialUpdate.executeCombi(this.href, firstForm.id, callContainerId, callback, callSettings);return false;
								}
							});
						} else {
							$this.on("click", function (e) {
								if (!e.isDefaultPrevented()) {
									var callSettings = composeSettings.call(this, settings, e);
									var callContainerId = callSettings.containerId ? callSettings.containerId : containerId;
									$.partialUpdate.execute(this.href, callContainerId, callback, callSettings);return false;
								}
							});
						}
					}
				}
			});
		});
	};
})(jQuery);

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var jQuery = __webpack_require__(3);

/**!
 * project-site: http://plugins.jquery.com/project/AjaxManager
 * repository: http://github.com/aFarkas/Ajaxmanager
 * @author Alexander Farkas
 * @version 3.12
 * Copyright 2010, Alexander Farkas
 * Dual licensed under the MIT or GPL Version 2 licenses.
 */

(function ($) {
    "use strict";

    var managed = {},
        cache = {};
    $.manageAjax = function () {
        function create(name, opts) {
            managed[name] = new $.manageAjax._manager(name, opts);
            return managed[name];
        }

        function destroy(name) {
            if (managed[name]) {
                managed[name].clear(true);
                delete managed[name];
            }
        }

        var publicFns = {
            create: create,
            destroy: destroy
        };

        return publicFns;
    }();

    $.manageAjax._manager = function (name, opts) {
        this.requests = {};
        this.inProgress = 0;
        this.name = name;
        this.qName = name;

        this.opts = $.extend({}, $.manageAjax.defaults, opts);
        if (opts && opts.queue && opts.queue !== true && typeof opts.queue === 'string' && opts.queue !== 'clear') {
            this.qName = opts.queue;
        }
    };

    $.manageAjax._manager.prototype = {
        add: function add(url, o) {
            if ((typeof url === 'undefined' ? 'undefined' : _typeof(url)) == 'object') {
                o = url;
            } else if (typeof url == 'string') {
                o = $.extend(o || {}, { url: url });
            }
            o = $.extend({}, this.opts, o);

            var origCom = o.complete || $.noop,
                origSuc = o.success || $.noop,
                beforeSend = o.beforeSend || $.noop,
                origError = o.error || $.noop,
                strData = typeof o.data == 'string' ? o.data : $.param(o.data || {}),
                xhrID = o.type + o.url + strData,
                that = this,
                ajaxFn = this._createAjax(xhrID, o, origSuc, origCom);
            if (o.preventDoubleRequests && o.queueDuplicateRequests) {
                if (o.preventDoubleRequests) {
                    o.queueDuplicateRequests = false;
                }
                setTimeout(function () {
                    throw "preventDoubleRequests and queueDuplicateRequests can't be both true";
                }, 0);
            }
            if (this.requests[xhrID] && o.preventDoubleRequests) {
                return;
            }
            ajaxFn.xhrID = xhrID;
            o.xhrID = xhrID;

            o.beforeSend = function (xhr, opts) {
                var ret = beforeSend.call(this, xhr, opts);
                if (ret === false) {
                    that._removeXHR(xhrID);
                }
                xhr = null;
                return ret;
            };
            o.complete = function (xhr, status) {
                that._complete.call(that, this, origCom, xhr, status, xhrID, o);
                xhr = null;
            };

            o.success = function (data, status, xhr) {
                that._success.call(that, this, origSuc, data, status, xhr, o);
                xhr = null;
            };

            //always add some error callback
            o.error = function (ahr, status, errorStr) {
                var httpStatus = '',
                    content = '';
                if (status !== 'timeout' && ahr) {
                    httpStatus = ahr.status;
                    content = ahr.responseXML || ahr.responseText;
                }
                if (origError) {
                    origError.call(this, ahr, status, errorStr, o);
                } else {
                    setTimeout(function () {
                        throw status + '| status: ' + httpStatus + ' | URL: ' + o.url + ' | data: ' + strData + ' | thrown: ' + errorStr + ' | response: ' + content;
                    }, 0);
                }
                ahr = null;
            };

            if (o.queue === 'clear') {
                $(document).clearQueue(this.qName);
            }

            if (o.queue || o.queueDuplicateRequests && this.requests[xhrID]) {
                $.queue(document, this.qName, ajaxFn);
                if (this.inProgress < o.maxRequests && (!this.requests[xhrID] || !o.queueDuplicateRequests)) {
                    $.dequeue(document, this.qName);
                }
                return xhrID;
            }
            return ajaxFn();
        },
        _createAjax: function _createAjax(id, o, origSuc, origCom) {
            var that = this;
            return function () {
                if (o.beforeCreate.call(o.context || that, id, o) === false) {
                    return;
                }
                that.inProgress++;
                if (that.inProgress === 1) {
                    $.event.trigger(that.name + 'AjaxStart');
                }
                if (o.cacheResponse && cache[id]) {
                    if (!cache[id].cacheTTL || cache[id].cacheTTL < 0 || new Date().getTime() - cache[id].timestamp < cache[id].cacheTTL) {
                        that.requests[id] = {};
                        //START OF TWEAK
                        var cachedData = cache[id];
                        //END OF TWEAK
                        setTimeout(function () {
                            that._success.call(that, o.context || o, origSuc, cachedData._successData, 'success', cachedData, o);
                            that._complete.call(that, o.context || o, origCom, cachedData, 'success', id, o);
                        }, 0);
                    } else {
                        delete cache[id];
                    }
                }
                if (!o.cacheResponse || !cache[id]) {
                    if (o.async) {
                        that.requests[id] = $.ajax(o);
                    } else {
                        $.ajax(o);
                    }
                }
                return id;
            };
        },
        _removeXHR: function _removeXHR(xhrID) {
            if (this.opts.queue || this.opts.queueDuplicateRequests) {
                $.dequeue(document, this.qName);
            }
            this.inProgress--;
            this.requests[xhrID] = null;
            delete this.requests[xhrID];
        },
        clearCache: function clearCache() {
            cache = {};
        },
        _isAbort: function _isAbort(xhr, status, o) {
            if (!o.abortIsNoSuccess || !xhr && !status) {
                return false;
            }
            var ret = !!(!xhr || xhr.readyState === 0 || this.lastAbort === o.xhrID);
            xhr = null;
            return ret;
        },
        _complete: function _complete(context, origFn, xhr, status, xhrID, o) {
            if (this._isAbort(xhr, status, o)) {
                status = 'abort';
                o.abort.call(context, xhr, status, o);
            }
            origFn.call(context, xhr, status, o);

            $.event.trigger(this.name + 'AjaxComplete', [xhr, status, o]);

            if (o.domCompleteTrigger) {
                $(o.domCompleteTrigger).trigger(this.name + 'DOMComplete', [xhr, status, o]).trigger('DOMComplete', [xhr, status, o]);
            }

            this._removeXHR(xhrID);
            if (!this.inProgress) {
                $.event.trigger(this.name + 'AjaxStop');
            }
            xhr = null;
        },
        _success: function _success(context, origFn, data, status, xhr, o) {
            var that = this;
            if (this._isAbort(xhr, status, o)) {
                xhr = null;
                return;
            }
            if (o.abortOld) {
                $.each(this.requests, function (name) {
                    if (name === o.xhrID) {
                        return false;
                    }
                    that.abort(name);
                });
            }
            if (o.cacheResponse && !cache[o.xhrID]) {
                if (!xhr) {
                    xhr = {};
                }
                cache[o.xhrID] = {
                    status: xhr.status,
                    statusText: xhr.statusText,
                    responseText: xhr.responseText,
                    responseXML: xhr.responseXML,
                    _successData: data,
                    cacheTTL: o.cacheTTL,
                    timestamp: new Date().getTime()
                };
                if ('getAllResponseHeaders' in xhr) {
                    var responseHeaders = xhr.getAllResponseHeaders();
                    var parsedHeaders;
                    var parseHeaders = function parseHeaders() {
                        if (parsedHeaders) {
                            return;
                        }
                        parsedHeaders = {};
                        $.each(responseHeaders.split("\n"), function (i, headerLine) {
                            var delimiter = headerLine.indexOf(":");
                            parsedHeaders[headerLine.substr(0, delimiter)] = headerLine.substr(delimiter + 2);
                        });
                    };
                    $.extend(cache[o.xhrID], {
                        getAllResponseHeaders: function getAllResponseHeaders() {
                            return responseHeaders;
                        },
                        getResponseHeader: function getResponseHeader(name) {
                            parseHeaders();
                            return name in parsedHeaders ? parsedHeaders[name] : null;
                        }
                    });
                }
            }
            origFn.call(context, data, status, xhr, o);
            $.event.trigger(this.name + 'AjaxSuccess', [xhr, o, data]);
            if (o.domSuccessTrigger) {
                $(o.domSuccessTrigger).trigger(this.name + 'DOMSuccess', [data, o]).trigger('DOMSuccess', [data, o]);
            }
            xhr = null;
        },
        getData: function getData(id) {
            if (id) {
                var ret = this.requests[id];
                if (!ret && this.opts.queue) {
                    ret = $.grep($(document).queue(this.qName), function (fn, i) {
                        return fn.xhrID === id;
                    })[0];
                }
                return ret;
            }
            return {
                requests: this.requests,
                queue: this.opts.queue ? $(document).queue(this.qName) : [],
                inProgress: this.inProgress
            };
        },
        abort: function abort(id) {
            var xhr;
            if (id) {
                xhr = this.getData(id);

                if (xhr && xhr.abort) {
                    this.lastAbort = id;
                    xhr.abort();
                    this.lastAbort = false;
                } else {
                    $(document).queue(this.qName, $.grep($(document).queue(this.qName), function (fn, i) {
                        return fn !== xhr;
                    }));
                }
                xhr = null;
                return;
            }

            var that = this,
                ids = [];
            $.each(this.requests, function (id) {
                ids.push(id);
            });
            $.each(ids, function (i, id) {
                that.abort(id);
            });
        },
        clear: function clear(shouldAbort) {
            $(document).clearQueue(this.qName);
            if (shouldAbort) {
                this.abort();
            }
        }
    };
    $.manageAjax._manager.prototype.getXHR = $.manageAjax._manager.prototype.getData;
    $.manageAjax.defaults = {
        beforeCreate: $.noop,
        abort: $.noop,
        abortIsNoSuccess: true,
        maxRequests: 1,
        cacheResponse: false,
        async: true,
        domCompleteTrigger: false,
        domSuccessTrigger: false,
        preventDoubleRequests: true,
        queueDuplicateRequests: false,
        cacheTTL: -1,
        queue: false // true, false, clear
    };

    $.each($.manageAjax._manager.prototype, function (n, fn) {
        if (n.indexOf('_') === 0 || !$.isFunction(fn)) {
            return;
        }
        $.manageAjax[n] = function (name, o) {
            if (!managed[name]) {
                if (n === 'add') {
                    $.manageAjax.create(name, o);
                } else {
                    return;
                }
            }
            var args = Array.prototype.slice.call(arguments, 1);
            managed[name][n].apply(managed[name], args);
        };
    });
})(jQuery);

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var jQuery = __webpack_require__(3);

(function ($) {
    // block scope
    jQuery.fn.log = function (msg) {
        if (!window.console || !console) return;
        if (window.console || console.firebug) {
            msg = msg || '';
            if (msg !== '') msg += ': ';
            console.log("%s%o", msg, this);
        }
        return this;
    };
    $.extend({
        log: function log(msg) {
            if (!window.console || !console) return;
            if (window.console || console.firebug) {
                console.log("%s", msg);
            }
        }
    });
})(jQuery);

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var jQuery = __webpack_require__(3);
__webpack_require__(382);
/*!
 * jQuery Migrate - v1.4.1 - 2016-05-19
 * Copyright jQuery Foundation and other contributors
 */
(function (jQuery, window, undefined) {
  // See http://bugs.jquery.com/ticket/13335
  // "use strict";


  jQuery.migrateVersion = "1.4.1";

  var warnedAbout = {};

  // List of warnings already given; public read only
  jQuery.migrateWarnings = [];

  // Set to true to prevent console output; migrateWarnings still maintained
  // jQuery.migrateMute = false;

  // Show a message on the console so devs know we're active
  if (window.console && window.console.log) {
    window.console.log("JQMIGRATE: Migrate is installed" + (jQuery.migrateMute ? "" : " with logging active") + ", version " + jQuery.migrateVersion);
  }

  // Set to false to disable traces that appear with warnings
  if (jQuery.migrateTrace === undefined) {
    jQuery.migrateTrace = true;
  }

  // Forget any warnings we've already given; public
  jQuery.migrateReset = function () {
    warnedAbout = {};
    jQuery.migrateWarnings.length = 0;
  };

  function migrateWarn(msg) {
    var console = window.console;
    if (!warnedAbout[msg]) {
      warnedAbout[msg] = true;
      jQuery.migrateWarnings.push(msg);
      if (console && console.warn && !jQuery.migrateMute) {
        console.warn("JQMIGRATE: " + msg);
        if (jQuery.migrateTrace && console.trace) {
          console.trace();
        }
      }
    }
  }

  function migrateWarnProp(obj, prop, value, msg) {
    if (Object.defineProperty) {
      // On ES5 browsers (non-oldIE), warn if the code tries to get prop;
      // allow property to be overwritten in case some other plugin wants it
      try {
        Object.defineProperty(obj, prop, {
          configurable: true,
          enumerable: true,
          get: function get() {
            migrateWarn(msg);
            return value;
          },
          set: function set(newValue) {
            migrateWarn(msg);
            value = newValue;
          }
        });
        return;
      } catch (err) {
        // IE8 is a dope about Object.defineProperty, can't warn there
      }
    }

    // Non-ES5 (or broken) browser; just set the property
    jQuery._definePropertyBroken = true;
    obj[prop] = value;
  }

  if (document.compatMode === "BackCompat") {
    // jQuery has never supported or tested Quirks Mode
    migrateWarn("jQuery is not compatible with Quirks Mode");
  }

  var attrFn = jQuery("<input/>", { size: 1 }).attr("size") && jQuery.attrFn,
      oldAttr = jQuery.attr,
      valueAttrGet = jQuery.attrHooks.value && jQuery.attrHooks.value.get || function () {
    return null;
  },
      valueAttrSet = jQuery.attrHooks.value && jQuery.attrHooks.value.set || function () {
    return undefined;
  },
      rnoType = /^(?:input|button)$/i,
      rnoAttrNodeType = /^[238]$/,
      rboolean = /^(?:autofocus|autoplay|async|checked|controls|defer|disabled|hidden|loop|multiple|open|readonly|required|scoped|selected)$/i,
      ruseDefault = /^(?:checked|selected)$/i;

  // jQuery.attrFn
  migrateWarnProp(jQuery, "attrFn", attrFn || {}, "jQuery.attrFn is deprecated");

  jQuery.attr = function (elem, name, value, pass) {
    var lowerName = name.toLowerCase(),
        nType = elem && elem.nodeType;

    if (pass) {
      // Since pass is used internally, we only warn for new jQuery
      // versions where there isn't a pass arg in the formal params
      if (oldAttr.length < 4) {
        migrateWarn("jQuery.fn.attr( props, pass ) is deprecated");
      }
      if (elem && !rnoAttrNodeType.test(nType) && (attrFn ? name in attrFn : jQuery.isFunction(jQuery.fn[name]))) {
        return jQuery(elem)[name](value);
      }
    }

    // Warn if user tries to set `type`, since it breaks on IE 6/7/8; by checking
    // for disconnected elements we don't warn on $( "<button>", { type: "button" } ).
    if (name === "type" && value !== undefined && rnoType.test(elem.nodeName) && elem.parentNode) {
      migrateWarn("Can't change the 'type' of an input or button in IE 6/7/8");
    }

    // Restore boolHook for boolean property/attribute synchronization
    if (!jQuery.attrHooks[lowerName] && rboolean.test(lowerName)) {
      jQuery.attrHooks[lowerName] = {
        get: function get(elem, name) {
          // Align boolean attributes with corresponding properties
          // Fall back to attribute presence where some booleans are not supported
          var attrNode,
              property = jQuery.prop(elem, name);
          return property === true || typeof property !== "boolean" && (attrNode = elem.getAttributeNode(name)) && attrNode.nodeValue !== false ? name.toLowerCase() : undefined;
        },
        set: function set(elem, value, name) {
          var propName;
          if (value === false) {
            // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
          } else {
            // value is true since we know at this point it's type boolean and not false
            // Set boolean attributes to the same name and set the DOM property
            propName = jQuery.propFix[name] || name;
            if (propName in elem) {
              // Only set the IDL specifically if it already exists on the element
              elem[propName] = true;
            }

            elem.setAttribute(name, name.toLowerCase());
          }
          return name;
        }
      };

      // Warn only for attributes that can remain distinct from their properties post-1.9
      if (ruseDefault.test(lowerName)) {
        migrateWarn("jQuery.fn.attr('" + lowerName + "') might use property instead of attribute");
      }
    }

    return oldAttr.call(jQuery, elem, name, value);
  };

  // attrHooks: value
  jQuery.attrHooks.value = {
    get: function get(elem, name) {
      var nodeName = (elem.nodeName || "").toLowerCase();
      if (nodeName === "button") {
        return valueAttrGet.apply(this, arguments);
      }
      if (nodeName !== "input" && nodeName !== "option") {
        migrateWarn("jQuery.fn.attr('value') no longer gets properties");
      }
      return name in elem ? elem.value : null;
    },
    set: function set(elem, value) {
      var nodeName = (elem.nodeName || "").toLowerCase();
      if (nodeName === "button") {
        return valueAttrSet.apply(this, arguments);
      }
      if (nodeName !== "input" && nodeName !== "option") {
        migrateWarn("jQuery.fn.attr('value', val) no longer sets properties");
      }
      // Does not return so that setAttribute is also used
      elem.value = value;
    }
  };

  var matched,
      browser,
      oldInit = jQuery.fn.init,
      oldFind = jQuery.find,
      oldParseJSON = jQuery.parseJSON,
      rspaceAngle = /^\s*</,
      rattrHashTest = /\[(\s*[-\w]+\s*)([~|^$*]?=)\s*([-\w#]*?#[-\w#]*)\s*\]/,
      rattrHashGlob = /\[(\s*[-\w]+\s*)([~|^$*]?=)\s*([-\w#]*?#[-\w#]*)\s*\]/g,

  // Note: XSS check is done below after string is trimmed
  rquickExpr = /^([^<]*)(<[\w\W]+>)([^>]*)$/;

  // $(html) "looks like html" rule change
  jQuery.fn.init = function (selector, context, rootjQuery) {
    var match, ret;

    if (selector && typeof selector === "string") {
      if (!jQuery.isPlainObject(context) && (match = rquickExpr.exec(jQuery.trim(selector))) && match[0]) {

        // This is an HTML string according to the "old" rules; is it still?
        if (!rspaceAngle.test(selector)) {
          migrateWarn("$(html) HTML strings must start with '<' character");
        }
        if (match[3]) {
          migrateWarn("$(html) HTML text after last tag is ignored");
        }

        // Consistently reject any HTML-like string starting with a hash (gh-9521)
        // Note that this may break jQuery 1.6.x code that otherwise would work.
        if (match[0].charAt(0) === "#") {
          migrateWarn("HTML string cannot start with a '#' character");
          jQuery.error("JQMIGRATE: Invalid selector string (XSS)");
        }

        // Now process using loose rules; let pre-1.8 play too
        // Is this a jQuery context? parseHTML expects a DOM element (#178)
        if (context && context.context && context.context.nodeType) {
          context = context.context;
        }

        if (jQuery.parseHTML) {
          return oldInit.call(this, jQuery.parseHTML(match[2], context && context.ownerDocument || context || document, true), context, rootjQuery);
        }
      }
    }

    ret = oldInit.apply(this, arguments);

    // Fill in selector and context properties so .live() works
    if (selector && selector.selector !== undefined) {
      // A jQuery object, copy its properties
      ret.selector = selector.selector;
      ret.context = selector.context;
    } else {
      ret.selector = typeof selector === "string" ? selector : "";
      if (selector) {
        ret.context = selector.nodeType ? selector : context || document;
      }
    }

    return ret;
  };
  jQuery.fn.init.prototype = jQuery.fn;

  jQuery.find = function (selector) {
    var args = Array.prototype.slice.call(arguments);

    // Support: PhantomJS 1.x
    // String#match fails to match when used with a //g RegExp, only on some strings
    if (typeof selector === "string" && rattrHashTest.test(selector)) {

      // The nonstandard and undocumented unquoted-hash was removed in jQuery 1.12.0
      // First see if qS thinks it's a valid selector, if so avoid a false positive
      try {
        document.querySelector(selector);
      } catch (err1) {

        // Didn't *look* valid to qSA, warn and try quoting what we think is the value
        selector = selector.replace(rattrHashGlob, function (_, attr, op, value) {
          return "[" + attr + op + "\"" + value + "\"]";
        });

        // If the regexp *may* have created an invalid selector, don't update it
        // Note that there may be false alarms if selector uses jQuery extensions
        try {
          document.querySelector(selector);
          migrateWarn("Attribute selector with '#' must be quoted: " + args[0]);
          args[0] = selector;
        } catch (err2) {
          migrateWarn("Attribute selector with '#' was not fixed: " + args[0]);
        }
      }
    }

    return oldFind.apply(this, args);
  };

  // Copy properties attached to original jQuery.find method (e.g. .attr, .isXML)
  var findProp;
  for (findProp in oldFind) {
    if (Object.prototype.hasOwnProperty.call(oldFind, findProp)) {
      jQuery.find[findProp] = oldFind[findProp];
    }
  }

  // Let $.parseJSON(falsy_value) return null
  jQuery.parseJSON = function (json) {
    if (!json) {
      migrateWarn("jQuery.parseJSON requires a valid JSON string");
      return null;
    }
    return oldParseJSON.apply(this, arguments);
  };

  jQuery.uaMatch = function (ua) {
    ua = ua.toLowerCase();

    var match = /(chrome)[ \/]([\w.]+)/.exec(ua) || /(webkit)[ \/]([\w.]+)/.exec(ua) || /(opera)(?:.*version|)[ \/]([\w.]+)/.exec(ua) || /(msie) ([\w.]+)/.exec(ua) || ua.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua) || [];

    return {
      browser: match[1] || "",
      version: match[2] || "0"
    };
  };

  // Don't clobber any existing jQuery.browser in case it's different
  if (!jQuery.browser) {
    matched = jQuery.uaMatch(navigator.userAgent);
    browser = {};

    if (matched.browser) {
      browser[matched.browser] = true;
      browser.version = matched.version;
    }

    // Chrome is Webkit, but Webkit is also Safari.
    if (browser.chrome) {
      browser.webkit = true;
    } else if (browser.webkit) {
      browser.safari = true;
    }

    jQuery.browser = browser;
  }

  // Warn if the code tries to get jQuery.browser
  migrateWarnProp(jQuery, "browser", jQuery.browser, "jQuery.browser is deprecated");

  // jQuery.boxModel deprecated in 1.3, jQuery.support.boxModel deprecated in 1.7
  jQuery.boxModel = jQuery.support.boxModel = document.compatMode === "CSS1Compat";
  migrateWarnProp(jQuery, "boxModel", jQuery.boxModel, "jQuery.boxModel is deprecated");
  migrateWarnProp(jQuery.support, "boxModel", jQuery.support.boxModel, "jQuery.support.boxModel is deprecated");

  jQuery.sub = function () {
    function jQuerySub(selector, context) {
      return new jQuerySub.fn.init(selector, context);
    }
    jQuery.extend(true, jQuerySub, this);
    jQuerySub.superclass = this;
    jQuerySub.fn = jQuerySub.prototype = this();
    jQuerySub.fn.constructor = jQuerySub;
    jQuerySub.sub = this.sub;
    jQuerySub.fn.init = function init(selector, context) {
      var instance = jQuery.fn.init.call(this, selector, context, rootjQuerySub);
      return instance instanceof jQuerySub ? instance : jQuerySub(instance);
    };
    jQuerySub.fn.init.prototype = jQuerySub.fn;
    var rootjQuerySub = jQuerySub(document);
    migrateWarn("jQuery.sub() is deprecated");
    return jQuerySub;
  };

  // The number of elements contained in the matched element set
  jQuery.fn.size = function () {
    migrateWarn("jQuery.fn.size() is deprecated; use the .length property");
    return this.length;
  };

  var internalSwapCall = false;

  // If this version of jQuery has .swap(), don't false-alarm on internal uses
  if (jQuery.swap) {
    jQuery.each(["height", "width", "reliableMarginRight"], function (_, name) {
      var oldHook = jQuery.cssHooks[name] && jQuery.cssHooks[name].get;

      if (oldHook) {
        jQuery.cssHooks[name].get = function () {
          var ret;

          internalSwapCall = true;
          ret = oldHook.apply(this, arguments);
          internalSwapCall = false;
          return ret;
        };
      }
    });
  }

  jQuery.swap = function (elem, options, callback, args) {
    var ret,
        name,
        old = {};

    if (!internalSwapCall) {
      migrateWarn("jQuery.swap() is undocumented and deprecated");
    }

    // Remember the old values, and insert the new ones
    for (name in options) {
      old[name] = elem.style[name];
      elem.style[name] = options[name];
    }

    ret = callback.apply(elem, args || []);

    // Revert the old values
    for (name in options) {
      elem.style[name] = old[name];
    }

    return ret;
  };

  // Ensure that $.ajax gets the new parseJSON defined in core.js
  jQuery.ajaxSetup({
    converters: {
      "text json": jQuery.parseJSON
    }
  });

  var oldFnData = jQuery.fn.data;

  jQuery.fn.data = function (name) {
    var ret,
        evt,
        elem = this[0];

    // Handles 1.7 which has this behavior and 1.8 which doesn't
    if (elem && name === "events" && arguments.length === 1) {
      ret = jQuery.data(elem, name);
      evt = jQuery._data(elem, name);
      if ((ret === undefined || ret === evt) && evt !== undefined) {
        migrateWarn("Use of jQuery.fn.data('events') is deprecated");
        return evt;
      }
    }
    return oldFnData.apply(this, arguments);
  };

  var rscriptType = /\/(java|ecma)script/i;

  // Since jQuery.clean is used internally on older versions, we only shim if it's missing
  if (!jQuery.clean) {
    jQuery.clean = function (elems, context, fragment, scripts) {
      // Set context per 1.8 logic
      context = context || document;
      context = !context.nodeType && context[0] || context;
      context = context.ownerDocument || context;

      migrateWarn("jQuery.clean() is deprecated");

      var i,
          elem,
          handleScript,
          jsTags,
          ret = [];

      jQuery.merge(ret, jQuery.buildFragment(elems, context).childNodes);

      // Complex logic lifted directly from jQuery 1.8
      if (fragment) {
        // Special handling of each script element
        handleScript = function handleScript(elem) {
          // Check if we consider it executable
          if (!elem.type || rscriptType.test(elem.type)) {
            // Detach the script and store it in the scripts array (if provided) or the fragment
            // Return truthy to indicate that it has been handled
            return scripts ? scripts.push(elem.parentNode ? elem.parentNode.removeChild(elem) : elem) : fragment.appendChild(elem);
          }
        };

        for (i = 0; (elem = ret[i]) != null; i++) {
          // Check if we're done after handling an executable script
          if (!(jQuery.nodeName(elem, "script") && handleScript(elem))) {
            // Append to fragment and handle embedded scripts
            fragment.appendChild(elem);
            if (typeof elem.getElementsByTagName !== "undefined") {
              // handleScript alters the DOM, so use jQuery.merge to ensure snapshot iteration
              jsTags = jQuery.grep(jQuery.merge([], elem.getElementsByTagName("script")), handleScript);

              // Splice the scripts into ret after their former ancestor and advance our index beyond them
              ret.splice.apply(ret, [i + 1, 0].concat(jsTags));
              i += jsTags.length;
            }
          }
        }
      }

      return ret;
    };
  }

  var eventAdd = jQuery.event.add,
      eventRemove = jQuery.event.remove,
      eventTrigger = jQuery.event.trigger,
      oldToggle = jQuery.fn.toggle,
      oldLive = jQuery.fn.live,
      oldDie = jQuery.fn.die,
      oldLoad = jQuery.fn.load,
      ajaxEvents = "ajaxStart|ajaxStop|ajaxSend|ajaxComplete|ajaxError|ajaxSuccess",
      rajaxEvent = new RegExp("\\b(?:" + ajaxEvents + ")\\b"),
      rhoverHack = /(?:^|\s)hover(\.\S+|)\b/,
      hoverHack = function hoverHack(events) {
    if (typeof events !== "string" || jQuery.event.special.hover) {
      return events;
    }
    if (rhoverHack.test(events)) {
      migrateWarn("'hover' pseudo-event is deprecated, use 'mouseenter mouseleave'");
    }
    return events && events.replace(rhoverHack, "mouseenter$1 mouseleave$1");
  };

  // Event props removed in 1.9, put them back if needed; no practical way to warn them
  if (jQuery.event.props && jQuery.event.props[0] !== "attrChange") {
    jQuery.event.props.unshift("attrChange", "attrName", "relatedNode", "srcElement");
  }

  // Undocumented jQuery.event.handle was "deprecated" in jQuery 1.7
  if (jQuery.event.dispatch) {
    migrateWarnProp(jQuery.event, "handle", jQuery.event.dispatch, "jQuery.event.handle is undocumented and deprecated");
  }

  // Support for 'hover' pseudo-event and ajax event warnings
  jQuery.event.add = function (elem, types, handler, data, selector) {
    if (elem !== document && rajaxEvent.test(types)) {
      migrateWarn("AJAX events should be attached to document: " + types);
    }
    eventAdd.call(this, elem, hoverHack(types || ""), handler, data, selector);
  };
  jQuery.event.remove = function (elem, types, handler, selector, mappedTypes) {
    eventRemove.call(this, elem, hoverHack(types) || "", handler, selector, mappedTypes);
  };

  jQuery.each(["load", "unload", "error"], function (_, name) {

    jQuery.fn[name] = function () {
      var args = Array.prototype.slice.call(arguments, 0);

      // If this is an ajax load() the first arg should be the string URL;
      // technically this could also be the "Anything" arg of the event .load()
      // which just goes to show why this dumb signature has been deprecated!
      // jQuery custom builds that exclude the Ajax module justifiably die here.
      if (name === "load" && typeof args[0] === "string") {
        return oldLoad.apply(this, args);
      }

      migrateWarn("jQuery.fn." + name + "() is deprecated");

      args.splice(0, 0, name);
      if (arguments.length) {
        return this.bind.apply(this, args);
      }

      // Use .triggerHandler here because:
      // - load and unload events don't need to bubble, only applied to window or image
      // - error event should not bubble to window, although it does pre-1.7
      // See http://bugs.jquery.com/ticket/11820
      this.triggerHandler.apply(this, args);
      return this;
    };
  });

  jQuery.fn.toggle = function (fn, fn2) {

    // Don't mess with animation or css toggles
    if (!jQuery.isFunction(fn) || !jQuery.isFunction(fn2)) {
      return oldToggle.apply(this, arguments);
    }
    migrateWarn("jQuery.fn.toggle(handler, handler...) is deprecated");

    // Save reference to arguments for access in closure
    var args = arguments,
        guid = fn.guid || jQuery.guid++,
        i = 0,
        toggler = function toggler(event) {
      // Figure out which function to execute
      var lastToggle = (jQuery._data(this, "lastToggle" + fn.guid) || 0) % i;
      jQuery._data(this, "lastToggle" + fn.guid, lastToggle + 1);

      // Make sure that clicks stop
      event.preventDefault();

      // and execute the function
      return args[lastToggle].apply(this, arguments) || false;
    };

    // link all the functions, so any of them can unbind this click handler
    toggler.guid = guid;
    while (i < args.length) {
      args[i++].guid = guid;
    }

    return this.click(toggler);
  };

  jQuery.fn.live = function (types, data, fn) {
    migrateWarn("jQuery.fn.live() is deprecated");
    if (oldLive) {
      return oldLive.apply(this, arguments);
    }
    jQuery(this.context).on(types, this.selector, data, fn);
    return this;
  };

  jQuery.fn.die = function (types, fn) {
    migrateWarn("jQuery.fn.die() is deprecated");
    if (oldDie) {
      return oldDie.apply(this, arguments);
    }
    jQuery(this.context).off(types, this.selector || "**", fn);
    return this;
  };

  // Turn global events into document-triggered events
  jQuery.event.trigger = function (event, data, elem, onlyHandlers) {
    if (!elem && !rajaxEvent.test(event)) {
      migrateWarn("Global events are undocumented and deprecated");
    }
    return eventTrigger.call(this, event, data, elem || document, onlyHandlers);
  };
  jQuery.each(ajaxEvents.split("|"), function (_, name) {
    jQuery.event.special[name] = {
      setup: function setup() {
        var elem = this;

        // The document needs no shimming; must be !== for oldIE
        if (elem !== document) {
          jQuery.event.add(document, name + "." + jQuery.guid, function () {
            jQuery.event.trigger(name, Array.prototype.slice.call(arguments, 1), elem, true);
          });
          jQuery._data(this, name, jQuery.guid++);
        }
        return false;
      },
      teardown: function teardown() {
        if (this !== document) {
          jQuery.event.remove(document, name + "." + jQuery._data(this, name));
        }
        return false;
      }
    };
  });

  jQuery.event.special.ready = {
    setup: function setup() {
      if (this === document) {
        migrateWarn("'ready' event is deprecated");
      }
    }
  };

  var oldSelf = jQuery.fn.andSelf || jQuery.fn.addBack,
      oldFnFind = jQuery.fn.find;

  jQuery.fn.andSelf = function () {
    migrateWarn("jQuery.fn.andSelf() replaced by jQuery.fn.addBack()");
    return oldSelf.apply(this, arguments);
  };

  jQuery.fn.find = function (selector) {
    var ret = oldFnFind.apply(this, arguments);
    ret.context = this.context;
    ret.selector = this.selector ? this.selector + " " + selector : selector;
    return ret;
  };

  // jQuery 1.6 did not support Callbacks, do not warn there
  if (jQuery.Callbacks) {

    var oldDeferred = jQuery.Deferred,
        tuples = [
    // action, add listener, callbacks, .then handlers, final state
    ["resolve", "done", jQuery.Callbacks("once memory"), jQuery.Callbacks("once memory"), "resolved"], ["reject", "fail", jQuery.Callbacks("once memory"), jQuery.Callbacks("once memory"), "rejected"], ["notify", "progress", jQuery.Callbacks("memory"), jQuery.Callbacks("memory")]];

    jQuery.Deferred = function (func) {
      var deferred = oldDeferred(),
          promise = deferred.promise();

      deferred.pipe = promise.pipe = function () /* fnDone, fnFail, fnProgress */{
        var fns = arguments;

        migrateWarn("deferred.pipe() is deprecated");

        return jQuery.Deferred(function (newDefer) {
          jQuery.each(tuples, function (i, tuple) {
            var fn = jQuery.isFunction(fns[i]) && fns[i];
            // deferred.done(function() { bind to newDefer or newDefer.resolve })
            // deferred.fail(function() { bind to newDefer or newDefer.reject })
            // deferred.progress(function() { bind to newDefer or newDefer.notify })
            deferred[tuple[1]](function () {
              var returned = fn && fn.apply(this, arguments);
              if (returned && jQuery.isFunction(returned.promise)) {
                returned.promise().done(newDefer.resolve).fail(newDefer.reject).progress(newDefer.notify);
              } else {
                newDefer[tuple[0] + "With"](this === promise ? newDefer.promise() : this, fn ? [returned] : arguments);
              }
            });
          });
          fns = null;
        }).promise();
      };

      deferred.isResolved = function () {
        migrateWarn("deferred.isResolved is deprecated");
        return deferred.state() === "resolved";
      };

      deferred.isRejected = function () {
        migrateWarn("deferred.isRejected is deprecated");
        return deferred.state() === "rejected";
      };

      if (func) {
        func.call(deferred, deferred);
      }

      return deferred;
    };
  }
})(jQuery, window);

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//musí být jQuery ne $. Jinak to nefunguje :)
var jQuery = __webpack_require__(3);

jQuery.migrateMute = true;

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(3);

/*!
 * jQuery throttle / debounce - v1.1 - 3/7/2010
 * http://benalman.com/projects/jquery-throttle-debounce-plugin/
 * 
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */

// Script: jQuery throttle / debounce: Sometimes, less is more!
//
// *Version: 1.1, Last updated: 3/7/2010*
// 
// Project Home - http://benalman.com/projects/jquery-throttle-debounce-plugin/
// GitHub       - http://github.com/cowboy/jquery-throttle-debounce/
// Source       - http://github.com/cowboy/jquery-throttle-debounce/raw/master/jquery.ba-throttle-debounce.js
// (Minified)   - http://github.com/cowboy/jquery-throttle-debounce/raw/master/jquery.ba-throttle-debounce.min.js (0.7kb)
// 
// About: License
// 
// Copyright (c) 2010 "Cowboy" Ben Alman,
// Dual licensed under the MIT and GPL licenses.
// http://benalman.com/about/license/
// 
// About: Examples
// 
// These working examples, complete with fully commented code, illustrate a few
// ways in which this plugin can be used.
// 
// Throttle - http://benalman.com/code/projects/jquery-throttle-debounce/examples/throttle/
// Debounce - http://benalman.com/code/projects/jquery-throttle-debounce/examples/debounce/
// 
// About: Support and Testing
// 
// Information about what version or versions of jQuery this plugin has been
// tested with, what browsers it has been tested in, and where the unit tests
// reside (so you can test it yourself).
// 
// jQuery Versions - none, 1.3.2, 1.4.2
// Browsers Tested - Internet Explorer 6-8, Firefox 2-3.6, Safari 3-4, Chrome 4-5, Opera 9.6-10.1.
// Unit Tests      - http://benalman.com/code/projects/jquery-throttle-debounce/unit/
// 
// About: Release History
// 
// 1.1 - (3/7/2010) Fixed a bug in <jQuery.throttle> where trailing callbacks
//       executed later than they should. Reworked a fair amount of internal
//       logic as well.
// 1.0 - (3/6/2010) Initial release as a stand-alone project. Migrated over
//       from jquery-misc repo v0.4 to jquery-throttle repo v1.0, added the
//       no_trailing throttle parameter and debounce functionality.
// 
// Topic: Note for non-jQuery users
// 
// jQuery isn't actually required for this plugin, because nothing internal
// uses any jQuery methods or properties. jQuery is just used as a namespace
// under which these methods can exist.
// 
// Since jQuery isn't actually required for this plugin, if jQuery doesn't exist
// when this plugin is loaded, the method described below will be created in
// the `Cowboy` namespace. Usage will be exactly the same, but instead of
// $.method() or jQuery.method(), you'll need to use Cowboy.method().

(function (window, undefined) {
    '$:nomunge'; // Used by YUI compressor.

    // Since jQuery really isn't required for this plugin, use `jQuery` as the
    // namespace only if it already exists, otherwise use the `Cowboy` namespace,
    // creating it if necessary.

    var $ = window.jQuery || window.Cowboy || (window.Cowboy = {}),


    // Internal method reference.
    jq_throttle;

    // Method: jQuery.throttle
    //
    // Throttle execution of a function. Especially useful for rate limiting
    // execution of handlers on events like resize and scroll. If you want to
    // rate-limit execution of a function to a single time, see the
    // <jQuery.debounce> method.
    //
    // In this visualization, | is a throttled-function call and X is the actual
    // callback execution:
    //
    // > Throttled with `no_trailing` specified as false or unspecified:
    // > ||||||||||||||||||||||||| (pause) |||||||||||||||||||||||||
    // > X    X    X    X    X    X        X    X    X    X    X    X
    // >
    // > Throttled with `no_trailing` specified as true:
    // > ||||||||||||||||||||||||| (pause) |||||||||||||||||||||||||
    // > X    X    X    X    X             X    X    X    X    X
    //
    // Usage:
    //
    // > var throttled = jQuery.throttle( delay, [ no_trailing, ] callback );
    // >
    // > jQuery('selector').bind( 'someevent', throttled );
    // > jQuery('selector').unbind( 'someevent', throttled );
    //
    // This also works in jQuery 1.4+:
    //
    // > jQuery('selector').bind( 'someevent', jQuery.throttle( delay, [ no_trailing, ] callback ) );
    // > jQuery('selector').unbind( 'someevent', callback );
    //
    // Arguments:
    //
    //  delay - (Number) A zero-or-greater delay in milliseconds. For event
    //    callbacks, values around 100 or 250 (or even higher) are most useful.
    //  no_trailing - (Boolean) Optional, defaults to false. If no_trailing is
    //    true, callback will only execute every `delay` milliseconds while the
    //    throttled-function is being called. If no_trailing is false or
    //    unspecified, callback will be executed one final time after the last
    //    throttled-function call. (After the throttled-function has not been
    //    called for `delay` milliseconds, the internal counter is reset)
    //  callback - (Function) A function to be executed after delay milliseconds.
    //    The `this` context and all arguments are passed through, as-is, to
    //    `callback` when the throttled-function is executed.
    //
    // Returns:
    //
    //  (Function) A new, throttled, function.

    $.throttle = jq_throttle = function jq_throttle(delay, no_trailing, callback, debounce_mode) {
        // After wrapper has stopped being called, this timeout ensures that
        // `callback` is executed at the proper times in `throttle` and `end`
        // debounce modes.
        var timeout_id,


        // Keep track of the last time `callback` was executed.
        last_exec = 0;

        // `no_trailing` defaults to falsy.
        if (typeof no_trailing !== 'boolean') {
            debounce_mode = callback;
            callback = no_trailing;
            no_trailing = undefined;
        }

        // The `wrapper` function encapsulates all of the throttling / debouncing
        // functionality and when executed will limit the rate at which `callback`
        // is executed.
        function wrapper() {
            var that = this,
                elapsed = +new Date() - last_exec,
                args = arguments;

            // Execute `callback` and update the `last_exec` timestamp.
            function exec() {
                last_exec = +new Date();
                callback.apply(that, args);
            }

            ;

            // If `debounce_mode` is true (at_begin) this is used to clear the flag
            // to allow future `callback` executions.
            function clear() {
                timeout_id = undefined;
            }

            ;

            if (debounce_mode && !timeout_id) {
                // Since `wrapper` is being called for the first time and
                // `debounce_mode` is true (at_begin), execute `callback`.
                exec();
            }

            // Clear any existing timeout.
            timeout_id && clearTimeout(timeout_id);

            if (debounce_mode === undefined && elapsed > delay) {
                // In throttle mode, if `delay` time has been exceeded, execute
                // `callback`.
                exec();
            } else if (no_trailing !== true) {
                // In trailing throttle mode, since `delay` time has not been
                // exceeded, schedule `callback` to execute `delay` ms after most
                // recent execution.
                //
                // If `debounce_mode` is true (at_begin), schedule `clear` to execute
                // after `delay` ms.
                //
                // If `debounce_mode` is false (at end), schedule `callback` to
                // execute after `delay` ms.
                timeout_id = setTimeout(debounce_mode ? clear : exec, debounce_mode === undefined ? delay - elapsed : delay);
            }
        }

        ;

        // Set the guid of `wrapper` function to the same of original callback, so
        // it can be removed in jQuery 1.4+ .unbind or .die by using the original
        // callback as a reference.
        if ($.guid) {
            wrapper.guid = callback.guid = callback.guid || $.guid++;
        }

        // Return the wrapper function.
        return wrapper;
    };

    // Method: jQuery.debounce
    //
    // Debounce execution of a function. Debouncing, unlike throttling,
    // guarantees that a function is only executed a single time, either at the
    // very beginning of a series of calls, or at the very end. If you want to
    // simply rate-limit execution of a function, see the <jQuery.throttle>
    // method.
    //
    // In this visualization, | is a debounced-function call and X is the actual
    // callback execution:
    //
    // > Debounced with `at_begin` specified as false or unspecified:
    // > ||||||||||||||||||||||||| (pause) |||||||||||||||||||||||||
    // >                          X                                 X
    // >
    // > Debounced with `at_begin` specified as true:
    // > ||||||||||||||||||||||||| (pause) |||||||||||||||||||||||||
    // > X                                 X
    //
    // Usage:
    //
    // > var debounced = jQuery.debounce( delay, [ at_begin, ] callback );
    // >
    // > jQuery('selector').bind( 'someevent', debounced );
    // > jQuery('selector').unbind( 'someevent', debounced );
    //
    // This also works in jQuery 1.4+:
    //
    // > jQuery('selector').bind( 'someevent', jQuery.debounce( delay, [ at_begin, ] callback ) );
    // > jQuery('selector').unbind( 'someevent', callback );
    //
    // Arguments:
    //
    //  delay - (Number) A zero-or-greater delay in milliseconds. For event
    //    callbacks, values around 100 or 250 (or even higher) are most useful.
    //  at_begin - (Boolean) Optional, defaults to false. If at_begin is false or
    //    unspecified, callback will only be executed `delay` milliseconds after
    //    the last debounced-function call. If at_begin is true, callback will be
    //    executed only at the first debounced-function call. (After the
    //    throttled-function has not been called for `delay` milliseconds, the
    //    internal counter is reset)
    //  callback - (Function) A function to be executed after delay milliseconds.
    //    The `this` context and all arguments are passed through, as-is, to
    //    `callback` when the debounced-function is executed.
    //
    // Returns:
    //
    //  (Function) A new, debounced, function.

    $.debounce = function (delay, at_begin, callback) {
        return callback === undefined ? jq_throttle(delay, at_begin, false) : jq_throttle(delay, callback, at_begin !== false);
    };
})(window);

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(3);
__webpack_require__(385);

hs.graphicsDir = '/img/highslide/';
hs.transitions = ['expand', 'crossfade'];
hs.objectLoadTime = 'before'; // Load iframes 'before' or 'after' expansion.
hs.outlineType = '';
hs.align = 'center';
hs.dimmingOpacity = 0.95;

hs.cacheAjax = false;
hs.preserveContent = false;

// credits off
hs.showCredits = false;
hs.creditsHref = '';
hs.lang.creditsText = '';
hs.lang.creditsTitle = '';
hs.captionEval = 'this.a.title';
hs.captionOverlay = { position: 'below' };

hs.marginBottom = 110;
hs.marginLeft = 30;
hs.marginRight = 30;
hs.marginTop = 30;

if (window.innerWidth >= 992) {
	hs.marginBottom = 85;
	hs.marginLeft = 85;
	hs.marginRight = 85;
	hs.marginTop = 110;
};

hs.maxWidth = 1920;
hs.maxHeight = 1280;

if (hs.registerOverlay) {
	if (window.innerWidth >= 992) {
		hs.registerOverlay({
			fade: 2,
			hideOnMouseOut: false,
			html: '<a href="javascript:" onclick="return hs.close(this)" class="closebutton">Zavřít</a>',
			useOnHtml: true,
			position: 'top right',
			relativeTo: 'viewport'
		});
	} else {
		hs.registerOverlay({
			fade: 2,
			hideOnMouseOut: false,
			html: '<a href="javascript:" onclick="return hs.close(this)" class="closebutton">Zavřít</a>',
			useOnHtml: true,
			position: 'bottom center',
			relativeTo: 'viewport'
		});
	}
}

hs.Expander.prototype.onBeforeExpand = function (sender) {
	//jen pro obrazky
	if (sender.a.className.indexOf("hs-htmlExpand") < 0) {

		// dynamicka navigace mezi fotkami

		var arrowLeft = document.createElement('div');
		var arrowRight = document.createElement('div');

		if (sender.getAdjacentAnchor(-1)) {
			arrowLeft.innerHTML = '<a href="javascript:" onclick="return hs.previous(this)" title="Předchozí" class="highslide-previous"><span class="glyphicon glyphicon-arrow-left"></span></a>';
			arrowLeft.className = "controlbar-arrows";
		}
		if (sender.getAdjacentAnchor(1)) {
			arrowRight.innerHTML = '<a href="javascript:" onclick="return hs.next(this)" title="Následující" class="highslide-next"><span class="glyphicon glyphicon-arrow-right"></span></a>';
			arrowRight.className = "controlbar-arrows";
		}
		if (arrowLeft.innerHTML != "") {
			sender.createOverlay({ overlayId: arrowLeft, position: "bottom left", hideOnMouseOut: false, opacity: 1, width: 'auto', fade: 2, relativeTo: 'viewport' });
			if (window.innerWidth >= 992) {
				sender.createOverlay({ overlayId: arrowLeft, position: "middle left", hideOnMouseOut: false, opacity: 1, width: 'auto', fade: 2, relativeTo: 'viewport' });
			};
		}
		if (arrowRight.innerHTML != "") {
			sender.createOverlay({ overlayId: arrowRight, position: "bottom right", hideOnMouseOut: false, opacity: 1, width: 'auto', fade: 2, relativeTo: 'viewport' });
			if (window.innerWidth >= 992) {
				sender.createOverlay({ overlayId: arrowRight, position: "middle right", hideOnMouseOut: false, opacity: 1, width: 'auto', fade: 2, relativeTo: 'viewport' });
			};
		}
	}
};

hs.Expander.prototype.onAfterClose = function (sender) {
	if (sender.custom && sender.custom.puUrl && sender.custom.puWidget) {
		executePartialUpdate(sender.custom.puUrl, sender.custom.puWidget);
	}
};

$(window).on('resize', function () {
	if (window.innerWidth >= 992) {
		hs.marginBottom = 85;
		hs.marginLeft = 85;
		hs.marginRight = 85;
		hs.marginTop = 110;
		/*
  		if (arrowLeft.innerHTML != "") {
  			sender.createOverlay( { overlayId: arrowLeft, position: "middle left", hideOnMouseOut: false, opacity: 1, width: 'auto', fade: 2, relativeTo: 'viewport' } );
  		}
  		if (arrowRight.innerHTML != "") {
  			sender.createOverlay( { overlayId: arrowRight, position: "middle right", hideOnMouseOut: false, opacity: 1, width: 'auto', fade: 2, relativeTo: 'viewport' } );
  		}
  */
	} else {
		hs.marginBottom = 110;
		hs.marginLeft = 30;
		hs.marginRight = 30;
		hs.marginTop = 30;
		/*
  		if (arrowLeft.innerHTML != "") {
  			sender.createOverlay( { overlayId: arrowLeft, position: "top left", hideOnMouseOut: false, opacity: 1, width: 'auto', fade: 2, relativeTo: 'viewport' } );
  		}
  		if (arrowRight.innerHTML != "") {
  			sender.createOverlay( { overlayId: arrowRight, position: "top left", hideOnMouseOut: false, opacity: 1, width: 'auto', fade: 2, relativeTo: 'viewport' } );
  		}
  */
	};
});

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Name:    Highslide JS
 * Version: 4.1.13 (2011-10-06)
 * Config:  default +events +unobtrusive +imagemap +slideshow +positioning +transitions +viewport +thumbstrip +inline +ajax +iframe +flash
 * Author:  Torstein Hønsi
 * Support: www.highslide.com/support
 * License: www.highslide.com/#license
 */
if (!hs) {
    var hs = {
        // Language strings
        lang: {
            cssDirection: 'ltr',
            loadingText: 'Loading...',
            loadingTitle: 'Click to cancel',
            focusTitle: 'Click to bring to front',
            fullExpandTitle: 'Expand to actual size (f)',
            creditsText: 'Powered by <i>Highslide JS</i>',
            creditsTitle: 'Go to the Highslide JS homepage',
            previousText: 'Previous',
            nextText: 'Next',
            moveText: 'Move',
            closeText: 'Close',
            closeTitle: 'Close (esc)',
            resizeTitle: 'Resize',
            playText: 'Play',
            playTitle: 'Play slideshow (spacebar)',
            pauseText: 'Pause',
            pauseTitle: 'Pause slideshow (spacebar)',
            previousTitle: 'Previous (arrow left)',
            nextTitle: 'Next (arrow right)',
            moveTitle: 'Move',
            fullExpandText: '1:1',
            number: 'Image %1 of %2',
            restoreTitle: 'Click to close image, click and drag to move. Use arrow keys for next and previous.'
        },
        // See http://highslide.com/ref for examples of settings  
        graphicsDir: 'highslide/graphics/',
        expandCursor: 'zoomin.cur', // null disables
        restoreCursor: 'zoomout.cur', // null disables
        expandDuration: 250, // milliseconds
        restoreDuration: 250,
        marginLeft: 15,
        marginRight: 15,
        marginTop: 15,
        marginBottom: 15,
        zIndexCounter: 1001, // adjust to other absolutely positioned elements
        loadingOpacity: 0.75,
        allowMultipleInstances: true,
        numberOfImagesToPreload: 5,
        outlineWhileAnimating: 2, // 0 = never, 1 = always, 2 = HTML only 
        outlineStartOffset: 3, // ends at 10
        padToMinWidth: false, // pad the popup width to make room for wide caption
        fullExpandPosition: 'bottom right',
        fullExpandOpacity: 1,
        showCredits: true, // you can set this to false if you want
        creditsHref: 'http://highslide.com/',
        creditsTarget: '_self',
        enableKeyListener: true,
        openerTagNames: ['a', 'area'], // Add more to allow slideshow indexing
        transitions: [],
        transitionDuration: 250,
        dimmingOpacity: 0, // Lightbox style dimming background
        dimmingDuration: 50, // 0 for instant dimming

        allowWidthReduction: false,
        allowHeightReduction: true,
        preserveContent: true, // Preserve changes made to the content and position of HTML popups.
        objectLoadTime: 'before', // Load iframes 'before' or 'after' expansion.
        cacheAjax: true, // Cache ajax popups for instant display. Can be overridden for each popup.
        anchor: 'auto', // where the image expands from
        align: 'auto', // position in the client (overrides anchor)
        targetX: null, // the id of a target element
        targetY: null,
        dragByHeading: true,
        minWidth: 200,
        minHeight: 200,
        allowSizeReduction: true, // allow the image to reduce to fit client size. If false, this overrides minWidth and minHeight
        outlineType: 'drop-shadow', // set null to disable outlines
        skin: {
            controls: '<div class="highslide-controls"><ul>' + '<li class="highslide-previous">' + '<a href="#" title="{hs.lang.previousTitle}">' + '<span>{hs.lang.previousText}</span></a>' + '</li>' + '<li class="highslide-play">' + '<a href="#" title="{hs.lang.playTitle}">' + '<span>{hs.lang.playText}</span></a>' + '</li>' + '<li class="highslide-pause">' + '<a href="#" title="{hs.lang.pauseTitle}">' + '<span>{hs.lang.pauseText}</span></a>' + '</li>' + '<li class="highslide-next">' + '<a href="#" title="{hs.lang.nextTitle}">' + '<span>{hs.lang.nextText}</span></a>' + '</li>' + '<li class="highslide-move">' + '<a href="#" title="{hs.lang.moveTitle}">' + '<span>{hs.lang.moveText}</span></a>' + '</li>' + '<li class="highslide-full-expand">' + '<a href="#" title="{hs.lang.fullExpandTitle}">' + '<span>{hs.lang.fullExpandText}</span></a>' + '</li>' + '<li class="highslide-close">' + '<a href="#" title="{hs.lang.closeTitle}" >' + '<span>{hs.lang.closeText}</span></a>' + '</li>' + '</ul></div>',
            contentWrapper: '<div class="highslide-header"><ul>' + '<li class="highslide-previous">' + '<a href="#" title="{hs.lang.previousTitle}" onclick="return hs.previous(this)">' + '<span>{hs.lang.previousText}</span></a>' + '</li>' + '<li class="highslide-next">' + '<a href="#" title="{hs.lang.nextTitle}" onclick="return hs.next(this)">' + '<span>{hs.lang.nextText}</span></a>' + '</li>' + '<li class="highslide-move">' + '<a href="#" title="{hs.lang.moveTitle}" onclick="return false">' + '<span>{hs.lang.moveText}</span></a>' + '</li>' + '<li class="highslide-close">' + '<a href="#" title="{hs.lang.closeTitle}" onclick="return hs.close(this)">' + '<span>{hs.lang.closeText}</span></a>' + '</li>' + '</ul></div>' + '<div class="highslide-body"></div>' + '<div class="highslide-footer"><div>' + '<span class="highslide-resize" title="{hs.lang.resizeTitle}"><span></span></span>' + '</div></div>'
        },
        // END OF YOUR SETTINGS


        // declare internal properties
        preloadTheseImages: [],
        continuePreloading: true,
        expanders: [],
        overrides: ['allowSizeReduction', 'useBox', 'anchor', 'align', 'targetX', 'targetY', 'outlineType', 'outlineWhileAnimating', 'captionId', 'captionText', 'captionEval', 'captionOverlay', 'headingId', 'headingText', 'headingEval', 'headingOverlay', 'creditsPosition', 'dragByHeading', 'autoplay', 'numberPosition', 'transitions', 'dimmingOpacity', 'width', 'height', 'contentId', 'allowWidthReduction', 'allowHeightReduction', 'preserveContent', 'maincontentId', 'maincontentText', 'maincontentEval', 'objectType', 'cacheAjax', 'objectWidth', 'objectHeight', 'objectLoadTime', 'swfOptions', 'wrapperClassName', 'minWidth', 'minHeight', 'maxWidth', 'maxHeight', 'pageOrigin', 'slideshowGroup', 'easing', 'easingClose', 'fadeInOut', 'src'],
        overlays: [],
        idCounter: 0,
        oPos: {
            x: ['leftpanel', 'left', 'center', 'right', 'rightpanel'],
            y: ['above', 'top', 'middle', 'bottom', 'below']
        },
        mouse: {},
        headingOverlay: {},
        captionOverlay: {},
        swfOptions: { flashvars: {}, params: {}, attributes: {} },
        timers: [],

        slideshows: [],

        pendingOutlines: {},
        sleeping: [],
        preloadTheseAjax: [],
        cacheBindings: [],
        cachedGets: {},
        clones: {},
        onReady: [],
        uaVersion: /Trident\/4\.0/.test(navigator.userAgent) ? 8 : parseFloat((navigator.userAgent.toLowerCase().match(/.+(?:rv|it|ra|ie)[\/: ]([\d.]+)/) || [0, '0'])[1]),
        ie: document.all && !window.opera,
        //ie : navigator && /MSIE [678]/.test(navigator.userAgent), // ie9 compliant?
        safari: /Safari/.test(navigator.userAgent),
        geckoMac: /Macintosh.+rv:1\.[0-8].+Gecko/.test(navigator.userAgent),

        $: function $(id) {
            if (id) return document.getElementById(id);
        },

        push: function push(arr, val) {
            arr[arr.length] = val;
        },

        createElement: function createElement(tag, attribs, styles, parent, nopad) {
            var el = document.createElement(tag);
            if (attribs) hs.extend(el, attribs);
            if (nopad) hs.setStyles(el, { padding: 0, border: 'none', margin: 0 });
            if (styles) hs.setStyles(el, styles);
            if (parent) parent.appendChild(el);
            return el;
        },

        extend: function extend(el, attribs) {
            for (var x in attribs) {
                el[x] = attribs[x];
            }return el;
        },

        setStyles: function setStyles(el, styles) {
            for (var x in styles) {
                if (hs.ieLt9 && x == 'opacity') {
                    if (styles[x] > 0.99) el.style.removeAttribute('filter');else el.style.filter = 'alpha(opacity=' + styles[x] * 100 + ')';
                } else el.style[x] = styles[x];
            }
        },
        animate: function animate(el, prop, opt) {
            var start, end, unit;
            if ((typeof opt === 'undefined' ? 'undefined' : _typeof(opt)) != 'object' || opt === null) {
                var args = arguments;
                opt = {
                    duration: args[2],
                    easing: args[3],
                    complete: args[4]
                };
            }
            if (typeof opt.duration != 'number') opt.duration = 250;
            opt.easing = Math[opt.easing] || Math.easeInQuad;
            opt.curAnim = hs.extend({}, prop);
            for (var name in prop) {
                var e = new hs.fx(el, opt, name);

                start = parseFloat(hs.css(el, name)) || 0;
                end = parseFloat(prop[name]);
                unit = name != 'opacity' ? 'px' : '';

                e.custom(start, end, unit);
            }
        },
        css: function css(el, prop) {
            if (el.style[prop]) {
                return el.style[prop];
            } else if (document.defaultView) {
                return document.defaultView.getComputedStyle(el, null).getPropertyValue(prop);
            } else {
                if (prop == 'opacity') prop = 'filter';
                var val = el.currentStyle[prop.replace(/\-(\w)/g, function (a, b) {
                    return b.toUpperCase();
                })];
                if (prop == 'filter') val = val.replace(/alpha\(opacity=([0-9]+)\)/, function (a, b) {
                    return b / 100;
                });
                return val === '' ? 1 : val;
            }
        },

        getPageSize: function getPageSize() {
            var d = document,
                w = window,
                iebody = d.compatMode && d.compatMode != 'BackCompat' ? d.documentElement : d.body,
                ieLt9 = hs.ie && (hs.uaVersion < 9 || typeof pageXOffset == 'undefined');

            var width = ieLt9 ? iebody.clientWidth : d.documentElement.clientWidth || self.innerWidth,
                height = ieLt9 ? iebody.clientHeight : self.innerHeight;
            hs.page = {
                width: width,
                height: height,
                scrollLeft: ieLt9 ? iebody.scrollLeft : pageXOffset,
                scrollTop: ieLt9 ? iebody.scrollTop : pageYOffset
            };
            return hs.page;
        },

        getPosition: function getPosition(el) {
            if (/area/i.test(el.tagName)) {
                var imgs = document.getElementsByTagName('img');
                for (var i = 0; i < imgs.length; i++) {
                    var u = imgs[i].useMap;
                    if (u && u.replace(/^.*?#/, '') == el.parentNode.name) {
                        el = imgs[i];
                        break;
                    }
                }
            }
            var p = { x: el.offsetLeft, y: el.offsetTop };
            while (el.offsetParent) {
                el = el.offsetParent;
                p.x += el.offsetLeft;
                p.y += el.offsetTop;
                if (el != document.body && el != document.documentElement) {
                    p.x -= el.scrollLeft;
                    p.y -= el.scrollTop;
                }
            }
            return p;
        },

        expand: function expand(a, params, custom, type) {
            if (!a) a = hs.createElement('a', null, { display: 'none' }, hs.container);
            if (typeof a.getParams == 'function') return params;
            if (type == 'html') {
                for (var i = 0; i < hs.sleeping.length; i++) {
                    if (hs.sleeping[i] && hs.sleeping[i].a == a) {
                        hs.sleeping[i].awake();
                        hs.sleeping[i] = null;
                        return false;
                    }
                }
                hs.hasHtmlExpanders = true;
            }
            try {
                new hs.Expander(a, params, custom, type);
                return false;
            } catch (e) {
                return true;
            }
        },

        htmlExpand: function htmlExpand(a, params, custom) {
            return hs.expand(a, params, custom, 'html');
        },

        getSelfRendered: function getSelfRendered() {
            return hs.createElement('div', {
                className: 'highslide-html-content',
                innerHTML: hs.replaceLang(hs.skin.contentWrapper)
            });
        },
        getElementByClass: function getElementByClass(el, tagName, className) {
            var els = el.getElementsByTagName(tagName);
            for (var i = 0; i < els.length; i++) {
                if (new RegExp(className).test(els[i].className)) {
                    return els[i];
                }
            }
            return null;
        },
        replaceLang: function replaceLang(s) {
            s = s.replace(/\s/g, ' ');
            var re = /{hs\.lang\.([^}]+)\}/g,
                matches = s.match(re),
                lang;
            if (matches) for (var i = 0; i < matches.length; i++) {
                lang = matches[i].replace(re, "$1");
                if (typeof hs.lang[lang] != 'undefined') s = s.replace(matches[i], hs.lang[lang]);
            }
            return s;
        },

        setClickEvents: function setClickEvents() {
            var els = document.getElementsByTagName('a');
            for (var i = 0; i < els.length; i++) {
                var type = hs.isUnobtrusiveAnchor(els[i]);
                if (type && !els[i].hsHasSetClick) {
                    (function () {
                        var t = type;
                        if (hs.fireEvent(hs, 'onSetClickEvent', { element: els[i], type: t })) {
                            els[i].onclick = type == 'image' ? function () {
                                return hs.expand(this);
                            } : function () {
                                return hs.htmlExpand(this, { objectType: t });
                            };
                        }
                    })();
                    els[i].hsHasSetClick = true;
                }
            }
            hs.getAnchors();
        },
        isUnobtrusiveAnchor: function isUnobtrusiveAnchor(el) {
            if (el.rel == 'highslide') return 'image';else if (el.rel == 'highslide-ajax') return 'ajax';else if (el.rel == 'highslide-iframe') return 'iframe';else if (el.rel == 'highslide-swf') return 'swf';
        },

        getCacheBinding: function getCacheBinding(a) {
            for (var i = 0; i < hs.cacheBindings.length; i++) {
                if (hs.cacheBindings[i][0] == a) {
                    var c = hs.cacheBindings[i][1];
                    hs.cacheBindings[i][1] = c.cloneNode(1);
                    return c;
                }
            }
            return null;
        },

        preloadAjax: function preloadAjax(e) {
            var arr = hs.getAnchors();
            for (var i = 0; i < arr.htmls.length; i++) {
                var a = arr.htmls[i];
                if (hs.getParam(a, 'objectType') == 'ajax' && hs.getParam(a, 'cacheAjax')) hs.push(hs.preloadTheseAjax, a);
            }

            hs.preloadAjaxElement(0);
        },

        preloadAjaxElement: function preloadAjaxElement(i) {
            if (!hs.preloadTheseAjax[i]) return;
            var a = hs.preloadTheseAjax[i];
            var cache = hs.getNode(hs.getParam(a, 'contentId'));
            if (!cache) cache = hs.getSelfRendered();
            var ajax = new hs.Ajax(a, cache, 1);
            ajax.onError = function () {};
            ajax.onLoad = function () {
                hs.push(hs.cacheBindings, [a, cache]);
                hs.preloadAjaxElement(i + 1);
            };
            ajax.run();
        },

        focusTopmost: function focusTopmost() {
            var topZ = 0,
                topmostKey = -1,
                expanders = hs.expanders,
                exp,
                zIndex;
            for (var i = 0; i < expanders.length; i++) {
                exp = expanders[i];
                if (exp) {
                    zIndex = exp.wrapper.style.zIndex;
                    if (zIndex && zIndex > topZ) {
                        topZ = zIndex;
                        topmostKey = i;
                    }
                }
            }
            if (topmostKey == -1) hs.focusKey = -1;else expanders[topmostKey].focus();
        },

        getParam: function getParam(a, param) {
            a.getParams = a.onclick;
            var p = a.getParams ? a.getParams() : null;
            a.getParams = null;

            return p && typeof p[param] != 'undefined' ? p[param] : typeof hs[param] != 'undefined' ? hs[param] : null;
        },

        getSrc: function getSrc(a) {
            var src = hs.getParam(a, 'src');
            if (src) return src;
            return a.href;
        },

        getNode: function getNode(id) {
            var node = hs.$(id),
                clone = hs.clones[id],
                a = {};
            if (!node && !clone) return null;
            if (!clone) {
                clone = node.cloneNode(true);
                clone.id = '';
                hs.clones[id] = clone;
                return node;
            } else {
                return clone.cloneNode(true);
            }
        },

        discardElement: function discardElement(d) {
            if (d) hs.garbageBin.appendChild(d);
            hs.garbageBin.innerHTML = '';
        },
        dim: function dim(exp) {
            if (!hs.dimmer) {
                isNew = true;
                hs.dimmer = hs.createElement('div', {
                    className: 'highslide-dimming highslide-viewport-size',
                    owner: '',
                    onclick: function onclick() {
                        if (hs.fireEvent(hs, 'onDimmerClick')) hs.close();
                    }
                }, {
                    visibility: 'visible',
                    opacity: 0
                }, hs.container, true);

                if (/(Android|iPad|iPhone|iPod)/.test(navigator.userAgent)) {
                    var pixDimmerSize = function pixDimmerSize() {
                        hs.setStyles(hs.dimmer, {
                            width: body.scrollWidth + 'px',
                            height: body.scrollHeight + 'px'
                        });
                    };

                    var body = document.body;

                    pixDimmerSize();
                    hs.addEventListener(window, 'resize', pixDimmerSize);
                }
            }
            hs.dimmer.style.display = '';

            var isNew = hs.dimmer.owner == '';
            hs.dimmer.owner += '|' + exp.key;

            if (isNew) {
                if (hs.geckoMac && hs.dimmingGeckoFix) hs.setStyles(hs.dimmer, {
                    background: 'url(' + hs.graphicsDir + 'geckodimmer.png)',
                    opacity: 1
                });else hs.animate(hs.dimmer, { opacity: exp.dimmingOpacity }, hs.dimmingDuration);
            }
        },
        undim: function undim(key) {
            if (!hs.dimmer) return;
            if (typeof key != 'undefined') hs.dimmer.owner = hs.dimmer.owner.replace('|' + key, '');

            if (typeof key != 'undefined' && hs.dimmer.owner != '' || hs.upcoming && hs.getParam(hs.upcoming, 'dimmingOpacity')) return;

            if (hs.geckoMac && hs.dimmingGeckoFix) hs.dimmer.style.display = 'none';else hs.animate(hs.dimmer, { opacity: 0 }, hs.dimmingDuration, null, function () {
                hs.dimmer.style.display = 'none';
            });
        },
        transit: function transit(adj, exp) {
            var last = exp || hs.getExpander();
            exp = last;
            if (hs.upcoming) return false;else hs.last = last;
            hs.removeEventListener(document, window.opera ? 'keypress' : 'keydown', hs.keyHandler);
            try {
                hs.upcoming = adj;
                adj.onclick();
            } catch (e) {
                hs.last = hs.upcoming = null;
            }
            try {
                if (!adj || exp.transitions[1] != 'crossfade') exp.close();
            } catch (e) {}
            return false;
        },

        previousOrNext: function previousOrNext(el, op) {
            var exp = hs.getExpander(el);
            if (exp) return hs.transit(exp.getAdjacentAnchor(op), exp);else return false;
        },

        previous: function previous(el) {
            return hs.previousOrNext(el, -1);
        },

        next: function next(el) {
            return hs.previousOrNext(el, 1);
        },

        keyHandler: function keyHandler(e) {
            if (!e) e = window.event;
            if (!e.target) e.target = e.srcElement; // ie
            if (typeof e.target.form != 'undefined') return true; // form element has focus
            if (!hs.fireEvent(hs, 'onKeyDown', e)) return true;
            var exp = hs.getExpander();

            var op = null;
            switch (e.keyCode) {
                case 70:
                    // f
                    if (exp) exp.doFullExpand();
                    return true;
                case 32:
                    // Space
                    op = 2;
                    break;
                case 34: // Page Down
                case 39: // Arrow right
                case 40:
                    // Arrow down
                    op = 1;
                    break;
                case 8: // Backspace
                case 33: // Page Up
                case 37: // Arrow left
                case 38:
                    // Arrow up
                    op = -1;
                    break;
                case 27: // Escape
                case 13:
                    // Enter
                    op = 0;
            }
            if (op !== null) {
                if (op != 2) hs.removeEventListener(document, window.opera ? 'keypress' : 'keydown', hs.keyHandler);
                if (!hs.enableKeyListener) return true;

                if (e.preventDefault) e.preventDefault();else e.returnValue = false;
                if (exp) {
                    if (op == 0) {
                        exp.close();
                    } else if (op == 2) {
                        if (exp.slideshow) exp.slideshow.hitSpace();
                    } else {
                        if (exp.slideshow) exp.slideshow.pause();
                        hs.previousOrNext(exp.key, op);
                    }
                    return false;
                }
            }
            return true;
        },

        registerOverlay: function registerOverlay(overlay) {
            hs.push(hs.overlays, hs.extend(overlay, { hsId: 'hsId' + hs.idCounter++ }));
        },

        addSlideshow: function addSlideshow(options) {
            var sg = options.slideshowGroup;
            if ((typeof sg === 'undefined' ? 'undefined' : _typeof(sg)) == 'object') {
                for (var i = 0; i < sg.length; i++) {
                    var o = {};
                    for (var x in options) {
                        o[x] = options[x];
                    }o.slideshowGroup = sg[i];
                    hs.push(hs.slideshows, o);
                }
            } else {
                hs.push(hs.slideshows, options);
            }
        },

        getWrapperKey: function getWrapperKey(element, expOnly) {
            var el,
                re = /^highslide-wrapper-([0-9]+)$/;
            // 1. look in open expanders
            el = element;
            while (el.parentNode) {
                if (el.hsKey !== undefined) return el.hsKey;
                if (el.id && re.test(el.id)) return el.id.replace(re, "$1");
                el = el.parentNode;
            }
            // 2. look in thumbnail
            if (!expOnly) {
                el = element;
                while (el.parentNode) {
                    if (el.tagName && hs.isHsAnchor(el)) {
                        for (var key = 0; key < hs.expanders.length; key++) {
                            var exp = hs.expanders[key];
                            if (exp && exp.a == el) return key;
                        }
                    }
                    el = el.parentNode;
                }
            }
            return null;
        },

        getExpander: function getExpander(el, expOnly) {
            if (typeof el == 'undefined') return hs.expanders[hs.focusKey] || null;
            if (typeof el == 'number') return hs.expanders[el] || null;
            if (typeof el == 'string') el = hs.$(el);
            return hs.expanders[hs.getWrapperKey(el, expOnly)] || null;
        },

        isHsAnchor: function isHsAnchor(a) {
            return a.onclick && a.onclick.toString().replace(/\s/g, ' ').match(/hs.(htmlE|e)xpand/);
        },

        reOrder: function reOrder() {
            for (var i = 0; i < hs.expanders.length; i++) {
                if (hs.expanders[i] && hs.expanders[i].isExpanded) hs.focusTopmost();
            }
        },
        fireEvent: function fireEvent(obj, evt, args) {
            return obj && obj[evt] ? obj[evt](obj, args) !== false : true;
        },

        mouseClickHandler: function mouseClickHandler(e) {
            if (!e) e = window.event;
            if (e.button > 1) return true;
            if (!e.target) e.target = e.srcElement;

            var el = e.target;
            while (el.parentNode && !/highslide-(image|move|html|resize)/.test(el.className)) {
                el = el.parentNode;
            }
            var exp = hs.getExpander(el);
            if (exp && (exp.isClosing || !exp.isExpanded)) return true;

            if (exp && e.type == 'mousedown') {
                if (e.target.form) return true;
                var match = el.className.match(/highslide-(image|move|resize)/);
                if (match) {
                    hs.dragArgs = {
                        exp: exp,
                        type: match[1],
                        left: exp.x.pos,
                        width: exp.x.size,
                        top: exp.y.pos,
                        height: exp.y.size,
                        clickX: e.clientX,
                        clickY: e.clientY
                    };

                    hs.addEventListener(document, 'mousemove', hs.dragHandler);
                    if (e.preventDefault) e.preventDefault(); // FF

                    if (/highslide-(image|html)-blur/.test(exp.content.className)) {
                        exp.focus();
                        hs.hasFocused = true;
                    }
                    return false;
                } else if (/highslide-html/.test(el.className) && hs.focusKey != exp.key) {
                    exp.focus();
                    exp.doShowHide('hidden');
                }
            } else if (e.type == 'mouseup') {

                hs.removeEventListener(document, 'mousemove', hs.dragHandler);

                if (hs.dragArgs) {
                    if (hs.styleRestoreCursor && hs.dragArgs.type == 'image') hs.dragArgs.exp.content.style.cursor = hs.styleRestoreCursor;
                    var hasDragged = hs.dragArgs.hasDragged;

                    if (!hasDragged && !hs.hasFocused && !/(move|resize)/.test(hs.dragArgs.type)) {
                        if (hs.fireEvent(exp, 'onImageClick')) exp.close();
                    } else if (hasDragged || !hasDragged && hs.hasHtmlExpanders) {
                        hs.dragArgs.exp.doShowHide('hidden');
                    }

                    if (hs.dragArgs.exp.releaseMask) hs.dragArgs.exp.releaseMask.style.display = 'none';

                    if (hasDragged) hs.fireEvent(hs.dragArgs.exp, 'onDrop', hs.dragArgs);
                    hs.hasFocused = false;
                    hs.dragArgs = null;
                } else if (/highslide-image-blur/.test(el.className)) {
                    el.style.cursor = hs.styleRestoreCursor;
                }
            }
            return false;
        },

        dragHandler: function dragHandler(e) {
            if (!hs.dragArgs) return true;
            if (!e) e = window.event;
            var a = hs.dragArgs,
                exp = a.exp;
            if (exp.iframe) {
                if (!exp.releaseMask) exp.releaseMask = hs.createElement('div', null, { position: 'absolute', width: exp.x.size + 'px', height: exp.y.size + 'px',
                    left: exp.x.cb + 'px', top: exp.y.cb + 'px', zIndex: 4, background: hs.ieLt9 ? 'white' : 'none',
                    opacity: 0.01 }, exp.wrapper, true);
                if (exp.releaseMask.style.display == 'none') exp.releaseMask.style.display = '';
            }

            a.dX = e.clientX - a.clickX;
            a.dY = e.clientY - a.clickY;

            var distance = Math.sqrt(Math.pow(a.dX, 2) + Math.pow(a.dY, 2));
            if (!a.hasDragged) a.hasDragged = a.type != 'image' && distance > 0 || distance > (hs.dragSensitivity || 5);

            if (a.hasDragged && e.clientX > 5 && e.clientY > 5) {
                if (!hs.fireEvent(exp, 'onDrag', a)) return false;

                if (a.type == 'resize') exp.resize(a);else {
                    exp.moveTo(a.left + a.dX, a.top + a.dY);
                    if (a.type == 'image') exp.content.style.cursor = 'move';
                }
            }
            return false;
        },

        wrapperMouseHandler: function wrapperMouseHandler(e) {
            try {
                if (!e) e = window.event;
                var over = /mouseover/i.test(e.type);
                if (!e.target) e.target = e.srcElement; // ie
                if (!e.relatedTarget) e.relatedTarget = over ? e.fromElement : e.toElement; // ie
                var exp = hs.getExpander(e.target);
                if (!exp.isExpanded) return;
                if (!exp || !e.relatedTarget || hs.getExpander(e.relatedTarget, true) == exp || hs.dragArgs) return;
                hs.fireEvent(exp, over ? 'onMouseOver' : 'onMouseOut', e);
                for (var i = 0; i < exp.overlays.length; i++) {
                    (function () {
                        var o = hs.$('hsId' + exp.overlays[i]);
                        if (o && o.hideOnMouseOut) {
                            if (over) hs.setStyles(o, { visibility: 'visible', display: '' });
                            hs.animate(o, { opacity: over ? o.opacity : 0 }, o.dur);
                        }
                    })();
                }
            } catch (e) {}
        },
        addEventListener: function addEventListener(el, event, func) {
            if (el == document && event == 'ready') {
                hs.push(hs.onReady, func);
            }
            try {
                el.addEventListener(event, func, false);
            } catch (e) {
                try {
                    el.detachEvent('on' + event, func);
                    el.attachEvent('on' + event, func);
                } catch (e) {
                    el['on' + event] = func;
                }
            }
        },

        removeEventListener: function removeEventListener(el, event, func) {
            try {
                el.removeEventListener(event, func, false);
            } catch (e) {
                try {
                    el.detachEvent('on' + event, func);
                } catch (e) {
                    el['on' + event] = null;
                }
            }
        },

        preloadFullImage: function preloadFullImage(i) {
            if (hs.continuePreloading && hs.preloadTheseImages[i] && hs.preloadTheseImages[i] != 'undefined') {
                var img = document.createElement('img');
                img.onload = function () {
                    img = null;
                    hs.preloadFullImage(i + 1);
                };
                img.src = hs.preloadTheseImages[i];
            }
        },
        preloadImages: function preloadImages(number) {
            if (number && (typeof number === 'undefined' ? 'undefined' : _typeof(number)) != 'object') hs.numberOfImagesToPreload = number;

            var arr = hs.getAnchors();
            for (var i = 0; i < arr.images.length && i < hs.numberOfImagesToPreload; i++) {
                hs.push(hs.preloadTheseImages, hs.getSrc(arr.images[i]));
            }

            // preload outlines
            if (hs.outlineType) new hs.Outline(hs.outlineType, function () {
                hs.preloadFullImage(0);
            });else hs.preloadFullImage(0);

            // preload cursor
            if (hs.restoreCursor) var cur = hs.createElement('img', { src: hs.graphicsDir + hs.restoreCursor });
        },

        init: function init() {
            if (!hs.container) {

                hs.ieLt7 = hs.ie && hs.uaVersion < 7;
                hs.ieLt9 = hs.ie && hs.uaVersion < 9;

                hs.getPageSize();
                hs.ie6SSL = hs.ieLt7 && location.protocol == 'https:';
                for (var x in hs.langDefaults) {
                    if (typeof hs[x] != 'undefined') hs.lang[x] = hs[x];else if (typeof hs.lang[x] == 'undefined' && typeof hs.langDefaults[x] != 'undefined') hs.lang[x] = hs.langDefaults[x];
                }

                hs.container = hs.createElement('div', {
                    className: 'highslide-container'
                }, {
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    width: '100%',
                    zIndex: hs.zIndexCounter,
                    direction: 'ltr'
                }, document.body, true);
                hs.loading = hs.createElement('a', {
                    className: 'highslide-loading',
                    title: hs.lang.loadingTitle,
                    innerHTML: hs.lang.loadingText,
                    href: 'javascript:;'
                }, {
                    position: 'absolute',
                    top: '-9999px',
                    opacity: hs.loadingOpacity,
                    zIndex: 1
                }, hs.container);
                hs.garbageBin = hs.createElement('div', null, { display: 'none' }, hs.container);
                hs.viewport = hs.createElement('div', {
                    className: 'highslide-viewport highslide-viewport-size'
                }, {
                    visibility: hs.safari && hs.uaVersion < 525 ? 'visible' : 'hidden'
                }, hs.container, 1);
                hs.clearing = hs.createElement('div', null, { clear: 'both', paddingTop: '1px' }, null, true);

                // http://www.robertpenner.com/easing/ 
                Math.linearTween = function (t, b, c, d) {
                    return c * t / d + b;
                };
                Math.easeInQuad = function (t, b, c, d) {
                    return c * (t /= d) * t + b;
                };
                Math.easeOutQuad = function (t, b, c, d) {
                    return -c * (t /= d) * (t - 2) + b;
                };

                hs.hideSelects = hs.ieLt7;
                hs.hideIframes = window.opera && hs.uaVersion < 9 || navigator.vendor == 'KDE' || hs.ieLt7 && hs.uaVersion < 5.5;
                hs.fireEvent(this, 'onActivate');
            }
        },
        ready: function ready() {
            if (hs.isReady) return;
            hs.isReady = true;
            for (var i = 0; i < hs.onReady.length; i++) {
                hs.onReady[i]();
            }
        },

        updateAnchors: function updateAnchors() {
            var el,
                els,
                all = [],
                images = [],
                htmls = [],
                groups = {},
                re;

            for (var i = 0; i < hs.openerTagNames.length; i++) {
                els = document.getElementsByTagName(hs.openerTagNames[i]);
                for (var j = 0; j < els.length; j++) {
                    el = els[j];
                    re = hs.isHsAnchor(el);
                    if (re) {
                        hs.push(all, el);
                        if (re[0] == 'hs.expand') hs.push(images, el);else if (re[0] == 'hs.htmlExpand') hs.push(htmls, el);
                        var g = hs.getParam(el, 'slideshowGroup') || 'none';
                        if (!groups[g]) groups[g] = [];
                        hs.push(groups[g], el);
                    }
                }
            }
            hs.anchors = { all: all, groups: groups, images: images, htmls: htmls };
            return hs.anchors;
        },

        getAnchors: function getAnchors() {
            return hs.anchors || hs.updateAnchors();
        },

        close: function close(el) {
            var exp = hs.getExpander(el);
            if (exp) exp.close();
            return false;
        }
    }; // end hs object
    hs.fx = function (elem, options, prop) {
        this.options = options;
        this.elem = elem;
        this.prop = prop;

        if (!options.orig) options.orig = {};
    };
    hs.fx.prototype = {
        update: function update() {
            (hs.fx.step[this.prop] || hs.fx.step._default)(this);

            if (this.options.step) this.options.step.call(this.elem, this.now, this);
        },
        custom: function custom(from, to, unit) {
            this.startTime = new Date().getTime();
            this.start = from;
            this.end = to;
            this.unit = unit; // || this.unit || "px";
            this.now = this.start;
            this.pos = this.state = 0;

            var self = this;

            function t(gotoEnd) {
                return self.step(gotoEnd);
            }

            t.elem = this.elem;

            if (t() && hs.timers.push(t) == 1) {
                hs.timerId = setInterval(function () {
                    var timers = hs.timers;

                    for (var i = 0; i < timers.length; i++) {
                        if (!timers[i]()) timers.splice(i--, 1);
                    }if (!timers.length) {
                        clearInterval(hs.timerId);
                    }
                }, 13);
            }
        },
        step: function step(gotoEnd) {
            var t = new Date().getTime();
            if (gotoEnd || t >= this.options.duration + this.startTime) {
                this.now = this.end;
                this.pos = this.state = 1;
                this.update();

                this.options.curAnim[this.prop] = true;

                var done = true;
                for (var i in this.options.curAnim) {
                    if (this.options.curAnim[i] !== true) done = false;
                }if (done) {
                    if (this.options.complete) this.options.complete.call(this.elem);
                }
                return false;
            } else {
                var n = t - this.startTime;
                this.state = n / this.options.duration;
                this.pos = this.options.easing(n, 0, 1, this.options.duration);
                this.now = this.start + (this.end - this.start) * this.pos;
                this.update();
            }
            return true;
        }

    };

    hs.extend(hs.fx, {
        step: {

            opacity: function opacity(fx) {
                hs.setStyles(fx.elem, { opacity: fx.now });
            },

            _default: function _default(fx) {
                try {
                    if (fx.elem.style && fx.elem.style[fx.prop] != null) fx.elem.style[fx.prop] = fx.now + fx.unit;else fx.elem[fx.prop] = fx.now;
                } catch (e) {}
            }
        }
    });

    hs.Outline = function (outlineType, onLoad) {
        this.onLoad = onLoad;
        this.outlineType = outlineType;
        var v = hs.uaVersion,
            tr;

        this.hasAlphaImageLoader = hs.ie && hs.uaVersion < 7;
        if (!outlineType) {
            if (onLoad) onLoad();
            return;
        }

        hs.init();
        this.table = hs.createElement('table', {
            cellSpacing: 0
        }, {
            visibility: 'hidden',
            position: 'absolute',
            borderCollapse: 'collapse',
            width: 0
        }, hs.container, true);
        var tbody = hs.createElement('tbody', null, null, this.table, 1);

        this.td = [];
        for (var i = 0; i <= 8; i++) {
            if (i % 3 == 0) tr = hs.createElement('tr', null, { height: 'auto' }, tbody, true);
            this.td[i] = hs.createElement('td', null, null, tr, true);
            var style = i != 4 ? { lineHeight: 0, fontSize: 0 } : { position: 'relative' };
            hs.setStyles(this.td[i], style);
        }
        this.td[4].className = outlineType + ' highslide-outline';

        this.preloadGraphic();
    };

    hs.Outline.prototype = {
        preloadGraphic: function preloadGraphic() {
            var src = hs.graphicsDir + (hs.outlinesDir || "outlines/") + this.outlineType + ".png";

            var appendTo = hs.safari && hs.uaVersion < 525 ? hs.container : null;
            this.graphic = hs.createElement('img', null, { position: 'absolute',
                top: '-9999px' }, appendTo, true); // for onload trigger

            var pThis = this;
            this.graphic.onload = function () {
                pThis.onGraphicLoad();
            };

            this.graphic.src = src;
        },

        onGraphicLoad: function onGraphicLoad() {
            var o = this.offset = this.graphic.width / 4,
                pos = [[0, 0], [0, -4], [-2, 0], [0, -8], 0, [-2, -8], [0, -2], [0, -6], [-2, -2]],
                dim = { height: 2 * o + 'px', width: 2 * o + 'px' };
            for (var i = 0; i <= 8; i++) {
                if (pos[i]) {
                    if (this.hasAlphaImageLoader) {
                        var w = i == 1 || i == 7 ? '100%' : this.graphic.width + 'px';
                        var div = hs.createElement('div', null, { width: '100%', height: '100%', position: 'relative', overflow: 'hidden' }, this.td[i], true);
                        hs.createElement('div', null, {
                            filter: "progid:DXImageTransform.Microsoft.AlphaImageLoader(sizingMethod=scale, src='" + this.graphic.src + "')",
                            position: 'absolute',
                            width: w,
                            height: this.graphic.height + 'px',
                            left: pos[i][0] * o + 'px',
                            top: pos[i][1] * o + 'px'
                        }, div, true);
                    } else {
                        hs.setStyles(this.td[i], { background: 'url(' + this.graphic.src + ') ' + pos[i][0] * o + 'px ' + pos[i][1] * o + 'px' });
                    }

                    if (window.opera && (i == 3 || i == 5)) hs.createElement('div', null, dim, this.td[i], true);

                    hs.setStyles(this.td[i], dim);
                }
            }
            this.graphic = null;
            if (hs.pendingOutlines[this.outlineType]) hs.pendingOutlines[this.outlineType].destroy();
            hs.pendingOutlines[this.outlineType] = this;
            if (this.onLoad) this.onLoad();
        },

        setPosition: function setPosition(pos, offset, vis, dur, easing) {
            var exp = this.exp,
                stl = exp.wrapper.style,
                offset = offset || 0,
                pos = pos || {
                x: exp.x.pos + offset,
                y: exp.y.pos + offset,
                w: exp.x.get('wsize') - 2 * offset,
                h: exp.y.get('wsize') - 2 * offset
            };
            if (vis) this.table.style.visibility = pos.h >= 4 * this.offset ? 'visible' : 'hidden';
            hs.setStyles(this.table, {
                left: pos.x - this.offset + 'px',
                top: pos.y - this.offset + 'px',
                width: pos.w + 2 * this.offset + 'px'
            });

            pos.w -= 2 * this.offset;
            pos.h -= 2 * this.offset;
            hs.setStyles(this.td[4], {
                width: pos.w >= 0 ? pos.w + 'px' : 0,
                height: pos.h >= 0 ? pos.h + 'px' : 0
            });
            if (this.hasAlphaImageLoader) this.td[3].style.height = this.td[5].style.height = this.td[4].style.height;
        },

        destroy: function destroy(hide) {
            if (hide) this.table.style.visibility = 'hidden';else hs.discardElement(this.table);
        }
    };

    hs.Dimension = function (exp, dim) {
        this.exp = exp;
        this.dim = dim;
        this.ucwh = dim == 'x' ? 'Width' : 'Height';
        this.wh = this.ucwh.toLowerCase();
        this.uclt = dim == 'x' ? 'Left' : 'Top';
        this.lt = this.uclt.toLowerCase();
        this.ucrb = dim == 'x' ? 'Right' : 'Bottom';
        this.rb = this.ucrb.toLowerCase();
        this.p1 = this.p2 = 0;
    };
    hs.Dimension.prototype = {
        get: function get(key) {
            switch (key) {
                case 'loadingPos':
                    return this.tpos + this.tb + (this.t - hs.loading['offset' + this.ucwh]) / 2;
                case 'loadingPosXfade':
                    return this.pos + this.cb + this.p1 + (this.size - hs.loading['offset' + this.ucwh]) / 2;
                case 'wsize':
                    return this.size + 2 * this.cb + this.p1 + this.p2;
                case 'fitsize':
                    return this.clientSize - this.marginMin - this.marginMax;
                case 'maxsize':
                    return this.get('fitsize') - 2 * this.cb - this.p1 - this.p2;
                case 'opos':
                    return this.pos - (this.exp.outline ? this.exp.outline.offset : 0);
                case 'osize':
                    return this.get('wsize') + (this.exp.outline ? 2 * this.exp.outline.offset : 0);
                case 'imgPad':
                    return this.imgSize ? Math.round((this.size - this.imgSize) / 2) : 0;

            }
        },
        calcBorders: function calcBorders() {
            // correct for borders
            this.cb = (this.exp.content['offset' + this.ucwh] - this.t) / 2;

            this.marginMax = hs['margin' + this.ucrb];
        },
        calcThumb: function calcThumb() {
            this.t = this.exp.el[this.wh] ? parseInt(this.exp.el[this.wh]) : this.exp.el['offset' + this.ucwh];
            this.tpos = this.exp.tpos[this.dim];
            this.tb = (this.exp.el['offset' + this.ucwh] - this.t) / 2;
            if (this.tpos == 0 || this.tpos == -1) {
                this.tpos = hs.page[this.wh] / 2 + hs.page['scroll' + this.uclt];
            }
            ;
        },
        calcExpanded: function calcExpanded() {
            var exp = this.exp;
            this.justify = 'auto';

            // get alignment
            if (exp.align == 'center') this.justify = 'center';else if (new RegExp(this.lt).test(exp.anchor)) this.justify = null;else if (new RegExp(this.rb).test(exp.anchor)) this.justify = 'max';

            // size and position
            this.pos = this.tpos - this.cb + this.tb;

            if (this.maxHeight && this.dim == 'x') exp.maxWidth = Math.min(exp.maxWidth || this.full, exp.maxHeight * this.full / exp.y.full);

            this.size = Math.min(this.full, exp['max' + this.ucwh] || this.full);
            this.minSize = exp.allowSizeReduction ? Math.min(exp['min' + this.ucwh], this.full) : this.full;
            if (exp.isImage && exp.useBox) {
                this.size = exp[this.wh];
                this.imgSize = this.full;
            }
            if (this.dim == 'x' && hs.padToMinWidth) this.minSize = exp.minWidth;
            this.target = exp['target' + this.dim.toUpperCase()];
            this.marginMin = hs['margin' + this.uclt];
            this.scroll = hs.page['scroll' + this.uclt];
            this.clientSize = hs.page[this.wh];
        },
        setSize: function setSize(i) {
            var exp = this.exp;
            if (exp.isImage && (exp.useBox || hs.padToMinWidth)) {
                this.imgSize = i;
                this.size = Math.max(this.size, this.imgSize);
                exp.content.style[this.lt] = this.get('imgPad') + 'px';
            } else this.size = i;

            exp.content.style[this.wh] = i + 'px';
            exp.wrapper.style[this.wh] = this.get('wsize') + 'px';
            if (exp.outline) exp.outline.setPosition();
            if (exp.releaseMask) exp.releaseMask.style[this.wh] = i + 'px';
            if (this.dim == 'y' && exp.iDoc && exp.body.style.height != 'auto') try {
                exp.iDoc.body.style.overflow = 'auto';
            } catch (e) {}
            if (exp.isHtml) {
                var d = exp.scrollerDiv;
                if (this.sizeDiff === undefined) this.sizeDiff = exp.innerContent['offset' + this.ucwh] - d['offset' + this.ucwh];
                d.style[this.wh] = this.size - this.sizeDiff + 'px';

                if (this.dim == 'x') exp.mediumContent.style.width = 'auto';
                if (exp.body) exp.body.style[this.wh] = 'auto';
            }
            if (this.dim == 'x' && exp.overlayBox) exp.sizeOverlayBox(true);
            if (this.dim == 'x' && exp.slideshow && exp.isImage) {
                if (i == this.full) exp.slideshow.disable('full-expand');else exp.slideshow.enable('full-expand');
            }
        },
        setPos: function setPos(i) {
            this.pos = i;
            this.exp.wrapper.style[this.lt] = i + 'px';

            if (this.exp.outline) this.exp.outline.setPosition();
        }
    };

    hs.Expander = function (a, params, custom, contentType) {
        if (document.readyState && hs.ie && !hs.isReady) {
            hs.addEventListener(document, 'ready', function () {
                new hs.Expander(a, params, custom, contentType);
            });
            return;
        }
        this.a = a;
        this.custom = custom;
        this.contentType = contentType || 'image';
        this.isHtml = contentType == 'html';
        this.isImage = !this.isHtml;

        hs.continuePreloading = false;
        this.overlays = [];
        this.last = hs.last;
        hs.last = null;
        hs.init();
        var key = this.key = hs.expanders.length;
        // override inline parameters
        for (var i = 0; i < hs.overrides.length; i++) {
            var name = hs.overrides[i];
            this[name] = params && typeof params[name] != 'undefined' ? params[name] : hs[name];
        }
        if (!this.src) this.src = a.href;

        // get thumb
        var el = params && params.thumbnailId ? hs.$(params.thumbnailId) : a;
        el = this.thumb = el.getElementsByTagName('img')[0] || el;
        this.thumbsUserSetId = el.id || a.id;
        if (!hs.fireEvent(this, 'onInit')) return true;

        // check if already open
        for (var i = 0; i < hs.expanders.length; i++) {
            if (hs.expanders[i] && hs.expanders[i].a == a && !(this.last && this.transitions[1] == 'crossfade')) {
                hs.expanders[i].focus();
                return false;
            }
        }

        // cancel other
        if (!hs.allowSimultaneousLoading) for (var i = 0; i < hs.expanders.length; i++) {
            if (hs.expanders[i] && hs.expanders[i].thumb != el && !hs.expanders[i].onLoadStarted) {
                hs.expanders[i].cancelLoading();
            }
        }
        hs.expanders[key] = this;
        if (!hs.allowMultipleInstances && !hs.upcoming) {
            if (hs.expanders[key - 1]) hs.expanders[key - 1].close();
            if (typeof hs.focusKey != 'undefined' && hs.expanders[hs.focusKey]) hs.expanders[hs.focusKey].close();
        }

        // initiate metrics
        this.el = el;
        this.tpos = this.pageOrigin || hs.getPosition(el);
        hs.getPageSize();
        var x = this.x = new hs.Dimension(this, 'x');
        x.calcThumb();
        var y = this.y = new hs.Dimension(this, 'y');
        y.calcThumb();
        if (/area/i.test(el.tagName)) this.getImageMapAreaCorrection(el);
        this.wrapper = hs.createElement('div', {
            id: 'highslide-wrapper-' + this.key,
            className: 'highslide-wrapper ' + this.wrapperClassName
        }, {
            visibility: 'hidden',
            position: 'absolute',
            zIndex: hs.zIndexCounter += 2
        }, null, true);

        this.wrapper.onmouseover = this.wrapper.onmouseout = hs.wrapperMouseHandler;
        if (this.contentType == 'image' && this.outlineWhileAnimating == 2) this.outlineWhileAnimating = 0;

        // get the outline
        if (!this.outlineType || this.last && this.isImage && this.transitions[1] == 'crossfade') {
            this[this.contentType + 'Create']();
        } else if (hs.pendingOutlines[this.outlineType]) {
            this.connectOutline();
            this[this.contentType + 'Create']();
        } else {
            this.showLoading();
            var exp = this;
            new hs.Outline(this.outlineType, function () {
                exp.connectOutline();
                exp[exp.contentType + 'Create']();
            });
        }
        return true;
    };

    hs.Expander.prototype = {
        error: function error(e) {
            if (hs.debug) alert('Line ' + e.lineNumber + ': ' + e.message);else window.location.href = this.src;
        },

        connectOutline: function connectOutline() {
            var outline = this.outline = hs.pendingOutlines[this.outlineType];
            outline.exp = this;
            outline.table.style.zIndex = this.wrapper.style.zIndex - 1;
            hs.pendingOutlines[this.outlineType] = null;
        },

        showLoading: function showLoading() {
            if (this.onLoadStarted || this.loading) return;

            this.loading = hs.loading;
            var exp = this;
            this.loading.onclick = function () {
                exp.cancelLoading();
            };

            if (!hs.fireEvent(this, 'onShowLoading')) return;
            var exp = this,
                l = this.x.get('loadingPos') + 'px',
                t = this.y.get('loadingPos') + 'px';
            if (!tgt && this.last && this.transitions[1] == 'crossfade') var tgt = this.last;
            if (tgt) {
                l = tgt.x.get('loadingPosXfade') + 'px';
                t = tgt.y.get('loadingPosXfade') + 'px';
                this.loading.style.zIndex = hs.zIndexCounter++;
            }
            setTimeout(function () {
                if (exp.loading) hs.setStyles(exp.loading, { left: l, top: t, zIndex: hs.zIndexCounter++ });
            }, 100);
        },

        imageCreate: function imageCreate() {
            var exp = this;

            var img = document.createElement('img');
            this.content = img;
            img.onload = function () {
                if (hs.expanders[exp.key]) exp.contentLoaded();
            };
            if (hs.blockRightClick) img.oncontextmenu = function () {
                return false;
            };
            img.className = 'highslide-image';
            hs.setStyles(img, {
                visibility: 'hidden',
                display: 'block',
                position: 'absolute',
                maxWidth: '9999px',
                zIndex: 3
            });
            img.title = hs.lang.restoreTitle;
            if (hs.safari && hs.uaVersion < 525) hs.container.appendChild(img);
            if (hs.ie && hs.flushImgSize) img.src = null;
            img.src = this.src;

            this.showLoading();
        },

        htmlCreate: function htmlCreate() {
            if (!hs.fireEvent(this, 'onBeforeGetContent')) return;

            this.content = hs.getCacheBinding(this.a);
            if (!this.content) this.content = hs.getNode(this.contentId);
            if (!this.content) this.content = hs.getSelfRendered();
            this.getInline(['maincontent']);
            if (this.maincontent) {
                var body = hs.getElementByClass(this.content, 'div', 'highslide-body');
                if (body) body.appendChild(this.maincontent);
                this.maincontent.style.display = 'block';
            }
            hs.fireEvent(this, 'onAfterGetContent');

            var innerContent = this.innerContent = this.content;

            if (/(swf|iframe)/.test(this.objectType)) this.setObjContainerSize(innerContent);

            // the content tree
            hs.container.appendChild(this.wrapper);
            hs.setStyles(this.wrapper, {
                position: 'static',
                padding: '0 ' + hs.marginRight + 'px 0 ' + hs.marginLeft + 'px'
            });
            this.content = hs.createElement('div', {
                className: 'highslide-html'
            }, {
                position: 'relative',
                zIndex: 3,
                height: 0,
                overflow: 'hidden'
            }, this.wrapper);
            this.mediumContent = hs.createElement('div', null, null, this.content, 1);
            this.mediumContent.appendChild(innerContent);

            hs.setStyles(innerContent, {
                position: 'relative',
                display: 'block',
                direction: hs.lang.cssDirection || ''
            });
            if (this.width) innerContent.style.width = this.width + 'px';
            if (this.height) hs.setStyles(innerContent, {
                height: this.height + 'px',
                overflow: 'hidden'
            });
            if (innerContent.offsetWidth < this.minWidth) innerContent.style.width = this.minWidth + 'px';

            if (this.objectType == 'ajax' && !hs.getCacheBinding(this.a)) {
                this.showLoading();
                var exp = this;
                var ajax = new hs.Ajax(this.a, innerContent);
                ajax.src = this.src;
                ajax.onLoad = function () {
                    if (hs.expanders[exp.key]) exp.contentLoaded();
                };
                ajax.onError = function () {
                    location.href = exp.src;
                };
                ajax.run();
            } else if (this.objectType == 'iframe' && this.objectLoadTime == 'before') {
                this.writeExtendedContent();
            } else this.contentLoaded();
        },

        contentLoaded: function contentLoaded() {
            try {
                if (!this.content) return;
                this.content.onload = null;
                if (this.onLoadStarted) return;else this.onLoadStarted = true;

                var x = this.x,
                    y = this.y;

                if (this.loading) {
                    hs.setStyles(this.loading, { top: '-9999px' });
                    this.loading = null;
                    hs.fireEvent(this, 'onHideLoading');
                }
                if (this.isImage) {
                    x.full = this.content.width;
                    y.full = this.content.height;

                    hs.setStyles(this.content, {
                        width: x.t + 'px',
                        height: y.t + 'px'
                    });
                    this.wrapper.appendChild(this.content);
                    hs.container.appendChild(this.wrapper);
                } else if (this.htmlGetSize) this.htmlGetSize();

                x.calcBorders();
                y.calcBorders();

                hs.setStyles(this.wrapper, {
                    left: x.tpos + x.tb - x.cb + 'px',
                    top: y.tpos + x.tb - y.cb + 'px'
                });

                this.initSlideshow();
                this.getOverlays();

                var ratio = x.full / y.full;
                x.calcExpanded();
                this.justify(x);

                y.calcExpanded();
                this.justify(y);
                if (this.isHtml) this.htmlSizeOperations();
                if (this.overlayBox) this.sizeOverlayBox(0, 1);

                if (this.allowSizeReduction) {
                    if (this.isImage) this.correctRatio(ratio);else this.fitOverlayBox();
                    var ss = this.slideshow;
                    if (ss && this.last && ss.controls && ss.fixedControls) {
                        var pos = ss.overlayOptions.position || '',
                            p;
                        for (var dim in hs.oPos) {
                            for (var i = 0; i < 5; i++) {
                                p = this[dim];
                                if (pos.match(hs.oPos[dim][i])) {
                                    p.pos = this.last[dim].pos + (this.last[dim].p1 - p.p1) + (this.last[dim].size - p.size) * [0, 0, .5, 1, 1][i];
                                    if (ss.fixedControls == 'fit') {
                                        if (p.pos + p.size + p.p1 + p.p2 > p.scroll + p.clientSize - p.marginMax) p.pos = p.scroll + p.clientSize - p.size - p.marginMin - p.marginMax - p.p1 - p.p2;
                                        if (p.pos < p.scroll + p.marginMin) p.pos = p.scroll + p.marginMin;
                                    }
                                }
                            }
                        }
                    }
                    if (this.isImage && this.x.full > (this.x.imgSize || this.x.size)) {
                        this.createFullExpand();
                        if (this.overlays.length == 1) this.sizeOverlayBox();
                    }
                }
                this.show();
            } catch (e) {
                this.error(e);
            }
        },

        setObjContainerSize: function setObjContainerSize(parent, auto) {
            var c = hs.getElementByClass(parent, 'DIV', 'highslide-body');
            if (/(iframe|swf)/.test(this.objectType)) {
                if (this.objectWidth) c.style.width = this.objectWidth + 'px';
                if (this.objectHeight) c.style.height = this.objectHeight + 'px';
            }
        },

        writeExtendedContent: function writeExtendedContent() {
            if (this.hasExtendedContent) return;
            var exp = this;
            this.body = hs.getElementByClass(this.innerContent, 'DIV', 'highslide-body');
            if (this.objectType == 'iframe') {
                this.showLoading();
                var ruler = hs.clearing.cloneNode(1);
                this.body.appendChild(ruler);
                this.newWidth = this.innerContent.offsetWidth;
                if (!this.objectWidth) this.objectWidth = ruler.offsetWidth;
                var hDiff = this.innerContent.offsetHeight - this.body.offsetHeight,
                    h = this.objectHeight || hs.page.height - hDiff - hs.marginTop - hs.marginBottom,
                    onload = this.objectLoadTime == 'before' ? ' onload="if (hs.expanders[' + this.key + ']) hs.expanders[' + this.key + '].contentLoaded()" ' : '';
                this.body.innerHTML += '<iframe name="hs' + new Date().getTime() + '" frameborder="0" key="' + this.key + '" ' + ' style="width:' + this.objectWidth + 'px; height:' + h + 'px" ' + onload + ' src="' + this.src + '" ></iframe>';
                this.ruler = this.body.getElementsByTagName('div')[0];
                this.iframe = this.body.getElementsByTagName('iframe')[0];

                if (this.objectLoadTime == 'after') this.correctIframeSize();
            }
            if (this.objectType == 'swf') {
                this.body.id = this.body.id || 'hs-flash-id-' + this.key;
                var a = this.swfOptions;
                if (!a.params) a.params = {};
                if (typeof a.params.wmode == 'undefined') a.params.wmode = 'transparent';
                if (swfobject) swfobject.embedSWF(this.src, this.body.id, this.objectWidth, this.objectHeight, a.version || '7', a.expressInstallSwfurl, a.flashvars, a.params, a.attributes);
            }
            this.hasExtendedContent = true;
        },
        htmlGetSize: function htmlGetSize() {
            if (this.iframe && !this.objectHeight) {
                // loadtime before
                this.iframe.style.height = this.body.style.height = this.getIframePageHeight() + 'px';
            }
            this.innerContent.appendChild(hs.clearing);
            if (!this.x.full) this.x.full = this.innerContent.offsetWidth;
            this.y.full = this.innerContent.offsetHeight;
            this.innerContent.removeChild(hs.clearing);
            if (hs.ie && this.newHeight > parseInt(this.innerContent.currentStyle.height)) {
                // ie css bug
                this.newHeight = parseInt(this.innerContent.currentStyle.height);
            }
            hs.setStyles(this.wrapper, { position: 'absolute', padding: '0' });
            hs.setStyles(this.content, { width: this.x.t + 'px', height: this.y.t + 'px' });
        },

        getIframePageHeight: function getIframePageHeight() {
            var h;
            try {
                var doc = this.iDoc = this.iframe.contentDocument || this.iframe.contentWindow.document;
                var clearing = doc.createElement('div');
                clearing.style.clear = 'both';
                doc.body.appendChild(clearing);
                h = clearing.offsetTop;
                if (hs.ie) h += parseInt(doc.body.currentStyle.marginTop) + parseInt(doc.body.currentStyle.marginBottom) - 1;
            } catch (e) {
                // other domain
                h = 300;
            }
            return h;
        },
        correctIframeSize: function correctIframeSize() {
            var wDiff = this.innerContent.offsetWidth - this.ruler.offsetWidth;
            hs.discardElement(this.ruler);
            if (wDiff < 0) wDiff = 0;

            var hDiff = this.innerContent.offsetHeight - this.iframe.offsetHeight;
            if (this.iDoc && !this.objectHeight && !this.height && this.y.size == this.y.full) try {
                this.iDoc.body.style.overflow = 'hidden';
            } catch (e) {}
            hs.setStyles(this.iframe, {
                width: Math.abs(this.x.size - wDiff) + 'px',
                height: Math.abs(this.y.size - hDiff) + 'px'
            });
            hs.setStyles(this.body, {
                width: this.iframe.style.width,
                height: this.iframe.style.height
            });

            this.scrollingContent = this.iframe;
            this.scrollerDiv = this.scrollingContent;
        },
        htmlSizeOperations: function htmlSizeOperations() {

            this.setObjContainerSize(this.innerContent);

            if (this.objectType == 'swf' && this.objectLoadTime == 'before') this.writeExtendedContent();

            // handle minimum size
            if (this.x.size < this.x.full && !this.allowWidthReduction) this.x.size = this.x.full;
            if (this.y.size < this.y.full && !this.allowHeightReduction) this.y.size = this.y.full;
            this.scrollerDiv = this.innerContent;
            hs.setStyles(this.mediumContent, {
                position: 'relative',
                width: this.x.size + 'px'
            });
            hs.setStyles(this.innerContent, {
                border: 'none',
                width: 'auto',
                height: 'auto'
            });
            var node = hs.getElementByClass(this.innerContent, 'DIV', 'highslide-body');
            if (node && !/(iframe|swf)/.test(this.objectType)) {
                var cNode = node; // wrap to get true size
                node = hs.createElement(cNode.nodeName, null, { overflow: 'hidden' }, null, true);
                cNode.parentNode.insertBefore(node, cNode);
                node.appendChild(hs.clearing); // IE6
                node.appendChild(cNode);

                var wDiff = this.innerContent.offsetWidth - node.offsetWidth;
                var hDiff = this.innerContent.offsetHeight - node.offsetHeight;
                node.removeChild(hs.clearing);

                var kdeBugCorr = hs.safari || navigator.vendor == 'KDE' ? 1 : 0; // KDE repainting bug
                hs.setStyles(node, {
                    width: this.x.size - wDiff - kdeBugCorr + 'px',
                    height: this.y.size - hDiff + 'px',
                    overflow: 'auto',
                    position: 'relative'
                });
                if (kdeBugCorr && cNode.offsetHeight > node.offsetHeight) {
                    node.style.width = parseInt(node.style.width) + kdeBugCorr + 'px';
                }
                this.scrollingContent = node;
                this.scrollerDiv = this.scrollingContent;
            }
            if (this.iframe && this.objectLoadTime == 'before') this.correctIframeSize();
            if (!this.scrollingContent && this.y.size < this.mediumContent.offsetHeight) this.scrollerDiv = this.content;

            if (this.scrollerDiv == this.content && !this.allowWidthReduction && !/(iframe|swf)/.test(this.objectType)) {
                this.x.size += 17; // room for scrollbars
            }
            if (this.scrollerDiv && this.scrollerDiv.offsetHeight > this.scrollerDiv.parentNode.offsetHeight) {
                setTimeout("try { hs.expanders[" + this.key + "].scrollerDiv.style.overflow = 'auto'; } catch(e) {}", hs.expandDuration);
            }
        },

        getImageMapAreaCorrection: function getImageMapAreaCorrection(area) {
            var c = area.coords.split(',');
            for (var i = 0; i < c.length; i++) {
                c[i] = parseInt(c[i]);
            }if (area.shape.toLowerCase() == 'circle') {
                this.x.tpos += c[0] - c[2];
                this.y.tpos += c[1] - c[2];
                this.x.t = this.y.t = 2 * c[2];
            } else {
                var maxX,
                    maxY,
                    minX = maxX = c[0],
                    minY = maxY = c[1];
                for (var i = 0; i < c.length; i++) {
                    if (i % 2 == 0) {
                        minX = Math.min(minX, c[i]);
                        maxX = Math.max(maxX, c[i]);
                    } else {
                        minY = Math.min(minY, c[i]);
                        maxY = Math.max(maxY, c[i]);
                    }
                }
                this.x.tpos += minX;
                this.x.t = maxX - minX;
                this.y.tpos += minY;
                this.y.t = maxY - minY;
            }
        },
        justify: function justify(p, moveOnly) {
            var tgtArr,
                tgt = p.target,
                dim = p == this.x ? 'x' : 'y';

            if (tgt && tgt.match(/ /)) {
                tgtArr = tgt.split(' ');
                tgt = tgtArr[0];
            }
            if (tgt && hs.$(tgt)) {
                p.pos = hs.getPosition(hs.$(tgt))[dim];
                if (tgtArr && tgtArr[1] && tgtArr[1].match(/^[-]?[0-9]+px$/)) p.pos += parseInt(tgtArr[1]);
                if (p.size < p.minSize) p.size = p.minSize;
            } else if (p.justify == 'auto' || p.justify == 'center') {

                var hasMovedMin = false;

                var allowReduce = p.exp.allowSizeReduction;
                if (p.justify == 'center') p.pos = Math.round(p.scroll + (p.clientSize + p.marginMin - p.marginMax - p.get('wsize')) / 2);else p.pos = Math.round(p.pos - (p.get('wsize') - p.t) / 2);
                if (p.pos < p.scroll + p.marginMin) {
                    p.pos = p.scroll + p.marginMin;
                    hasMovedMin = true;
                }
                if (!moveOnly && p.size < p.minSize) {
                    p.size = p.minSize;
                    allowReduce = false;
                }
                if (p.pos + p.get('wsize') > p.scroll + p.clientSize - p.marginMax) {
                    if (!moveOnly && hasMovedMin && allowReduce) {
                        p.size = Math.min(p.size, p.get(dim == 'y' ? 'fitsize' : 'maxsize'));
                    } else if (p.get('wsize') < p.get('fitsize')) {
                        p.pos = p.scroll + p.clientSize - p.marginMax - p.get('wsize');
                    } else {
                        // image larger than viewport
                        p.pos = p.scroll + p.marginMin;
                        if (!moveOnly && allowReduce) p.size = p.get(dim == 'y' ? 'fitsize' : 'maxsize');
                    }
                }

                if (!moveOnly && p.size < p.minSize) {
                    p.size = p.minSize;
                    allowReduce = false;
                }
            } else if (p.justify == 'max') {
                p.pos = Math.floor(p.pos - p.size + p.t);
            }

            if (p.pos < p.marginMin) {
                var tmpMin = p.pos;
                p.pos = p.marginMin;

                if (allowReduce && !moveOnly) p.size = p.size - (p.pos - tmpMin);
            }
        },

        correctRatio: function correctRatio(ratio) {
            var x = this.x,
                y = this.y,
                changed = false,
                xSize = Math.min(x.full, x.size),
                ySize = Math.min(y.full, y.size),
                useBox = this.useBox || hs.padToMinWidth;

            if (xSize / ySize > ratio) {
                // width greater
                xSize = ySize * ratio;
                if (xSize < x.minSize) {
                    // below minWidth
                    xSize = x.minSize;
                    ySize = xSize / ratio;
                }
                changed = true;
            } else if (xSize / ySize < ratio) {
                // height greater
                ySize = xSize / ratio;
                changed = true;
            }

            if (hs.padToMinWidth && x.full < x.minSize) {
                x.imgSize = x.full;
                y.size = y.imgSize = y.full;
            } else if (this.useBox) {
                x.imgSize = xSize;
                y.imgSize = ySize;
            } else {
                x.size = xSize;
                y.size = ySize;
            }
            changed = this.fitOverlayBox(this.useBox ? null : ratio, changed);
            if (useBox && y.size < y.imgSize) {
                y.imgSize = y.size;
                x.imgSize = y.size * ratio;
            }
            if (changed || useBox) {
                x.pos = x.tpos - x.cb + x.tb;
                x.minSize = x.size;
                this.justify(x, true);

                y.pos = y.tpos - y.cb + y.tb;
                y.minSize = y.size;
                this.justify(y, true);
                if (this.overlayBox) this.sizeOverlayBox();
            }
        },
        fitOverlayBox: function fitOverlayBox(ratio, changed) {
            var x = this.x,
                y = this.y;
            if (this.overlayBox && (this.isImage || this.allowHeightReduction)) {
                while (y.size > this.minHeight && x.size > this.minWidth && y.get('wsize') > y.get('fitsize')) {
                    y.size -= 10;
                    if (ratio) x.size = y.size * ratio;
                    this.sizeOverlayBox(0, 1);
                    changed = true;
                }
            }
            return changed;
        },

        reflow: function reflow() {
            if (this.scrollerDiv) {
                var h = /iframe/i.test(this.scrollerDiv.tagName) ? this.getIframePageHeight() + 1 + 'px' : 'auto';
                if (this.body) this.body.style.height = h;
                this.scrollerDiv.style.height = h;
                this.y.setSize(this.innerContent.offsetHeight);
            }
        },

        show: function show() {
            var x = this.x,
                y = this.y;
            this.doShowHide('hidden');
            hs.fireEvent(this, 'onBeforeExpand');
            if (this.slideshow && this.slideshow.thumbstrip) this.slideshow.thumbstrip.selectThumb();

            // Apply size change
            this.changeSize(1, {
                wrapper: {
                    width: x.get('wsize'),
                    height: y.get('wsize'),
                    left: x.pos,
                    top: y.pos
                },
                content: {
                    left: x.p1 + x.get('imgPad'),
                    top: y.p1 + y.get('imgPad'),
                    width: x.imgSize || x.size,
                    height: y.imgSize || y.size
                }
            }, hs.expandDuration);
        },

        changeSize: function changeSize(up, to, dur) {
            // transition
            var trans = this.transitions,
                other = up ? this.last ? this.last.a : null : hs.upcoming,
                t = trans[1] && other && hs.getParam(other, 'transitions')[1] == trans[1] ? trans[1] : trans[0];

            if (this[t] && t != 'expand') {
                this[t](up, to);
                return;
            }

            if (this.outline && !this.outlineWhileAnimating) {
                if (up) this.outline.setPosition();else this.outline.destroy(this.isHtml && this.preserveContent);
            }

            if (!up) this.destroyOverlays();

            var exp = this,
                x = exp.x,
                y = exp.y,
                easing = this.easing;
            if (!up) easing = this.easingClose || easing;
            var after = up ? function () {

                if (exp.outline) exp.outline.table.style.visibility = "visible";
                setTimeout(function () {
                    exp.afterExpand();
                }, 50);
            } : function () {
                exp.afterClose();
            };
            if (up) hs.setStyles(this.wrapper, {
                width: x.t + 'px',
                height: y.t + 'px'
            });
            if (up && this.isHtml) {
                hs.setStyles(this.wrapper, {
                    left: x.tpos - x.cb + x.tb + 'px',
                    top: y.tpos - y.cb + y.tb + 'px'
                });
            }
            if (this.fadeInOut) {
                hs.setStyles(this.wrapper, { opacity: up ? 0 : 1 });
                hs.extend(to.wrapper, { opacity: up });
            }
            hs.animate(this.wrapper, to.wrapper, {
                duration: dur,
                easing: easing,
                step: function step(val, args) {
                    if (exp.outline && exp.outlineWhileAnimating && args.prop == 'top') {
                        var fac = up ? args.pos : 1 - args.pos;
                        var pos = {
                            w: x.t + (x.get('wsize') - x.t) * fac,
                            h: y.t + (y.get('wsize') - y.t) * fac,
                            x: x.tpos + (x.pos - x.tpos) * fac,
                            y: y.tpos + (y.pos - y.tpos) * fac
                        };
                        exp.outline.setPosition(pos, 0, 1);
                    }
                    if (exp.isHtml) {
                        if (args.prop == 'left') exp.mediumContent.style.left = x.pos - val + 'px';
                        if (args.prop == 'top') exp.mediumContent.style.top = y.pos - val + 'px';
                    }
                }
            });
            hs.animate(this.content, to.content, dur, easing, after);
            if (up) {
                this.wrapper.style.visibility = 'visible';
                this.content.style.visibility = 'visible';
                if (this.isHtml) this.innerContent.style.visibility = 'visible';
                this.a.className += ' highslide-active-anchor';
            }
        },

        fade: function fade(up, to) {
            this.outlineWhileAnimating = false;
            var exp = this,
                t = up ? hs.expandDuration : 0;

            if (up) {
                hs.animate(this.wrapper, to.wrapper, 0);
                hs.setStyles(this.wrapper, { opacity: 0, visibility: 'visible' });
                hs.animate(this.content, to.content, 0);
                this.content.style.visibility = 'visible';

                hs.animate(this.wrapper, { opacity: 1 }, t, null, function () {
                    exp.afterExpand();
                });
            }

            if (this.outline) {
                this.outline.table.style.zIndex = this.wrapper.style.zIndex;
                var dir = up || -1,
                    offset = this.outline.offset,
                    startOff = up ? 3 : offset,
                    endOff = up ? offset : 3;
                for (var i = startOff; dir * i <= dir * endOff; i += dir, t += 25) {
                    (function () {
                        var o = up ? endOff - i : startOff - i;
                        setTimeout(function () {
                            exp.outline.setPosition(0, o, 1);
                        }, t);
                    })();
                }
            }

            if (up) {} //setTimeout(function() { exp.afterExpand(); }, t+50);
            else {
                    setTimeout(function () {
                        if (exp.outline) exp.outline.destroy(exp.preserveContent);

                        exp.destroyOverlays();

                        hs.animate(exp.wrapper, { opacity: 0 }, hs.restoreDuration, null, function () {
                            exp.afterClose();
                        });
                    }, t);
                }
        },
        crossfade: function crossfade(up, to, from) {
            if (!up) return;
            var exp = this,
                last = this.last,
                x = this.x,
                y = this.y,
                lastX = last.x,
                lastY = last.y,
                wrapper = this.wrapper,
                content = this.content,
                overlayBox = this.overlayBox;
            hs.removeEventListener(document, 'mousemove', hs.dragHandler);

            hs.setStyles(content, {
                width: (x.imgSize || x.size) + 'px',
                height: (y.imgSize || y.size) + 'px'
            });
            if (overlayBox) overlayBox.style.overflow = 'visible';
            this.outline = last.outline;
            if (this.outline) this.outline.exp = exp;
            last.outline = null;
            var fadeBox = hs.createElement('div', {
                className: 'highslide-' + this.contentType
            }, {
                position: 'absolute',
                zIndex: 4,
                overflow: 'hidden',
                display: 'none'
            });
            var names = { oldImg: last, newImg: this };
            for (var n in names) {
                this[n] = names[n].content.cloneNode(1);
                hs.setStyles(this[n], {
                    position: 'absolute',
                    border: 0,
                    visibility: 'visible'
                });
                fadeBox.appendChild(this[n]);
            }
            wrapper.appendChild(fadeBox);
            if (this.isHtml) hs.setStyles(this.mediumContent, {
                left: 0,
                top: 0
            });
            if (overlayBox) {
                overlayBox.className = '';
                wrapper.appendChild(overlayBox);
            }
            fadeBox.style.display = '';
            last.content.style.display = 'none';

            if (hs.safari && hs.uaVersion < 525) {
                this.wrapper.style.visibility = 'visible';
            }
            hs.animate(wrapper, {
                width: x.size
            }, {
                duration: hs.transitionDuration,
                step: function step(val, args) {
                    var pos = args.pos,
                        invPos = 1 - pos;
                    var prop,
                        size = {},
                        props = ['pos', 'size', 'p1', 'p2'];
                    for (var n in props) {
                        prop = props[n];
                        size['x' + prop] = Math.round(invPos * lastX[prop] + pos * x[prop]);
                        size['y' + prop] = Math.round(invPos * lastY[prop] + pos * y[prop]);
                        size.ximgSize = Math.round(invPos * (lastX.imgSize || lastX.size) + pos * (x.imgSize || x.size));
                        size.ximgPad = Math.round(invPos * lastX.get('imgPad') + pos * x.get('imgPad'));
                        size.yimgSize = Math.round(invPos * (lastY.imgSize || lastY.size) + pos * (y.imgSize || y.size));
                        size.yimgPad = Math.round(invPos * lastY.get('imgPad') + pos * y.get('imgPad'));
                    }
                    if (exp.outline) exp.outline.setPosition({
                        x: size.xpos,
                        y: size.ypos,
                        w: size.xsize + size.xp1 + size.xp2 + 2 * x.cb,
                        h: size.ysize + size.yp1 + size.yp2 + 2 * y.cb
                    });
                    last.wrapper.style.clip = 'rect(' + (size.ypos - lastY.pos) + 'px, ' + (size.xsize + size.xp1 + size.xp2 + size.xpos + 2 * lastX.cb - lastX.pos) + 'px, ' + (size.ysize + size.yp1 + size.yp2 + size.ypos + 2 * lastY.cb - lastY.pos) + 'px, ' + (size.xpos - lastX.pos) + 'px)';

                    hs.setStyles(content, {
                        top: size.yp1 + y.get('imgPad') + 'px',
                        left: size.xp1 + x.get('imgPad') + 'px',
                        marginTop: y.pos - size.ypos + 'px',
                        marginLeft: x.pos - size.xpos + 'px'
                    });
                    hs.setStyles(wrapper, {
                        top: size.ypos + 'px',
                        left: size.xpos + 'px',
                        width: size.xp1 + size.xp2 + size.xsize + 2 * x.cb + 'px',
                        height: size.yp1 + size.yp2 + size.ysize + 2 * y.cb + 'px'
                    });
                    hs.setStyles(fadeBox, {
                        width: (size.ximgSize || size.xsize) + 'px',
                        height: (size.yimgSize || size.ysize) + 'px',
                        left: size.xp1 + size.ximgPad + 'px',
                        top: size.yp1 + size.yimgPad + 'px',
                        visibility: 'visible'
                    });

                    hs.setStyles(exp.oldImg, {
                        top: lastY.pos - size.ypos + lastY.p1 - size.yp1 + lastY.get('imgPad') - size.yimgPad + 'px',
                        left: lastX.pos - size.xpos + lastX.p1 - size.xp1 + lastX.get('imgPad') - size.ximgPad + 'px'
                    });

                    hs.setStyles(exp.newImg, {
                        opacity: pos,
                        top: y.pos - size.ypos + y.p1 - size.yp1 + y.get('imgPad') - size.yimgPad + 'px',
                        left: x.pos - size.xpos + x.p1 - size.xp1 + x.get('imgPad') - size.ximgPad + 'px'
                    });
                    if (overlayBox) hs.setStyles(overlayBox, {
                        width: size.xsize + 'px',
                        height: size.ysize + 'px',
                        left: size.xp1 + x.cb + 'px',
                        top: size.yp1 + y.cb + 'px'
                    });
                },
                complete: function complete() {
                    wrapper.style.visibility = content.style.visibility = 'visible';
                    content.style.display = 'block';
                    hs.discardElement(fadeBox);
                    exp.afterExpand();
                    last.afterClose();
                    exp.last = null;
                }

            });
        },
        reuseOverlay: function reuseOverlay(o, el) {
            if (!this.last) return false;
            for (var i = 0; i < this.last.overlays.length; i++) {
                var oDiv = hs.$('hsId' + this.last.overlays[i]);
                if (oDiv && oDiv.hsId == o.hsId) {
                    this.genOverlayBox();
                    oDiv.reuse = this.key;
                    hs.push(this.overlays, this.last.overlays[i]);
                    return true;
                }
            }
            return false;
        },

        afterExpand: function afterExpand() {
            this.isExpanded = true;
            this.focus();

            if (this.isHtml && this.objectLoadTime == 'after') this.writeExtendedContent();
            if (this.iframe) {
                try {
                    var exp = this,
                        doc = this.iframe.contentDocument || this.iframe.contentWindow.document;
                    hs.addEventListener(doc, 'mousedown', function () {
                        if (hs.focusKey != exp.key) exp.focus();
                    });
                } catch (e) {}
                if (hs.ie && typeof this.isClosing != 'boolean') // first open 
                    this.iframe.style.width = this.objectWidth - 1 + 'px'; // hasLayout
            }
            if (this.dimmingOpacity) hs.dim(this);
            if (hs.upcoming && hs.upcoming == this.a) hs.upcoming = null;
            this.prepareNextOutline();
            var p = hs.page,
                mX = hs.mouse.x + p.scrollLeft,
                mY = hs.mouse.y + p.scrollTop;
            this.mouseIsOver = this.x.pos < mX && mX < this.x.pos + this.x.get('wsize') && this.y.pos < mY && mY < this.y.pos + this.y.get('wsize');
            if (this.overlayBox) this.showOverlays();
            hs.fireEvent(this, 'onAfterExpand');
        },

        prepareNextOutline: function prepareNextOutline() {
            var key = this.key;
            var outlineType = this.outlineType;
            new hs.Outline(outlineType, function () {
                try {
                    hs.expanders[key].preloadNext();
                } catch (e) {}
            });
        },

        preloadNext: function preloadNext() {
            var next = this.getAdjacentAnchor(1);
            if (next && next.onclick.toString().match(/hs\.expand/)) var img = hs.createElement('img', { src: hs.getSrc(next) });
        },

        getAdjacentAnchor: function getAdjacentAnchor(op) {
            var current = this.getAnchorIndex(),
                as = hs.anchors.groups[this.slideshowGroup || 'none'];
            if (as && !as[current + op] && this.slideshow && this.slideshow.repeat) {
                if (op == 1) return as[0];else if (op == -1) return as[as.length - 1];
            }
            return as && as[current + op] || null;
        },

        getAnchorIndex: function getAnchorIndex() {
            var arr = hs.getAnchors().groups[this.slideshowGroup || 'none'];
            if (arr) for (var i = 0; i < arr.length; i++) {
                if (arr[i] == this.a) return i;
            }
            return null;
        },

        getNumber: function getNumber() {
            if (this[this.numberPosition]) {
                var arr = hs.anchors.groups[this.slideshowGroup || 'none'];
                if (arr) {
                    var s = hs.lang.number.replace('%1', this.getAnchorIndex() + 1).replace('%2', arr.length);
                    this[this.numberPosition].innerHTML = '<div class="highslide-number">' + s + '</div>' + this[this.numberPosition].innerHTML;
                }
            }
        },
        initSlideshow: function initSlideshow() {
            if (!this.last) {
                for (var i = 0; i < hs.slideshows.length; i++) {
                    var ss = hs.slideshows[i],
                        sg = ss.slideshowGroup;
                    if (typeof sg == 'undefined' || sg === null || sg === this.slideshowGroup) this.slideshow = new hs.Slideshow(this.key, ss);
                }
            } else {
                this.slideshow = this.last.slideshow;
            }
            var ss = this.slideshow;
            if (!ss) return;
            var key = ss.expKey = this.key;

            ss.checkFirstAndLast();
            ss.disable('full-expand');
            if (ss.controls) {
                this.createOverlay(hs.extend(ss.overlayOptions || {}, {
                    overlayId: ss.controls,
                    hsId: 'controls',
                    zIndex: 5
                }));
            }
            if (ss.thumbstrip) ss.thumbstrip.add(this);
            if (!this.last && this.autoplay) ss.play(true);
            if (ss.autoplay) {
                ss.autoplay = setTimeout(function () {
                    hs.next(key);
                }, ss.interval || 500);
            }
        },

        cancelLoading: function cancelLoading() {
            hs.discardElement(this.wrapper);
            hs.expanders[this.key] = null;
            if (hs.upcoming == this.a) hs.upcoming = null;
            hs.undim(this.key);
            if (this.loading) hs.loading.style.left = '-9999px';
            hs.fireEvent(this, 'onHideLoading');
        },

        writeCredits: function writeCredits() {
            if (this.credits) return;
            this.credits = hs.createElement('a', {
                href: hs.creditsHref,
                target: hs.creditsTarget,
                className: 'highslide-credits',
                innerHTML: hs.lang.creditsText,
                title: hs.lang.creditsTitle
            });
            this.createOverlay({
                overlayId: this.credits,
                position: this.creditsPosition || 'top left',
                hsId: 'credits'
            });
        },

        getInline: function getInline(types, addOverlay) {
            for (var i = 0; i < types.length; i++) {
                var type = types[i],
                    s = null;
                if (type == 'caption' && !hs.fireEvent(this, 'onBeforeGetCaption')) return;else if (type == 'heading' && !hs.fireEvent(this, 'onBeforeGetHeading')) return;
                if (!this[type + 'Id'] && this.thumbsUserSetId) this[type + 'Id'] = type + '-for-' + this.thumbsUserSetId;
                if (this[type + 'Id']) this[type] = hs.getNode(this[type + 'Id']);
                if (!this[type] && !this[type + 'Text'] && this[type + 'Eval']) try {
                    s = eval(this[type + 'Eval']);
                } catch (e) {}
                if (!this[type] && this[type + 'Text']) {
                    s = this[type + 'Text'];
                }
                if (!this[type] && !s) {
                    this[type] = hs.getNode(this.a['_' + type + 'Id']);
                    if (!this[type]) {
                        var next = this.a.nextSibling;
                        while (next && !hs.isHsAnchor(next)) {
                            if (new RegExp('highslide-' + type).test(next.className || null)) {
                                if (!next.id) this.a['_' + type + 'Id'] = next.id = 'hsId' + hs.idCounter++;
                                this[type] = hs.getNode(next.id);
                                break;
                            }
                            next = next.nextSibling;
                        }
                    }
                }
                if (!this[type] && !s && this.numberPosition == type) s = '\n';

                if (!this[type] && s) this[type] = hs.createElement('div', { className: 'highslide-' + type, innerHTML: s });

                if (addOverlay && this[type]) {
                    var o = { position: type == 'heading' ? 'above' : 'below' };
                    for (var x in this[type + 'Overlay']) {
                        o[x] = this[type + 'Overlay'][x];
                    }o.overlayId = this[type];
                    this.createOverlay(o);
                }
            }
        },

        // on end move and resize
        doShowHide: function doShowHide(visibility) {
            if (hs.hideSelects) this.showHideElements('SELECT', visibility);
            if (hs.hideIframes) this.showHideElements('IFRAME', visibility);
            if (hs.geckoMac) this.showHideElements('*', visibility);
        },
        showHideElements: function showHideElements(tagName, visibility) {
            var els = document.getElementsByTagName(tagName);
            var prop = tagName == '*' ? 'overflow' : 'visibility';
            for (var i = 0; i < els.length; i++) {
                if (prop == 'visibility' || document.defaultView.getComputedStyle(els[i], "").getPropertyValue('overflow') == 'auto' || els[i].getAttribute('hidden-by') != null) {
                    var hiddenBy = els[i].getAttribute('hidden-by');
                    if (visibility == 'visible' && hiddenBy) {
                        hiddenBy = hiddenBy.replace('[' + this.key + ']', '');
                        els[i].setAttribute('hidden-by', hiddenBy);
                        if (!hiddenBy) els[i].style[prop] = els[i].origProp;
                    } else if (visibility == 'hidden') {
                        // hide if behind
                        var elPos = hs.getPosition(els[i]);
                        elPos.w = els[i].offsetWidth;
                        elPos.h = els[i].offsetHeight;
                        if (!this.dimmingOpacity) {
                            // hide all if dimming

                            var clearsX = elPos.x + elPos.w < this.x.get('opos') || elPos.x > this.x.get('opos') + this.x.get('osize');
                            var clearsY = elPos.y + elPos.h < this.y.get('opos') || elPos.y > this.y.get('opos') + this.y.get('osize');
                        }
                        var wrapperKey = hs.getWrapperKey(els[i]);
                        if (!clearsX && !clearsY && wrapperKey != this.key) {
                            // element falls behind image
                            if (!hiddenBy) {
                                els[i].setAttribute('hidden-by', '[' + this.key + ']');
                                els[i].origProp = els[i].style[prop];
                                els[i].style[prop] = 'hidden';
                            } else if (hiddenBy.indexOf('[' + this.key + ']') == -1) {
                                els[i].setAttribute('hidden-by', hiddenBy + '[' + this.key + ']');
                            }
                        } else if ((hiddenBy == '[' + this.key + ']' || hs.focusKey == wrapperKey) && wrapperKey != this.key) {
                            // on move
                            els[i].setAttribute('hidden-by', '');
                            els[i].style[prop] = els[i].origProp || '';
                        } else if (hiddenBy && hiddenBy.indexOf('[' + this.key + ']') > -1) {
                            els[i].setAttribute('hidden-by', hiddenBy.replace('[' + this.key + ']', ''));
                        }
                    }
                }
            }
        },

        focus: function focus() {
            this.wrapper.style.zIndex = hs.zIndexCounter += 2;
            // blur others
            for (var i = 0; i < hs.expanders.length; i++) {
                if (hs.expanders[i] && i == hs.focusKey) {
                    var blurExp = hs.expanders[i];
                    blurExp.content.className += ' highslide-' + blurExp.contentType + '-blur';
                    if (blurExp.isImage) {
                        blurExp.content.style.cursor = hs.ieLt7 ? 'hand' : 'pointer';
                        blurExp.content.title = hs.lang.focusTitle;
                    }
                    hs.fireEvent(blurExp, 'onBlur');
                }
            }

            // focus this
            if (this.outline) this.outline.table.style.zIndex = this.wrapper.style.zIndex - 1;
            this.content.className = 'highslide-' + this.contentType;
            if (this.isImage) {
                this.content.title = hs.lang.restoreTitle;

                if (hs.restoreCursor) {
                    hs.styleRestoreCursor = window.opera ? 'pointer' : 'url(' + hs.graphicsDir + hs.restoreCursor + '), pointer';
                    if (hs.ieLt7 && hs.uaVersion < 6) hs.styleRestoreCursor = 'hand';
                    this.content.style.cursor = hs.styleRestoreCursor;
                }
            }
            hs.focusKey = this.key;
            hs.addEventListener(document, window.opera ? 'keypress' : 'keydown', hs.keyHandler);
            hs.fireEvent(this, 'onFocus');
        },
        moveTo: function moveTo(x, y) {
            this.x.setPos(x);
            this.y.setPos(y);
        },
        resize: function resize(e) {
            var w,
                h,
                r = e.width / e.height;
            w = Math.max(e.width + e.dX, Math.min(this.minWidth, this.x.full));
            if (this.isImage && Math.abs(w - this.x.full) < 12) w = this.x.full;
            h = this.isHtml ? e.height + e.dY : w / r;
            if (h < Math.min(this.minHeight, this.y.full)) {
                h = Math.min(this.minHeight, this.y.full);
                if (this.isImage) w = h * r;
            }
            this.resizeTo(w, h);
        },
        resizeTo: function resizeTo(w, h) {
            this.y.setSize(h);
            this.x.setSize(w);
            this.wrapper.style.height = this.y.get('wsize') + 'px';
        },

        close: function close() {
            if (this.isClosing || !this.isExpanded) return;
            if (this.transitions[1] == 'crossfade' && hs.upcoming) {
                hs.getExpander(hs.upcoming).cancelLoading();
                hs.upcoming = null;
            }
            if (!hs.fireEvent(this, 'onBeforeClose')) return;
            this.isClosing = true;
            if (this.slideshow && !hs.upcoming) this.slideshow.pause();

            hs.removeEventListener(document, window.opera ? 'keypress' : 'keydown', hs.keyHandler);

            try {
                if (this.isHtml) this.htmlPrepareClose();
                this.content.style.cursor = 'default';
                this.changeSize(0, {
                    wrapper: {
                        width: this.x.t,
                        height: this.y.t,
                        left: this.x.tpos - this.x.cb + this.x.tb,
                        top: this.y.tpos - this.y.cb + this.y.tb
                    },
                    content: {
                        left: 0,
                        top: 0,
                        width: this.x.t,
                        height: this.y.t
                    }
                }, hs.restoreDuration);
            } catch (e) {
                this.afterClose();
            }
        },

        htmlPrepareClose: function htmlPrepareClose() {
            if (hs.geckoMac) {
                // bad redraws
                if (!hs.mask) hs.mask = hs.createElement('div', null, { position: 'absolute' }, hs.container);
                hs.setStyles(hs.mask, { width: this.x.size + 'px', height: this.y.size + 'px',
                    left: this.x.pos + 'px', top: this.y.pos + 'px', display: 'block' });
            }
            if (this.objectType == 'swf') try {
                hs.$(this.body.id).StopPlay();
            } catch (e) {}

            if (this.objectLoadTime == 'after' && !this.preserveContent) this.destroyObject();
            if (this.scrollerDiv && this.scrollerDiv != this.scrollingContent) this.scrollerDiv.style.overflow = 'hidden';
        },

        destroyObject: function destroyObject() {
            if (hs.ie && this.iframe) try {
                this.iframe.contentWindow.document.body.innerHTML = '';
            } catch (e) {}
            if (this.objectType == 'swf') swfobject.removeSWF(this.body.id);
            this.body.innerHTML = '';
        },

        sleep: function sleep() {
            if (this.outline) this.outline.table.style.display = 'none';
            this.releaseMask = null;
            this.wrapper.style.display = 'none';
            this.isExpanded = false;
            hs.push(hs.sleeping, this);
        },

        awake: function awake() {
            try {

                hs.expanders[this.key] = this;

                if (!hs.allowMultipleInstances && hs.focusKey != this.key) {
                    try {
                        hs.expanders[hs.focusKey].close();
                    } catch (e) {}
                }

                var z = hs.zIndexCounter++,
                    stl = { display: '', zIndex: z };
                hs.setStyles(this.wrapper, stl);
                this.isClosing = false;

                var o = this.outline || 0;
                if (o) {
                    if (!this.outlineWhileAnimating) stl.visibility = 'hidden';
                    hs.setStyles(o.table, stl);
                }
                if (this.slideshow) {
                    this.initSlideshow();
                }

                this.show();
            } catch (e) {}
        },

        createOverlay: function createOverlay(o) {
            var el = o.overlayId,
                relToVP = o.relativeTo == 'viewport' && !/panel$/.test(o.position);
            if (typeof el == 'string') el = hs.getNode(el);
            if (o.html) el = hs.createElement('div', { innerHTML: o.html });
            if (!el || typeof el == 'string') return;
            if (!hs.fireEvent(this, 'onCreateOverlay', { overlay: el })) return;
            el.style.display = 'block';
            o.hsId = o.hsId || o.overlayId;
            if (this.transitions[1] == 'crossfade' && this.reuseOverlay(o, el)) return;
            this.genOverlayBox();
            var width = o.width && /^[0-9]+(px|%)$/.test(o.width) ? o.width : 'auto';
            if (/^(left|right)panel$/.test(o.position) && !/^[0-9]+px$/.test(o.width)) width = '200px';
            var overlay = hs.createElement('div', {
                id: 'hsId' + hs.idCounter++,
                hsId: o.hsId
            }, {
                position: 'absolute',
                visibility: 'hidden',
                width: width,
                direction: hs.lang.cssDirection || '',
                opacity: 0
            }, relToVP ? hs.viewport : this.overlayBox, true);
            if (relToVP) overlay.hsKey = this.key;

            overlay.appendChild(el);
            hs.extend(overlay, {
                opacity: 1,
                offsetX: 0,
                offsetY: 0,
                dur: o.fade === 0 || o.fade === false || o.fade == 2 && hs.ie ? 0 : 250
            });
            hs.extend(overlay, o);

            if (this.gotOverlays) {
                this.positionOverlay(overlay);
                if (!overlay.hideOnMouseOut || this.mouseIsOver) hs.animate(overlay, { opacity: overlay.opacity }, overlay.dur);
            }
            hs.push(this.overlays, hs.idCounter - 1);
        },
        positionOverlay: function positionOverlay(overlay) {
            var p = overlay.position || 'middle center',
                relToVP = overlay.relativeTo == 'viewport',
                offX = overlay.offsetX,
                offY = overlay.offsetY;
            if (relToVP) {
                hs.viewport.style.display = 'block';
                overlay.hsKey = this.key;
                if (overlay.offsetWidth > overlay.parentNode.offsetWidth) overlay.style.width = '100%';
            } else if (overlay.parentNode != this.overlayBox) this.overlayBox.appendChild(overlay);
            if (/left$/.test(p)) overlay.style.left = offX + 'px';

            if (/center$/.test(p)) hs.setStyles(overlay, {
                left: '50%',
                marginLeft: offX - Math.round(overlay.offsetWidth / 2) + 'px'
            });

            if (/right$/.test(p)) overlay.style.right = -offX + 'px';

            if (/^leftpanel$/.test(p)) {
                hs.setStyles(overlay, {
                    right: '100%',
                    marginRight: this.x.cb + 'px',
                    top: -this.y.cb + 'px',
                    bottom: -this.y.cb + 'px',
                    overflow: 'auto'
                });
                this.x.p1 = overlay.offsetWidth;
            } else if (/^rightpanel$/.test(p)) {
                hs.setStyles(overlay, {
                    left: '100%',
                    marginLeft: this.x.cb + 'px',
                    top: -this.y.cb + 'px',
                    bottom: -this.y.cb + 'px',
                    overflow: 'auto'
                });
                this.x.p2 = overlay.offsetWidth;
            }
            var parOff = overlay.parentNode.offsetHeight;
            overlay.style.height = 'auto';
            if (relToVP && overlay.offsetHeight > parOff) overlay.style.height = hs.ieLt7 ? parOff + 'px' : '100%';

            if (/^top/.test(p)) overlay.style.top = offY + 'px';
            if (/^middle/.test(p)) hs.setStyles(overlay, {
                top: '50%',
                marginTop: offY - Math.round(overlay.offsetHeight / 2) + 'px'
            });
            if (/^bottom/.test(p)) overlay.style.bottom = -offY + 'px';
            if (/^above$/.test(p)) {
                hs.setStyles(overlay, {
                    left: -this.x.p1 - this.x.cb + 'px',
                    right: -this.x.p2 - this.x.cb + 'px',
                    bottom: '100%',
                    marginBottom: this.y.cb + 'px',
                    width: 'auto'
                });
                this.y.p1 = overlay.offsetHeight;
            } else if (/^below$/.test(p)) {
                hs.setStyles(overlay, {
                    position: 'relative',
                    left: -this.x.p1 - this.x.cb + 'px',
                    right: -this.x.p2 - this.x.cb + 'px',
                    top: '100%',
                    marginTop: this.y.cb + 'px',
                    width: 'auto'
                });
                this.y.p2 = overlay.offsetHeight;
                overlay.style.position = 'absolute';
            }
        },

        getOverlays: function getOverlays() {
            this.getInline(['heading', 'caption'], true);
            this.getNumber();
            if (this.caption) hs.fireEvent(this, 'onAfterGetCaption');
            if (this.heading) hs.fireEvent(this, 'onAfterGetHeading');
            if (this.heading && this.dragByHeading) this.heading.className += ' highslide-move';
            if (hs.showCredits) this.writeCredits();
            for (var i = 0; i < hs.overlays.length; i++) {
                var o = hs.overlays[i],
                    tId = o.thumbnailId,
                    sg = o.slideshowGroup;
                if (!tId && !sg || tId && tId == this.thumbsUserSetId || sg && sg === this.slideshowGroup) {
                    if (this.isImage || this.isHtml && o.useOnHtml) this.createOverlay(o);
                }
            }
            var os = [];
            for (var i = 0; i < this.overlays.length; i++) {
                var o = hs.$('hsId' + this.overlays[i]);
                if (/panel$/.test(o.position)) this.positionOverlay(o);else hs.push(os, o);
            }
            for (var i = 0; i < os.length; i++) {
                this.positionOverlay(os[i]);
            }this.gotOverlays = true;
        },
        genOverlayBox: function genOverlayBox() {
            if (!this.overlayBox) this.overlayBox = hs.createElement('div', {
                className: this.wrapperClassName
            }, {
                position: 'absolute',
                width: (this.x.size || (this.useBox ? this.width : null) || this.x.full) + 'px',
                height: (this.y.size || this.y.full) + 'px',
                visibility: 'hidden',
                overflow: 'hidden',
                zIndex: hs.ie ? 4 : 'auto'
            }, hs.container, true);
        },
        sizeOverlayBox: function sizeOverlayBox(doWrapper, doPanels) {
            var overlayBox = this.overlayBox,
                x = this.x,
                y = this.y;
            hs.setStyles(overlayBox, {
                width: x.size + 'px',
                height: y.size + 'px'
            });
            if (doWrapper || doPanels) {
                for (var i = 0; i < this.overlays.length; i++) {
                    var o = hs.$('hsId' + this.overlays[i]);
                    var ie6 = hs.ieLt7 || document.compatMode == 'BackCompat';
                    if (o && /^(above|below)$/.test(o.position)) {
                        if (ie6) {
                            o.style.width = overlayBox.offsetWidth + 2 * x.cb + x.p1 + x.p2 + 'px';
                        }
                        y[o.position == 'above' ? 'p1' : 'p2'] = o.offsetHeight;
                    }
                    if (o && ie6 && /^(left|right)panel$/.test(o.position)) {
                        o.style.height = overlayBox.offsetHeight + 2 * y.cb + 'px';
                    }
                }
            }
            if (doWrapper) {
                hs.setStyles(this.content, {
                    top: y.p1 + 'px'
                });
                hs.setStyles(overlayBox, {
                    top: y.p1 + y.cb + 'px'
                });
            }
        },

        showOverlays: function showOverlays() {
            var b = this.overlayBox;
            b.className = '';
            hs.setStyles(b, {
                top: this.y.p1 + this.y.cb + 'px',
                left: this.x.p1 + this.x.cb + 'px',
                overflow: 'visible'
            });
            if (hs.safari) b.style.visibility = 'visible';
            this.wrapper.appendChild(b);
            for (var i = 0; i < this.overlays.length; i++) {
                var o = hs.$('hsId' + this.overlays[i]);
                o.style.zIndex = o.zIndex || 4;
                if (!o.hideOnMouseOut || this.mouseIsOver) {
                    o.style.visibility = 'visible';
                    hs.setStyles(o, { visibility: 'visible', display: '' });
                    hs.animate(o, { opacity: o.opacity }, o.dur);
                }
            }
        },

        destroyOverlays: function destroyOverlays() {
            if (!this.overlays.length) return;
            if (this.slideshow) {
                var c = this.slideshow.controls;
                if (c && hs.getExpander(c) == this) c.parentNode.removeChild(c);
            }
            for (var i = 0; i < this.overlays.length; i++) {
                var o = hs.$('hsId' + this.overlays[i]);
                if (o && o.parentNode == hs.viewport && hs.getExpander(o) == this) hs.discardElement(o);
            }
            if (this.isHtml && this.preserveContent) {
                this.overlayBox.style.top = '-9999px';
                hs.container.appendChild(this.overlayBox);
            } else hs.discardElement(this.overlayBox);
        },

        createFullExpand: function createFullExpand() {
            if (this.slideshow && this.slideshow.controls) {
                this.slideshow.enable('full-expand');
                return;
            }
            this.fullExpandLabel = hs.createElement('a', {
                href: 'javascript:hs.expanders[' + this.key + '].doFullExpand();',
                title: hs.lang.fullExpandTitle,
                className: 'highslide-full-expand'
            });
            if (!hs.fireEvent(this, 'onCreateFullExpand')) return;

            this.createOverlay({
                overlayId: this.fullExpandLabel,
                position: hs.fullExpandPosition,
                hideOnMouseOut: true,
                opacity: hs.fullExpandOpacity
            });
        },

        doFullExpand: function doFullExpand() {
            try {
                if (!hs.fireEvent(this, 'onDoFullExpand')) return;
                if (this.fullExpandLabel) hs.discardElement(this.fullExpandLabel);

                this.focus();
                var xSize = this.x.size,
                    ySize = this.y.size;
                this.resizeTo(this.x.full, this.y.full);

                var xpos = this.x.pos - (this.x.size - xSize) / 2;
                if (xpos < hs.marginLeft) xpos = hs.marginLeft;

                var ypos = this.y.pos - (this.y.size - ySize) / 2;
                if (ypos < hs.marginTop) ypos = hs.marginTop;

                this.moveTo(xpos, ypos);
                this.doShowHide('hidden');
            } catch (e) {
                this.error(e);
            }
        },

        afterClose: function afterClose() {
            this.a.className = this.a.className.replace('highslide-active-anchor', '');

            this.doShowHide('visible');

            if (this.isHtml && this.preserveContent && this.transitions[1] != 'crossfade') {
                this.sleep();
            } else {
                if (this.outline && this.outlineWhileAnimating) this.outline.destroy();

                hs.discardElement(this.wrapper);
            }
            if (hs.mask) hs.mask.style.display = 'none';
            this.destroyOverlays();
            if (!hs.viewport.childNodes.length) hs.viewport.style.display = 'none';

            if (this.dimmingOpacity) hs.undim(this.key);
            hs.fireEvent(this, 'onAfterClose');
            hs.expanders[this.key] = null;
            hs.reOrder();
        }

    };

    // hs.Ajax object prototype
    hs.Ajax = function (a, content, pre) {
        this.a = a;
        this.content = content;
        this.pre = pre;
    };

    hs.Ajax.prototype = {
        run: function run() {
            var xhr;
            if (!this.src) this.src = hs.getSrc(this.a);
            if (this.src.match('#')) {
                var arr = this.src.split('#');
                this.src = arr[0];
                this.id = arr[1];
            }
            if (hs.cachedGets[this.src]) {
                this.cachedGet = hs.cachedGets[this.src];
                if (this.id) this.getElementContent();else this.loadHTML();
                return;
            }
            try {
                xhr = new XMLHttpRequest();
            } catch (e) {
                try {
                    xhr = new ActiveXObject("Msxml2.XMLHTTP");
                } catch (e) {
                    try {
                        xhr = new ActiveXObject("Microsoft.XMLHTTP");
                    } catch (e) {
                        this.onError();
                    }
                }
            }
            var pThis = this;
            xhr.onreadystatechange = function () {
                if (pThis.xhr.readyState == 4) {
                    if (pThis.id) pThis.getElementContent();else pThis.loadHTML();
                }
            };
            var src = this.src;
            this.xhr = xhr;
            if (hs.forceAjaxReload) src = src.replace(/$/, (/\?/.test(src) ? '&' : '?') + 'dummy=' + new Date().getTime());
            xhr.open('GET', src, true);
            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
            xhr.send(null);
        },

        getElementContent: function getElementContent() {
            hs.init();
            var attribs = window.opera || hs.ie6SSL ? { src: 'about:blank' } : null;

            this.iframe = hs.createElement('iframe', attribs, { position: 'absolute', top: '-9999px' }, hs.container);

            this.loadHTML();
        },

        loadHTML: function loadHTML() {
            var s = this.cachedGet || this.xhr.responseText,
                regBody;
            if (this.pre) hs.cachedGets[this.src] = s;
            if (!hs.ie || hs.uaVersion >= 5.5) {
                s = s.replace(new RegExp('<link[^>]*>', 'gi'), '').replace(new RegExp('<script[^>]*>.*?</script>', 'gi'), '');
                if (this.iframe) {
                    var doc = this.iframe.contentDocument;
                    if (!doc && this.iframe.contentWindow) doc = this.iframe.contentWindow.document;
                    if (!doc) {
                        // Opera
                        var pThis = this;
                        setTimeout(function () {
                            pThis.loadHTML();
                        }, 25);
                        return;
                    }
                    doc.open();
                    doc.write(s);
                    doc.close();
                    try {
                        s = doc.getElementById(this.id).innerHTML;
                    } catch (e) {
                        try {
                            s = this.iframe.document.getElementById(this.id).innerHTML;
                        } catch (e) {} // opera
                    }
                    hs.discardElement(this.iframe);
                } else {
                    regBody = /(<body[^>]*>|<\/body>)/ig;
                    if (regBody.test(s)) s = s.split(regBody)[hs.ieLt9 ? 1 : 2];
                }
            }
            hs.getElementByClass(this.content, 'DIV', 'highslide-body').innerHTML = s;
            this.onLoad();
            for (var x in this) {
                this[x] = null;
            }
        }
    };

    hs.Slideshow = function (expKey, options) {
        if (hs.dynamicallyUpdateAnchors !== false) hs.updateAnchors();
        this.expKey = expKey;
        for (var x in options) {
            this[x] = options[x];
        }if (this.useControls) this.getControls();
        if (this.thumbstrip) this.thumbstrip = hs.Thumbstrip(this);
    };
    hs.Slideshow.prototype = {
        getControls: function getControls() {
            this.controls = hs.createElement('div', { innerHTML: hs.replaceLang(hs.skin.controls) }, null, hs.container);

            var buttons = ['play', 'pause', 'previous', 'next', 'move', 'full-expand', 'close'];
            this.btn = {};
            var pThis = this;
            for (var i = 0; i < buttons.length; i++) {
                this.btn[buttons[i]] = hs.getElementByClass(this.controls, 'li', 'highslide-' + buttons[i]);
                this.enable(buttons[i]);
            }
            this.btn.pause.style.display = 'none';
            //this.disable('full-expand');
        },
        checkFirstAndLast: function checkFirstAndLast() {
            if (this.repeat || !this.controls) return;
            var exp = hs.expanders[this.expKey],
                cur = exp.getAnchorIndex(),
                re = /disabled$/;
            if (cur == 0) this.disable('previous');else if (re.test(this.btn.previous.getElementsByTagName('a')[0].className)) this.enable('previous');
            if (cur + 1 == hs.anchors.groups[exp.slideshowGroup || 'none'].length) {
                this.disable('next');
                this.disable('play');
            } else if (re.test(this.btn.next.getElementsByTagName('a')[0].className)) {
                this.enable('next');
                this.enable('play');
            }
        },
        enable: function enable(btn) {
            if (!this.btn) return;
            var sls = this,
                a = this.btn[btn].getElementsByTagName('a')[0],
                re = /disabled$/;
            a.onclick = function () {
                sls[btn]();
                return false;
            };
            if (re.test(a.className)) a.className = a.className.replace(re, '');
        },
        disable: function disable(btn) {
            if (!this.btn) return;
            var a = this.btn[btn].getElementsByTagName('a')[0];
            a.onclick = function () {
                return false;
            };
            if (!/disabled$/.test(a.className)) a.className += ' disabled';
        },
        hitSpace: function hitSpace() {
            if (this.autoplay) this.pause();else this.play();
        },
        play: function play(wait) {
            if (this.btn) {
                this.btn.play.style.display = 'none';
                this.btn.pause.style.display = '';
            }

            this.autoplay = true;
            if (!wait) hs.next(this.expKey);
        },
        pause: function pause() {
            if (this.btn) {
                this.btn.pause.style.display = 'none';
                this.btn.play.style.display = '';
            }

            clearTimeout(this.autoplay);
            this.autoplay = null;
        },
        previous: function previous() {
            this.pause();
            hs.previous(this.btn.previous);
        },
        next: function next() {
            this.pause();
            hs.next(this.btn.next);
        },
        move: function move() {},
        'full-expand': function fullExpand() {
            hs.getExpander().doFullExpand();
        },
        close: function close() {
            hs.close(this.btn.close);
        }
    };
    hs.Thumbstrip = function (slideshow) {
        function add(exp) {
            hs.extend(options || {}, {
                overlayId: dom,
                hsId: 'thumbstrip',
                className: 'highslide-thumbstrip-' + mode + '-overlay ' + (options.className || '')
            });
            if (hs.ieLt7) options.fade = 0;
            exp.createOverlay(options);
            hs.setStyles(dom.parentNode, { overflow: 'hidden' });
        }

        ;

        function scroll(delta) {
            selectThumb(undefined, Math.round(delta * dom[isX ? 'offsetWidth' : 'offsetHeight'] * 0.7));
        }

        ;

        function selectThumb(i, scrollBy) {
            if (i === undefined) for (var j = 0; j < group.length; j++) {
                if (group[j] == hs.expanders[slideshow.expKey].a) {
                    i = j;
                    break;
                }
            }
            if (i === undefined) return;
            var as = dom.getElementsByTagName('a'),
                active = as[i],
                cell = active.parentNode,
                left = isX ? 'Left' : 'Top',
                right = isX ? 'Right' : 'Bottom',
                width = isX ? 'Width' : 'Height',
                offsetLeft = 'offset' + left,
                offsetWidth = 'offset' + width,
                overlayWidth = div.parentNode.parentNode[offsetWidth],
                minTblPos = overlayWidth - table[offsetWidth],
                curTblPos = parseInt(table.style[isX ? 'left' : 'top']) || 0,
                tblPos = curTblPos,
                mgnRight = 20;
            if (scrollBy !== undefined) {
                tblPos = curTblPos - scrollBy;

                if (minTblPos > 0) minTblPos = 0;
                if (tblPos > 0) tblPos = 0;
                if (tblPos < minTblPos) tblPos = minTblPos;
            } else {
                for (var j = 0; j < as.length; j++) {
                    as[j].className = '';
                }active.className = 'highslide-active-anchor';
                var activeLeft = i > 0 ? as[i - 1].parentNode[offsetLeft] : cell[offsetLeft],
                    activeRight = cell[offsetLeft] + cell[offsetWidth] + (as[i + 1] ? as[i + 1].parentNode[offsetWidth] : 0);
                if (activeRight > overlayWidth - curTblPos) tblPos = overlayWidth - activeRight;else if (activeLeft < -curTblPos) tblPos = -activeLeft;
            }
            var markerPos = cell[offsetLeft] + (cell[offsetWidth] - marker[offsetWidth]) / 2 + tblPos;
            hs.animate(table, isX ? { left: tblPos } : { top: tblPos }, null, 'easeOutQuad');
            hs.animate(marker, isX ? { left: markerPos } : { top: markerPos }, null, 'easeOutQuad');
            scrollUp.style.display = tblPos < 0 ? 'block' : 'none';
            scrollDown.style.display = tblPos > minTblPos ? 'block' : 'none';
        }

        ;

        // initialize
        var group = hs.anchors.groups[hs.expanders[slideshow.expKey].slideshowGroup || 'none'],
            options = slideshow.thumbstrip,
            mode = options.mode || 'horizontal',
            floatMode = mode == 'float',
            tree = floatMode ? ['div', 'ul', 'li', 'span'] : ['table', 'tbody', 'tr', 'td'],
            isX = mode == 'horizontal',
            dom = hs.createElement('div', {
            className: 'highslide-thumbstrip highslide-thumbstrip-' + mode,
            innerHTML: '<div class="highslide-thumbstrip-inner">' + '<' + tree[0] + '><' + tree[1] + '></' + tree[1] + '></' + tree[0] + '></div>' + '<div class="highslide-scroll-up"><div></div></div>' + '<div class="highslide-scroll-down"><div></div></div>' + '<div class="highslide-marker"><div></div></div>'
        }, {
            display: 'none'
        }, hs.container),
            domCh = dom.childNodes,
            div = domCh[0],
            scrollUp = domCh[1],
            scrollDown = domCh[2],
            marker = domCh[3],
            table = div.firstChild,
            tbody = dom.getElementsByTagName(tree[1])[0],
            tr;
        for (var i = 0; i < group.length; i++) {
            if (i == 0 || !isX) tr = hs.createElement(tree[2], null, null, tbody);
            (function () {
                var a = group[i],
                    cell = hs.createElement(tree[3], null, null, tr),
                    pI = i;
                hs.createElement('a', {
                    href: a.href,
                    title: a.title,
                    onclick: function onclick() {
                        if (/highslide-active-anchor/.test(this.className)) return false;
                        hs.getExpander(this).focus();
                        return hs.transit(a);
                    },
                    innerHTML: hs.stripItemFormatter ? hs.stripItemFormatter(a) : a.innerHTML
                }, null, cell);
            })();
        }
        if (!floatMode) {
            scrollUp.onclick = function () {
                scroll(-1);
            };
            scrollDown.onclick = function () {
                scroll(1);
            };
            hs.addEventListener(tbody, document.onmousewheel !== undefined ? 'mousewheel' : 'DOMMouseScroll', function (e) {
                var delta = 0;
                e = e || window.event;
                if (e.wheelDelta) {
                    delta = e.wheelDelta / 120;
                    if (hs.opera) delta = -delta;
                } else if (e.detail) {
                    delta = -e.detail / 3;
                }
                if (delta) scroll(-delta * 0.2);
                if (e.preventDefault) e.preventDefault();
                e.returnValue = false;
            });
        }

        return {
            add: add,
            selectThumb: selectThumb
        };
    };
    hs.langDefaults = hs.lang;
    // history
    var HsExpander = hs.Expander;
    if (hs.ie && window == window.top) {
        (function () {
            try {
                document.documentElement.doScroll('left');
            } catch (e) {
                setTimeout(arguments.callee, 50);
                return;
            }
            hs.ready();
        })();
    }
    hs.addEventListener(document, 'DOMContentLoaded', hs.ready);
    hs.addEventListener(window, 'load', hs.ready);

    // set handlers
    hs.addEventListener(document, 'ready', function () {
        if (hs.expandCursor || hs.dimmingOpacity) {
            var addRule = function addRule(sel, dec) {
                if (hs.ie && (hs.uaVersion < 9 || backCompat)) {
                    var last = document.styleSheets[document.styleSheets.length - 1];
                    if (_typeof(last.addRule) == "object") last.addRule(sel, dec);
                } else {
                    style.appendChild(document.createTextNode(sel + " {" + dec + "}"));
                }
            };

            var fix = function fix(prop) {
                return 'expression( ( ( ignoreMe = document.documentElement.' + prop + ' ? document.documentElement.' + prop + ' : document.body.' + prop + ' ) ) + \'px\' );';
            };

            var style = hs.createElement('style', { type: 'text/css' }, null, document.getElementsByTagName('HEAD')[0]),
                backCompat = document.compatMode == 'BackCompat';

            if (hs.expandCursor) addRule('.highslide img', 'cursor: url(' + hs.graphicsDir + hs.expandCursor + '), pointer !important;');
            addRule('.highslide-viewport-size', hs.ie && (hs.uaVersion < 7 || backCompat) ? 'position: absolute; ' + 'left:' + fix('scrollLeft') + 'top:' + fix('scrollTop') + 'width:' + fix('clientWidth') + 'height:' + fix('clientHeight') : 'position: fixed; width: 100%; height: 100%; left: 0; top: 0');
        }
    });
    hs.addEventListener(window, 'resize', function () {
        hs.getPageSize();
        if (hs.viewport) for (var i = 0; i < hs.viewport.childNodes.length; i++) {
            var node = hs.viewport.childNodes[i],
                exp = hs.getExpander(node);
            exp.positionOverlay(node);
            if (node.hsId == 'thumbstrip') exp.slideshow.thumbstrip.selectThumb();
        }
    });
    hs.addEventListener(document, 'mousemove', function (e) {
        hs.mouse = { x: e.clientX, y: e.clientY };
    });
    hs.addEventListener(document, 'mousedown', hs.mouseClickHandler);
    hs.addEventListener(document, 'mouseup', hs.mouseClickHandler);
    hs.addEventListener(document, 'ready', hs.setClickEvents);
    hs.addEventListener(window, 'load', hs.preloadImages);
    hs.addEventListener(window, 'load', hs.preloadAjax);
}
window.hs = hs;

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(3);
var generatedVarNameBootstrapTransition = __webpack_require__(387);

/* ========================================================================
 * Bootstrap: collapse.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#collapse
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

/* jshint latedef: false */

+function ($) {
  'use strict';

  // COLLAPSE PUBLIC CLASS DEFINITION
  // ================================

  var Collapse = function (element, options) {
    this.$element      = $(element)
    this.options       = $.extend({}, Collapse.DEFAULTS, options)
    this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
                           '[data-toggle="collapse"][data-target="#' + element.id + '"]')
    this.transitioning = null

    if (this.options.parent) {
      this.$parent = this.getParent()
    } else {
      this.addAriaAndCollapsedClass(this.$element, this.$trigger)
    }

    if (this.options.toggle) this.toggle()
  }

  Collapse.VERSION  = '3.4.1'

  Collapse.TRANSITION_DURATION = 350

  Collapse.DEFAULTS = {
    toggle: true
  }

  Collapse.prototype.dimension = function () {
    var hasWidth = this.$element.hasClass('width')
    return hasWidth ? 'width' : 'height'
  }

  Collapse.prototype.show = function () {
    if (this.transitioning || this.$element.hasClass('in')) return

    var activesData
    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')

    if (actives && actives.length) {
      activesData = actives.data('bs.collapse')
      if (activesData && activesData.transitioning) return
    }

    var startEvent = $.Event('show.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    if (actives && actives.length) {
      Plugin.call(actives, 'hide')
      activesData || actives.data('bs.collapse', null)
    }

    var dimension = this.dimension()

    this.$element
      .removeClass('collapse')
      .addClass('collapsing')[dimension](0)
      .attr('aria-expanded', true)

    this.$trigger
      .removeClass('collapsed')
      .attr('aria-expanded', true)

    this.transitioning = 1

    var complete = function () {
      this.$element
        .removeClass('collapsing')
        .addClass('collapse in')[dimension]('')
      this.transitioning = 0
      this.$element
        .trigger('shown.bs.collapse')
    }

    if (!$.support.transition) return complete.call(this)

    var scrollSize = $.camelCase(['scroll', dimension].join('-'))

    this.$element
      .one('bsTransitionEnd', $.proxy(complete, this))
      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
  }

  Collapse.prototype.hide = function () {
    if (this.transitioning || !this.$element.hasClass('in')) return

    var startEvent = $.Event('hide.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    var dimension = this.dimension()

    this.$element[dimension](this.$element[dimension]())[0].offsetHeight

    this.$element
      .addClass('collapsing')
      .removeClass('collapse in')
      .attr('aria-expanded', false)

    this.$trigger
      .addClass('collapsed')
      .attr('aria-expanded', false)

    this.transitioning = 1

    var complete = function () {
      this.transitioning = 0
      this.$element
        .removeClass('collapsing')
        .addClass('collapse')
        .trigger('hidden.bs.collapse')
    }

    if (!$.support.transition) return complete.call(this)

    this.$element
      [dimension](0)
      .one('bsTransitionEnd', $.proxy(complete, this))
      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
  }

  Collapse.prototype.toggle = function () {
    this[this.$element.hasClass('in') ? 'hide' : 'show']()
  }

  Collapse.prototype.getParent = function () {
    return $(document).find(this.options.parent)
      .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
      .each($.proxy(function (i, element) {
        var $element = $(element)
        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
      }, this))
      .end()
  }

  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
    var isOpen = $element.hasClass('in')

    $element.attr('aria-expanded', isOpen)
    $trigger
      .toggleClass('collapsed', !isOpen)
      .attr('aria-expanded', isOpen)
  }

  function getTargetFromTrigger($trigger) {
    var href
    var target = $trigger.attr('data-target')
      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7

    return $(document).find(target)
  }


  // COLLAPSE PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.collapse')
      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.collapse

  $.fn.collapse             = Plugin
  $.fn.collapse.Constructor = Collapse


  // COLLAPSE NO CONFLICT
  // ====================

  $.fn.collapse.noConflict = function () {
    $.fn.collapse = old
    return this
  }


  // COLLAPSE DATA-API
  // =================

  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
    var $this   = $(this)

    if (!$this.attr('data-target')) e.preventDefault()

    var $target = getTargetFromTrigger($this)
    var data    = $target.data('bs.collapse')
    var option  = data ? 'toggle' : $this.data()

    Plugin.call($target, option)
  })

}(jQuery);



/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(3);

/* ========================================================================
 * Bootstrap: transition.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#transitions
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // CSS TRANSITION SUPPORT (Shoutout: https://modernizr.com/)
  // ============================================================

  function transitionEnd() {
    var el = document.createElement('bootstrap')

    var transEndEventNames = {
      WebkitTransition : 'webkitTransitionEnd',
      MozTransition    : 'transitionend',
      OTransition      : 'oTransitionEnd otransitionend',
      transition       : 'transitionend'
    }

    for (var name in transEndEventNames) {
      if (el.style[name] !== undefined) {
        return { end: transEndEventNames[name] }
      }
    }

    return false // explicit for ie8 (  ._.)
  }

  // https://blog.alexmaccaw.com/css-transitions
  $.fn.emulateTransitionEnd = function (duration) {
    var called = false
    var $el = this
    $(this).one('bsTransitionEnd', function () { called = true })
    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
    setTimeout(callback, duration)
    return this
  }

  $(function () {
    $.support.transition = transitionEnd()

    if (!$.support.transition) return

    $.event.special.bsTransitionEnd = {
      bindType: $.support.transition.end,
      delegateType: $.support.transition.end,
      handle: function (e) {
        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
      }
    }
  })

}(jQuery);



/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function ($) {
	"use strict";

	var PLUGIN_NAME = "rowHeight";
	var PLUGIN_VERSION = "v1";

	var DEFAULTS = {
		selector: '',
		item: ''
	};

	// The actual plugin constructor
	var RowHeight = function RowHeight(element, options) {
		this.element = element;
		this.$t = $(this.element);

		this.options = $.extend(true, {}, DEFAULTS, options);
		this._defaults = DEFAULTS;
		this.initialise();
	};

	/**
  * init function
  */
	RowHeight.prototype.initialise = function () {

		this.containerWidth = 0;
		this.elementWidth = 0;
		this.elementWidth2 = 0;
		this.linesCount = 0;
		this.columnCount = 0;
		this.elementCount = 0;
		this.actHeight = 0;

		this.setRowHeight();
		this.bindEvents();

		this.resizeTimer = null;
	};

	RowHeight.prototype.setRowHeight = function () {
		var o = this.options;
		//var self = this;

		this.containerWidth = this.$t.width();
		if (this.containerWidth == 0) {
			return false;
		}
		this.elementCount = $(o.selector, this.$t).size();
		this.elementWidth = $(o.selector, this.$t).first().outerWidth(true);
		this.columnCount = Math.round(this.containerWidth / this.elementWidth);
		this.linesCount = Math.ceil(this.elementCount / this.columnCount);

		if ($(o.item, this.$t).size() > 0) {
			this.setHeight(o.item);
		}
		this.setHeight(o.selector);
	};

	RowHeight.prototype.setHeight = function (selector) {
		var self = this;
		$(selector, this.$t).css('height', 'auto');
		for (var i = 0; i < this.linesCount; i++) {
			this.actHeight = 0;

			for (var j = i * this.columnCount; j < i * this.columnCount + this.columnCount; j++) {
				this.actHeight = $(selector + ':eq(' + j + ')', this.$t).outerHeight() > this.actHeight ? $(selector + ':eq(' + j + ')', this.$t).outerHeight() : this.actHeight;
			}
			$(selector, this.$t).filter(function (index) {
				return index >= i * self.columnCount && index < i * self.columnCount + self.columnCount;
			}).outerHeight(self.actHeight);
		}
	};

	RowHeight.prototype.bindEvents = function () {
		var self = this;

		$(window).bind('resize.rowheightChange', function () {
			clearTimeout(self.resizeTimer);
			self.resizeTimer = setTimeout(function () {
				self.setRowHeight();
			}, 200);
		});
	};

	/**
  * decide, which methods will be "public"
  */
	var API = {
		setRowHeight: RowHeight.prototype.setRowHeight
	};

	/**
  * plugin go live
  * @param value - first param - decides, which action shall be executed
  * 		if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
  * 		if string && in API object - run method named as this value with all args[index > 0]
  * @return {*}
  */
	$.fn[PLUGIN_NAME] = function (value) {
		var args = arguments;

		return this.each(function () {
			var $this = $(this);
			// get plugin instance
			var plugin = $this.data('plugin_' + PLUGIN_NAME);

			// if there's not, create one
			if (!plugin) {
				plugin = new RowHeight(this, value);
				$this.data('plugin_' + PLUGIN_NAME, plugin);
			}
			// if there is and first parameter is in predefined API methods, call it with rest of params
			else if (API[value]) {
					plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
				}
		});
	};

	/**
  * setDefaults with $.googlemap.setDefaults();
  */
	$[PLUGIN_NAME] = $.fn[PLUGIN_NAME];
	$[PLUGIN_NAME].setDefaults = function (newOptions) {
		DEFAULTS = $.extend(true, {}, DEFAULTS, newOptions);
	};
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function ($) {
	"use strict";

	var PLUGIN_NAME = "rwdBackground";
	var PLUGIN_VERSION = "v01";

	var DEFAULTS = {
		selector: 'bg-rwd'
	};

	// The actual plugin constructor
	var RwdBackground = function RwdBackground(element, options) {

		this.element = element;
		this.$t = $(this.element);

		this.options = $.extend(true, {}, DEFAULTS, options);
		this._defaults = DEFAULTS;

		this.attrString = 'data-' + this.options.selector + '-';
		this.attrString2 = this.options.selector + '-';

		this.initialise();
	};

	/**
  * init function
  */
	RwdBackground.prototype.initialise = function () {

		this.getAttributes();
		this.setRwdBackground();
		this.bindEvents();

		this.resizeTimer = null;
	};

	RwdBackground.prototype.setRwdBackground = function () {

		var browserWidth = window.innerWidth;
		if (!this.$t || !this.$t.data('attributes')) {
			return false;
		}
		var arrayLength = this.$t.data('attributes').length;
		var attrStringLength;

		if (arrayLength == 0) {
			attrStringLength = this.attrString.length;
			this.$t.css('background-image', 'url(' + this.$t.attr(this.attrString.substr(0, attrStringLength - 1)) + ')');
		} else {
			for (var i = 0; i < arrayLength; i++) {
				if (browserWidth <= this.$t.data('attributes')[i]) {
					this.$t.css('background-image', 'url(' + this.$t.attr(this.attrString + this.$t.data('attributes')[i]) + ')');
					return false;
				}
				if (browserWidth >= this.$t.data('attributes')[i]) {
					attrStringLength = this.attrString.length;
					this.$t.css('background-image', 'url(' + this.$t.attr(this.attrString.substr(0, attrStringLength - 1)) + ')');
				}
				/*
    			if (this.$t.data('attributes')[i] >= browserWidth) {
    				this.$t.css('background-image', 'url(' + this.$t.attr(this.attrString+this.$t.data('attributes')[i]) + ')');
    				return false;
    			}
    			if (i == (arrayLength -1)&& browserWidth > this.$t.data('attributes')[i]) {
    				this.$t.css('background-image', 'url(' + this.$t.attr(this.attrString+this.$t.data('attributes')[i]) + ')');
    			};
    */
			}
		}
	};

	RwdBackground.prototype.getAttributes = function () {

		var attributes = [];
		var self = this;
		//var attributes = {};

		if (this.$t.length) {
			$.each(this.$t[0].attributes, function (index, attr) {
				//attributes[ attr.name ] = attr.value;
				if (attr.name.indexOf(self.attrString) == 0) {
					attributes.push(parseInt(attr.name.substring(self.attrString.length)));
				}
			});

			var sortedArray = attributes.sort(function (a, b) {
				return a - b;
			});

			this.$t.data('attributes', sortedArray);
		}
	};

	RwdBackground.prototype.bindEvents = function () {

		var self = this;

		$(window).bind('resize.rwd.background', function () {
			clearTimeout(self.resizeTimer);
			self.resizeTimer = setTimeout(function () {
				self.setRwdBackground();
			}, 200);
		});
	};

	/**
  * decide, which methods will be "public"
  */
	var API = {
		setRwdBackground: RwdBackground.prototype.setRwdBackground
	};

	/**
  * plugin go live
  * @param value - first param - decides, which action shall be executed
  * 		if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
  * 		if string && in API object - run method named as this value with all args[index > 0]
  * @return {*}
  */
	$.fn[PLUGIN_NAME] = function (value) {
		var args = arguments;

		return this.each(function () {
			var $this = $(this);
			// get plugin instance
			var plugin = $this.data('plugin_' + PLUGIN_NAME);

			// if there's not, create one
			if (!plugin) {
				plugin = new RwdBackground(this, value);
				$this.data('plugin_' + PLUGIN_NAME, plugin);
			}
			// if there is and first parameter is in predefined API methods, call it with rest of params
			else if (API[value]) {
					plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
				}
		});
	};

	/**
  * setDefaults with $.googlemap.setDefaults();
  */
	$[PLUGIN_NAME] = $.fn[PLUGIN_NAME];
	$[PLUGIN_NAME].setDefaults = function (newOptions) {
		DEFAULTS = $.extend(true, {}, DEFAULTS, newOptions);
	};
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var jQuery = __webpack_require__(3);

/**
 * jQuery Unveil
 * A very lightweight jQuery plugin to lazy load images
 * http://luis-almeida.github.com/unveil
 *
 * Licensed under the MIT license.
 * Copyright 2013 Luís Almeida
 * https://github.com/luis-almeida
 */

(function ($) {
	$.fn.unveil = function (threshold, callback) {
		var $w = $(window),
		    th = threshold || 0,
		    retina = window.devicePixelRatio > 1,
		    attrib = retina ? "data-src-retina" : "data-src",
		    images = this,
		    loaded;

		this.one("unveil", function () {
			var source = this.getAttribute(attrib);
			source = source || this.getAttribute("data-src");
			if (source) {
				this.setAttribute("src", source);
				if (typeof callback === "function") callback.call(this);
			}
		});

		function unveil() {
			var inview = images.filter(function () {
				var $e = $(this);
				if ($e.is(":hidden")) return;

				var wt = $w.scrollTop(),
				    wb = wt + $w.height(),
				    et = $e.offset().top,
				    eb = et + $e.height();

				return eb >= wt - th && et <= wb + th;
			});

			loaded = inview.trigger("unveil");
			images = images.not(loaded);
		}

		$w.on("scroll.unveil resize.unveil lookup.unveil", unveil);

		unveil();

		return this;
	};
})(jQuery);

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Google Map plugin for jQuery
 * author: Filip Hladík (FG Forrest, a.s.)
 * 	*******************************************************************************************************************
 * 3rd parties
 * 	- MarkerClusterer - https://google-maps-utility-library-v3.googlecode.com/svn/trunk/markerclusterer/docs/reference.html
 *
 * 	*******************************************************************************************************************
 * 	INITIAL USAGE: $('div.map').googlemap(SETTINGS);
 * 	*******************************************************************************************************************
 *
 * 	SETTINGS - { key: value, key2: value2, ...}
 *
 * 	width [integer] [DEFAULT null] - width of the map, in pixels.
 * 		- if not given, map inherits width from element, that the map plugin has been applied to
 *
 * 	height [integer] [DEFAULT null] - height of the map, in pixels
 * 		- if not given, same behavior as width
 *
 * 	mapOptions [object]
 * 	startingPosition : {	// [object] - set center of the map
 * 		{
 *			lat: x			// latitude - float
 *			lng: y			// longitude - float
 *			zoom: z			// zoom - integer
 * 		},
 * 		mapTypeControl:		true,			// [boolean] [DEFAULT true] - enables controls to change map type (ROADMAP, TERRAIN, etc...)
 * 		mapTypeId:  		'ROADMAP',		// [enum - HYBRID | TERRAIN | ROADMAP | SATELLITE] [DEFAULT ROADMAP] - type of initially loaded map
 * 		scaleControl:		true, 			// [boolean] [DEFAULT true] - enables layer with map scale information
 * 		panControl:			true,			// [boolean] [DEFAULT true] - enables controls to move map
 * 		streetViewControl:	true,			// [boolean] [DEFAULT true] - enables streetView
 * 		zoomControl:		true, 			// [boolean] [DEFAULT true] - enables controls to zoom the map
 * 		maxZoom:			x,				// [integer]
 * 		minZoom:			y,				// [integer]
 * 		scrollwheel:		true,			// [boolean] [DEFAULT true] - enables map zooming with mouse scroll
 * 		draggable:			true,			// [boolean] [DEFAULT true] - enables map panning
 * 		styles:				[]				// [array of objects] - style your map your way, based on https://developers.google.com/maps/tutorials/customizing/styling-the-base-map
 * 	}
 *
 * 	markerTypes [array of objects] - define your own icon styles
 * 	[{
 *		icon:	{
 *			url: '/path/to/image',
 *			size: new google.maps.Size(x, y),			// size of marker in px [x - width, y - height]
 *			origin: new google.maps.Point(x, y),		// position of marker image in sprite (if given) [x - position from the left, y - position from the top]
 *			anchor: new google.maps.Point(x, y)     	// tip of the marker [x - from the left, y - from the top]
 *		},
 *		shape:	{																// https://developers.google.com/maps/documentation/javascript/reference#MarkerShape
 *			coords:		[x1,y1,x2,y2] || [x, y, r] || [x1, y1, ... xn, yn],		// cordinates making the part of the marker clickable
 *			type:		'value'													// type of shape [ENUM - rect | circle | poly]
 *		}
 * 	}]
 *
 * 	showAllMarkersOnEmptyFilter [boolean] [DEFAULT true] - used when filtering, if true, all markers are displayed when filter is empty object
 *
 * 	clustering [object] - usage of MarkerClusterer
 * 	{
 *		enabled: false,			// self-explanatory
 *		mode: value,			// [enum - all | type] [DEFAULT all] - cluster all icons, icons by type, icons by collectionId
 *		groups: {
 *          group1: {
 *          	categories: [],	// array of markers type, which should be included in this cluster group
 *          	iconsStyles: []	// custom iconsStyles for this group
 *          }
 *		},
 *   	iconsStyles: [			// [array of objects] - custom cluster icons, there are 5 sizes of cluster icons, define them all, if you use this feature
 *			{
 *				anchor: [y, x],								// y - position of the number from the top, x - position of the number from the left
 *																- if any of these numbers is -1, the number is centered at that direction
 *				textColor: '#fff',							// color of the number on the groupped marker
 *				url: '/path/to/image',						// self-explanatory
 *				height: 50,									// height of the groupped marker
 *				width: 50,									// width of the groupped marker
 *				textSize: 12,								// font size of the number
 *				margin: '-25px 0 0 0'						// set the pointing tip of the marker, originaly is center of the marker.
 *																- this settings sets the pointing tip to the bottom of the marker (- half of height)
 *			}
 *   	],
 *   	maxZoom: x,											// level of zoom, where groupping of markers will not be applied
 *   	batchSize: x,                                       // number of markers that are processed in one batch
 *   	batchSizeIE: x,										// the same - IE
 *   	gridSize: x											// sets size of the box to cluster, default: 60px
 * 	}
 *
 * 	oneBubbleAtOnce: true									// [boolean] - if true, you can have only one marker infowindow displayed
 *
 * 	bubbleContentFormatter: function(mData) {				// [function] - set your custom function to format content of the infowindow
 *															//	- the only parameter given is markersData provided in loadMarkers method
 * 	}														//	- function must return STRING
 *
 *
 * 	*******************************************************************************************************************
 */

/**
 * CHANGELOG
 *
 * v3.0.0b
 * - Clustering revamped
 * 		- clustering of all generated markers into one clusterer (mode: all)
 * 		- clustering of all generated markers into clusterers by type (mode: type)
 * 		- NOT IMPLEMENTED YET - clustering of all generated markers into clusterers by collection (mode: collection)
 *
 *
 * 		- define custom clusterer groups - identified by categories {array} and iconsStyles {array of max 5 objects} - same structure as clustering.iconsStyles
 *
 * 	beta version - !! DO NOT USE CLUSTERING while loading markers with multiple "loadMarkers" method into multiple collections !!
 *
 * v2.2.6
 * - [METHOD] filterObjects
 * 		- NEW [CONFIG] - param.onMarkerSuccess: [function(marker), this refers to plugin instance]
 * 			- when marker successfully passes the filter, this function is executed
 *
 * v2.2.5
 * - NEW [METHOD] customMarkerAction
 * 		- call marker custom action from outside of plugin, marker is identified by markerId and collectionId
 * 		- usage
 * 		$('#map').googlemap('customMarkerAction', {
 * 		    markerId: [Integer],
 * 		    collectionId: [String], default 'default',
 * 		    execute: [function]
 * 		})
 * - internal - generated markers now contain reference to its infowindow object (can be used in customMarkerAction as marker.infowindow)
 *
 * v2.2.4
 * - zoomToMarkersBounds - fixed case, when offset == 0
 *
 * v2.2.3
 * - zoomToMarkersBounds hotfix
 *
 * v2.2.2
 * - [METHOD] loadMarkers
 * 		- NEW [CONFIG] - param.zoomToMarkersBounds: [number]
 * 			- after markers are rendered, map is trying to use maximum zoom as possible while all visible markers
 *			  are in bounds. Afterwards zoom is changed by zoomToMarkersBounds param
 *
 * v2.2.1
 * - [INTERNAL] complete markerData are added to generatedMarker in this._generatedMarkers - for later use (e.g. during manual call of the marker listener)
 *
 * v2.2.0
 * - NEW [METHOD] renderPrintVersionMap
 * 		- using google maps static - renders an image from actual map (with markers)
 * - NEW [METHOD] removeCustomMarkersByCollectionId
 * 		- self explanatory, removes customMarkers at once - identified by collectionId
 * - [METHOD] setCenterAndZoom
 * 		- NEW [CONFIG] - param.position - map is centered according to the given latitude and longitude parameters, afterwards
 * 		  center is panned to position relative to map size [x, y] - x, y are numbers between 0 - 1
 * - NEW [CONFIG]
 * 		- draggable
 * 		- styles
 */

var $ = __webpack_require__(3);

"use strict";

function ClusterIcon(e, t) {
	e.getMarkerClusterer().extend(ClusterIcon, google.maps.OverlayView);this.cluster_ = e;this.className_ = e.getMarkerClusterer().getClusterClass();this.styles_ = t;this.center_ = null;this.div_ = null;this.sums_ = null;this.visible_ = false;this.setMap(e.getMap());
}function Cluster(e) {
	this.markerClusterer_ = e;this.map_ = e.getMap();this.gridSize_ = e.getGridSize();this.minClusterSize_ = e.getMinimumClusterSize();this.averageCenter_ = e.getAverageCenter();this.printable_ = e.getPrintable();this.markers_ = [];this.center_ = null;this.bounds_ = null;this.clusterIcon_ = new ClusterIcon(this, e.getStyles());
}function MarkerClusterer(e, t, n) {
	this.extend(MarkerClusterer, google.maps.OverlayView);t = t || [];n = n || {};this.markers_ = [];this.clusters_ = [];this.listeners_ = [];this.activeMap_ = null;this.ready_ = false;this.gridSize_ = n.gridSize || 60;this.minClusterSize_ = n.minimumClusterSize || 2;this.maxZoom_ = n.maxZoom || null;this.styles_ = n.styles || [];this.title_ = n.title || "";this.zoomOnClick_ = true;if (n.zoomOnClick !== undefined) {
		this.zoomOnClick_ = n.zoomOnClick;
	}this.averageCenter_ = false;if (n.averageCenter !== undefined) {
		this.averageCenter_ = n.averageCenter;
	}this.ignoreHidden_ = false;if (n.ignoreHidden !== undefined) {
		this.ignoreHidden_ = n.ignoreHidden;
	}this.printable_ = false;if (n.printable !== undefined) {
		this.printable_ = n.printable;
	}this.imagePath_ = n.imagePath || MarkerClusterer.IMAGE_PATH;this.imageExtension_ = n.imageExtension || MarkerClusterer.IMAGE_EXTENSION;this.imageSizes_ = n.imageSizes || MarkerClusterer.IMAGE_SIZES;this.calculator_ = n.calculator || MarkerClusterer.CALCULATOR;this.batchSize_ = n.batchSize || MarkerClusterer.BATCH_SIZE;this.batchSizeIE_ = n.batchSizeIE || MarkerClusterer.BATCH_SIZE_IE;this.clusterClass_ = n.clusterClass || "cluster";if (navigator.userAgent.toLowerCase().indexOf("msie") !== -1) {
		this.batchSize_ = this.batchSizeIE_;
	}this.setupStyles_();this.addMarkers(t, true);this.setMap(e);
}ClusterIcon.prototype.onAdd = function () {
	var e = this;var t;var n;this.div_ = document.createElement("div");this.div_.className = this.className_;if (this.visible_) {
		this.show();
	}this.getPanes().overlayMouseTarget.appendChild(this.div_);google.maps.event.addListener(this.getMap(), "bounds_changed", function () {
		n = t;
	});google.maps.event.addDomListener(this.div_, "mousedown", function () {
		t = true;n = false;
	});google.maps.event.addDomListener(this.div_, "click", function (r) {
		t = false;if (!n) {
			var i;var s;var o = e.cluster_.getMarkerClusterer();google.maps.event.trigger(o, "click", e.cluster_);google.maps.event.trigger(o, "clusterclick", e.cluster_);if (o.getZoomOnClick()) {
				s = o.getMaxZoom();i = e.cluster_.getBounds();o.getMap().fitBounds(i);setTimeout(function () {
					o.getMap().fitBounds(i);if (s !== null && o.getMap().getZoom() > s) {
						o.getMap().setZoom(s + 1);
					}
				}, 100);
			}r.cancelBubble = true;if (r.stopPropagation) {
				r.stopPropagation();
			}
		}
	});google.maps.event.addDomListener(this.div_, "mouseover", function () {
		var t = e.cluster_.getMarkerClusterer();google.maps.event.trigger(t, "mouseover", e.cluster_);
	});google.maps.event.addDomListener(this.div_, "mouseout", function () {
		var t = e.cluster_.getMarkerClusterer();google.maps.event.trigger(t, "mouseout", e.cluster_);
	});
};ClusterIcon.prototype.onRemove = function () {
	if (this.div_ && this.div_.parentNode) {
		this.hide();google.maps.event.clearInstanceListeners(this.div_);this.div_.parentNode.removeChild(this.div_);this.div_ = null;
	}
};ClusterIcon.prototype.draw = function () {
	if (this.visible_) {
		var e = this.getPosFromLatLng_(this.center_);this.div_.style.top = e.y + "px";this.div_.style.left = e.x + "px";
	}
};ClusterIcon.prototype.hide = function () {
	if (this.div_) {
		this.div_.style.display = "none";
	}this.visible_ = false;
};ClusterIcon.prototype.show = function () {
	if (this.div_) {
		var e = this.getPosFromLatLng_(this.center_);this.div_.style.cssText = this.createCss(e);if (this.cluster_.printable_) {
			this.div_.innerHTML = "<img src='" + this.url_ + "'><div style='position: absolute; top: 0px; left: 0px; width: " + this.width_ + "px;'>" + this.sums_.text + "</div>";
		} else {
			this.div_.innerHTML = this.sums_.text;
		}if (typeof this.sums_.title === "undefined" || this.sums_.title === "") {
			this.div_.title = this.cluster_.getMarkerClusterer().getTitle();
		} else {
			this.div_.title = this.sums_.title;
		}this.div_.style.display = "";
	}this.visible_ = true;
};ClusterIcon.prototype.useStyle = function (e) {
	this.sums_ = e;var t = Math.max(0, e.index - 1);t = Math.min(this.styles_.length - 1, t);var n = this.styles_[t];this.url_ = n.url;this.height_ = n.height;this.width_ = n.width;this.anchor_ = n.anchor;this.anchorIcon_ = n.anchorIcon || [parseInt(this.height_ / 2, 10), parseInt(this.width_ / 2, 10)];this.textColor_ = n.textColor || "black";this.textSize_ = n.textSize || 11;this.textDecoration_ = n.textDecoration || "none";this.fontWeight_ = n.fontWeight || "bold";this.fontStyle_ = n.fontStyle || "normal";this.fontFamily_ = n.fontFamily || "Arial,sans-serif";this.backgroundPosition_ = n.backgroundPosition || "0 0";this.margin_ = n.margin || "0";
};ClusterIcon.prototype.setCenter = function (e) {
	this.center_ = e;
};ClusterIcon.prototype.createCss = function (e) {
	var t = [];if (!this.cluster_.printable_) {
		t.push("background-image:url(" + this.url_ + ");");t.push("background-position:" + this.backgroundPosition_ + ";");
	}if (_typeof(this.anchor_) === "object") {
		if (typeof this.anchor_[0] === "number" && this.anchor_[0] >= 0 && this.anchor_[0] < this.height_) {
			t.push("height:" + (this.height_ - this.anchor_[0]) + "px; padding-top:" + this.anchor_[0] + "px;");
		} else {
			t.push("height:" + this.height_ + "px; line-height:" + this.height_ + "px;");
		}if (typeof this.anchor_[1] === "number" && this.anchor_[1] >= 0 && this.anchor_[1] < this.width_) {
			t.push("width:" + (this.width_ - this.anchor_[1]) + "px; padding-left:" + this.anchor_[1] + "px;");
		} else {
			t.push("width:" + this.width_ + "px; text-align:center;");
		}
	} else {
		t.push("height:" + this.height_ + "px; line-height:" + this.height_ + "px; width:" + this.width_ + "px; text-align:center;");
	}t.push("cursor:pointer; color:" + this.textColor_ + "; position:absolute; font-size:" + this.textSize_ + "px; font-family:" + this.fontFamily_ + "; font-weight:" + this.fontWeight_ + "; font-style:" + this.fontStyle_ + "; text-decoration:" + this.textDecoration_ + "; margin:" + this.margin_ + ";");return t.join("");
};ClusterIcon.prototype.getPosFromLatLng_ = function (e) {
	var t = this.getProjection().fromLatLngToDivPixel(e);t.x -= this.anchorIcon_[1];t.y -= this.anchorIcon_[0];return t;
};Cluster.prototype.getSize = function () {
	return this.markers_.length;
};Cluster.prototype.getMarkers = function () {
	return this.markers_;
};Cluster.prototype.getCenter = function () {
	return this.center_;
};Cluster.prototype.getMap = function () {
	return this.map_;
};Cluster.prototype.getMarkerClusterer = function () {
	return this.markerClusterer_;
};Cluster.prototype.getBounds = function () {
	var e;var t = new google.maps.LatLngBounds(this.center_, this.center_);var n = this.getMarkers();for (e = 0; e < n.length; e++) {
		t.extend(n[e].getPosition());
	}return t;
};Cluster.prototype.remove = function () {
	this.clusterIcon_.setMap(null);this.markers_ = [];delete this.markers_;
};Cluster.prototype.addMarker = function (e) {
	var t;var n;var r;if (this.isMarkerAlreadyAdded_(e)) {
		return false;
	}if (!this.center_) {
		this.center_ = e.getPosition();this.calculateBounds_();
	} else {
		if (this.averageCenter_) {
			var i = this.markers_.length + 1;var s = (this.center_.lat() * (i - 1) + e.getPosition().lat()) / i;var o = (this.center_.lng() * (i - 1) + e.getPosition().lng()) / i;this.center_ = new google.maps.LatLng(s, o);this.calculateBounds_();
		}
	}e.isAdded = true;this.markers_.push(e);n = this.markers_.length;r = this.markerClusterer_.getMaxZoom();if (r !== null && this.map_.getZoom() > r) {
		if (e.getMap() !== this.map_) {
			e.setMap(this.map_);
		}
	} else if (n < this.minClusterSize_) {
		if (e.getMap() !== this.map_) {
			e.setMap(this.map_);
		}
	} else if (n === this.minClusterSize_) {
		for (t = 0; t < n; t++) {
			this.markers_[t].setMap(null);
		}
	} else {
		e.setMap(null);
	}this.updateIcon_();return true;
};Cluster.prototype.isMarkerInClusterBounds = function (e) {
	return this.bounds_.contains(e.getPosition());
};Cluster.prototype.calculateBounds_ = function () {
	var e = new google.maps.LatLngBounds(this.center_, this.center_);this.bounds_ = this.markerClusterer_.getExtendedBounds(e);
};Cluster.prototype.updateIcon_ = function () {
	var e = this.markers_.length;var t = this.markerClusterer_.getMaxZoom();if (t !== null && this.map_.getZoom() > t) {
		this.clusterIcon_.hide();return;
	}if (e < this.minClusterSize_) {
		this.clusterIcon_.hide();return;
	}var n = this.markerClusterer_.getStyles().length;var r = this.markerClusterer_.getCalculator()(this.markers_, n);this.clusterIcon_.setCenter(this.center_);this.clusterIcon_.useStyle(r);this.clusterIcon_.show();
};Cluster.prototype.isMarkerAlreadyAdded_ = function (e) {
	var t;if (this.markers_.indexOf) {
		return this.markers_.indexOf(e) !== -1;
	} else {
		for (t = 0; t < this.markers_.length; t++) {
			if (e === this.markers_[t]) {
				return true;
			}
		}
	}return false;
};MarkerClusterer.prototype.onAdd = function () {
	var e = this;this.activeMap_ = this.getMap();this.ready_ = true;this.repaint();this.listeners_ = [google.maps.event.addListener(this.getMap(), "zoom_changed", function () {
		e.resetViewport_(false);if (this.getZoom() === (this.get("minZoom") || 0) || this.getZoom() === this.get("maxZoom")) {
			google.maps.event.trigger(this, "idle");
		}
	}), google.maps.event.addListener(this.getMap(), "idle", function () {
		e.redraw_();
	})];
};MarkerClusterer.prototype.onRemove = function () {
	var e;for (e = 0; e < this.markers_.length; e++) {
		if (this.markers_[e].getMap() !== this.activeMap_) {
			this.markers_[e].setMap(this.activeMap_);
		}
	}for (e = 0; e < this.clusters_.length; e++) {
		this.clusters_[e].remove();
	}this.clusters_ = [];for (e = 0; e < this.listeners_.length; e++) {
		google.maps.event.removeListener(this.listeners_[e]);
	}this.listeners_ = [];this.activeMap_ = null;this.ready_ = false;
};MarkerClusterer.prototype.draw = function () {};MarkerClusterer.prototype.setupStyles_ = function () {
	var e, t, n;if (this.styles_.length > 0) {
		return;
	}for (e = 0; e < this.imageSizes_.length; e++) {
		t = this.imageSizes_[e][0];n = this.imageSizes_[e][1];this.styles_.push({ url: this.imagePath_ + (e + 1) + "." + this.imageExtension_, height: n, width: t });
	}
};MarkerClusterer.prototype.fitMapToMarkers = function () {
	var e;var t = this.getMarkers();var n = new google.maps.LatLngBounds();for (e = 0; e < t.length; e++) {
		n.extend(t[e].getPosition());
	}this.getMap().fitBounds(n);
};MarkerClusterer.prototype.getGridSize = function () {
	return this.gridSize_;
};MarkerClusterer.prototype.setGridSize = function (e) {
	this.gridSize_ = e;
};MarkerClusterer.prototype.getMinimumClusterSize = function () {
	return this.minClusterSize_;
};MarkerClusterer.prototype.setMinimumClusterSize = function (e) {
	this.minClusterSize_ = e;
};MarkerClusterer.prototype.getMaxZoom = function () {
	return this.maxZoom_;
};MarkerClusterer.prototype.setMaxZoom = function (e) {
	this.maxZoom_ = e;
};MarkerClusterer.prototype.getStyles = function () {
	return this.styles_;
};MarkerClusterer.prototype.setStyles = function (e) {
	this.styles_ = e;
};MarkerClusterer.prototype.getTitle = function () {
	return this.title_;
};MarkerClusterer.prototype.setTitle = function (e) {
	this.title_ = e;
};MarkerClusterer.prototype.getZoomOnClick = function () {
	return this.zoomOnClick_;
};MarkerClusterer.prototype.setZoomOnClick = function (e) {
	this.zoomOnClick_ = e;
};MarkerClusterer.prototype.getAverageCenter = function () {
	return this.averageCenter_;
};MarkerClusterer.prototype.setAverageCenter = function (e) {
	this.averageCenter_ = e;
};MarkerClusterer.prototype.getIgnoreHidden = function () {
	return this.ignoreHidden_;
};MarkerClusterer.prototype.setIgnoreHidden = function (e) {
	this.ignoreHidden_ = e;
};MarkerClusterer.prototype.getImageExtension = function () {
	return this.imageExtension_;
};MarkerClusterer.prototype.setImageExtension = function (e) {
	this.imageExtension_ = e;
};MarkerClusterer.prototype.getImagePath = function () {
	return this.imagePath_;
};MarkerClusterer.prototype.setImagePath = function (e) {
	this.imagePath_ = e;
};MarkerClusterer.prototype.getImageSizes = function () {
	return this.imageSizes_;
};MarkerClusterer.prototype.setImageSizes = function (e) {
	this.imageSizes_ = e;
};MarkerClusterer.prototype.getCalculator = function () {
	return this.calculator_;
};MarkerClusterer.prototype.setCalculator = function (e) {
	this.calculator_ = e;
};MarkerClusterer.prototype.getPrintable = function () {
	return this.printable_;
};MarkerClusterer.prototype.setPrintable = function (e) {
	this.printable_ = e;
};MarkerClusterer.prototype.getBatchSizeIE = function () {
	return this.batchSizeIE_;
};MarkerClusterer.prototype.setBatchSizeIE = function (e) {
	this.batchSizeIE_ = e;
};MarkerClusterer.prototype.getClusterClass = function () {
	return this.clusterClass_;
};MarkerClusterer.prototype.setClusterClass = function (e) {
	this.clusterClass_ = e;
};MarkerClusterer.prototype.getMarkers = function () {
	return this.markers_;
};MarkerClusterer.prototype.getTotalMarkers = function () {
	return this.markers_.length;
};MarkerClusterer.prototype.getClusters = function () {
	return this.clusters_;
};MarkerClusterer.prototype.getTotalClusters = function () {
	return this.clusters_.length;
};MarkerClusterer.prototype.addMarker = function (e, t) {
	this.pushMarkerTo_(e);if (!t) {
		this.redraw_();
	}
};MarkerClusterer.prototype.addMarkers = function (e, t) {
	var n;for (n = 0; n < e.length; n++) {
		this.pushMarkerTo_(e[n]);
	}if (!t) {
		this.redraw_();
	}
};MarkerClusterer.prototype.pushMarkerTo_ = function (e) {
	if (e.getDraggable()) {
		var t = this;google.maps.event.addListener(e, "dragend", function () {
			if (t.ready_) {
				this.isAdded = false;t.repaint();
			}
		});
	}e.isAdded = false;this.markers_.push(e);
};MarkerClusterer.prototype.removeMarker = function (e, t) {
	var n = this.removeMarker_(e);if (!t && n) {
		this.repaint();
	}return n;
};MarkerClusterer.prototype.removeMarkers = function (e, t) {
	var n, r;var i = false;for (n = 0; n < e.length; n++) {
		r = this.removeMarker_(e[n]);i = i || r;
	}if (!t && i) {
		this.repaint();
	}return i;
};MarkerClusterer.prototype.removeMarker_ = function (e) {
	var t;var n = -1;if (this.markers_.indexOf) {
		n = this.markers_.indexOf(e);
	} else {
		for (t = 0; t < this.markers_.length; t++) {
			if (e === this.markers_[t]) {
				n = t;break;
			}
		}
	}if (n === -1) {
		return false;
	}e.setMap(null);this.markers_.splice(n, 1);return true;
};MarkerClusterer.prototype.clearMarkers = function () {
	this.resetViewport_(true);this.markers_ = [];
};MarkerClusterer.prototype.repaint = function () {
	var e = this.clusters_.slice();this.clusters_ = [];this.resetViewport_(false);this.redraw_();setTimeout(function () {
		var t;for (t = 0; t < e.length; t++) {
			e[t].remove();
		}
	}, 0);
};MarkerClusterer.prototype.getExtendedBounds = function (e) {
	var t = this.getProjection();var n = new google.maps.LatLng(e.getNorthEast().lat(), e.getNorthEast().lng());var r = new google.maps.LatLng(e.getSouthWest().lat(), e.getSouthWest().lng());var i = t.fromLatLngToDivPixel(n);i.x += this.gridSize_;i.y -= this.gridSize_;var s = t.fromLatLngToDivPixel(r);s.x -= this.gridSize_;s.y += this.gridSize_;var o = t.fromDivPixelToLatLng(i);var u = t.fromDivPixelToLatLng(s);e.extend(o);e.extend(u);return e;
};MarkerClusterer.prototype.redraw_ = function () {
	this.createClusters_(0);
};MarkerClusterer.prototype.resetViewport_ = function (e) {
	var t, n;for (t = 0; t < this.clusters_.length; t++) {
		this.clusters_[t].remove();
	}this.clusters_ = [];for (t = 0; t < this.markers_.length; t++) {
		n = this.markers_[t];n.isAdded = false;if (e) {
			n.setMap(null);
		}
	}
};MarkerClusterer.prototype.distanceBetweenPoints_ = function (e, t) {
	var n = 6371;var r = (t.lat() - e.lat()) * Math.PI / 180;var i = (t.lng() - e.lng()) * Math.PI / 180;var s = Math.sin(r / 2) * Math.sin(r / 2) + Math.cos(e.lat() * Math.PI / 180) * Math.cos(t.lat() * Math.PI / 180) * Math.sin(i / 2) * Math.sin(i / 2);var o = 2 * Math.atan2(Math.sqrt(s), Math.sqrt(1 - s));var u = n * o;return u;
};MarkerClusterer.prototype.isMarkerInBounds_ = function (e, t) {
	return t.contains(e.getPosition());
};MarkerClusterer.prototype.addToClosestCluster_ = function (e) {
	var t, n, r, i;var s = 4e4;var o = null;for (t = 0; t < this.clusters_.length; t++) {
		r = this.clusters_[t];i = r.getCenter();if (i) {
			n = this.distanceBetweenPoints_(i, e.getPosition());if (n < s) {
				s = n;o = r;
			}
		}
	}if (o && o.isMarkerInClusterBounds(e)) {
		o.addMarker(e);
	} else {
		r = new Cluster(this);r.addMarker(e);this.clusters_.push(r);
	}
};MarkerClusterer.prototype.createClusters_ = function (e) {
	var t, n;var r;var i = this;if (!this.ready_) {
		return;
	}if (e === 0) {
		google.maps.event.trigger(this, "clusteringbegin", this);if (typeof this.timerRefStatic !== "undefined") {
			clearTimeout(this.timerRefStatic);delete this.timerRefStatic;
		}
	}if (this.getMap().getZoom() > 3) {
		r = new google.maps.LatLngBounds(this.getMap().getBounds().getSouthWest(), this.getMap().getBounds().getNorthEast());
	} else {
		r = new google.maps.LatLngBounds(new google.maps.LatLng(85.02070771743472, -178.48388434375), new google.maps.LatLng(-85.08136444384544, 178.00048865625));
	}var s = this.getExtendedBounds(r);var o = Math.min(e + this.batchSize_, this.markers_.length);for (t = e; t < o; t++) {
		n = this.markers_[t];if (!n.isAdded && this.isMarkerInBounds_(n, s)) {
			if (!this.ignoreHidden_ || this.ignoreHidden_ && n.getVisible()) {
				this.addToClosestCluster_(n);
			}
		}
	}if (o < this.markers_.length) {
		this.timerRefStatic = setTimeout(function () {
			i.createClusters_(o);
		}, 0);
	} else {
		delete this.timerRefStatic;google.maps.event.trigger(this, "clusteringend", this);
	}
};MarkerClusterer.prototype.extend = function (e, t) {
	return function (e) {
		var t;for (t in e.prototype) {
			this.prototype[t] = e.prototype[t];
		}return this;
	}.apply(e, [t]);
};MarkerClusterer.CALCULATOR = function (e, t) {
	var n = 0;var r = "";var i = e.length.toString();var s = i;while (s !== 0) {
		s = parseInt(s / 10, 10);n++;
	}n = Math.min(n, t);return { text: i, index: n, title: r };
};MarkerClusterer.BATCH_SIZE = 2e3;MarkerClusterer.BATCH_SIZE_IE = 500;MarkerClusterer.IMAGE_PATH = "http://google-maps-utility-library-v3.googlecode.com/svn/trunk/markerclustererplus/images/m";MarkerClusterer.IMAGE_EXTENSION = "png";MarkerClusterer.IMAGE_SIZES = [[53, 53], [56, 56], [66, 66], [78, 78], [90, 90]];

var MAP_TYPE = {
	HYBRID: google.maps.MapTypeId.HYBRID,
	TERRAIN: google.maps.MapTypeId.TERRAIN,
	ROADMAP: google.maps.MapTypeId.ROADMAP,
	SATELLITE: google.maps.MapTypeId.SATELLITE
};

var PLUGIN_NAME = "googlemap";
var PLUGIN_VERSION = "v3.0.0b";

var DEFAULTS = {
	width: null,
	height: null,
	mapOptions: {
		startingPosition: {
			lat: 49.773811,
			lng: 15.771272,
			zoom: 7
		},
		mapTypeControl: true,
		mapTypeId: MAP_TYPE.ROADMAP,
		scaleControl: true,
		panControl: true,
		streetViewControl: true,
		zoomControl: true,
		maxZoom: null,
		minZoom: null,
		scrollwheel: true,
		draggable: true,
		styles: []
	},
	markerTypes: [],
	showAllMarkersOnEmptyFilter: true,
	clustering: {
		enabled: false,
		mode: 'all',
		groups: {},
		iconsStyles: [],
		maxZoom: null,
		batchSize: 2000,
		batchSizeIE: 500,
		gridSize: 60
	},
	oneBubbleAtOnce: true,
	bubbleContentFormatter: function bubbleContentFormatter(mData) {
		var str = '';
		if (mData.title) {
			str += '<h3>' + mData.title + '</h3>';
		}

		return str;
	},
	print: {
		selector: null,
		apiUrl: 'https://maps.googleapis.com/maps/api/staticmap?',
		customZoom: 10,
		size: '640x380'
	}
};

/**
 *
 * @param element
 * @param options
 * @constructor
 */
var GoogleMap = function GoogleMap(element, options) {
	this.element = element;

	this.options = $.extend(true, {}, DEFAULTS, options);
	this._defaults = DEFAULTS;
	this._initialise();
};

/**
 * Init function - run this on init (builds basic map and sets basic internal variables)
 * @private
 */
GoogleMap.prototype._initialise = function () {
	var o = this.options;

	// set given height, width ... if not given, dimensions will be taken from CSS
	if (o.width && o.height) {
		$(this.element).css({
			'width': o.width + 'px',
			'height': o.height + 'px'
		});
	}
	google.maps.visualRefresh = false;
	this._buildMap();
	// markers
	this._markersData = [];
	this._generatedMarkers = [];
	this._customMarkers = [];

	// clustering
	this._clusterers = {};
	this._clustererGroups = {};

	// shapes
	this._shapesData = [];
	this._generatedShapes = [];

	// common to shapes and markers
	this._generatedInfoWindows = [];

	// other
	this._mapListeners = [];
	this._kmlLayers = [];
	this._generatedPaths = [];
};

/**
 * Support function - gets and returns size of the given object {obj}
 * @param {object} obj
 * @returns {number}
 * @private
 */
GoogleMap.prototype._getObjectLength = function (obj) {
	var cnt = 0;
	for (var x in obj) {
		if (obj.hasOwnProperty(x)) {
			cnt++;
		}
	}
	return cnt;
};

/**
 * Renders basic map with given options
 * @private
 */
GoogleMap.prototype._buildMap = function () {
	var o = this.options;
	this._gmap = new google.maps.Map(this.element, {
		zoom: o.mapOptions.startingPosition.zoom,
		center: new google.maps.LatLng(o.mapOptions.startingPosition.lat, o.mapOptions.startingPosition.lng),
		mapTypeControl: o.mapOptions.mapTypeControl,
		mapTypeId: MAP_TYPE[o.mapOptions.mapTypeId] || o.mapOptions.mapTypeId,
		scaleControl: o.mapOptions.scaleControl,
		panControl: o.mapOptions.panControl,
		streetViewControl: o.mapOptions.streetViewControl,
		zoomControl: o.mapOptions.zoomControl,
		maxZoom: o.mapOptions.maxZoom,
		minZoom: o.mapOptions.minZoom,
		scrollwheel: o.mapOptions.scrollwheel,
		draggable: o.mapOptions.draggable,
		styles: o.mapOptions.styles
	});
};

/**
 * loads data to this._markersData[collectionId] and executes callback, if given
 * @param {object} params 			- object with:
 *
 * common
 * 	collectionId {string} 			- load and store data into this collection
 * 	callback {function}				- execute callback after data is loaded
 *
 * loading data via array
 * 	data {array of objects} 		- data for markers [{id, lat, lng, title, ...}]
 *
 * loading data via ajax
 * 	dataUrl {string} 				- ajax url to get data (JSON)
 * 	postData {object}				- data passed to JSON request
 * 	dataSetname {string} 			- level 1 key of JSON response
 */
GoogleMap.prototype.loadMarkers = function (params) {
	var _self = this;
	var collectionId = params.collectionId || 'default';
	var filter = params.initialFilter || {};
	var fulltextFilter = params.initialFulltextFilter || {};
	var postData = params.postData || {};
	var listeners = params.listeners || null;
	this.clearMapObjectsAndInfoWindows('markers', collectionId);

	// load data via ajax
	if (params.dataUrl) {

		var dataSetName = params.dataSetName || 'markers';

		$.getJSON(params.dataUrl, postData, function (dt) {
			if (dt && dt[dataSetName].length > 0) {
				_self._markersData[collectionId] = dt[dataSetName].slice(0);
				if (typeof params.render == "undefined" || params.render) {
					_self._processMarkers({
						collectionId: collectionId,
						initialFilter: filter,
						initialFulltextFilter: fulltextFilter,
						listeners: listeners
					});
				}
			}
			_self.zoomToMarkersBounds(_typeof(params.zoomToMarkersBounds) !== undefined ? params.zoomToMarkersBounds : null);

			if ($.isFunction(params.callback)) {
				params.callback.call(_self);
			}
		});
	}
	// load data from given array {params.data}
	else if ($.isArray(params.data)) {
			this._markersData[collectionId] = params.data.slice(0);

			if (typeof params.render == "undefined" || params.render) {
				this._processMarkers({
					collectionId: collectionId,
					initialFilter: filter,
					initialFulltextFilter: fulltextFilter,
					listeners: listeners
				});
			}
			_self.zoomToMarkersBounds(_typeof(params.zoomToMarkersBounds) !== undefined ? params.zoomToMarkersBounds : null);

			if ($.isFunction(params.callback)) {
				params.callback.call(_self);
			}
		}
};

/**
 * Process given collection of markers, applies clustering, if enabled and applies initial filtering
 * @param {object} params
 *	collectionId {string} - render only markers within this collection. If null, render all collections
 * 	initialFilter {object} - object of properties rules, which are applied to rendered marker - if it is visible or not
 * 	initialFulltextFilter {object}
 * 	listeners {object}
 * @private
 */
GoogleMap.prototype._processMarkers = function (params) {
	var o = this.options;

	if (params.collectionId && $.isArray(this._markersData[params.collectionId])) {
		this._renderMarker(params.collectionId, this._markersData[params.collectionId], params.listeners);
	} else {
		for (var collection in this._markersData) {
			if (this._markersData.hasOwnProperty(collection)) {
				this._renderMarker(collection, this._markersData[collection], params.listeners);
			}
		}
	}

	if (o.clustering.enabled) {
		this._createMarkerClusters(true);
	}

	if (this._getObjectLength(params.initialFilter) > 0 || this._getObjectLength(params.initialFulltextFilter)) {
		this.filterObjects('markers', params.initialFilter, params.initialFulltextFilter);
	}
};

/**
 * Renders single marker, binds custom or default action to itself and stores itself into this._generatedMarkers
 * @param collectionId
 * @param markersData
 * @param listeners
 * @returns {boolean}
 * @private
 */
GoogleMap.prototype._renderMarker = function (collectionId, markersData, listeners) {
	var o = this.options;
	var self = this;
	var bubbleContent = '';
	var marker, infowindow;

	for (var i = 0; i < markersData.length; i++) {

		if ($.isFunction(o.bubbleContentFormatter)) {
			bubbleContent = o.bubbleContentFormatter(markersData[i]);
		}

		marker = new google.maps.Marker({
			id: markersData[i].id,
			position: new google.maps.LatLng(markersData[i].lat, markersData[i].lng),
			container: this.element,
			map: this._gmap,
			title: markersData[i].title,
			cursor: bubbleContent && bubbleContent != "" ? 'pointer' : 'default',
			type: markersData[i].type,
			visible: o.showAllMarkersOnEmptyFilter && this._getObjectLength(o.initialFilter) == 0,
			filter: markersData[i].filter,
			fulltextData: markersData[i].fulltextData,
			collectionId: collectionId, // internal fallback
			collection: collectionId, // used by clustering
			icon: o.markerTypes.length > 0 && _typeof(o.markerTypes[markersData[i].type]) == "object" ? o.markerTypes[markersData[i].type].icon : null,
			shape: o.markerTypes.length > 0 && _typeof(o.markerTypes[markersData[i].type]) == "object" ? o.markerTypes[markersData[i].type].shape : null,
			objectType: 'marker',
			markerData: markersData[i]
		});

		if (listeners) {
			for (var listener in listeners) {
				if (listeners.hasOwnProperty(listener)) {
					this.processMarkersCustomAction(marker, listener, listeners[listener], markersData[i]);
				}
			}
		} else {
			if (bubbleContent && bubbleContent != "") {
				infowindow = this.createInfowindow(marker, bubbleContent, collectionId);
				this._generatedInfoWindows.push(infowindow);
			}
		}

		this._generatedMarkers.push(marker);
	}

	return true;
};

GoogleMap.prototype.createInfowindow = function (object, bubbleContent, collectionId) {
	var infowindow;
	var self = this;
	var o = this.options;
	infowindow = new google.maps.InfoWindow({
		content: bubbleContent
	});

	infowindow.collectionId = collectionId;
	object.infowindow = infowindow;

	google.maps.event.addListener(object, 'click', function (event) {
		if (o.oneBubbleAtOnce) {
			self.closeInfoWindows();
		}
		if (object.objectType == 'shape') {
			infowindow.setPosition(event.latLng);
			infowindow.open(self._gmap);
		} else {
			infowindow.open(self._gmap, object);
		}
	});

	return infowindow;
};

GoogleMap.prototype.processMarkersCustomAction = function (marker, listenerType, listenerAction, markersData) {
	var self = this;
	google.maps.event.addListener(marker, listenerType, function (event) {
		listenerAction.call(self, event, markersData, marker);
	});
};

GoogleMap.prototype.zoomToMarkersBounds = function (offset) {
	if (offset == null) return false;

	var _self = this;
	// perform zoom and remove itself
	var performOffsetZoom = function performOffsetZoom() {
		_self._gmap.setZoom(_self._gmap.getZoom() + offset);
		google.maps.event.removeListener(offsetZoomListener);
	};
	var offsetZoomListener = google.maps.event.addListener(_self._gmap, 'idle', performOffsetZoom);

	var bounds = new google.maps.LatLngBounds();

	for (var i = 0; i < this._generatedMarkers.length; i++) {

		if (this._generatedMarkers[i].getVisible()) {
			bounds.extend(this._generatedMarkers[i].position);
		}
	}

	this._gmap.fitBounds(bounds);

	return true;
};

/**
 * place custom marker with options in params
 * @param params
 * - id
 * - latitude
 * - longitude
 * - title
 * - draggable
 */
GoogleMap.prototype.placeCustomMarker = function (params) {
	var o = this.options;
	var id = params.id || this._customMarkers.length++;

	if (_typeof(this._customMarkers[params.id]) == "object") {
		this.removeCustomMarker({
			id: params.id
		});
	}

	var marker = new google.maps.Marker({
		position: new google.maps.LatLng(params.latitude, params.longitude),
		container: this.element,
		map: this._gmap,
		id: params.id,
		title: params.title || '',
		cursor: params.draggable ? 'move' : 'default',
		visible: true,
		draggable: params.draggable || false,
		icon: params.iconType ? o.markerTypes[params.iconType].icon : null,
		shadow: params.iconType ? o.markerTypes[params.iconType].shadow : null,
		shape: params.iconType ? o.markerTypes[params.iconType].shape : null,
		collectionId: params.collectionId || 'default'
	});

	for (var listener in params.listeners) {
		if (params.listeners.hasOwnProperty(listener)) {
			this.bindEventToCustomMarker(marker, listener, params.listeners[listener]);
		}
	}

	if (params.zIndex) {
		marker.setZIndex(params.zIndex);
	}

	this._customMarkers[params.id] = marker;
};
/**
 * helper function to placeCustomMarker - prevent mutable variable
 * @param target
 * @param eventType
 * @param fnc
 */
GoogleMap.prototype.bindEventToCustomMarker = function (target, eventType, fnc) {
	var self = this;
	google.maps.event.addListener(target, eventType, function (event) {
		fnc.call(self, event.latLng.lat(), event.latLng.lng());
	});
};

/**
 * remove custom placed marker by id
 */
GoogleMap.prototype.removeCustomMarker = function (params) {
	if (!this._customMarkers[params.id]) {
		return false;
	}
	this._customMarkers[params.id].setMap(null);
	this._customMarkers[params.id] = null;
	delete this._customMarkers[params.id];
	return true;
};

GoogleMap.prototype.removeCustomMarkersByCollectionId = function (collectionId) {
	for (var marker in this._customMarkers) {
		if (this._customMarkers.hasOwnProperty(marker)) {
			if (this._customMarkers[marker] != null && this._customMarkers[marker].collectionId == collectionId) {
				this._customMarkers[marker].setMap(null);
				this._customMarkers[marker] = null;
				delete this._customMarkers[marker];
			}
		}
	}
};

/**
 * backward compatibility method
 */
GoogleMap.prototype.filterMarkers = function (filter, fulltextFilter, params) {
	this.filterObjects('markers', filter, fulltextFilter, params);
};

/**
 * goes through generated objects and enables / disables its visibility according to the filter
 * @param filter
 */
GoogleMap.prototype.filterObjects = function (type, filter, fulltextFilter, params) {
	var o = this.options;

	// decide whether to filter markers or shapes
	// to be extended with more object types coming
	var objectsToFilter = type == 'markers' ? this._generatedMarkers : this._generatedShapes;

	if (!objectsToFilter || objectsToFilter.length == 0) {
		return false;
	}
	this.closeInfoWindows();

	var currentMarkerVisibilityByCategory, currentMarkerVisible, markerFilter, markerFulltextData;
	for (var i = 0; i < objectsToFilter.length; i++) {

		if (!o.showAllMarkersOnEmptyFilter && this._getObjectLength(filter) == 0) {
			objectsToFilter[i].setVisible(false);
			continue;
		}

		markerFilter = objectsToFilter[i].filter || {};
		markerFulltextData = objectsToFilter[i].fulltextData || {};
		currentMarkerVisibilityByCategory = [];
		// common data filtering
		for (var filterGroup in filter) {
			if (!filter.hasOwnProperty(filterGroup) || filter[filterGroup].length == 0) {
				continue;
			}

			currentMarkerVisibilityByCategory[filterGroup] = false;

			if ($.isArray(filter[filterGroup])) {
				if (markerFilter && !markerFilter[filterGroup]) {
					continue;
				}

				for (var i2 = 0; i2 < filter[filterGroup].length; i2++) {
					if ($.inArray(filter[filterGroup][i2], markerFilter[filterGroup]) > -1) {
						currentMarkerVisibilityByCategory[filterGroup] = true;
					}
				}
			}
		}
		// fulltext filtering
		for (var fulltextFilterGroup in fulltextFilter) {
			if (!fulltextFilter.hasOwnProperty(fulltextFilterGroup) || fulltextFilter[fulltextFilterGroup].length == 0) {
				continue;
			}

			currentMarkerVisibilityByCategory[fulltextFilterGroup] = false;

			if ($.isArray(fulltextFilter[fulltextFilterGroup])) {
				if (!markerFulltextData[fulltextFilterGroup]) {
					continue;
				}
				for (var i3 = 0; i3 < fulltextFilter[fulltextFilterGroup].length; i3++) {
					for (var i4 = 0; i4 < markerFulltextData[fulltextFilterGroup].length; i4++) {
						if (markerFulltextData[fulltextFilterGroup][i4].toLowerCase().indexOf(fulltextFilter[fulltextFilterGroup][i3].toLowerCase()) > -1) {
							currentMarkerVisibilityByCategory[fulltextFilterGroup] = true;
						}
					}
				}
			}
		}
		currentMarkerVisible = true;
		for (var resultGroup in currentMarkerVisibilityByCategory) {
			if (currentMarkerVisibilityByCategory.hasOwnProperty(resultGroup)) {
				currentMarkerVisible = currentMarkerVisible & currentMarkerVisibilityByCategory[resultGroup];
			}
		}

		if (currentMarkerVisible) {
			objectsToFilter[i].setVisible(true);

			// onMarkerSuccess
			if (params && $.isFunction(params.onMarkerSuccess)) {
				params.onMarkerSuccess.call(this, objectsToFilter[i]);
			}

			// if shape is visible, its marker needs to be visible as well
			if (type == 'shapes' && objectsToFilter[i].shapeMarker) {
				objectsToFilter[i].shapeMarker.setVisible(true);
			}
		} else {
			objectsToFilter[i].setVisible(false);

			// if shape is invisible, its marker needs to be hidden as well
			if (type == 'shapes' && objectsToFilter[i].shapeMarker) {
				objectsToFilter[i].shapeMarker.setVisible(false);
			}
		}
	}

	// repaint clusters after filtering
	if (type == 'markers' && o.clustering.enabled) {
		for (var cluster in this._clusterers) {
			if (this._clusterers.hasOwnProperty(cluster)) {
				this._clusterers[cluster].repaint();
			}
		}
	}
};

/**
 *
 */
GoogleMap.prototype.clearMapObjectsAndInfoWindows = function (type, collectionId) {
	var o = this.options;
	var markersToRemove = [];
	if (!this._markersData[collectionId]) {
		return true;
	}

	var i;
	for (i = 0; i < this._generatedInfoWindows.length; i++) {
		if (this._generatedInfoWindows[i].collectionId == collectionId) {
			this._generatedInfoWindows[i].close();
			this._generatedInfoWindows.splice(i, 1);
			i--;
		}
	}

	if (type == "markers") {
		for (i = 0; i < this._generatedMarkers.length; i++) {
			if (this._generatedMarkers[i].collectionId == collectionId) {
				this._generatedMarkers[i].setMap(null);
				markersToRemove.push(this._generatedMarkers[i]);
				this._generatedMarkers.splice(i, 1);
				i--;
			}
		}

		// TODO - BETA VERSION - removing markers from multiple clusterers isn't working well
		if (o.clustering.enabled) {
			for (var cluster in this._clusterers) {
				if (this._clusterers.hasOwnProperty(cluster)) {
					this._clusterers[cluster].removeMarkers(markersToRemove);
				}
			}
		}

		this._markersData[collectionId] = [];
	}

	if (type == "shapes") {
		for (i = 0; i < this._generatedShapes.length; i++) {
			if (this._generatedShapes[i].collectionId == collectionId) {
				this._generatedShapes[i].setMap(null);
				if (this._generatedShapes[i].shapeMarker) {
					this._generatedShapes[i].shapeMarker.setMap(null);
				}
				this._generatedShapes.splice(i, 1);
				i--;
			}
		}

		this._shapesData[collectionId] = [];
	}

	return true;
};

/**
 * closes all generated infoWindows
 */
GoogleMap.prototype.closeInfoWindows = function () {
	for (var i = 0; i < this._generatedInfoWindows.length; i++) {
		if (this._generatedInfoWindows[i] !== null) {
			this._generatedInfoWindows[i].close();
		}
	}
};

/**
 * sets center and zoom to the current map
 * @param params - object with properties:
 *  - latitude
 *  - longitude
 *  - zoom
 */
GoogleMap.prototype.setCenterAndZoom = function (params) {
	var lat = params.lat || params.latitude;
	var lng = params.lng || params.longitude;
	this._gmap.setCenter(new google.maps.LatLng(lat, lng));
	this._gmap.setZoom(params.zoom);

	if (params.position) {
		var width = Math.round($(this.element).width());
		var height = Math.round($(this.element).height());
		var actualPosition = [width / 2, height / 2];
		var newPosition = [width * params.position[0], height * params.position[1]];
		var offset = [actualPosition[0] - newPosition[0], actualPosition[1] - newPosition[1]];
		this._gmap.panBy(offset[0], offset[1]);
	}
};

/**
 * changes map type
 * @param type
 */
GoogleMap.prototype.setMapType = function (type) {
	this._gmap.setMapTypeId(MAP_TYPE[type] || type);
};

/**
 * external map type setup
 * @param options - object of options https://developers.google.com/maps/documentation/javascript/reference#MapOptions
 */
GoogleMap.prototype.setOptions = function (options) {
	this._gmap.setOptions(options);
};

/**
 * renders a path on map
 * @param pathData - array of google coordinates [new google.maps.LatLng(50.1116210001872,14.6206970146592),new google.maps.LatLng(50.1116788214025,14.6209640760919)...]
 * @param pathColor - hexacolor of the path
 * @param pathWidth - width in pixels
 * @param pathOpacity - opacity
 */
GoogleMap.prototype.renderPath = function (pathData, pathColor, pathWidth, pathOpacity) {
	var path = new google.maps.Polyline({
		path: pathData,
		strokeColor: pathColor || '#f00',
		strokeOpacity: pathOpacity || 1.0,
		strokeWeight: pathWidth || '2'
	});

	path.setMap(this._gmap);
	this._generatedPaths.push(path);
};

/**
 * loads data to this._shapesData[collectionId] and executes callback, if given
 * @param params - object with:
 * 	collectionId - load and store data into this collection
 * 	data - pure data
 * 	dataUrl - ajax url to get data (JSON)
 * 	postData - data passed to JSON request
 * 	callback - execute callback after data is loaded
 */
GoogleMap.prototype.loadShapes = function (params) {
	var _self = this;
	var collectionId = params.collectionId || 'default';
	var filter = params.initialFilter || {};
	var fulltextFilter = params.initialFulltextFilter || {};
	var postData = params.postData || {};
	var listeners = params.listeners || null;
	this.clearMapObjectsAndInfoWindows('shapes', collectionId);
	if (params.dataUrl) {

		var dataSetName = params.dataSetName || 'shapes';

		$.getJSON(params.dataUrl, postData, function (dt) {
			if (dt && dt[dataSetName]) {
				_self._shapesData[collectionId] = $.extend(true, {}, dt[dataSetName]);
				if (typeof params.render == "undefined" || params.render) {
					_self.processShapes({
						collectionId: collectionId,
						initialFilter: filter,
						initialFulltextFilter: fulltextFilter,
						listeners: listeners
					});
				}
			}

			if ($.isFunction(params.callback)) {
				params.callback.call(_self);
			}
		});
	} else if ($.isArray(params.data)) {
		this._shapesData[collectionId] = params.data.slice(0);
		this._shapesData[collectionId] = $.extend(true, {}, params.data);

		if (typeof params.render == "undefined" || params.render) {
			this.processShapes({
				collectionId: collectionId,
				initialFilter: filter,
				initialFulltextFilter: fulltextFilter,
				listeners: listeners
			});
		}

		if ($.isFunction(params.callback)) {
			params.callback.call(_self);
		}
	}
};

/**
 * gets array of objects (shapes) and renders them to the map
 * @param params - object with:
 *	collectionId - render only shapes within this collection. If null, render all collections
 * 	initialFilter - object of properties rules, which are applied to rendered shape - if it is visible or not
 */

GoogleMap.prototype.processShapes = function (params) {
	var o = this.options;

	if (params.collectionId && $.isArray(this._shapesData[params.collectionId])) {
		this.renderShape(params.collectionId, this._shapesData[params.collectionId], params.listeners);
	} else {
		for (var collection in this._shapesData) {
			if (this._shapesData.hasOwnProperty(collection)) {
				this.renderShape(collection, this._shapesData[collection], params.listeners);
			}
		}
	}

	if (this._getObjectLength(params.initialFilter) > 0 || this._getObjectLength(params.initialFulltextFilter)) {
		this.filterObjects('shapes', params.initialFilter, params.initialFulltextFilter);
	}
};

/**
 * render shape on map
 * @params
 * 	- data - {id, lat, lng, radius}
 * 	- type
 * 	- strokeColor
 * 	- fillColor
 * 	- strokeWidth
 * 	- strokeOpacity
 * 	- fillOpacity
 */

GoogleMap.prototype.renderShape = function (collectionId, shapesData, listeners) {

	var o = this.options;
	var _self = this;
	var bubbleContent = '';
	var shape, infowindow;

	var strokeColor = shapesData.style.strokeColor || "#f00";
	var fillColor = shapesData.style.fillColor || strokeColor;
	var strokeWeight = shapesData.style.strokeWeight || 2;
	var strokeOpacity = shapesData.style.strokeOpacity || 0.8;
	var fillOpacity = shapesData.style.fillOpacity || 0.3;
	var enableShapeMarkers = shapesData.enableShapeMarkers || false;
	var shapeMarkerPointData,
	    shapeType,
	    shapeData,
	    polygonCoords = [];

	for (var i = 0; i < shapesData.data.length; i++) {

		if ($.isFunction(o.bubbleContentFormatter)) {
			bubbleContent = o.bubbleContentFormatter(shapesData.data[i]);
		}

		shapeData = shapesData.data[i];
		shapeData.style = shapeData.style || {};
		shapeType = shapeData.style.type || shapesData.style.type || null;
		shapeMarkerPointData = {};

		switch (shapeType) {
			case 'circle':
				shape = new google.maps.Circle({
					map: this._gmap,
					strokeColor: shapeData.style.strokeColor || strokeColor,
					strokeOpacity: shapeData.style.strokeOpacity || strokeOpacity,
					strokeWeight: shapeData.style.strokeWeight || strokeWeight,
					fillColor: shapeData.style.fillColor || fillColor,
					fillOpacity: shapeData.style.fillOpacity || fillOpacity,
					center: new google.maps.LatLng(shapeData.lat, shapeData.lng),
					radius: shapeData.radius,
					filter: shapeData.filter,
					fulltextData: shapeData.fulltextData,
					container: _self.element,
					collectionId: collectionId,
					clickable: bubbleContent && bubbleContent != "",
					objectType: 'shape',
					visible: o.showAllMarkersOnEmptyFilter
				});

				shapeMarkerPointData.circle = new google.maps.LatLng(shapeData.lat, shapeData.lng);
				break;

			case 'polygon':
				polygonCoords = [];
				for (var point = 0; point < shapeData.points.length; point++) {
					polygonCoords.push(new google.maps.LatLng(shapeData.points[point].lat, shapeData.points[point].lng));
				}

				shape = new google.maps.Polygon({
					map: this._gmap,
					strokeColor: shapeData.style.strokeColor || strokeColor,
					strokeOpacity: shapeData.style.strokeOpacity || strokeOpacity,
					strokeWeight: shapeData.style.strokeWeight || strokeWeight,
					fillColor: shapeData.style.fillColor || fillColor,
					fillOpacity: shapeData.style.fillOpacity || fillOpacity,
					paths: polygonCoords,
					filter: shapeData.filter,
					fulltextData: shapeData.fulltextData,
					container: _self.element,
					collectionId: collectionId,
					clickable: bubbleContent && bubbleContent != "",
					objectType: 'shape',
					visible: o.showAllMarkersOnEmptyFilter
				});

				shapeMarkerPointData.polygon = polygonCoords.slice(0);
				break;

			default:
				break;
		}

		/*
   TODO
   if (listeners) {
   for (var listener in listeners) {
   if (listeners.hasOwnProperty(listener)) {
   this.processMarkersCustomAction(marker, listener, listeners[listener], markersData[i]);
   }
   }
   } else {
   }*/

		if (bubbleContent && bubbleContent != "") {
			infowindow = this.createInfowindow(shape, bubbleContent, collectionId);
			this._generatedInfoWindows.push(infowindow);
		}
		if (enableShapeMarkers) {
			shapeMarkerPointData.type = shapeData.type;
			shape.shapeMarker = this.renderShapeMarker(shapeType, shapeMarkerPointData, infowindow);
			this._generatedShapes.push(shape);
		}
	}

	return true;
};

GoogleMap.prototype.renderShapeMarker = function (type, data, infowindow) {
	var pos = type == "circle" ? data.circle : data.polygon[0];

	var o = this.options;
	var iw = infowindow.content && infowindow.content != "";
	var _self = this;

	var shapeMarker = new google.maps.Marker({
		position: pos,
		container: this.element,
		map: this._gmap,
		title: '',
		cursor: iw ? 'pointer' : 'default',
		visible: true,
		icon: o.markerTypes.length > 0 && _typeof(o.markerTypes[data.type]) == "object" ? o.markerTypes[data.type].icon : null,
		shape: o.markerTypes.length > 0 && _typeof(o.markerTypes[data.type]) == "object" ? o.markerTypes[data.type].shape : null,
		objectType: 'shapeMarker'
	});

	if (iw) {
		google.maps.event.addListener(shapeMarker, 'click', function (event) {
			if (o.oneBubbleAtOnce) {
				_self.closeInfoWindows();
			}
			infowindow.open(_self._gmap, shapeMarker);
		});
	}

	return shapeMarker;
};

/**
 * renders layer from external KMZ (zipped KML) layer
 * params
 * 		id
 * 		kmzFile
 * 		showImmediately
 * 		clickable
 * 		callback
 */
GoogleMap.prototype.renderKMZLayer = function (params) {
	var _self = this;
	var kmlLayer = new google.maps.KmlLayer(params.kmzFile, {
		preserveViewport: true,
		clickable: params.clickable || false
	});
	var showImmediately = params.showImmediately === undefined ? true : params.showImmediately;
	if (showImmediately) {
		kmlLayer.setMap(this._gmap);
	} else {
		kmlLayer.setMap(null);
	}

	this._kmlLayers.push({
		id: params.id,
		layer: kmlLayer,
		enabled: showImmediately
	});

	if (showImmediately && $.isFunction(params.callback)) {
		params.callback.call(_self);
	}
};

/**
 * toggles kmz layer by id
 * @param id
 */
GoogleMap.prototype.toggleKMZLayer = function (id) {
	var kmlLayers = this._kmlLayers;
	for (var i = 0; i < kmlLayers.length; i++) {
		if (kmlLayers[i].id == id) {
			if (kmlLayers[i].enabled) {
				kmlLayers[i].layer.setMap(null);
			} else {
				kmlLayers[i].layer.setMap(this._gmap);
			}
			kmlLayers[i].enabled = !kmlLayers[i].enabled;
		}
	}
};

/**
 * show address by string
 * @params
 *  - address
 *  - zoom
 *  - callback
 */
GoogleMap.prototype.findAndShowAddress = function (params) {
	var _self = this;
	var address = params.address;
	if (params.location && params.location != "") {
		address += ", " + params.location;
	}
	var geocoder = new google.maps.Geocoder();
	geocoder.geocode({ 'address': address }, function (results, status) {
		if (status == google.maps.GeocoderStatus.OK && results.length > 0) {
			_self.setCenterAndZoom({
				latitude: results[0].geometry.location.lat(),
				longitude: results[0].geometry.location.lng(),
				zoom: params.zoom || 16
			});

			if ($.isFunction(params.callback)) {
				params.callback.call(_self, results[0].geometry.location.lat(), results[0].geometry.location.lng());
			}
		}
	});
};

/**
 * adds listener to an object
 * @param params
 * - target - target, that listens to event
 * - eventType - click, dblclick, mouseup, mousedown, mouseover, mouseout
 * - function
 */
GoogleMap.prototype.addListener = function (params) {
	var _self = this;
	var id = params.id;
	var target = null;
	var eventType = params.eventType;

	switch (params.target) {
		case "map":
			target = this._gmap;
			break;
		default:
			break;
	}

	if (!target) {
		return false;
	}

	this._mapListeners[id] = google.maps.event.addListener(target, eventType, function (event) {
		params.execute.call(_self, event.latLng.lat(), event.latLng.lng());
	});
};

GoogleMap.prototype.removeListener = function (params) {
	google.maps.event.removeListener(this._mapListeners[params.id]);
	this._mapListeners[params.id] = null;
	delete this._mapListeners[params.id];
};

GoogleMap.prototype.renderPrintVersionMap = function () {
	var url = this.options.print.apiUrl;
	url += 'center=' + this.options.mapOptions.startingPosition.lat + ',' + this.options.mapOptions.startingPosition.lng;
	url += '&zoom=' + this.options.print.customZoom;
	url += '&size=' + this.options.print.size;

	if (this._generatedMarkers.length > 0) {
		url += '&markers=';
	}
	for (var i = 0; i < this._generatedMarkers.length; i++) {
		url += this._generatedMarkers[i].position.lat() + ',' + this._generatedMarkers[i].position.lng();
		if (i < this._generatedMarkers.length - 1) {
			url += "|";
		}
	}
	var printImg = $('<img src="' + url + '">');
	$(this.options.print.selector).append(printImg);
};

/**
 *
 * @param params
 */
GoogleMap.prototype.customMarkerAction = function (params) {
	var collectionId = params.collectionId || 'default';
	var markerId = params.markerId || null;

	if (!markerId) {
		return false;
	}

	var marker = $.grep(this._generatedMarkers, function (e) {
		return e.id == markerId && e.collectionId == collectionId;
	});

	if ($.isFunction(params.execute) && marker.length == 1) {
		params.execute.call(this, marker[0]);
	}
};
/**
 * creates cluster groups from this._generatedMarkers
 * @private
 */
GoogleMap.prototype._parseGeneratedMarkersIntoClusterGroups = function () {
	var o = this.options;
	this._clustererGroups = {};

	// exit if clustering not properly set
	if (!o.clustering || o.clustering.mode === 'all' || !o.clustering.groups || this._getObjectLength(o.clustering.groups) == 0) {
		return false;
	}

	for (var group in o.clustering.groups) {
		if (!o.clustering.groups.hasOwnProperty(group)) continue;

		this._clustererGroups[group] = [];

		for (var i = 0; i < this._generatedMarkers.length; i++) {
			if ($.inArray(this._generatedMarkers[i][o.clustering.mode], o.clustering.groups[group].categories) > -1) {
				this._clustererGroups[group].push(this._generatedMarkers[i]);
			}
		}
	}
};

/**
 * Creates clusters (this._clusterers) from this._clustererGroups
 * @param {boolean} parse
 * @private
 */
GoogleMap.prototype._createMarkerClusters = function (parse) {
	if (parse) {
		this._parseGeneratedMarkersIntoClusterGroups();
	}

	this._clusterers = {};
	var o = this.options;

	// mode all
	if (o.clustering.mode === 'all') {
		this._createSingleCluster({
			markers: this._generatedMarkers,
			id: 'all',
			iconsStyles: o.clustering.iconsStyles || []
		});
	}

	// mode type or collectionId
	for (var clustererGroup in this._clustererGroups) {
		if (!this._clustererGroups.hasOwnProperty(clustererGroup)) continue;

		this._createSingleCluster({
			markers: this._clustererGroups[clustererGroup],
			id: clustererGroup,
			iconsStyles: o.clustering.groups[clustererGroup].iconsStyles || o.clustering.iconsStyles || []
		});
	}
};

/**
 * Creates single MarkerClusterer instance with params.markers and saves it to this._clusterers[params.id]
 * @param {object} params
 * @private
 */
GoogleMap.prototype._createSingleCluster = function (params) {
	var o = this.options;
	if (!params.markers || params.markers.length < 1) {
		return false;
	}
	this._clusterers[params.id] = new MarkerClusterer(this._gmap, params.markers, {
		averageCenter: true,
		ignoreHidden: true,
		styles: params.iconsStyles,
		maxZoom: o.clustering.maxZoom,
		batchSize: o.clustering.batchSize,
		batchSizeIE: o.clustering.batchSizeIE,
		gridSize: o.clustering.gridSize
	});
};

/**
 * decide, which methods will be "public"
 */
var API = {
	setCenterAndZoom: GoogleMap.prototype.setCenterAndZoom,
	setMapType: GoogleMap.prototype.setMapType,
	setOptions: GoogleMap.prototype.setOptions,
	renderPath: GoogleMap.prototype.renderPath,
	renderKMZLayer: GoogleMap.prototype.renderKMZLayer,
	toggleKMZLayer: GoogleMap.prototype.toggleKMZLayer,
	loadMarkers: GoogleMap.prototype.loadMarkers,
	loadShapes: GoogleMap.prototype.loadShapes,
	filterObjects: GoogleMap.prototype.filterObjects,
	filterMarkers: GoogleMap.prototype.filterMarkers, // compat mode, to be removed soon, use filterObjects instead
	findAndShowAddress: GoogleMap.prototype.findAndShowAddress,
	addListener: GoogleMap.prototype.addListener,
	removeListener: GoogleMap.prototype.removeListener,
	placeCustomMarker: GoogleMap.prototype.placeCustomMarker,
	removeCustomMarker: GoogleMap.prototype.removeCustomMarker,
	renderPrintVersionMap: GoogleMap.prototype.renderPrintVersionMap,
	removeCustomMarkersByCollectionId: GoogleMap.prototype.removeCustomMarkersByCollectionId,
	customMarkerAction: GoogleMap.prototype.customMarkerAction
};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 * 		if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 * 		if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function (value) {
	var args = arguments;

	return this.each(function () {
		var $this = $(this);

		// get plugin instance
		var plugin = $this.data('plugin_' + PLUGIN_NAME);

		// if there's not, create one
		if (!plugin) {
			plugin = new GoogleMap(this, value);
			$this.data('plugin_' + PLUGIN_NAME, plugin);
		}
		// if there is and first parameter is in predefined API methods, call it with rest of params
		else if (API[value]) {
				plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
			}
	});
};

/**
 * setDefaults with $.googlemap.setDefaults();
 */
$[PLUGIN_NAME] = $.fn[PLUGIN_NAME];
$[PLUGIN_NAME].setDefaults = function (newOptions) {
	DEFAULTS = $.extend(true, {}, DEFAULTS, newOptions);
};

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


$ = __webpack_require__(3);
__webpack_require__(393);
__webpack_require__(394);

"use strict";

var PLUGIN_NAME = "webslider";

var DEFAULTS = {
	minScreenWidth: 320,
	data: [],
	sliderContentFormatter: function sliderContentFormatter(data) {},
	slideContentFormatter: function slideContentFormatter(slideData) {
		var result = '';
		var resultCooperationAwards = '';
		var resultText1 = '';
		var resultText2 = '';
		var slideAnimation = '';

		if (slideData.iea && slideData.iea !== '' || slideData.webtop100 && slideData.webtop100 !== '' || slideData.zlatyerb && slideData.zlatyerb !== '' || slideData.zlatystrednik && slideData.zlatystrednik !== '' || slideData.fenix && slideData.fenix !== '') {
			slideAnimation = true;
			resultCooperationAwards = '<ul class="slide__infobox__list">\n';
			if (slideData.iea && slideData.iea !== '') {
				resultCooperationAwards += '  <li class="slide__infobox__item"><img class="svg-icon" src="/ver/20180718/img/klienti/iea.svg" width="75" height="75" alt="" /><span class="slide__infobox__year">' + slideData.iea + '</span></li>\n';
			}
			if (slideData.webtop100 && slideData.webtop100 !== '') {
				resultCooperationAwards += '  <li class="slide__infobox__item"><img class="svg-icon" src="/ver/20180718/img/klienti/webtop100.svg" width="75" height="75" alt="" /><span class="slide__infobox__year">' + slideData.webtop100 + '</span></li>\n';
			}
			if (slideData.zlatyerb && slideData.zlatyerb !== '') {
				resultCooperationAwards += '  <li class="slide__infobox__item"><img class="svg-icon" src="/ver/20180718/img/klienti/zlaty-erb.svg" width="75" height="75" alt="" /><span class="slide__infobox__year">' + slideData.zlatyerb + '</span></li>\n';
			}
			if (slideData.zlatystrednik && slideData.zlatystrednik !== '') {
				resultCooperationAwards += '  <li class="slide__infobox__item"><img class="svg-icon" src="/ver/20180718/img/klienti/zlaty-strednik.svg" width="75" height="75" alt="" /><span class="slide__infobox__year">' + slideData.zlatystrednik + '</span></li>\n';
			}
			if (slideData.fenix && slideData.fenix !== '') {
				resultCooperationAwards += '  <li class="slide__infobox__item"><img class="svg-icon" src="/ver/20180718/img/klienti/zlaty-fenix.svg" width="75" height="75" alt="" /><span class="slide__infobox__year">' + slideData.fenix + '</span></li>\n';
			}
			resultCooperationAwards += '</ul>\n';
			/*
   		} else if (slideData.cooperation && slideData.cooperation !== '') {
   			resultCooperationAwards = '<ul class="slide__infobox__list">\n\t<li class="slide__infobox__item"><img class="svg-icon" src="/ver/20180718/img/klienti/spoluprace_' + web.lang + '.svg" width="75" height="75" alt="" /><span class="slide__infobox__year slide__infobox__year--cooperation">' + slideData.cooperation + '</span></li>\n</ul>\n';
   */
		}
		if (slideData.text1 && slideData.text1 !== '') {
			resultText1 = '<p class="slide__infobox__text slide__infobox__text--text1">' + slideData.text1 + '</p>\n';
		}
		if (slideData.text1 && slideData.text2 !== '') {
			resultText2 = '<p class="slide__infobox__text slide__infobox__text--text2">' + slideData.text2 + '</p>\n';
		}

		result = '	<div class="slide">\n';
		result += '		<div class="bg-rwd js_state-active' + (slideData.itemLink && slideData.itemLink !== '' ? ' with-link' : '') + '" data-bg-rwd="' + slideData.activeImage['bg-rwd'] + '" data-bg-rwd-320="' + slideData.activeImage['bg-rwd-320'] + '" data-bg-rwd-540="' + slideData.activeImage['bg-rwd-540'] + '" data-bg-rwd-660="' + slideData.activeImage['bg-rwd-660'] + '" data-bg-rwd-828="' + slideData.activeImage['bg-rwd-828'] + '" data-bg-rwd-1052="' + slideData.activeImage['bg-rwd-1052'] + '" data-bg-rwd-1260="' + slideData.activeImage['bg-rwd-1260'] + '"' + (slideData.itemLink && slideData.itemLink !== '' ? ' data-slide-link="' + slideData.itemLink + '"' : '') + (slideData.blank ? ' data-slide-link-blank="' + slideData.blank + '"' : '') + '>\n';
		if (slideData.text1 && slideData.text1 !== '') {
			result += ' 		<div class="slide__infobox' + (slideData.position && slideData.position !== '' ? ' slide__infobox--' + slideData.position : '') + (slideData.iea && slideData.iea !== '' || slideData.webtop100 && slideData.webtop100 !== '' || slideData.zlatyerb && slideData.zlatyerb !== '' || slideData.zlatystrednik && slideData.zlatystrednik !== '' || slideData.fenix && slideData.fenix !== '' ? ' slide__infobox--hasValuation' : '') + ' js_slideInfobox">\n';
			result += '	  	  <h2 class="slide__infobox__title js_slideInfoboxTitle">' + slideData.name + '</h2>\n';
			result += '	  	  <div class="slide__infobox__content">\n';
			result += resultText1;
			if (slideAnimation) {
				result += '	  	    <div class="slide__infobox__animation slide__infobox__animation--bigger">\n';
			} else {
				result += '	  	    <div class="slide__infobox__animation">\n';
			}
			result += resultText2;
			result += resultCooperationAwards;
			result += '		    </div>\n';
			result += '		  </div>\n';
			result += '		</div>\n';
		}
		result += '		</div>\n';
		result += '		<div class="bg-rwd js_state-inactive' + (slideData.itemLink && slideData.itemLink !== '' ? ' with-link' : '') + '" data-bg-rwd="' + slideData.inactiveImage['bg-rwd'] + '" data-bg-rwd-320="' + slideData.inactiveImage['bg-rwd-320'] + '" data-bg-rwd-540="' + slideData.inactiveImage['bg-rwd-540'] + '" data-bg-rwd-660="' + slideData.inactiveImage['bg-rwd-660'] + '" data-bg-rwd-828="' + slideData.inactiveImage['bg-rwd-828'] + '" data-bg-rwd-1052="' + slideData.inactiveImage['bg-rwd-1052'] + '" data-bg-rwd-1260="' + slideData.inactiveImage['bg-rwd-1260'] + '"' + (slideData.itemLink && slideData.itemLink !== '' ? ' data-slide-link="' + slideData.itemLink + '"' : '') + (slideData.blank ? ' data-slide-link-blank="' + slideData.blank + '"' : '') + '></div>\n';
		result += '	</div>\n';
		return result;
	},
	slidesWrapperSelector: null,
	sliderWrapperSelector: null,
	controlArrows: true,
	controlPoints: true,
	slideTime: 8000,
	slideAnimationTime: 1000,
	slideAnimationEasing: 'easeInOutQuad',
	autostart: true,
	startingSlide: 0,
	customCallback: function customCallback() {}
};

// The actual plugin constructor
function WebSlider(element, options) {
	this.element = element;
	this.$t = $(this.element);

	this.options = $.extend(true, {}, DEFAULTS, options);
	this._wWidth = window.innerWidth || window.document.body.clientWidth;
	this._slides = [];
	this._animationInProgress = false;

	this._defaults = DEFAULTS;
	this._name = PLUGIN_NAME;

	this._changeTimer = null;

	this.initialise();
}

/**
 * init
 */
WebSlider.prototype.initialise = function () {
	if (this._wWidth < this.options.minScreenWidth) {
		this.$t.empty().hide();
		return false;
	}

	this.$t.show();
	this.actualSlide = this.options.startingSlide;
	this.slidesWrapper = null;
	this.sliderWrapper = null;

	if (this.options.data.length > 0) {
		this.renderSlider();
		this.renderSlides();
	}

	if (this.options.data.length > 1) {
		this.renderControls();
		this.bindTouchEvents();

		if (this.options.autostart) {
			this.startRotation();
		}

		this.$t.trigger('WEBSLIDER_INIT', [this.options.data[this.getPreviousSlideIndex(1)], this.options.data[this.getNextSlideIndex(1)]]);
	}

	if ($.isFunction(this.options.customCallback)) {
		this.options.customCallback.call(this);
	}
};

/**
 * render slider, set wrappers
 */
WebSlider.prototype.renderSlider = function () {
	var htmlResult = this.options.sliderContentFormatter();

	this.$t.html(htmlResult);
	this.sliderWrapper = $(this.options.sliderWrapperSelector, this.$t);
	this.slidesWrapper = $(this.options.slidesWrapperSelector, this.$t);
};

/**
 * read data and build slides list
 */
WebSlider.prototype.renderSlides = function () {
	var $slide = null;
	var animationBoxHeight = '42px';

	for (var i = 0; i < this.options.data.length; i++) {
		$slide = $(this.options.slideContentFormatter(this.options.data[i]));
		this._slides.push($slide);
		$slide.appendTo(this.slidesWrapper);
	}

	this._slides[this.actualSlide].addClass('active');
	this._slides[this.getPreviousSlideIndex(1)].addClass('previous-slide');
	this._slides[this.getNextSlideIndex(1)].addClass('next-slide');

	if ($('.slide__infobox__animation', this._slides[this.actualSlide]).hasClass('slide__infobox__animation--bigger')) {
		animationBoxHeight = '142px';
	}

	$('.slide.active .slide__infobox__animation').animate({
		height: animationBoxHeight
	}, 1500, function () {
		// Animation complete.
	});

	this.slidesWrapper.on('click', '.slide > div', function (event) {
		var link = $(event.currentTarget).data('slideLink');
		var blank = $(event.currentTarget).data('slideLinkBlank');
		if (!link) {
			return false;
		}
		if (blank) {
			window.open(link);
		} else {
			window.location.href = link;
		}
	});

	this.slidesWrapper.on('click', '.slide > div a', function (event) {
		$('body').trigger('WEBSLIDER_INSIDE_ANCHOR_CLICKED', [event.currentTarget]);
	});
};

WebSlider.prototype.getPreviousSlideIndex = function (index) {
	index = index || 1;
	var previousSlide = this.actualSlide - index;

	if (previousSlide < 0) {
		previousSlide = this.options.data.length - index + this.actualSlide;
	}
	return previousSlide;
};
WebSlider.prototype.getNextSlideIndex = function (index) {
	var nextSlide = this.actualSlide + index;

	if (nextSlide > this.options.data.length - 1) {
		nextSlide = this.actualSlide - this.options.data.length + index;
	}
	return nextSlide;
};

/**
 * render controls
 */
WebSlider.prototype.renderControls = function () {
	this.controlArrows = this.options.controlArrows ? this.renderControlArrows() : null;
	this.controlPoints = this.options.controlPoints ? this.renderControlPoints() : null;

	if (this.controlArrows) {
		this.sliderWrapper.append(this.controlArrows);
		this.$prevArrow = $('.control-previous', this.sliderWrapper);
		this.$nextArrow = $('.control-next', this.sliderWrapper);
		this.decorControlArrows();
		this.bindControlArrows();
	}

	if (this.controlPoints) {
		this.$t.append(this.controlPoints);
		this.bindControlPoints();
		this.updateControlPoints(this.actualSlide);
	}
};

/**
 * renders control arrows
 */
WebSlider.prototype.renderControlArrows = function () {
	var str = '';
	str += '<a class="control control-previous" href="javascript:void(0)"><span class="visible-over"></span><span class="title"><span class="wrapper"></span></span></a>';
	str += '<a class="control control-next" href="javascript:void(0)"><span class="visible-over"></span><span class="title"><span class="wrapper"></span></span></a>';
	return str;
};

// update widths of control arrows
WebSlider.prototype.decorControlArrows = function () {
	var sideWidthTotal = this.$t.outerWidth() - this.slidesWrapper.outerWidth();
	var leftSideWidth = parseInt(sideWidthTotal / 2);
	var rightSideWidth = parseInt(sideWidthTotal / 2);

	if (leftSideWidth + rightSideWidth < sideWidthTotal) {
		leftSideWidth++;
	}

	$('.control:eq(0)', this.sliderWrapper).width(leftSideWidth);
	$('.control:eq(1)', this.sliderWrapper).width(rightSideWidth);
};

/**
 * bind action to control arrows
 */
WebSlider.prototype.bindControlArrows = function () {
	var self = this;

	$('a.control', this.$t).bind('click', function (event) {
		event.preventDefault();
		if (self._animationInProgress) {
			return false;
		}

		clearTimeout(this._changeTimer);

		if ($(event.currentTarget).hasClass('control-previous')) {
			self.rotate(self.actualSlide, 'prev');
		}

		if ($(event.currentTarget).hasClass('control-next')) {
			self.rotate(self.actualSlide, 'next');
		}
	});
};

/**
 * renders control points
 */
WebSlider.prototype.renderControlPoints = function () {
	var str = '<ul class="control-points">';

	for (var i = 0; i < this.options.data.length; i++) {
		str += '<li>' + i + '</li>';
	}

	str += '</ul>';
	return str;
};

/**
 * bind action to control points
 */
WebSlider.prototype.bindControlPoints = function () {
	var self = this;
	clearTimeout(this._changeTimer);

	$('.control-points>li', this.$t).bind('click', function () {
		self.changeSlide(self.actualSlide, $(this).text());
	});
};

/**
 *
 */
WebSlider.prototype.rotate = function (from, direction) {
	this._animationInProgress = true;

	var newSlide = this.actualSlide;
	clearTimeout(this._changeTimer);

	if (direction == 'prev') {
		newSlide--;
		newSlide = newSlide < 0 ? this.options.data.length - 1 : newSlide;
	}

	if (direction == 'next') {
		newSlide++;
		newSlide = newSlide >= this.options.data.length ? 0 : newSlide;
	}

	this.changeSlide(this.actualSlide, newSlide, direction);
};

/**
 *
 * @param from
 * @param to
 * @param direction
 */
WebSlider.prototype.changeSlide = function (from, to, direction) {

	var self_ = this;

	if (from == to) {
		return false;
	}

	this.$t.trigger('WEBSLIDER_ANIMATION_START', [direction]);

	var $newNextSlide = this._slides[this.getNextSlideIndex(2)]; // retrieve actual + 2 slide
	var $nextSlide = this._slides[this.getNextSlideIndex(1)]; // retrieve actual + 1 slide
	var $actualSlide = this._slides[this.actualSlide]; // retrieve actual
	var $previousSlide = this._slides[this.getPreviousSlideIndex(1)]; // retrieve actual - 1 slide
	var $newPreviousSlide = this._slides[this.getPreviousSlideIndex(2)]; //  retrieve actual - 2 slide

	var $newSubSlide = $('.js_state-active', self_._slides[to]).clone().addClass('js_webslider-added');
	var $oldSubSlide = $('.js_state-active', $actualSlide);
	var $oldSubSlideForPrev = $('.js_state-inactive', $actualSlide);
	var $prevOldSlide,
	    $nextOldSlide = null;

	if (direction == 'next') {

		// next slide
		$newNextSlide.css({ left: '200%', right: 'auto' }).show().addClass('next-slide').animate({ left: '100%' }, self_.options.slideAnimationTime, self_.options.slideAnimationEasing);
		$nextSlide.animate({ left: 0 }, self_.options.slideAnimationTime, self_.options.slideAnimationEasing);

		// actual slide
		$newSubSlide.css({ left: '100%' }).appendTo(self_._slides[from]);
		$newSubSlide.animate({ left: 0 }, self_.options.slideAnimationTime, self_.options.slideAnimationEasing);
		$oldSubSlide.animate({ left: '-100%' }, self_.options.slideAnimationTime, self_.options.slideAnimationEasing);

		// prev slide
		$prevOldSlide = $oldSubSlideForPrev.clone().addClass('js_webslider-added').appendTo($previousSlide).css({ left: '100%' });
		$prevOldSlide.animate({ left: 0 }, self_.options.slideAnimationTime, self_.options.slideAnimationEasing);
		$('.js_state-inactive:first', $previousSlide).animate({ left: '-100%' }, self_.options.slideAnimationTime, self_.options.slideAnimationEasing, function () {
			window.setTimeout(function () {
				self_.$t.trigger('WEBSLIDER_ANIMATION_COMPLETE', ['next']);
			}, 10);
		});
	}

	if (direction == 'prev') {

		// prev slide
		$newPreviousSlide.css({ left: 'auto', right: '200%' }).show().addClass('previous-slide').animate({ right: '100%' }, self_.options.slideAnimationTime, self_.options.slideAnimationEasing);
		$previousSlide.animate({ right: 0 }, self_.options.slideAnimationTime, self_.options.slideAnimationEasing);

		// actual slide
		$newSubSlide.css({ left: '-100%' }).appendTo(self_._slides[from]);
		$newSubSlide.animate({ left: 0 }, self_.options.slideAnimationTime, self_.options.slideAnimationEasing);
		$oldSubSlide.css({ left: 0 }).animate({ left: '100%' }, self_.options.slideAnimationTime, self_.options.slideAnimationEasing);

		// next slide
		$nextOldSlide = $oldSubSlideForPrev.clone().addClass('js_webslider-added').appendTo($nextSlide).css({ left: '-100%' });
		$nextOldSlide.animate({ left: 0 }, self_.options.slideAnimationTime, self_.options.slideAnimationEasing);
		$('.js_state-inactive:first', $nextSlide).animate({ left: '100%' }, self_.options.slideAnimationTime, self_.options.slideAnimationEasing, function () {
			window.setTimeout(function () {
				self_.$t.trigger('WEBSLIDER_ANIMATION_COMPLETE', ['prev']);
			}, 10);
		});
	}

	this.$t.off('WEBSLIDER_ANIMATION_COMPLETE').on('WEBSLIDER_ANIMATION_COMPLETE', function (event, dir) {

		self_._animationInProgress = false;
		$('.js_webslider-added', self_.$t).remove();

		$('.slide > div', self_.$t).css({ left: 0, right: 'auto' });
		if (dir === 'next') {
			$actualSlide.removeClass('active').addClass('previous-slide');
			$nextSlide.hide().removeClass('next-slide').addClass('active').show();
			$previousSlide.hide().removeClass('previous-slide');
		} else if (dir === 'prev') {
			$actualSlide.removeClass('active').addClass('next-slide');
			$previousSlide.hide().removeClass('previous-slide').addClass('active').show();
			$nextSlide.hide().removeClass('next-slide');
		}
		$('.slide__infobox__animation', $actualSlide).removeAttr('style');
		var animationBoxHeight = '42px';
		if ($('.slide.active .slide__infobox__animation').hasClass('slide__infobox__animation--bigger')) {
			animationBoxHeight = '142px';
		}
		$('.slide.active .slide__infobox__animation').animate({
			height: animationBoxHeight
		}, 1000, function () {
			// Animation complete.
		});

		self_.actualSlide = to;

		$nextSlide = self_._slides[self_.getNextSlideIndex(1)]; // retrieve actual + 1 slide
		$actualSlide = self_._slides[self_.actualSlide]; // retrieve actual
		$previousSlide = self_._slides[self_.getPreviousSlideIndex(1)]; // retrieve actual - 1 slide

		$nextSlide.css({ left: '100%' }).show();
		$previousSlide.css({ right: '100%', left: 'auto' }).show();

		self_.$t.trigger('WEBSLIDER_ROTATION_COMPLETE', [self_.options.data[self_.getPreviousSlideIndex(1)], self_.options.data[self_.getNextSlideIndex(1)]]);

		if (self_.options.autostart) {
			self_.startRotation();
		}
	});
};

/**
 * start
 */
WebSlider.prototype.startRotation = function () {
	var self = this;
	clearTimeout(this._changeTimer);

	this._changeTimer = setTimeout(function () {
		self.rotate(self.actualSlide, 'next');
	}, self.options.slideTime);
};

/**
 * sets the right controlPoint active
 */
WebSlider.prototype.updateControlPoints = function (index) {
	if (this.options.controlPoints) {
		$('.control-points li', this.$t).removeClass('active');
		$('.control-points li:eq(' + index + ')', this.$t).addClass('active');
	}
};

WebSlider.prototype.isTouchDevice = function () {
	return 'ontouchstart' in document.documentElement;
};

/**
 *
 */
WebSlider.prototype.bindTouchEvents = function () {
	var self_ = this;
	this.$t.bind('swipeone', function (e, je) {
		if (self_._animationInProgress) {
			return false;
		}
		if (Math.abs(je.delta[0].lastY) > 50) {
			return false;
		}
		if (je.direction.lastX == 1) {
			self_.rotate(self_.actualSlide, 'prev');
		}

		if (je.direction.lastX == -1) {
			self_.rotate(self_.actualSlide, 'next');
		}
	});
};

/**
 * getter for external use (we need to save actual slide to browser history in order to renew it on history.back() )
 * @returns {number|*}
 */
WebSlider.prototype.getActualSlide = function () {
	return this.actualSlide;
};

/**
 * decide, which methods will be "public"
 */
var API = {
	decorControlArrows: WebSlider.prototype.decorControlArrows,
	getActualSlide: WebSlider.prototype.getActualSlide,
	rotate: WebSlider.prototype.rotate
};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 *         if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 *         if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function (value) {
	var args = arguments;

	return this.each(function () {
		var $this = $(this);

		// get plugin instance
		var plugin = $this.data('plugin_' + PLUGIN_NAME);

		// if there's not, create one
		if (!plugin) {
			plugin = new WebSlider(this, value);
			$this.data('plugin_' + PLUGIN_NAME, plugin);
		}
		// if there is and first parameter is in predefined API methods, call it with rest of params
		else if (API[value]) {
				plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
			}
	});
};

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var jQuery = __webpack_require__(3);

// t: current time, b: begInnIng value, c: change In value, d: duration
jQuery.easing['jswing'] = jQuery.easing['swing'];

jQuery.extend(jQuery.easing, {
	def: 'easeOutQuad',
	swing: function swing(x, t, b, c, d) {
		//alert(jQuery.easing.default);
		return jQuery.easing[jQuery.easing.def](x, t, b, c, d);
	},
	easeInQuad: function easeInQuad(x, t, b, c, d) {
		return c * (t /= d) * t + b;
	},
	easeOutQuad: function easeOutQuad(x, t, b, c, d) {
		return -c * (t /= d) * (t - 2) + b;
	},
	easeInOutQuad: function easeInOutQuad(x, t, b, c, d) {
		if ((t /= d / 2) < 1) return c / 2 * t * t + b;
		return -c / 2 * (--t * (t - 2) - 1) + b;
	},
	easeInCubic: function easeInCubic(x, t, b, c, d) {
		return c * (t /= d) * t * t + b;
	},
	easeOutCubic: function easeOutCubic(x, t, b, c, d) {
		return c * ((t = t / d - 1) * t * t + 1) + b;
	},
	easeInOutCubic: function easeInOutCubic(x, t, b, c, d) {
		if ((t /= d / 2) < 1) return c / 2 * t * t * t + b;
		return c / 2 * ((t -= 2) * t * t + 2) + b;
	},
	easeInQuart: function easeInQuart(x, t, b, c, d) {
		return c * (t /= d) * t * t * t + b;
	},
	easeOutQuart: function easeOutQuart(x, t, b, c, d) {
		return -c * ((t = t / d - 1) * t * t * t - 1) + b;
	},
	easeInOutQuart: function easeInOutQuart(x, t, b, c, d) {
		if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
		return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
	},
	easeInQuint: function easeInQuint(x, t, b, c, d) {
		return c * (t /= d) * t * t * t * t + b;
	},
	easeOutQuint: function easeOutQuint(x, t, b, c, d) {
		return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
	},
	easeInOutQuint: function easeInOutQuint(x, t, b, c, d) {
		if ((t /= d / 2) < 1) return c / 2 * t * t * t * t * t + b;
		return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
	},
	easeInSine: function easeInSine(x, t, b, c, d) {
		return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
	},
	easeOutSine: function easeOutSine(x, t, b, c, d) {
		return c * Math.sin(t / d * (Math.PI / 2)) + b;
	},
	easeInOutSine: function easeInOutSine(x, t, b, c, d) {
		return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
	},
	easeInExpo: function easeInExpo(x, t, b, c, d) {
		return t == 0 ? b : c * Math.pow(2, 10 * (t / d - 1)) + b;
	},
	easeOutExpo: function easeOutExpo(x, t, b, c, d) {
		return t == d ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b;
	},
	easeInOutExpo: function easeInOutExpo(x, t, b, c, d) {
		if (t == 0) return b;
		if (t == d) return b + c;
		if ((t /= d / 2) < 1) return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
		return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
	},
	easeInCirc: function easeInCirc(x, t, b, c, d) {
		return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
	},
	easeOutCirc: function easeOutCirc(x, t, b, c, d) {
		return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
	},
	easeInOutCirc: function easeInOutCirc(x, t, b, c, d) {
		if ((t /= d / 2) < 1) return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b;
		return c / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
	},
	easeInElastic: function easeInElastic(x, t, b, c, d) {
		var s = 1.70158;var p = 0;var a = c;
		if (t == 0) return b;if ((t /= d) == 1) return b + c;if (!p) p = d * .3;
		if (a < Math.abs(c)) {
			a = c;var s = p / 4;
		} else var s = p / (2 * Math.PI) * Math.asin(c / a);
		return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
	},
	easeOutElastic: function easeOutElastic(x, t, b, c, d) {
		var s = 1.70158;var p = 0;var a = c;
		if (t == 0) return b;if ((t /= d) == 1) return b + c;if (!p) p = d * .3;
		if (a < Math.abs(c)) {
			a = c;var s = p / 4;
		} else var s = p / (2 * Math.PI) * Math.asin(c / a);
		return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b;
	},
	easeInOutElastic: function easeInOutElastic(x, t, b, c, d) {
		var s = 1.70158;var p = 0;var a = c;
		if (t == 0) return b;if ((t /= d / 2) == 2) return b + c;if (!p) p = d * (.3 * 1.5);
		if (a < Math.abs(c)) {
			a = c;var s = p / 4;
		} else var s = p / (2 * Math.PI) * Math.asin(c / a);
		if (t < 1) return -.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
		return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p) * .5 + c + b;
	},
	easeInBack: function easeInBack(x, t, b, c, d, s) {
		if (s == undefined) s = 1.70158;
		return c * (t /= d) * t * ((s + 1) * t - s) + b;
	},
	easeOutBack: function easeOutBack(x, t, b, c, d, s) {
		if (s == undefined) s = 1.70158;
		return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
	},
	easeInOutBack: function easeInOutBack(x, t, b, c, d, s) {
		if (s == undefined) s = 1.70158;
		if ((t /= d / 2) < 1) return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
		return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
	},
	easeInBounce: function easeInBounce(x, t, b, c, d) {
		return c - jQuery.easing.easeOutBounce(x, d - t, 0, c, d) + b;
	},
	easeOutBounce: function easeOutBounce(x, t, b, c, d) {
		if ((t /= d) < 1 / 2.75) {
			return c * (7.5625 * t * t) + b;
		} else if (t < 2 / 2.75) {
			return c * (7.5625 * (t -= 1.5 / 2.75) * t + .75) + b;
		} else if (t < 2.5 / 2.75) {
			return c * (7.5625 * (t -= 2.25 / 2.75) * t + .9375) + b;
		} else {
			return c * (7.5625 * (t -= 2.625 / 2.75) * t + .984375) + b;
		}
	},
	easeInOutBounce: function easeInOutBounce(x, t, b, c, d) {
		if (t < d / 2) return jQuery.easing.easeInBounce(x, t * 2, 0, c, d) * .5 + b;
		return jQuery.easing.easeOutBounce(x, t * 2 - d, 0, c, d) * .5 + c * .5 + b;
	}
});

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var jQuery = __webpack_require__(3);

/*jslint undef: true, browser: true, continue: true, eqeq: true, vars: true, forin: true, white: true, newcap: false, nomen: true, plusplus: true, maxerr: 50, indent: 4 */

/**
 * jGestures: a jQuery plugin for gesture events
 * Copyright 2010-2011 Neue Digitale / Razorfish GmbH
 * Copyright 2011-2012, Razorfish GmbH
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @fileOverview
 * Razorfish GmbH javascript library: add touch events such as 'pinch',
 * 'rotate', 'swipe', 'tap' and 'orientationchange' on capable user agents.
 * For incapable devices there's a basic event substitution: a "tapone" event
 * can be triggered by "clicking", a "swipeone" by performing a swipe-ish
 * gesture using the mouse (buttondown - mousemove - buttonup).
 *
 * This is still a beta version, bugfixes and improvements appreciated.
 *
 * @author martin.krause@razorfish.de
 * @version 0.90-shake
 *
 * @requires
 * jQuery JavaScript Library v1.4.2 - http://jquery.com/
 *	Copyright 2010, John Resig
 *	Dual licensed under the MIT or GPL Version 2 licenses.
 *	http://jquery.org/license
 *
 * @example	jQuery('#swipe').bind('swipeone',eventHandler);
 *
 * Notification on native events:
 * On every native touchstart, touchend, gesturestart and gestureend-event,
 * jgestures triggers a corresponding custom event
 * ('jGestures.touchstart', 'jGestures.touchend;start', 'jGestures.touchend;processed',
 * 'jGestures.gesturestart', 'jGestures.gestureend;start', 'jGestures.gestureend;processed') on the event-element.
 * The  eventhandler's second argument represents the original touch event (yes: including all touchpoints).
 * Use this if you need very detailed control e.g. kinetic scrolling or implementing additional gestures.
 *
 * Every jGesture-eventhandler receives a custom object as second argument
 * containing the original event (originalEvent property) and processed
 * information (such as delta values and timesptamp).
 * Example:{
 *				type: eventtype e.g. "swipe","pinch",
 *				originalEvent: {DOM-Event},
 *				// default: just one entry on the delta-array - the first touchpoint
 *				// the first touchpoint is the reference point for every gesture,
 *				// because moving touchpoints in various directions would result in
 *				// a gesture.
 *				// delta and direction details are just provided for touch not for gesture / motion events
 *				delta : [
 *					{
 *						lastX:{Number} , // x-axis: relative to the last touchevent (e.g. touchmove!)
 *						lastY:{Number}, // y-axis: relative to the last touchevent (e.g. touchmove!)
 *						moved: {Number},  // distance: relative to the original touchpoint
 *						startX: {Number} , // relative to the original touchpoint
 *						startY: {Number} ,// relative to the original touchpoint
 *					} ],
 *				// based on the first touchpoint
 *				direction : { // relative to the last touchevent (e.g. touchmove!)
 *					vector: {Number}, // -1|+1, indicates the direction if necessary(pinch/rotate)
 *					orientation: {Number} // window.orientation: -90,0,90,180 || null (window.orienntation)
 *					lastX : {Number}, // -1,0,+1 || null (orientationchange) // relative to the last touchevent (e.g. touchmove!)
 *					lastY : {Number}, // -1,0,+1 || null (orientationchange)// relative to the last touchevent (e.g. touchmove!)
 *					startX: {Number} , // relative to the original touchpoint
 *					startY: {Number} ,// relative to the original touchpoint
 *				},
 *				rotation: {Number} || null, // gestureonly: amount of rotation relative to the current position NOT the original
 *				scale: {Number} || null, // gestureonly: amount of scaling relative to the current position NOT the original
 *				duration: {Number}, // ms: relative to the original touchpoint
 *				description : {String} // details as String: {TYPE *}:{TOUCHES 1|2|3|4}:{X-AXIS 'right'|'left'|'steady'}:{Y-AXIS 'down'|'up'|'steady'} e.g. "swipe:1:left:steady" relative to the last touchpoint
 *			};
 *
 * Available jGesture-events can be grouped into:
 *
 *
 * Device events:
 *	The jGesture-Events in this group are triggered by the device.
 *
 * @event 'orientationchange'
 *		The device is turned clockwise or counterclockwise. This event is triggered
 *		by the device and might use an internal gyroscope.
 *	obj.description:
 *		orientationchange:landscape:clockwise:-90
 *		orientationchange:portrait:default:0
 *		orientationchange:landscape:counterclockwise|portrait:90
 *		orientationchange:portrait:upsidedown:180
 *
 *
 * Move events:
 *	The jGesture-Events in this group are triggered during the touch/gesture
 *	execution whenever a touchpoint changes.
 *	In contrast to touchend/gestureend-events which are triggered after
 *	the touch/gesture has completed.
 *
 * @event 'pinch'
 *		Is triggered during a pinch gesture (two fingers moving away from or
 *		towards each other).
 *	obj.description:
 *		pinch:-1:close
 *		pinch:+1:open
 *
 * @event 'rotate'
 *		Is triggered during a rotation gesture (two fingers rotating clockwise
 *		or counterclockwise).
 *	obj.description:
 *		rotate:-1:counterclockwise
 *		rotate:+1:+clockwise
 *
 * @event 'swipemove'
 *		Is triggered during a swipe move gesture (finger(s) being moved around
 *		the device, e.g. dragging)
 *	obj.description:
 *		swipemove:1:left:down
 *		swipemove:1:left:up
 *		swipemove:1:left:steady
 *		swipemove:1:right:down
 *		swipemove:1:right:up
 *		swipemove:1:right:steady
 *		swipemove:2:left:down
 *		swipemove:2:left:up
 *		swipemove:2:left:steady
 *		swipemove:2:right:down
 *		swipemove:2:right:up
 *		swipemove:2:right:steady
 *		swipemove:2:left:down
 *		swipemove:3:left:up
 *		swipemove:3:left:steady
 *		swipemove:3:right:down
 *		swipemove:3:right:up
 *		swipemove:3:right:steady
 *		swipemove:3:left:down
 *		swipemove:4:left:up
 *		swipemove:4:left:steady
 *		swipemove:4:right:down
 *		swipemove:4:right:up
 *		swipemove:4:right:steady
 *
 *
 * Toucheend events:
 *	The jGesture-Events in this group are triggered after the touch/gesture
 *	has completed.
 *	In contrast to touchmove-events which are triggered during the touch/gesture
 *	execution whenever a touchpoint changes.
 *
 * @event 'swipeone'
 *		Is triggered after a swipe move gesture with one touchpoint (one finger
 *		was moved around the device)
 *	obj.description:
 *		swipeone:1:left:down
 *		swipeone:1:left:up
 *		swipeone:1:left:steady
 *		swipeone:1:right:down
 *		swipeone:1:right:up
 *		swipeone:1:right:steady
 *
 * @event 'swipetwo'
 *		Is triggered after a swipe move gesture with two touchpoints (two fingers
 *		were moved around the device)
 *	obj.description:
 *		swipetwo:2:left:down
 *		swipetwo:2:left:up
 *		swipetwo:2:left:steady
 *		swipetwo:2:right:down
 *		swipetwo:2:right:up
 *		swipetwo:2:right:steady
 *
 * @event 'swipethree'
 *		Is triggered after a swipe move gesture with three touchpoints (three
 *		fingers were moved around the device)
 *	obj.description:
 *		swipethree:3:left:down
 *		swipethree:3:left:up
 *		swipethree:3:left:steady
 *		swipethree:3:right:down
 *		swipethree:3:right:up
 *		swipethree:3:right:steady
 *
 * @event 'swipefour'
 *		Is triggered after a swipe move gesture with four touchpoints (four
 *		fingers were moved around the device)
 *	obj.description:
 *		swipefour:4:left:down
 *		swipefour:4:left:up
 *		swipefour:4:left:steady
 *		swipefour:4:right:down
 *		swipefour:4:right:up
 *		swipefour:4:right:steady
 *
 *
 * @event 'swipeup'
 *		Is triggered after an  strict upwards swipe move gesture
 *	obj.description:
 *		swipe:1:steady:up
 *		swipe:2:steady:up
 *		swipe:3:steady:up
 *		swipe:4:steady:up
 *
 * @event 'swiperightup'
 *		Is triggered after a rightwards and upwards swipe move gesture
 *	obj.description:
 *		swipe:1:right:up
 *		swipe:2:right:up
 *		swipe:3:right:up
 *		swipe:4:right:up
 *
 * @event 'swiperight'
 *		Is triggered after a  strict rightwards swipe move gesture
 *	obj.description:
 *		swipe:1:right:steady
 *		swipe:2:right:steady
 *		swipe:3:right:steady
 *		swipe:4:right:steady
 *
 * @event 'swiperightdown'
 *		Is triggered after a rightwards and downwards swipe move gesture
 *	obj.description:
 *		swipe:1:right:down
 *		swipe:2:right:down
 *		swipe:3:right:down
 *		swipe:4:right:down
 *
 * @event 'swipedown'
 *		Is triggered after a  strict downwards swipe move gesture
 *	obj.description:
 *		swipe:1:steady:down
 *		swipe:2:steady:down
 *		swipe:3:steady:down
 *		swipe:4:steady:down
 *
 * @event 'swipeleftdown'
 *		Is triggered after a leftwards and downwards swipe move gesture
 *	obj.description:
 *		swipe:1:left:down
 *		swipe:2:left:down
 *		swipe:3:left:down
 *		swipe:4:left:down
 *
 * @event 'swipeleft'
 *		Is triggered after a strict leftwards swipe move gesture
 *	obj.description:
 *		swipe:1:left:steady
 *		swipe:2:left:steady
 *		swipe:3:left:steady
 *		swipe:4:left:steady
 *
 * @event 'swipeleftup'
 *		Is triggered after a leftwards and upwards swipe move gesture
 *	obj.description:
 *		swipe:1:left:up
 *		swipe:2:left:up
 *		swipe:3:left:up
 *		swipe:4:left:up
 *
 * @event 'tapone'
 *		Is triggered after a single (one finger) tap gesture
 *	obj.description:
 *		tapone
 *
 * @event 'taptwo'
 *		Is triggered after a double (two finger) tap gesture
 *	obj.description:
 *		taptwo
 * *
 * @event 'tapthree'
 *		Is triggered after a tripple (three finger) tap gesture
 *	obj.description:
 *		tapthree
 *
 *
 * Gestureend events:
 *	A gesture is an interpretation of different touchpoints.
 *	The jGesture-Events in this group are triggered when a gesture has finished
 *	and the touchpoints are removed from the device.
 *
 * @event 'pinchopen'
 *		Is triggered when a pinchopen gesture (two fingers moving away from each
 *		other) occured and the touchpoints (fingers) are removed the device.
 *	obj.description:
 *		pinch:+1:open
 *
 * @event 'pinchclose'
 *		Is triggered when a pinchclose gesture (two fingers moving towards each
 *		other) occured and the touchpoints (fingers) are removed the device.
 *	obj.description:
 *		pinch:-1:close
 *
 * @event 'rotatecw'
 *		Is triggered when a clockwise rotation gesture (two fingers rotating
 *		clockwise) occured and the touchpoints (fingers) are removed the device.
 *	obj.description:
 *		rotate:+1:+clockwise
 *
 * @event 'rotateccw'
 *		Is triggered when a counterclockwise rotation gesture (two fingers
 *		rotating counterclockwise) occured and the touchpoints (fingers) are
 *		removed the device.
 *	obj.description:
 *		rotate:-1:+counterclockwise
 *
 *
 * Motion events:
 *  A "motion event" is an interpretation of changes in space, e.g. a "shaking motion"
 *  consists of a specified number of acceleration changes in a given interval.
 * For understanding "directions", place your mobile device on a table with the bottom
 * (home button) close to you:
 *  - x-axis: horizontal left / right
 *  - y-axis: horizontal front / back (through the home button)
 *  - z-axis: vertical through your device
 *
 *  Note: Devicemotion / deviceorientation don't send custom event (such as: jGestures.touchstart).
 *  Note: Devicemotion should be bound on the "window-element" - because the whole device moves
 *
 * @event 'shake'
 *		Is triggered when a shaking motion is detected
 *	obj.description:
 *		shake:leftright:x-axisfrontback:y-axis:updown:z-axis
 *
 * @event 'shakefrontback'
 *		Is triggered when a shaking motion is detected and the gesture can be interpreted as a mainly front-back movement.
  *	obj.description:
 *		shakefrontback:shakefrontback:y-axis
 *
 * @event 'shakeleftright'
 *		Is triggered when a shaking motion is detected and the gesture can be interpreted as a mainly left-right movement.
 *		Additional major movements are mentioned in the obj.description.
 *	obj.description:
 *		shakeleftright:leftright:x-axis
 *
 * @event 'shakeupdown'
 *		Is triggered when a shaking motion is detected and the gesture can be interpreted as a mainly up-down movement.
 *		Additional major movements are mentioned in the obj.description.
 *	obj.description:
 *		shake:shakeupdown:updown:z-axis
 *
 * @example
 *		.bind( eventType, [ eventData ], handler(eventObject) )
 * jQuery('body').bind('tapone',function(){alert(arguments[1].description);})
 *
 */

(function ($) {

	/**
 * General thresholds.
 */
	// @TODO: move to $...defaults
	// @TODO: shake to defaults freeze etc
	// change of x deg in y ms


	$.jGestures = {};
	$.jGestures.defaults = {};
	$.jGestures.defaults.thresholdShake = {
		requiredShakes: 10,
		freezeShakes: 100,
		frontback: {
			sensitivity: 10
		},
		leftright: {
			sensitivity: 10
		},
		updown: {
			sensitivity: 10
		}
	};

	$.jGestures.defaults.thresholdPinchopen = 0.05;
	$.jGestures.defaults.thresholdPinchmove = 0.05;
	$.jGestures.defaults.thresholdPinch = 0.05;
	$.jGestures.defaults.thresholdPinchclose = 0.05;
	$.jGestures.defaults.thresholdRotatecw = 5; //deg
	$.jGestures.defaults.thresholdRotateccw = 5; // deg
	// a tap becomes a swipe if x/y values changes are above this threshold
	$.jGestures.defaults.thresholdMove = 20;
	$.jGestures.defaults.thresholdSwipe = 100;
	// get capable user agents
	$.jGestures.data = {};
	$.jGestures.data.capableDevicesInUserAgentString = ['iPad', 'iPhone', 'iPod', 'Mobile Safari']; // basic functionality such as swipe, pinch, rotate, tap should work on every mobile safari, e.g. GalaxyTab
	$.jGestures.data.hasGestures = function () {
		var _i;for (_i = 0; _i < $.jGestures.data.capableDevicesInUserAgentString.length; _i++) {
			if (navigator.userAgent.indexOf($.jGestures.data.capableDevicesInUserAgentString[_i]) !== -1) {
				return true;
			}
		}return false;
	}();
	$.hasGestures = $.jGestures.data.hasGestures;
	$.jGestures.events = {
		touchstart: 'jGestures.touchstart',
		touchendStart: 'jGestures.touchend;start',
		touchendProcessed: 'jGestures.touchend;processed',
		gesturestart: 'jGestures.gesturestart',
		gestureendStart: 'jGestures.gestureend;start',
		gestureendProcessed: 'jGestures.gestureend;processed'
	};

	jQuery.each({
		// "first domevent necessary"_"touch event+counter" : "exposed as"
		// event: orientationchange
		orientationchange_orientationchange01: "orientationchange",
		// event: gestures
		gestureend_pinchopen01: "pinchopen",
		gestureend_pinchclose01: "pinchclose",
		gestureend_rotatecw01: 'rotatecw',
		gestureend_rotateccw01: 'rotateccw',
		// move events
		gesturechange_pinch01: 'pinch',
		gesturechange_rotate01: 'rotate',
		touchstart_swipe13: 'swipemove',
		// event: touches
		touchstart_swipe01: "swipeone",
		touchstart_swipe02: "swipetwo",
		touchstart_swipe03: "swipethree",
		touchstart_swipe04: "swipefour",
		touchstart_swipe05: 'swipeup',
		touchstart_swipe06: 'swiperightup',
		touchstart_swipe07: 'swiperight',
		touchstart_swipe08: 'swiperightdown',
		touchstart_swipe09: 'swipedown',
		touchstart_swipe10: 'swipeleftdown',
		touchstart_swipe11: 'swipeleft',
		touchstart_swipe12: 'swipeleftup',
		touchstart_tap01: 'tapone',
		touchstart_tap02: 'taptwo',
		touchstart_tap03: 'tapthree',
		touchstart_tap04: 'tapfour',

		devicemotion_shake01: 'shake',
		devicemotion_shake02: 'shakefrontback',
		devicemotion_shake03: 'shakeleftright',
		devicemotion_shake04: 'shakeupdown'

	},

	/**
 * Add gesture events inside the jQuery.event.special namespace
 */
	function (sInternal_, sPublicFN_) {

		// add as funciton to jQuery.event.special.sPublicFN_
		jQuery.event.special[sPublicFN_] = {

			/**
   * When the first event handler is bound, jQuery executes the setup function.
   * This plugin just uses one eventhandler per element, regardless of the number of bound events.
   * All Events are stored internally as properties on the dom-element using the $.data api.
   * The setup-function adds the eventlistener, acting as a proxy function for the internal events.
   * $.data.ojQueryGestures[_sDOMEvent ('tap') ] = {Boolean}
   * @return {Void}
   */
			setup: function setup() {
				// split the arguments to necessary controll arguements
				var _aSplit = sInternal_.split('_');
				var _sDOMEvent = _aSplit[0]; //
				// get the associated gesture event and strip the counter: necessary for distinguisihng similliar events such as tapone-tapfour
				var _sGestureEvent = _aSplit[1].slice(0, _aSplit[1].length - 2);
				var _$element = jQuery(this);
				var _oDatajQueryGestures;
				var oObj;
				// bind the event handler on the first $.bind() for a gestureend-event, set marker
				if (!_$element.data('ojQueryGestures') || !_$element.data('ojQueryGestures')[_sDOMEvent]) {
					// setup pseudo event
					_oDatajQueryGestures = _$element.data('ojQueryGestures') || {};
					oObj = {};
					// marker for:  domEvent being set on this element
					// e.g.: $.data.oGestureInternals['touchstart'] = true;
					// since they're grouped, i'm just marking the first one being added
					oObj[_sDOMEvent] = true;
					$.extend(true, _oDatajQueryGestures, oObj);
					_$element.data('ojQueryGestures', _oDatajQueryGestures);
					// add gesture events
					if ($.hasGestures) {
						switch (_sGestureEvent) {

							// event: orientationchange
							case 'orientationchange':
								_$element.get(0).addEventListener('orientationchange', _onOrientationchange, false);
								break;

							// event:
							// - shake
							// - tilt
							case 'shake':
							case 'shakefrontback':
							case 'shakeleftright':
							case 'shakeupdown':
							case 'tilt':
								//$.hasGyroscope = true //!window.DeviceOrientationEvent;
								//_$element.get(0).addEventListener('devicemotion', _onDevicemotion, false);
								//_$element.get(0).addEventListener('deviceorientation', _onDeviceorientation, false);
								_$element.get(0).addEventListener('devicemotion', _onDevicemotion, false);
								break;

							// event:
							// - touchstart
							// - touchmove
							// - touchend
							case 'tap':
							case 'swipe':
							case 'swipeup':
							case 'swiperightup':
							case 'swiperight':
							case 'swiperightdown':
							case 'swipedown':
							case 'swipeleftdown':
							case 'swipeleft':
								_$element.get(0).addEventListener('touchstart', _onTouchstart, false);
								break;

							// event: gestureend
							case 'pinchopen':
							case 'pinchclose':
							case 'rotatecw':
							case 'rotateccw':
								_$element.get(0).addEventListener('gesturestart', _onGesturestart, false);
								_$element.get(0).addEventListener('gestureend', _onGestureend, false);
								break;

							// event: gesturechange
							case 'pinch':
							case 'rotate':
								_$element.get(0).addEventListener('gesturestart', _onGesturestart, false);
								_$element.get(0).addEventListener('gesturechange', _onGesturechange, false);
								break;
						}
					}
					// create substitute for gesture events
					else {
							switch (_sGestureEvent) {
								// event substitutes:
								// - touchstart: mousedown
								// - touchmove: none
								// - touchend: mouseup
								case 'tap':
								case 'swipe':
									// _$element.get(0).addEventListener('mousedown', _onTouchstart, false);
									_$element.bind('mousedown', _onTouchstart);
									break;

								// no substitution
								case 'orientationchange':
								case 'pinchopen':
								case 'pinchclose':
								case 'rotatecw':
								case 'rotateccw':
								case 'pinch':
								case 'rotate':
								case 'shake':
								case 'tilt':

									break;
							}
						}
				}
				return false;
			},

			/**
   * For every $.bind(GESTURE) the add-function will be called.
   * Instead of binding an actual eventlister, the event is stored as $.data on the element.
   * The handler will be triggered using $.triggerHandler(GESTURE) if the internal
   * eventhandler (proxy being bound on setup()) detects a GESTURE event
   * @param {Object} event_ jQuery-Event-Object being passed by $.bind()
   * @return {Void}
   */
			add: function add(event_) {
				// add pseudo event: properties on $.data
				var _$element = jQuery(this);
				var _oDatajQueryGestures = _$element.data('ojQueryGestures');
				//					_oDatajQueryGestures[event_.type] = { 'originalType' : event_.type , 'threshold' : event_.data.threshold, 'preventDefault' : event_.data.preventDefault } ;
				_oDatajQueryGestures[event_.type] = { 'originalType': event_.type };
				return false;
			},

			/**
   * For every $.unbind(GESTURE) the remove-function will be called.
   * Instead of removing the actual eventlister, the event is removed from $.data on the element.
   * @param {Object} event_ jQuery-Event-Object being passed by $.bind()
   * @return {Void}
   */
			remove: function remove(event_) {
				// remove pseudo event: properties on $.data
				var _$element = jQuery(this);
				var _oDatajQueryGestures = _$element.data('ojQueryGestures');
				_oDatajQueryGestures[event_.type] = false;
				_$element.data('ojQueryGestures', _oDatajQueryGestures);
				return false;
			},

			/**
   * The last $.unbind()-call on the domElement triggers the teardown function
   * removing the eventlistener
   * @return {Void}
   */
			// @TODO: maybe rework teardown to work with event type?!
			teardown: function teardown() {
				// split the arguments to necessary controll arguements
				var _aSplit = sInternal_.split('_');
				var _sDOMEvent = _aSplit[0]; //
				// get the associated gesture event and strip the counter: necessary for distinguisihng similliar events such as tapone-tapfour
				var _sGestureEvent = _aSplit[1].slice(0, _aSplit[1].length - 2);
				var _$element = jQuery(this);
				var _oDatajQueryGestures;
				var oObj;
				// bind the event handler on the first $.bind() for a gestureend-event, set marker
				if (!_$element.data('ojQueryGestures') || !_$element.data('ojQueryGestures')[_sDOMEvent]) {
					// setup pseudo event
					_oDatajQueryGestures = _$element.data('ojQueryGestures') || {};
					oObj = {};
					// remove marker for:  domEvent being set on this element
					oObj[_sDOMEvent] = false;
					$.extend(true, _oDatajQueryGestures, oObj);
					_$element.data('ojQueryGestures', _oDatajQueryGestures);

					// remove gesture events
					if ($.hasGestures) {
						switch (_sGestureEvent) {

							// event: orientationchange
							case 'orientationchange':
								_$element.get(0).removeEventListener('orientationchange', _onOrientationchange, false);
								break;

							case 'shake':
							case 'shakefrontback':
							case 'shakeleftright':
							case 'shakeupdown':
							case 'tilt':
								_$element.get(0).removeEventListener('devicemotion', _onDevicemotion, false);
								break;

							// event :
							// - touchstart
							// - touchmove
							// - touchend
							case 'tap':
							case 'swipe':
							case 'swipeup':
							case 'swiperightup':
							case 'swiperight':
							case 'swiperightdown':
							case 'swipedown':
							case 'swipeleftdown':
							case 'swipeleft':
							case 'swipeleftup':
								_$element.get(0).removeEventListener('touchstart', _onTouchstart, false);
								_$element.get(0).removeEventListener('touchmove', _onTouchmove, false);
								_$element.get(0).removeEventListener('touchend', _onTouchend, false);
								break;

							// event: gestureend
							case 'pinchopen':
							case 'pinchclose':
							case 'rotatecw':
							case 'rotateccw':
								_$element.get(0).removeEventListener('gesturestart', _onGesturestart, false);
								_$element.get(0).removeEventListener('gestureend', _onGestureend, false);
								break;

							// event: gesturechange
							case 'pinch':
							case 'rotate':
								_$element.get(0).removeEventListener('gesturestart', _onGesturestart, false);
								_$element.get(0).removeEventListener('gesturechange', _onGesturechange, false);
								break;
						}
					}
					// remove substitute for gesture events
					else {
							switch (_sGestureEvent) {
								// event substitutes:
								// - touchstart: mousedown
								// - touchmove: none
								// - touchend: mouseup
								case 'tap':
								case 'swipe':
									//									_$element.get(0).removeEventListener('mousedown', _onTouchstart, false);
									//									_$element.get(0).removeEventListener('mousemove', _onTouchmove, false);
									//									_$element.get(0).removeEventListener('mouseup', _onTouchend, false);
									_$element.unbind('mousedown', _onTouchstart);
									_$element.unbind('mousemove', _onTouchmove);
									_$element.unbind('mouseup', _onTouchend);
									break;

								// no substitution
								case 'orientationchange':
								case 'pinchopen':
								case 'pinchclose':
								case 'rotatecw':
								case 'rotateccw':
								case 'pinch':
								case 'rotate':
								case 'shake':
								case 'tilt':

									break;
							}
						}
				}
				return false;
			}

		};
	});

	/**
 * Creates the object that ist passed as second argument to the $element.triggerHandler function.
 * This object contains detailed informations about the gesture event.
 * @param {Object} oOptions_  {type: {String}, touches: {String}, deltaY: {String},deltaX : {String}, startMove: {Object}, event:{DOM-Event}, timestamp:{String},vector: {Number}}
 * @example _createOptions (
 *				{
 *					type: 'swipemove',
 *					touches: '1',
 *					deltaY: _iDeltaY,
 *					deltaX : _iDeltaX,
 *					startMove: _oDatajQueryGestures.oStartTouch,
 *					event:event_,
 *					timestamp:_oEventData.timestamp,
 *					vector: -1
 *				}
 *			);
 * @returns {Object}
 *			{
 *				type: eventtype e.g. "swipe","pinch",
 *				originalEvent: {DOM-Event},
 *				// default: just one entry on the delta-array - the first touchpoint
 *				// the first touchpoint is the reference point for every gesture,
 *				// because moving touchpoints in various directions would result in
 *				// a gesture.
 *				// delta and direction details are just provided for touch not for gesture / motion events
 *				delta : [
 *					{
 *						lastX:{Number} , // x-axis: relative to the last touchevent (e.g. touchmove!)
 *						lastY:{Number}, // y-axis: relative to the last touchevent (e.g. touchmove!)
 *						moved: {Number},  // distance: relative to the original touchpoint
 *						startX: {Number} , // relative to the original touchpoint
 *						startY: {Number} ,// relative to the original touchpoint
 *					} ],
 *				// based on the first touchpoint
 *				direction : { // relative to the last touchevent (e.g. touchmove!)
 *					vector: {Number}, // -1|+1, indicates the direction if necessary(pinch/rotate)
 *					orientation: {Number} // window.orientation: -90,0,90,180 || null (window.orienntation)
 *					lastX : {Number}, // -1,0,+1 relative to the last touchevent (e.g. touchmove!)
 *					lastY : {Number}, // -1,0,+1 relative to the last touchevent (e.g. touchmove!)
 *					startX: {Number} , //-1,0,+1 relative to the original touchpoint
 *					startY: {Number} ,// -1,0,+1 relative to the original touchpoint
 *				},
 *				rotation: {Number} || null, // gestureonly: amount of rotation relative to the current position NOT the original
 *				scale: {Number} || null, // gestureonly: amount of scaling relative to the current position NOT the original
 *				duration: {Number}, // ms: relative to the original touchpoint
 *				description : {String} // details as String: {TYPE *}:{TOUCHES 1|2|3|4}:{X-AXIS 'right'|'left'|'steady'}:{Y-AXIS 'down'|'up'|'steady'} e.g. "swipe:1:left:steady" relative to the last touchpoint
 *			};
 */
	function _createOptions(oOptions_) {
		// force properties
		oOptions_.startMove = oOptions_.startMove ? oOptions_.startMove : { startX: null, startY: null, timestamp: null };
		var _iNow = new Date().getTime();
		var _oDirection;
		var _oDelta;
		// calculate touch differences
		if (oOptions_.touches) {
			// store delta values
			_oDelta = [{
				lastX: oOptions_.deltaX,
				lastY: oOptions_.deltaY,
				moved: null,
				startX: oOptions_.screenX - oOptions_.startMove.screenX,
				startY: oOptions_.screenY - oOptions_.startMove.screenY
			}];

			_oDirection = {
				vector: oOptions_.vector || null,
				orientation: window.orientation || null,
				lastX: _oDelta[0].lastX > 0 ? +1 : _oDelta[0].lastX < 0 ? -1 : 0,
				lastY: _oDelta[0].lastY > 0 ? +1 : _oDelta[0].lastY < 0 ? -1 : 0,
				startX: _oDelta[0].startX > 0 ? +1 : _oDelta[0].startX < 0 ? -1 : 0,
				startY: _oDelta[0].startY > 0 ? +1 : _oDelta[0].startY < 0 ? -1 : 0
			};

			// calculate distance traveled using the pythagorean theorem
			_oDelta[0].moved = Math.sqrt(Math.pow(Math.abs(_oDelta[0].startX), 2) + Math.pow(Math.abs(_oDelta[0].startY), 2));
		}
		return {
			type: oOptions_.type || null,
			originalEvent: oOptions_.event || null,
			delta: _oDelta || null,
			direction: _oDirection || { orientation: window.orientation || null, vector: oOptions_.vector || null },
			duration: oOptions_.duration ? oOptions_.duration : oOptions_.startMove.timestamp ? _iNow - oOptions_.timestamp : null,
			rotation: oOptions_.rotation || null,
			scale: oOptions_.scale || null,
			description: oOptions_.description || [oOptions_.type, ':', oOptions_.touches, ':', _oDelta[0].lastX != 0 ? _oDelta[0].lastX > 0 ? 'right' : 'left' : 'steady', ':', _oDelta[0].lastY != 0 ? _oDelta[0].lastY > 0 ? 'down' : 'up' : 'steady'].join('')
		};
	}

	/**
 * DOM-event handlers
 */

	/**
 * Handler: orientationchange
 * Triggers the bound orientationchange handler on the window element
 * The "orientationchange" handler will receive an object with additional information
 * about the event.
 *  {
 *	direction : {
 *		orientation: {-90|0|90|180}
 *	},
 *	description : [
 *		'orientationchange:{landscape:clockwise:|portrait:default|landscape:counterclockwise|portrait:upsidedown}:{-90|0|90|180}' // e.g. 'orientation:landscape:clockwise:-90
 *	}
 * @param {DOM-Event} event_
 * @return {Void}
 */
	function _onOrientationchange(event_) {

		// window.orientation: -90,0,90,180
		var _aDict = ['landscape:clockwise:', 'portrait:default:', 'landscape:counterclockwise:', 'portrait:upsidedown:'];

		$(window).triggerHandler('orientationchange', {
			direction: { orientation: window.orientation },
			description: ['orientationchange:', _aDict[window.orientation / 90 + 1], window.orientation].join('')
		});
	}

	/**
 * Handler: devicemotion
 * Calculates "motion events" such as shake, tilt, wiggle by observing "changes in space"
 * For understanding "directions", place your mobile device on a table with the bottom
 * (home button) close to you:
 *  - x-axis: horizontal left / right
 *  - y-axis: horizontal front / back (through the home button)
 *  - z-axis: vertical through your device
 * @param {DOM-Event} event_
 * @returns {Object}
 *			{
 *				type: eventtype e.g. "shake",
 *				originalEvent: {DOM-Event},
 *				// delta and direction details are just provided for touch not for gesture / motion events
 *				delta : null,
 *				direction :{
 *					vector: null,
 *					orientation: -90,0,90,180 || null (window.orienntation)
 *				}
 *				rotation: {Number} , //  amount of rotation relative to the current position NOT the original
 *				scale: {Number} , // amount of scaling relative to the current position NOT the original
 *				duration: {Number}, // ms: duration of the motion
 *				description : {String} // details as String: pinch:{'close'|'open'} e.g. "pinch:-1:close" ||  rotate:{'counterclockwise'|'clockwise'} e.g. "rotate:-1:counterclockwise"
 *			};
 * @param {DOM-Event} event_
 * @return {Void}
 */
	function _onDevicemotion(event_) {

		var _sType;
		var _$element = jQuery(window);
		//var _bHasGyroscope = $.hasGyroscope;

		// skip custom notification: devicemotion is triggered every 0.05s regardlesse of any gesture

		// get options
		var _oDatajQueryGestures = _$element.data('ojQueryGestures');

		var _oThreshold = $.jGestures.defaults.thresholdShake;

		// get last position or set initital values
		var _oLastDevicePosition = _oDatajQueryGestures.oDeviceMotionLastDevicePosition || {
			accelerationIncludingGravity: {
				x: 0,
				y: 0,
				z: 0
			},
			shake: {
				eventCount: 0,
				intervalsPassed: 0,
				intervalsFreeze: 0
			},
			shakeleftright: {
				eventCount: 0,
				intervalsPassed: 0,
				intervalsFreeze: 0
			},
			shakefrontback: {
				eventCount: 0,
				intervalsPassed: 0,
				intervalsFreeze: 0
			},
			shakeupdown: {
				eventCount: 0,
				intervalsPassed: 0,
				intervalsFreeze: 0
			}
		};

		// cache current values
		var _oCurrentDevicePosition = {
			accelerationIncludingGravity: {
				x: event_.accelerationIncludingGravity.x,
				y: event_.accelerationIncludingGravity.y,
				z: event_.accelerationIncludingGravity.z
			},
			shake: {
				eventCount: _oLastDevicePosition.shake.eventCount,
				intervalsPassed: _oLastDevicePosition.shake.intervalsPassed,
				intervalsFreeze: _oLastDevicePosition.shake.intervalsFreeze
			},
			shakeleftright: {
				eventCount: _oLastDevicePosition.shakeleftright.eventCount,
				intervalsPassed: _oLastDevicePosition.shakeleftright.intervalsPassed,
				intervalsFreeze: _oLastDevicePosition.shakeleftright.intervalsFreeze
			},
			shakefrontback: {
				eventCount: _oLastDevicePosition.shakefrontback.eventCount,
				intervalsPassed: _oLastDevicePosition.shakefrontback.intervalsPassed,
				intervalsFreeze: _oLastDevicePosition.shakefrontback.intervalsFreeze
			},
			shakeupdown: {
				eventCount: _oLastDevicePosition.shakeupdown.eventCount,
				intervalsPassed: _oLastDevicePosition.shakeupdown.intervalsPassed,
				intervalsFreeze: _oLastDevicePosition.shakeupdown.intervalsFreeze
			}

		};

		// options
		var _aType;
		var _aDescription;
		var _oObj;

		// trigger events for all bound pseudo events on this element
		for (_sType in _oDatajQueryGestures) {
			// get current pseudo event


			// trigger bound events on this element
			switch (_sType) {

				case 'shake':
				case 'shakeleftright':
				case 'shakefrontback':
				case 'shakeupdown':

					// options
					_aType = [];
					_aDescription = [];

					_aType.push(_sType);

					// freeze shake - prevent multiple shake events on one  shaking motion (user won't stop shaking immediately)
					if (++_oCurrentDevicePosition[_sType].intervalsFreeze > _oThreshold.freezeShakes && _oCurrentDevicePosition[_sType].intervalsFreeze < 2 * _oThreshold.freezeShakes) {
						break;
					}

					// set control values
					_oCurrentDevicePosition[_sType].intervalsFreeze = 0;
					_oCurrentDevicePosition[_sType].intervalsPassed++;

					// check for shaking motions: massive acceleration changes in every direction
					if ((_sType === 'shake' || _sType === 'shakeleftright') && (_oCurrentDevicePosition.accelerationIncludingGravity.x > _oThreshold.leftright.sensitivity || _oCurrentDevicePosition.accelerationIncludingGravity.x < -1 * _oThreshold.leftright.sensitivity)) {
						_aType.push('leftright');
						_aType.push('x-axis');
					}

					if ((_sType === 'shake' || _sType === 'shakefrontback') && (_oCurrentDevicePosition.accelerationIncludingGravity.y > _oThreshold.frontback.sensitivity || _oCurrentDevicePosition.accelerationIncludingGravity.y < -1 * _oThreshold.frontback.sensitivity)) {
						_aType.push('frontback');
						_aType.push('y-axis');
					}

					if ((_sType === 'shake' || _sType === 'shakeupdown') && (_oCurrentDevicePosition.accelerationIncludingGravity.z + 9.81 > _oThreshold.updown.sensitivity || _oCurrentDevicePosition.accelerationIncludingGravity.z + 9.81 < -1 * _oThreshold.updown.sensitivity)) {
						_aType.push('updown');
						_aType.push('z-axis');
					}

					// at least one successful shaking event
					if (_aType.length > 1) {
						// minimum number of shaking motions during  the defined "time" (messured by events - device event interval: 0.05s)
						if (++_oCurrentDevicePosition[_sType].eventCount == _oThreshold.requiredShakes && _oCurrentDevicePosition[_sType].intervalsPassed < _oThreshold.freezeShakes) {
							// send event
							_$element.triggerHandler(_sType, _createOptions({ type: _sType, description: _aType.join(':'), event: event_, duration: _oCurrentDevicePosition[_sType].intervalsPassed * 5 }));
							// reset
							_oCurrentDevicePosition[_sType].eventCount = 0;
							_oCurrentDevicePosition[_sType].intervalsPassed = 0;
							// freeze shake
							_oCurrentDevicePosition[_sType].intervalsFreeze = _oThreshold.freezeShakes + 1;
						}
						// too slow, reset
						else if (_oCurrentDevicePosition[_sType].eventCount == _oThreshold.requiredShakes && _oCurrentDevicePosition[_sType].intervalsPassed > _oThreshold.freezeShakes) {
								_oCurrentDevicePosition[_sType].eventCount = 0;
								_oCurrentDevicePosition[_sType].intervalsPassed = 0;
							}
					}
					break;

			}

			// refresh pseudo events
			_oObj = {};
			_oObj.oDeviceMotionLastDevicePosition = _oCurrentDevicePosition;
			_$element.data('ojQueryGestures', $.extend(true, _oDatajQueryGestures, _oObj));
		}
	}

	/**
 * Handler: touchstart or mousedown
 * Setup pseudo-event by storing initial values such as :
 *	screenX : {Number}
 *	screenY : {Number}
 *	timestamp: {Number}
 *  on the pseudo gesture event and
 *  sets up additional eventlisteners for handling touchmove events.
 * @param {DOM-Event} event_
 * @return {Void}
 */
	function _onTouchstart(event_) {

		// ignore bubbled handlers
		// if ( event_.currentTarget !== event_.target ) { return; }

		var _$element = jQuery(event_.currentTarget);
		// var _$element = jQuery(event_.target);

		// trigger custom notification
		_$element.triggerHandler($.jGestures.events.touchstart, event_);

		// set the necessary touch events
		if ($.hasGestures) {
			event_.currentTarget.addEventListener('touchmove', _onTouchmove, false);
			event_.currentTarget.addEventListener('touchend', _onTouchend, false);
		}
		// event substitution
		else {
				//			event_.currentTarget.addEventListener('mousemove', _onTouchmove, false);
				//			event_.currentTarget.addEventListener('mouseup', _onTouchend, false);
				_$element.bind('mousemove', _onTouchmove);
				_$element.bind('mouseup', _onTouchend);
			}

		// get stored pseudo event
		var _oDatajQueryGestures = _$element.data('ojQueryGestures');

		// var _oEventData = _oDatajQueryGestures[_sType];
		var _eventBase = event_.touches ? event_.touches[0] : event_;
		// store current values for calculating relative values (changes between touchmoveevents)
		var _oObj = {};
		_oObj.oLastSwipemove = { screenX: _eventBase.screenX, screenY: _eventBase.screenY, timestamp: new Date().getTime() };
		_oObj.oStartTouch = { screenX: _eventBase.screenX, screenY: _eventBase.screenY, timestamp: new Date().getTime() };

		_$element.data('ojQueryGestures', $.extend(true, _oDatajQueryGestures, _oObj));
	}

	/**
 * Handler: touchmove or mousemove
 * Calculates the x/y changes since the last event,
 * compares it to $.jGestures.defaults.thresholdMove and triggers
 * an swipemove event if the distance exceed the
 * threshold.
 * Custom-event argument object:
 * {Object}
 *			{
 *				type: e.g. 'swipemove',
 *				≈: {DOM-Event},
 *				// default: just one entry on the delta-array - the first touchpoint
 *				// the first touchpoint is the reference point for every gesture,
 *				// because moving touchpoints in various directions would result in
 *				// a gesture.
 *				// delta and direction details are just provided for touch not for gesture / motion events
 *				delta : [
 *					{
 *						lastX:{Number} , // x-axis: relative to the last touchevent (e.g. touchmove!)
 *						lastY:{Number}, // y-axis: relative to the last touchevent (e.g. touchmove!)
 *						moved: {Number},  // distance: relative to the original touchpoint
 *						startX: {Number} , // relative to the original touchpoint
 *						startY: {Number} ,// relative to the original touchpoint
 *					} ],
 *				// based on the first touchpoint
 *				direction : { // relative to the last touchevent (e.g. touchmove!)
 *					vector: {Number}, // -1|+1, indicates the direction if necessary(pinch/rotate)
 *					orientation: {Number} // window.orientation: -90,0,90,180 || null (window.orienntation)
 *					lastX : {Number}, // -1,0,+1 relative to the last touchevent (e.g. touchmove!)
 *					lastY : {Number}, // -1,0,+1 relative to the last touchevent (e.g. touchmove!)
 *					startX: {Number} , //-1,0,+1 relative to the original touchpoint
 *					startY: {Number} ,// -1,0,+1 relative to the original touchpoint
 *				},
 *				rotation: null, // gestureonly: amount of rotation relative to the current position NOT the original
 *				scale: null, // gestureonly: amount of scaling relative to the current position NOT the original
 *				duration: {Number}, // ms: relative to the original touchpoint
 *				description : {String} // details as String: {TYPE *}:{TOUCHES 1|2|3|4}:{X-AXIS 'right'|'left'|'steady'}:{Y-AXIS 'down'|'up'|'steady'} e.g. "swipe:1:left:steady" relative to the last touchpoint
 *			};
 *
 * @param {DOM-Event} event_
 * @return {Void}
 */
	function _onTouchmove(event_) {

		var _$element = jQuery(event_.currentTarget);
		// var _$element = jQuery(event_.target);

		// get stored pseudo event
		var _oDatajQueryGestures = _$element.data('ojQueryGestures');

		var _bHasTouches = !!event_.touches;
		var _iScreenX = _bHasTouches ? event_.changedTouches[0].screenX : event_.screenX;
		var _iScreenY = _bHasTouches ? event_.changedTouches[0].screenY : event_.screenY;

		//relative to the last event
		var _oEventData = _oDatajQueryGestures.oLastSwipemove;
		var _iDeltaX = _iScreenX - _oEventData.screenX;
		var _iDeltaY = _iScreenY - _oEventData.screenY;

		var _oDetails;

		// there's a swipemove set (not the first occurance), trigger event
		if (!!_oDatajQueryGestures.oLastSwipemove) {
			// check
			_oDetails = _createOptions({ type: 'swipemove', touches: _bHasTouches ? event_.touches.length : '1', screenY: _iScreenY, screenX: _iScreenX, deltaY: _iDeltaY, deltaX: _iDeltaX, startMove: _oEventData, event: event_, timestamp: _oEventData.timestamp });
			_$element.triggerHandler(_oDetails.type, _oDetails);
		}
		// store the new values
		var _oObj = {};
		var _eventBase = event_.touches ? event_.touches[0] : event_;
		_oObj.oLastSwipemove = { screenX: _eventBase.screenX, screenY: _eventBase.screenY, timestamp: new Date().getTime() };
		_$element.data('ojQueryGestures', $.extend(true, _oDatajQueryGestures, _oObj));
	}

	/**
 * Handler: touchend or mouseup
 * Removes the additional handlers (move/end)
 * Calculates the x/y changes since the touchstart event
 * not in relation to the last move event.
 * Triggers the
 *	swipeone|swipetwo|swipethree|swipefour|
 *	swipeup|swiperightup|swiperight|swiperightdown|swipedown|
 *	swipeleftdown|swipeleft|swipeleftup|
 *	tapone|taptwo|tapthree|tapfour
 * event.
 *		{Object}
 *			{
 *				type: eventtype e.g. "swipeone","swipeleftdown",
 *				originalEvent: {DOM-Event},
 *				// default: just one entry on the delta-array - the first touchpoint
 *				// the first touchpoint is the reference point for every gesture,
 *				// because moving touchpoints in various directions would result in
 *				// a gesture.
 *				// delta and direction details are just provided for touch not for gesture / motion events
 *				delta : [
 *					{
 *						lastX:{Number} , // x-axis: relative to the last touchevent (e.g. touchmove!)
 *						lastY:{Number}, // y-axis: relative to the last touchevent (e.g. touchmove!)
 *						moved: {Number},  // distance: relative to the original touchpoint
 *						startX: {Number} , // relative to the original touchpoint
 *						startY: {Number} ,// relative to the original touchpoint
 *					} ],
 *				// based on the first touchpoint
 *				direction : { // relative to the last touchevent (e.g. touchmove!)
 *					vector: {Number}, // -1|+1, indicates the direction if necessary(pinch/rotate)
 *					orientation: {Number} // window.orientation: -90,0,90,180 || null (window.orienntation)
 *					lastX : {Number}, // -1,0,+1 relative to the last touchevent (e.g. touchmove!)
 *					lastY : {Number}, // -1,0,+1 relative to the last touchevent (e.g. touchmove!)
 *					startX: {Number} , //-1,0,+1 relative to the original touchpoint
 *					startY: {Number} ,// -1,0,+1 relative to the original touchpoint
 *				},
 *				rotation: null,
 *				scale: null ,
 *				duration: {Number}, // ms: relative to the original touchpoint
 *				description : {String} // details as String: {TYPE *}:{TOUCHES 1|2|3|4}:{X-AXIS 'right'|'left'|'steady'}:{Y-AXIS 'down'|'up'|'steady'} e.g. "swipe:1:left:steady" relative to the last touchpoint
 *			};
 * @param {DOM-Event} event_
 * @return {Void}
 */
	function _onTouchend(event_) {

		// ignore bubbled handlers
		// if ( event_.currentTarget !== event_.target ) { return; }

		var _$element = jQuery(event_.currentTarget);
		var _bHasTouches = !!event_.changedTouches;
		var _iTouches = _bHasTouches ? event_.changedTouches.length : '1';
		var _iScreenX = _bHasTouches ? event_.changedTouches[0].screenX : event_.screenX;
		var _iScreenY = _bHasTouches ? event_.changedTouches[0].screenY : event_.screenY;

		// trigger custom notification
		_$element.triggerHandler($.jGestures.events.touchendStart, event_);

		// var _$element = jQuery(event_.target);
		// remove events
		if ($.hasGestures) {
			event_.currentTarget.removeEventListener('touchmove', _onTouchmove, false);
			event_.currentTarget.removeEventListener('touchend', _onTouchend, false);
		}
		// event substitution
		else {
				//			event_.currentTarget.removeEventListener('mousemove', _onTouchmove, false);
				//			event_.currentTarget.removeEventListener('mouseup', _onTouchend, false);
				_$element.unbind('mousemove', _onTouchmove);
				_$element.unbind('mouseup', _onTouchend);
			}
		// get all bound pseudo events
		var _oDatajQueryGestures = _$element.data('ojQueryGestures');

		// if the current change on the x/y position is above the defined threshold for moving an element set the moved flag
		// to distinguish between a moving gesture and a shaking finger trying to tap
		var _bHasMoved = Math.abs(_oDatajQueryGestures.oStartTouch.screenX - _iScreenX) > $.jGestures.defaults.thresholdMove || Math.abs(_oDatajQueryGestures.oStartTouch.screenY - _iScreenY) > $.jGestures.defaults.thresholdMove ? true : false;

		// if the current change on the x/y position is above the defined threshold for swiping set the moved flag
		// to indicate we're dealing with a swipe gesture
		var _bHasSwipeGesture = Math.abs(_oDatajQueryGestures.oStartTouch.screenX - _iScreenX) > $.jGestures.defaults.thresholdSwipe || Math.abs(_oDatajQueryGestures.oStartTouch.screenY - _iScreenY) > $.jGestures.defaults.thresholdSwipe ? true : false;

		var _sType;
		var _oEventData;

		var _oDelta;

		// calculate distances in relation to the touchstart position not the last touchmove event!
		var _iDeltaX;
		var _iDeltaY;
		var _oDetails;

		var _aDict = ['zero', 'one', 'two', 'three', 'four'];

		// swipe marker
		var _bIsSwipe;

		// trigger events for all bound pseudo events on this element
		for (_sType in _oDatajQueryGestures) {

			// get current pseudo event
			_oEventData = _oDatajQueryGestures.oStartTouch;

			_oDelta = {};
			_iScreenX = _bHasTouches ? event_.changedTouches[0].screenX : event_.screenX;
			_iScreenY = _bHasTouches ? event_.changedTouches[0].screenY : event_.screenY;
			// calculate distances in relation to the touchstart position not the last touchmove event!
			_iDeltaX = _iScreenX - _oEventData.screenX;
			_iDeltaY = _iScreenY - _oEventData.screenY;
			_oDetails = _createOptions({ type: 'swipe', touches: _iTouches, screenY: _iScreenY, screenX: _iScreenX, deltaY: _iDeltaY, deltaX: _iDeltaX, startMove: _oEventData, event: event_, timestamp: _oEventData.timestamp });

			// swipe marker
			_bIsSwipe = false;

			// trigger bound events on this element
			switch (_sType) {
				case 'swipeone':

					if (_bHasTouches === false && _iTouches == 1 && _bHasMoved === false) {
						// trigger tapone!
						break;
					}
					if (_bHasTouches === false || _iTouches == 1 && _bHasMoved === true && _bHasSwipeGesture === true) {
						_bIsSwipe = true;

						_oDetails.type = ['swipe', _aDict[_iTouches]].join('');
						_$element.triggerHandler(_oDetails.type, _oDetails);
					}
					break;

				case 'swipetwo':
					if (_bHasTouches && _iTouches == 2 && _bHasMoved === true && _bHasSwipeGesture === true) {
						_bIsSwipe = true;
						_oDetails.type = ['swipe', _aDict[_iTouches]].join('');
						_$element.triggerHandler(_oDetails.type, _oDetails);
					}
					break;

				case 'swipethree':
					if (_bHasTouches && _iTouches == 3 && _bHasMoved === true && _bHasSwipeGesture === true) {
						_bIsSwipe = true;
						_oDetails.type = ['swipe', _aDict[_iTouches]].join('');
						_$element.triggerHandler(_oDetails.type, _oDetails);
					}
					break;

				case 'swipefour':
					if (_bHasTouches && _iTouches == 4 && _bHasMoved === true && _bHasSwipeGesture === true) {
						_bIsSwipe = true;
						_oDetails.type = ['swipe', _aDict[_iTouches]].join('');
						_$element.triggerHandler(_oDetails.type, _oDetails);
					}
					break;

				case 'swipeup':
				case 'swiperightup':
				case 'swiperight':
				case 'swiperightdown':
				case 'swipedown':
				case 'swipeleftdown':
				case 'swipeleft':
				case 'swipeleftup':
					if (_bHasTouches && _bHasMoved === true && _bHasSwipeGesture === true) {
						_bIsSwipe = true;
						_oDetails.type = ['swipe', _oDetails.delta[0].lastX != 0 ? _oDetails.delta[0].lastX > 0 ? 'right' : 'left' : '', _oDetails.delta[0].lastY != 0 ? _oDetails.delta[0].lastY > 0 ? 'down' : 'up' : ''].join('');
						_$element.triggerHandler(_oDetails.type, _oDetails);
					}
					break;

				case 'tapone':
				case 'taptwo':
				case 'tapthree':
				case 'tapfour':
					if ( /* _bHasTouches && */_bHasMoved !== true && _bIsSwipe !== true && _aDict[_iTouches] == _sType.slice(3)) {
						_oDetails.description = ['tap', _aDict[_iTouches]].join('');
						_oDetails.type = ['tap', _aDict[_iTouches]].join('');
						_$element.triggerHandler(_oDetails.type, _oDetails);
					}
					break;

			}

			// refresh pseudo events
			var _oObj = {};
			//			_oObj[_sType] = false;
			//			_oObj.hasTouchmoved = false;
			_$element.data('ojQueryGestures', $.extend(true, _oDatajQueryGestures, _oObj));
			_$element.data('ojQueryGestures', $.extend(true, _oDatajQueryGestures, _oObj));
		}
		_$element.triggerHandler($.jGestures.events.touchendProcessed, event_);
	}

	/**
 * Handler: gesturestart
 * Setup pseudo-event by storing initial values such as :
 *	timestamp: {Number}
 *  on the pseudo gesture event
 * Since the gesture-event doesn't supply event.touches no tuchpoints will be calculated
 * @param {DOM-Event} event_
 * @return {Void}
 */
	function _onGesturestart(event_) {

		// ignore bubbled handlers
		// if ( event_.currentTarget !== event_.target ) { return; }

		var _$element = jQuery(event_.currentTarget);
		// var _$element = jQuery(event_.target);

		// trigger custom notification
		_$element.triggerHandler($.jGestures.events.gesturestart, event_);

		// get stored pseudo event
		var _oDatajQueryGestures = _$element.data('ojQueryGestures');

		// var _oEventData = _oDatajQueryGestures[_sType];
		// store current values for calculating relative values (changes between touchmoveevents)
		var _oObj = {};
		_oObj.oStartTouch = { timestamp: new Date().getTime() };
		_$element.data('ojQueryGestures', $.extend(true, _oDatajQueryGestures, _oObj));
	}

	/**
 * Handler: gesturechange
 * Read the event_.scale / event_.rotate values,
 * an triggers a pinch|rotate event if necessary.
 * Since the gesture-event doesn't supply event.touches no tuchpoints will be calculated
 * @returns {Object}
 *			{
 *				type: eventtype e.g. "pinch","rotate",
 *				originalEvent: {DOM-Event},
 *				// delta and direction details are just provided for touch not for gesture / motion events
 *				delta : null,
 *				direction : {
 *					vector: {Number}, // -1|+1, indicates the direction if necessary(pinch/rotate)
 *					 orientation: {Number} // window.orientation: -90,0,90,180 || null (window.orienntation)
 *				 },
 *				rotation: {Number} , //  amount of rotation relative to the current position NOT the original
 *				scale: {Number} , // amount of scaling relative to the current position NOT the original
 *				duration: {Number}, // ms: relative to the original touchpoint
 *				description : {String} // details as String: pinch:{'close'|'open'} e.g. "pinch:-1:close" ||  rotate:{'counterclockwise'|'clockwise'} e.g. "rotate:-1:counterclockwise"
 *			};
 * @param {DOM-Event} event_
 * @return {Void}
 */
	function _onGesturechange(event_) {

		// ignore bubbled handlers
		// if ( event_.currentTarget !== event_.target ) { return; }

		var _$element = jQuery(event_.currentTarget);
		// var _$element = jQuery(event_.target);
		var _iDelta, _iDirection, _sDesc, _oDetails;
		// get all pseudo events
		var _oDatajQueryGestures = _$element.data('ojQueryGestures');

		// trigger events for all bound pseudo events on this element
		var _sType;
		for (_sType in _oDatajQueryGestures) {

			// trigger a specific bound event
			switch (_sType) {

				case 'pinch':
					_iDelta = event_.scale;
					if (_iDelta < 1 && _iDelta % 1 < 1 - $.jGestures.defaults.thresholdPinchclose || _iDelta > 1 && _iDelta % 1 > $.jGestures.defaults.thresholdPinchopen) {
						_iDirection = _iDelta < 1 ? -1 : +1;
						_oDetails = _createOptions({ type: 'pinch', scale: _iDelta, touches: null, startMove: _oDatajQueryGestures.oStartTouch, event: event_, timestamp: _oDatajQueryGestures.oStartTouch.timestamp, vector: _iDirection, description: ['pinch:', _iDirection, ':', _iDelta < 1 ? 'close' : 'open'].join('') });
						_$element.triggerHandler(_oDetails.type, _oDetails);
					}
					break;

				case 'rotate':
					_iDelta = event_.rotation;
					if (_iDelta < 1 && -1 * _iDelta > $.jGestures.defaults.thresholdRotateccw || _iDelta > 1 && _iDelta > $.jGestures.defaults.thresholdRotatecw) {
						_iDirection = _iDelta < 1 ? -1 : +1;
						_oDetails = _createOptions({ type: 'rotate', rotation: _iDelta, touches: null, startMove: _oDatajQueryGestures.oStartTouch, event: event_, timestamp: _oDatajQueryGestures.oStartTouch.timestamp, vector: _iDirection, description: ['rotate:', _iDirection, ':', _iDelta < 1 ? 'counterclockwise' : 'clockwise'].join('') });
						_$element.triggerHandler(_oDetails.type, _oDetails);
					}
					break;

			}
		}
	}

	/**
 * Handler: gestureend
 * Read the event_.scale / event_.rotate values,
 * compares it to $.jGestures.defaults.threshold* and triggers
 * a pinchclose|pinchclose|rotatecw|rotateccw event if the distance exceed the
 * Since the gesture-event doesn't supply event.touches no tuchpoints will be calculated
 * * Custom-event argument object:
 * @returns {Object}
 *			{
 *				type: eventtype e.g. "pinchclose","pinchopen", "rotatecw", "rotateccw",
 *				originalEvent: {DOM-Event},
 *				// delta and direction details are just provided for touch not for gesture / motion events
 *				delta : null,
 *				// based on the first touchpoint
 *				direction : {
 *					vector: {Number}, // -1|+1, indicates the direction if necessary(pinch/rotate)
 *					orientation: {Number} // window.orientation: -90,0,90,180 || null (window.orienntation)
 *				},
 *				rotation: {Number} , //  amount of rotation relative to the current position NOT the original
 *				scale: {Number} , // amount of scaling relative to the current position NOT the original
 *				duration: {Number}, // ms: relative to the original touchpoint
 *				description : {String} // details as String: pinch:{'close'|'open'} e.g. "pinch:-1:close" ||  rotate:{'counterclockwise'|'clockwise'} e.g. "rotate:-1:counterclockwise"
 *			};
 * @param {DOM-Event} event_
 * @return {Void}
 */
	function _onGestureend(event_) {
		// ignore bubbled handlers
		// if ( event_.currentTarget !== event_.target ) { return; }

		var _$element = jQuery(event_.currentTarget);
		// var _$element = jQuery(event_.target);

		// trigger custom notification
		_$element.triggerHandler($.jGestures.events.gestureendStart, event_);

		var _iDelta;
		var _oDatajQueryGestures = _$element.data('ojQueryGestures');

		// trigger handler for every bound event
		var _sType;
		for (_sType in _oDatajQueryGestures) {

			switch (_sType) {

				case 'pinchclose':
					_iDelta = event_.scale;
					if (_iDelta < 1 && _iDelta % 1 < 1 - $.jGestures.defaults.thresholdPinchclose) {
						_$element.triggerHandler('pinchclose', _createOptions({ type: 'pinchclose', scale: _iDelta, vector: -1, touches: null, startMove: _oDatajQueryGestures.oStartTouch, event: event_, timestamp: _oDatajQueryGestures.oStartTouch.timestamp, description: 'pinch:-1:close' }));
					}
					break;

				case 'pinchopen':
					_iDelta = event_.scale;
					if (_iDelta > 1 && _iDelta % 1 > $.jGestures.defaults.thresholdPinchopen) {
						_$element.triggerHandler('pinchopen', _createOptions({ type: 'pinchopen', scale: _iDelta, vector: +1, touches: null, startMove: _oDatajQueryGestures.oStartTouch, event: event_, timestamp: _oDatajQueryGestures.oStartTouch.timestamp, description: 'pinch:+1:open' }));
					}
					break;

				case 'rotatecw':
					_iDelta = event_.rotation;
					if (_iDelta > 1 && _iDelta > $.jGestures.defaults.thresholdRotatecw) {
						_$element.triggerHandler('rotatecw', _createOptions({ type: 'rotatecw', rotation: _iDelta, vector: +1, touches: null, startMove: _oDatajQueryGestures.oStartTouch, event: event_, timestamp: _oDatajQueryGestures.oStartTouch.timestamp, description: 'rotate:+1:clockwise' }));
					}
					break;

				case 'rotateccw':
					_iDelta = event_.rotation;
					if (_iDelta < 1 && -1 * _iDelta > $.jGestures.defaults.thresholdRotateccw) {
						_$element.triggerHandler('rotateccw', _createOptions({ type: 'rotateccw', rotation: _iDelta, vector: -1, touches: null, startMove: _oDatajQueryGestures.oStartTouch, event: event_, timestamp: _oDatajQueryGestures.oStartTouch.timestamp, description: 'rotate:-1:counterclockwise' }));
					}
					break;

			}
		}
		_$element.triggerHandler($.jGestures.events.gestureendProcessed, event_);
	}
})(jQuery);

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * get social network feed
 * 	- twitter part based on #### Twitter Post Fetcher v5.0 #### by Jason Mayes
 */

new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3)]; ((function ($) {

	"use strict";

	var PLUGIN_NAME = "socialNetworkFetcher";
	var PLUGIN_VERSION = "v2.0";

	var DEFAULTS = {
		twitterId: "",
		postsCount: 5,
		removeUrls: false,
		dateFormatPattern: 'd of MMMMM, yyyy',
		lang: 'en',
		messages: {
			'en': {
				monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
				monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
				more: 'View on Twitter'
			},
			'cs': {
				monthNames: ['Leden', 'Únor', 'Březen', 'Duben', 'Květen', 'Červen', 'Červenec', 'Srpen', 'Září', 'Říjen', 'Listopad', 'Prosinec'],
				monthNamesShort: ['Led', 'Úno', 'Bře', 'Dub', 'Kvě', 'Čer', 'Čec', 'Srp', 'Zář', 'Říj', 'Lis', 'Pro'],
				more: 'Celý tweet'
			}
		},
		twitterTemplate: function twitterTemplate(data, o) {
			var str = '<div class="row">';
			$.each(data, function (index, item) {
				str += '<div class="item col-xxs-8 col-xxs-offset-2 col-md-11 col-md-offset-1 item-twitter">';
				if (item.retweetcredit && item.retweetcredit.name && item.retweetcredit.name != '') {
					str += '<p class="twitter-tweet-info">' + item.retweetcredit.name + '<time class="tweet-date">' + item.pubdateFormatted + '</time>';
					if (item.user.img) {
						str += '<img src="' + item.user.img + '" class="twitter-user-ico"></p>';
					}
				} else if (item.user) {
					if (item.user.name) {
						str += '<p class="twitter-tweet-info"><a href="' + item.user.url + '" target="_blank">';
						if (item.user.img) {
							str += '<img src="' + item.user.img + '" class="twitter-user-ico">';
						}
						str += item.user.name + ' <small>' + item.user.nickname + '</small></a><time class="tweet-date">' + item.pubdateFormatted + '</time></p>';
					}
				}
				str += '<p>' + item.tweetcontent + '</p>';
				if (item.permalink) {
					str += '<p class="twitter-more"><a href="' + item.permalink + '" target="_blank">' + o.messages[o.lang].more + '</a>';
				}
				str += '</div>';
			});
			str += '</div>';
			return str;
		}
	};

	/**
  *
  * @param element
  * @param options
  * @constructor
  */
	var SocialNetworkFetcher = function SocialNetworkFetcher(element, options) {
		this.element = element;
		this.$t = $(this.element);

		this.options = $.extend(true, {}, DEFAULTS, options);
		this._defaults = DEFAULTS;

		this.$infiniteNextWrapper = null;
		this.$wrapper = null;

		this.debugEnabled_ = false;

		this.initialise_();
	};

	SocialNetworkFetcher.prototype.formatDate_ = function (dt, pattern, messages) {
		var result = pattern;
		var fd = dt.getDate();
		if (fd < 10) fd = "0" + fd;
		var fm = dt.getMonth() + 1;
		if (fm < 10) fm = "0" + fm;

		var fms = messages.monthNames[dt.getMonth()];
		var fmss = messages.monthNamesShort[dt.getMonth()];

		var fs = dt.getSeconds();
		if (fs < 10) fs = "0" + fs;

		result = result.replace(/dd/gi, fd);
		result = result.replace(/d/gi, dt.getDate());
		if (pattern.indexOf('MM') < 0) {
			result = result.replace(/M/gi, dt.getMonth() + 1);
		}
		result = result.replace(/MMMMM/gi, fms);
		result = result.replace(/MMM/gi, fmss);
		result = result.replace(/MM/gi, fm);
		result = result.replace(/yyyy/gi, dt.getFullYear());
		result = result.replace(/HH/gi, dt.getHours());
		result = result.replace(/mm/gi, dt.getMinutes());
		result = result.replace(/ss/gi, fs);
		return result;
	};

	/**
  * Init function - read options.cookieName status,
  * @private
  */
	SocialNetworkFetcher.prototype.initialise_ = function () {
		if (this.options.twitterId != "") {
			this.getDataFromTwitter_();
		}
	};

	SocialNetworkFetcher.prototype.getDataFromTwitter_ = function () {
		var self_ = this;
		var dataUrl = 'https://cdn.syndication.twimg.com/widgets/timelines/' + this.options.twitterId + '?&lang=' + this.options.lang + '&suppress_response_codes=true&rnd=' + new Date().getTime() + '&callback=?';
		$.getJSON(dataUrl, function (dt) {
			if (dt.headers.status == 200 && dt.body) {
				self_.parseTwitterData_(dt.body);
			}
		});
	};

	SocialNetworkFetcher.prototype.parseTwitterData_ = function (data) {
		var $streamBody = $(data);
		var item;
		var result = [];

		var self_ = this;

		$('.timeline-Tweet:lt(' + this.options.postsCount + ')', $streamBody).each(function (index, tweet) {
			item = {};
			// display user info
			var $userA = $(tweet).find('.timeline-Tweet-author');
			item.user = {};
			item.user.url = $('.TweetAuthor-link', $userA).attr('href');
			item.user.img = $('.TweetAuthor-avatar img', $userA).attr('data-src-2x');
			item.user.name = $('.TweetAuthor-name', $userA).text();
			item.user.nickname = $('.TweetAuthor-screenName', $userA).text();

			// get permalink
			item.permalink = $(tweet).find('a.timeline-Tweet-timestamp').attr('href');

			// display tweet itself
			var tweetContent = $(tweet).find('.timeline-Tweet-text').html();
			if (self_.options.removeUrls) {
				tweetContent = tweetContent.replace(/<a.*?>/gi, "");
			}
			tweetContent = tweetContent.replace(/ class=".*?"| dir=".*?"| data-query-source=".*?"| rel=".*?"| data-scribe=".*?"| data-mentioned-user-id=".*?"| data-expanded-url=".*?"| data-pre-embedded=".*?"/gi, "");
			tweetContent = tweetContent.replace(/href="/gi, "target=\"_blank\" href=\"");
			item.tweetcontent = tweetContent;

			item.tweetmedia = {};

			// inline image
			if ($(tweet).find('.timeline-Tweet-media .MediaCard-mediaContainer a img').size() > 0) {
				item.tweetmedia.image = {};

				var thumbsset = decodeURIComponent(String($(tweet).find('.timeline-Tweet-media .MediaCard-mediaContainer a img:first').attr('data-srcset')));
				var thumb, imageSize;

				if (!thumbsset || thumbsset == '') {
					return false;
				}

				var thumblist = thumbsset.split(',');

				for (var i = 0; i < thumblist.length; i++) {
					thumb = thumblist[i];

					if (window.location.protocol == 'http:') {
						thumb = thumb.replace('https://', 'http://');
					} else {
						thumb = thumb.replace('http://', 'https://');
					}

					thumb = thumb.substring(0, thumb.indexOf(' '));

					imageSize = thumb.lastIndexOf(':') > 10 ? thumb.substring(thumb.lastIndexOf(':') + 1) : 'default';

					item.tweetmedia.image[imageSize] = thumb;
				}

				item.tweetmedia.image.url = $(tweet).find('.timeline-Tweet-media .MediaCard-mediaContainer a:first').attr('href');
			}

			// retweeted by
			if ($(tweet).find('.timeline-Tweet-retweetCredit').size() > 0) {
				item.retweetcredit = {};
				item.retweetcredit.name = $.trim($(tweet).find('.timeline-Tweet-retweetCredit').text());
			}

			// show and format date
			var dtString = $(tweet).find('.timeline-Tweet-metadata .dt-updated').attr('datetime');
			dtString = dtString.substring(0, dtString.indexOf('+'));
			var pubDate = new Date();
			if (navigator.userAgent.indexOf('MSIE 8.0') > -1 || navigator.userAgent.indexOf('MSIE 7.0') > -1 || navigator.userAgent.indexOf('Safari') > -1) {
				pubDate = new Date(dtString.substr(0, 4), parseInt(dtString.substr(5, 2)) - 1, dtString.substr(8, 2), dtString.substr(11, 2), dtString.substr(14, 2), dtString.substr(17, 2));
			} else {
				pubDate = new Date(dtString);
			}

			item.pubdate = pubDate;
			item.pubdateFormatted = self_.formatDate_(pubDate, self_.options.dateFormatPattern, self_.options.messages[self_.options.lang]);

			item.twTools = {};
			item.twTools.retweet = $(tweet).find('.timeline-ShareMenu-container .timeline-ShareMenu-option[data="element:twitter"]').attr('href');
			result.push(item);
		});

		//console.log(result);
		this.$t.append(this.options.twitterTemplate(result, this.options));
	};

	var API = {};

	/**
  * plugin go live
  * @param value - first param - decides, which action shall be executed
  * 		if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
  * 		if string && in API object - run method named as this value with all args[index > 0]
  * @return {*}
  */
	$.fn[PLUGIN_NAME] = function (value) {
		var args = arguments;

		return this.each(function () {
			var $this = $(this);

			// get plugin instance
			var plugin = $this.data('plugin_' + PLUGIN_NAME);

			// if there's not, create one
			if (!plugin) {
				plugin = new SocialNetworkFetcher(this, value);
				$this.data('plugin_' + PLUGIN_NAME, plugin);
			}
			// if there is and first parameter is in predefined API methods, call it with rest of params
			else if (API[value]) {
					plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
				}
		});
	};

	/**
  * setDefaults with $.googlemap.setDefaults();
  */
	$[PLUGIN_NAME] = $.fn[PLUGIN_NAME];
	$[PLUGIN_NAME].setDefaults = function (newOptions) {
		DEFAULTS = $.extend(true, {}, DEFAULTS, newOptions);
	};
}).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}).catch(__webpack_require__.oe);

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*! jQuery UI - v1.11.4 - 2016-01-26
* http://jqueryui.com
* Includes: effect.js
* Copyright jQuery Foundation and other contributors; Licensed MIT */

(function (e) {
   true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (e),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : e(jQuery);
})(function (e) {
  var t = "ui-effects-",
      i = e;e.effects = { effect: {} }, function (e, t) {
    function i(e, t, i) {
      var s = c[t.type] || {};return null == e ? i || !t.def ? null : t.def : (e = s.floor ? ~~e : parseFloat(e), isNaN(e) ? t.def : s.mod ? (e + s.mod) % s.mod : 0 > e ? 0 : e > s.max ? s.max : e);
    }function s(i) {
      var s = l(),
          n = s._rgba = [];return i = i.toLowerCase(), f(h, function (e, a) {
        var o,
            r = a.re.exec(i),
            h = r && a.parse(r),
            l = a.space || "rgba";return h ? (o = s[l](h), s[u[l].cache] = o[u[l].cache], n = s._rgba = o._rgba, !1) : t;
      }), n.length ? ("0,0,0,0" === n.join() && e.extend(n, a.transparent), s) : a[i];
    }function n(e, t, i) {
      return i = (i + 1) % 1, 1 > 6 * i ? e + 6 * (t - e) * i : 1 > 2 * i ? t : 2 > 3 * i ? e + 6 * (t - e) * (2 / 3 - i) : e;
    }var a,
        o = "backgroundColor borderBottomColor borderLeftColor borderRightColor borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor",
        r = /^([\-+])=\s*(\d+\.?\d*)/,
        h = [{ re: /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/, parse: function parse(e) {
        return [e[1], e[2], e[3], e[4]];
      } }, { re: /rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/, parse: function parse(e) {
        return [2.55 * e[1], 2.55 * e[2], 2.55 * e[3], e[4]];
      } }, { re: /#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})/, parse: function parse(e) {
        return [parseInt(e[1], 16), parseInt(e[2], 16), parseInt(e[3], 16)];
      } }, { re: /#([a-f0-9])([a-f0-9])([a-f0-9])/, parse: function parse(e) {
        return [parseInt(e[1] + e[1], 16), parseInt(e[2] + e[2], 16), parseInt(e[3] + e[3], 16)];
      } }, { re: /hsla?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/, space: "hsla", parse: function parse(e) {
        return [e[1], e[2] / 100, e[3] / 100, e[4]];
      } }],
        l = e.Color = function (t, i, s, n) {
      return new e.Color.fn.parse(t, i, s, n);
    },
        u = { rgba: { props: { red: { idx: 0, type: "byte" }, green: { idx: 1, type: "byte" }, blue: { idx: 2, type: "byte" } } }, hsla: { props: { hue: { idx: 0, type: "degrees" }, saturation: { idx: 1, type: "percent" }, lightness: { idx: 2, type: "percent" } } } },
        c = { "byte": { floor: !0, max: 255 }, percent: { max: 1 }, degrees: { mod: 360, floor: !0 } },
        d = l.support = {},
        p = e("<p>")[0],
        f = e.each;p.style.cssText = "background-color:rgba(1,1,1,.5)", d.rgba = p.style.backgroundColor.indexOf("rgba") > -1, f(u, function (e, t) {
      t.cache = "_" + e, t.props.alpha = { idx: 3, type: "percent", def: 1 };
    }), l.fn = e.extend(l.prototype, { parse: function parse(n, o, r, h) {
        if (n === t) return this._rgba = [null, null, null, null], this;(n.jquery || n.nodeType) && (n = e(n).css(o), o = t);var c = this,
            d = e.type(n),
            p = this._rgba = [];return o !== t && (n = [n, o, r, h], d = "array"), "string" === d ? this.parse(s(n) || a._default) : "array" === d ? (f(u.rgba.props, function (e, t) {
          p[t.idx] = i(n[t.idx], t);
        }), this) : "object" === d ? (n instanceof l ? f(u, function (e, t) {
          n[t.cache] && (c[t.cache] = n[t.cache].slice());
        }) : f(u, function (t, s) {
          var a = s.cache;f(s.props, function (e, t) {
            if (!c[a] && s.to) {
              if ("alpha" === e || null == n[e]) return;c[a] = s.to(c._rgba);
            }c[a][t.idx] = i(n[e], t, !0);
          }), c[a] && 0 > e.inArray(null, c[a].slice(0, 3)) && (c[a][3] = 1, s.from && (c._rgba = s.from(c[a])));
        }), this) : t;
      }, is: function is(e) {
        var i = l(e),
            s = !0,
            n = this;return f(u, function (e, a) {
          var o,
              r = i[a.cache];return r && (o = n[a.cache] || a.to && a.to(n._rgba) || [], f(a.props, function (e, i) {
            return null != r[i.idx] ? s = r[i.idx] === o[i.idx] : t;
          })), s;
        }), s;
      }, _space: function _space() {
        var e = [],
            t = this;return f(u, function (i, s) {
          t[s.cache] && e.push(i);
        }), e.pop();
      }, transition: function transition(e, t) {
        var s = l(e),
            n = s._space(),
            a = u[n],
            o = 0 === this.alpha() ? l("transparent") : this,
            r = o[a.cache] || a.to(o._rgba),
            h = r.slice();return s = s[a.cache], f(a.props, function (e, n) {
          var a = n.idx,
              o = r[a],
              l = s[a],
              u = c[n.type] || {};null !== l && (null === o ? h[a] = l : (u.mod && (l - o > u.mod / 2 ? o += u.mod : o - l > u.mod / 2 && (o -= u.mod)), h[a] = i((l - o) * t + o, n)));
        }), this[n](h);
      }, blend: function blend(t) {
        if (1 === this._rgba[3]) return this;var i = this._rgba.slice(),
            s = i.pop(),
            n = l(t)._rgba;return l(e.map(i, function (e, t) {
          return (1 - s) * n[t] + s * e;
        }));
      }, toRgbaString: function toRgbaString() {
        var t = "rgba(",
            i = e.map(this._rgba, function (e, t) {
          return null == e ? t > 2 ? 1 : 0 : e;
        });return 1 === i[3] && (i.pop(), t = "rgb("), t + i.join() + ")";
      }, toHslaString: function toHslaString() {
        var t = "hsla(",
            i = e.map(this.hsla(), function (e, t) {
          return null == e && (e = t > 2 ? 1 : 0), t && 3 > t && (e = Math.round(100 * e) + "%"), e;
        });return 1 === i[3] && (i.pop(), t = "hsl("), t + i.join() + ")";
      }, toHexString: function toHexString(t) {
        var i = this._rgba.slice(),
            s = i.pop();return t && i.push(~~(255 * s)), "#" + e.map(i, function (e) {
          return e = (e || 0).toString(16), 1 === e.length ? "0" + e : e;
        }).join("");
      }, toString: function toString() {
        return 0 === this._rgba[3] ? "transparent" : this.toRgbaString();
      } }), l.fn.parse.prototype = l.fn, u.hsla.to = function (e) {
      if (null == e[0] || null == e[1] || null == e[2]) return [null, null, null, e[3]];var t,
          i,
          s = e[0] / 255,
          n = e[1] / 255,
          a = e[2] / 255,
          o = e[3],
          r = Math.max(s, n, a),
          h = Math.min(s, n, a),
          l = r - h,
          u = r + h,
          c = .5 * u;return t = h === r ? 0 : s === r ? 60 * (n - a) / l + 360 : n === r ? 60 * (a - s) / l + 120 : 60 * (s - n) / l + 240, i = 0 === l ? 0 : .5 >= c ? l / u : l / (2 - u), [Math.round(t) % 360, i, c, null == o ? 1 : o];
    }, u.hsla.from = function (e) {
      if (null == e[0] || null == e[1] || null == e[2]) return [null, null, null, e[3]];var t = e[0] / 360,
          i = e[1],
          s = e[2],
          a = e[3],
          o = .5 >= s ? s * (1 + i) : s + i - s * i,
          r = 2 * s - o;return [Math.round(255 * n(r, o, t + 1 / 3)), Math.round(255 * n(r, o, t)), Math.round(255 * n(r, o, t - 1 / 3)), a];
    }, f(u, function (s, n) {
      var a = n.props,
          o = n.cache,
          h = n.to,
          u = n.from;l.fn[s] = function (s) {
        if (h && !this[o] && (this[o] = h(this._rgba)), s === t) return this[o].slice();var n,
            r = e.type(s),
            c = "array" === r || "object" === r ? s : arguments,
            d = this[o].slice();return f(a, function (e, t) {
          var s = c["object" === r ? e : t.idx];null == s && (s = d[t.idx]), d[t.idx] = i(s, t);
        }), u ? (n = l(u(d)), n[o] = d, n) : l(d);
      }, f(a, function (t, i) {
        l.fn[t] || (l.fn[t] = function (n) {
          var a,
              o = e.type(n),
              h = "alpha" === t ? this._hsla ? "hsla" : "rgba" : s,
              l = this[h](),
              u = l[i.idx];return "undefined" === o ? u : ("function" === o && (n = n.call(this, u), o = e.type(n)), null == n && i.empty ? this : ("string" === o && (a = r.exec(n), a && (n = u + parseFloat(a[2]) * ("+" === a[1] ? 1 : -1))), l[i.idx] = n, this[h](l)));
        });
      });
    }), l.hook = function (t) {
      var i = t.split(" ");f(i, function (t, i) {
        e.cssHooks[i] = { set: function set(t, n) {
            var a,
                o,
                r = "";if ("transparent" !== n && ("string" !== e.type(n) || (a = s(n)))) {
              if (n = l(a || n), !d.rgba && 1 !== n._rgba[3]) {
                for (o = "backgroundColor" === i ? t.parentNode : t; ("" === r || "transparent" === r) && o && o.style;) {
                  try {
                    r = e.css(o, "backgroundColor"), o = o.parentNode;
                  } catch (h) {}
                }n = n.blend(r && "transparent" !== r ? r : "_default");
              }n = n.toRgbaString();
            }try {
              t.style[i] = n;
            } catch (h) {}
          } }, e.fx.step[i] = function (t) {
          t.colorInit || (t.start = l(t.elem, i), t.end = l(t.end), t.colorInit = !0), e.cssHooks[i].set(t.elem, t.start.transition(t.end, t.pos));
        };
      });
    }, l.hook(o), e.cssHooks.borderColor = { expand: function expand(e) {
        var t = {};return f(["Top", "Right", "Bottom", "Left"], function (i, s) {
          t["border" + s + "Color"] = e;
        }), t;
      } }, a = e.Color.names = { aqua: "#00ffff", black: "#000000", blue: "#0000ff", fuchsia: "#ff00ff", gray: "#808080", green: "#008000", lime: "#00ff00", maroon: "#800000", navy: "#000080", olive: "#808000", purple: "#800080", red: "#ff0000", silver: "#c0c0c0", teal: "#008080", white: "#ffffff", yellow: "#ffff00", transparent: [null, null, null, 0], _default: "#ffffff" };
  }(i), function () {
    function t(t) {
      var i,
          s,
          n = t.ownerDocument.defaultView ? t.ownerDocument.defaultView.getComputedStyle(t, null) : t.currentStyle,
          a = {};if (n && n.length && n[0] && n[n[0]]) for (s = n.length; s--;) {
        i = n[s], "string" == typeof n[i] && (a[e.camelCase(i)] = n[i]);
      } else for (i in n) {
        "string" == typeof n[i] && (a[i] = n[i]);
      }return a;
    }function s(t, i) {
      var s,
          n,
          o = {};for (s in i) {
        n = i[s], t[s] !== n && (a[s] || (e.fx.step[s] || !isNaN(parseFloat(n))) && (o[s] = n));
      }return o;
    }var n = ["add", "remove", "toggle"],
        a = { border: 1, borderBottom: 1, borderColor: 1, borderLeft: 1, borderRight: 1, borderTop: 1, borderWidth: 1, margin: 1, padding: 1 };e.each(["borderLeftStyle", "borderRightStyle", "borderBottomStyle", "borderTopStyle"], function (t, s) {
      e.fx.step[s] = function (e) {
        ("none" !== e.end && !e.setAttr || 1 === e.pos && !e.setAttr) && (i.style(e.elem, s, e.end), e.setAttr = !0);
      };
    }), e.fn.addBack || (e.fn.addBack = function (e) {
      return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
    }), e.effects.animateClass = function (i, a, o, r) {
      var h = e.speed(a, o, r);return this.queue(function () {
        var a,
            o = e(this),
            r = o.attr("class") || "",
            l = h.children ? o.find("*").addBack() : o;l = l.map(function () {
          var i = e(this);return { el: i, start: t(this) };
        }), a = function a() {
          e.each(n, function (e, t) {
            i[t] && o[t + "Class"](i[t]);
          });
        }, a(), l = l.map(function () {
          return this.end = t(this.el[0]), this.diff = s(this.start, this.end), this;
        }), o.attr("class", r), l = l.map(function () {
          var t = this,
              i = e.Deferred(),
              s = e.extend({}, h, { queue: !1, complete: function complete() {
              i.resolve(t);
            } });return this.el.animate(this.diff, s), i.promise();
        }), e.when.apply(e, l.get()).done(function () {
          a(), e.each(arguments, function () {
            var t = this.el;e.each(this.diff, function (e) {
              t.css(e, "");
            });
          }), h.complete.call(o[0]);
        });
      });
    }, e.fn.extend({ addClass: function (t) {
        return function (i, s, n, a) {
          return s ? e.effects.animateClass.call(this, { add: i }, s, n, a) : t.apply(this, arguments);
        };
      }(e.fn.addClass), removeClass: function (t) {
        return function (i, s, n, a) {
          return arguments.length > 1 ? e.effects.animateClass.call(this, { remove: i }, s, n, a) : t.apply(this, arguments);
        };
      }(e.fn.removeClass), toggleClass: function (t) {
        return function (i, s, n, a, o) {
          return "boolean" == typeof s || void 0 === s ? n ? e.effects.animateClass.call(this, s ? { add: i } : { remove: i }, n, a, o) : t.apply(this, arguments) : e.effects.animateClass.call(this, { toggle: i }, s, n, a);
        };
      }(e.fn.toggleClass), switchClass: function switchClass(t, i, s, n, a) {
        return e.effects.animateClass.call(this, { add: i, remove: t }, s, n, a);
      } });
  }(), function () {
    function i(t, i, s, n) {
      return e.isPlainObject(t) && (i = t, t = t.effect), t = { effect: t }, null == i && (i = {}), e.isFunction(i) && (n = i, s = null, i = {}), ("number" == typeof i || e.fx.speeds[i]) && (n = s, s = i, i = {}), e.isFunction(s) && (n = s, s = null), i && e.extend(t, i), s = s || i.duration, t.duration = e.fx.off ? 0 : "number" == typeof s ? s : s in e.fx.speeds ? e.fx.speeds[s] : e.fx.speeds._default, t.complete = n || i.complete, t;
    }function s(t) {
      return !t || "number" == typeof t || e.fx.speeds[t] ? !0 : "string" != typeof t || e.effects.effect[t] ? e.isFunction(t) ? !0 : "object" != (typeof t === "undefined" ? "undefined" : _typeof(t)) || t.effect ? !1 : !0 : !0;
    }e.extend(e.effects, { version: "1.11.4", save: function save(e, i) {
        for (var s = 0; i.length > s; s++) {
          null !== i[s] && e.data(t + i[s], e[0].style[i[s]]);
        }
      }, restore: function restore(e, i) {
        var s, n;for (n = 0; i.length > n; n++) {
          null !== i[n] && (s = e.data(t + i[n]), void 0 === s && (s = ""), e.css(i[n], s));
        }
      }, setMode: function setMode(e, t) {
        return "toggle" === t && (t = e.is(":hidden") ? "show" : "hide"), t;
      }, getBaseline: function getBaseline(e, t) {
        var i, s;switch (e[0]) {case "top":
            i = 0;break;case "middle":
            i = .5;break;case "bottom":
            i = 1;break;default:
            i = e[0] / t.height;}switch (e[1]) {case "left":
            s = 0;break;case "center":
            s = .5;break;case "right":
            s = 1;break;default:
            s = e[1] / t.width;}return { x: s, y: i };
      }, createWrapper: function createWrapper(t) {
        if (t.parent().is(".ui-effects-wrapper")) return t.parent();var i = { width: t.outerWidth(!0), height: t.outerHeight(!0), "float": t.css("float") },
            s = e("<div></div>").addClass("ui-effects-wrapper").css({ fontSize: "100%", background: "transparent", border: "none", margin: 0, padding: 0 }),
            n = { width: t.width(), height: t.height() },
            a = document.activeElement;try {
          a.id;
        } catch (o) {
          a = document.body;
        }return t.wrap(s), (t[0] === a || e.contains(t[0], a)) && e(a).focus(), s = t.parent(), "static" === t.css("position") ? (s.css({ position: "relative" }), t.css({ position: "relative" })) : (e.extend(i, { position: t.css("position"), zIndex: t.css("z-index") }), e.each(["top", "left", "bottom", "right"], function (e, s) {
          i[s] = t.css(s), isNaN(parseInt(i[s], 10)) && (i[s] = "auto");
        }), t.css({ position: "relative", top: 0, left: 0, right: "auto", bottom: "auto" })), t.css(n), s.css(i).show();
      }, removeWrapper: function removeWrapper(t) {
        var i = document.activeElement;return t.parent().is(".ui-effects-wrapper") && (t.parent().replaceWith(t), (t[0] === i || e.contains(t[0], i)) && e(i).focus()), t;
      }, setTransition: function setTransition(t, i, s, n) {
        return n = n || {}, e.each(i, function (e, i) {
          var a = t.cssUnit(i);a[0] > 0 && (n[i] = a[0] * s + a[1]);
        }), n;
      } }), e.fn.extend({ effect: function effect() {
        function t(t) {
          function i() {
            e.isFunction(a) && a.call(n[0]), e.isFunction(t) && t();
          }var n = e(this),
              a = s.complete,
              r = s.mode;(n.is(":hidden") ? "hide" === r : "show" === r) ? (n[r](), i()) : o.call(n[0], s, i);
        }var s = i.apply(this, arguments),
            n = s.mode,
            a = s.queue,
            o = e.effects.effect[s.effect];return e.fx.off || !o ? n ? this[n](s.duration, s.complete) : this.each(function () {
          s.complete && s.complete.call(this);
        }) : a === !1 ? this.each(t) : this.queue(a || "fx", t);
      }, show: function (e) {
        return function (t) {
          if (s(t)) return e.apply(this, arguments);var n = i.apply(this, arguments);return n.mode = "show", this.effect.call(this, n);
        };
      }(e.fn.show), hide: function (e) {
        return function (t) {
          if (s(t)) return e.apply(this, arguments);var n = i.apply(this, arguments);return n.mode = "hide", this.effect.call(this, n);
        };
      }(e.fn.hide), toggle: function (e) {
        return function (t) {
          if (s(t) || "boolean" == typeof t) return e.apply(this, arguments);var n = i.apply(this, arguments);return n.mode = "toggle", this.effect.call(this, n);
        };
      }(e.fn.toggle), cssUnit: function cssUnit(t) {
        var i = this.css(t),
            s = [];return e.each(["em", "px", "%", "pt"], function (e, t) {
          i.indexOf(t) > 0 && (s = [parseFloat(i), t]);
        }), s;
      } });
  }(), function () {
    var t = {};e.each(["Quad", "Cubic", "Quart", "Quint", "Expo"], function (e, i) {
      t[i] = function (t) {
        return Math.pow(t, e + 2);
      };
    }), e.extend(t, { Sine: function Sine(e) {
        return 1 - Math.cos(e * Math.PI / 2);
      }, Circ: function Circ(e) {
        return 1 - Math.sqrt(1 - e * e);
      }, Elastic: function Elastic(e) {
        return 0 === e || 1 === e ? e : -Math.pow(2, 8 * (e - 1)) * Math.sin((80 * (e - 1) - 7.5) * Math.PI / 15);
      }, Back: function Back(e) {
        return e * e * (3 * e - 2);
      }, Bounce: function Bounce(e) {
        for (var t, i = 4; ((t = Math.pow(2, --i)) - 1) / 11 > e;) {}return 1 / Math.pow(4, 3 - i) - 7.5625 * Math.pow((3 * t - 2) / 22 - e, 2);
      } }), e.each(t, function (t, i) {
      e.easing["easeIn" + t] = i, e.easing["easeOut" + t] = function (e) {
        return 1 - i(1 - e);
      }, e.easing["easeInOut" + t] = function (e) {
        return .5 > e ? i(2 * e) / 2 : 1 - i(-2 * e + 2) / 2;
      };
    });
  }(), e.effects;
});

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _swiper = __webpack_require__(398);

var _swiper2 = _interopRequireDefault(_swiper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var deviceSwiper = new _swiper2.default('.hp-device__swiper-container', {
  speed: 200,
  spaceBetween: 0,
  touchReleaseOnEdges: true,
  autoplay: {
    delay: 8000,
    disableOnInteraction: false
  },
  loop: true,
  navigation: {
    nextEl: '.hp-device__swiper-next',
    prevEl: '.hp-device__swiper-prev'
  }
});

deviceSwiper.on('slideNextTransitionStart', function () {
  deviceSwiper.navigation.$nextEl.addClass('hp-device__swiper-next--active');
});

deviceSwiper.on('slidePrevTransitionStart', function () {
  deviceSwiper.navigation.$prevEl.addClass('hp-device__swiper-prev--active');
});

deviceSwiper.on('slideChangeTransitionEnd', function () {
  deviceSwiper.navigation.$nextEl.removeClass('hp-device__swiper-next--active');
  deviceSwiper.navigation.$prevEl.removeClass('hp-device__swiper-prev--active');
});

$(function () {

  if ($('.js_device-img').length > 0) {
    deviceSwiper.autoplay.stop();
    var interval = setInterval(function () {
      var images = document.body.getElementsByClassName('js_device-img');
      var length = images.length;
      var counter = 0;
      for (var i = 0; i < length; i++) {
        if (images[i].complete) {
          counter++;
        }
      }
      if (counter === length) {
        $('.js_device').addClass('animate');
        deviceSwiper.autoplay.start();
        clearInterval(interval);
      }
    }, 800);
  }
});

var bubblesBg = document.getElementsByClassName('js_bubbles-bg');
deviceSwiper.on('slideChange', function () {
  for (var i = 0; i < bubblesBg.length; i++) {
    bubblesBg[i].classList.remove('hp-device__bubbles-bg--active');
  }
  bubblesBg[deviceSwiper.realIndex].classList.add('hp-device__bubbles-bg--active');
});

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Swiper 4.5.1
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://www.idangero.us/swiper/
 *
 * Copyright 2014-2019 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: September 13, 2019
 */

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, global.Swiper = factory());
}(this, function () { 'use strict';

  /**
   * SSR Window 1.0.1
   * Better handling for window object in SSR environment
   * https://github.com/nolimits4web/ssr-window
   *
   * Copyright 2018, Vladimir Kharlampidi
   *
   * Licensed under MIT
   *
   * Released on: July 18, 2018
   */
  var doc = (typeof document === 'undefined') ? {
    body: {},
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    activeElement: {
      blur: function blur() {},
      nodeName: '',
    },
    querySelector: function querySelector() {
      return null;
    },
    querySelectorAll: function querySelectorAll() {
      return [];
    },
    getElementById: function getElementById() {
      return null;
    },
    createEvent: function createEvent() {
      return {
        initEvent: function initEvent() {},
      };
    },
    createElement: function createElement() {
      return {
        children: [],
        childNodes: [],
        style: {},
        setAttribute: function setAttribute() {},
        getElementsByTagName: function getElementsByTagName() {
          return [];
        },
      };
    },
    location: { hash: '' },
  } : document; // eslint-disable-line

  var win = (typeof window === 'undefined') ? {
    document: doc,
    navigator: {
      userAgent: '',
    },
    location: {},
    history: {},
    CustomEvent: function CustomEvent() {
      return this;
    },
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    getComputedStyle: function getComputedStyle() {
      return {
        getPropertyValue: function getPropertyValue() {
          return '';
        },
      };
    },
    Image: function Image() {},
    Date: function Date() {},
    screen: {},
    setTimeout: function setTimeout() {},
    clearTimeout: function clearTimeout() {},
  } : window; // eslint-disable-line

  /**
   * Dom7 2.1.3
   * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
   * http://framework7.io/docs/dom.html
   *
   * Copyright 2019, Vladimir Kharlampidi
   * The iDangero.us
   * http://www.idangero.us/
   *
   * Licensed under MIT
   *
   * Released on: February 11, 2019
   */

  var Dom7 = function Dom7(arr) {
    var self = this;
    // Create array-like object
    for (var i = 0; i < arr.length; i += 1) {
      self[i] = arr[i];
    }
    self.length = arr.length;
    // Return collection with methods
    return this;
  };

  function $(selector, context) {
    var arr = [];
    var i = 0;
    if (selector && !context) {
      if (selector instanceof Dom7) {
        return selector;
      }
    }
    if (selector) {
        // String
      if (typeof selector === 'string') {
        var els;
        var tempParent;
        var html = selector.trim();
        if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
          var toCreate = 'div';
          if (html.indexOf('<li') === 0) { toCreate = 'ul'; }
          if (html.indexOf('<tr') === 0) { toCreate = 'tbody'; }
          if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) { toCreate = 'tr'; }
          if (html.indexOf('<tbody') === 0) { toCreate = 'table'; }
          if (html.indexOf('<option') === 0) { toCreate = 'select'; }
          tempParent = doc.createElement(toCreate);
          tempParent.innerHTML = html;
          for (i = 0; i < tempParent.childNodes.length; i += 1) {
            arr.push(tempParent.childNodes[i]);
          }
        } else {
          if (!context && selector[0] === '#' && !selector.match(/[ .<>:~]/)) {
            // Pure ID selector
            els = [doc.getElementById(selector.trim().split('#')[1])];
          } else {
            // Other selectors
            els = (context || doc).querySelectorAll(selector.trim());
          }
          for (i = 0; i < els.length; i += 1) {
            if (els[i]) { arr.push(els[i]); }
          }
        }
      } else if (selector.nodeType || selector === win || selector === doc) {
        // Node/element
        arr.push(selector);
      } else if (selector.length > 0 && selector[0].nodeType) {
        // Array of elements or instance of Dom
        for (i = 0; i < selector.length; i += 1) {
          arr.push(selector[i]);
        }
      }
    }
    return new Dom7(arr);
  }

  $.fn = Dom7.prototype;
  $.Class = Dom7;
  $.Dom7 = Dom7;

  function unique(arr) {
    var uniqueArray = [];
    for (var i = 0; i < arr.length; i += 1) {
      if (uniqueArray.indexOf(arr[i]) === -1) { uniqueArray.push(arr[i]); }
    }
    return uniqueArray;
  }

  // Classes and attributes
  function addClass(className) {
    if (typeof className === 'undefined') {
      return this;
    }
    var classes = className.split(' ');
    for (var i = 0; i < classes.length; i += 1) {
      for (var j = 0; j < this.length; j += 1) {
        if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') { this[j].classList.add(classes[i]); }
      }
    }
    return this;
  }
  function removeClass(className) {
    var classes = className.split(' ');
    for (var i = 0; i < classes.length; i += 1) {
      for (var j = 0; j < this.length; j += 1) {
        if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') { this[j].classList.remove(classes[i]); }
      }
    }
    return this;
  }
  function hasClass(className) {
    if (!this[0]) { return false; }
    return this[0].classList.contains(className);
  }
  function toggleClass(className) {
    var classes = className.split(' ');
    for (var i = 0; i < classes.length; i += 1) {
      for (var j = 0; j < this.length; j += 1) {
        if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') { this[j].classList.toggle(classes[i]); }
      }
    }
    return this;
  }
  function attr(attrs, value) {
    var arguments$1 = arguments;

    if (arguments.length === 1 && typeof attrs === 'string') {
      // Get attr
      if (this[0]) { return this[0].getAttribute(attrs); }
      return undefined;
    }

    // Set attrs
    for (var i = 0; i < this.length; i += 1) {
      if (arguments$1.length === 2) {
        // String
        this[i].setAttribute(attrs, value);
      } else {
        // Object
        // eslint-disable-next-line
        for (var attrName in attrs) {
          this[i][attrName] = attrs[attrName];
          this[i].setAttribute(attrName, attrs[attrName]);
        }
      }
    }
    return this;
  }
  // eslint-disable-next-line
  function removeAttr(attr) {
    for (var i = 0; i < this.length; i += 1) {
      this[i].removeAttribute(attr);
    }
    return this;
  }
  function data(key, value) {
    var el;
    if (typeof value === 'undefined') {
      el = this[0];
      // Get value
      if (el) {
        if (el.dom7ElementDataStorage && (key in el.dom7ElementDataStorage)) {
          return el.dom7ElementDataStorage[key];
        }

        var dataKey = el.getAttribute(("data-" + key));
        if (dataKey) {
          return dataKey;
        }
        return undefined;
      }
      return undefined;
    }

    // Set value
    for (var i = 0; i < this.length; i += 1) {
      el = this[i];
      if (!el.dom7ElementDataStorage) { el.dom7ElementDataStorage = {}; }
      el.dom7ElementDataStorage[key] = value;
    }
    return this;
  }
  // Transforms
  // eslint-disable-next-line
  function transform(transform) {
    for (var i = 0; i < this.length; i += 1) {
      var elStyle = this[i].style;
      elStyle.webkitTransform = transform;
      elStyle.transform = transform;
    }
    return this;
  }
  function transition(duration) {
    if (typeof duration !== 'string') {
      duration = duration + "ms"; // eslint-disable-line
    }
    for (var i = 0; i < this.length; i += 1) {
      var elStyle = this[i].style;
      elStyle.webkitTransitionDuration = duration;
      elStyle.transitionDuration = duration;
    }
    return this;
  }
  // Events
  function on() {
    var assign;

    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
    var eventType = args[0];
    var targetSelector = args[1];
    var listener = args[2];
    var capture = args[3];
    if (typeof args[1] === 'function') {
      (assign = args, eventType = assign[0], listener = assign[1], capture = assign[2]);
      targetSelector = undefined;
    }
    if (!capture) { capture = false; }

    function handleLiveEvent(e) {
      var target = e.target;
      if (!target) { return; }
      var eventData = e.target.dom7EventData || [];
      if (eventData.indexOf(e) < 0) {
        eventData.unshift(e);
      }
      if ($(target).is(targetSelector)) { listener.apply(target, eventData); }
      else {
        var parents = $(target).parents(); // eslint-disable-line
        for (var k = 0; k < parents.length; k += 1) {
          if ($(parents[k]).is(targetSelector)) { listener.apply(parents[k], eventData); }
        }
      }
    }
    function handleEvent(e) {
      var eventData = e && e.target ? e.target.dom7EventData || [] : [];
      if (eventData.indexOf(e) < 0) {
        eventData.unshift(e);
      }
      listener.apply(this, eventData);
    }
    var events = eventType.split(' ');
    var j;
    for (var i = 0; i < this.length; i += 1) {
      var el = this[i];
      if (!targetSelector) {
        for (j = 0; j < events.length; j += 1) {
          var event = events[j];
          if (!el.dom7Listeners) { el.dom7Listeners = {}; }
          if (!el.dom7Listeners[event]) { el.dom7Listeners[event] = []; }
          el.dom7Listeners[event].push({
            listener: listener,
            proxyListener: handleEvent,
          });
          el.addEventListener(event, handleEvent, capture);
        }
      } else {
        // Live events
        for (j = 0; j < events.length; j += 1) {
          var event$1 = events[j];
          if (!el.dom7LiveListeners) { el.dom7LiveListeners = {}; }
          if (!el.dom7LiveListeners[event$1]) { el.dom7LiveListeners[event$1] = []; }
          el.dom7LiveListeners[event$1].push({
            listener: listener,
            proxyListener: handleLiveEvent,
          });
          el.addEventListener(event$1, handleLiveEvent, capture);
        }
      }
    }
    return this;
  }
  function off() {
    var assign;

    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
    var eventType = args[0];
    var targetSelector = args[1];
    var listener = args[2];
    var capture = args[3];
    if (typeof args[1] === 'function') {
      (assign = args, eventType = assign[0], listener = assign[1], capture = assign[2]);
      targetSelector = undefined;
    }
    if (!capture) { capture = false; }

    var events = eventType.split(' ');
    for (var i = 0; i < events.length; i += 1) {
      var event = events[i];
      for (var j = 0; j < this.length; j += 1) {
        var el = this[j];
        var handlers = (void 0);
        if (!targetSelector && el.dom7Listeners) {
          handlers = el.dom7Listeners[event];
        } else if (targetSelector && el.dom7LiveListeners) {
          handlers = el.dom7LiveListeners[event];
        }
        if (handlers && handlers.length) {
          for (var k = handlers.length - 1; k >= 0; k -= 1) {
            var handler = handlers[k];
            if (listener && handler.listener === listener) {
              el.removeEventListener(event, handler.proxyListener, capture);
              handlers.splice(k, 1);
            } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
              el.removeEventListener(event, handler.proxyListener, capture);
              handlers.splice(k, 1);
            } else if (!listener) {
              el.removeEventListener(event, handler.proxyListener, capture);
              handlers.splice(k, 1);
            }
          }
        }
      }
    }
    return this;
  }
  function trigger() {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var events = args[0].split(' ');
    var eventData = args[1];
    for (var i = 0; i < events.length; i += 1) {
      var event = events[i];
      for (var j = 0; j < this.length; j += 1) {
        var el = this[j];
        var evt = (void 0);
        try {
          evt = new win.CustomEvent(event, {
            detail: eventData,
            bubbles: true,
            cancelable: true,
          });
        } catch (e) {
          evt = doc.createEvent('Event');
          evt.initEvent(event, true, true);
          evt.detail = eventData;
        }
        // eslint-disable-next-line
        el.dom7EventData = args.filter(function (data, dataIndex) { return dataIndex > 0; });
        el.dispatchEvent(evt);
        el.dom7EventData = [];
        delete el.dom7EventData;
      }
    }
    return this;
  }
  function transitionEnd(callback) {
    var events = ['webkitTransitionEnd', 'transitionend'];
    var dom = this;
    var i;
    function fireCallBack(e) {
      /* jshint validthis:true */
      if (e.target !== this) { return; }
      callback.call(this, e);
      for (i = 0; i < events.length; i += 1) {
        dom.off(events[i], fireCallBack);
      }
    }
    if (callback) {
      for (i = 0; i < events.length; i += 1) {
        dom.on(events[i], fireCallBack);
      }
    }
    return this;
  }
  function outerWidth(includeMargins) {
    if (this.length > 0) {
      if (includeMargins) {
        // eslint-disable-next-line
        var styles = this.styles();
        return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
      }
      return this[0].offsetWidth;
    }
    return null;
  }
  function outerHeight(includeMargins) {
    if (this.length > 0) {
      if (includeMargins) {
        // eslint-disable-next-line
        var styles = this.styles();
        return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
      }
      return this[0].offsetHeight;
    }
    return null;
  }
  function offset() {
    if (this.length > 0) {
      var el = this[0];
      var box = el.getBoundingClientRect();
      var body = doc.body;
      var clientTop = el.clientTop || body.clientTop || 0;
      var clientLeft = el.clientLeft || body.clientLeft || 0;
      var scrollTop = el === win ? win.scrollY : el.scrollTop;
      var scrollLeft = el === win ? win.scrollX : el.scrollLeft;
      return {
        top: (box.top + scrollTop) - clientTop,
        left: (box.left + scrollLeft) - clientLeft,
      };
    }

    return null;
  }
  function styles() {
    if (this[0]) { return win.getComputedStyle(this[0], null); }
    return {};
  }
  function css(props, value) {
    var i;
    if (arguments.length === 1) {
      if (typeof props === 'string') {
        if (this[0]) { return win.getComputedStyle(this[0], null).getPropertyValue(props); }
      } else {
        for (i = 0; i < this.length; i += 1) {
          // eslint-disable-next-line
          for (var prop in props) {
            this[i].style[prop] = props[prop];
          }
        }
        return this;
      }
    }
    if (arguments.length === 2 && typeof props === 'string') {
      for (i = 0; i < this.length; i += 1) {
        this[i].style[props] = value;
      }
      return this;
    }
    return this;
  }
  // Iterate over the collection passing elements to `callback`
  function each(callback) {
    // Don't bother continuing without a callback
    if (!callback) { return this; }
    // Iterate over the current collection
    for (var i = 0; i < this.length; i += 1) {
      // If the callback returns false
      if (callback.call(this[i], i, this[i]) === false) {
        // End the loop early
        return this;
      }
    }
    // Return `this` to allow chained DOM operations
    return this;
  }
  // eslint-disable-next-line
  function html(html) {
    if (typeof html === 'undefined') {
      return this[0] ? this[0].innerHTML : undefined;
    }

    for (var i = 0; i < this.length; i += 1) {
      this[i].innerHTML = html;
    }
    return this;
  }
  // eslint-disable-next-line
  function text(text) {
    if (typeof text === 'undefined') {
      if (this[0]) {
        return this[0].textContent.trim();
      }
      return null;
    }

    for (var i = 0; i < this.length; i += 1) {
      this[i].textContent = text;
    }
    return this;
  }
  function is(selector) {
    var el = this[0];
    var compareWith;
    var i;
    if (!el || typeof selector === 'undefined') { return false; }
    if (typeof selector === 'string') {
      if (el.matches) { return el.matches(selector); }
      else if (el.webkitMatchesSelector) { return el.webkitMatchesSelector(selector); }
      else if (el.msMatchesSelector) { return el.msMatchesSelector(selector); }

      compareWith = $(selector);
      for (i = 0; i < compareWith.length; i += 1) {
        if (compareWith[i] === el) { return true; }
      }
      return false;
    } else if (selector === doc) { return el === doc; }
    else if (selector === win) { return el === win; }

    if (selector.nodeType || selector instanceof Dom7) {
      compareWith = selector.nodeType ? [selector] : selector;
      for (i = 0; i < compareWith.length; i += 1) {
        if (compareWith[i] === el) { return true; }
      }
      return false;
    }
    return false;
  }
  function index() {
    var child = this[0];
    var i;
    if (child) {
      i = 0;
      // eslint-disable-next-line
      while ((child = child.previousSibling) !== null) {
        if (child.nodeType === 1) { i += 1; }
      }
      return i;
    }
    return undefined;
  }
  // eslint-disable-next-line
  function eq(index) {
    if (typeof index === 'undefined') { return this; }
    var length = this.length;
    var returnIndex;
    if (index > length - 1) {
      return new Dom7([]);
    }
    if (index < 0) {
      returnIndex = length + index;
      if (returnIndex < 0) { return new Dom7([]); }
      return new Dom7([this[returnIndex]]);
    }
    return new Dom7([this[index]]);
  }
  function append() {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var newChild;

    for (var k = 0; k < args.length; k += 1) {
      newChild = args[k];
      for (var i = 0; i < this.length; i += 1) {
        if (typeof newChild === 'string') {
          var tempDiv = doc.createElement('div');
          tempDiv.innerHTML = newChild;
          while (tempDiv.firstChild) {
            this[i].appendChild(tempDiv.firstChild);
          }
        } else if (newChild instanceof Dom7) {
          for (var j = 0; j < newChild.length; j += 1) {
            this[i].appendChild(newChild[j]);
          }
        } else {
          this[i].appendChild(newChild);
        }
      }
    }

    return this;
  }
  function prepend(newChild) {
    var i;
    var j;
    for (i = 0; i < this.length; i += 1) {
      if (typeof newChild === 'string') {
        var tempDiv = doc.createElement('div');
        tempDiv.innerHTML = newChild;
        for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
          this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
        }
      } else if (newChild instanceof Dom7) {
        for (j = 0; j < newChild.length; j += 1) {
          this[i].insertBefore(newChild[j], this[i].childNodes[0]);
        }
      } else {
        this[i].insertBefore(newChild, this[i].childNodes[0]);
      }
    }
    return this;
  }
  function next(selector) {
    if (this.length > 0) {
      if (selector) {
        if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
          return new Dom7([this[0].nextElementSibling]);
        }
        return new Dom7([]);
      }

      if (this[0].nextElementSibling) { return new Dom7([this[0].nextElementSibling]); }
      return new Dom7([]);
    }
    return new Dom7([]);
  }
  function nextAll(selector) {
    var nextEls = [];
    var el = this[0];
    if (!el) { return new Dom7([]); }
    while (el.nextElementSibling) {
      var next = el.nextElementSibling; // eslint-disable-line
      if (selector) {
        if ($(next).is(selector)) { nextEls.push(next); }
      } else { nextEls.push(next); }
      el = next;
    }
    return new Dom7(nextEls);
  }
  function prev(selector) {
    if (this.length > 0) {
      var el = this[0];
      if (selector) {
        if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
          return new Dom7([el.previousElementSibling]);
        }
        return new Dom7([]);
      }

      if (el.previousElementSibling) { return new Dom7([el.previousElementSibling]); }
      return new Dom7([]);
    }
    return new Dom7([]);
  }
  function prevAll(selector) {
    var prevEls = [];
    var el = this[0];
    if (!el) { return new Dom7([]); }
    while (el.previousElementSibling) {
      var prev = el.previousElementSibling; // eslint-disable-line
      if (selector) {
        if ($(prev).is(selector)) { prevEls.push(prev); }
      } else { prevEls.push(prev); }
      el = prev;
    }
    return new Dom7(prevEls);
  }
  function parent(selector) {
    var parents = []; // eslint-disable-line
    for (var i = 0; i < this.length; i += 1) {
      if (this[i].parentNode !== null) {
        if (selector) {
          if ($(this[i].parentNode).is(selector)) { parents.push(this[i].parentNode); }
        } else {
          parents.push(this[i].parentNode);
        }
      }
    }
    return $(unique(parents));
  }
  function parents(selector) {
    var parents = []; // eslint-disable-line
    for (var i = 0; i < this.length; i += 1) {
      var parent = this[i].parentNode; // eslint-disable-line
      while (parent) {
        if (selector) {
          if ($(parent).is(selector)) { parents.push(parent); }
        } else {
          parents.push(parent);
        }
        parent = parent.parentNode;
      }
    }
    return $(unique(parents));
  }
  function closest(selector) {
    var closest = this; // eslint-disable-line
    if (typeof selector === 'undefined') {
      return new Dom7([]);
    }
    if (!closest.is(selector)) {
      closest = closest.parents(selector).eq(0);
    }
    return closest;
  }
  function find(selector) {
    var foundElements = [];
    for (var i = 0; i < this.length; i += 1) {
      var found = this[i].querySelectorAll(selector);
      for (var j = 0; j < found.length; j += 1) {
        foundElements.push(found[j]);
      }
    }
    return new Dom7(foundElements);
  }
  function children(selector) {
    var children = []; // eslint-disable-line
    for (var i = 0; i < this.length; i += 1) {
      var childNodes = this[i].childNodes;

      for (var j = 0; j < childNodes.length; j += 1) {
        if (!selector) {
          if (childNodes[j].nodeType === 1) { children.push(childNodes[j]); }
        } else if (childNodes[j].nodeType === 1 && $(childNodes[j]).is(selector)) {
          children.push(childNodes[j]);
        }
      }
    }
    return new Dom7(unique(children));
  }
  function remove() {
    for (var i = 0; i < this.length; i += 1) {
      if (this[i].parentNode) { this[i].parentNode.removeChild(this[i]); }
    }
    return this;
  }
  function add() {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var dom = this;
    var i;
    var j;
    for (i = 0; i < args.length; i += 1) {
      var toAdd = $(args[i]);
      for (j = 0; j < toAdd.length; j += 1) {
        dom[dom.length] = toAdd[j];
        dom.length += 1;
      }
    }
    return dom;
  }

  var Methods = {
    addClass: addClass,
    removeClass: removeClass,
    hasClass: hasClass,
    toggleClass: toggleClass,
    attr: attr,
    removeAttr: removeAttr,
    data: data,
    transform: transform,
    transition: transition,
    on: on,
    off: off,
    trigger: trigger,
    transitionEnd: transitionEnd,
    outerWidth: outerWidth,
    outerHeight: outerHeight,
    offset: offset,
    css: css,
    each: each,
    html: html,
    text: text,
    is: is,
    index: index,
    eq: eq,
    append: append,
    prepend: prepend,
    next: next,
    nextAll: nextAll,
    prev: prev,
    prevAll: prevAll,
    parent: parent,
    parents: parents,
    closest: closest,
    find: find,
    children: children,
    remove: remove,
    add: add,
    styles: styles,
  };

  Object.keys(Methods).forEach(function (methodName) {
    $.fn[methodName] = $.fn[methodName] || Methods[methodName];
  });

  var Utils = {
    deleteProps: function deleteProps(obj) {
      var object = obj;
      Object.keys(object).forEach(function (key) {
        try {
          object[key] = null;
        } catch (e) {
          // no getter for object
        }
        try {
          delete object[key];
        } catch (e) {
          // something got wrong
        }
      });
    },
    nextTick: function nextTick(callback, delay) {
      if ( delay === void 0 ) delay = 0;

      return setTimeout(callback, delay);
    },
    now: function now() {
      return Date.now();
    },
    getTranslate: function getTranslate(el, axis) {
      if ( axis === void 0 ) axis = 'x';

      var matrix;
      var curTransform;
      var transformMatrix;

      var curStyle = win.getComputedStyle(el, null);

      if (win.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(',').length > 6) {
          curTransform = curTransform.split(', ').map(function (a) { return a.replace(',', '.'); }).join(', ');
        }
        // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new win.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
      } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
        matrix = transformMatrix.toString().split(',');
      }

      if (axis === 'x') {
        // Latest Chrome and webkits Fix
        if (win.WebKitCSSMatrix) { curTransform = transformMatrix.m41; }
        // Crazy IE10 Matrix
        else if (matrix.length === 16) { curTransform = parseFloat(matrix[12]); }
        // Normal Browsers
        else { curTransform = parseFloat(matrix[4]); }
      }
      if (axis === 'y') {
        // Latest Chrome and webkits Fix
        if (win.WebKitCSSMatrix) { curTransform = transformMatrix.m42; }
        // Crazy IE10 Matrix
        else if (matrix.length === 16) { curTransform = parseFloat(matrix[13]); }
        // Normal Browsers
        else { curTransform = parseFloat(matrix[5]); }
      }
      return curTransform || 0;
    },
    parseUrlQuery: function parseUrlQuery(url) {
      var query = {};
      var urlToParse = url || win.location.href;
      var i;
      var params;
      var param;
      var length;
      if (typeof urlToParse === 'string' && urlToParse.length) {
        urlToParse = urlToParse.indexOf('?') > -1 ? urlToParse.replace(/\S*\?/, '') : '';
        params = urlToParse.split('&').filter(function (paramsPart) { return paramsPart !== ''; });
        length = params.length;

        for (i = 0; i < length; i += 1) {
          param = params[i].replace(/#\S+/g, '').split('=');
          query[decodeURIComponent(param[0])] = typeof param[1] === 'undefined' ? undefined : decodeURIComponent(param[1]) || '';
        }
      }
      return query;
    },
    isObject: function isObject(o) {
      return typeof o === 'object' && o !== null && o.constructor && o.constructor === Object;
    },
    extend: function extend() {
      var args = [], len$1 = arguments.length;
      while ( len$1-- ) args[ len$1 ] = arguments[ len$1 ];

      var to = Object(args[0]);
      for (var i = 1; i < args.length; i += 1) {
        var nextSource = args[i];
        if (nextSource !== undefined && nextSource !== null) {
          var keysArray = Object.keys(Object(nextSource));
          for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
            var nextKey = keysArray[nextIndex];
            var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
            if (desc !== undefined && desc.enumerable) {
              if (Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
                Utils.extend(to[nextKey], nextSource[nextKey]);
              } else if (!Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
                to[nextKey] = {};
                Utils.extend(to[nextKey], nextSource[nextKey]);
              } else {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
      }
      return to;
    },
  };

  var Support = (function Support() {
    var testDiv = doc.createElement('div');
    return {
      touch: (win.Modernizr && win.Modernizr.touch === true) || (function checkTouch() {
        return !!((win.navigator.maxTouchPoints > 0) || ('ontouchstart' in win) || (win.DocumentTouch && doc instanceof win.DocumentTouch));
      }()),

      pointerEvents: !!(win.navigator.pointerEnabled || win.PointerEvent || ('maxTouchPoints' in win.navigator && win.navigator.maxTouchPoints > 0)),
      prefixedPointerEvents: !!win.navigator.msPointerEnabled,

      transition: (function checkTransition() {
        var style = testDiv.style;
        return ('transition' in style || 'webkitTransition' in style || 'MozTransition' in style);
      }()),
      transforms3d: (win.Modernizr && win.Modernizr.csstransforms3d === true) || (function checkTransforms3d() {
        var style = testDiv.style;
        return ('webkitPerspective' in style || 'MozPerspective' in style || 'OPerspective' in style || 'MsPerspective' in style || 'perspective' in style);
      }()),

      flexbox: (function checkFlexbox() {
        var style = testDiv.style;
        var styles = ('alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient').split(' ');
        for (var i = 0; i < styles.length; i += 1) {
          if (styles[i] in style) { return true; }
        }
        return false;
      }()),

      observer: (function checkObserver() {
        return ('MutationObserver' in win || 'WebkitMutationObserver' in win);
      }()),

      passiveListener: (function checkPassiveListener() {
        var supportsPassive = false;
        try {
          var opts = Object.defineProperty({}, 'passive', {
            // eslint-disable-next-line
            get: function get() {
              supportsPassive = true;
            },
          });
          win.addEventListener('testPassiveListener', null, opts);
        } catch (e) {
          // No support
        }
        return supportsPassive;
      }()),

      gestures: (function checkGestures() {
        return 'ongesturestart' in win;
      }()),
    };
  }());

  var Browser = (function Browser() {
    function isSafari() {
      var ua = win.navigator.userAgent.toLowerCase();
      return (ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0);
    }
    return {
      isIE: !!win.navigator.userAgent.match(/Trident/g) || !!win.navigator.userAgent.match(/MSIE/g),
      isEdge: !!win.navigator.userAgent.match(/Edge/g),
      isSafari: isSafari(),
      isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(win.navigator.userAgent),
    };
  }());

  var SwiperClass = function SwiperClass(params) {
    if ( params === void 0 ) params = {};

    var self = this;
    self.params = params;

    // Events
    self.eventsListeners = {};

    if (self.params && self.params.on) {
      Object.keys(self.params.on).forEach(function (eventName) {
        self.on(eventName, self.params.on[eventName]);
      });
    }
  };

  var staticAccessors = { components: { configurable: true } };

  SwiperClass.prototype.on = function on (events, handler, priority) {
    var self = this;
    if (typeof handler !== 'function') { return self; }
    var method = priority ? 'unshift' : 'push';
    events.split(' ').forEach(function (event) {
      if (!self.eventsListeners[event]) { self.eventsListeners[event] = []; }
      self.eventsListeners[event][method](handler);
    });
    return self;
  };

  SwiperClass.prototype.once = function once (events, handler, priority) {
    var self = this;
    if (typeof handler !== 'function') { return self; }
    function onceHandler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

      handler.apply(self, args);
      self.off(events, onceHandler);
      if (onceHandler.f7proxy) {
        delete onceHandler.f7proxy;
      }
    }
    onceHandler.f7proxy = handler;
    return self.on(events, onceHandler, priority);
  };

  SwiperClass.prototype.off = function off (events, handler) {
    var self = this;
    if (!self.eventsListeners) { return self; }
    events.split(' ').forEach(function (event) {
      if (typeof handler === 'undefined') {
        self.eventsListeners[event] = [];
      } else if (self.eventsListeners[event] && self.eventsListeners[event].length) {
        self.eventsListeners[event].forEach(function (eventHandler, index) {
          if (eventHandler === handler || (eventHandler.f7proxy && eventHandler.f7proxy === handler)) {
            self.eventsListeners[event].splice(index, 1);
          }
        });
      }
    });
    return self;
  };

  SwiperClass.prototype.emit = function emit () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

    var self = this;
    if (!self.eventsListeners) { return self; }
    var events;
    var data;
    var context;
    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
      events = args[0];
      data = args.slice(1, args.length);
      context = self;
    } else {
      events = args[0].events;
      data = args[0].data;
      context = args[0].context || self;
    }
    var eventsArray = Array.isArray(events) ? events : events.split(' ');
    eventsArray.forEach(function (event) {
      if (self.eventsListeners && self.eventsListeners[event]) {
        var handlers = [];
        self.eventsListeners[event].forEach(function (eventHandler) {
          handlers.push(eventHandler);
        });
        handlers.forEach(function (eventHandler) {
          eventHandler.apply(context, data);
        });
      }
    });
    return self;
  };

  SwiperClass.prototype.useModulesParams = function useModulesParams (instanceParams) {
    var instance = this;
    if (!instance.modules) { return; }
    Object.keys(instance.modules).forEach(function (moduleName) {
      var module = instance.modules[moduleName];
      // Extend params
      if (module.params) {
        Utils.extend(instanceParams, module.params);
      }
    });
  };

  SwiperClass.prototype.useModules = function useModules (modulesParams) {
      if ( modulesParams === void 0 ) modulesParams = {};

    var instance = this;
    if (!instance.modules) { return; }
    Object.keys(instance.modules).forEach(function (moduleName) {
      var module = instance.modules[moduleName];
      var moduleParams = modulesParams[moduleName] || {};
      // Extend instance methods and props
      if (module.instance) {
        Object.keys(module.instance).forEach(function (modulePropName) {
          var moduleProp = module.instance[modulePropName];
          if (typeof moduleProp === 'function') {
            instance[modulePropName] = moduleProp.bind(instance);
          } else {
            instance[modulePropName] = moduleProp;
          }
        });
      }
      // Add event listeners
      if (module.on && instance.on) {
        Object.keys(module.on).forEach(function (moduleEventName) {
          instance.on(moduleEventName, module.on[moduleEventName]);
        });
      }

      // Module create callback
      if (module.create) {
        module.create.bind(instance)(moduleParams);
      }
    });
  };

  staticAccessors.components.set = function (components) {
    var Class = this;
    if (!Class.use) { return; }
    Class.use(components);
  };

  SwiperClass.installModule = function installModule (module) {
      var params = [], len = arguments.length - 1;
      while ( len-- > 0 ) params[ len ] = arguments[ len + 1 ];

    var Class = this;
    if (!Class.prototype.modules) { Class.prototype.modules = {}; }
    var name = module.name || (((Object.keys(Class.prototype.modules).length) + "_" + (Utils.now())));
    Class.prototype.modules[name] = module;
    // Prototype
    if (module.proto) {
      Object.keys(module.proto).forEach(function (key) {
        Class.prototype[key] = module.proto[key];
      });
    }
    // Class
    if (module.static) {
      Object.keys(module.static).forEach(function (key) {
        Class[key] = module.static[key];
      });
    }
    // Callback
    if (module.install) {
      module.install.apply(Class, params);
    }
    return Class;
  };

  SwiperClass.use = function use (module) {
      var params = [], len = arguments.length - 1;
      while ( len-- > 0 ) params[ len ] = arguments[ len + 1 ];

    var Class = this;
    if (Array.isArray(module)) {
      module.forEach(function (m) { return Class.installModule(m); });
      return Class;
    }
    return Class.installModule.apply(Class, [ module ].concat( params ));
  };

  Object.defineProperties( SwiperClass, staticAccessors );

  function updateSize () {
    var swiper = this;
    var width;
    var height;
    var $el = swiper.$el;
    if (typeof swiper.params.width !== 'undefined') {
      width = swiper.params.width;
    } else {
      width = $el[0].clientWidth;
    }
    if (typeof swiper.params.height !== 'undefined') {
      height = swiper.params.height;
    } else {
      height = $el[0].clientHeight;
    }
    if ((width === 0 && swiper.isHorizontal()) || (height === 0 && swiper.isVertical())) {
      return;
    }

    // Subtract paddings
    width = width - parseInt($el.css('padding-left'), 10) - parseInt($el.css('padding-right'), 10);
    height = height - parseInt($el.css('padding-top'), 10) - parseInt($el.css('padding-bottom'), 10);

    Utils.extend(swiper, {
      width: width,
      height: height,
      size: swiper.isHorizontal() ? width : height,
    });
  }

  function updateSlides () {
    var swiper = this;
    var params = swiper.params;

    var $wrapperEl = swiper.$wrapperEl;
    var swiperSize = swiper.size;
    var rtl = swiper.rtlTranslate;
    var wrongRTL = swiper.wrongRTL;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    var slides = $wrapperEl.children(("." + (swiper.params.slideClass)));
    var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    var snapGrid = [];
    var slidesGrid = [];
    var slidesSizesGrid = [];

    var offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === 'function') {
      offsetBefore = params.slidesOffsetBefore.call(swiper);
    }

    var offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === 'function') {
      offsetAfter = params.slidesOffsetAfter.call(swiper);
    }

    var previousSnapGridLength = swiper.snapGrid.length;
    var previousSlidesGridLength = swiper.snapGrid.length;

    var spaceBetween = params.spaceBetween;
    var slidePosition = -offsetBefore;
    var prevSlideSize = 0;
    var index = 0;
    if (typeof swiperSize === 'undefined') {
      return;
    }
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
      spaceBetween = (parseFloat(spaceBetween.replace('%', '')) / 100) * swiperSize;
    }

    swiper.virtualSize = -spaceBetween;

    // reset margins
    if (rtl) { slides.css({ marginLeft: '', marginTop: '' }); }
    else { slides.css({ marginRight: '', marginBottom: '' }); }

    var slidesNumberEvenToRows;
    if (params.slidesPerColumn > 1) {
      if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
        slidesNumberEvenToRows = slidesLength;
      } else {
        slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
      }
      if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
        slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
      }
    }

    // Calc slides
    var slideSize;
    var slidesPerColumn = params.slidesPerColumn;
    var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
    var numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);
    for (var i = 0; i < slidesLength; i += 1) {
      slideSize = 0;
      var slide = slides.eq(i);
      if (params.slidesPerColumn > 1) {
        // Set slides order
        var newSlideOrderIndex = (void 0);
        var column = (void 0);
        var row = (void 0);
        if (
          (params.slidesPerColumnFill === 'column')
          || (params.slidesPerColumnFill === 'row' && params.slidesPerGroup > 1)
        ) {
          if (params.slidesPerColumnFill === 'column') {
            column = Math.floor(i / slidesPerColumn);
            row = i - (column * slidesPerColumn);
            if (column > numFullColumns || (column === numFullColumns && row === slidesPerColumn - 1)) {
              row += 1;
              if (row >= slidesPerColumn) {
                row = 0;
                column += 1;
              }
            }
          } else {
            var groupIndex = Math.floor(i / params.slidesPerGroup);
            row = Math.floor(i / params.slidesPerView) - groupIndex * params.slidesPerColumn;
            column = i - row * params.slidesPerView - groupIndex * params.slidesPerView;
          }
          newSlideOrderIndex = column + ((row * slidesNumberEvenToRows) / slidesPerColumn);
          slide
            .css({
              '-webkit-box-ordinal-group': newSlideOrderIndex,
              '-moz-box-ordinal-group': newSlideOrderIndex,
              '-ms-flex-order': newSlideOrderIndex,
              '-webkit-order': newSlideOrderIndex,
              order: newSlideOrderIndex,
            });
        } else {
          row = Math.floor(i / slidesPerRow);
          column = i - (row * slidesPerRow);
        }
        slide
          .css(
            ("margin-" + (swiper.isHorizontal() ? 'top' : 'left')),
            (row !== 0 && params.spaceBetween) && (((params.spaceBetween) + "px"))
          )
          .attr('data-swiper-column', column)
          .attr('data-swiper-row', row);
      }
      if (slide.css('display') === 'none') { continue; } // eslint-disable-line

      if (params.slidesPerView === 'auto') {
        var slideStyles = win.getComputedStyle(slide[0], null);
        var currentTransform = slide[0].style.transform;
        var currentWebKitTransform = slide[0].style.webkitTransform;
        if (currentTransform) {
          slide[0].style.transform = 'none';
        }
        if (currentWebKitTransform) {
          slide[0].style.webkitTransform = 'none';
        }
        if (params.roundLengths) {
          slideSize = swiper.isHorizontal()
            ? slide.outerWidth(true)
            : slide.outerHeight(true);
        } else {
          // eslint-disable-next-line
          if (swiper.isHorizontal()) {
            var width = parseFloat(slideStyles.getPropertyValue('width'));
            var paddingLeft = parseFloat(slideStyles.getPropertyValue('padding-left'));
            var paddingRight = parseFloat(slideStyles.getPropertyValue('padding-right'));
            var marginLeft = parseFloat(slideStyles.getPropertyValue('margin-left'));
            var marginRight = parseFloat(slideStyles.getPropertyValue('margin-right'));
            var boxSizing = slideStyles.getPropertyValue('box-sizing');
            if (boxSizing && boxSizing === 'border-box' && !Browser.isIE) {
              slideSize = width + marginLeft + marginRight;
            } else {
              slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight;
            }
          } else {
            var height = parseFloat(slideStyles.getPropertyValue('height'));
            var paddingTop = parseFloat(slideStyles.getPropertyValue('padding-top'));
            var paddingBottom = parseFloat(slideStyles.getPropertyValue('padding-bottom'));
            var marginTop = parseFloat(slideStyles.getPropertyValue('margin-top'));
            var marginBottom = parseFloat(slideStyles.getPropertyValue('margin-bottom'));
            var boxSizing$1 = slideStyles.getPropertyValue('box-sizing');
            if (boxSizing$1 && boxSizing$1 === 'border-box' && !Browser.isIE) {
              slideSize = height + marginTop + marginBottom;
            } else {
              slideSize = height + paddingTop + paddingBottom + marginTop + marginBottom;
            }
          }
        }
        if (currentTransform) {
          slide[0].style.transform = currentTransform;
        }
        if (currentWebKitTransform) {
          slide[0].style.webkitTransform = currentWebKitTransform;
        }
        if (params.roundLengths) { slideSize = Math.floor(slideSize); }
      } else {
        slideSize = (swiperSize - ((params.slidesPerView - 1) * spaceBetween)) / params.slidesPerView;
        if (params.roundLengths) { slideSize = Math.floor(slideSize); }

        if (slides[i]) {
          if (swiper.isHorizontal()) {
            slides[i].style.width = slideSize + "px";
          } else {
            slides[i].style.height = slideSize + "px";
          }
        }
      }
      if (slides[i]) {
        slides[i].swiperSlideSize = slideSize;
      }
      slidesSizesGrid.push(slideSize);


      if (params.centeredSlides) {
        slidePosition = slidePosition + (slideSize / 2) + (prevSlideSize / 2) + spaceBetween;
        if (prevSlideSize === 0 && i !== 0) { slidePosition = slidePosition - (swiperSize / 2) - spaceBetween; }
        if (i === 0) { slidePosition = slidePosition - (swiperSize / 2) - spaceBetween; }
        if (Math.abs(slidePosition) < 1 / 1000) { slidePosition = 0; }
        if (params.roundLengths) { slidePosition = Math.floor(slidePosition); }
        if ((index) % params.slidesPerGroup === 0) { snapGrid.push(slidePosition); }
        slidesGrid.push(slidePosition);
      } else {
        if (params.roundLengths) { slidePosition = Math.floor(slidePosition); }
        if ((index) % params.slidesPerGroup === 0) { snapGrid.push(slidePosition); }
        slidesGrid.push(slidePosition);
        slidePosition = slidePosition + slideSize + spaceBetween;
      }

      swiper.virtualSize += slideSize + spaceBetween;

      prevSlideSize = slideSize;

      index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    var newSlidesGrid;

    if (
      rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
      $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") });
    }
    if (!Support.flexbox || params.setWrapperSize) {
      if (swiper.isHorizontal()) { $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
      else { $wrapperEl.css({ height: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
    }

    if (params.slidesPerColumn > 1) {
      swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
      swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
      if (swiper.isHorizontal()) { $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
      else { $wrapperEl.css({ height: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
      if (params.centeredSlides) {
        newSlidesGrid = [];
        for (var i$1 = 0; i$1 < snapGrid.length; i$1 += 1) {
          var slidesGridItem = snapGrid[i$1];
          if (params.roundLengths) { slidesGridItem = Math.floor(slidesGridItem); }
          if (snapGrid[i$1] < swiper.virtualSize + snapGrid[0]) { newSlidesGrid.push(slidesGridItem); }
        }
        snapGrid = newSlidesGrid;
      }
    }

    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
      newSlidesGrid = [];
      for (var i$2 = 0; i$2 < snapGrid.length; i$2 += 1) {
        var slidesGridItem$1 = snapGrid[i$2];
        if (params.roundLengths) { slidesGridItem$1 = Math.floor(slidesGridItem$1); }
        if (snapGrid[i$2] <= swiper.virtualSize - swiperSize) {
          newSlidesGrid.push(slidesGridItem$1);
        }
      }
      snapGrid = newSlidesGrid;
      if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
        snapGrid.push(swiper.virtualSize - swiperSize);
      }
    }
    if (snapGrid.length === 0) { snapGrid = [0]; }

    if (params.spaceBetween !== 0) {
      if (swiper.isHorizontal()) {
        if (rtl) { slides.css({ marginLeft: (spaceBetween + "px") }); }
        else { slides.css({ marginRight: (spaceBetween + "px") }); }
      } else { slides.css({ marginBottom: (spaceBetween + "px") }); }
    }

    if (params.centerInsufficientSlides) {
      var allSlidesSize = 0;
      slidesSizesGrid.forEach(function (slideSizeValue) {
        allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
      });
      allSlidesSize -= params.spaceBetween;
      if (allSlidesSize < swiperSize) {
        var allSlidesOffset = (swiperSize - allSlidesSize) / 2;
        snapGrid.forEach(function (snap, snapIndex) {
          snapGrid[snapIndex] = snap - allSlidesOffset;
        });
        slidesGrid.forEach(function (snap, snapIndex) {
          slidesGrid[snapIndex] = snap + allSlidesOffset;
        });
      }
    }

    Utils.extend(swiper, {
      slides: slides,
      snapGrid: snapGrid,
      slidesGrid: slidesGrid,
      slidesSizesGrid: slidesSizesGrid,
    });

    if (slidesLength !== previousSlidesLength) {
      swiper.emit('slidesLengthChange');
    }
    if (snapGrid.length !== previousSnapGridLength) {
      if (swiper.params.watchOverflow) { swiper.checkOverflow(); }
      swiper.emit('snapGridLengthChange');
    }
    if (slidesGrid.length !== previousSlidesGridLength) {
      swiper.emit('slidesGridLengthChange');
    }

    if (params.watchSlidesProgress || params.watchSlidesVisibility) {
      swiper.updateSlidesOffset();
    }
  }

  function updateAutoHeight (speed) {
    var swiper = this;
    var activeSlides = [];
    var newHeight = 0;
    var i;
    if (typeof speed === 'number') {
      swiper.setTransition(speed);
    } else if (speed === true) {
      swiper.setTransition(swiper.params.speed);
    }
    // Find slides currently in view
    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
        var index = swiper.activeIndex + i;
        if (index > swiper.slides.length) { break; }
        activeSlides.push(swiper.slides.eq(index)[0]);
      }
    } else {
      activeSlides.push(swiper.slides.eq(swiper.activeIndex)[0]);
    }

    // Find new height from highest slide in view
    for (i = 0; i < activeSlides.length; i += 1) {
      if (typeof activeSlides[i] !== 'undefined') {
        var height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
      }
    }

    // Update Height
    if (newHeight) { swiper.$wrapperEl.css('height', (newHeight + "px")); }
  }

  function updateSlidesOffset () {
    var swiper = this;
    var slides = swiper.slides;
    for (var i = 0; i < slides.length; i += 1) {
      slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
    }
  }

  function updateSlidesProgress (translate) {
    if ( translate === void 0 ) translate = (this && this.translate) || 0;

    var swiper = this;
    var params = swiper.params;

    var slides = swiper.slides;
    var rtl = swiper.rtlTranslate;

    if (slides.length === 0) { return; }
    if (typeof slides[0].swiperSlideOffset === 'undefined') { swiper.updateSlidesOffset(); }

    var offsetCenter = -translate;
    if (rtl) { offsetCenter = translate; }

    // Visible Slides
    slides.removeClass(params.slideVisibleClass);

    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];

    for (var i = 0; i < slides.length; i += 1) {
      var slide = slides[i];
      var slideProgress = (
        (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0)) - slide.swiperSlideOffset
      ) / (slide.swiperSlideSize + params.spaceBetween);
      if (params.watchSlidesVisibility) {
        var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
        var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        var isVisible = (slideBefore >= 0 && slideBefore < swiper.size - 1)
                  || (slideAfter > 1 && slideAfter <= swiper.size)
                  || (slideBefore <= 0 && slideAfter >= swiper.size);
        if (isVisible) {
          swiper.visibleSlides.push(slide);
          swiper.visibleSlidesIndexes.push(i);
          slides.eq(i).addClass(params.slideVisibleClass);
        }
      }
      slide.progress = rtl ? -slideProgress : slideProgress;
    }
    swiper.visibleSlides = $(swiper.visibleSlides);
  }

  function updateProgress (translate) {
    if ( translate === void 0 ) translate = (this && this.translate) || 0;

    var swiper = this;
    var params = swiper.params;

    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    var progress = swiper.progress;
    var isBeginning = swiper.isBeginning;
    var isEnd = swiper.isEnd;
    var wasBeginning = isBeginning;
    var wasEnd = isEnd;
    if (translatesDiff === 0) {
      progress = 0;
      isBeginning = true;
      isEnd = true;
    } else {
      progress = (translate - swiper.minTranslate()) / (translatesDiff);
      isBeginning = progress <= 0;
      isEnd = progress >= 1;
    }
    Utils.extend(swiper, {
      progress: progress,
      isBeginning: isBeginning,
      isEnd: isEnd,
    });

    if (params.watchSlidesProgress || params.watchSlidesVisibility) { swiper.updateSlidesProgress(translate); }

    if (isBeginning && !wasBeginning) {
      swiper.emit('reachBeginning toEdge');
    }
    if (isEnd && !wasEnd) {
      swiper.emit('reachEnd toEdge');
    }
    if ((wasBeginning && !isBeginning) || (wasEnd && !isEnd)) {
      swiper.emit('fromEdge');
    }

    swiper.emit('progress', progress);
  }

  function updateSlidesClasses () {
    var swiper = this;

    var slides = swiper.slides;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    var activeIndex = swiper.activeIndex;
    var realIndex = swiper.realIndex;
    var isVirtual = swiper.virtual && params.virtual.enabled;

    slides.removeClass(((params.slideActiveClass) + " " + (params.slideNextClass) + " " + (params.slidePrevClass) + " " + (params.slideDuplicateActiveClass) + " " + (params.slideDuplicateNextClass) + " " + (params.slideDuplicatePrevClass)));

    var activeSlide;
    if (isVirtual) {
      activeSlide = swiper.$wrapperEl.find(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + activeIndex + "\"]"));
    } else {
      activeSlide = slides.eq(activeIndex);
    }

    // Active classes
    activeSlide.addClass(params.slideActiveClass);

    if (params.loop) {
      // Duplicate to all looped slides
      if (activeSlide.hasClass(params.slideDuplicateClass)) {
        $wrapperEl
          .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + realIndex + "\"]"))
          .addClass(params.slideDuplicateActiveClass);
      } else {
        $wrapperEl
          .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]"))
          .addClass(params.slideDuplicateActiveClass);
      }
    }
    // Next Slide
    var nextSlide = activeSlide.nextAll(("." + (params.slideClass))).eq(0).addClass(params.slideNextClass);
    if (params.loop && nextSlide.length === 0) {
      nextSlide = slides.eq(0);
      nextSlide.addClass(params.slideNextClass);
    }
    // Prev Slide
    var prevSlide = activeSlide.prevAll(("." + (params.slideClass))).eq(0).addClass(params.slidePrevClass);
    if (params.loop && prevSlide.length === 0) {
      prevSlide = slides.eq(-1);
      prevSlide.addClass(params.slidePrevClass);
    }
    if (params.loop) {
      // Duplicate to all looped slides
      if (nextSlide.hasClass(params.slideDuplicateClass)) {
        $wrapperEl
          .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + (nextSlide.attr('data-swiper-slide-index')) + "\"]"))
          .addClass(params.slideDuplicateNextClass);
      } else {
        $wrapperEl
          .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + (nextSlide.attr('data-swiper-slide-index')) + "\"]"))
          .addClass(params.slideDuplicateNextClass);
      }
      if (prevSlide.hasClass(params.slideDuplicateClass)) {
        $wrapperEl
          .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + (prevSlide.attr('data-swiper-slide-index')) + "\"]"))
          .addClass(params.slideDuplicatePrevClass);
      } else {
        $wrapperEl
          .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + (prevSlide.attr('data-swiper-slide-index')) + "\"]"))
          .addClass(params.slideDuplicatePrevClass);
      }
    }
  }

  function updateActiveIndex (newActiveIndex) {
    var swiper = this;
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    var slidesGrid = swiper.slidesGrid;
    var snapGrid = swiper.snapGrid;
    var params = swiper.params;
    var previousIndex = swiper.activeIndex;
    var previousRealIndex = swiper.realIndex;
    var previousSnapIndex = swiper.snapIndex;
    var activeIndex = newActiveIndex;
    var snapIndex;
    if (typeof activeIndex === 'undefined') {
      for (var i = 0; i < slidesGrid.length; i += 1) {
        if (typeof slidesGrid[i + 1] !== 'undefined') {
          if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - ((slidesGrid[i + 1] - slidesGrid[i]) / 2)) {
            activeIndex = i;
          } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
            activeIndex = i + 1;
          }
        } else if (translate >= slidesGrid[i]) {
          activeIndex = i;
        }
      }
      // Normalize slideIndex
      if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === 'undefined') { activeIndex = 0; }
      }
    }
    if (snapGrid.indexOf(translate) >= 0) {
      snapIndex = snapGrid.indexOf(translate);
    } else {
      snapIndex = Math.floor(activeIndex / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) { snapIndex = snapGrid.length - 1; }
    if (activeIndex === previousIndex) {
      if (snapIndex !== previousSnapIndex) {
        swiper.snapIndex = snapIndex;
        swiper.emit('snapIndexChange');
      }
      return;
    }

    // Get real index
    var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);

    Utils.extend(swiper, {
      snapIndex: snapIndex,
      realIndex: realIndex,
      previousIndex: previousIndex,
      activeIndex: activeIndex,
    });
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');
    if (previousRealIndex !== realIndex) {
      swiper.emit('realIndexChange');
    }
    if (swiper.initialized || swiper.runCallbacksOnInit) {
      swiper.emit('slideChange');
    }
  }

  function updateClickedSlide (e) {
    var swiper = this;
    var params = swiper.params;
    var slide = $(e.target).closest(("." + (params.slideClass)))[0];
    var slideFound = false;
    if (slide) {
      for (var i = 0; i < swiper.slides.length; i += 1) {
        if (swiper.slides[i] === slide) { slideFound = true; }
      }
    }

    if (slide && slideFound) {
      swiper.clickedSlide = slide;
      if (swiper.virtual && swiper.params.virtual.enabled) {
        swiper.clickedIndex = parseInt($(slide).attr('data-swiper-slide-index'), 10);
      } else {
        swiper.clickedIndex = $(slide).index();
      }
    } else {
      swiper.clickedSlide = undefined;
      swiper.clickedIndex = undefined;
      return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
      swiper.slideToClickedSlide();
    }
  }

  var update = {
    updateSize: updateSize,
    updateSlides: updateSlides,
    updateAutoHeight: updateAutoHeight,
    updateSlidesOffset: updateSlidesOffset,
    updateSlidesProgress: updateSlidesProgress,
    updateProgress: updateProgress,
    updateSlidesClasses: updateSlidesClasses,
    updateActiveIndex: updateActiveIndex,
    updateClickedSlide: updateClickedSlide,
  };

  function getTranslate (axis) {
    if ( axis === void 0 ) axis = this.isHorizontal() ? 'x' : 'y';

    var swiper = this;

    var params = swiper.params;
    var rtl = swiper.rtlTranslate;
    var translate = swiper.translate;
    var $wrapperEl = swiper.$wrapperEl;

    if (params.virtualTranslate) {
      return rtl ? -translate : translate;
    }

    var currentTranslate = Utils.getTranslate($wrapperEl[0], axis);
    if (rtl) { currentTranslate = -currentTranslate; }

    return currentTranslate || 0;
  }

  function setTranslate (translate, byController) {
    var swiper = this;
    var rtl = swiper.rtlTranslate;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    var progress = swiper.progress;
    var x = 0;
    var y = 0;
    var z = 0;

    if (swiper.isHorizontal()) {
      x = rtl ? -translate : translate;
    } else {
      y = translate;
    }

    if (params.roundLengths) {
      x = Math.floor(x);
      y = Math.floor(y);
    }

    if (!params.virtualTranslate) {
      if (Support.transforms3d) { $wrapperEl.transform(("translate3d(" + x + "px, " + y + "px, " + z + "px)")); }
      else { $wrapperEl.transform(("translate(" + x + "px, " + y + "px)")); }
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;

    // Check if we need to update progress
    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) {
      newProgress = 0;
    } else {
      newProgress = (translate - swiper.minTranslate()) / (translatesDiff);
    }
    if (newProgress !== progress) {
      swiper.updateProgress(translate);
    }

    swiper.emit('setTranslate', swiper.translate, byController);
  }

  function minTranslate () {
    return (-this.snapGrid[0]);
  }

  function maxTranslate () {
    return (-this.snapGrid[this.snapGrid.length - 1]);
  }

  var translate = {
    getTranslate: getTranslate,
    setTranslate: setTranslate,
    minTranslate: minTranslate,
    maxTranslate: maxTranslate,
  };

  function setTransition (duration, byController) {
    var swiper = this;

    swiper.$wrapperEl.transition(duration);

    swiper.emit('setTransition', duration, byController);
  }

  function transitionStart (runCallbacks, direction) {
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var activeIndex = swiper.activeIndex;
    var params = swiper.params;
    var previousIndex = swiper.previousIndex;
    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }

    var dir = direction;
    if (!dir) {
      if (activeIndex > previousIndex) { dir = 'next'; }
      else if (activeIndex < previousIndex) { dir = 'prev'; }
      else { dir = 'reset'; }
    }

    swiper.emit('transitionStart');

    if (runCallbacks && activeIndex !== previousIndex) {
      if (dir === 'reset') {
        swiper.emit('slideResetTransitionStart');
        return;
      }
      swiper.emit('slideChangeTransitionStart');
      if (dir === 'next') {
        swiper.emit('slideNextTransitionStart');
      } else {
        swiper.emit('slidePrevTransitionStart');
      }
    }
  }

  function transitionEnd$1 (runCallbacks, direction) {
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var activeIndex = swiper.activeIndex;
    var previousIndex = swiper.previousIndex;
    swiper.animating = false;
    swiper.setTransition(0);

    var dir = direction;
    if (!dir) {
      if (activeIndex > previousIndex) { dir = 'next'; }
      else if (activeIndex < previousIndex) { dir = 'prev'; }
      else { dir = 'reset'; }
    }

    swiper.emit('transitionEnd');

    if (runCallbacks && activeIndex !== previousIndex) {
      if (dir === 'reset') {
        swiper.emit('slideResetTransitionEnd');
        return;
      }
      swiper.emit('slideChangeTransitionEnd');
      if (dir === 'next') {
        swiper.emit('slideNextTransitionEnd');
      } else {
        swiper.emit('slidePrevTransitionEnd');
      }
    }
  }

  var transition$1 = {
    setTransition: setTransition,
    transitionStart: transitionStart,
    transitionEnd: transitionEnd$1,
  };

  function slideTo (index, speed, runCallbacks, internal) {
    if ( index === void 0 ) index = 0;
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var slideIndex = index;
    if (slideIndex < 0) { slideIndex = 0; }

    var params = swiper.params;
    var snapGrid = swiper.snapGrid;
    var slidesGrid = swiper.slidesGrid;
    var previousIndex = swiper.previousIndex;
    var activeIndex = swiper.activeIndex;
    var rtl = swiper.rtlTranslate;
    if (swiper.animating && params.preventInteractionOnTransition) {
      return false;
    }

    var snapIndex = Math.floor(slideIndex / params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) { snapIndex = snapGrid.length - 1; }

    if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
      swiper.emit('beforeSlideChangeStart');
    }

    var translate = -snapGrid[snapIndex];

    // Update progress
    swiper.updateProgress(translate);

    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
      for (var i = 0; i < slidesGrid.length; i += 1) {
        if (-Math.floor(translate * 100) >= Math.floor(slidesGrid[i] * 100)) {
          slideIndex = i;
        }
      }
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
      if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
        return false;
      }
      if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
        if ((activeIndex || 0) !== slideIndex) { return false; }
      }
    }

    var direction;
    if (slideIndex > activeIndex) { direction = 'next'; }
    else if (slideIndex < activeIndex) { direction = 'prev'; }
    else { direction = 'reset'; }


    // Update Index
    if ((rtl && -translate === swiper.translate) || (!rtl && translate === swiper.translate)) {
      swiper.updateActiveIndex(slideIndex);
      // Update Height
      if (params.autoHeight) {
        swiper.updateAutoHeight();
      }
      swiper.updateSlidesClasses();
      if (params.effect !== 'slide') {
        swiper.setTranslate(translate);
      }
      if (direction !== 'reset') {
        swiper.transitionStart(runCallbacks, direction);
        swiper.transitionEnd(runCallbacks, direction);
      }
      return false;
    }

    if (speed === 0 || !Support.transition) {
      swiper.setTransition(0);
      swiper.setTranslate(translate);
      swiper.updateActiveIndex(slideIndex);
      swiper.updateSlidesClasses();
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    } else {
      swiper.setTransition(speed);
      swiper.setTranslate(translate);
      swiper.updateActiveIndex(slideIndex);
      swiper.updateSlidesClasses();
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.transitionStart(runCallbacks, direction);
      if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) {
          swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) { return; }
            if (e.target !== this) { return; }
            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
          };
        }
        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
      }
    }

    return true;
  }

  function slideToLoop (index, speed, runCallbacks, internal) {
    if ( index === void 0 ) index = 0;
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var newIndex = index;
    if (swiper.params.loop) {
      newIndex += swiper.loopedSlides;
    }

    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
  }

  /* eslint no-unused-vars: "off" */
  function slideNext (speed, runCallbacks, internal) {
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var params = swiper.params;
    var animating = swiper.animating;
    if (params.loop) {
      if (animating) { return false; }
      swiper.loopFix();
      // eslint-disable-next-line
      swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
      return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
    }
    return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
  }

  /* eslint no-unused-vars: "off" */
  function slidePrev (speed, runCallbacks, internal) {
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var params = swiper.params;
    var animating = swiper.animating;
    var snapGrid = swiper.snapGrid;
    var slidesGrid = swiper.slidesGrid;
    var rtlTranslate = swiper.rtlTranslate;

    if (params.loop) {
      if (animating) { return false; }
      swiper.loopFix();
      // eslint-disable-next-line
      swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    var translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
      if (val < 0) { return -Math.floor(Math.abs(val)); }
      return Math.floor(val);
    }
    var normalizedTranslate = normalize(translate);
    var normalizedSnapGrid = snapGrid.map(function (val) { return normalize(val); });
    var normalizedSlidesGrid = slidesGrid.map(function (val) { return normalize(val); });

    var currentSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate)];
    var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    var prevIndex;
    if (typeof prevSnap !== 'undefined') {
      prevIndex = slidesGrid.indexOf(prevSnap);
      if (prevIndex < 0) { prevIndex = swiper.activeIndex - 1; }
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
  }

  /* eslint no-unused-vars: "off" */
  function slideReset (speed, runCallbacks, internal) {
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
  }

  /* eslint no-unused-vars: "off" */
  function slideToClosest (speed, runCallbacks, internal) {
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var index = swiper.activeIndex;
    var snapIndex = Math.floor(index / swiper.params.slidesPerGroup);

    if (snapIndex < swiper.snapGrid.length - 1) {
      var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;

      var currentSnap = swiper.snapGrid[snapIndex];
      var nextSnap = swiper.snapGrid[snapIndex + 1];

      if ((translate - currentSnap) > (nextSnap - currentSnap) / 2) {
        index = swiper.params.slidesPerGroup;
      }
    }

    return swiper.slideTo(index, speed, runCallbacks, internal);
  }

  function slideToClickedSlide () {
    var swiper = this;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;

    var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    var slideToIndex = swiper.clickedIndex;
    var realIndex;
    if (params.loop) {
      if (swiper.animating) { return; }
      realIndex = parseInt($(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
      if (params.centeredSlides) {
        if (
          (slideToIndex < swiper.loopedSlides - (slidesPerView / 2))
          || (slideToIndex > (swiper.slides.length - swiper.loopedSlides) + (slidesPerView / 2))
        ) {
          swiper.loopFix();
          slideToIndex = $wrapperEl
            .children(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + (params.slideDuplicateClass) + ")"))
            .eq(0)
            .index();

          Utils.nextTick(function () {
            swiper.slideTo(slideToIndex);
          });
        } else {
          swiper.slideTo(slideToIndex);
        }
      } else if (slideToIndex > swiper.slides.length - slidesPerView) {
        swiper.loopFix();
        slideToIndex = $wrapperEl
          .children(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + (params.slideDuplicateClass) + ")"))
          .eq(0)
          .index();

        Utils.nextTick(function () {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else {
      swiper.slideTo(slideToIndex);
    }
  }

  var slide = {
    slideTo: slideTo,
    slideToLoop: slideToLoop,
    slideNext: slideNext,
    slidePrev: slidePrev,
    slideReset: slideReset,
    slideToClosest: slideToClosest,
    slideToClickedSlide: slideToClickedSlide,
  };

  function loopCreate () {
    var swiper = this;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    // Remove duplicated slides
    $wrapperEl.children(("." + (params.slideClass) + "." + (params.slideDuplicateClass))).remove();

    var slides = $wrapperEl.children(("." + (params.slideClass)));

    if (params.loopFillGroupWithBlank) {
      var blankSlidesNum = params.slidesPerGroup - (slides.length % params.slidesPerGroup);
      if (blankSlidesNum !== params.slidesPerGroup) {
        for (var i = 0; i < blankSlidesNum; i += 1) {
          var blankNode = $(doc.createElement('div')).addClass(((params.slideClass) + " " + (params.slideBlankClass)));
          $wrapperEl.append(blankNode);
        }
        slides = $wrapperEl.children(("." + (params.slideClass)));
      }
    }

    if (params.slidesPerView === 'auto' && !params.loopedSlides) { params.loopedSlides = slides.length; }

    swiper.loopedSlides = parseInt(params.loopedSlides || params.slidesPerView, 10);
    swiper.loopedSlides += params.loopAdditionalSlides;
    if (swiper.loopedSlides > slides.length) {
      swiper.loopedSlides = slides.length;
    }

    var prependSlides = [];
    var appendSlides = [];
    slides.each(function (index, el) {
      var slide = $(el);
      if (index < swiper.loopedSlides) { appendSlides.push(el); }
      if (index < slides.length && index >= slides.length - swiper.loopedSlides) { prependSlides.push(el); }
      slide.attr('data-swiper-slide-index', index);
    });
    for (var i$1 = 0; i$1 < appendSlides.length; i$1 += 1) {
      $wrapperEl.append($(appendSlides[i$1].cloneNode(true)).addClass(params.slideDuplicateClass));
    }
    for (var i$2 = prependSlides.length - 1; i$2 >= 0; i$2 -= 1) {
      $wrapperEl.prepend($(prependSlides[i$2].cloneNode(true)).addClass(params.slideDuplicateClass));
    }
  }

  function loopFix () {
    var swiper = this;
    var params = swiper.params;
    var activeIndex = swiper.activeIndex;
    var slides = swiper.slides;
    var loopedSlides = swiper.loopedSlides;
    var allowSlidePrev = swiper.allowSlidePrev;
    var allowSlideNext = swiper.allowSlideNext;
    var snapGrid = swiper.snapGrid;
    var rtl = swiper.rtlTranslate;
    var newIndex;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;

    var snapTranslate = -snapGrid[activeIndex];
    var diff = snapTranslate - swiper.getTranslate();


    // Fix For Negative Oversliding
    if (activeIndex < loopedSlides) {
      newIndex = (slides.length - (loopedSlides * 3)) + activeIndex;
      newIndex += loopedSlides;
      var slideChanged = swiper.slideTo(newIndex, 0, false, true);
      if (slideChanged && diff !== 0) {
        swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
      }
    } else if ((params.slidesPerView === 'auto' && activeIndex >= loopedSlides * 2) || (activeIndex >= slides.length - loopedSlides)) {
      // Fix For Positive Oversliding
      newIndex = -slides.length + activeIndex + loopedSlides;
      newIndex += loopedSlides;
      var slideChanged$1 = swiper.slideTo(newIndex, 0, false, true);
      if (slideChanged$1 && diff !== 0) {
        swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
      }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
  }

  function loopDestroy () {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl;
    var params = swiper.params;
    var slides = swiper.slides;
    $wrapperEl.children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + ",." + (params.slideClass) + "." + (params.slideBlankClass))).remove();
    slides.removeAttr('data-swiper-slide-index');
  }

  var loop = {
    loopCreate: loopCreate,
    loopFix: loopFix,
    loopDestroy: loopDestroy,
  };

  function setGrabCursor (moving) {
    var swiper = this;
    if (Support.touch || !swiper.params.simulateTouch || (swiper.params.watchOverflow && swiper.isLocked)) { return; }
    var el = swiper.el;
    el.style.cursor = 'move';
    el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
    el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
    el.style.cursor = moving ? 'grabbing' : 'grab';
  }

  function unsetGrabCursor () {
    var swiper = this;
    if (Support.touch || (swiper.params.watchOverflow && swiper.isLocked)) { return; }
    swiper.el.style.cursor = '';
  }

  var grabCursor = {
    setGrabCursor: setGrabCursor,
    unsetGrabCursor: unsetGrabCursor,
  };

  function appendSlide (slides) {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl;
    var params = swiper.params;
    if (params.loop) {
      swiper.loopDestroy();
    }
    if (typeof slides === 'object' && 'length' in slides) {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i]) { $wrapperEl.append(slides[i]); }
      }
    } else {
      $wrapperEl.append(slides);
    }
    if (params.loop) {
      swiper.loopCreate();
    }
    if (!(params.observer && Support.observer)) {
      swiper.update();
    }
  }

  function prependSlide (slides) {
    var swiper = this;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    var activeIndex = swiper.activeIndex;

    if (params.loop) {
      swiper.loopDestroy();
    }
    var newActiveIndex = activeIndex + 1;
    if (typeof slides === 'object' && 'length' in slides) {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i]) { $wrapperEl.prepend(slides[i]); }
      }
      newActiveIndex = activeIndex + slides.length;
    } else {
      $wrapperEl.prepend(slides);
    }
    if (params.loop) {
      swiper.loopCreate();
    }
    if (!(params.observer && Support.observer)) {
      swiper.update();
    }
    swiper.slideTo(newActiveIndex, 0, false);
  }

  function addSlide (index, slides) {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl;
    var params = swiper.params;
    var activeIndex = swiper.activeIndex;
    var activeIndexBuffer = activeIndex;
    if (params.loop) {
      activeIndexBuffer -= swiper.loopedSlides;
      swiper.loopDestroy();
      swiper.slides = $wrapperEl.children(("." + (params.slideClass)));
    }
    var baseLength = swiper.slides.length;
    if (index <= 0) {
      swiper.prependSlide(slides);
      return;
    }
    if (index >= baseLength) {
      swiper.appendSlide(slides);
      return;
    }
    var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;

    var slidesBuffer = [];
    for (var i = baseLength - 1; i >= index; i -= 1) {
      var currentSlide = swiper.slides.eq(i);
      currentSlide.remove();
      slidesBuffer.unshift(currentSlide);
    }

    if (typeof slides === 'object' && 'length' in slides) {
      for (var i$1 = 0; i$1 < slides.length; i$1 += 1) {
        if (slides[i$1]) { $wrapperEl.append(slides[i$1]); }
      }
      newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else {
      $wrapperEl.append(slides);
    }

    for (var i$2 = 0; i$2 < slidesBuffer.length; i$2 += 1) {
      $wrapperEl.append(slidesBuffer[i$2]);
    }

    if (params.loop) {
      swiper.loopCreate();
    }
    if (!(params.observer && Support.observer)) {
      swiper.update();
    }
    if (params.loop) {
      swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    } else {
      swiper.slideTo(newActiveIndex, 0, false);
    }
  }

  function removeSlide (slidesIndexes) {
    var swiper = this;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    var activeIndex = swiper.activeIndex;

    var activeIndexBuffer = activeIndex;
    if (params.loop) {
      activeIndexBuffer -= swiper.loopedSlides;
      swiper.loopDestroy();
      swiper.slides = $wrapperEl.children(("." + (params.slideClass)));
    }
    var newActiveIndex = activeIndexBuffer;
    var indexToRemove;

    if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
      for (var i = 0; i < slidesIndexes.length; i += 1) {
        indexToRemove = slidesIndexes[i];
        if (swiper.slides[indexToRemove]) { swiper.slides.eq(indexToRemove).remove(); }
        if (indexToRemove < newActiveIndex) { newActiveIndex -= 1; }
      }
      newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
      indexToRemove = slidesIndexes;
      if (swiper.slides[indexToRemove]) { swiper.slides.eq(indexToRemove).remove(); }
      if (indexToRemove < newActiveIndex) { newActiveIndex -= 1; }
      newActiveIndex = Math.max(newActiveIndex, 0);
    }

    if (params.loop) {
      swiper.loopCreate();
    }

    if (!(params.observer && Support.observer)) {
      swiper.update();
    }
    if (params.loop) {
      swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    } else {
      swiper.slideTo(newActiveIndex, 0, false);
    }
  }

  function removeAllSlides () {
    var swiper = this;

    var slidesIndexes = [];
    for (var i = 0; i < swiper.slides.length; i += 1) {
      slidesIndexes.push(i);
    }
    swiper.removeSlide(slidesIndexes);
  }

  var manipulation = {
    appendSlide: appendSlide,
    prependSlide: prependSlide,
    addSlide: addSlide,
    removeSlide: removeSlide,
    removeAllSlides: removeAllSlides,
  };

  var Device = (function Device() {
    var ua = win.navigator.userAgent;

    var device = {
      ios: false,
      android: false,
      androidChrome: false,
      desktop: false,
      windows: false,
      iphone: false,
      ipod: false,
      ipad: false,
      cordova: win.cordova || win.phonegap,
      phonegap: win.cordova || win.phonegap,
    };

    var windows = ua.match(/(Windows Phone);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);


    // Windows
    if (windows) {
      device.os = 'windows';
      device.osVersion = windows[2];
      device.windows = true;
    }
    // Android
    if (android && !windows) {
      device.os = 'android';
      device.osVersion = android[2];
      device.android = true;
      device.androidChrome = ua.toLowerCase().indexOf('chrome') >= 0;
    }
    if (ipad || iphone || ipod) {
      device.os = 'ios';
      device.ios = true;
    }
    // iOS
    if (iphone && !ipod) {
      device.osVersion = iphone[2].replace(/_/g, '.');
      device.iphone = true;
    }
    if (ipad) {
      device.osVersion = ipad[2].replace(/_/g, '.');
      device.ipad = true;
    }
    if (ipod) {
      device.osVersion = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
      device.iphone = true;
    }
    // iOS 8+ changed UA
    if (device.ios && device.osVersion && ua.indexOf('Version/') >= 0) {
      if (device.osVersion.split('.')[0] === '10') {
        device.osVersion = ua.toLowerCase().split('version/')[1].split(' ')[0];
      }
    }

    // Desktop
    device.desktop = !(device.os || device.android || device.webView);

    // Webview
    device.webView = (iphone || ipad || ipod) && ua.match(/.*AppleWebKit(?!.*Safari)/i);

    // Minimal UI
    if (device.os && device.os === 'ios') {
      var osVersionArr = device.osVersion.split('.');
      var metaViewport = doc.querySelector('meta[name="viewport"]');
      device.minimalUi = !device.webView
        && (ipod || iphone)
        && (osVersionArr[0] * 1 === 7 ? osVersionArr[1] * 1 >= 1 : osVersionArr[0] * 1 > 7)
        && metaViewport && metaViewport.getAttribute('content').indexOf('minimal-ui') >= 0;
    }

    // Pixel Ratio
    device.pixelRatio = win.devicePixelRatio || 1;

    // Export object
    return device;
  }());

  function onTouchStart (event) {
    var swiper = this;
    var data = swiper.touchEventsData;
    var params = swiper.params;
    var touches = swiper.touches;
    if (swiper.animating && params.preventInteractionOnTransition) {
      return;
    }
    var e = event;
    if (e.originalEvent) { e = e.originalEvent; }
    data.isTouchEvent = e.type === 'touchstart';
    if (!data.isTouchEvent && 'which' in e && e.which === 3) { return; }
    if (!data.isTouchEvent && 'button' in e && e.button > 0) { return; }
    if (data.isTouched && data.isMoved) { return; }
    if (params.noSwiping && $(e.target).closest(params.noSwipingSelector ? params.noSwipingSelector : ("." + (params.noSwipingClass)))[0]) {
      swiper.allowClick = true;
      return;
    }
    if (params.swipeHandler) {
      if (!$(e).closest(params.swipeHandler)[0]) { return; }
    }

    touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
    touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    var startX = touches.currentX;
    var startY = touches.currentY;

    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app (UIWebView) cannot swipe-to-go-back anymore

    var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
    var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
    if (
      edgeSwipeDetection
      && ((startX <= edgeSwipeThreshold)
      || (startX >= win.screen.width - edgeSwipeThreshold))
    ) {
      return;
    }

    Utils.extend(data, {
      isTouched: true,
      isMoved: false,
      allowTouchCallbacks: true,
      isScrolling: undefined,
      startMoving: undefined,
    });

    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = Utils.now();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) { data.allowThresholdMove = false; }
    if (e.type !== 'touchstart') {
      var preventDefault = true;
      if ($(e.target).is(data.formElements)) { preventDefault = false; }
      if (
        doc.activeElement
        && $(doc.activeElement).is(data.formElements)
        && doc.activeElement !== e.target
      ) {
        doc.activeElement.blur();
      }

      var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
      if (params.touchStartForcePreventDefault || shouldPreventDefault) {
        e.preventDefault();
      }
    }
    swiper.emit('touchStart', e);
  }

  function onTouchMove (event) {
    var swiper = this;
    var data = swiper.touchEventsData;
    var params = swiper.params;
    var touches = swiper.touches;
    var rtl = swiper.rtlTranslate;
    var e = event;
    if (e.originalEvent) { e = e.originalEvent; }
    if (!data.isTouched) {
      if (data.startMoving && data.isScrolling) {
        swiper.emit('touchMoveOpposite', e);
      }
      return;
    }
    if (data.isTouchEvent && e.type === 'mousemove') { return; }
    var pageX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
    var pageY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
    if (e.preventedByNestedSwiper) {
      touches.startX = pageX;
      touches.startY = pageY;
      return;
    }
    if (!swiper.allowTouchMove) {
      // isMoved = true;
      swiper.allowClick = false;
      if (data.isTouched) {
        Utils.extend(touches, {
          startX: pageX,
          startY: pageY,
          currentX: pageX,
          currentY: pageY,
        });
        data.touchStartTime = Utils.now();
      }
      return;
    }
    if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
      if (swiper.isVertical()) {
        // Vertical
        if (
          (pageY < touches.startY && swiper.translate <= swiper.maxTranslate())
          || (pageY > touches.startY && swiper.translate >= swiper.minTranslate())
        ) {
          data.isTouched = false;
          data.isMoved = false;
          return;
        }
      } else if (
        (pageX < touches.startX && swiper.translate <= swiper.maxTranslate())
        || (pageX > touches.startX && swiper.translate >= swiper.minTranslate())
      ) {
        return;
      }
    }
    if (data.isTouchEvent && doc.activeElement) {
      if (e.target === doc.activeElement && $(e.target).is(data.formElements)) {
        data.isMoved = true;
        swiper.allowClick = false;
        return;
      }
    }
    if (data.allowTouchCallbacks) {
      swiper.emit('touchMove', e);
    }
    if (e.targetTouches && e.targetTouches.length > 1) { return; }

    touches.currentX = pageX;
    touches.currentY = pageY;

    var diffX = touches.currentX - touches.startX;
    var diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt((Math.pow( diffX, 2 )) + (Math.pow( diffY, 2 ))) < swiper.params.threshold) { return; }

    if (typeof data.isScrolling === 'undefined') {
      var touchAngle;
      if ((swiper.isHorizontal() && touches.currentY === touches.startY) || (swiper.isVertical() && touches.currentX === touches.startX)) {
        data.isScrolling = false;
      } else {
        // eslint-disable-next-line
        if ((diffX * diffX) + (diffY * diffY) >= 25) {
          touchAngle = (Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180) / Math.PI;
          data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : (90 - touchAngle > params.touchAngle);
        }
      }
    }
    if (data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }
    if (typeof data.startMoving === 'undefined') {
      if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
        data.startMoving = true;
      }
    }
    if (data.isScrolling) {
      data.isTouched = false;
      return;
    }
    if (!data.startMoving) {
      return;
    }
    swiper.allowClick = false;
    e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) {
      e.stopPropagation();
    }

    if (!data.isMoved) {
      if (params.loop) {
        swiper.loopFix();
      }
      data.startTranslate = swiper.getTranslate();
      swiper.setTransition(0);
      if (swiper.animating) {
        swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
      }
      data.allowMomentumBounce = false;
      // Grab Cursor
      if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
        swiper.setGrabCursor(true);
      }
      swiper.emit('sliderFirstMove', e);
    }
    swiper.emit('sliderMove', e);
    data.isMoved = true;

    var diff = swiper.isHorizontal() ? diffX : diffY;
    touches.diff = diff;

    diff *= params.touchRatio;
    if (rtl) { diff = -diff; }

    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    data.currentTranslate = diff + data.startTranslate;

    var disableParentSwiper = true;
    var resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) {
      resistanceRatio = 0;
    }
    if ((diff > 0 && data.currentTranslate > swiper.minTranslate())) {
      disableParentSwiper = false;
      if (params.resistance) { data.currentTranslate = (swiper.minTranslate() - 1) + (Math.pow( (-swiper.minTranslate() + data.startTranslate + diff), resistanceRatio )); }
    } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) { data.currentTranslate = (swiper.maxTranslate() + 1) - (Math.pow( (swiper.maxTranslate() - data.startTranslate - diff), resistanceRatio )); }
    }

    if (disableParentSwiper) {
      e.preventedByNestedSwiper = true;
    }

    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
      data.currentTranslate = data.startTranslate;
    }
    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
      data.currentTranslate = data.startTranslate;
    }


    // Threshold
    if (params.threshold > 0) {
      if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
        if (!data.allowThresholdMove) {
          data.allowThresholdMove = true;
          touches.startX = touches.currentX;
          touches.startY = touches.currentY;
          data.currentTranslate = data.startTranslate;
          touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
          return;
        }
      } else {
        data.currentTranslate = data.startTranslate;
        return;
      }
    }

    if (!params.followFinger) { return; }

    // Update active index in free mode
    if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
    if (params.freeMode) {
      // Velocity
      if (data.velocities.length === 0) {
        data.velocities.push({
          position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
          time: data.touchStartTime,
        });
      }
      data.velocities.push({
        position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
        time: Utils.now(),
      });
    }
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate);
  }

  function onTouchEnd (event) {
    var swiper = this;
    var data = swiper.touchEventsData;

    var params = swiper.params;
    var touches = swiper.touches;
    var rtl = swiper.rtlTranslate;
    var $wrapperEl = swiper.$wrapperEl;
    var slidesGrid = swiper.slidesGrid;
    var snapGrid = swiper.snapGrid;
    var e = event;
    if (e.originalEvent) { e = e.originalEvent; }
    if (data.allowTouchCallbacks) {
      swiper.emit('touchEnd', e);
    }
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
      if (data.isMoved && params.grabCursor) {
        swiper.setGrabCursor(false);
      }
      data.isMoved = false;
      data.startMoving = false;
      return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(false);
    }

    // Time diff
    var touchEndTime = Utils.now();
    var timeDiff = touchEndTime - data.touchStartTime;

    // Tap, doubleTap, Click
    if (swiper.allowClick) {
      swiper.updateClickedSlide(e);
      swiper.emit('tap', e);
      if (timeDiff < 300 && (touchEndTime - data.lastClickTime) > 300) {
        if (data.clickTimeout) { clearTimeout(data.clickTimeout); }
        data.clickTimeout = Utils.nextTick(function () {
          if (!swiper || swiper.destroyed) { return; }
          swiper.emit('click', e);
        }, 300);
      }
      if (timeDiff < 300 && (touchEndTime - data.lastClickTime) < 300) {
        if (data.clickTimeout) { clearTimeout(data.clickTimeout); }
        swiper.emit('doubleTap', e);
      }
    }

    data.lastClickTime = Utils.now();
    Utils.nextTick(function () {
      if (!swiper.destroyed) { swiper.allowClick = true; }
    });

    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
      data.isTouched = false;
      data.isMoved = false;
      data.startMoving = false;
      return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;

    var currentPos;
    if (params.followFinger) {
      currentPos = rtl ? swiper.translate : -swiper.translate;
    } else {
      currentPos = -data.currentTranslate;
    }

    if (params.freeMode) {
      if (currentPos < -swiper.minTranslate()) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }
      if (currentPos > -swiper.maxTranslate()) {
        if (swiper.slides.length < snapGrid.length) {
          swiper.slideTo(snapGrid.length - 1);
        } else {
          swiper.slideTo(swiper.slides.length - 1);
        }
        return;
      }

      if (params.freeModeMomentum) {
        if (data.velocities.length > 1) {
          var lastMoveEvent = data.velocities.pop();
          var velocityEvent = data.velocities.pop();

          var distance = lastMoveEvent.position - velocityEvent.position;
          var time = lastMoveEvent.time - velocityEvent.time;
          swiper.velocity = distance / time;
          swiper.velocity /= 2;
          if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
            swiper.velocity = 0;
          }
          // this implies that the user stopped moving a finger then released.
          // There would be no events with distance zero, so the last event is stale.
          if (time > 150 || (Utils.now() - lastMoveEvent.time) > 300) {
            swiper.velocity = 0;
          }
        } else {
          swiper.velocity = 0;
        }
        swiper.velocity *= params.freeModeMomentumVelocityRatio;

        data.velocities.length = 0;
        var momentumDuration = 1000 * params.freeModeMomentumRatio;
        var momentumDistance = swiper.velocity * momentumDuration;

        var newPosition = swiper.translate + momentumDistance;
        if (rtl) { newPosition = -newPosition; }

        var doBounce = false;
        var afterBouncePosition;
        var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
        var needsLoopFix;
        if (newPosition < swiper.maxTranslate()) {
          if (params.freeModeMomentumBounce) {
            if (newPosition + swiper.maxTranslate() < -bounceAmount) {
              newPosition = swiper.maxTranslate() - bounceAmount;
            }
            afterBouncePosition = swiper.maxTranslate();
            doBounce = true;
            data.allowMomentumBounce = true;
          } else {
            newPosition = swiper.maxTranslate();
          }
          if (params.loop && params.centeredSlides) { needsLoopFix = true; }
        } else if (newPosition > swiper.minTranslate()) {
          if (params.freeModeMomentumBounce) {
            if (newPosition - swiper.minTranslate() > bounceAmount) {
              newPosition = swiper.minTranslate() + bounceAmount;
            }
            afterBouncePosition = swiper.minTranslate();
            doBounce = true;
            data.allowMomentumBounce = true;
          } else {
            newPosition = swiper.minTranslate();
          }
          if (params.loop && params.centeredSlides) { needsLoopFix = true; }
        } else if (params.freeModeSticky) {
          var nextSlide;
          for (var j = 0; j < snapGrid.length; j += 1) {
            if (snapGrid[j] > -newPosition) {
              nextSlide = j;
              break;
            }
          }

          if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
            newPosition = snapGrid[nextSlide];
          } else {
            newPosition = snapGrid[nextSlide - 1];
          }
          newPosition = -newPosition;
        }
        if (needsLoopFix) {
          swiper.once('transitionEnd', function () {
            swiper.loopFix();
          });
        }
        // Fix duration
        if (swiper.velocity !== 0) {
          if (rtl) {
            momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
          } else {
            momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
          }
        } else if (params.freeModeSticky) {
          swiper.slideToClosest();
          return;
        }

        if (params.freeModeMomentumBounce && doBounce) {
          swiper.updateProgress(afterBouncePosition);
          swiper.setTransition(momentumDuration);
          swiper.setTranslate(newPosition);
          swiper.transitionStart(true, swiper.swipeDirection);
          swiper.animating = true;
          $wrapperEl.transitionEnd(function () {
            if (!swiper || swiper.destroyed || !data.allowMomentumBounce) { return; }
            swiper.emit('momentumBounce');

            swiper.setTransition(params.speed);
            swiper.setTranslate(afterBouncePosition);
            $wrapperEl.transitionEnd(function () {
              if (!swiper || swiper.destroyed) { return; }
              swiper.transitionEnd();
            });
          });
        } else if (swiper.velocity) {
          swiper.updateProgress(newPosition);
          swiper.setTransition(momentumDuration);
          swiper.setTranslate(newPosition);
          swiper.transitionStart(true, swiper.swipeDirection);
          if (!swiper.animating) {
            swiper.animating = true;
            $wrapperEl.transitionEnd(function () {
              if (!swiper || swiper.destroyed) { return; }
              swiper.transitionEnd();
            });
          }
        } else {
          swiper.updateProgress(newPosition);
        }

        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      } else if (params.freeModeSticky) {
        swiper.slideToClosest();
        return;
      }

      if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
        swiper.updateProgress();
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
      return;
    }

    // Find current slide
    var stopIndex = 0;
    var groupSize = swiper.slidesSizesGrid[0];
    for (var i = 0; i < slidesGrid.length; i += params.slidesPerGroup) {
      if (typeof slidesGrid[i + params.slidesPerGroup] !== 'undefined') {
        if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + params.slidesPerGroup]) {
          stopIndex = i;
          groupSize = slidesGrid[i + params.slidesPerGroup] - slidesGrid[i];
        }
      } else if (currentPos >= slidesGrid[i]) {
        stopIndex = i;
        groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
      }
    }

    // Find current slide size
    var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;

    if (timeDiff > params.longSwipesMs) {
      // Long touches
      if (!params.longSwipes) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }
      if (swiper.swipeDirection === 'next') {
        if (ratio >= params.longSwipesRatio) { swiper.slideTo(stopIndex + params.slidesPerGroup); }
        else { swiper.slideTo(stopIndex); }
      }
      if (swiper.swipeDirection === 'prev') {
        if (ratio > (1 - params.longSwipesRatio)) { swiper.slideTo(stopIndex + params.slidesPerGroup); }
        else { swiper.slideTo(stopIndex); }
      }
    } else {
      // Short swipes
      if (!params.shortSwipes) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }
      if (swiper.swipeDirection === 'next') {
        swiper.slideTo(stopIndex + params.slidesPerGroup);
      }
      if (swiper.swipeDirection === 'prev') {
        swiper.slideTo(stopIndex);
      }
    }
  }

  function onResize () {
    var swiper = this;

    var params = swiper.params;
    var el = swiper.el;

    if (el && el.offsetWidth === 0) { return; }

    // Breakpoints
    if (params.breakpoints) {
      swiper.setBreakpoint();
    }

    // Save locks
    var allowSlideNext = swiper.allowSlideNext;
    var allowSlidePrev = swiper.allowSlidePrev;
    var snapGrid = swiper.snapGrid;

    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;

    swiper.updateSize();
    swiper.updateSlides();

    if (params.freeMode) {
      var newTranslate = Math.min(Math.max(swiper.translate, swiper.maxTranslate()), swiper.minTranslate());
      swiper.setTranslate(newTranslate);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();

      if (params.autoHeight) {
        swiper.updateAutoHeight();
      }
    } else {
      swiper.updateSlidesClasses();
      if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
        swiper.slideTo(swiper.slides.length - 1, 0, false, true);
      } else {
        swiper.slideTo(swiper.activeIndex, 0, false, true);
      }
    }
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
      swiper.autoplay.run();
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;

    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }
  }

  function onClick (e) {
    var swiper = this;
    if (!swiper.allowClick) {
      if (swiper.params.preventClicks) { e.preventDefault(); }
      if (swiper.params.preventClicksPropagation && swiper.animating) {
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
    }
  }

  function attachEvents() {
    var swiper = this;
    var params = swiper.params;
    var touchEvents = swiper.touchEvents;
    var el = swiper.el;
    var wrapperEl = swiper.wrapperEl;

    {
      swiper.onTouchStart = onTouchStart.bind(swiper);
      swiper.onTouchMove = onTouchMove.bind(swiper);
      swiper.onTouchEnd = onTouchEnd.bind(swiper);
    }

    swiper.onClick = onClick.bind(swiper);

    var target = params.touchEventsTarget === 'container' ? el : wrapperEl;
    var capture = !!params.nested;

    // Touch Events
    {
      if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
        target.addEventListener(touchEvents.start, swiper.onTouchStart, false);
        doc.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
        doc.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
      } else {
        if (Support.touch) {
          var passiveListener = touchEvents.start === 'touchstart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
          target.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
          target.addEventListener(touchEvents.move, swiper.onTouchMove, Support.passiveListener ? { passive: false, capture: capture } : capture);
          target.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
        }
        if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
          target.addEventListener('mousedown', swiper.onTouchStart, false);
          doc.addEventListener('mousemove', swiper.onTouchMove, capture);
          doc.addEventListener('mouseup', swiper.onTouchEnd, false);
        }
      }
      // Prevent Links Clicks
      if (params.preventClicks || params.preventClicksPropagation) {
        target.addEventListener('click', swiper.onClick, true);
      }
    }

    // Resize handler
    swiper.on((Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate'), onResize, true);
  }

  function detachEvents() {
    var swiper = this;

    var params = swiper.params;
    var touchEvents = swiper.touchEvents;
    var el = swiper.el;
    var wrapperEl = swiper.wrapperEl;

    var target = params.touchEventsTarget === 'container' ? el : wrapperEl;
    var capture = !!params.nested;

    // Touch Events
    {
      if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
        target.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
        doc.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
        doc.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
      } else {
        if (Support.touch) {
          var passiveListener = touchEvents.start === 'onTouchStart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
          target.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
          target.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
          target.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
        }
        if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
          target.removeEventListener('mousedown', swiper.onTouchStart, false);
          doc.removeEventListener('mousemove', swiper.onTouchMove, capture);
          doc.removeEventListener('mouseup', swiper.onTouchEnd, false);
        }
      }
      // Prevent Links Clicks
      if (params.preventClicks || params.preventClicksPropagation) {
        target.removeEventListener('click', swiper.onClick, true);
      }
    }

    // Resize handler
    swiper.off((Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate'), onResize);
  }

  var events = {
    attachEvents: attachEvents,
    detachEvents: detachEvents,
  };

  function setBreakpoint () {
    var swiper = this;
    var activeIndex = swiper.activeIndex;
    var initialized = swiper.initialized;
    var loopedSlides = swiper.loopedSlides; if ( loopedSlides === void 0 ) loopedSlides = 0;
    var params = swiper.params;
    var breakpoints = params.breakpoints;
    if (!breakpoints || (breakpoints && Object.keys(breakpoints).length === 0)) { return; }

    // Set breakpoint for window width and update parameters
    var breakpoint = swiper.getBreakpoint(breakpoints);

    if (breakpoint && swiper.currentBreakpoint !== breakpoint) {
      var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
      if (breakpointOnlyParams) {
        ['slidesPerView', 'spaceBetween', 'slidesPerGroup'].forEach(function (param) {
          var paramValue = breakpointOnlyParams[param];
          if (typeof paramValue === 'undefined') { return; }
          if (param === 'slidesPerView' && (paramValue === 'AUTO' || paramValue === 'auto')) {
            breakpointOnlyParams[param] = 'auto';
          } else if (param === 'slidesPerView') {
            breakpointOnlyParams[param] = parseFloat(paramValue);
          } else {
            breakpointOnlyParams[param] = parseInt(paramValue, 10);
          }
        });
      }

      var breakpointParams = breakpointOnlyParams || swiper.originalParams;
      var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
      var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);

      if (directionChanged && initialized) {
        swiper.changeDirection();
      }

      Utils.extend(swiper.params, breakpointParams);

      Utils.extend(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev,
      });

      swiper.currentBreakpoint = breakpoint;

      if (needsReLoop && initialized) {
        swiper.loopDestroy();
        swiper.loopCreate();
        swiper.updateSlides();
        swiper.slideTo((activeIndex - loopedSlides) + swiper.loopedSlides, 0, false);
      }

      swiper.emit('breakpoint', breakpointParams);
    }
  }

  function getBreakpoint (breakpoints) {
    var swiper = this;
    // Get breakpoint for window width
    if (!breakpoints) { return undefined; }
    var breakpoint = false;
    var points = [];
    Object.keys(breakpoints).forEach(function (point) {
      points.push(point);
    });
    points.sort(function (a, b) { return parseInt(a, 10) - parseInt(b, 10); });
    for (var i = 0; i < points.length; i += 1) {
      var point = points[i];
      if (swiper.params.breakpointsInverse) {
        if (point <= win.innerWidth) {
          breakpoint = point;
        }
      } else if (point >= win.innerWidth && !breakpoint) {
        breakpoint = point;
      }
    }
    return breakpoint || 'max';
  }

  var breakpoints = { setBreakpoint: setBreakpoint, getBreakpoint: getBreakpoint };

  function addClasses () {
    var swiper = this;
    var classNames = swiper.classNames;
    var params = swiper.params;
    var rtl = swiper.rtl;
    var $el = swiper.$el;
    var suffixes = [];

    suffixes.push('initialized');
    suffixes.push(params.direction);

    if (params.freeMode) {
      suffixes.push('free-mode');
    }
    if (!Support.flexbox) {
      suffixes.push('no-flexbox');
    }
    if (params.autoHeight) {
      suffixes.push('autoheight');
    }
    if (rtl) {
      suffixes.push('rtl');
    }
    if (params.slidesPerColumn > 1) {
      suffixes.push('multirow');
    }
    if (Device.android) {
      suffixes.push('android');
    }
    if (Device.ios) {
      suffixes.push('ios');
    }
    // WP8 Touch Events Fix
    if ((Browser.isIE || Browser.isEdge) && (Support.pointerEvents || Support.prefixedPointerEvents)) {
      suffixes.push(("wp8-" + (params.direction)));
    }

    suffixes.forEach(function (suffix) {
      classNames.push(params.containerModifierClass + suffix);
    });

    $el.addClass(classNames.join(' '));
  }

  function removeClasses () {
    var swiper = this;
    var $el = swiper.$el;
    var classNames = swiper.classNames;

    $el.removeClass(classNames.join(' '));
  }

  var classes = { addClasses: addClasses, removeClasses: removeClasses };

  function loadImage (imageEl, src, srcset, sizes, checkForComplete, callback) {
    var image;
    function onReady() {
      if (callback) { callback(); }
    }
    if (!imageEl.complete || !checkForComplete) {
      if (src) {
        image = new win.Image();
        image.onload = onReady;
        image.onerror = onReady;
        if (sizes) {
          image.sizes = sizes;
        }
        if (srcset) {
          image.srcset = srcset;
        }
        if (src) {
          image.src = src;
        }
      } else {
        onReady();
      }
    } else {
      // image already loaded...
      onReady();
    }
  }

  function preloadImages () {
    var swiper = this;
    swiper.imagesToLoad = swiper.$el.find('img');
    function onReady() {
      if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) { return; }
      if (swiper.imagesLoaded !== undefined) { swiper.imagesLoaded += 1; }
      if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
        if (swiper.params.updateOnImagesReady) { swiper.update(); }
        swiper.emit('imagesReady');
      }
    }
    for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
      var imageEl = swiper.imagesToLoad[i];
      swiper.loadImage(
        imageEl,
        imageEl.currentSrc || imageEl.getAttribute('src'),
        imageEl.srcset || imageEl.getAttribute('srcset'),
        imageEl.sizes || imageEl.getAttribute('sizes'),
        true,
        onReady
      );
    }
  }

  var images = {
    loadImage: loadImage,
    preloadImages: preloadImages,
  };

  function checkOverflow() {
    var swiper = this;
    var wasLocked = swiper.isLocked;

    swiper.isLocked = swiper.snapGrid.length === 1;
    swiper.allowSlideNext = !swiper.isLocked;
    swiper.allowSlidePrev = !swiper.isLocked;

    // events
    if (wasLocked !== swiper.isLocked) { swiper.emit(swiper.isLocked ? 'lock' : 'unlock'); }

    if (wasLocked && wasLocked !== swiper.isLocked) {
      swiper.isEnd = false;
      swiper.navigation.update();
    }
  }

  var checkOverflow$1 = { checkOverflow: checkOverflow };

  var defaults = {
    init: true,
    direction: 'horizontal',
    touchEventsTarget: 'container',
    initialSlide: 0,
    speed: 300,
    //
    preventInteractionOnTransition: false,

    // To support iOS's swipe-to-go-back gesture (when being used in-app, with UIWebView).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,

    // Free mode
    freeMode: false,
    freeModeMomentum: true,
    freeModeMomentumRatio: 1,
    freeModeMomentumBounce: true,
    freeModeMomentumBounceRatio: 1,
    freeModeMomentumVelocityRatio: 1,
    freeModeSticky: false,
    freeModeMinimumVelocity: 0.02,

    // Autoheight
    autoHeight: false,

    // Set wrapper width
    setWrapperSize: false,

    // Virtual Translate
    virtualTranslate: false,

    // Effects
    effect: 'slide', // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'

    // Breakpoints
    breakpoints: undefined,
    breakpointsInverse: false,

    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerColumn: 1,
    slidesPerColumnFill: 'column',
    slidesPerGroup: 1,
    centeredSlides: false,
    slidesOffsetBefore: 0, // in px
    slidesOffsetAfter: 0, // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,

    // Disable swiper and hide navigation when container not overflow
    watchOverflow: false,

    // Round length
    roundLengths: false,

    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 0,
    touchMoveStopPropagation: true,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,

    // Unique Navigation Elements
    uniqueNavElements: true,

    // Resistance
    resistance: true,
    resistanceRatio: 0.85,

    // Progress
    watchSlidesProgress: false,
    watchSlidesVisibility: false,

    // Cursor
    grabCursor: false,

    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,

    // Images
    preloadImages: true,
    updateOnImagesReady: true,

    // loop
    loop: false,
    loopAdditionalSlides: 0,
    loopedSlides: null,
    loopFillGroupWithBlank: false,

    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null, // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,

    // Passive Listeners
    passiveListeners: true,

    // NS
    containerModifierClass: 'swiper-container-', // NEW
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-invisible-blank',
    slideActiveClass: 'swiper-slide-active',
    slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideDuplicateClass: 'swiper-slide-duplicate',
    slideNextClass: 'swiper-slide-next',
    slideDuplicateNextClass: 'swiper-slide-duplicate-next',
    slidePrevClass: 'swiper-slide-prev',
    slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
    wrapperClass: 'swiper-wrapper',

    // Callbacks
    runCallbacksOnInit: true,
  };

  /* eslint no-param-reassign: "off" */

  var prototypes = {
    update: update,
    translate: translate,
    transition: transition$1,
    slide: slide,
    loop: loop,
    grabCursor: grabCursor,
    manipulation: manipulation,
    events: events,
    breakpoints: breakpoints,
    checkOverflow: checkOverflow$1,
    classes: classes,
    images: images,
  };

  var extendedDefaults = {};

  var Swiper = /*@__PURE__*/(function (SwiperClass) {
    function Swiper() {
      var assign;

      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];
      var el;
      var params;
      if (args.length === 1 && args[0].constructor && args[0].constructor === Object) {
        params = args[0];
      } else {
        (assign = args, el = assign[0], params = assign[1]);
      }
      if (!params) { params = {}; }

      params = Utils.extend({}, params);
      if (el && !params.el) { params.el = el; }

      SwiperClass.call(this, params);

      Object.keys(prototypes).forEach(function (prototypeGroup) {
        Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
          if (!Swiper.prototype[protoMethod]) {
            Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
          }
        });
      });

      // Swiper Instance
      var swiper = this;
      if (typeof swiper.modules === 'undefined') {
        swiper.modules = {};
      }
      Object.keys(swiper.modules).forEach(function (moduleName) {
        var module = swiper.modules[moduleName];
        if (module.params) {
          var moduleParamName = Object.keys(module.params)[0];
          var moduleParams = module.params[moduleParamName];
          if (typeof moduleParams !== 'object' || moduleParams === null) { return; }
          if (!(moduleParamName in params && 'enabled' in moduleParams)) { return; }
          if (params[moduleParamName] === true) {
            params[moduleParamName] = { enabled: true };
          }
          if (
            typeof params[moduleParamName] === 'object'
            && !('enabled' in params[moduleParamName])
          ) {
            params[moduleParamName].enabled = true;
          }
          if (!params[moduleParamName]) { params[moduleParamName] = { enabled: false }; }
        }
      });

      // Extend defaults with modules params
      var swiperParams = Utils.extend({}, defaults);
      swiper.useModulesParams(swiperParams);

      // Extend defaults with passed params
      swiper.params = Utils.extend({}, swiperParams, extendedDefaults, params);
      swiper.originalParams = Utils.extend({}, swiper.params);
      swiper.passedParams = Utils.extend({}, params);

      // Save Dom lib
      swiper.$ = $;

      // Find el
      var $el = $(swiper.params.el);
      el = $el[0];

      if (!el) {
        return undefined;
      }

      if ($el.length > 1) {
        var swipers = [];
        $el.each(function (index, containerEl) {
          var newParams = Utils.extend({}, params, { el: containerEl });
          swipers.push(new Swiper(newParams));
        });
        return swipers;
      }

      el.swiper = swiper;
      $el.data('swiper', swiper);

      // Find Wrapper
      var $wrapperEl = $el.children(("." + (swiper.params.wrapperClass)));

      // Extend Swiper
      Utils.extend(swiper, {
        $el: $el,
        el: el,
        $wrapperEl: $wrapperEl,
        wrapperEl: $wrapperEl[0],

        // Classes
        classNames: [],

        // Slides
        slides: $(),
        slidesGrid: [],
        snapGrid: [],
        slidesSizesGrid: [],

        // isDirection
        isHorizontal: function isHorizontal() {
          return swiper.params.direction === 'horizontal';
        },
        isVertical: function isVertical() {
          return swiper.params.direction === 'vertical';
        },
        // RTL
        rtl: (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
        rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
        wrongRTL: $wrapperEl.css('display') === '-webkit-box',

        // Indexes
        activeIndex: 0,
        realIndex: 0,

        //
        isBeginning: true,
        isEnd: false,

        // Props
        translate: 0,
        previousTranslate: 0,
        progress: 0,
        velocity: 0,
        animating: false,

        // Locks
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev,

        // Touch Events
        touchEvents: (function touchEvents() {
          var touch = ['touchstart', 'touchmove', 'touchend'];
          var desktop = ['mousedown', 'mousemove', 'mouseup'];
          if (Support.pointerEvents) {
            desktop = ['pointerdown', 'pointermove', 'pointerup'];
          } else if (Support.prefixedPointerEvents) {
            desktop = ['MSPointerDown', 'MSPointerMove', 'MSPointerUp'];
          }
          swiper.touchEventsTouch = {
            start: touch[0],
            move: touch[1],
            end: touch[2],
          };
          swiper.touchEventsDesktop = {
            start: desktop[0],
            move: desktop[1],
            end: desktop[2],
          };
          return Support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
        }()),
        touchEventsData: {
          isTouched: undefined,
          isMoved: undefined,
          allowTouchCallbacks: undefined,
          touchStartTime: undefined,
          isScrolling: undefined,
          currentTranslate: undefined,
          startTranslate: undefined,
          allowThresholdMove: undefined,
          // Form elements to match
          formElements: 'input, select, option, textarea, button, video',
          // Last click time
          lastClickTime: Utils.now(),
          clickTimeout: undefined,
          // Velocities
          velocities: [],
          allowMomentumBounce: undefined,
          isTouchEvent: undefined,
          startMoving: undefined,
        },

        // Clicks
        allowClick: true,

        // Touches
        allowTouchMove: swiper.params.allowTouchMove,

        touches: {
          startX: 0,
          startY: 0,
          currentX: 0,
          currentY: 0,
          diff: 0,
        },

        // Images
        imagesToLoad: [],
        imagesLoaded: 0,

      });

      // Install Modules
      swiper.useModules();

      // Init
      if (swiper.params.init) {
        swiper.init();
      }

      // Return app instance
      return swiper;
    }

    if ( SwiperClass ) Swiper.__proto__ = SwiperClass;
    Swiper.prototype = Object.create( SwiperClass && SwiperClass.prototype );
    Swiper.prototype.constructor = Swiper;

    var staticAccessors = { extendedDefaults: { configurable: true },defaults: { configurable: true },Class: { configurable: true },$: { configurable: true } };

    Swiper.prototype.slidesPerViewDynamic = function slidesPerViewDynamic () {
      var swiper = this;
      var params = swiper.params;
      var slides = swiper.slides;
      var slidesGrid = swiper.slidesGrid;
      var swiperSize = swiper.size;
      var activeIndex = swiper.activeIndex;
      var spv = 1;
      if (params.centeredSlides) {
        var slideSize = slides[activeIndex].swiperSlideSize;
        var breakLoop;
        for (var i = activeIndex + 1; i < slides.length; i += 1) {
          if (slides[i] && !breakLoop) {
            slideSize += slides[i].swiperSlideSize;
            spv += 1;
            if (slideSize > swiperSize) { breakLoop = true; }
          }
        }
        for (var i$1 = activeIndex - 1; i$1 >= 0; i$1 -= 1) {
          if (slides[i$1] && !breakLoop) {
            slideSize += slides[i$1].swiperSlideSize;
            spv += 1;
            if (slideSize > swiperSize) { breakLoop = true; }
          }
        }
      } else {
        for (var i$2 = activeIndex + 1; i$2 < slides.length; i$2 += 1) {
          if (slidesGrid[i$2] - slidesGrid[activeIndex] < swiperSize) {
            spv += 1;
          }
        }
      }
      return spv;
    };

    Swiper.prototype.update = function update () {
      var swiper = this;
      if (!swiper || swiper.destroyed) { return; }
      var snapGrid = swiper.snapGrid;
      var params = swiper.params;
      // Breakpoints
      if (params.breakpoints) {
        swiper.setBreakpoint();
      }
      swiper.updateSize();
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();

      function setTranslate() {
        var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
        var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
        swiper.setTranslate(newTranslate);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
      var translated;
      if (swiper.params.freeMode) {
        setTranslate();
        if (swiper.params.autoHeight) {
          swiper.updateAutoHeight();
        }
      } else {
        if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
          translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
        } else {
          translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
        }
        if (!translated) {
          setTranslate();
        }
      }
      if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
        swiper.checkOverflow();
      }
      swiper.emit('update');
    };

    Swiper.prototype.changeDirection = function changeDirection (newDirection, needUpdate) {
      if ( needUpdate === void 0 ) needUpdate = true;

      var swiper = this;
      var currentDirection = swiper.params.direction;
      if (!newDirection) {
        // eslint-disable-next-line
        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
      }
      if ((newDirection === currentDirection) || (newDirection !== 'horizontal' && newDirection !== 'vertical')) {
        return swiper;
      }

      swiper.$el
        .removeClass(("" + (swiper.params.containerModifierClass) + currentDirection + " wp8-" + currentDirection))
        .addClass(("" + (swiper.params.containerModifierClass) + newDirection));

      if ((Browser.isIE || Browser.isEdge) && (Support.pointerEvents || Support.prefixedPointerEvents)) {
        swiper.$el.addClass(((swiper.params.containerModifierClass) + "wp8-" + newDirection));
      }

      swiper.params.direction = newDirection;

      swiper.slides.each(function (slideIndex, slideEl) {
        if (newDirection === 'vertical') {
          slideEl.style.width = '';
        } else {
          slideEl.style.height = '';
        }
      });

      swiper.emit('changeDirection');
      if (needUpdate) { swiper.update(); }

      return swiper;
    };

    Swiper.prototype.init = function init () {
      var swiper = this;
      if (swiper.initialized) { return; }

      swiper.emit('beforeInit');

      // Set breakpoint
      if (swiper.params.breakpoints) {
        swiper.setBreakpoint();
      }

      // Add Classes
      swiper.addClasses();

      // Create loop
      if (swiper.params.loop) {
        swiper.loopCreate();
      }

      // Update size
      swiper.updateSize();

      // Update slides
      swiper.updateSlides();

      if (swiper.params.watchOverflow) {
        swiper.checkOverflow();
      }

      // Set Grab Cursor
      if (swiper.params.grabCursor) {
        swiper.setGrabCursor();
      }

      if (swiper.params.preloadImages) {
        swiper.preloadImages();
      }

      // Slide To Initial Slide
      if (swiper.params.loop) {
        swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit);
      } else {
        swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit);
      }

      // Attach events
      swiper.attachEvents();

      // Init Flag
      swiper.initialized = true;

      // Emit
      swiper.emit('init');
    };

    Swiper.prototype.destroy = function destroy (deleteInstance, cleanStyles) {
      if ( deleteInstance === void 0 ) deleteInstance = true;
      if ( cleanStyles === void 0 ) cleanStyles = true;

      var swiper = this;
      var params = swiper.params;
      var $el = swiper.$el;
      var $wrapperEl = swiper.$wrapperEl;
      var slides = swiper.slides;

      if (typeof swiper.params === 'undefined' || swiper.destroyed) {
        return null;
      }

      swiper.emit('beforeDestroy');

      // Init Flag
      swiper.initialized = false;

      // Detach events
      swiper.detachEvents();

      // Destroy loop
      if (params.loop) {
        swiper.loopDestroy();
      }

      // Cleanup styles
      if (cleanStyles) {
        swiper.removeClasses();
        $el.removeAttr('style');
        $wrapperEl.removeAttr('style');
        if (slides && slides.length) {
          slides
            .removeClass([
              params.slideVisibleClass,
              params.slideActiveClass,
              params.slideNextClass,
              params.slidePrevClass ].join(' '))
            .removeAttr('style')
            .removeAttr('data-swiper-slide-index')
            .removeAttr('data-swiper-column')
            .removeAttr('data-swiper-row');
        }
      }

      swiper.emit('destroy');

      // Detach emitter events
      Object.keys(swiper.eventsListeners).forEach(function (eventName) {
        swiper.off(eventName);
      });

      if (deleteInstance !== false) {
        swiper.$el[0].swiper = null;
        swiper.$el.data('swiper', null);
        Utils.deleteProps(swiper);
      }
      swiper.destroyed = true;

      return null;
    };

    Swiper.extendDefaults = function extendDefaults (newDefaults) {
      Utils.extend(extendedDefaults, newDefaults);
    };

    staticAccessors.extendedDefaults.get = function () {
      return extendedDefaults;
    };

    staticAccessors.defaults.get = function () {
      return defaults;
    };

    staticAccessors.Class.get = function () {
      return SwiperClass;
    };

    staticAccessors.$.get = function () {
      return $;
    };

    Object.defineProperties( Swiper, staticAccessors );

    return Swiper;
  }(SwiperClass));

  var Device$1 = {
    name: 'device',
    proto: {
      device: Device,
    },
    static: {
      device: Device,
    },
  };

  var Support$1 = {
    name: 'support',
    proto: {
      support: Support,
    },
    static: {
      support: Support,
    },
  };

  var Browser$1 = {
    name: 'browser',
    proto: {
      browser: Browser,
    },
    static: {
      browser: Browser,
    },
  };

  var Resize = {
    name: 'resize',
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        resize: {
          resizeHandler: function resizeHandler() {
            if (!swiper || swiper.destroyed || !swiper.initialized) { return; }
            swiper.emit('beforeResize');
            swiper.emit('resize');
          },
          orientationChangeHandler: function orientationChangeHandler() {
            if (!swiper || swiper.destroyed || !swiper.initialized) { return; }
            swiper.emit('orientationchange');
          },
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        // Emit resize
        win.addEventListener('resize', swiper.resize.resizeHandler);

        // Emit orientationchange
        win.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
      },
      destroy: function destroy() {
        var swiper = this;
        win.removeEventListener('resize', swiper.resize.resizeHandler);
        win.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
      },
    },
  };

  var Observer = {
    func: win.MutationObserver || win.WebkitMutationObserver,
    attach: function attach(target, options) {
      if ( options === void 0 ) options = {};

      var swiper = this;

      var ObserverFunc = Observer.func;
      var observer = new ObserverFunc(function (mutations) {
        // The observerUpdate event should only be triggered
        // once despite the number of mutations.  Additional
        // triggers are redundant and are very costly
        if (mutations.length === 1) {
          swiper.emit('observerUpdate', mutations[0]);
          return;
        }
        var observerUpdate = function observerUpdate() {
          swiper.emit('observerUpdate', mutations[0]);
        };

        if (win.requestAnimationFrame) {
          win.requestAnimationFrame(observerUpdate);
        } else {
          win.setTimeout(observerUpdate, 0);
        }
      });

      observer.observe(target, {
        attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
        childList: typeof options.childList === 'undefined' ? true : options.childList,
        characterData: typeof options.characterData === 'undefined' ? true : options.characterData,
      });

      swiper.observer.observers.push(observer);
    },
    init: function init() {
      var swiper = this;
      if (!Support.observer || !swiper.params.observer) { return; }
      if (swiper.params.observeParents) {
        var containerParents = swiper.$el.parents();
        for (var i = 0; i < containerParents.length; i += 1) {
          swiper.observer.attach(containerParents[i]);
        }
      }
      // Observe container
      swiper.observer.attach(swiper.$el[0], { childList: swiper.params.observeSlideChildren });

      // Observe wrapper
      swiper.observer.attach(swiper.$wrapperEl[0], { attributes: false });
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.observer.observers.forEach(function (observer) {
        observer.disconnect();
      });
      swiper.observer.observers = [];
    },
  };

  var Observer$1 = {
    name: 'observer',
    params: {
      observer: false,
      observeParents: false,
      observeSlideChildren: false,
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        observer: {
          init: Observer.init.bind(swiper),
          attach: Observer.attach.bind(swiper),
          destroy: Observer.destroy.bind(swiper),
          observers: [],
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        swiper.observer.init();
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.observer.destroy();
      },
    },
  };

  var Virtual = {
    update: function update(force) {
      var swiper = this;
      var ref = swiper.params;
      var slidesPerView = ref.slidesPerView;
      var slidesPerGroup = ref.slidesPerGroup;
      var centeredSlides = ref.centeredSlides;
      var ref$1 = swiper.params.virtual;
      var addSlidesBefore = ref$1.addSlidesBefore;
      var addSlidesAfter = ref$1.addSlidesAfter;
      var ref$2 = swiper.virtual;
      var previousFrom = ref$2.from;
      var previousTo = ref$2.to;
      var slides = ref$2.slides;
      var previousSlidesGrid = ref$2.slidesGrid;
      var renderSlide = ref$2.renderSlide;
      var previousOffset = ref$2.offset;
      swiper.updateActiveIndex();
      var activeIndex = swiper.activeIndex || 0;

      var offsetProp;
      if (swiper.rtlTranslate) { offsetProp = 'right'; }
      else { offsetProp = swiper.isHorizontal() ? 'left' : 'top'; }

      var slidesAfter;
      var slidesBefore;
      if (centeredSlides) {
        slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
      } else {
        slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesBefore;
        slidesBefore = slidesPerGroup + addSlidesAfter;
      }
      var from = Math.max((activeIndex || 0) - slidesBefore, 0);
      var to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
      var offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);

      Utils.extend(swiper.virtual, {
        from: from,
        to: to,
        offset: offset,
        slidesGrid: swiper.slidesGrid,
      });

      function onRendered() {
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        if (swiper.lazy && swiper.params.lazy.enabled) {
          swiper.lazy.load();
        }
      }

      if (previousFrom === from && previousTo === to && !force) {
        if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
          swiper.slides.css(offsetProp, (offset + "px"));
        }
        swiper.updateProgress();
        return;
      }
      if (swiper.params.virtual.renderExternal) {
        swiper.params.virtual.renderExternal.call(swiper, {
          offset: offset,
          from: from,
          to: to,
          slides: (function getSlides() {
            var slidesToRender = [];
            for (var i = from; i <= to; i += 1) {
              slidesToRender.push(slides[i]);
            }
            return slidesToRender;
          }()),
        });
        onRendered();
        return;
      }
      var prependIndexes = [];
      var appendIndexes = [];
      if (force) {
        swiper.$wrapperEl.find(("." + (swiper.params.slideClass))).remove();
      } else {
        for (var i = previousFrom; i <= previousTo; i += 1) {
          if (i < from || i > to) {
            swiper.$wrapperEl.find(("." + (swiper.params.slideClass) + "[data-swiper-slide-index=\"" + i + "\"]")).remove();
          }
        }
      }
      for (var i$1 = 0; i$1 < slides.length; i$1 += 1) {
        if (i$1 >= from && i$1 <= to) {
          if (typeof previousTo === 'undefined' || force) {
            appendIndexes.push(i$1);
          } else {
            if (i$1 > previousTo) { appendIndexes.push(i$1); }
            if (i$1 < previousFrom) { prependIndexes.push(i$1); }
          }
        }
      }
      appendIndexes.forEach(function (index) {
        swiper.$wrapperEl.append(renderSlide(slides[index], index));
      });
      prependIndexes.sort(function (a, b) { return b - a; }).forEach(function (index) {
        swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
      });
      swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, (offset + "px"));
      onRendered();
    },
    renderSlide: function renderSlide(slide, index) {
      var swiper = this;
      var params = swiper.params.virtual;
      if (params.cache && swiper.virtual.cache[index]) {
        return swiper.virtual.cache[index];
      }
      var $slideEl = params.renderSlide
        ? $(params.renderSlide.call(swiper, slide, index))
        : $(("<div class=\"" + (swiper.params.slideClass) + "\" data-swiper-slide-index=\"" + index + "\">" + slide + "</div>"));
      if (!$slideEl.attr('data-swiper-slide-index')) { $slideEl.attr('data-swiper-slide-index', index); }
      if (params.cache) { swiper.virtual.cache[index] = $slideEl; }
      return $slideEl;
    },
    appendSlide: function appendSlide(slides) {
      var swiper = this;
      if (typeof slides === 'object' && 'length' in slides) {
        for (var i = 0; i < slides.length; i += 1) {
          if (slides[i]) { swiper.virtual.slides.push(slides[i]); }
        }
      } else {
        swiper.virtual.slides.push(slides);
      }
      swiper.virtual.update(true);
    },
    prependSlide: function prependSlide(slides) {
      var swiper = this;
      var activeIndex = swiper.activeIndex;
      var newActiveIndex = activeIndex + 1;
      var numberOfNewSlides = 1;

      if (Array.isArray(slides)) {
        for (var i = 0; i < slides.length; i += 1) {
          if (slides[i]) { swiper.virtual.slides.unshift(slides[i]); }
        }
        newActiveIndex = activeIndex + slides.length;
        numberOfNewSlides = slides.length;
      } else {
        swiper.virtual.slides.unshift(slides);
      }
      if (swiper.params.virtual.cache) {
        var cache = swiper.virtual.cache;
        var newCache = {};
        Object.keys(cache).forEach(function (cachedIndex) {
          newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cache[cachedIndex];
        });
        swiper.virtual.cache = newCache;
      }
      swiper.virtual.update(true);
      swiper.slideTo(newActiveIndex, 0);
    },
    removeSlide: function removeSlide(slidesIndexes) {
      var swiper = this;
      if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) { return; }
      var activeIndex = swiper.activeIndex;
      if (Array.isArray(slidesIndexes)) {
        for (var i = slidesIndexes.length - 1; i >= 0; i -= 1) {
          swiper.virtual.slides.splice(slidesIndexes[i], 1);
          if (swiper.params.virtual.cache) {
            delete swiper.virtual.cache[slidesIndexes[i]];
          }
          if (slidesIndexes[i] < activeIndex) { activeIndex -= 1; }
          activeIndex = Math.max(activeIndex, 0);
        }
      } else {
        swiper.virtual.slides.splice(slidesIndexes, 1);
        if (swiper.params.virtual.cache) {
          delete swiper.virtual.cache[slidesIndexes];
        }
        if (slidesIndexes < activeIndex) { activeIndex -= 1; }
        activeIndex = Math.max(activeIndex, 0);
      }
      swiper.virtual.update(true);
      swiper.slideTo(activeIndex, 0);
    },
    removeAllSlides: function removeAllSlides() {
      var swiper = this;
      swiper.virtual.slides = [];
      if (swiper.params.virtual.cache) {
        swiper.virtual.cache = {};
      }
      swiper.virtual.update(true);
      swiper.slideTo(0, 0);
    },
  };

  var Virtual$1 = {
    name: 'virtual',
    params: {
      virtual: {
        enabled: false,
        slides: [],
        cache: true,
        renderSlide: null,
        renderExternal: null,
        addSlidesBefore: 0,
        addSlidesAfter: 0,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        virtual: {
          update: Virtual.update.bind(swiper),
          appendSlide: Virtual.appendSlide.bind(swiper),
          prependSlide: Virtual.prependSlide.bind(swiper),
          removeSlide: Virtual.removeSlide.bind(swiper),
          removeAllSlides: Virtual.removeAllSlides.bind(swiper),
          renderSlide: Virtual.renderSlide.bind(swiper),
          slides: swiper.params.virtual.slides,
          cache: {},
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (!swiper.params.virtual.enabled) { return; }
        swiper.classNames.push(((swiper.params.containerModifierClass) + "virtual"));
        var overwriteParams = {
          watchSlidesProgress: true,
        };
        Utils.extend(swiper.params, overwriteParams);
        Utils.extend(swiper.originalParams, overwriteParams);

        if (!swiper.params.initialSlide) {
          swiper.virtual.update();
        }
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (!swiper.params.virtual.enabled) { return; }
        swiper.virtual.update();
      },
    },
  };

  var Keyboard = {
    handle: function handle(event) {
      var swiper = this;
      var rtl = swiper.rtlTranslate;
      var e = event;
      if (e.originalEvent) { e = e.originalEvent; } // jquery fix
      var kc = e.keyCode || e.charCode;
      // Directions locks
      if (!swiper.allowSlideNext && ((swiper.isHorizontal() && kc === 39) || (swiper.isVertical() && kc === 40) || kc === 34)) {
        return false;
      }
      if (!swiper.allowSlidePrev && ((swiper.isHorizontal() && kc === 37) || (swiper.isVertical() && kc === 38) || kc === 33)) {
        return false;
      }
      if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
        return undefined;
      }
      if (doc.activeElement && doc.activeElement.nodeName && (doc.activeElement.nodeName.toLowerCase() === 'input' || doc.activeElement.nodeName.toLowerCase() === 'textarea')) {
        return undefined;
      }
      if (swiper.params.keyboard.onlyInViewport && (kc === 33 || kc === 34 || kc === 37 || kc === 39 || kc === 38 || kc === 40)) {
        var inView = false;
        // Check that swiper should be inside of visible area of window
        if (swiper.$el.parents(("." + (swiper.params.slideClass))).length > 0 && swiper.$el.parents(("." + (swiper.params.slideActiveClass))).length === 0) {
          return undefined;
        }
        var windowWidth = win.innerWidth;
        var windowHeight = win.innerHeight;
        var swiperOffset = swiper.$el.offset();
        if (rtl) { swiperOffset.left -= swiper.$el[0].scrollLeft; }
        var swiperCoord = [
          [swiperOffset.left, swiperOffset.top],
          [swiperOffset.left + swiper.width, swiperOffset.top],
          [swiperOffset.left, swiperOffset.top + swiper.height],
          [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height] ];
        for (var i = 0; i < swiperCoord.length; i += 1) {
          var point = swiperCoord[i];
          if (
            point[0] >= 0 && point[0] <= windowWidth
            && point[1] >= 0 && point[1] <= windowHeight
          ) {
            inView = true;
          }
        }
        if (!inView) { return undefined; }
      }
      if (swiper.isHorizontal()) {
        if (kc === 33 || kc === 34 || kc === 37 || kc === 39) {
          if (e.preventDefault) { e.preventDefault(); }
          else { e.returnValue = false; }
        }
        if (((kc === 34 || kc === 39) && !rtl) || ((kc === 33 || kc === 37) && rtl)) { swiper.slideNext(); }
        if (((kc === 33 || kc === 37) && !rtl) || ((kc === 34 || kc === 39) && rtl)) { swiper.slidePrev(); }
      } else {
        if (kc === 33 || kc === 34 || kc === 38 || kc === 40) {
          if (e.preventDefault) { e.preventDefault(); }
          else { e.returnValue = false; }
        }
        if (kc === 34 || kc === 40) { swiper.slideNext(); }
        if (kc === 33 || kc === 38) { swiper.slidePrev(); }
      }
      swiper.emit('keyPress', kc);
      return undefined;
    },
    enable: function enable() {
      var swiper = this;
      if (swiper.keyboard.enabled) { return; }
      $(doc).on('keydown', swiper.keyboard.handle);
      swiper.keyboard.enabled = true;
    },
    disable: function disable() {
      var swiper = this;
      if (!swiper.keyboard.enabled) { return; }
      $(doc).off('keydown', swiper.keyboard.handle);
      swiper.keyboard.enabled = false;
    },
  };

  var Keyboard$1 = {
    name: 'keyboard',
    params: {
      keyboard: {
        enabled: false,
        onlyInViewport: true,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        keyboard: {
          enabled: false,
          enable: Keyboard.enable.bind(swiper),
          disable: Keyboard.disable.bind(swiper),
          handle: Keyboard.handle.bind(swiper),
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.keyboard.enabled) {
          swiper.keyboard.enable();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.keyboard.enabled) {
          swiper.keyboard.disable();
        }
      },
    },
  };

  function isEventSupported() {
    var eventName = 'onwheel';
    var isSupported = eventName in doc;

    if (!isSupported) {
      var element = doc.createElement('div');
      element.setAttribute(eventName, 'return;');
      isSupported = typeof element[eventName] === 'function';
    }

    if (!isSupported
      && doc.implementation
      && doc.implementation.hasFeature
      // always returns true in newer browsers as per the standard.
      // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
      && doc.implementation.hasFeature('', '') !== true
    ) {
      // This is the only way to test support for the `wheel` event in IE9+.
      isSupported = doc.implementation.hasFeature('Events.wheel', '3.0');
    }

    return isSupported;
  }
  var Mousewheel = {
    lastScrollTime: Utils.now(),
    event: (function getEvent() {
      if (win.navigator.userAgent.indexOf('firefox') > -1) { return 'DOMMouseScroll'; }
      return isEventSupported() ? 'wheel' : 'mousewheel';
    }()),
    normalize: function normalize(e) {
      // Reasonable defaults
      var PIXEL_STEP = 10;
      var LINE_HEIGHT = 40;
      var PAGE_HEIGHT = 800;

      var sX = 0;
      var sY = 0; // spinX, spinY
      var pX = 0;
      var pY = 0; // pixelX, pixelY

      // Legacy
      if ('detail' in e) {
        sY = e.detail;
      }
      if ('wheelDelta' in e) {
        sY = -e.wheelDelta / 120;
      }
      if ('wheelDeltaY' in e) {
        sY = -e.wheelDeltaY / 120;
      }
      if ('wheelDeltaX' in e) {
        sX = -e.wheelDeltaX / 120;
      }

      // side scrolling on FF with DOMMouseScroll
      if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
        sX = sY;
        sY = 0;
      }

      pX = sX * PIXEL_STEP;
      pY = sY * PIXEL_STEP;

      if ('deltaY' in e) {
        pY = e.deltaY;
      }
      if ('deltaX' in e) {
        pX = e.deltaX;
      }

      if ((pX || pY) && e.deltaMode) {
        if (e.deltaMode === 1) { // delta in LINE units
          pX *= LINE_HEIGHT;
          pY *= LINE_HEIGHT;
        } else { // delta in PAGE units
          pX *= PAGE_HEIGHT;
          pY *= PAGE_HEIGHT;
        }
      }

      // Fall-back if spin cannot be determined
      if (pX && !sX) {
        sX = (pX < 1) ? -1 : 1;
      }
      if (pY && !sY) {
        sY = (pY < 1) ? -1 : 1;
      }

      return {
        spinX: sX,
        spinY: sY,
        pixelX: pX,
        pixelY: pY,
      };
    },
    handleMouseEnter: function handleMouseEnter() {
      var swiper = this;
      swiper.mouseEntered = true;
    },
    handleMouseLeave: function handleMouseLeave() {
      var swiper = this;
      swiper.mouseEntered = false;
    },
    handle: function handle(event) {
      var e = event;
      var swiper = this;
      var params = swiper.params.mousewheel;

      if (!swiper.mouseEntered && !params.releaseOnEdges) { return true; }

      if (e.originalEvent) { e = e.originalEvent; } // jquery fix
      var delta = 0;
      var rtlFactor = swiper.rtlTranslate ? -1 : 1;

      var data = Mousewheel.normalize(e);

      if (params.forceToAxis) {
        if (swiper.isHorizontal()) {
          if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) { delta = data.pixelX * rtlFactor; }
          else { return true; }
        } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) { delta = data.pixelY; }
        else { return true; }
      } else {
        delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
      }

      if (delta === 0) { return true; }

      if (params.invert) { delta = -delta; }

      if (!swiper.params.freeMode) {
        if (Utils.now() - swiper.mousewheel.lastScrollTime > 60) {
          if (delta < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
              swiper.slideNext();
              swiper.emit('scroll', e);
            } else if (params.releaseOnEdges) { return true; }
          } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            swiper.emit('scroll', e);
          } else if (params.releaseOnEdges) { return true; }
        }
        swiper.mousewheel.lastScrollTime = (new win.Date()).getTime();
      } else {
        // Freemode or scrollContainer:
        if (swiper.params.loop) {
          swiper.loopFix();
        }
        var position = swiper.getTranslate() + (delta * params.sensitivity);
        var wasBeginning = swiper.isBeginning;
        var wasEnd = swiper.isEnd;

        if (position >= swiper.minTranslate()) { position = swiper.minTranslate(); }
        if (position <= swiper.maxTranslate()) { position = swiper.maxTranslate(); }

        swiper.setTransition(0);
        swiper.setTranslate(position);
        swiper.updateProgress();
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();

        if ((!wasBeginning && swiper.isBeginning) || (!wasEnd && swiper.isEnd)) {
          swiper.updateSlidesClasses();
        }

        if (swiper.params.freeModeSticky) {
          clearTimeout(swiper.mousewheel.timeout);
          swiper.mousewheel.timeout = Utils.nextTick(function () {
            swiper.slideToClosest();
          }, 300);
        }
        // Emit event
        swiper.emit('scroll', e);

        // Stop autoplay
        if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) { swiper.autoplay.stop(); }
        // Return page scroll on edge positions
        if (position === swiper.minTranslate() || position === swiper.maxTranslate()) { return true; }
      }

      if (e.preventDefault) { e.preventDefault(); }
      else { e.returnValue = false; }
      return false;
    },
    enable: function enable() {
      var swiper = this;
      if (!Mousewheel.event) { return false; }
      if (swiper.mousewheel.enabled) { return false; }
      var target = swiper.$el;
      if (swiper.params.mousewheel.eventsTarged !== 'container') {
        target = $(swiper.params.mousewheel.eventsTarged);
      }
      target.on('mouseenter', swiper.mousewheel.handleMouseEnter);
      target.on('mouseleave', swiper.mousewheel.handleMouseLeave);
      target.on(Mousewheel.event, swiper.mousewheel.handle);
      swiper.mousewheel.enabled = true;
      return true;
    },
    disable: function disable() {
      var swiper = this;
      if (!Mousewheel.event) { return false; }
      if (!swiper.mousewheel.enabled) { return false; }
      var target = swiper.$el;
      if (swiper.params.mousewheel.eventsTarged !== 'container') {
        target = $(swiper.params.mousewheel.eventsTarged);
      }
      target.off(Mousewheel.event, swiper.mousewheel.handle);
      swiper.mousewheel.enabled = false;
      return true;
    },
  };

  var Mousewheel$1 = {
    name: 'mousewheel',
    params: {
      mousewheel: {
        enabled: false,
        releaseOnEdges: false,
        invert: false,
        forceToAxis: false,
        sensitivity: 1,
        eventsTarged: 'container',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        mousewheel: {
          enabled: false,
          enable: Mousewheel.enable.bind(swiper),
          disable: Mousewheel.disable.bind(swiper),
          handle: Mousewheel.handle.bind(swiper),
          handleMouseEnter: Mousewheel.handleMouseEnter.bind(swiper),
          handleMouseLeave: Mousewheel.handleMouseLeave.bind(swiper),
          lastScrollTime: Utils.now(),
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.mousewheel.enabled) { swiper.mousewheel.enable(); }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.mousewheel.enabled) { swiper.mousewheel.disable(); }
      },
    },
  };

  var Navigation = {
    update: function update() {
      // Update Navigation Buttons
      var swiper = this;
      var params = swiper.params.navigation;

      if (swiper.params.loop) { return; }
      var ref = swiper.navigation;
      var $nextEl = ref.$nextEl;
      var $prevEl = ref.$prevEl;

      if ($prevEl && $prevEl.length > 0) {
        if (swiper.isBeginning) {
          $prevEl.addClass(params.disabledClass);
        } else {
          $prevEl.removeClass(params.disabledClass);
        }
        $prevEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
      if ($nextEl && $nextEl.length > 0) {
        if (swiper.isEnd) {
          $nextEl.addClass(params.disabledClass);
        } else {
          $nextEl.removeClass(params.disabledClass);
        }
        $nextEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
    },
    onPrevClick: function onPrevClick(e) {
      var swiper = this;
      e.preventDefault();
      if (swiper.isBeginning && !swiper.params.loop) { return; }
      swiper.slidePrev();
    },
    onNextClick: function onNextClick(e) {
      var swiper = this;
      e.preventDefault();
      if (swiper.isEnd && !swiper.params.loop) { return; }
      swiper.slideNext();
    },
    init: function init() {
      var swiper = this;
      var params = swiper.params.navigation;
      if (!(params.nextEl || params.prevEl)) { return; }

      var $nextEl;
      var $prevEl;
      if (params.nextEl) {
        $nextEl = $(params.nextEl);
        if (
          swiper.params.uniqueNavElements
          && typeof params.nextEl === 'string'
          && $nextEl.length > 1
          && swiper.$el.find(params.nextEl).length === 1
        ) {
          $nextEl = swiper.$el.find(params.nextEl);
        }
      }
      if (params.prevEl) {
        $prevEl = $(params.prevEl);
        if (
          swiper.params.uniqueNavElements
          && typeof params.prevEl === 'string'
          && $prevEl.length > 1
          && swiper.$el.find(params.prevEl).length === 1
        ) {
          $prevEl = swiper.$el.find(params.prevEl);
        }
      }

      if ($nextEl && $nextEl.length > 0) {
        $nextEl.on('click', swiper.navigation.onNextClick);
      }
      if ($prevEl && $prevEl.length > 0) {
        $prevEl.on('click', swiper.navigation.onPrevClick);
      }

      Utils.extend(swiper.navigation, {
        $nextEl: $nextEl,
        nextEl: $nextEl && $nextEl[0],
        $prevEl: $prevEl,
        prevEl: $prevEl && $prevEl[0],
      });
    },
    destroy: function destroy() {
      var swiper = this;
      var ref = swiper.navigation;
      var $nextEl = ref.$nextEl;
      var $prevEl = ref.$prevEl;
      if ($nextEl && $nextEl.length) {
        $nextEl.off('click', swiper.navigation.onNextClick);
        $nextEl.removeClass(swiper.params.navigation.disabledClass);
      }
      if ($prevEl && $prevEl.length) {
        $prevEl.off('click', swiper.navigation.onPrevClick);
        $prevEl.removeClass(swiper.params.navigation.disabledClass);
      }
    },
  };

  var Navigation$1 = {
    name: 'navigation',
    params: {
      navigation: {
        nextEl: null,
        prevEl: null,

        hideOnClick: false,
        disabledClass: 'swiper-button-disabled',
        hiddenClass: 'swiper-button-hidden',
        lockClass: 'swiper-button-lock',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        navigation: {
          init: Navigation.init.bind(swiper),
          update: Navigation.update.bind(swiper),
          destroy: Navigation.destroy.bind(swiper),
          onNextClick: Navigation.onNextClick.bind(swiper),
          onPrevClick: Navigation.onPrevClick.bind(swiper),
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        swiper.navigation.init();
        swiper.navigation.update();
      },
      toEdge: function toEdge() {
        var swiper = this;
        swiper.navigation.update();
      },
      fromEdge: function fromEdge() {
        var swiper = this;
        swiper.navigation.update();
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.navigation.destroy();
      },
      click: function click(e) {
        var swiper = this;
        var ref = swiper.navigation;
        var $nextEl = ref.$nextEl;
        var $prevEl = ref.$prevEl;
        if (
          swiper.params.navigation.hideOnClick
          && !$(e.target).is($prevEl)
          && !$(e.target).is($nextEl)
        ) {
          var isHidden;
          if ($nextEl) {
            isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
          } else if ($prevEl) {
            isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
          }
          if (isHidden === true) {
            swiper.emit('navigationShow', swiper);
          } else {
            swiper.emit('navigationHide', swiper);
          }
          if ($nextEl) {
            $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
          }
          if ($prevEl) {
            $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
          }
        }
      },
    },
  };

  var Pagination = {
    update: function update() {
      // Render || Update Pagination bullets/items
      var swiper = this;
      var rtl = swiper.rtl;
      var params = swiper.params.pagination;
      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
      var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
      var $el = swiper.pagination.$el;
      // Current/Total
      var current;
      var total = swiper.params.loop ? Math.ceil((slidesLength - (swiper.loopedSlides * 2)) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
      if (swiper.params.loop) {
        current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
        if (current > slidesLength - 1 - (swiper.loopedSlides * 2)) {
          current -= (slidesLength - (swiper.loopedSlides * 2));
        }
        if (current > total - 1) { current -= total; }
        if (current < 0 && swiper.params.paginationType !== 'bullets') { current = total + current; }
      } else if (typeof swiper.snapIndex !== 'undefined') {
        current = swiper.snapIndex;
      } else {
        current = swiper.activeIndex || 0;
      }
      // Types
      if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
        var bullets = swiper.pagination.bullets;
        var firstIndex;
        var lastIndex;
        var midIndex;
        if (params.dynamicBullets) {
          swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
          $el.css(swiper.isHorizontal() ? 'width' : 'height', ((swiper.pagination.bulletSize * (params.dynamicMainBullets + 4)) + "px"));
          if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
            swiper.pagination.dynamicBulletIndex += (current - swiper.previousIndex);
            if (swiper.pagination.dynamicBulletIndex > (params.dynamicMainBullets - 1)) {
              swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
            } else if (swiper.pagination.dynamicBulletIndex < 0) {
              swiper.pagination.dynamicBulletIndex = 0;
            }
          }
          firstIndex = current - swiper.pagination.dynamicBulletIndex;
          lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
          midIndex = (lastIndex + firstIndex) / 2;
        }
        bullets.removeClass(((params.bulletActiveClass) + " " + (params.bulletActiveClass) + "-next " + (params.bulletActiveClass) + "-next-next " + (params.bulletActiveClass) + "-prev " + (params.bulletActiveClass) + "-prev-prev " + (params.bulletActiveClass) + "-main"));
        if ($el.length > 1) {
          bullets.each(function (index, bullet) {
            var $bullet = $(bullet);
            var bulletIndex = $bullet.index();
            if (bulletIndex === current) {
              $bullet.addClass(params.bulletActiveClass);
            }
            if (params.dynamicBullets) {
              if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
                $bullet.addClass(((params.bulletActiveClass) + "-main"));
              }
              if (bulletIndex === firstIndex) {
                $bullet
                  .prev()
                  .addClass(((params.bulletActiveClass) + "-prev"))
                  .prev()
                  .addClass(((params.bulletActiveClass) + "-prev-prev"));
              }
              if (bulletIndex === lastIndex) {
                $bullet
                  .next()
                  .addClass(((params.bulletActiveClass) + "-next"))
                  .next()
                  .addClass(((params.bulletActiveClass) + "-next-next"));
              }
            }
          });
        } else {
          var $bullet = bullets.eq(current);
          $bullet.addClass(params.bulletActiveClass);
          if (params.dynamicBullets) {
            var $firstDisplayedBullet = bullets.eq(firstIndex);
            var $lastDisplayedBullet = bullets.eq(lastIndex);
            for (var i = firstIndex; i <= lastIndex; i += 1) {
              bullets.eq(i).addClass(((params.bulletActiveClass) + "-main"));
            }
            $firstDisplayedBullet
              .prev()
              .addClass(((params.bulletActiveClass) + "-prev"))
              .prev()
              .addClass(((params.bulletActiveClass) + "-prev-prev"));
            $lastDisplayedBullet
              .next()
              .addClass(((params.bulletActiveClass) + "-next"))
              .next()
              .addClass(((params.bulletActiveClass) + "-next-next"));
          }
        }
        if (params.dynamicBullets) {
          var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
          var bulletsOffset = (((swiper.pagination.bulletSize * dynamicBulletsLength) - (swiper.pagination.bulletSize)) / 2) - (midIndex * swiper.pagination.bulletSize);
          var offsetProp = rtl ? 'right' : 'left';
          bullets.css(swiper.isHorizontal() ? offsetProp : 'top', (bulletsOffset + "px"));
        }
      }
      if (params.type === 'fraction') {
        $el.find(("." + (params.currentClass))).text(params.formatFractionCurrent(current + 1));
        $el.find(("." + (params.totalClass))).text(params.formatFractionTotal(total));
      }
      if (params.type === 'progressbar') {
        var progressbarDirection;
        if (params.progressbarOpposite) {
          progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
        } else {
          progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
        }
        var scale = (current + 1) / total;
        var scaleX = 1;
        var scaleY = 1;
        if (progressbarDirection === 'horizontal') {
          scaleX = scale;
        } else {
          scaleY = scale;
        }
        $el.find(("." + (params.progressbarFillClass))).transform(("translate3d(0,0,0) scaleX(" + scaleX + ") scaleY(" + scaleY + ")")).transition(swiper.params.speed);
      }
      if (params.type === 'custom' && params.renderCustom) {
        $el.html(params.renderCustom(swiper, current + 1, total));
        swiper.emit('paginationRender', swiper, $el[0]);
      } else {
        swiper.emit('paginationUpdate', swiper, $el[0]);
      }
      $el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    },
    render: function render() {
      // Render Container
      var swiper = this;
      var params = swiper.params.pagination;
      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
      var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;

      var $el = swiper.pagination.$el;
      var paginationHTML = '';
      if (params.type === 'bullets') {
        var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - (swiper.loopedSlides * 2)) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        for (var i = 0; i < numberOfBullets; i += 1) {
          if (params.renderBullet) {
            paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
          } else {
            paginationHTML += "<" + (params.bulletElement) + " class=\"" + (params.bulletClass) + "\"></" + (params.bulletElement) + ">";
          }
        }
        $el.html(paginationHTML);
        swiper.pagination.bullets = $el.find(("." + (params.bulletClass)));
      }
      if (params.type === 'fraction') {
        if (params.renderFraction) {
          paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
        } else {
          paginationHTML = "<span class=\"" + (params.currentClass) + "\"></span>"
          + ' / '
          + "<span class=\"" + (params.totalClass) + "\"></span>";
        }
        $el.html(paginationHTML);
      }
      if (params.type === 'progressbar') {
        if (params.renderProgressbar) {
          paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
        } else {
          paginationHTML = "<span class=\"" + (params.progressbarFillClass) + "\"></span>";
        }
        $el.html(paginationHTML);
      }
      if (params.type !== 'custom') {
        swiper.emit('paginationRender', swiper.pagination.$el[0]);
      }
    },
    init: function init() {
      var swiper = this;
      var params = swiper.params.pagination;
      if (!params.el) { return; }

      var $el = $(params.el);
      if ($el.length === 0) { return; }

      if (
        swiper.params.uniqueNavElements
        && typeof params.el === 'string'
        && $el.length > 1
        && swiper.$el.find(params.el).length === 1
      ) {
        $el = swiper.$el.find(params.el);
      }

      if (params.type === 'bullets' && params.clickable) {
        $el.addClass(params.clickableClass);
      }

      $el.addClass(params.modifierClass + params.type);

      if (params.type === 'bullets' && params.dynamicBullets) {
        $el.addClass(("" + (params.modifierClass) + (params.type) + "-dynamic"));
        swiper.pagination.dynamicBulletIndex = 0;
        if (params.dynamicMainBullets < 1) {
          params.dynamicMainBullets = 1;
        }
      }
      if (params.type === 'progressbar' && params.progressbarOpposite) {
        $el.addClass(params.progressbarOppositeClass);
      }

      if (params.clickable) {
        $el.on('click', ("." + (params.bulletClass)), function onClick(e) {
          e.preventDefault();
          var index = $(this).index() * swiper.params.slidesPerGroup;
          if (swiper.params.loop) { index += swiper.loopedSlides; }
          swiper.slideTo(index);
        });
      }

      Utils.extend(swiper.pagination, {
        $el: $el,
        el: $el[0],
      });
    },
    destroy: function destroy() {
      var swiper = this;
      var params = swiper.params.pagination;
      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
      var $el = swiper.pagination.$el;

      $el.removeClass(params.hiddenClass);
      $el.removeClass(params.modifierClass + params.type);
      if (swiper.pagination.bullets) { swiper.pagination.bullets.removeClass(params.bulletActiveClass); }
      if (params.clickable) {
        $el.off('click', ("." + (params.bulletClass)));
      }
    },
  };

  var Pagination$1 = {
    name: 'pagination',
    params: {
      pagination: {
        el: null,
        bulletElement: 'span',
        clickable: false,
        hideOnClick: false,
        renderBullet: null,
        renderProgressbar: null,
        renderFraction: null,
        renderCustom: null,
        progressbarOpposite: false,
        type: 'bullets', // 'bullets' or 'progressbar' or 'fraction' or 'custom'
        dynamicBullets: false,
        dynamicMainBullets: 1,
        formatFractionCurrent: function (number) { return number; },
        formatFractionTotal: function (number) { return number; },
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active',
        modifierClass: 'swiper-pagination-', // NEW
        currentClass: 'swiper-pagination-current',
        totalClass: 'swiper-pagination-total',
        hiddenClass: 'swiper-pagination-hidden',
        progressbarFillClass: 'swiper-pagination-progressbar-fill',
        progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
        clickableClass: 'swiper-pagination-clickable', // NEW
        lockClass: 'swiper-pagination-lock',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        pagination: {
          init: Pagination.init.bind(swiper),
          render: Pagination.render.bind(swiper),
          update: Pagination.update.bind(swiper),
          destroy: Pagination.destroy.bind(swiper),
          dynamicBulletIndex: 0,
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        swiper.pagination.init();
        swiper.pagination.render();
        swiper.pagination.update();
      },
      activeIndexChange: function activeIndexChange() {
        var swiper = this;
        if (swiper.params.loop) {
          swiper.pagination.update();
        } else if (typeof swiper.snapIndex === 'undefined') {
          swiper.pagination.update();
        }
      },
      snapIndexChange: function snapIndexChange() {
        var swiper = this;
        if (!swiper.params.loop) {
          swiper.pagination.update();
        }
      },
      slidesLengthChange: function slidesLengthChange() {
        var swiper = this;
        if (swiper.params.loop) {
          swiper.pagination.render();
          swiper.pagination.update();
        }
      },
      snapGridLengthChange: function snapGridLengthChange() {
        var swiper = this;
        if (!swiper.params.loop) {
          swiper.pagination.render();
          swiper.pagination.update();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.pagination.destroy();
      },
      click: function click(e) {
        var swiper = this;
        if (
          swiper.params.pagination.el
          && swiper.params.pagination.hideOnClick
          && swiper.pagination.$el.length > 0
          && !$(e.target).hasClass(swiper.params.pagination.bulletClass)
        ) {
          var isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);
          if (isHidden === true) {
            swiper.emit('paginationShow', swiper);
          } else {
            swiper.emit('paginationHide', swiper);
          }
          swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
        }
      },
    },
  };

  var Scrollbar = {
    setTranslate: function setTranslate() {
      var swiper = this;
      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }
      var scrollbar = swiper.scrollbar;
      var rtl = swiper.rtlTranslate;
      var progress = swiper.progress;
      var dragSize = scrollbar.dragSize;
      var trackSize = scrollbar.trackSize;
      var $dragEl = scrollbar.$dragEl;
      var $el = scrollbar.$el;
      var params = swiper.params.scrollbar;

      var newSize = dragSize;
      var newPos = (trackSize - dragSize) * progress;
      if (rtl) {
        newPos = -newPos;
        if (newPos > 0) {
          newSize = dragSize - newPos;
          newPos = 0;
        } else if (-newPos + dragSize > trackSize) {
          newSize = trackSize + newPos;
        }
      } else if (newPos < 0) {
        newSize = dragSize + newPos;
        newPos = 0;
      } else if (newPos + dragSize > trackSize) {
        newSize = trackSize - newPos;
      }
      if (swiper.isHorizontal()) {
        if (Support.transforms3d) {
          $dragEl.transform(("translate3d(" + newPos + "px, 0, 0)"));
        } else {
          $dragEl.transform(("translateX(" + newPos + "px)"));
        }
        $dragEl[0].style.width = newSize + "px";
      } else {
        if (Support.transforms3d) {
          $dragEl.transform(("translate3d(0px, " + newPos + "px, 0)"));
        } else {
          $dragEl.transform(("translateY(" + newPos + "px)"));
        }
        $dragEl[0].style.height = newSize + "px";
      }
      if (params.hide) {
        clearTimeout(swiper.scrollbar.timeout);
        $el[0].style.opacity = 1;
        swiper.scrollbar.timeout = setTimeout(function () {
          $el[0].style.opacity = 0;
          $el.transition(400);
        }, 1000);
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }
      swiper.scrollbar.$dragEl.transition(duration);
    },
    updateSize: function updateSize() {
      var swiper = this;
      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }

      var scrollbar = swiper.scrollbar;
      var $dragEl = scrollbar.$dragEl;
      var $el = scrollbar.$el;

      $dragEl[0].style.width = '';
      $dragEl[0].style.height = '';
      var trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;

      var divider = swiper.size / swiper.virtualSize;
      var moveDivider = divider * (trackSize / swiper.size);
      var dragSize;
      if (swiper.params.scrollbar.dragSize === 'auto') {
        dragSize = trackSize * divider;
      } else {
        dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
      }

      if (swiper.isHorizontal()) {
        $dragEl[0].style.width = dragSize + "px";
      } else {
        $dragEl[0].style.height = dragSize + "px";
      }

      if (divider >= 1) {
        $el[0].style.display = 'none';
      } else {
        $el[0].style.display = '';
      }
      if (swiper.params.scrollbar.hide) {
        $el[0].style.opacity = 0;
      }
      Utils.extend(scrollbar, {
        trackSize: trackSize,
        divider: divider,
        moveDivider: moveDivider,
        dragSize: dragSize,
      });
      scrollbar.$el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
    },
    getPointerPosition: function getPointerPosition(e) {
      var swiper = this;
      if (swiper.isHorizontal()) {
        return ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageX : e.pageX || e.clientX);
      }
      return ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageY : e.pageY || e.clientY);
    },
    setDragPosition: function setDragPosition(e) {
      var swiper = this;
      var scrollbar = swiper.scrollbar;
      var rtl = swiper.rtlTranslate;
      var $el = scrollbar.$el;
      var dragSize = scrollbar.dragSize;
      var trackSize = scrollbar.trackSize;
      var dragStartPos = scrollbar.dragStartPos;

      var positionRatio;
      positionRatio = ((scrollbar.getPointerPosition(e)) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top']
        - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
      positionRatio = Math.max(Math.min(positionRatio, 1), 0);
      if (rtl) {
        positionRatio = 1 - positionRatio;
      }

      var position = swiper.minTranslate() + ((swiper.maxTranslate() - swiper.minTranslate()) * positionRatio);

      swiper.updateProgress(position);
      swiper.setTranslate(position);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    },
    onDragStart: function onDragStart(e) {
      var swiper = this;
      var params = swiper.params.scrollbar;
      var scrollbar = swiper.scrollbar;
      var $wrapperEl = swiper.$wrapperEl;
      var $el = scrollbar.$el;
      var $dragEl = scrollbar.$dragEl;
      swiper.scrollbar.isTouched = true;
      swiper.scrollbar.dragStartPos = (e.target === $dragEl[0] || e.target === $dragEl)
        ? scrollbar.getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
      e.preventDefault();
      e.stopPropagation();

      $wrapperEl.transition(100);
      $dragEl.transition(100);
      scrollbar.setDragPosition(e);

      clearTimeout(swiper.scrollbar.dragTimeout);

      $el.transition(0);
      if (params.hide) {
        $el.css('opacity', 1);
      }
      swiper.emit('scrollbarDragStart', e);
    },
    onDragMove: function onDragMove(e) {
      var swiper = this;
      var scrollbar = swiper.scrollbar;
      var $wrapperEl = swiper.$wrapperEl;
      var $el = scrollbar.$el;
      var $dragEl = scrollbar.$dragEl;

      if (!swiper.scrollbar.isTouched) { return; }
      if (e.preventDefault) { e.preventDefault(); }
      else { e.returnValue = false; }
      scrollbar.setDragPosition(e);
      $wrapperEl.transition(0);
      $el.transition(0);
      $dragEl.transition(0);
      swiper.emit('scrollbarDragMove', e);
    },
    onDragEnd: function onDragEnd(e) {
      var swiper = this;

      var params = swiper.params.scrollbar;
      var scrollbar = swiper.scrollbar;
      var $el = scrollbar.$el;

      if (!swiper.scrollbar.isTouched) { return; }
      swiper.scrollbar.isTouched = false;
      if (params.hide) {
        clearTimeout(swiper.scrollbar.dragTimeout);
        swiper.scrollbar.dragTimeout = Utils.nextTick(function () {
          $el.css('opacity', 0);
          $el.transition(400);
        }, 1000);
      }
      swiper.emit('scrollbarDragEnd', e);
      if (params.snapOnRelease) {
        swiper.slideToClosest();
      }
    },
    enableDraggable: function enableDraggable() {
      var swiper = this;
      if (!swiper.params.scrollbar.el) { return; }
      var scrollbar = swiper.scrollbar;
      var touchEventsTouch = swiper.touchEventsTouch;
      var touchEventsDesktop = swiper.touchEventsDesktop;
      var params = swiper.params;
      var $el = scrollbar.$el;
      var target = $el[0];
      var activeListener = Support.passiveListener && params.passiveListeners ? { passive: false, capture: false } : false;
      var passiveListener = Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
      if (!Support.touch) {
        target.addEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
        doc.addEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
        doc.addEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
      } else {
        target.addEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
        target.addEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
        target.addEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
      }
    },
    disableDraggable: function disableDraggable() {
      var swiper = this;
      if (!swiper.params.scrollbar.el) { return; }
      var scrollbar = swiper.scrollbar;
      var touchEventsTouch = swiper.touchEventsTouch;
      var touchEventsDesktop = swiper.touchEventsDesktop;
      var params = swiper.params;
      var $el = scrollbar.$el;
      var target = $el[0];
      var activeListener = Support.passiveListener && params.passiveListeners ? { passive: false, capture: false } : false;
      var passiveListener = Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
      if (!Support.touch) {
        target.removeEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
        doc.removeEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
        doc.removeEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
      } else {
        target.removeEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
        target.removeEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
        target.removeEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
      }
    },
    init: function init() {
      var swiper = this;
      if (!swiper.params.scrollbar.el) { return; }
      var scrollbar = swiper.scrollbar;
      var $swiperEl = swiper.$el;
      var params = swiper.params.scrollbar;

      var $el = $(params.el);
      if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
        $el = $swiperEl.find(params.el);
      }

      var $dragEl = $el.find(("." + (swiper.params.scrollbar.dragClass)));
      if ($dragEl.length === 0) {
        $dragEl = $(("<div class=\"" + (swiper.params.scrollbar.dragClass) + "\"></div>"));
        $el.append($dragEl);
      }

      Utils.extend(scrollbar, {
        $el: $el,
        el: $el[0],
        $dragEl: $dragEl,
        dragEl: $dragEl[0],
      });

      if (params.draggable) {
        scrollbar.enableDraggable();
      }
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.scrollbar.disableDraggable();
    },
  };

  var Scrollbar$1 = {
    name: 'scrollbar',
    params: {
      scrollbar: {
        el: null,
        dragSize: 'auto',
        hide: false,
        draggable: false,
        snapOnRelease: true,
        lockClass: 'swiper-scrollbar-lock',
        dragClass: 'swiper-scrollbar-drag',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        scrollbar: {
          init: Scrollbar.init.bind(swiper),
          destroy: Scrollbar.destroy.bind(swiper),
          updateSize: Scrollbar.updateSize.bind(swiper),
          setTranslate: Scrollbar.setTranslate.bind(swiper),
          setTransition: Scrollbar.setTransition.bind(swiper),
          enableDraggable: Scrollbar.enableDraggable.bind(swiper),
          disableDraggable: Scrollbar.disableDraggable.bind(swiper),
          setDragPosition: Scrollbar.setDragPosition.bind(swiper),
          getPointerPosition: Scrollbar.getPointerPosition.bind(swiper),
          onDragStart: Scrollbar.onDragStart.bind(swiper),
          onDragMove: Scrollbar.onDragMove.bind(swiper),
          onDragEnd: Scrollbar.onDragEnd.bind(swiper),
          isTouched: false,
          timeout: null,
          dragTimeout: null,
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        swiper.scrollbar.init();
        swiper.scrollbar.updateSize();
        swiper.scrollbar.setTranslate();
      },
      update: function update() {
        var swiper = this;
        swiper.scrollbar.updateSize();
      },
      resize: function resize() {
        var swiper = this;
        swiper.scrollbar.updateSize();
      },
      observerUpdate: function observerUpdate() {
        var swiper = this;
        swiper.scrollbar.updateSize();
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        swiper.scrollbar.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        swiper.scrollbar.setTransition(duration);
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.scrollbar.destroy();
      },
    },
  };

  var Parallax = {
    setTransform: function setTransform(el, progress) {
      var swiper = this;
      var rtl = swiper.rtl;

      var $el = $(el);
      var rtlFactor = rtl ? -1 : 1;

      var p = $el.attr('data-swiper-parallax') || '0';
      var x = $el.attr('data-swiper-parallax-x');
      var y = $el.attr('data-swiper-parallax-y');
      var scale = $el.attr('data-swiper-parallax-scale');
      var opacity = $el.attr('data-swiper-parallax-opacity');

      if (x || y) {
        x = x || '0';
        y = y || '0';
      } else if (swiper.isHorizontal()) {
        x = p;
        y = '0';
      } else {
        y = p;
        x = '0';
      }

      if ((x).indexOf('%') >= 0) {
        x = (parseInt(x, 10) * progress * rtlFactor) + "%";
      } else {
        x = (x * progress * rtlFactor) + "px";
      }
      if ((y).indexOf('%') >= 0) {
        y = (parseInt(y, 10) * progress) + "%";
      } else {
        y = (y * progress) + "px";
      }

      if (typeof opacity !== 'undefined' && opacity !== null) {
        var currentOpacity = opacity - ((opacity - 1) * (1 - Math.abs(progress)));
        $el[0].style.opacity = currentOpacity;
      }
      if (typeof scale === 'undefined' || scale === null) {
        $el.transform(("translate3d(" + x + ", " + y + ", 0px)"));
      } else {
        var currentScale = scale - ((scale - 1) * (1 - Math.abs(progress)));
        $el.transform(("translate3d(" + x + ", " + y + ", 0px) scale(" + currentScale + ")"));
      }
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      var $el = swiper.$el;
      var slides = swiper.slides;
      var progress = swiper.progress;
      var snapGrid = swiper.snapGrid;
      $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]')
        .each(function (index, el) {
          swiper.parallax.setTransform(el, progress);
        });
      slides.each(function (slideIndex, slideEl) {
        var slideProgress = slideEl.progress;
        if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
          slideProgress += Math.ceil(slideIndex / 2) - (progress * (snapGrid.length - 1));
        }
        slideProgress = Math.min(Math.max(slideProgress, -1), 1);
        $(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]')
          .each(function (index, el) {
            swiper.parallax.setTransform(el, slideProgress);
          });
      });
    },
    setTransition: function setTransition(duration) {
      if ( duration === void 0 ) duration = this.params.speed;

      var swiper = this;
      var $el = swiper.$el;
      $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]')
        .each(function (index, parallaxEl) {
          var $parallaxEl = $(parallaxEl);
          var parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
          if (duration === 0) { parallaxDuration = 0; }
          $parallaxEl.transition(parallaxDuration);
        });
    },
  };

  var Parallax$1 = {
    name: 'parallax',
    params: {
      parallax: {
        enabled: false,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        parallax: {
          setTransform: Parallax.setTransform.bind(swiper),
          setTranslate: Parallax.setTranslate.bind(swiper),
          setTransition: Parallax.setTransition.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (!swiper.params.parallax.enabled) { return; }
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
      },
      init: function init() {
        var swiper = this;
        if (!swiper.params.parallax.enabled) { return; }
        swiper.parallax.setTranslate();
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (!swiper.params.parallax.enabled) { return; }
        swiper.parallax.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (!swiper.params.parallax.enabled) { return; }
        swiper.parallax.setTransition(duration);
      },
    },
  };

  var Zoom = {
    // Calc Scale From Multi-touches
    getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
      if (e.targetTouches.length < 2) { return 1; }
      var x1 = e.targetTouches[0].pageX;
      var y1 = e.targetTouches[0].pageY;
      var x2 = e.targetTouches[1].pageX;
      var y2 = e.targetTouches[1].pageY;
      var distance = Math.sqrt((Math.pow( (x2 - x1), 2 )) + (Math.pow( (y2 - y1), 2 )));
      return distance;
    },
    // Events
    onGestureStart: function onGestureStart(e) {
      var swiper = this;
      var params = swiper.params.zoom;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      zoom.fakeGestureTouched = false;
      zoom.fakeGestureMoved = false;
      if (!Support.gestures) {
        if (e.type !== 'touchstart' || (e.type === 'touchstart' && e.targetTouches.length < 2)) {
          return;
        }
        zoom.fakeGestureTouched = true;
        gesture.scaleStart = Zoom.getDistanceBetweenTouches(e);
      }
      if (!gesture.$slideEl || !gesture.$slideEl.length) {
        gesture.$slideEl = $(e.target).closest('.swiper-slide');
        if (gesture.$slideEl.length === 0) { gesture.$slideEl = swiper.slides.eq(swiper.activeIndex); }
        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
        gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
        gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
        if (gesture.$imageWrapEl.length === 0) {
          gesture.$imageEl = undefined;
          return;
        }
      }
      gesture.$imageEl.transition(0);
      swiper.zoom.isScaling = true;
    },
    onGestureChange: function onGestureChange(e) {
      var swiper = this;
      var params = swiper.params.zoom;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      if (!Support.gestures) {
        if (e.type !== 'touchmove' || (e.type === 'touchmove' && e.targetTouches.length < 2)) {
          return;
        }
        zoom.fakeGestureMoved = true;
        gesture.scaleMove = Zoom.getDistanceBetweenTouches(e);
      }
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
      if (Support.gestures) {
        zoom.scale = e.scale * zoom.currentScale;
      } else {
        zoom.scale = (gesture.scaleMove / gesture.scaleStart) * zoom.currentScale;
      }
      if (zoom.scale > gesture.maxRatio) {
        zoom.scale = (gesture.maxRatio - 1) + (Math.pow( ((zoom.scale - gesture.maxRatio) + 1), 0.5 ));
      }
      if (zoom.scale < params.minRatio) {
        zoom.scale = (params.minRatio + 1) - (Math.pow( ((params.minRatio - zoom.scale) + 1), 0.5 ));
      }
      gesture.$imageEl.transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
    },
    onGestureEnd: function onGestureEnd(e) {
      var swiper = this;
      var params = swiper.params.zoom;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      if (!Support.gestures) {
        if (!zoom.fakeGestureTouched || !zoom.fakeGestureMoved) {
          return;
        }
        if (e.type !== 'touchend' || (e.type === 'touchend' && e.changedTouches.length < 2 && !Device.android)) {
          return;
        }
        zoom.fakeGestureTouched = false;
        zoom.fakeGestureMoved = false;
      }
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
      zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
      gesture.$imageEl.transition(swiper.params.speed).transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
      zoom.currentScale = zoom.scale;
      zoom.isScaling = false;
      if (zoom.scale === 1) { gesture.$slideEl = undefined; }
    },
    onTouchStart: function onTouchStart(e) {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      var image = zoom.image;
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
      if (image.isTouched) { return; }
      if (Device.android) { e.preventDefault(); }
      image.isTouched = true;
      image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
      image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    },
    onTouchMove: function onTouchMove(e) {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      var image = zoom.image;
      var velocity = zoom.velocity;
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
      swiper.allowClick = false;
      if (!image.isTouched || !gesture.$slideEl) { return; }

      if (!image.isMoved) {
        image.width = gesture.$imageEl[0].offsetWidth;
        image.height = gesture.$imageEl[0].offsetHeight;
        image.startX = Utils.getTranslate(gesture.$imageWrapEl[0], 'x') || 0;
        image.startY = Utils.getTranslate(gesture.$imageWrapEl[0], 'y') || 0;
        gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
        gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
        gesture.$imageWrapEl.transition(0);
        if (swiper.rtl) {
          image.startX = -image.startX;
          image.startY = -image.startY;
        }
      }
      // Define if we need image drag
      var scaledWidth = image.width * zoom.scale;
      var scaledHeight = image.height * zoom.scale;

      if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) { return; }

      image.minX = Math.min(((gesture.slideWidth / 2) - (scaledWidth / 2)), 0);
      image.maxX = -image.minX;
      image.minY = Math.min(((gesture.slideHeight / 2) - (scaledHeight / 2)), 0);
      image.maxY = -image.minY;

      image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
      image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;

      if (!image.isMoved && !zoom.isScaling) {
        if (
          swiper.isHorizontal()
          && (
            (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x)
            || (Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)
          )
        ) {
          image.isTouched = false;
          return;
        } if (
          !swiper.isHorizontal()
          && (
            (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y)
            || (Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)
          )
        ) {
          image.isTouched = false;
          return;
        }
      }
      e.preventDefault();
      e.stopPropagation();

      image.isMoved = true;
      image.currentX = (image.touchesCurrent.x - image.touchesStart.x) + image.startX;
      image.currentY = (image.touchesCurrent.y - image.touchesStart.y) + image.startY;

      if (image.currentX < image.minX) {
        image.currentX = (image.minX + 1) - (Math.pow( ((image.minX - image.currentX) + 1), 0.8 ));
      }
      if (image.currentX > image.maxX) {
        image.currentX = (image.maxX - 1) + (Math.pow( ((image.currentX - image.maxX) + 1), 0.8 ));
      }

      if (image.currentY < image.minY) {
        image.currentY = (image.minY + 1) - (Math.pow( ((image.minY - image.currentY) + 1), 0.8 ));
      }
      if (image.currentY > image.maxY) {
        image.currentY = (image.maxY - 1) + (Math.pow( ((image.currentY - image.maxY) + 1), 0.8 ));
      }

      // Velocity
      if (!velocity.prevPositionX) { velocity.prevPositionX = image.touchesCurrent.x; }
      if (!velocity.prevPositionY) { velocity.prevPositionY = image.touchesCurrent.y; }
      if (!velocity.prevTime) { velocity.prevTime = Date.now(); }
      velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
      velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
      if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) { velocity.x = 0; }
      if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) { velocity.y = 0; }
      velocity.prevPositionX = image.touchesCurrent.x;
      velocity.prevPositionY = image.touchesCurrent.y;
      velocity.prevTime = Date.now();

      gesture.$imageWrapEl.transform(("translate3d(" + (image.currentX) + "px, " + (image.currentY) + "px,0)"));
    },
    onTouchEnd: function onTouchEnd() {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      var image = zoom.image;
      var velocity = zoom.velocity;
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
      if (!image.isTouched || !image.isMoved) {
        image.isTouched = false;
        image.isMoved = false;
        return;
      }
      image.isTouched = false;
      image.isMoved = false;
      var momentumDurationX = 300;
      var momentumDurationY = 300;
      var momentumDistanceX = velocity.x * momentumDurationX;
      var newPositionX = image.currentX + momentumDistanceX;
      var momentumDistanceY = velocity.y * momentumDurationY;
      var newPositionY = image.currentY + momentumDistanceY;

      // Fix duration
      if (velocity.x !== 0) { momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x); }
      if (velocity.y !== 0) { momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y); }
      var momentumDuration = Math.max(momentumDurationX, momentumDurationY);

      image.currentX = newPositionX;
      image.currentY = newPositionY;

      // Define if we need image drag
      var scaledWidth = image.width * zoom.scale;
      var scaledHeight = image.height * zoom.scale;
      image.minX = Math.min(((gesture.slideWidth / 2) - (scaledWidth / 2)), 0);
      image.maxX = -image.minX;
      image.minY = Math.min(((gesture.slideHeight / 2) - (scaledHeight / 2)), 0);
      image.maxY = -image.minY;
      image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
      image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);

      gesture.$imageWrapEl.transition(momentumDuration).transform(("translate3d(" + (image.currentX) + "px, " + (image.currentY) + "px,0)"));
    },
    onTransitionEnd: function onTransitionEnd() {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
        gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
        gesture.$imageWrapEl.transform('translate3d(0,0,0)');

        zoom.scale = 1;
        zoom.currentScale = 1;

        gesture.$slideEl = undefined;
        gesture.$imageEl = undefined;
        gesture.$imageWrapEl = undefined;
      }
    },
    // Toggle Zoom
    toggle: function toggle(e) {
      var swiper = this;
      var zoom = swiper.zoom;

      if (zoom.scale && zoom.scale !== 1) {
        // Zoom Out
        zoom.out();
      } else {
        // Zoom In
        zoom.in(e);
      }
    },
    in: function in$1(e) {
      var swiper = this;

      var zoom = swiper.zoom;
      var params = swiper.params.zoom;
      var gesture = zoom.gesture;
      var image = zoom.image;

      if (!gesture.$slideEl) {
        gesture.$slideEl = swiper.clickedSlide ? $(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
        gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
      }
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }

      gesture.$slideEl.addClass(("" + (params.zoomedSlideClass)));

      var touchX;
      var touchY;
      var offsetX;
      var offsetY;
      var diffX;
      var diffY;
      var translateX;
      var translateY;
      var imageWidth;
      var imageHeight;
      var scaledWidth;
      var scaledHeight;
      var translateMinX;
      var translateMinY;
      var translateMaxX;
      var translateMaxY;
      var slideWidth;
      var slideHeight;

      if (typeof image.touchesStart.x === 'undefined' && e) {
        touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
        touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
      } else {
        touchX = image.touchesStart.x;
        touchY = image.touchesStart.y;
      }

      zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
      zoom.currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
      if (e) {
        slideWidth = gesture.$slideEl[0].offsetWidth;
        slideHeight = gesture.$slideEl[0].offsetHeight;
        offsetX = gesture.$slideEl.offset().left;
        offsetY = gesture.$slideEl.offset().top;
        diffX = (offsetX + (slideWidth / 2)) - touchX;
        diffY = (offsetY + (slideHeight / 2)) - touchY;

        imageWidth = gesture.$imageEl[0].offsetWidth;
        imageHeight = gesture.$imageEl[0].offsetHeight;
        scaledWidth = imageWidth * zoom.scale;
        scaledHeight = imageHeight * zoom.scale;

        translateMinX = Math.min(((slideWidth / 2) - (scaledWidth / 2)), 0);
        translateMinY = Math.min(((slideHeight / 2) - (scaledHeight / 2)), 0);
        translateMaxX = -translateMinX;
        translateMaxY = -translateMinY;

        translateX = diffX * zoom.scale;
        translateY = diffY * zoom.scale;

        if (translateX < translateMinX) {
          translateX = translateMinX;
        }
        if (translateX > translateMaxX) {
          translateX = translateMaxX;
        }

        if (translateY < translateMinY) {
          translateY = translateMinY;
        }
        if (translateY > translateMaxY) {
          translateY = translateMaxY;
        }
      } else {
        translateX = 0;
        translateY = 0;
      }
      gesture.$imageWrapEl.transition(300).transform(("translate3d(" + translateX + "px, " + translateY + "px,0)"));
      gesture.$imageEl.transition(300).transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
    },
    out: function out() {
      var swiper = this;

      var zoom = swiper.zoom;
      var params = swiper.params.zoom;
      var gesture = zoom.gesture;

      if (!gesture.$slideEl) {
        gesture.$slideEl = swiper.clickedSlide ? $(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
        gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
      }
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }

      zoom.scale = 1;
      zoom.currentScale = 1;
      gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
      gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
      gesture.$slideEl.removeClass(("" + (params.zoomedSlideClass)));
      gesture.$slideEl = undefined;
    },
    // Attach/Detach Events
    enable: function enable() {
      var swiper = this;
      var zoom = swiper.zoom;
      if (zoom.enabled) { return; }
      zoom.enabled = true;

      var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;

      // Scale image
      if (Support.gestures) {
        swiper.$wrapperEl.on('gesturestart', '.swiper-slide', zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.on('gesturechange', '.swiper-slide', zoom.onGestureChange, passiveListener);
        swiper.$wrapperEl.on('gestureend', '.swiper-slide', zoom.onGestureEnd, passiveListener);
      } else if (swiper.touchEvents.start === 'touchstart') {
        swiper.$wrapperEl.on(swiper.touchEvents.start, '.swiper-slide', zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.on(swiper.touchEvents.move, '.swiper-slide', zoom.onGestureChange, passiveListener);
        swiper.$wrapperEl.on(swiper.touchEvents.end, '.swiper-slide', zoom.onGestureEnd, passiveListener);
      }

      // Move image
      swiper.$wrapperEl.on(swiper.touchEvents.move, ("." + (swiper.params.zoom.containerClass)), zoom.onTouchMove);
    },
    disable: function disable() {
      var swiper = this;
      var zoom = swiper.zoom;
      if (!zoom.enabled) { return; }

      swiper.zoom.enabled = false;

      var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;

      // Scale image
      if (Support.gestures) {
        swiper.$wrapperEl.off('gesturestart', '.swiper-slide', zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.off('gesturechange', '.swiper-slide', zoom.onGestureChange, passiveListener);
        swiper.$wrapperEl.off('gestureend', '.swiper-slide', zoom.onGestureEnd, passiveListener);
      } else if (swiper.touchEvents.start === 'touchstart') {
        swiper.$wrapperEl.off(swiper.touchEvents.start, '.swiper-slide', zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.off(swiper.touchEvents.move, '.swiper-slide', zoom.onGestureChange, passiveListener);
        swiper.$wrapperEl.off(swiper.touchEvents.end, '.swiper-slide', zoom.onGestureEnd, passiveListener);
      }

      // Move image
      swiper.$wrapperEl.off(swiper.touchEvents.move, ("." + (swiper.params.zoom.containerClass)), zoom.onTouchMove);
    },
  };

  var Zoom$1 = {
    name: 'zoom',
    params: {
      zoom: {
        enabled: false,
        maxRatio: 3,
        minRatio: 1,
        toggle: true,
        containerClass: 'swiper-zoom-container',
        zoomedSlideClass: 'swiper-slide-zoomed',
      },
    },
    create: function create() {
      var swiper = this;
      var zoom = {
        enabled: false,
        scale: 1,
        currentScale: 1,
        isScaling: false,
        gesture: {
          $slideEl: undefined,
          slideWidth: undefined,
          slideHeight: undefined,
          $imageEl: undefined,
          $imageWrapEl: undefined,
          maxRatio: 3,
        },
        image: {
          isTouched: undefined,
          isMoved: undefined,
          currentX: undefined,
          currentY: undefined,
          minX: undefined,
          minY: undefined,
          maxX: undefined,
          maxY: undefined,
          width: undefined,
          height: undefined,
          startX: undefined,
          startY: undefined,
          touchesStart: {},
          touchesCurrent: {},
        },
        velocity: {
          x: undefined,
          y: undefined,
          prevPositionX: undefined,
          prevPositionY: undefined,
          prevTime: undefined,
        },
      };

      ('onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out').split(' ').forEach(function (methodName) {
        zoom[methodName] = Zoom[methodName].bind(swiper);
      });
      Utils.extend(swiper, {
        zoom: zoom,
      });

      var scale = 1;
      Object.defineProperty(swiper.zoom, 'scale', {
        get: function get() {
          return scale;
        },
        set: function set(value) {
          if (scale !== value) {
            var imageEl = swiper.zoom.gesture.$imageEl ? swiper.zoom.gesture.$imageEl[0] : undefined;
            var slideEl = swiper.zoom.gesture.$slideEl ? swiper.zoom.gesture.$slideEl[0] : undefined;
            swiper.emit('zoomChange', value, imageEl, slideEl);
          }
          scale = value;
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.zoom.enabled) {
          swiper.zoom.enable();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.zoom.disable();
      },
      touchStart: function touchStart(e) {
        var swiper = this;
        if (!swiper.zoom.enabled) { return; }
        swiper.zoom.onTouchStart(e);
      },
      touchEnd: function touchEnd(e) {
        var swiper = this;
        if (!swiper.zoom.enabled) { return; }
        swiper.zoom.onTouchEnd(e);
      },
      doubleTap: function doubleTap(e) {
        var swiper = this;
        if (swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
          swiper.zoom.toggle(e);
        }
      },
      transitionEnd: function transitionEnd() {
        var swiper = this;
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
          swiper.zoom.onTransitionEnd();
        }
      },
    },
  };

  var Lazy = {
    loadInSlide: function loadInSlide(index, loadInDuplicate) {
      if ( loadInDuplicate === void 0 ) loadInDuplicate = true;

      var swiper = this;
      var params = swiper.params.lazy;
      if (typeof index === 'undefined') { return; }
      if (swiper.slides.length === 0) { return; }
      var isVirtual = swiper.virtual && swiper.params.virtual.enabled;

      var $slideEl = isVirtual
        ? swiper.$wrapperEl.children(("." + (swiper.params.slideClass) + "[data-swiper-slide-index=\"" + index + "\"]"))
        : swiper.slides.eq(index);

      var $images = $slideEl.find(("." + (params.elementClass) + ":not(." + (params.loadedClass) + "):not(." + (params.loadingClass) + ")"));
      if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) {
        $images = $images.add($slideEl[0]);
      }
      if ($images.length === 0) { return; }

      $images.each(function (imageIndex, imageEl) {
        var $imageEl = $(imageEl);
        $imageEl.addClass(params.loadingClass);

        var background = $imageEl.attr('data-background');
        var src = $imageEl.attr('data-src');
        var srcset = $imageEl.attr('data-srcset');
        var sizes = $imageEl.attr('data-sizes');

        swiper.loadImage($imageEl[0], (src || background), srcset, sizes, false, function () {
          if (typeof swiper === 'undefined' || swiper === null || !swiper || (swiper && !swiper.params) || swiper.destroyed) { return; }
          if (background) {
            $imageEl.css('background-image', ("url(\"" + background + "\")"));
            $imageEl.removeAttr('data-background');
          } else {
            if (srcset) {
              $imageEl.attr('srcset', srcset);
              $imageEl.removeAttr('data-srcset');
            }
            if (sizes) {
              $imageEl.attr('sizes', sizes);
              $imageEl.removeAttr('data-sizes');
            }
            if (src) {
              $imageEl.attr('src', src);
              $imageEl.removeAttr('data-src');
            }
          }

          $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
          $slideEl.find(("." + (params.preloaderClass))).remove();
          if (swiper.params.loop && loadInDuplicate) {
            var slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');
            if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
              var originalSlide = swiper.$wrapperEl.children(("[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]:not(." + (swiper.params.slideDuplicateClass) + ")"));
              swiper.lazy.loadInSlide(originalSlide.index(), false);
            } else {
              var duplicatedSlide = swiper.$wrapperEl.children(("." + (swiper.params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]"));
              swiper.lazy.loadInSlide(duplicatedSlide.index(), false);
            }
          }
          swiper.emit('lazyImageReady', $slideEl[0], $imageEl[0]);
        });

        swiper.emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
      });
    },
    load: function load() {
      var swiper = this;
      var $wrapperEl = swiper.$wrapperEl;
      var swiperParams = swiper.params;
      var slides = swiper.slides;
      var activeIndex = swiper.activeIndex;
      var isVirtual = swiper.virtual && swiperParams.virtual.enabled;
      var params = swiperParams.lazy;

      var slidesPerView = swiperParams.slidesPerView;
      if (slidesPerView === 'auto') {
        slidesPerView = 0;
      }

      function slideExist(index) {
        if (isVirtual) {
          if ($wrapperEl.children(("." + (swiperParams.slideClass) + "[data-swiper-slide-index=\"" + index + "\"]")).length) {
            return true;
          }
        } else if (slides[index]) { return true; }
        return false;
      }
      function slideIndex(slideEl) {
        if (isVirtual) {
          return $(slideEl).attr('data-swiper-slide-index');
        }
        return $(slideEl).index();
      }

      if (!swiper.lazy.initialImageLoaded) { swiper.lazy.initialImageLoaded = true; }
      if (swiper.params.watchSlidesVisibility) {
        $wrapperEl.children(("." + (swiperParams.slideVisibleClass))).each(function (elIndex, slideEl) {
          var index = isVirtual ? $(slideEl).attr('data-swiper-slide-index') : $(slideEl).index();
          swiper.lazy.loadInSlide(index);
        });
      } else if (slidesPerView > 1) {
        for (var i = activeIndex; i < activeIndex + slidesPerView; i += 1) {
          if (slideExist(i)) { swiper.lazy.loadInSlide(i); }
        }
      } else {
        swiper.lazy.loadInSlide(activeIndex);
      }
      if (params.loadPrevNext) {
        if (slidesPerView > 1 || (params.loadPrevNextAmount && params.loadPrevNextAmount > 1)) {
          var amount = params.loadPrevNextAmount;
          var spv = slidesPerView;
          var maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
          var minIndex = Math.max(activeIndex - Math.max(spv, amount), 0);
          // Next Slides
          for (var i$1 = activeIndex + slidesPerView; i$1 < maxIndex; i$1 += 1) {
            if (slideExist(i$1)) { swiper.lazy.loadInSlide(i$1); }
          }
          // Prev Slides
          for (var i$2 = minIndex; i$2 < activeIndex; i$2 += 1) {
            if (slideExist(i$2)) { swiper.lazy.loadInSlide(i$2); }
          }
        } else {
          var nextSlide = $wrapperEl.children(("." + (swiperParams.slideNextClass)));
          if (nextSlide.length > 0) { swiper.lazy.loadInSlide(slideIndex(nextSlide)); }

          var prevSlide = $wrapperEl.children(("." + (swiperParams.slidePrevClass)));
          if (prevSlide.length > 0) { swiper.lazy.loadInSlide(slideIndex(prevSlide)); }
        }
      }
    },
  };

  var Lazy$1 = {
    name: 'lazy',
    params: {
      lazy: {
        enabled: false,
        loadPrevNext: false,
        loadPrevNextAmount: 1,
        loadOnTransitionStart: false,

        elementClass: 'swiper-lazy',
        loadingClass: 'swiper-lazy-loading',
        loadedClass: 'swiper-lazy-loaded',
        preloaderClass: 'swiper-lazy-preloader',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        lazy: {
          initialImageLoaded: false,
          load: Lazy.load.bind(swiper),
          loadInSlide: Lazy.loadInSlide.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
          swiper.params.preloadImages = false;
        }
      },
      init: function init() {
        var swiper = this;
        if (swiper.params.lazy.enabled && !swiper.params.loop && swiper.params.initialSlide === 0) {
          swiper.lazy.load();
        }
      },
      scroll: function scroll() {
        var swiper = this;
        if (swiper.params.freeMode && !swiper.params.freeModeSticky) {
          swiper.lazy.load();
        }
      },
      resize: function resize() {
        var swiper = this;
        if (swiper.params.lazy.enabled) {
          swiper.lazy.load();
        }
      },
      scrollbarDragMove: function scrollbarDragMove() {
        var swiper = this;
        if (swiper.params.lazy.enabled) {
          swiper.lazy.load();
        }
      },
      transitionStart: function transitionStart() {
        var swiper = this;
        if (swiper.params.lazy.enabled) {
          if (swiper.params.lazy.loadOnTransitionStart || (!swiper.params.lazy.loadOnTransitionStart && !swiper.lazy.initialImageLoaded)) {
            swiper.lazy.load();
          }
        }
      },
      transitionEnd: function transitionEnd() {
        var swiper = this;
        if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
          swiper.lazy.load();
        }
      },
    },
  };

  /* eslint no-bitwise: ["error", { "allow": [">>"] }] */

  var Controller = {
    LinearSpline: function LinearSpline(x, y) {
      var binarySearch = (function search() {
        var maxIndex;
        var minIndex;
        var guess;
        return function (array, val) {
          minIndex = -1;
          maxIndex = array.length;
          while (maxIndex - minIndex > 1) {
            guess = maxIndex + minIndex >> 1;
            if (array[guess] <= val) {
              minIndex = guess;
            } else {
              maxIndex = guess;
            }
          }
          return maxIndex;
        };
      }());
      this.x = x;
      this.y = y;
      this.lastIndex = x.length - 1;
      // Given an x value (x2), return the expected y2 value:
      // (x1,y1) is the known point before given value,
      // (x3,y3) is the known point after given value.
      var i1;
      var i3;

      this.interpolate = function interpolate(x2) {
        if (!x2) { return 0; }

        // Get the indexes of x1 and x3 (the array indexes before and after given x2):
        i3 = binarySearch(this.x, x2);
        i1 = i3 - 1;

        // We have our indexes i1 & i3, so we can calculate already:
        // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
        return (((x2 - this.x[i1]) * (this.y[i3] - this.y[i1])) / (this.x[i3] - this.x[i1])) + this.y[i1];
      };
      return this;
    },
    // xxx: for now i will just save one spline function to to
    getInterpolateFunction: function getInterpolateFunction(c) {
      var swiper = this;
      if (!swiper.controller.spline) {
        swiper.controller.spline = swiper.params.loop
          ? new Controller.LinearSpline(swiper.slidesGrid, c.slidesGrid)
          : new Controller.LinearSpline(swiper.snapGrid, c.snapGrid);
      }
    },
    setTranslate: function setTranslate(setTranslate$1, byController) {
      var swiper = this;
      var controlled = swiper.controller.control;
      var multiplier;
      var controlledTranslate;
      function setControlledTranslate(c) {
        // this will create an Interpolate function based on the snapGrids
        // x is the Grid of the scrolled scroller and y will be the controlled scroller
        // it makes sense to create this only once and recall it for the interpolation
        // the function does a lot of value caching for performance
        var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
        if (swiper.params.controller.by === 'slide') {
          swiper.controller.getInterpolateFunction(c);
          // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
          // but it did not work out
          controlledTranslate = -swiper.controller.spline.interpolate(-translate);
        }

        if (!controlledTranslate || swiper.params.controller.by === 'container') {
          multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
          controlledTranslate = ((translate - swiper.minTranslate()) * multiplier) + c.minTranslate();
        }

        if (swiper.params.controller.inverse) {
          controlledTranslate = c.maxTranslate() - controlledTranslate;
        }
        c.updateProgress(controlledTranslate);
        c.setTranslate(controlledTranslate, swiper);
        c.updateActiveIndex();
        c.updateSlidesClasses();
      }
      if (Array.isArray(controlled)) {
        for (var i = 0; i < controlled.length; i += 1) {
          if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
            setControlledTranslate(controlled[i]);
          }
        }
      } else if (controlled instanceof Swiper && byController !== controlled) {
        setControlledTranslate(controlled);
      }
    },
    setTransition: function setTransition(duration, byController) {
      var swiper = this;
      var controlled = swiper.controller.control;
      var i;
      function setControlledTransition(c) {
        c.setTransition(duration, swiper);
        if (duration !== 0) {
          c.transitionStart();
          if (c.params.autoHeight) {
            Utils.nextTick(function () {
              c.updateAutoHeight();
            });
          }
          c.$wrapperEl.transitionEnd(function () {
            if (!controlled) { return; }
            if (c.params.loop && swiper.params.controller.by === 'slide') {
              c.loopFix();
            }
            c.transitionEnd();
          });
        }
      }
      if (Array.isArray(controlled)) {
        for (i = 0; i < controlled.length; i += 1) {
          if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
            setControlledTransition(controlled[i]);
          }
        }
      } else if (controlled instanceof Swiper && byController !== controlled) {
        setControlledTransition(controlled);
      }
    },
  };
  var Controller$1 = {
    name: 'controller',
    params: {
      controller: {
        control: undefined,
        inverse: false,
        by: 'slide', // or 'container'
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        controller: {
          control: swiper.params.controller.control,
          getInterpolateFunction: Controller.getInterpolateFunction.bind(swiper),
          setTranslate: Controller.setTranslate.bind(swiper),
          setTransition: Controller.setTransition.bind(swiper),
        },
      });
    },
    on: {
      update: function update() {
        var swiper = this;
        if (!swiper.controller.control) { return; }
        if (swiper.controller.spline) {
          swiper.controller.spline = undefined;
          delete swiper.controller.spline;
        }
      },
      resize: function resize() {
        var swiper = this;
        if (!swiper.controller.control) { return; }
        if (swiper.controller.spline) {
          swiper.controller.spline = undefined;
          delete swiper.controller.spline;
        }
      },
      observerUpdate: function observerUpdate() {
        var swiper = this;
        if (!swiper.controller.control) { return; }
        if (swiper.controller.spline) {
          swiper.controller.spline = undefined;
          delete swiper.controller.spline;
        }
      },
      setTranslate: function setTranslate(translate, byController) {
        var swiper = this;
        if (!swiper.controller.control) { return; }
        swiper.controller.setTranslate(translate, byController);
      },
      setTransition: function setTransition(duration, byController) {
        var swiper = this;
        if (!swiper.controller.control) { return; }
        swiper.controller.setTransition(duration, byController);
      },
    },
  };

  var a11y = {
    makeElFocusable: function makeElFocusable($el) {
      $el.attr('tabIndex', '0');
      return $el;
    },
    addElRole: function addElRole($el, role) {
      $el.attr('role', role);
      return $el;
    },
    addElLabel: function addElLabel($el, label) {
      $el.attr('aria-label', label);
      return $el;
    },
    disableEl: function disableEl($el) {
      $el.attr('aria-disabled', true);
      return $el;
    },
    enableEl: function enableEl($el) {
      $el.attr('aria-disabled', false);
      return $el;
    },
    onEnterKey: function onEnterKey(e) {
      var swiper = this;
      var params = swiper.params.a11y;
      if (e.keyCode !== 13) { return; }
      var $targetEl = $(e.target);
      if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
        if (!(swiper.isEnd && !swiper.params.loop)) {
          swiper.slideNext();
        }
        if (swiper.isEnd) {
          swiper.a11y.notify(params.lastSlideMessage);
        } else {
          swiper.a11y.notify(params.nextSlideMessage);
        }
      }
      if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
        if (!(swiper.isBeginning && !swiper.params.loop)) {
          swiper.slidePrev();
        }
        if (swiper.isBeginning) {
          swiper.a11y.notify(params.firstSlideMessage);
        } else {
          swiper.a11y.notify(params.prevSlideMessage);
        }
      }
      if (swiper.pagination && $targetEl.is(("." + (swiper.params.pagination.bulletClass)))) {
        $targetEl[0].click();
      }
    },
    notify: function notify(message) {
      var swiper = this;
      var notification = swiper.a11y.liveRegion;
      if (notification.length === 0) { return; }
      notification.html('');
      notification.html(message);
    },
    updateNavigation: function updateNavigation() {
      var swiper = this;

      if (swiper.params.loop) { return; }
      var ref = swiper.navigation;
      var $nextEl = ref.$nextEl;
      var $prevEl = ref.$prevEl;

      if ($prevEl && $prevEl.length > 0) {
        if (swiper.isBeginning) {
          swiper.a11y.disableEl($prevEl);
        } else {
          swiper.a11y.enableEl($prevEl);
        }
      }
      if ($nextEl && $nextEl.length > 0) {
        if (swiper.isEnd) {
          swiper.a11y.disableEl($nextEl);
        } else {
          swiper.a11y.enableEl($nextEl);
        }
      }
    },
    updatePagination: function updatePagination() {
      var swiper = this;
      var params = swiper.params.a11y;
      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
        swiper.pagination.bullets.each(function (bulletIndex, bulletEl) {
          var $bulletEl = $(bulletEl);
          swiper.a11y.makeElFocusable($bulletEl);
          swiper.a11y.addElRole($bulletEl, 'button');
          swiper.a11y.addElLabel($bulletEl, params.paginationBulletMessage.replace(/{{index}}/, $bulletEl.index() + 1));
        });
      }
    },
    init: function init() {
      var swiper = this;

      swiper.$el.append(swiper.a11y.liveRegion);

      // Navigation
      var params = swiper.params.a11y;
      var $nextEl;
      var $prevEl;
      if (swiper.navigation && swiper.navigation.$nextEl) {
        $nextEl = swiper.navigation.$nextEl;
      }
      if (swiper.navigation && swiper.navigation.$prevEl) {
        $prevEl = swiper.navigation.$prevEl;
      }
      if ($nextEl) {
        swiper.a11y.makeElFocusable($nextEl);
        swiper.a11y.addElRole($nextEl, 'button');
        swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
        $nextEl.on('keydown', swiper.a11y.onEnterKey);
      }
      if ($prevEl) {
        swiper.a11y.makeElFocusable($prevEl);
        swiper.a11y.addElRole($prevEl, 'button');
        swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
        $prevEl.on('keydown', swiper.a11y.onEnterKey);
      }

      // Pagination
      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
        swiper.pagination.$el.on('keydown', ("." + (swiper.params.pagination.bulletClass)), swiper.a11y.onEnterKey);
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0) { swiper.a11y.liveRegion.remove(); }

      var $nextEl;
      var $prevEl;
      if (swiper.navigation && swiper.navigation.$nextEl) {
        $nextEl = swiper.navigation.$nextEl;
      }
      if (swiper.navigation && swiper.navigation.$prevEl) {
        $prevEl = swiper.navigation.$prevEl;
      }
      if ($nextEl) {
        $nextEl.off('keydown', swiper.a11y.onEnterKey);
      }
      if ($prevEl) {
        $prevEl.off('keydown', swiper.a11y.onEnterKey);
      }

      // Pagination
      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
        swiper.pagination.$el.off('keydown', ("." + (swiper.params.pagination.bulletClass)), swiper.a11y.onEnterKey);
      }
    },
  };
  var A11y = {
    name: 'a11y',
    params: {
      a11y: {
        enabled: true,
        notificationClass: 'swiper-notification',
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        firstSlideMessage: 'This is the first slide',
        lastSlideMessage: 'This is the last slide',
        paginationBulletMessage: 'Go to slide {{index}}',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        a11y: {
          liveRegion: $(("<span class=\"" + (swiper.params.a11y.notificationClass) + "\" aria-live=\"assertive\" aria-atomic=\"true\"></span>")),
        },
      });
      Object.keys(a11y).forEach(function (methodName) {
        swiper.a11y[methodName] = a11y[methodName].bind(swiper);
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) { return; }
        swiper.a11y.init();
        swiper.a11y.updateNavigation();
      },
      toEdge: function toEdge() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) { return; }
        swiper.a11y.updateNavigation();
      },
      fromEdge: function fromEdge() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) { return; }
        swiper.a11y.updateNavigation();
      },
      paginationUpdate: function paginationUpdate() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) { return; }
        swiper.a11y.updatePagination();
      },
      destroy: function destroy() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) { return; }
        swiper.a11y.destroy();
      },
    },
  };

  var History = {
    init: function init() {
      var swiper = this;
      if (!swiper.params.history) { return; }
      if (!win.history || !win.history.pushState) {
        swiper.params.history.enabled = false;
        swiper.params.hashNavigation.enabled = true;
        return;
      }
      var history = swiper.history;
      history.initialized = true;
      history.paths = History.getPathValues();
      if (!history.paths.key && !history.paths.value) { return; }
      history.scrollToSlide(0, history.paths.value, swiper.params.runCallbacksOnInit);
      if (!swiper.params.history.replaceState) {
        win.addEventListener('popstate', swiper.history.setHistoryPopState);
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (!swiper.params.history.replaceState) {
        win.removeEventListener('popstate', swiper.history.setHistoryPopState);
      }
    },
    setHistoryPopState: function setHistoryPopState() {
      var swiper = this;
      swiper.history.paths = History.getPathValues();
      swiper.history.scrollToSlide(swiper.params.speed, swiper.history.paths.value, false);
    },
    getPathValues: function getPathValues() {
      var pathArray = win.location.pathname.slice(1).split('/').filter(function (part) { return part !== ''; });
      var total = pathArray.length;
      var key = pathArray[total - 2];
      var value = pathArray[total - 1];
      return { key: key, value: value };
    },
    setHistory: function setHistory(key, index) {
      var swiper = this;
      if (!swiper.history.initialized || !swiper.params.history.enabled) { return; }
      var slide = swiper.slides.eq(index);
      var value = History.slugify(slide.attr('data-history'));
      if (!win.location.pathname.includes(key)) {
        value = key + "/" + value;
      }
      var currentState = win.history.state;
      if (currentState && currentState.value === value) {
        return;
      }
      if (swiper.params.history.replaceState) {
        win.history.replaceState({ value: value }, null, value);
      } else {
        win.history.pushState({ value: value }, null, value);
      }
    },
    slugify: function slugify(text) {
      return text.toString()
        .replace(/\s+/g, '-')
        .replace(/[^\w-]+/g, '')
        .replace(/--+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');
    },
    scrollToSlide: function scrollToSlide(speed, value, runCallbacks) {
      var swiper = this;
      if (value) {
        for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
          var slide = swiper.slides.eq(i);
          var slideHistory = History.slugify(slide.attr('data-history'));
          if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
            var index = slide.index();
            swiper.slideTo(index, speed, runCallbacks);
          }
        }
      } else {
        swiper.slideTo(0, speed, runCallbacks);
      }
    },
  };

  var History$1 = {
    name: 'history',
    params: {
      history: {
        enabled: false,
        replaceState: false,
        key: 'slides',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        history: {
          init: History.init.bind(swiper),
          setHistory: History.setHistory.bind(swiper),
          setHistoryPopState: History.setHistoryPopState.bind(swiper),
          scrollToSlide: History.scrollToSlide.bind(swiper),
          destroy: History.destroy.bind(swiper),
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.history.enabled) {
          swiper.history.init();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.params.history.enabled) {
          swiper.history.destroy();
        }
      },
      transitionEnd: function transitionEnd() {
        var swiper = this;
        if (swiper.history.initialized) {
          swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
        }
      },
    },
  };

  var HashNavigation = {
    onHashCange: function onHashCange() {
      var swiper = this;
      var newHash = doc.location.hash.replace('#', '');
      var activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');
      if (newHash !== activeSlideHash) {
        var newIndex = swiper.$wrapperEl.children(("." + (swiper.params.slideClass) + "[data-hash=\"" + newHash + "\"]")).index();
        if (typeof newIndex === 'undefined') { return; }
        swiper.slideTo(newIndex);
      }
    },
    setHash: function setHash() {
      var swiper = this;
      if (!swiper.hashNavigation.initialized || !swiper.params.hashNavigation.enabled) { return; }
      if (swiper.params.hashNavigation.replaceState && win.history && win.history.replaceState) {
        win.history.replaceState(null, null, (("#" + (swiper.slides.eq(swiper.activeIndex).attr('data-hash'))) || ''));
      } else {
        var slide = swiper.slides.eq(swiper.activeIndex);
        var hash = slide.attr('data-hash') || slide.attr('data-history');
        doc.location.hash = hash || '';
      }
    },
    init: function init() {
      var swiper = this;
      if (!swiper.params.hashNavigation.enabled || (swiper.params.history && swiper.params.history.enabled)) { return; }
      swiper.hashNavigation.initialized = true;
      var hash = doc.location.hash.replace('#', '');
      if (hash) {
        var speed = 0;
        for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
          var slide = swiper.slides.eq(i);
          var slideHash = slide.attr('data-hash') || slide.attr('data-history');
          if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
            var index = slide.index();
            swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
          }
        }
      }
      if (swiper.params.hashNavigation.watchState) {
        $(win).on('hashchange', swiper.hashNavigation.onHashCange);
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (swiper.params.hashNavigation.watchState) {
        $(win).off('hashchange', swiper.hashNavigation.onHashCange);
      }
    },
  };
  var HashNavigation$1 = {
    name: 'hash-navigation',
    params: {
      hashNavigation: {
        enabled: false,
        replaceState: false,
        watchState: false,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        hashNavigation: {
          initialized: false,
          init: HashNavigation.init.bind(swiper),
          destroy: HashNavigation.destroy.bind(swiper),
          setHash: HashNavigation.setHash.bind(swiper),
          onHashCange: HashNavigation.onHashCange.bind(swiper),
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.hashNavigation.enabled) {
          swiper.hashNavigation.init();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.params.hashNavigation.enabled) {
          swiper.hashNavigation.destroy();
        }
      },
      transitionEnd: function transitionEnd() {
        var swiper = this;
        if (swiper.hashNavigation.initialized) {
          swiper.hashNavigation.setHash();
        }
      },
    },
  };

  /* eslint no-underscore-dangle: "off" */

  var Autoplay = {
    run: function run() {
      var swiper = this;
      var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
      var delay = swiper.params.autoplay.delay;
      if ($activeSlideEl.attr('data-swiper-autoplay')) {
        delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
      }
      clearTimeout(swiper.autoplay.timeout);
      swiper.autoplay.timeout = Utils.nextTick(function () {
        if (swiper.params.autoplay.reverseDirection) {
          if (swiper.params.loop) {
            swiper.loopFix();
            swiper.slidePrev(swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else if (!swiper.isBeginning) {
            swiper.slidePrev(swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else if (!swiper.params.autoplay.stopOnLastSlide) {
            swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else {
            swiper.autoplay.stop();
          }
        } else if (swiper.params.loop) {
          swiper.loopFix();
          swiper.slideNext(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.isEnd) {
          swiper.slideNext(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          swiper.slideTo(0, swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else {
          swiper.autoplay.stop();
        }
      }, delay);
    },
    start: function start() {
      var swiper = this;
      if (typeof swiper.autoplay.timeout !== 'undefined') { return false; }
      if (swiper.autoplay.running) { return false; }
      swiper.autoplay.running = true;
      swiper.emit('autoplayStart');
      swiper.autoplay.run();
      return true;
    },
    stop: function stop() {
      var swiper = this;
      if (!swiper.autoplay.running) { return false; }
      if (typeof swiper.autoplay.timeout === 'undefined') { return false; }

      if (swiper.autoplay.timeout) {
        clearTimeout(swiper.autoplay.timeout);
        swiper.autoplay.timeout = undefined;
      }
      swiper.autoplay.running = false;
      swiper.emit('autoplayStop');
      return true;
    },
    pause: function pause(speed) {
      var swiper = this;
      if (!swiper.autoplay.running) { return; }
      if (swiper.autoplay.paused) { return; }
      if (swiper.autoplay.timeout) { clearTimeout(swiper.autoplay.timeout); }
      swiper.autoplay.paused = true;
      if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
        swiper.autoplay.paused = false;
        swiper.autoplay.run();
      } else {
        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.autoplay.onTransitionEnd);
        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
      }
    },
  };

  var Autoplay$1 = {
    name: 'autoplay',
    params: {
      autoplay: {
        enabled: false,
        delay: 3000,
        waitForTransition: true,
        disableOnInteraction: true,
        stopOnLastSlide: false,
        reverseDirection: false,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        autoplay: {
          running: false,
          paused: false,
          run: Autoplay.run.bind(swiper),
          start: Autoplay.start.bind(swiper),
          stop: Autoplay.stop.bind(swiper),
          pause: Autoplay.pause.bind(swiper),
          onTransitionEnd: function onTransitionEnd(e) {
            if (!swiper || swiper.destroyed || !swiper.$wrapperEl) { return; }
            if (e.target !== this) { return; }
            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.autoplay.onTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
            swiper.autoplay.paused = false;
            if (!swiper.autoplay.running) {
              swiper.autoplay.stop();
            } else {
              swiper.autoplay.run();
            }
          },
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.autoplay.enabled) {
          swiper.autoplay.start();
        }
      },
      beforeTransitionStart: function beforeTransitionStart(speed, internal) {
        var swiper = this;
        if (swiper.autoplay.running) {
          if (internal || !swiper.params.autoplay.disableOnInteraction) {
            swiper.autoplay.pause(speed);
          } else {
            swiper.autoplay.stop();
          }
        }
      },
      sliderFirstMove: function sliderFirstMove() {
        var swiper = this;
        if (swiper.autoplay.running) {
          if (swiper.params.autoplay.disableOnInteraction) {
            swiper.autoplay.stop();
          } else {
            swiper.autoplay.pause();
          }
        }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.autoplay.running) {
          swiper.autoplay.stop();
        }
      },
    },
  };

  var Fade = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var slides = swiper.slides;
      for (var i = 0; i < slides.length; i += 1) {
        var $slideEl = swiper.slides.eq(i);
        var offset = $slideEl[0].swiperSlideOffset;
        var tx = -offset;
        if (!swiper.params.virtualTranslate) { tx -= swiper.translate; }
        var ty = 0;
        if (!swiper.isHorizontal()) {
          ty = tx;
          tx = 0;
        }
        var slideOpacity = swiper.params.fadeEffect.crossFade
          ? Math.max(1 - Math.abs($slideEl[0].progress), 0)
          : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
        $slideEl
          .css({
            opacity: slideOpacity,
          })
          .transform(("translate3d(" + tx + "px, " + ty + "px, 0px)"));
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      var slides = swiper.slides;
      var $wrapperEl = swiper.$wrapperEl;
      slides.transition(duration);
      if (swiper.params.virtualTranslate && duration !== 0) {
        var eventTriggered = false;
        slides.transitionEnd(function () {
          if (eventTriggered) { return; }
          if (!swiper || swiper.destroyed) { return; }
          eventTriggered = true;
          swiper.animating = false;
          var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
          for (var i = 0; i < triggerEvents.length; i += 1) {
            $wrapperEl.trigger(triggerEvents[i]);
          }
        });
      }
    },
  };

  var EffectFade = {
    name: 'effect-fade',
    params: {
      fadeEffect: {
        crossFade: false,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        fadeEffect: {
          setTranslate: Fade.setTranslate.bind(swiper),
          setTransition: Fade.setTransition.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.effect !== 'fade') { return; }
        swiper.classNames.push(((swiper.params.containerModifierClass) + "fade"));
        var overwriteParams = {
          slidesPerView: 1,
          slidesPerColumn: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          spaceBetween: 0,
          virtualTranslate: true,
        };
        Utils.extend(swiper.params, overwriteParams);
        Utils.extend(swiper.originalParams, overwriteParams);
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (swiper.params.effect !== 'fade') { return; }
        swiper.fadeEffect.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (swiper.params.effect !== 'fade') { return; }
        swiper.fadeEffect.setTransition(duration);
      },
    },
  };

  var Cube = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var $el = swiper.$el;
      var $wrapperEl = swiper.$wrapperEl;
      var slides = swiper.slides;
      var swiperWidth = swiper.width;
      var swiperHeight = swiper.height;
      var rtl = swiper.rtlTranslate;
      var swiperSize = swiper.size;
      var params = swiper.params.cubeEffect;
      var isHorizontal = swiper.isHorizontal();
      var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
      var wrapperRotate = 0;
      var $cubeShadowEl;
      if (params.shadow) {
        if (isHorizontal) {
          $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');
          if ($cubeShadowEl.length === 0) {
            $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
            $wrapperEl.append($cubeShadowEl);
          }
          $cubeShadowEl.css({ height: (swiperWidth + "px") });
        } else {
          $cubeShadowEl = $el.find('.swiper-cube-shadow');
          if ($cubeShadowEl.length === 0) {
            $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
            $el.append($cubeShadowEl);
          }
        }
      }
      for (var i = 0; i < slides.length; i += 1) {
        var $slideEl = slides.eq(i);
        var slideIndex = i;
        if (isVirtual) {
          slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
        }
        var slideAngle = slideIndex * 90;
        var round = Math.floor(slideAngle / 360);
        if (rtl) {
          slideAngle = -slideAngle;
          round = Math.floor(-slideAngle / 360);
        }
        var progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
        var tx = 0;
        var ty = 0;
        var tz = 0;
        if (slideIndex % 4 === 0) {
          tx = -round * 4 * swiperSize;
          tz = 0;
        } else if ((slideIndex - 1) % 4 === 0) {
          tx = 0;
          tz = -round * 4 * swiperSize;
        } else if ((slideIndex - 2) % 4 === 0) {
          tx = swiperSize + (round * 4 * swiperSize);
          tz = swiperSize;
        } else if ((slideIndex - 3) % 4 === 0) {
          tx = -swiperSize;
          tz = (3 * swiperSize) + (swiperSize * 4 * round);
        }
        if (rtl) {
          tx = -tx;
        }

        if (!isHorizontal) {
          ty = tx;
          tx = 0;
        }

        var transform = "rotateX(" + (isHorizontal ? 0 : -slideAngle) + "deg) rotateY(" + (isHorizontal ? slideAngle : 0) + "deg) translate3d(" + tx + "px, " + ty + "px, " + tz + "px)";
        if (progress <= 1 && progress > -1) {
          wrapperRotate = (slideIndex * 90) + (progress * 90);
          if (rtl) { wrapperRotate = (-slideIndex * 90) - (progress * 90); }
        }
        $slideEl.transform(transform);
        if (params.slideShadows) {
          // Set shadows
          var shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
          var shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
          if (shadowBefore.length === 0) {
            shadowBefore = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>"));
            $slideEl.append(shadowBefore);
          }
          if (shadowAfter.length === 0) {
            shadowAfter = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>"));
            $slideEl.append(shadowAfter);
          }
          if (shadowBefore.length) { shadowBefore[0].style.opacity = Math.max(-progress, 0); }
          if (shadowAfter.length) { shadowAfter[0].style.opacity = Math.max(progress, 0); }
        }
      }
      $wrapperEl.css({
        '-webkit-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
        '-moz-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
        '-ms-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
        'transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
      });

      if (params.shadow) {
        if (isHorizontal) {
          $cubeShadowEl.transform(("translate3d(0px, " + ((swiperWidth / 2) + params.shadowOffset) + "px, " + (-swiperWidth / 2) + "px) rotateX(90deg) rotateZ(0deg) scale(" + (params.shadowScale) + ")"));
        } else {
          var shadowAngle = Math.abs(wrapperRotate) - (Math.floor(Math.abs(wrapperRotate) / 90) * 90);
          var multiplier = 1.5 - (
            (Math.sin((shadowAngle * 2 * Math.PI) / 360) / 2)
            + (Math.cos((shadowAngle * 2 * Math.PI) / 360) / 2)
          );
          var scale1 = params.shadowScale;
          var scale2 = params.shadowScale / multiplier;
          var offset = params.shadowOffset;
          $cubeShadowEl.transform(("scale3d(" + scale1 + ", 1, " + scale2 + ") translate3d(0px, " + ((swiperHeight / 2) + offset) + "px, " + (-swiperHeight / 2 / scale2) + "px) rotateX(-90deg)"));
        }
      }
      var zFactor = (Browser.isSafari || Browser.isUiWebView) ? (-swiperSize / 2) : 0;
      $wrapperEl
        .transform(("translate3d(0px,0," + zFactor + "px) rotateX(" + (swiper.isHorizontal() ? 0 : wrapperRotate) + "deg) rotateY(" + (swiper.isHorizontal() ? -wrapperRotate : 0) + "deg)"));
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      var $el = swiper.$el;
      var slides = swiper.slides;
      slides
        .transition(duration)
        .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
        .transition(duration);
      if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
        $el.find('.swiper-cube-shadow').transition(duration);
      }
    },
  };

  var EffectCube = {
    name: 'effect-cube',
    params: {
      cubeEffect: {
        slideShadows: true,
        shadow: true,
        shadowOffset: 20,
        shadowScale: 0.94,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        cubeEffect: {
          setTranslate: Cube.setTranslate.bind(swiper),
          setTransition: Cube.setTransition.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.effect !== 'cube') { return; }
        swiper.classNames.push(((swiper.params.containerModifierClass) + "cube"));
        swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));
        var overwriteParams = {
          slidesPerView: 1,
          slidesPerColumn: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          resistanceRatio: 0,
          spaceBetween: 0,
          centeredSlides: false,
          virtualTranslate: true,
        };
        Utils.extend(swiper.params, overwriteParams);
        Utils.extend(swiper.originalParams, overwriteParams);
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (swiper.params.effect !== 'cube') { return; }
        swiper.cubeEffect.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (swiper.params.effect !== 'cube') { return; }
        swiper.cubeEffect.setTransition(duration);
      },
    },
  };

  var Flip = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var slides = swiper.slides;
      var rtl = swiper.rtlTranslate;
      for (var i = 0; i < slides.length; i += 1) {
        var $slideEl = slides.eq(i);
        var progress = $slideEl[0].progress;
        if (swiper.params.flipEffect.limitRotation) {
          progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
        }
        var offset = $slideEl[0].swiperSlideOffset;
        var rotate = -180 * progress;
        var rotateY = rotate;
        var rotateX = 0;
        var tx = -offset;
        var ty = 0;
        if (!swiper.isHorizontal()) {
          ty = tx;
          tx = 0;
          rotateX = -rotateY;
          rotateY = 0;
        } else if (rtl) {
          rotateY = -rotateY;
        }

        $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;

        if (swiper.params.flipEffect.slideShadows) {
          // Set shadows
          var shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
          var shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
          if (shadowBefore.length === 0) {
            shadowBefore = $(("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'left' : 'top') + "\"></div>"));
            $slideEl.append(shadowBefore);
          }
          if (shadowAfter.length === 0) {
            shadowAfter = $(("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'right' : 'bottom') + "\"></div>"));
            $slideEl.append(shadowAfter);
          }
          if (shadowBefore.length) { shadowBefore[0].style.opacity = Math.max(-progress, 0); }
          if (shadowAfter.length) { shadowAfter[0].style.opacity = Math.max(progress, 0); }
        }
        $slideEl
          .transform(("translate3d(" + tx + "px, " + ty + "px, 0px) rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)"));
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      var slides = swiper.slides;
      var activeIndex = swiper.activeIndex;
      var $wrapperEl = swiper.$wrapperEl;
      slides
        .transition(duration)
        .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
        .transition(duration);
      if (swiper.params.virtualTranslate && duration !== 0) {
        var eventTriggered = false;
        // eslint-disable-next-line
        slides.eq(activeIndex).transitionEnd(function onTransitionEnd() {
          if (eventTriggered) { return; }
          if (!swiper || swiper.destroyed) { return; }
          // if (!$(this).hasClass(swiper.params.slideActiveClass)) return;
          eventTriggered = true;
          swiper.animating = false;
          var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
          for (var i = 0; i < triggerEvents.length; i += 1) {
            $wrapperEl.trigger(triggerEvents[i]);
          }
        });
      }
    },
  };

  var EffectFlip = {
    name: 'effect-flip',
    params: {
      flipEffect: {
        slideShadows: true,
        limitRotation: true,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        flipEffect: {
          setTranslate: Flip.setTranslate.bind(swiper),
          setTransition: Flip.setTransition.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.effect !== 'flip') { return; }
        swiper.classNames.push(((swiper.params.containerModifierClass) + "flip"));
        swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));
        var overwriteParams = {
          slidesPerView: 1,
          slidesPerColumn: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          spaceBetween: 0,
          virtualTranslate: true,
        };
        Utils.extend(swiper.params, overwriteParams);
        Utils.extend(swiper.originalParams, overwriteParams);
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (swiper.params.effect !== 'flip') { return; }
        swiper.flipEffect.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (swiper.params.effect !== 'flip') { return; }
        swiper.flipEffect.setTransition(duration);
      },
    },
  };

  var Coverflow = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var swiperWidth = swiper.width;
      var swiperHeight = swiper.height;
      var slides = swiper.slides;
      var $wrapperEl = swiper.$wrapperEl;
      var slidesSizesGrid = swiper.slidesSizesGrid;
      var params = swiper.params.coverflowEffect;
      var isHorizontal = swiper.isHorizontal();
      var transform = swiper.translate;
      var center = isHorizontal ? -transform + (swiperWidth / 2) : -transform + (swiperHeight / 2);
      var rotate = isHorizontal ? params.rotate : -params.rotate;
      var translate = params.depth;
      // Each slide offset from center
      for (var i = 0, length = slides.length; i < length; i += 1) {
        var $slideEl = slides.eq(i);
        var slideSize = slidesSizesGrid[i];
        var slideOffset = $slideEl[0].swiperSlideOffset;
        var offsetMultiplier = ((center - slideOffset - (slideSize / 2)) / slideSize) * params.modifier;

        var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
        var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
        // var rotateZ = 0
        var translateZ = -translate * Math.abs(offsetMultiplier);

        var translateY = isHorizontal ? 0 : params.stretch * (offsetMultiplier);
        var translateX = isHorizontal ? params.stretch * (offsetMultiplier) : 0;

        // Fix for ultra small values
        if (Math.abs(translateX) < 0.001) { translateX = 0; }
        if (Math.abs(translateY) < 0.001) { translateY = 0; }
        if (Math.abs(translateZ) < 0.001) { translateZ = 0; }
        if (Math.abs(rotateY) < 0.001) { rotateY = 0; }
        if (Math.abs(rotateX) < 0.001) { rotateX = 0; }

        var slideTransform = "translate3d(" + translateX + "px," + translateY + "px," + translateZ + "px)  rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)";

        $slideEl.transform(slideTransform);
        $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
        if (params.slideShadows) {
          // Set shadows
          var $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
          var $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
          if ($shadowBeforeEl.length === 0) {
            $shadowBeforeEl = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>"));
            $slideEl.append($shadowBeforeEl);
          }
          if ($shadowAfterEl.length === 0) {
            $shadowAfterEl = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>"));
            $slideEl.append($shadowAfterEl);
          }
          if ($shadowBeforeEl.length) { $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0; }
          if ($shadowAfterEl.length) { $shadowAfterEl[0].style.opacity = (-offsetMultiplier) > 0 ? -offsetMultiplier : 0; }
        }
      }

      // Set correct perspective for IE10
      if (Support.pointerEvents || Support.prefixedPointerEvents) {
        var ws = $wrapperEl[0].style;
        ws.perspectiveOrigin = center + "px 50%";
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      swiper.slides
        .transition(duration)
        .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
        .transition(duration);
    },
  };

  var EffectCoverflow = {
    name: 'effect-coverflow',
    params: {
      coverflowEffect: {
        rotate: 50,
        stretch: 0,
        depth: 100,
        modifier: 1,
        slideShadows: true,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        coverflowEffect: {
          setTranslate: Coverflow.setTranslate.bind(swiper),
          setTransition: Coverflow.setTransition.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.effect !== 'coverflow') { return; }

        swiper.classNames.push(((swiper.params.containerModifierClass) + "coverflow"));
        swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));

        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (swiper.params.effect !== 'coverflow') { return; }
        swiper.coverflowEffect.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (swiper.params.effect !== 'coverflow') { return; }
        swiper.coverflowEffect.setTransition(duration);
      },
    },
  };

  var Thumbs = {
    init: function init() {
      var swiper = this;
      var ref = swiper.params;
      var thumbsParams = ref.thumbs;
      var SwiperClass = swiper.constructor;
      if (thumbsParams.swiper instanceof SwiperClass) {
        swiper.thumbs.swiper = thumbsParams.swiper;
        Utils.extend(swiper.thumbs.swiper.originalParams, {
          watchSlidesProgress: true,
          slideToClickedSlide: false,
        });
        Utils.extend(swiper.thumbs.swiper.params, {
          watchSlidesProgress: true,
          slideToClickedSlide: false,
        });
      } else if (Utils.isObject(thumbsParams.swiper)) {
        swiper.thumbs.swiper = new SwiperClass(Utils.extend({}, thumbsParams.swiper, {
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          slideToClickedSlide: false,
        }));
        swiper.thumbs.swiperCreated = true;
      }
      swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
      swiper.thumbs.swiper.on('tap', swiper.thumbs.onThumbClick);
    },
    onThumbClick: function onThumbClick() {
      var swiper = this;
      var thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper) { return; }
      var clickedIndex = thumbsSwiper.clickedIndex;
      var clickedSlide = thumbsSwiper.clickedSlide;
      if (clickedSlide && $(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) { return; }
      if (typeof clickedIndex === 'undefined' || clickedIndex === null) { return; }
      var slideToIndex;
      if (thumbsSwiper.params.loop) {
        slideToIndex = parseInt($(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
      } else {
        slideToIndex = clickedIndex;
      }
      if (swiper.params.loop) {
        var currentIndex = swiper.activeIndex;
        if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
          swiper.loopFix();
          // eslint-disable-next-line
          swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
          currentIndex = swiper.activeIndex;
        }
        var prevIndex = swiper.slides.eq(currentIndex).prevAll(("[data-swiper-slide-index=\"" + slideToIndex + "\"]")).eq(0).index();
        var nextIndex = swiper.slides.eq(currentIndex).nextAll(("[data-swiper-slide-index=\"" + slideToIndex + "\"]")).eq(0).index();
        if (typeof prevIndex === 'undefined') { slideToIndex = nextIndex; }
        else if (typeof nextIndex === 'undefined') { slideToIndex = prevIndex; }
        else if (nextIndex - currentIndex < currentIndex - prevIndex) { slideToIndex = nextIndex; }
        else { slideToIndex = prevIndex; }
      }
      swiper.slideTo(slideToIndex);
    },
    update: function update(initial) {
      var swiper = this;
      var thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper) { return; }

      var slidesPerView = thumbsSwiper.params.slidesPerView === 'auto'
        ? thumbsSwiper.slidesPerViewDynamic()
        : thumbsSwiper.params.slidesPerView;

      if (swiper.realIndex !== thumbsSwiper.realIndex) {
        var currentThumbsIndex = thumbsSwiper.activeIndex;
        var newThumbsIndex;
        if (thumbsSwiper.params.loop) {
          if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
            thumbsSwiper.loopFix();
            // eslint-disable-next-line
            thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
            currentThumbsIndex = thumbsSwiper.activeIndex;
          }
          // Find actual thumbs index to slide to
          var prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll(("[data-swiper-slide-index=\"" + (swiper.realIndex) + "\"]")).eq(0).index();
          var nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll(("[data-swiper-slide-index=\"" + (swiper.realIndex) + "\"]")).eq(0).index();
          if (typeof prevThumbsIndex === 'undefined') { newThumbsIndex = nextThumbsIndex; }
          else if (typeof nextThumbsIndex === 'undefined') { newThumbsIndex = prevThumbsIndex; }
          else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) { newThumbsIndex = currentThumbsIndex; }
          else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) { newThumbsIndex = nextThumbsIndex; }
          else { newThumbsIndex = prevThumbsIndex; }
        } else {
          newThumbsIndex = swiper.realIndex;
        }
        if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
          if (thumbsSwiper.params.centeredSlides) {
            if (newThumbsIndex > currentThumbsIndex) {
              newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
            } else {
              newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
            }
          } else if (newThumbsIndex > currentThumbsIndex) {
            newThumbsIndex = newThumbsIndex - slidesPerView + 1;
          }
          thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
        }
      }

      // Activate thumbs
      var thumbsToActivate = 1;
      var thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;

      if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
        thumbsToActivate = swiper.params.slidesPerView;
      }

      thumbsSwiper.slides.removeClass(thumbActiveClass);
      if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual) {
        for (var i = 0; i < thumbsToActivate; i += 1) {
          thumbsSwiper.$wrapperEl.children(("[data-swiper-slide-index=\"" + (swiper.realIndex + i) + "\"]")).addClass(thumbActiveClass);
        }
      } else {
        for (var i$1 = 0; i$1 < thumbsToActivate; i$1 += 1) {
          thumbsSwiper.slides.eq(swiper.realIndex + i$1).addClass(thumbActiveClass);
        }
      }
    },
  };
  var Thumbs$1 = {
    name: 'thumbs',
    params: {
      thumbs: {
        swiper: null,
        slideThumbActiveClass: 'swiper-slide-thumb-active',
        thumbsContainerClass: 'swiper-container-thumbs',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        thumbs: {
          swiper: null,
          init: Thumbs.init.bind(swiper),
          update: Thumbs.update.bind(swiper),
          onThumbClick: Thumbs.onThumbClick.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        var ref = swiper.params;
        var thumbs = ref.thumbs;
        if (!thumbs || !thumbs.swiper) { return; }
        swiper.thumbs.init();
        swiper.thumbs.update(true);
      },
      slideChange: function slideChange() {
        var swiper = this;
        if (!swiper.thumbs.swiper) { return; }
        swiper.thumbs.update();
      },
      update: function update() {
        var swiper = this;
        if (!swiper.thumbs.swiper) { return; }
        swiper.thumbs.update();
      },
      resize: function resize() {
        var swiper = this;
        if (!swiper.thumbs.swiper) { return; }
        swiper.thumbs.update();
      },
      observerUpdate: function observerUpdate() {
        var swiper = this;
        if (!swiper.thumbs.swiper) { return; }
        swiper.thumbs.update();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) { return; }
        thumbsSwiper.setTransition(duration);
      },
      beforeDestroy: function beforeDestroy() {
        var swiper = this;
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) { return; }
        if (swiper.thumbs.swiperCreated && thumbsSwiper) {
          thumbsSwiper.destroy();
        }
      },
    },
  };

  // Swiper Class

  var components = [
    Device$1,
    Support$1,
    Browser$1,
    Resize,
    Observer$1,
    Virtual$1,
    Keyboard$1,
    Mousewheel$1,
    Navigation$1,
    Pagination$1,
    Scrollbar$1,
    Parallax$1,
    Zoom$1,
    Lazy$1,
    Controller$1,
    A11y,
    History$1,
    HashNavigation$1,
    Autoplay$1,
    EffectFade,
    EffectCube,
    EffectFlip,
    EffectCoverflow,
    Thumbs$1
  ];

  if (typeof Swiper.use === 'undefined') {
    Swiper.use = Swiper.Class.use;
    Swiper.installModule = Swiper.Class.installModule;
  }

  Swiper.use(components);

  return Swiper;

}));


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


$ = __webpack_require__(3);
__webpack_require__(400);
var RamJetFileProgress = __webpack_require__(401);

var fg = fg || {};

fg.Upload = function (element, options) {
	this.init(element, options);
};

fg.Upload.prototype.defaults = {
	// plupload options
	runtimes: 'html5,flash,html4',
	url: null,
	flash_swf_url: null,
	autoStart: true,
	dragdrop: true,
	// file limits
	filters: [],
	max_file_size: 0,
	max_file_count: 0,
	max_file_queue_count: 0,
	// elements
	drop_element: null,
	statusDiv: null,
	progressTarget: null,
	progressWidth: null,
	// buttons
	browse_button: null,
	startQueueTarget: null,
	cancelQueueTarget: null,
	// localization messages
	labelInQueue: undefined,
	labelUploading: undefined,
	labelComplete: undefined,
	labelStopped: undefined,
	labelCancelled: undefined,
	labelFileQueued: undefined,
	labelUploadCompleted: undefined,
	labelQueueCompleted: undefined,
	labelErrorUploadLimit: undefined,
	labelErrorQueueLimit: undefined,
	labelErrorFileTooBig: undefined,
	labelErrorZeroLength: undefined,
	labelErrorInvalidFileType: undefined,
	labelErrorUnknownError: undefined,
	labelErrorUploadError: undefined,
	// auto disappear uploaded files and error messages - time in ms, 0 for no disappear
	disappearUploadedFiles: 0,
	disappearErrors: 0
};

fg.Upload.Error = {
	'FILE_COUNT_ERROR': -9001,
	'FILE_QUEUE_COUNT_ERROR': -9002,
	'FILE_ZERO_BYTE_ERROR': -9003
};

$.fn.fgUpload = function (options) {
	var upload = new fg.Upload($(this), options);
	$(this).data('fgUpload', upload);
};

fg.Upload.prototype.init = function (element, options) {
	this.element = element;
	this.queue = [];
	this.alreadyCounted = false;
	this.options = $.extend({}, this.defaults, options);
	this.uploader = new plupload.Uploader(this.options);

	this.browseButton = $('#' + this.options['browse_button']);
	this.startButton = $('#' + this.options['startQueueTarget']);
	this.cancelButton = $('#' + this.options['cancelQueueTarget']);
	this.statusDiv = $('#' + this.options['statusDiv']);
	this.dropElement = $('#' + this.options['drop_element']);

	if (this.options['max_file_count']) {
		this.uploader.bind('FilesAdded', $.proxy(function (up, files) {
			var removed = [],
			    selectedCount = files.length;
			var extraCount = up.files.length + selectedCount - this.options['max_file_count'];
			if (extraCount > 0) {
				removed = files.splice(selectedCount - extraCount, extraCount);
				//remove files from uploader queue
				$.each(removed, $.proxy(function (index, file) {
					this.uploader.removeFile(file);
				}, this));
				up.trigger('Error', {
					code: fg.Upload.Error.FILE_COUNT_ERROR,
					message: 'File count error.',
					file: removed
				});
			}
		}, this));
	}
	this.uploader.bind('Init', $.proxy(this.onInit, this));
	this.uploader.bind('Error', $.proxy(this.onError, this));

	this.uploader.init();

	this.uploader.bind('FilesAdded', $.proxy(this.onFilesAdded, this));
	this.uploader.bind('QueueChanged', $.proxy(this.onQueueChanged, this));
	this.uploader.bind('StateChanged', $.proxy(this.onStateChanged, this));
	this.uploader.bind('BeforeUpload', $.proxy(this.onBeforeUpload, this));
	this.uploader.bind('UploadFile', $.proxy(this.onUploadFile, this));
	this.uploader.bind('UploadProgress', $.proxy(this.onUploadProgress, this));
	this.uploader.bind('FileUploaded', $.proxy(this.onFileUploaded, this));
	this.uploader.bind('UploadComplete', $.proxy(this.onUploadComplete, this));
};

fg.Upload.prototype.onInit = function (up, res) {
	if (up.features.dragdrop && this.options['dragdrop']) {
		this.dropElement.show();
		this.dropElement.bind('dragenter', $.proxy(function (e) {
			this.dropElement.addClass('hover');
		}, this));
		this.dropElement.bind('dragleave drop', $.proxy(function (e) {
			this.dropElement.removeClass('hover');
		}, this));
	} else {
		this.dropElement.hide();
	}
};

fg.Upload.prototype.onFilesAdded = function (up, files) {
	if (this.options['max_file_queue_count']) {
		var removed = [],
		    selectedCount = files.length;
		if (selectedCount > this.options['max_file_queue_count']) {
			//remove files from uploader queue
			$.each(files, $.proxy(function (index, file) {
				this.uploader.removeFile(file);
			}, this));
			up.trigger('Error', {
				code: fg.Upload.Error.FILE_QUEUE_COUNT_ERROR,
				file: removed
			});
			files = [];
			return;
		}
	}

	$.each(files, $.proxy(function (index, file) {
		if (file.size == 0) {
			this.uploader.removeFile(file);
			up.trigger('Error', {
				code: fg.Upload.Error.FILE_ZERO_BYTE_ERROR,
				file: file,
				message: 'Zero byte file error.'
			});
		}
		if (file.status !== plupload.FAILED) {
			var progress = new RamJetFileProgress(file, this.options['progressTarget'], this.options['progressWidth']);
			progress.setStatus(this.options['labelInQueue']);
			progress.toggleCancel(true, this);

			this.queue[file.id] = {
				'progress': progress
			};
		}
	}, this));

	if (this.options['autoStart']) {
		// set a little delay to make sure that QueueChanged triggered by the core has time to complete
		setTimeout($.proxy(function () {
			this.uploader.start();
		}, this), 10);
	}

	this.startButton.removeAttr('disabled').bind('click', $.proxy(function () {
		this.uploader.start();
		return false;
	}, this));
};

fg.Upload.prototype.onQueueChanged = function (up) {
	this.refreshQueueCount(up);
	this.uploadGuardedForm(up);
};

fg.Upload.prototype.onStateChanged = function (up) {
	if (up.state === plupload.STARTED) {
		this.cancelButton.show();
		this.startButton.hide();
		this.browseButton.attr('disabled', 'disabled').addClass('disabled');
		this.cancelButton.bind('click', $.proxy(function () {
			this.uploader.stop();
		}, this));
	} else {
		this.cancelButton.hide();
		this.startButton.show();
		this.browseButton.removeAttr('disabled').removeClass('disabled');
	}
};

fg.Upload.prototype.onBeforeUpload = function (up, file) {
	var progress = this.queue[file.id]['progress'];
	progress.setStatus(this.options['labelUploading']);
	progress.toggleCancel(true, this);
};

fg.Upload.prototype.onUploadFile = function (up, file) {};

fg.Upload.prototype.onUploadProgress = function (up, file) {
	var progress = this.queue[file.id]['progress'];
	var percent = file.percent;
	progress.setProgress(percent);
	progress.setStatus(this.options['labelUploading']);
};

fg.Upload.prototype.onFileUploaded = function (up, file, response) {
	var progress = this.queue[file.id]['progress'];
	progress.setComplete(this.options['disappearUploadedFiles']);
	progress.setStatus(this.options['labelComplete']);
	progress.toggleCancel(false);
};

fg.Upload.prototype.onUploadComplete = function (up, params) {
	this.startButton.attr('disabled', 'disabled');
	this.refreshUploadCount(up);
	this.uploadGuardedForm(up);
};

fg.Upload.prototype.cancelUpload = function (fileId) {
	var file = this.uploader.getFile(fileId);
	this.uploader.removeFile(file);
	var progress = this.queue[fileId]['progress'];
	progress.setCancelled(100);
};

fg.Upload.prototype.onError = function (up, error) {
	var message = error.message || '';
	var file = error.file;

	if (file !== undefined) {
		var progress = new RamJetFileProgress(file, this.options['progressTarget'], this.options['progressWidth']);
		progress.setError(this.options['disappearErrors']);
	}

	var map = {
		'&': '&amp;',
		'<': '&lt;',
		'>': '&gt;',
		'"': '&quot;',
		"'": '&#x27;',
		"/": '&#x2F;'
	};
	var reg = /[&<>"'/]/ig;
	var fileName = file.name.replace(reg, function (match) {
		return map[match];
	});

	switch (error.code) {
		case plupload.INIT_ERROR:
			this.destroy();
			break;
		case plupload.FILE_SIZE_ERROR:
			progress.setStatus(this.options['labelErrorFileTooBig']);
			message = "Error Code: FILE_SIZE_ERROR, File name: " + fileName + ", File size: " + file.size + ", Message: " + message;
			break;
		case plupload.FILE_EXTENSION_ERROR:
			progress.setStatus(this.options['labelErrorInvalidFileType']);
			message = "Error Code: FILE_EXTENSION_ERROR, File name: " + fileName + ", File size: " + file.size + ", Message: " + message;
			break;
		case plupload.HTTP_ERROR:
			progress.setStatus(this.options['labelErrorUploadError'] + " (" + message + ")");
			message = "Error Code: HTTP_ERROR, File name: " + fileName + ", Message: " + message;
			break;
		case fg.Upload.Error.FILE_COUNT_ERROR:
			progress.setStatus(this.options['labelErrorUploadLimit']);
			progress.setLabel(this.options['labelStopped']);
			message = "Error Code: FILE_COUNT_ERROR, Max file count: " + this.options['max_file_count'] + ", Message: " + message;
			break;
		case fg.Upload.Error.FILE_QUEUE_COUNT_ERROR:
			progress.setStatus(this.options['labelErrorQueueLimit']);
			progress.setLabel(this.options['labelStopped']);
			message = "Error Code: FILE_QUEUE_COUNT_ERROR, Max file count for queue: " + this.options['max_file_queue_count'] + ", Message: " + message;
			break;
		case fg.Upload.Error.FILE_ZERO_BYTE_ERROR:
			progress.setStatus(this.options['labelErrorZeroLength']);
			message = "Error Code: FILE_ZERO_BYTE_ERROR, File name: " + fileName + ", File size: " + file.size + ", Message: " + message;
			break;
		default:
			if (file !== null) {
				progress.setStatus(this.options['labelErrorUploadError']);
			}
			message = "Error Code: " + error.code + ", File name: " + fileName + ", File size: " + file.size + ", Message: " + message;
			break;
	}
	this.debug(message);
};

fg.Upload.prototype.refreshQueueCount = function (up) {
	var filesInQueue = up.total.queued;

	this.statusDiv.html(this.options.labelFileQueued.replace("{0}", filesInQueue));
	if (filesInQueue == 0) {
		this.refreshUploadCount(up);
	}
};

fg.Upload.prototype.refreshUploadCount = function (up) {
	this.statusDiv.html(this.options.labelQueueCompleted.replace("{0}", up.total.uploaded));
};

fg.Upload.prototype.destroy = function () {
	// unbind all button events
	this.startButton.unbind();
	this.cancelButton.unbind();
	// destroy uploader instance
	this.uploader.destroy();
	this.element.hide();
	// show alternative content
	$('#' + this.element.attr('id').replace('__container', '__noscript_container')).show();
};

fg.Upload.prototype.SubmitForm = function (envelopingForm) {
	var envelopingFormCls = envelopingForm;

	this.monitorSubmit = function (event) {
		var pluploads = envelopingFormCls.data().pluploads;
		for (var i = 0; i < pluploads.length; i++) {
			if (!(pluploads[i].state === plupload.STARTED)) {
				pluploads[i].start();
			}
		}
		envelopingFormCls.data("formSubmitRequested", event.target);
		//disable all the submit buttons in the form
		var submitsCls = envelopingFormCls.find("input[type=submit]");
		submitsCls.filter("[disabled!=disabled]").addClass("disabledByPlupload").attr("disabled", "disabled");
		return false;
	};
	this.unbind = function () {
		var existingGuard = envelopingFormCls.data().uploadGuardedForm;
		var submitsCls = envelopingFormCls.find("input[type=submit]");
		envelopingFormCls.unbind("submit", existingGuard.monitorSubmit);
		submitsCls.unbind("click", existingGuard.monitorSubmit);
		submitsCls.filter(".disabledByPlupload").removeClass("disabledByPlupload").removeAttr("disabled");
	};
	this.bind = function () {
		envelopingFormCls.bind("submit", $.proxy(this.monitorSubmit, this));
		//disable all the submit buttons in the form
		var submitsCls = envelopingFormCls.find("input[type=submit]");
		submitsCls.bind("click", this.monitorSubmit);
	};
	this.addPluploadToMonitor = function (plupload) {
		envelopingFormCls.data().pluploads.push(plupload);
	};
	this.removePluploadToMonitor = function (plupload) {
		envelopingFormCls.data().pluploads.pop();
	};
	this.hasAnyPluploads = function () {
		return envelopingFormCls.data().pluploads.length > 0;
	};
};

fg.Upload.prototype.uploadGuardedForm = function (up) {
	var envelopingForm = this.element.parents("form");
	if (envelopingForm.length > 0) {
		var existingGuard = envelopingForm.data().uploadGuardedForm;
		if (up.total.queued > 0) {
			if (existingGuard === undefined || existingGuard === null) {
				//disable submit of the form
				existingGuard = new this.SubmitForm(envelopingForm);
				envelopingForm.data("uploadGuardedForm", existingGuard);
				envelopingForm.data("pluploads", new Array());
				envelopingForm.data("formSubmitRequested", null);
				existingGuard.bind();
				if (this.alreadyCounted !== true) {
					existingGuard.addPluploadToMonitor(up);
					this.alreadyCounted = true;
				}
			} else {
				if (this.alreadyCounted !== true) {
					existingGuard.addPluploadToMonitor(up);
					this.alreadyCounted = true;
				}
			}
		} else {
			if (existingGuard !== undefined || existingGuard !== null) {
				existingGuard.removePluploadToMonitor(up);
				if (!existingGuard.hasAnyPluploads()) {
					//enable submit of the form again
					existingGuard.unbind();
					if (envelopingForm.data().formSubmitRequested !== null) {
						var fsr = envelopingForm.data().formSubmitRequested;
						envelopingForm.data("uploadGuardedForm", null);
						envelopingForm.data("pluploads", null);
						envelopingForm.data("formSubmitRequested", null);
						if (fsr.tagName.toUpperCase() == "INPUT") {
							setTimeout(function () {
								fsr.click();
							}, 2000);
						} else if (fsr.tagName.toUpperCase() == "FORM") {
							setTimeout(function () {
								fsr.submit();
							}, 2000);
						}
					}
				}
			}
		}
	}
};

fg.Upload.prototype.debug = function (message) {
	if (window.console) {
		console.log(message);
	}
};

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*1.5.4*/
(function () {
	var f = 0,
	    l = [],
	    n = {},
	    j = {},
	    a = { "<": "lt", ">": "gt", "&": "amp", '"': "quot", "'": "#39" },
	    m = /[<>&\"\']/g,
	    b,
	    c = window.setTimeout,
	    d = {},
	    e;

	function h() {
		this.returnValue = false;
	}

	function k() {
		this.cancelBubble = true;
	}

	(function (o) {
		var p = o.split(/,/),
		    q,
		    s,
		    r;
		for (q = 0; q < p.length; q += 2) {
			r = p[q + 1].split(/ /);
			for (s = 0; s < r.length; s++) {
				j[r[s]] = p[q];
			}
		}
	})("application/msword,doc dot,application/pdf,pdf,application/pgp-signature,pgp,application/postscript,ps ai eps,application/rtf,rtf,application/vnd.ms-excel,xls xlb,application/vnd.ms-powerpoint,ppt pps pot,application/zip,zip,application/x-shockwave-flash,swf swfl,application/vnd.openxmlformats-officedocument.wordprocessingml.document,docx,application/vnd.openxmlformats-officedocument.wordprocessingml.template,dotx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,xlsx,application/vnd.openxmlformats-officedocument.presentationml.presentation,pptx,application/vnd.openxmlformats-officedocument.presentationml.template,potx,application/vnd.openxmlformats-officedocument.presentationml.slideshow,ppsx,application/x-javascript,js,application/json,json,audio/mpeg,mpga mpega mp2 mp3,audio/x-wav,wav,audio/mp4,m4a,image/bmp,bmp,image/gif,gif,image/jpeg,jpeg jpg jpe,image/photoshop,psd,image/png,png,image/svg+xml,svg svgz,image/tiff,tiff tif,text/plain,asc txt text diff log,text/html,htm html xhtml,text/css,css,text/csv,csv,text/rtf,rtf,video/mpeg,mpeg mpg mpe,video/quicktime,qt mov,video/mp4,mp4,video/x-m4v,m4v,video/x-flv,flv,video/x-ms-wmv,wmv,video/avi,avi,video/webm,webm,video/vnd.rn-realvideo,rv,application/vnd.oasis.opendocument.formula-template,otf,application/octet-stream,exe");
	var g;
	g = { VERSION: "1.5.4", STOPPED: 1, STARTED: 2, QUEUED: 1, UPLOADING: 2, FAILED: 4, DONE: 5, GENERIC_ERROR: -100, HTTP_ERROR: -200, IO_ERROR: -300, SECURITY_ERROR: -400, INIT_ERROR: -500, FILE_SIZE_ERROR: -600, FILE_EXTENSION_ERROR: -601, IMAGE_FORMAT_ERROR: -700, IMAGE_MEMORY_ERROR: -701, IMAGE_DIMENSIONS_ERROR: -702, mimeTypes: j, ua: function () {
			var s = navigator,
			    r = s.userAgent,
			    t = s.vendor,
			    p,
			    o,
			    q;
			p = /WebKit/.test(r);
			q = p && t.indexOf("Apple") !== -1;
			o = window.opera && window.opera.buildNumber;
			return { windows: navigator.platform.indexOf("Win") !== -1, ie: !p && !o && /MSIE/gi.test(r) && /Explorer/gi.test(s.appName), webkit: p, gecko: !p && /Gecko/.test(r), safari: q, opera: !!o };
		}(), typeOf: function typeOf(p) {
			return {}.toString.call(p).match(/\s([a-z|A-Z]+)/)[1].toLowerCase();
		}, extend: function extend(o) {
			g.each(arguments, function (p, q) {
				if (q > 0) {
					g.each(p, function (s, r) {
						o[r] = s;
					});
				}
			});
			return o;
		}, cleanName: function cleanName(o) {
			var p, q;
			q = [/[\300-\306]/g, "A", /[\340-\346]/g, "a", /\307/g, "C", /\347/g, "c", /[\310-\313]/g, "E", /[\350-\353]/g, "e", /[\314-\317]/g, "I", /[\354-\357]/g, "i", /\321/g, "N", /\361/g, "n", /[\322-\330]/g, "O", /[\362-\370]/g, "o", /[\331-\334]/g, "U", /[\371-\374]/g, "u"];
			for (p = 0; p < q.length; p += 2) {
				o = o.replace(q[p], q[p + 1]);
			}
			o = o.replace(/\s+/g, "_");
			o = o.replace(/[^a-z0-9_\-\.]+/gi, "");
			return o;
		}, addRuntime: function addRuntime(o, p) {
			p.name = o;
			l[o] = p;
			l.push(p);
			return p;
		}, guid: function guid() {
			var o = new Date().getTime().toString(32),
			    p;
			for (p = 0; p < 5; p++) {
				o += Math.floor(Math.random() * 65535).toString(32);
			}
			return (g.guidPrefix || "p") + o + (f++).toString(32);
		}, buildUrl: function buildUrl(p, o) {
			var q = "";
			g.each(o, function (s, r) {
				q += (q ? "&" : "") + encodeURIComponent(r) + "=" + encodeURIComponent(s);
			});
			if (q) {
				p += (p.indexOf("?") > 0 ? "&" : "?") + q;
			}
			return p;
		}, each: function each(r, s) {
			var q, p, o;
			if (r) {
				q = r.length;
				if (q === b) {
					for (p in r) {
						if (r.hasOwnProperty(p)) {
							if (s(r[p], p) === false) {
								return;
							}
						}
					}
				} else {
					for (o = 0; o < q; o++) {
						if (s(r[o], o) === false) {
							return;
						}
					}
				}
			}
		}, formatSize: function formatSize(o) {
			if (o === b || /\D/.test(o)) {
				return g.translate("N/A");
			}
			if (o > 1073741824) {
				return Math.round(o / 1073741824, 1) + " GB";
			}
			if (o > 1048576) {
				return Math.round(o / 1048576, 1) + " MB";
			}
			if (o > 1024) {
				return Math.round(o / 1024, 1) + " KB";
			}
			return o + " b";
		}, getPos: function getPos(p, t) {
			var u = 0,
			    s = 0,
			    w,
			    v = document,
			    q,
			    r;
			p = p;
			t = t || v.body;
			function o(C) {
				var A,
				    B,
				    z = 0,
				    D = 0;
				if (C) {
					B = C.getBoundingClientRect();
					A = v.compatMode === "CSS1Compat" ? v.documentElement : v.body;
					z = B.left + A.scrollLeft;
					D = B.top + A.scrollTop;
				}
				return { x: z, y: D };
			}

			if (p && p.getBoundingClientRect && navigator.userAgent.indexOf("MSIE") > 0 && v.documentMode < 8) {
				q = o(p);
				r = o(t);
				return { x: q.x - r.x, y: q.y - r.y };
			}
			w = p;
			while (w && w != t && w.nodeType) {
				u += w.offsetLeft || 0;
				s += w.offsetTop || 0;
				w = w.offsetParent;
			}
			w = p.parentNode;
			while (w && w != t && w.nodeType) {
				u -= w.scrollLeft || 0;
				s -= w.scrollTop || 0;
				w = w.parentNode;
			}
			return { x: u, y: s };
		}, getSize: function getSize(o) {
			return { w: o.offsetWidth || o.clientWidth, h: o.offsetHeight || o.clientHeight };
		}, parseSize: function parseSize(o) {
			var p;
			if (typeof o == "string") {
				o = /^([0-9]+)([mgk]?)$/.exec(o.toLowerCase().replace(/[^0-9mkg]/g, ""));
				p = o[2];
				o = +o[1];
				if (p == "g") {
					o *= 1073741824;
				}
				if (p == "m") {
					o *= 1048576;
				}
				if (p == "k") {
					o *= 1024;
				}
			}
			return o;
		}, xmlEncode: function xmlEncode(o) {
			return o ? ("" + o).replace(m, function (p) {
				return a[p] ? "&" + a[p] + ";" : p;
			}) : o;
		}, toArray: function toArray(q) {
			var p,
			    o = [];
			for (p = 0; p < q.length; p++) {
				o[p] = q[p];
			}
			return o;
		}, inArray: function inArray(q, r) {
			if (r) {
				if (Array.prototype.indexOf) {
					return Array.prototype.indexOf.call(r, q);
				}
				for (var o = 0, p = r.length; o < p; o++) {
					if (r[o] === q) {
						return o;
					}
				}
			}
			return -1;
		}, addI18n: function addI18n(o) {
			return g.extend(n, o);
		}, translate: function translate(o) {
			return n[o] || o;
		}, isEmptyObj: function isEmptyObj(o) {
			if (o === b) {
				return true;
			}
			for (var p in o) {
				return false;
			}
			return true;
		}, hasClass: function hasClass(q, p) {
			var o;
			if (q.className == "") {
				return false;
			}
			o = new RegExp("(^|\\s+)" + p + "(\\s+|$)");
			return o.test(q.className);
		}, addClass: function addClass(p, o) {
			if (!g.hasClass(p, o)) {
				p.className = p.className == "" ? o : p.className.replace(/\s+$/, "") + " " + o;
			}
		}, removeClass: function removeClass(q, p) {
			var o = new RegExp("(^|\\s+)" + p + "(\\s+|$)");
			q.className = q.className.replace(o, function (s, r, t) {
				return r === " " && t === " " ? " " : "";
			});
		}, getStyle: function getStyle(p, o) {
			if (p.currentStyle) {
				return p.currentStyle[o];
			} else {
				if (window.getComputedStyle) {
					return window.getComputedStyle(p, null)[o];
				}
			}
		}, addEvent: function addEvent(t, o, u) {
			var s, r, q, p;
			p = arguments[3];
			o = o.toLowerCase();
			if (e === b) {
				e = "Plupload_" + g.guid();
			}
			if (t.addEventListener) {
				s = u;
				t.addEventListener(o, s, false);
			} else {
				if (t.attachEvent) {
					s = function s() {
						var v = window.event;
						if (!v.target) {
							v.target = v.srcElement;
						}
						v.preventDefault = h;
						v.stopPropagation = k;
						u(v);
					};
					t.attachEvent("on" + o, s);
				}
			}
			if (t[e] === b) {
				t[e] = g.guid();
			}
			if (!d.hasOwnProperty(t[e])) {
				d[t[e]] = {};
			}
			r = d[t[e]];
			if (!r.hasOwnProperty(o)) {
				r[o] = [];
			}
			r[o].push({ func: s, orig: u, key: p });
		}, removeEvent: function removeEvent(t, o) {
			var r, u, q;
			if (typeof arguments[2] == "function") {
				u = arguments[2];
			} else {
				q = arguments[2];
			}
			o = o.toLowerCase();
			if (t[e] && d[t[e]] && d[t[e]][o]) {
				r = d[t[e]][o];
			} else {
				return;
			}
			for (var p = r.length - 1; p >= 0; p--) {
				if (r[p].key === q || r[p].orig === u) {
					if (t.removeEventListener) {
						t.removeEventListener(o, r[p].func, false);
					} else {
						if (t.detachEvent) {
							t.detachEvent("on" + o, r[p].func);
						}
					}
					r[p].orig = null;
					r[p].func = null;
					r.splice(p, 1);
					if (u !== b) {
						break;
					}
				}
			}
			if (!r.length) {
				delete d[t[e]][o];
			}
			if (g.isEmptyObj(d[t[e]])) {
				delete d[t[e]];
				try {
					delete t[e];
				} catch (s) {
					t[e] = b;
				}
			}
		}, removeAllEvents: function removeAllEvents(p) {
			var o = arguments[1];
			if (p[e] === b || !p[e]) {
				return;
			}
			g.each(d[p[e]], function (r, q) {
				g.removeEvent(p, q, o);
			});
		} };
	g.Uploader = function (s) {
		var p = {},
		    v,
		    u = [],
		    r,
		    q = false;
		v = new g.QueueProgress();
		s = g.extend({ chunk_size: 0, multipart: true, multi_selection: true, file_data_name: "file", filters: [] }, s);
		function t() {
			var x,
			    y = 0,
			    w;
			if (this.state == g.STARTED) {
				for (w = 0; w < u.length; w++) {
					if (!x && u[w].status == g.QUEUED) {
						x = u[w];
						x.status = g.UPLOADING;
						if (this.trigger("BeforeUpload", x)) {
							this.trigger("UploadFile", x);
						}
					} else {
						y++;
					}
				}
				if (y == u.length) {
					this.stop();
					this.trigger("UploadComplete", u);
				}
			}
		}

		function o() {
			var x, w;
			v.reset();
			for (x = 0; x < u.length; x++) {
				w = u[x];
				if (w.size !== b) {
					v.size += w.size;
					v.loaded += w.loaded;
				} else {
					v.size = b;
				}
				if (w.status == g.DONE) {
					v.uploaded++;
				} else {
					if (w.status == g.FAILED) {
						v.failed++;
					} else {
						v.queued++;
					}
				}
			}
			if (v.size === b) {
				v.percent = u.length > 0 ? Math.ceil(v.uploaded / u.length * 100) : 0;
			} else {
				v.bytesPerSec = Math.ceil(v.loaded / ((+new Date() - r || 1) / 1000));
				v.percent = v.size > 0 ? Math.ceil(v.loaded / v.size * 100) : 0;
			}
		}

		g.extend(this, { state: g.STOPPED, runtime: "", features: {}, files: u, settings: s, total: v, id: g.guid(), init: function init() {
				var B = this,
				    C,
				    y,
				    x,
				    A = 0,
				    z;
				if (typeof s.preinit == "function") {
					s.preinit(B);
				} else {
					g.each(s.preinit, function (E, D) {
						B.bind(D, E);
					});
				}
				s.page_url = s.page_url || document.location.pathname.replace(/\/[^\/]+$/g, "/");
				if (!/^(\w+:\/\/|\/)/.test(s.url)) {
					s.url = s.page_url + s.url;
				}
				s.chunk_size = g.parseSize(s.chunk_size);
				s.max_file_size = g.parseSize(s.max_file_size);
				B.bind("FilesAdded", function (D, G) {
					var F,
					    E,
					    I = 0,
					    J,
					    H = s.filters;
					if (H && H.length) {
						J = [];
						g.each(H, function (K) {
							g.each(K.extensions.split(/,/), function (L) {
								if (/^\s*\*\s*$/.test(L)) {
									J.push("\\.*");
								} else {
									J.push("\\." + L.replace(new RegExp("[" + "/^$.*+?|()[]{}\\".replace(/./g, "\\$&") + "]", "g"), "\\$&"));
								}
							});
						});
						J = new RegExp(J.join("|") + "$", "i");
					}
					for (F = 0; F < G.length; F++) {
						E = G[F];
						E.loaded = 0;
						E.percent = 0;
						E.status = g.QUEUED;
						if (J && !J.test(E.name)) {
							D.trigger("Error", { code: g.FILE_EXTENSION_ERROR, message: g.translate("File extension error."), file: E });
							continue;
						}
						if (E.size !== b && E.size > s.max_file_size) {
							D.trigger("Error", { code: g.FILE_SIZE_ERROR, message: g.translate("File size error."), file: E });
							continue;
						}
						u.push(E);
						I++;
					}
					if (I) {
						c(function () {
							B.trigger("QueueChanged");
							B.refresh();
						}, 1);
					} else {
						return false;
					}
				});
				if (s.unique_names) {
					B.bind("UploadFile", function (D, E) {
						var G = E.name.match(/\.([^.]+)$/),
						    F = "tmp";
						if (G) {
							F = G[1];
						}
						E.target_name = E.id + "." + F;
					});
				}
				B.bind("UploadProgress", function (D, E) {
					E.percent = E.size > 0 ? Math.ceil(E.loaded / E.size * 100) : 100;
					o();
				});
				B.bind("StateChanged", function (D) {
					if (D.state == g.STARTED) {
						r = +new Date();
					} else {
						if (D.state == g.STOPPED) {
							for (C = D.files.length - 1; C >= 0; C--) {
								if (D.files[C].status == g.UPLOADING) {
									D.files[C].status = g.QUEUED;
									o();
								}
							}
						}
					}
				});
				B.bind("QueueChanged", o);
				B.bind("Error", function (D, E) {
					if (E.file) {
						E.file.status = g.FAILED;
						o();
						if (D.state == g.STARTED) {
							c(function () {
								t.call(B);
							}, 1);
						}
					}
				});
				B.bind("FileUploaded", function (D, E) {
					E.status = g.DONE;
					E.loaded = E.size;
					D.trigger("UploadProgress", E);
					c(function () {
						t.call(B);
					}, 1);
				});
				if (s.runtimes) {
					y = [];
					z = s.runtimes.split(/\s?,\s?/);
					for (C = 0; C < z.length; C++) {
						if (l[z[C]]) {
							y.push(l[z[C]]);
						}
					}
				} else {
					y = l;
				}
				function w() {
					var G = y[A++],
					    F,
					    D,
					    E;
					if (G) {
						F = G.getFeatures();
						D = B.settings.required_features;
						if (D) {
							D = D.split(",");
							for (E = 0; E < D.length; E++) {
								if (!F[D[E]]) {
									w();
									return;
								}
							}
						}
						G.init(B, function (H) {
							if (H && H.success) {
								B.features = F;
								B.runtime = G.name;
								B.trigger("Init", { runtime: G.name });
								B.trigger("PostInit");
								B.refresh();
							} else {
								w();
							}
						});
					} else {
						B.trigger("Error", { code: g.INIT_ERROR, message: g.translate("Init error.") });
					}
				}

				w();
				if (typeof s.init == "function") {
					s.init(B);
				} else {
					g.each(s.init, function (E, D) {
						B.bind(D, E);
					});
				}
			}, refresh: function refresh() {
				this.trigger("Refresh");
			}, start: function start() {
				if (u.length && this.state != g.STARTED) {
					this.state = g.STARTED;
					this.trigger("StateChanged");
					t.call(this);
				}
			}, stop: function stop() {
				if (this.state != g.STOPPED) {
					this.state = g.STOPPED;
					this.trigger("CancelUpload");
					this.trigger("StateChanged");
				}
			}, disableBrowse: function disableBrowse() {
				q = arguments[0] !== b ? arguments[0] : true;
				this.trigger("DisableBrowse", q);
			}, getFile: function getFile(x) {
				var w;
				for (w = u.length - 1; w >= 0; w--) {
					if (u[w].id === x) {
						return u[w];
					}
				}
			}, removeFile: function removeFile(x) {
				var w;
				for (w = u.length - 1; w >= 0; w--) {
					if (u[w].id === x.id) {
						return this.splice(w, 1)[0];
					}
				}
			}, splice: function splice(y, w) {
				var x;
				x = u.splice(y === b ? 0 : y, w === b ? u.length : w);
				this.trigger("FilesRemoved", x);
				this.trigger("QueueChanged");
				return x;
			}, trigger: function trigger(x) {
				var z = p[x.toLowerCase()],
				    y,
				    w;
				if (z) {
					w = Array.prototype.slice.call(arguments);
					w[0] = this;
					for (y = 0; y < z.length; y++) {
						if (z[y].func.apply(z[y].scope, w) === false) {
							return false;
						}
					}
				}
				return true;
			}, hasEventListener: function hasEventListener(w) {
				return !!p[w.toLowerCase()];
			}, bind: function bind(w, y, x) {
				var z;
				w = w.toLowerCase();
				z = p[w] || [];
				z.push({ func: y, scope: x || this });
				p[w] = z;
			}, unbind: function unbind(w) {
				w = w.toLowerCase();
				var z = p[w],
				    x,
				    y = arguments[1];
				if (z) {
					if (y !== b) {
						for (x = z.length - 1; x >= 0; x--) {
							if (z[x].func === y) {
								z.splice(x, 1);
								break;
							}
						}
					} else {
						z = [];
					}
					if (!z.length) {
						delete p[w];
					}
				}
			}, unbindAll: function unbindAll() {
				var w = this;
				g.each(p, function (y, x) {
					w.unbind(x);
				});
			}, destroy: function destroy() {
				this.stop();
				this.trigger("Destroy");
				this.unbindAll();
			} });
	};
	g.File = function (r, p, q) {
		var o = this;
		o.id = r;
		o.name = p;
		o.size = q;
		o.loaded = 0;
		o.percent = 0;
		o.status = 0;
	};
	g.Runtime = function () {
		this.getFeatures = function () {};
		this.init = function (o, p) {};
	};
	g.QueueProgress = function () {
		var o = this;
		o.size = 0;
		o.loaded = 0;
		o.uploaded = 0;
		o.failed = 0;
		o.queued = 0;
		o.percent = 0;
		o.bytesPerSec = 0;
		o.reset = function () {
			o.size = o.loaded = o.uploaded = o.failed = o.queued = o.percent = o.bytesPerSec = 0;
		};
	};
	g.runtimes = {};
	window.plupload = g;
})();
(function () {
	if (window.google && google.gears) {
		return;
	}var a = null;if (typeof GearsFactory != "undefined") {
		a = new GearsFactory();
	} else {
		try {
			a = new ActiveXObject("Gears.Factory");if (a.getBuildInfo().indexOf("ie_mobile") != -1) {
				a.privateSetGlobalObject(this);
			}
		} catch (b) {
			if (typeof navigator.mimeTypes != "undefined" && navigator.mimeTypes["application/x-googlegears"]) {
				a = document.createElement("object");a.style.display = "none";a.width = 0;a.height = 0;a.type = "application/x-googlegears";document.documentElement.appendChild(a);
			}
		}
	}if (!a) {
		return;
	}if (!window.google) {
		window.google = {};
	}if (!google.gears) {
		google.gears = { factory: a };
	}
})();(function (e, b, c, d) {
	var f = {};function a(h, k, m) {
		var g, j, l, o;j = google.gears.factory.create("beta.canvas");try {
			j.decode(h);if (!k.width) {
				k.width = j.width;
			}if (!k.height) {
				k.height = j.height;
			}o = Math.min(width / j.width, height / j.height);if (o < 1 || o === 1 && m === "image/jpeg") {
				j.resize(Math.round(j.width * o), Math.round(j.height * o));if (k.quality) {
					return j.encode(m, { quality: k.quality / 100 });
				}return j.encode(m);
			}
		} catch (n) {}return h;
	}c.runtimes.Gears = c.addRuntime("gears", { getFeatures: function getFeatures() {
			return { dragdrop: true, jpgresize: true, pngresize: true, chunks: true, progress: true, multipart: true, multi_selection: true };
		}, init: function init(l, n) {
			var m,
			    h,
			    g = false;if (!e.google || !google.gears) {
				return n({ success: false });
			}try {
				m = google.gears.factory.create("beta.desktop");
			} catch (k) {
				return n({ success: false });
			}function j(q) {
				var p,
				    o,
				    r = [],
				    s;for (o = 0; o < q.length; o++) {
					p = q[o];s = c.guid();f[s] = p.blob;r.push(new c.File(s, p.name, p.blob.length));
				}l.trigger("FilesAdded", r);
			}l.bind("PostInit", function () {
				var p = l.settings,
				    o = b.getElementById(p.drop_element);if (o) {
					c.addEvent(o, "dragover", function (q) {
						m.setDropEffect(q, "copy");q.preventDefault();
					}, l.id);c.addEvent(o, "drop", function (r) {
						var q = m.getDragData(r, "application/x-gears-files");if (q) {
							j(q.files);
						}r.preventDefault();
					}, l.id);o = 0;
				}c.addEvent(b.getElementById(p.browse_button), "click", function (u) {
					var t = [],
					    r,
					    q,
					    s;u.preventDefault();if (g) {
						return;
					}no_type_restriction: for (r = 0; r < p.filters.length; r++) {
						s = p.filters[r].extensions.split(",");for (q = 0; q < s.length; q++) {
							if (s[q] === "*") {
								t = [];break no_type_restriction;
							}t.push("." + s[q]);
						}
					}m.openFiles(j, { singleFile: !p.multi_selection, filter: t });
				}, l.id);
			});l.bind("CancelUpload", function () {
				if (h.abort) {
					h.abort();
				}
			});l.bind("UploadFile", function (u, r) {
				var w = 0,
				    v,
				    s,
				    t = 0,
				    q = u.settings.resize,
				    o;if (q && /\.(png|jpg|jpeg)$/i.test(r.name)) {
					f[r.id] = a(f[r.id], q, /\.png$/i.test(r.name) ? "image/png" : "image/jpeg");
				}r.size = f[r.id].length;s = u.settings.chunk_size;o = s > 0;v = Math.ceil(r.size / s);if (!o) {
					s = r.size;v = 1;
				}function p() {
					var C,
					    y = u.settings.multipart,
					    x = 0,
					    B = { name: r.target_name || r.name },
					    z = u.settings.url;function A(E) {
						var D,
						    J = "----pluploadboundary" + c.guid(),
						    G = "--",
						    I = "\r\n",
						    F,
						    H;if (y) {
							h.setRequestHeader("Content-Type", "multipart/form-data; boundary=" + J);D = google.gears.factory.create("beta.blobbuilder");c.each(c.extend(B, u.settings.multipart_params), function (L, K) {
								D.append(G + J + I + 'Content-Disposition: form-data; name="' + K + '"' + I + I);D.append(L + I);
							});H = c.mimeTypes[r.name.replace(/^.+\.([^.]+)/, "$1").toLowerCase()] || "application/octet-stream";D.append(G + J + I + 'Content-Disposition: form-data; name="' + u.settings.file_data_name + '"; filename="' + r.name + '"' + I + "Content-Type: " + H + I + I);D.append(E);D.append(I + G + J + G + I);F = D.getAsBlob();x = F.length - E.length;E = F;
						}h.send(E);
					}if (r.status == c.DONE || r.status == c.FAILED || u.state == c.STOPPED) {
						return;
					}if (o) {
						B.chunk = w;B.chunks = v;
					}C = Math.min(s, r.size - w * s);if (!y) {
						z = c.buildUrl(u.settings.url, B);
					}h = google.gears.factory.create("beta.httprequest");h.open("POST", z);if (!y) {
						h.setRequestHeader("Content-Disposition", 'attachment; filename="' + r.name + '"');h.setRequestHeader("Content-Type", "application/octet-stream");
					}c.each(u.settings.headers, function (E, D) {
						h.setRequestHeader(D, E);
					});h.upload.onprogress = function (D) {
						r.loaded = t + D.loaded - x;u.trigger("UploadProgress", r);
					};h.onreadystatechange = function () {
						var D;if (h.readyState == 4 && u.state !== c.STOPPED) {
							if (h.status == 200) {
								D = { chunk: w, chunks: v, response: h.responseText, status: h.status };u.trigger("ChunkUploaded", r, D);if (D.cancelled) {
									r.status = c.FAILED;return;
								}t += C;if (++w >= v) {
									r.status = c.DONE;u.trigger("FileUploaded", r, { response: h.responseText, status: h.status });
								} else {
									p();
								}
							} else {
								u.trigger("Error", { code: c.HTTP_ERROR, message: c.translate("HTTP Error."), file: r, chunk: w, chunks: v, status: h.status });
							}
						}
					};if (w < v) {
						A(f[r.id].slice(w * s, C));
					}
				}p();
			});l.bind("DisableBrowse", function (o, p) {
				g = p;
			});l.bind("Destroy", function (o) {
				var p,
				    q,
				    r = { browseButton: o.settings.browse_button, dropElm: o.settings.drop_element };for (p in r) {
					q = b.getElementById(r[p]);if (q) {
						c.removeAllEvents(q, o.id);
					}
				}
			});n({ success: true });
		} });
})(window, document, plupload);(function (g, b, d, e) {
	var a = {},
	    h = {};function c(o) {
		var n,
		    m = typeof o === "undefined" ? "undefined" : _typeof(o),
		    j,
		    l,
		    k;if (o === e || o === null) {
			return "null";
		}if (m === "string") {
			n = "\bb\tt\nn\ff\rr\"\"''\\\\";return '"' + o.replace(/([\u0080-\uFFFF\x00-\x1f\"])/g, function (r, q) {
				var p = n.indexOf(q);if (p + 1) {
					return "\\" + n.charAt(p + 1);
				}r = q.charCodeAt().toString(16);return "\\u" + "0000".substring(r.length) + r;
			}) + '"';
		}if (m == "object") {
			j = o.length !== e;n = "";if (j) {
				for (l = 0; l < o.length; l++) {
					if (n) {
						n += ",";
					}n += c(o[l]);
				}n = "[" + n + "]";
			} else {
				for (k in o) {
					if (o.hasOwnProperty(k)) {
						if (n) {
							n += ",";
						}n += c(k) + ":" + c(o[k]);
					}
				}n = "{" + n + "}";
			}return n;
		}return "" + o;
	}function f(s) {
		var v = false,
		    j = null,
		    o = null,
		    k,
		    l,
		    m,
		    u,
		    n,
		    q = 0;try {
			try {
				o = new ActiveXObject("AgControl.AgControl");if (o.IsVersionSupported(s)) {
					v = true;
				}o = null;
			} catch (r) {
				var p = navigator.plugins["Silverlight Plug-In"];if (p) {
					k = p.description;if (k === "1.0.30226.2") {
						k = "2.0.30226.2";
					}l = k.split(".");while (l.length > 3) {
						l.pop();
					}while (l.length < 4) {
						l.push(0);
					}m = s.split(".");while (m.length > 4) {
						m.pop();
					}do {
						u = parseInt(m[q], 10);n = parseInt(l[q], 10);q++;
					} while (q < m.length && u === n);if (u <= n && !isNaN(u)) {
						v = true;
					}
				}
			}
		} catch (t) {
			v = false;
		}return v;
	}d.silverlight = { trigger: function trigger(n, k) {
			var m = a[n],
			    l,
			    j;if (m) {
				j = d.toArray(arguments).slice(1);j[0] = "Silverlight:" + k;setTimeout(function () {
					m.trigger.apply(m, j);
				}, 0);
			}
		} };d.runtimes.Silverlight = d.addRuntime("silverlight", { getFeatures: function getFeatures() {
			return { jpgresize: true, pngresize: true, chunks: true, progress: true, multipart: true, multi_selection: true };
		}, init: function init(p, q) {
			var o,
			    m = "",
			    n = p.settings.filters,
			    l,
			    k = b.body;if (!f("2.0.31005.0") || g.opera && g.opera.buildNumber) {
				q({ success: false });return;
			}h[p.id] = false;a[p.id] = p;o = b.createElement("div");o.id = p.id + "_silverlight_container";d.extend(o.style, { position: "absolute", top: "0px", background: p.settings.shim_bgcolor || "transparent", zIndex: 99999, width: "100px", height: "100px", overflow: "hidden", opacity: p.settings.shim_bgcolor || b.documentMode > 8 ? "" : 0.01 });o.className = "plupload silverlight";if (p.settings.container) {
				k = b.getElementById(p.settings.container);if (d.getStyle(k, "position") === "static") {
					k.style.position = "relative";
				}
			}k.appendChild(o);for (l = 0; l < n.length; l++) {
				m += (m != "" ? "|" : "") + n[l].title + " | *." + n[l].extensions.replace(/,/g, ";*.");
			}o.innerHTML = '<object id="' + p.id + '_silverlight" data="data:application/x-silverlight," type="application/x-silverlight-2" style="outline:none;" width="1024" height="1024"><param name="source" value="' + p.settings.silverlight_xap_url + '"/><param name="background" value="Transparent"/><param name="windowless" value="true"/><param name="enablehtmlaccess" value="true"/><param name="initParams" value="id=' + p.id + ",filter=" + m + ",multiselect=" + p.settings.multi_selection + '"/></object>';function j() {
				return b.getElementById(p.id + "_silverlight").content.Upload;
			}p.bind("Silverlight:Init", function () {
				var r,
				    s = {};if (h[p.id]) {
					return;
				}h[p.id] = true;p.bind("Silverlight:StartSelectFiles", function (t) {
					r = [];
				});p.bind("Silverlight:SelectFile", function (t, w, u, v) {
					var x;x = d.guid();s[x] = w;s[w] = x;r.push(new d.File(x, u, v));
				});p.bind("Silverlight:SelectSuccessful", function () {
					if (r.length) {
						p.trigger("FilesAdded", r);
					}
				});p.bind("Silverlight:UploadChunkError", function (t, w, u, x, v) {
					p.trigger("Error", { code: d.IO_ERROR, message: "IO Error.", details: v, file: t.getFile(s[w]) });
				});p.bind("Silverlight:UploadFileProgress", function (t, x, u, w) {
					var v = t.getFile(s[x]);if (v.status != d.FAILED) {
						v.size = w;v.loaded = u;t.trigger("UploadProgress", v);
					}
				});p.bind("Refresh", function (t) {
					var u, v, w;u = b.getElementById(t.settings.browse_button);if (u) {
						v = d.getPos(u, b.getElementById(t.settings.container));w = d.getSize(u);d.extend(b.getElementById(t.id + "_silverlight_container").style, { top: v.y + "px", left: v.x + "px", width: w.w + "px", height: w.h + "px" });
					}
				});p.bind("Silverlight:UploadChunkSuccessful", function (t, w, u, z, y) {
					var x,
					    v = t.getFile(s[w]);x = { chunk: u, chunks: z, response: y };t.trigger("ChunkUploaded", v, x);if (v.status != d.FAILED && t.state !== d.STOPPED) {
						j().UploadNextChunk();
					}if (u == z - 1) {
						v.status = d.DONE;t.trigger("FileUploaded", v, { response: y });
					}
				});p.bind("Silverlight:UploadSuccessful", function (t, w, u) {
					var v = t.getFile(s[w]);v.status = d.DONE;t.trigger("FileUploaded", v, { response: u });
				});p.bind("FilesRemoved", function (t, v) {
					var u;for (u = 0; u < v.length; u++) {
						j().RemoveFile(s[v[u].id]);
					}
				});p.bind("UploadFile", function (t, v) {
					var w = t.settings,
					    u = w.resize || {};j().UploadFile(s[v.id], t.settings.url, c({ name: v.target_name || v.name, mime: d.mimeTypes[v.name.replace(/^.+\.([^.]+)/, "$1").toLowerCase()] || "application/octet-stream", chunk_size: w.chunk_size, image_width: u.width, image_height: u.height, image_quality: u.quality || 90, multipart: !!w.multipart, multipart_params: w.multipart_params || {}, file_data_name: w.file_data_name, headers: w.headers }));
				});p.bind("CancelUpload", function () {
					j().CancelUpload();
				});p.bind("Silverlight:MouseEnter", function (t) {
					var u, v;u = b.getElementById(p.settings.browse_button);v = t.settings.browse_button_hover;if (u && v) {
						d.addClass(u, v);
					}
				});p.bind("Silverlight:MouseLeave", function (t) {
					var u, v;u = b.getElementById(p.settings.browse_button);v = t.settings.browse_button_hover;if (u && v) {
						d.removeClass(u, v);
					}
				});p.bind("Silverlight:MouseLeftButtonDown", function (t) {
					var u, v;u = b.getElementById(p.settings.browse_button);v = t.settings.browse_button_active;if (u && v) {
						d.addClass(u, v);d.addEvent(b.body, "mouseup", function () {
							d.removeClass(u, v);
						});
					}
				});p.bind("Sliverlight:StartSelectFiles", function (t) {
					var u, v;u = b.getElementById(p.settings.browse_button);v = t.settings.browse_button_active;if (u && v) {
						d.removeClass(u, v);
					}
				});p.bind("DisableBrowse", function (t, u) {
					j().DisableBrowse(u);
				});p.bind("Destroy", function (t) {
					var u;d.removeAllEvents(b.body, t.id);delete h[t.id];delete a[t.id];u = b.getElementById(t.id + "_silverlight_container");if (u) {
						k.removeChild(u);
					}
				});q({ success: true });
			});
		} });
})(window, document, plupload);(function (f, b, d, e) {
	var a = {},
	    g = {};function c() {
		var h;try {
			h = navigator.plugins["Shockwave Flash"];h = h.description;
		} catch (k) {
			try {
				h = new ActiveXObject("ShockwaveFlash.ShockwaveFlash").GetVariable("$version");
			} catch (j) {
				h = "0.0";
			}
		}h = h.match(/\d+/g);return parseFloat(h[0] + "." + h[1]);
	}d.flash = { trigger: function trigger(k, h, j) {
			setTimeout(function () {
				var n = a[k],
				    m,
				    l;if (n) {
					n.trigger("Flash:" + h, j);
				}
			}, 0);
		} };d.runtimes.Flash = d.addRuntime("flash", { getFeatures: function getFeatures() {
			return { jpgresize: true, pngresize: true, maxWidth: 8091, maxHeight: 8091, chunks: true, progress: true, multipart: true, multi_selection: true };
		}, init: function init(n, p) {
			var l,
			    m,
			    h = 0,
			    j = b.body;if (c() < 10) {
				p({ success: false });return;
			}g[n.id] = false;a[n.id] = n;l = b.getElementById(n.settings.browse_button);m = b.createElement("div");m.id = n.id + "_flash_container";d.extend(m.style, { position: "absolute", top: "0px", background: n.settings.shim_bgcolor || "transparent", zIndex: 99999, width: "100%", height: "100%" });m.className = "plupload flash";if (n.settings.container) {
				j = b.getElementById(n.settings.container);if (d.getStyle(j, "position") === "static") {
					j.style.position = "relative";
				}
			}j.appendChild(m);(function () {
				var q, r;q = '<object id="' + n.id + '_flash" type="application/x-shockwave-flash" data="' + n.settings.flash_swf_url + '" ';if (d.ua.ie) {
					q += 'classid="clsid:d27cdb6e-ae6d-11cf-96b8-444553540000" ';
				}q += 'width="100%" height="100%" style="outline:0"><param name="movie" value="' + n.settings.flash_swf_url + '" /><param name="flashvars" value="id=' + escape(n.id) + '" /><param name="wmode" value="transparent" /><param name="allowscriptaccess" value="always" /></object>';if (d.ua.ie) {
					r = b.createElement("div");m.appendChild(r);r.outerHTML = q;r = null;
				} else {
					m.innerHTML = q;
				}
			})();function o() {
				return b.getElementById(n.id + "_flash");
			}function k() {
				if (h++ > 5000) {
					p({ success: false });return;
				}if (g[n.id] === false) {
					setTimeout(k, 1);
				}
			}k();l = m = null;n.bind("Destroy", function (q) {
				var r;d.removeAllEvents(b.body, q.id);delete g[q.id];delete a[q.id];r = b.getElementById(q.id + "_flash_container");if (r) {
					j.removeChild(r);
				}
			});n.bind("Flash:Init", function () {
				var s = {},
				    r;try {
					o().setFileFilters(n.settings.filters, n.settings.multi_selection);
				} catch (q) {
					p({ success: false });return;
				}if (g[n.id]) {
					return;
				}g[n.id] = true;n.bind("UploadFile", function (t, v) {
					var w = t.settings,
					    u = n.settings.resize || {};o().uploadFile(s[v.id], w.url, { name: v.target_name || v.name, mime: d.mimeTypes[v.name.replace(/^.+\.([^.]+)/, "$1").toLowerCase()] || "application/octet-stream", chunk_size: w.chunk_size, width: u.width, height: u.height, quality: u.quality, multipart: w.multipart, multipart_params: w.multipart_params || {}, file_data_name: w.file_data_name, format: /\.(jpg|jpeg)$/i.test(v.name) ? "jpg" : "png", headers: w.headers, urlstream_upload: w.urlstream_upload });
				});n.bind("CancelUpload", function () {
					o().cancelUpload();
				});n.bind("Flash:UploadProcess", function (u, t) {
					var v = u.getFile(s[t.id]);if (v.status != d.FAILED) {
						v.loaded = t.loaded;v.size = t.size;u.trigger("UploadProgress", v);
					}
				});n.bind("Flash:UploadChunkComplete", function (t, v) {
					var w,
					    u = t.getFile(s[v.id]);w = { chunk: v.chunk, chunks: v.chunks, response: v.text };t.trigger("ChunkUploaded", u, w);if (u.status !== d.FAILED && t.state !== d.STOPPED) {
						o().uploadNextChunk();
					}if (v.chunk == v.chunks - 1) {
						u.status = d.DONE;t.trigger("FileUploaded", u, { response: v.text });
					}
				});n.bind("Flash:SelectFiles", function (t, w) {
					var v,
					    u,
					    x = [],
					    y;for (u = 0; u < w.length; u++) {
						v = w[u];y = d.guid();s[y] = v.id;s[v.id] = y;x.push(new d.File(y, v.name, v.size));
					}if (x.length) {
						n.trigger("FilesAdded", x);
					}
				});n.bind("Flash:SecurityError", function (t, u) {
					n.trigger("Error", { code: d.SECURITY_ERROR, message: d.translate("Security error."), details: u.message, file: n.getFile(s[u.id]) });
				});n.bind("Flash:GenericError", function (t, u) {
					n.trigger("Error", { code: d.GENERIC_ERROR, message: d.translate("Generic error."), details: u.message, file: n.getFile(s[u.id]) });
				});n.bind("Flash:IOError", function (t, u) {
					n.trigger("Error", { code: d.IO_ERROR, message: d.translate("IO error."), details: u.message, file: n.getFile(s[u.id]) });
				});n.bind("Flash:ImageError", function (t, u) {
					n.trigger("Error", { code: parseInt(u.code, 10), message: d.translate("Image error."), file: n.getFile(s[u.id]) });
				});n.bind("Flash:StageEvent:rollOver", function (t) {
					var u, v;u = b.getElementById(n.settings.browse_button);v = t.settings.browse_button_hover;if (u && v) {
						d.addClass(u, v);
					}
				});n.bind("Flash:StageEvent:rollOut", function (t) {
					var u, v;u = b.getElementById(n.settings.browse_button);v = t.settings.browse_button_hover;if (u && v) {
						d.removeClass(u, v);
					}
				});n.bind("Flash:StageEvent:mouseDown", function (t) {
					var u, v;u = b.getElementById(n.settings.browse_button);v = t.settings.browse_button_active;if (u && v) {
						d.addClass(u, v);d.addEvent(b.body, "mouseup", function () {
							d.removeClass(u, v);
						}, t.id);
					}
				});n.bind("Flash:StageEvent:mouseUp", function (t) {
					var u, v;u = b.getElementById(n.settings.browse_button);v = t.settings.browse_button_active;if (u && v) {
						d.removeClass(u, v);
					}
				});n.bind("Flash:ExifData", function (t, u) {
					n.trigger("ExifData", n.getFile(s[u.id]), u.data);
				});n.bind("Flash:GpsData", function (t, u) {
					n.trigger("GpsData", n.getFile(s[u.id]), u.data);
				});n.bind("QueueChanged", function (t) {
					n.refresh();
				});n.bind("FilesRemoved", function (t, v) {
					var u;for (u = 0; u < v.length; u++) {
						o().removeFile(s[v[u].id]);
					}
				});n.bind("StateChanged", function (t) {
					n.refresh();
				});n.bind("Refresh", function (t) {
					var u, v, w;o().setFileFilters(n.settings.filters, n.settings.multi_selection);u = b.getElementById(t.settings.browse_button);if (u) {
						v = d.getPos(u, b.getElementById(t.settings.container));w = d.getSize(u);d.extend(b.getElementById(t.id + "_flash_container").style, { top: v.y + "px", left: v.x + "px", width: w.w + "px", height: w.h + "px" });
					}
				});n.bind("DisableBrowse", function (t, u) {
					o().disableBrowse(u);
				});p({ success: true });
			});
		} });
})(window, document, plupload);(function (a) {
	a.runtimes.BrowserPlus = a.addRuntime("browserplus", { getFeatures: function getFeatures() {
			return { dragdrop: true, jpgresize: true, pngresize: true, chunks: true, progress: true, multipart: true, multi_selection: true };
		}, init: function init(g, j) {
			var e = window.BrowserPlus,
			    h = {},
			    d = g.settings,
			    c = d.resize;function f(o) {
				var n,
				    m,
				    k = [],
				    l,
				    p;for (m = 0; m < o.length; m++) {
					l = o[m];p = a.guid();h[p] = l;k.push(new a.File(p, l.name, l.size));
				}if (m) {
					g.trigger("FilesAdded", k);
				}
			}function b() {
				var k = false;g.bind("PostInit", function () {
					var o,
					    m = d.drop_element,
					    q = g.id + "_droptarget",
					    l = document.getElementById(m),
					    n;function r(t, s) {
						e.DragAndDrop.AddDropTarget({ id: t }, function (u) {
							e.DragAndDrop.AttachCallbacks({ id: t, hover: function hover(v) {
									if (!v && s) {
										s();
									}
								}, drop: function drop(v) {
									if (s) {
										s();
									}f(v);
								} }, function () {});
						});
					}function p() {
						document.getElementById(q).style.top = "-1000px";
					}if (l) {
						if (document.attachEvent && /MSIE/gi.test(navigator.userAgent)) {
							o = document.createElement("div");o.setAttribute("id", q);a.extend(o.style, { position: "absolute", top: "-1000px", background: "red", filter: "alpha(opacity=0)", opacity: 0 });document.body.appendChild(o);a.addEvent(l, "dragenter", function (t) {
								var s, u;s = document.getElementById(m);u = a.getPos(s);a.extend(document.getElementById(q).style, { top: u.y + "px", left: u.x + "px", width: s.offsetWidth + "px", height: s.offsetHeight + "px" });
							});r(q, p);
						} else {
							r(m);
						}
					}a.addEvent(document.getElementById(d.browse_button), "click", function (y) {
						var s = [],
						    u,
						    t,
						    x = d.filters,
						    w,
						    v;y.preventDefault();if (k) {
							return;
						}no_type_restriction: for (u = 0; u < x.length; u++) {
							w = x[u].extensions.split(",");for (t = 0; t < w.length; t++) {
								if (w[t] === "*") {
									s = [];break no_type_restriction;
								}v = a.mimeTypes[w[t]];if (v && a.inArray(v, s) === -1) {
									s.push(a.mimeTypes[w[t]]);
								}
							}
						}e.FileBrowse.OpenBrowseDialog({ mimeTypes: s }, function (z) {
							if (z.success) {
								f(z.value);
							}
						});
					});l = o = null;
				});g.bind("CancelUpload", function () {
					e.Uploader.cancel({}, function () {});
				});g.bind("DisableBrowse", function (l, m) {
					k = m;
				});g.bind("UploadFile", function (o, l) {
					var n = h[l.id],
					    t = {},
					    m = o.settings.chunk_size,
					    p,
					    q = [];function s(u, w) {
						var v;if (l.status == a.FAILED) {
							return;
						}t.name = l.target_name || l.name;if (m) {
							t.chunk = "" + u;t.chunks = "" + w;
						}v = q.shift();e.Uploader.upload({ url: o.settings.url, files: { file: v }, cookies: document.cookies, postvars: a.extend(t, o.settings.multipart_params), progressCallback: function progressCallback(z) {
								var y,
								    x = 0;p[u] = parseInt(z.filePercent * v.size / 100, 10);for (y = 0; y < p.length; y++) {
									x += p[y];
								}l.loaded = x;o.trigger("UploadProgress", l);
							} }, function (y) {
							var x, z;if (y.success) {
								x = y.value.statusCode;if (m) {
									o.trigger("ChunkUploaded", l, { chunk: u, chunks: w, response: y.value.body, status: x });
								}if (q.length > 0) {
									s(++u, w);
								} else {
									l.status = a.DONE;o.trigger("FileUploaded", l, { response: y.value.body, status: x });if (x >= 400) {
										o.trigger("Error", { code: a.HTTP_ERROR, message: a.translate("HTTP Error."), file: l, status: x });
									}
								}
							} else {
								o.trigger("Error", { code: a.GENERIC_ERROR, message: a.translate("Generic Error."), file: l, details: y.error });
							}
						});
					}function r(u) {
						l.size = u.size;if (m) {
							e.FileAccess.chunk({ file: u, chunkSize: m }, function (x) {
								if (x.success) {
									var y = x.value,
									    v = y.length;p = Array(v);for (var w = 0; w < v; w++) {
										p[w] = 0;q.push(y[w]);
									}s(0, v);
								}
							});
						} else {
							p = Array(1);q.push(u);s(0, 1);
						}
					}if (c && /\.(png|jpg|jpeg)$/i.test(l.name)) {
						BrowserPlus.ImageAlter.transform({ file: n, quality: c.quality || 90, actions: [{ scale: { maxwidth: c.width, maxheight: c.height } }] }, function (u) {
							if (u.success) {
								r(u.value.file);
							}
						});
					} else {
						r(n);
					}
				});j({ success: true });
			}if (e) {
				e.init(function (l) {
					var k = [{ service: "Uploader", version: "3" }, { service: "DragAndDrop", version: "1" }, { service: "FileBrowse", version: "1" }, { service: "FileAccess", version: "2" }];if (c) {
						k.push({ service: "ImageAlter", version: "4" });
					}if (l.success) {
						e.require({ services: k }, function (m) {
							if (m.success) {
								b();
							} else {
								j();
							}
						});
					} else {
						j();
					}
				});
			} else {
				j();
			}
		} });
})(plupload);(function (h, k, j, e) {
	var c = {},
	    g;function m(o, p) {
		var n;if ("FileReader" in h) {
			n = new FileReader();n.readAsDataURL(o);n.onload = function () {
				p(n.result);
			};
		} else {
			return p(o.getAsDataURL());
		}
	}function l(o, p) {
		var n;if ("FileReader" in h) {
			n = new FileReader();n.readAsBinaryString(o);n.onload = function () {
				p(n.result);
			};
		} else {
			return p(o.getAsBinary());
		}
	}function d(r, p, n, v) {
		var q,
		    o,
		    u,
		    s,
		    t = this;m(c[r.id], function (w) {
			q = k.createElement("canvas");q.style.display = "none";k.body.appendChild(q);o = q.getContext("2d");u = new Image();u.onerror = u.onabort = function () {
				v({ success: false });
			};u.onload = function () {
				var B, x, z, y, A;if (!p.width) {
					p.width = u.width;
				}if (!p.height) {
					p.height = u.height;
				}s = Math.min(p.width / u.width, p.height / u.height);if (s < 1 || s === 1 && n === "image/jpeg") {
					B = Math.round(u.width * s);x = Math.round(u.height * s);q.width = B;q.height = x;o.drawImage(u, 0, 0, B, x);if (n === "image/jpeg") {
						y = new f(atob(w.substring(w.indexOf("base64,") + 7)));if (y.headers && y.headers.length) {
							A = new a();if (A.init(y.get("exif")[0])) {
								A.setExif("PixelXDimension", B);A.setExif("PixelYDimension", x);y.set("exif", A.getBinary());if (t.hasEventListener("ExifData")) {
									t.trigger("ExifData", r, A.EXIF());
								}if (t.hasEventListener("GpsData")) {
									t.trigger("GpsData", r, A.GPS());
								}
							}
						}if (p.quality) {
							try {
								w = q.toDataURL(n, p.quality / 100);
							} catch (C) {
								w = q.toDataURL(n);
							}
						}
					} else {
						w = q.toDataURL(n);
					}w = w.substring(w.indexOf("base64,") + 7);w = atob(w);if (y && y.headers && y.headers.length) {
						w = y.restore(w);y.purge();
					}q.parentNode.removeChild(q);v({ success: true, data: w });
				} else {
					v({ success: false });
				}
			};u.src = w;
		});
	}j.runtimes.Html5 = j.addRuntime("html5", { getFeatures: function getFeatures() {
			var s, o, r, q, p, n;o = r = p = n = false;if (h.XMLHttpRequest) {
				s = new XMLHttpRequest();r = !!s.upload;o = !!(s.sendAsBinary || s.upload);
			}if (o) {
				q = !!(s.sendAsBinary || h.Uint8Array && h.ArrayBuffer);p = !!(File && (File.prototype.getAsDataURL || h.FileReader) && q);n = !!(File && (File.prototype.mozSlice || File.prototype.webkitSlice || File.prototype.slice));
			}g = j.ua.safari && j.ua.windows;return { html5: o, dragdrop: function () {
					var t = k.createElement("div");return "draggable" in t || "ondragstart" in t && "ondrop" in t;
				}(), jpgresize: p, pngresize: p, multipart: p || !!h.FileReader || !!h.FormData, canSendBinary: q, cantSendBlobInFormData: !!(j.ua.gecko && h.FormData && h.FileReader && !FileReader.prototype.readAsArrayBuffer), progress: r, chunks: n, multi_selection: !(j.ua.safari && j.ua.windows), triggerDialog: j.ua.gecko && h.FormData || j.ua.webkit };
		}, init: function init(p, r) {
			var n, q;function o(w) {
				var u,
				    t,
				    v = [],
				    x,
				    s = {};for (t = 0; t < w.length; t++) {
					u = w[t];if (s[u.name]) {
						continue;
					}s[u.name] = true;x = j.guid();c[x] = u;v.push(new j.File(x, u.fileName || u.name, u.fileSize || u.size));
				}if (v.length) {
					p.trigger("FilesAdded", v);
				}
			}n = this.getFeatures();if (!n.html5) {
				r({ success: false });return;
			}p.bind("Init", function (w) {
				var G,
				    F,
				    C = [],
				    v,
				    D,
				    t = w.settings.filters,
				    u,
				    B,
				    s = k.body,
				    E;G = k.createElement("div");G.id = w.id + "_html5_container";j.extend(G.style, { position: "absolute", background: p.settings.shim_bgcolor || "transparent", width: "100px", height: "100px", overflow: "hidden", zIndex: 99999, opacity: p.settings.shim_bgcolor ? "" : 0 });G.className = "plupload html5";if (p.settings.container) {
					s = k.getElementById(p.settings.container);if (j.getStyle(s, "position") === "static") {
						s.style.position = "relative";
					}
				}s.appendChild(G);no_type_restriction: for (v = 0; v < t.length; v++) {
					u = t[v].extensions.split(/,/);for (D = 0; D < u.length; D++) {
						if (u[D] === "*") {
							C = [];break no_type_restriction;
						}B = j.mimeTypes[u[D]];if (B && j.inArray(B, C) === -1) {
							C.push(B);
						}
					}
				}G.innerHTML = '<input id="' + p.id + '_html5"  style="font-size:999px" type="file" accept="' + C.join(",") + '" ' + (p.settings.multi_selection && p.features.multi_selection ? 'multiple="multiple"' : "") + " />";G.scrollTop = 100;E = k.getElementById(p.id + "_html5");if (w.features.triggerDialog) {
					j.extend(E.style, { position: "absolute", width: "100%", height: "100%" });
				} else {
					j.extend(E.style, { cssFloat: "right", styleFloat: "right" });
				}E.onchange = function () {
					o(this.files);this.value = "";
				};F = k.getElementById(w.settings.browse_button);if (F) {
					var z = w.settings.browse_button_hover,
					    A = w.settings.browse_button_active,
					    x = w.features.triggerDialog ? F : G;if (z) {
						j.addEvent(x, "mouseover", function () {
							j.addClass(F, z);
						}, w.id);j.addEvent(x, "mouseout", function () {
							j.removeClass(F, z);
						}, w.id);
					}if (A) {
						j.addEvent(x, "mousedown", function () {
							j.addClass(F, A);
						}, w.id);j.addEvent(k.body, "mouseup", function () {
							j.removeClass(F, A);
						}, w.id);
					}if (w.features.triggerDialog) {
						j.addEvent(F, "click", function (H) {
							var y = k.getElementById(w.id + "_html5");if (y && !y.disabled) {
								y.click();
							}H.preventDefault();
						}, w.id);
					}
				}
			});p.bind("PostInit", function () {
				var s = k.getElementById(p.settings.drop_element);if (s) {
					if (g) {
						j.addEvent(s, "dragenter", function (w) {
							var v, t, u;v = k.getElementById(p.id + "_drop");if (!v) {
								v = k.createElement("input");v.setAttribute("type", "file");v.setAttribute("id", p.id + "_drop");v.setAttribute("multiple", "multiple");j.addEvent(v, "change", function () {
									o(this.files);j.removeEvent(v, "change", p.id);v.parentNode.removeChild(v);
								}, p.id);s.appendChild(v);
							}t = j.getPos(s, k.getElementById(p.settings.container));u = j.getSize(s);if (j.getStyle(s, "position") === "static") {
								j.extend(s.style, { position: "relative" });
							}j.extend(v.style, { position: "absolute", display: "block", top: 0, left: 0, width: u.w + "px", height: u.h + "px", opacity: 0 });
						}, p.id);return;
					}j.addEvent(s, "dragover", function (t) {
						t.preventDefault();
					}, p.id);j.addEvent(s, "drop", function (u) {
						var t = u.dataTransfer;if (t && t.files) {
							o(t.files);
						}u.preventDefault();
					}, p.id);
				}
			});p.bind("Refresh", function (s) {
				var t, u, v, x, w;t = k.getElementById(p.settings.browse_button);if (t) {
					u = j.getPos(t, k.getElementById(s.settings.container));v = j.getSize(t);x = k.getElementById(p.id + "_html5_container");j.extend(x.style, { top: u.y + "px", left: u.x + "px", width: v.w + "px", height: v.h + "px" });if (p.features.triggerDialog) {
						if (j.getStyle(t, "position") === "static") {
							j.extend(t.style, { position: "relative" });
						}w = parseInt(j.getStyle(t, "z-index"), 10);if (isNaN(w)) {
							w = 0;
						}j.extend(t.style, { zIndex: w });j.extend(x.style, { zIndex: w - 1 });
					}
				}
			});p.bind("DisableBrowse", function (s, u) {
				var t = k.getElementById(s.id + "_html5");if (t) {
					t.disabled = u;
				}
			});p.bind("CancelUpload", function () {
				if (q && q.abort) {
					q.abort();
				}
			});p.bind("UploadFile", function (s, u) {
				var v = s.settings,
				    y,
				    t;function x(A, D, z) {
					var B;if (File.prototype.slice) {
						try {
							A.slice();return A.slice(D, z);
						} catch (C) {
							return A.slice(D, z - D);
						}
					} else {
						if (B = File.prototype.webkitSlice || File.prototype.mozSlice) {
							return B.call(A, D, z);
						} else {
							return null;
						}
					}
				}function w(A) {
					var D = 0,
					    C = 0,
					    z = "FileReader" in h ? new FileReader() : null;function B() {
						var I,
						    M,
						    K,
						    L,
						    H,
						    J,
						    F,
						    E = s.settings.url;function G(V) {
							var T = 0,
							    N = "----pluploadboundary" + j.guid(),
							    O,
							    P = "--",
							    U = "\r\n",
							    R = "";q = new XMLHttpRequest();if (q.upload) {
								q.upload.onprogress = function (W) {
									u.loaded = Math.min(u.size, C + W.loaded - T);s.trigger("UploadProgress", u);
								};
							}q.onreadystatechange = function () {
								var W, Y;if (q.readyState == 4 && s.state !== j.STOPPED) {
									try {
										W = q.status;
									} catch (X) {
										W = 0;
									}if (W >= 400) {
										s.trigger("Error", { code: j.HTTP_ERROR, message: j.translate("HTTP Error."), file: u, status: W });
									} else {
										if (K) {
											Y = { chunk: D, chunks: K, response: q.responseText, status: W };s.trigger("ChunkUploaded", u, Y);C += J;if (Y.cancelled) {
												u.status = j.FAILED;return;
											}u.loaded = Math.min(u.size, (D + 1) * H);
										} else {
											u.loaded = u.size;
										}s.trigger("UploadProgress", u);V = I = O = R = null;if (!K || ++D >= K) {
											u.status = j.DONE;s.trigger("FileUploaded", u, { response: q.responseText, status: W });
										} else {
											B();
										}
									}
								}
							};if (s.settings.multipart && n.multipart) {
								L.name = u.target_name || u.name;q.open("post", E, true);j.each(s.settings.headers, function (X, W) {
									q.setRequestHeader(W, X);
								});if (typeof V !== "string" && !!h.FormData) {
									O = new FormData();j.each(j.extend(L, s.settings.multipart_params), function (X, W) {
										O.append(W, X);
									});O.append(s.settings.file_data_name, V);q.send(O);return;
								}if (typeof V === "string") {
									q.setRequestHeader("Content-Type", "multipart/form-data; boundary=" + N);j.each(j.extend(L, s.settings.multipart_params), function (X, W) {
										R += P + N + U + 'Content-Disposition: form-data; name="' + W + '"' + U + U;R += unescape(encodeURIComponent(X)) + U;
									});F = j.mimeTypes[u.name.replace(/^.+\.([^.]+)/, "$1").toLowerCase()] || "application/octet-stream";R += P + N + U + 'Content-Disposition: form-data; name="' + s.settings.file_data_name + '"; filename="' + unescape(encodeURIComponent(u.name)) + '"' + U + "Content-Type: " + F + U + U + V + U + P + N + P + U;T = R.length - V.length;V = R;if (q.sendAsBinary) {
										q.sendAsBinary(V);
									} else {
										if (n.canSendBinary) {
											var S = new Uint8Array(V.length);for (var Q = 0; Q < V.length; Q++) {
												S[Q] = V.charCodeAt(Q) & 255;
											}q.send(S.buffer);
										}
									}return;
								}
							}E = j.buildUrl(s.settings.url, j.extend(L, s.settings.multipart_params));q.open("post", E, true);q.setRequestHeader("Content-Type", "application/octet-stream");j.each(s.settings.headers, function (X, W) {
								q.setRequestHeader(W, X);
							});q.send(V);
						}if (u.status == j.DONE || u.status == j.FAILED || s.state == j.STOPPED) {
							return;
						}L = { name: u.target_name || u.name };if (v.chunk_size && u.size > v.chunk_size && (n.chunks || typeof A == "string")) {
							H = v.chunk_size;K = Math.ceil(u.size / H);J = Math.min(H, u.size - D * H);if (typeof A == "string") {
								I = A.substring(D * H, D * H + J);
							} else {
								I = x(A, D * H, D * H + J);
							}L.chunk = D;L.chunks = K;
						} else {
							J = u.size;I = A;
						}if (s.settings.multipart && n.multipart && typeof I !== "string" && z && n.cantSendBlobInFormData && n.chunks && s.settings.chunk_size) {
							z.onload = function () {
								G(z.result);
							};z.readAsBinaryString(I);
						} else {
							G(I);
						}
					}B();
				}y = c[u.id];if (n.jpgresize && s.settings.resize && /\.(png|jpg|jpeg)$/i.test(u.name)) {
					d.call(s, u, s.settings.resize, /\.png$/i.test(u.name) ? "image/png" : "image/jpeg", function (z) {
						if (z.success) {
							u.size = z.data.length;w(z.data);
						} else {
							if (n.chunks) {
								w(y);
							} else {
								l(y, w);
							}
						}
					});
				} else {
					if (!n.chunks && n.jpgresize) {
						l(y, w);
					} else {
						w(y);
					}
				}
			});p.bind("Destroy", function (s) {
				var u,
				    v,
				    t = k.body,
				    w = { inputContainer: s.id + "_html5_container", inputFile: s.id + "_html5", browseButton: s.settings.browse_button, dropElm: s.settings.drop_element };for (u in w) {
					v = k.getElementById(w[u]);if (v) {
						j.removeAllEvents(v, s.id);
					}
				}j.removeAllEvents(k.body, s.id);if (s.settings.container) {
					t = k.getElementById(s.settings.container);
				}t.removeChild(k.getElementById(w.inputContainer));
			});r({ success: true });
		} });function b() {
		var q = false,
		    o;function r(t, v) {
			var s = q ? 0 : -8 * (v - 1),
			    w = 0,
			    u;for (u = 0; u < v; u++) {
				w |= o.charCodeAt(t + u) << Math.abs(s + u * 8);
			}return w;
		}function n(u, s, t) {
			var t = arguments.length === 3 ? t : o.length - s - 1;o = o.substr(0, s) + u + o.substr(t + s);
		}function p(t, u, w) {
			var x = "",
			    s = q ? 0 : -8 * (w - 1),
			    v;for (v = 0; v < w; v++) {
				x += String.fromCharCode(u >> Math.abs(s + v * 8) & 255);
			}n(x, t, w);
		}return { II: function II(s) {
				if (s === e) {
					return q;
				} else {
					q = s;
				}
			}, init: function init(s) {
				q = false;o = s;
			}, SEGMENT: function SEGMENT(s, u, t) {
				switch (arguments.length) {case 1:
						return o.substr(s, o.length - s - 1);case 2:
						return o.substr(s, u);case 3:
						n(t, s, u);break;default:
						return o;}
			}, BYTE: function BYTE(s) {
				return r(s, 1);
			}, SHORT: function SHORT(s) {
				return r(s, 2);
			}, LONG: function LONG(s, t) {
				if (t === e) {
					return r(s, 4);
				} else {
					p(s, t, 4);
				}
			}, SLONG: function SLONG(s) {
				var t = r(s, 4);return t > 2147483647 ? t - 4294967296 : t;
			}, STRING: function STRING(s, t) {
				var u = "";for (t += s; s < t; s++) {
					u += String.fromCharCode(r(s, 1));
				}return u;
			} };
	}function f(s) {
		var u = { 65505: { app: "EXIF", name: "APP1", signature: "Exif\0" }, 65506: { app: "ICC", name: "APP2", signature: "ICC_PROFILE\0" }, 65517: { app: "IPTC", name: "APP13", signature: "Photoshop 3.0\0" } },
		    t = [],
		    r,
		    n,
		    p = e,
		    q = 0,
		    o;r = new b();r.init(s);if (r.SHORT(0) !== 65496) {
			return;
		}n = 2;o = Math.min(1048576, s.length);while (n <= o) {
			p = r.SHORT(n);if (p >= 65488 && p <= 65495) {
				n += 2;continue;
			}if (p === 65498 || p === 65497) {
				break;
			}q = r.SHORT(n + 2) + 2;if (u[p] && r.STRING(n + 4, u[p].signature.length) === u[p].signature) {
				t.push({ hex: p, app: u[p].app.toUpperCase(), name: u[p].name.toUpperCase(), start: n, length: q, segment: r.SEGMENT(n, q) });
			}n += q;
		}r.init(null);return { headers: t, restore: function restore(y) {
				r.init(y);var w = new f(y);if (!w.headers) {
					return false;
				}for (var x = w.headers.length; x > 0; x--) {
					var z = w.headers[x - 1];r.SEGMENT(z.start, z.length, "");
				}w.purge();n = r.SHORT(2) == 65504 ? 4 + r.SHORT(4) : 2;for (var x = 0, v = t.length; x < v; x++) {
					r.SEGMENT(n, 0, t[x].segment);n += t[x].length;
				}return r.SEGMENT();
			}, get: function get(x) {
				var y = [];for (var w = 0, v = t.length; w < v; w++) {
					if (t[w].app === x.toUpperCase()) {
						y.push(t[w].segment);
					}
				}return y;
			}, set: function set(y, x) {
				var z = [];if (typeof x === "string") {
					z.push(x);
				} else {
					z = x;
				}for (var w = ii = 0, v = t.length; w < v; w++) {
					if (t[w].app === y.toUpperCase()) {
						t[w].segment = z[ii];t[w].length = z[ii].length;ii++;
					}if (ii >= z.length) {
						break;
					}
				}
			}, purge: function purge() {
				t = [];r.init(null);
			} };
	}function a() {
		var q,
		    n,
		    o = {},
		    t;q = new b();n = { tiff: { 274: "Orientation", 34665: "ExifIFDPointer", 34853: "GPSInfoIFDPointer" }, exif: { 36864: "ExifVersion", 40961: "ColorSpace", 40962: "PixelXDimension", 40963: "PixelYDimension", 36867: "DateTimeOriginal", 33434: "ExposureTime", 33437: "FNumber", 34855: "ISOSpeedRatings", 37377: "ShutterSpeedValue", 37378: "ApertureValue", 37383: "MeteringMode", 37384: "LightSource", 37385: "Flash", 41986: "ExposureMode", 41987: "WhiteBalance", 41990: "SceneCaptureType", 41988: "DigitalZoomRatio", 41992: "Contrast", 41993: "Saturation", 41994: "Sharpness" }, gps: { 0: "GPSVersionID", 1: "GPSLatitudeRef", 2: "GPSLatitude", 3: "GPSLongitudeRef", 4: "GPSLongitude" } };t = { ColorSpace: { 1: "sRGB", 0: "Uncalibrated" }, MeteringMode: { 0: "Unknown", 1: "Average", 2: "CenterWeightedAverage", 3: "Spot", 4: "MultiSpot", 5: "Pattern", 6: "Partial", 255: "Other" }, LightSource: { 1: "Daylight", 2: "Fliorescent", 3: "Tungsten", 4: "Flash", 9: "Fine weather", 10: "Cloudy weather", 11: "Shade", 12: "Daylight fluorescent (D 5700 - 7100K)", 13: "Day white fluorescent (N 4600 -5400K)", 14: "Cool white fluorescent (W 3900 - 4500K)", 15: "White fluorescent (WW 3200 - 3700K)", 17: "Standard light A", 18: "Standard light B", 19: "Standard light C", 20: "D55", 21: "D65", 22: "D75", 23: "D50", 24: "ISO studio tungsten", 255: "Other" }, Flash: { 0: "Flash did not fire.", 1: "Flash fired.", 5: "Strobe return light not detected.", 7: "Strobe return light detected.", 9: "Flash fired, compulsory flash mode", 13: "Flash fired, compulsory flash mode, return light not detected", 15: "Flash fired, compulsory flash mode, return light detected", 16: "Flash did not fire, compulsory flash mode", 24: "Flash did not fire, auto mode", 25: "Flash fired, auto mode", 29: "Flash fired, auto mode, return light not detected", 31: "Flash fired, auto mode, return light detected", 32: "No flash function", 65: "Flash fired, red-eye reduction mode", 69: "Flash fired, red-eye reduction mode, return light not detected", 71: "Flash fired, red-eye reduction mode, return light detected", 73: "Flash fired, compulsory flash mode, red-eye reduction mode", 77: "Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected", 79: "Flash fired, compulsory flash mode, red-eye reduction mode, return light detected", 89: "Flash fired, auto mode, red-eye reduction mode", 93: "Flash fired, auto mode, return light not detected, red-eye reduction mode", 95: "Flash fired, auto mode, return light detected, red-eye reduction mode" }, ExposureMode: { 0: "Auto exposure", 1: "Manual exposure", 2: "Auto bracket" }, WhiteBalance: { 0: "Auto white balance", 1: "Manual white balance" }, SceneCaptureType: { 0: "Standard", 1: "Landscape", 2: "Portrait", 3: "Night scene" }, Contrast: { 0: "Normal", 1: "Soft", 2: "Hard" }, Saturation: { 0: "Normal", 1: "Low saturation", 2: "High saturation" }, Sharpness: { 0: "Normal", 1: "Soft", 2: "Hard" }, GPSLatitudeRef: { N: "North latitude", S: "South latitude" }, GPSLongitudeRef: { E: "East longitude", W: "West longitude" } };function p(u, C) {
			var w = q.SHORT(u),
			    z,
			    F,
			    G,
			    B,
			    A,
			    v,
			    x,
			    D,
			    E = [],
			    y = {};for (z = 0; z < w; z++) {
				x = v = u + 12 * z + 2;G = C[q.SHORT(x)];if (G === e) {
					continue;
				}B = q.SHORT(x += 2);A = q.LONG(x += 2);x += 4;E = [];switch (B) {case 1:case 7:
						if (A > 4) {
							x = q.LONG(x) + o.tiffHeader;
						}for (F = 0; F < A; F++) {
							E[F] = q.BYTE(x + F);
						}break;case 2:
						if (A > 4) {
							x = q.LONG(x) + o.tiffHeader;
						}y[G] = q.STRING(x, A - 1);continue;case 3:
						if (A > 2) {
							x = q.LONG(x) + o.tiffHeader;
						}for (F = 0; F < A; F++) {
							E[F] = q.SHORT(x + F * 2);
						}break;case 4:
						if (A > 1) {
							x = q.LONG(x) + o.tiffHeader;
						}for (F = 0; F < A; F++) {
							E[F] = q.LONG(x + F * 4);
						}break;case 5:
						x = q.LONG(x) + o.tiffHeader;for (F = 0; F < A; F++) {
							E[F] = q.LONG(x + F * 4) / q.LONG(x + F * 4 + 4);
						}break;case 9:
						x = q.LONG(x) + o.tiffHeader;for (F = 0; F < A; F++) {
							E[F] = q.SLONG(x + F * 4);
						}break;case 10:
						x = q.LONG(x) + o.tiffHeader;for (F = 0; F < A; F++) {
							E[F] = q.SLONG(x + F * 4) / q.SLONG(x + F * 4 + 4);
						}break;default:
						continue;}D = A == 1 ? E[0] : E;if (t.hasOwnProperty(G) && (typeof D === "undefined" ? "undefined" : _typeof(D)) != "object") {
					y[G] = t[G][D];
				} else {
					y[G] = D;
				}
			}return y;
		}function s() {
			var v = e,
			    u = o.tiffHeader;q.II(q.SHORT(u) == 18761);if (q.SHORT(u += 2) !== 42) {
				return false;
			}o.IFD0 = o.tiffHeader + q.LONG(u += 2);v = p(o.IFD0, n.tiff);o.exifIFD = "ExifIFDPointer" in v ? o.tiffHeader + v.ExifIFDPointer : e;o.gpsIFD = "GPSInfoIFDPointer" in v ? o.tiffHeader + v.GPSInfoIFDPointer : e;return true;
		}function r(w, u, z) {
			var B,
			    y,
			    x,
			    A = 0;if (typeof u === "string") {
				var v = n[w.toLowerCase()];for (hex in v) {
					if (v[hex] === u) {
						u = hex;break;
					}
				}
			}B = o[w.toLowerCase() + "IFD"];y = q.SHORT(B);for (i = 0; i < y; i++) {
				x = B + 12 * i + 2;if (q.SHORT(x) == u) {
					A = x + 8;break;
				}
			}if (!A) {
				return false;
			}q.LONG(A, z);return true;
		}return { init: function init(u) {
				o = { tiffHeader: 10 };if (u === e || !u.length) {
					return false;
				}q.init(u);if (q.SHORT(0) === 65505 && q.STRING(4, 5).toUpperCase() === "EXIF\0") {
					return s();
				}return false;
			}, EXIF: function EXIF() {
				var v;v = p(o.exifIFD, n.exif);if (v.ExifVersion && j.typeOf(v.ExifVersion) === "array") {
					for (var w = 0, u = ""; w < v.ExifVersion.length; w++) {
						u += String.fromCharCode(v.ExifVersion[w]);
					}v.ExifVersion = u;
				}return v;
			}, GPS: function GPS() {
				var u;u = p(o.gpsIFD, n.gps);if (u.GPSVersionID) {
					u.GPSVersionID = u.GPSVersionID.join(".");
				}return u;
			}, setExif: function setExif(u, v) {
				if (u !== "PixelXDimension" && u !== "PixelYDimension") {
					return false;
				}return r("exif", u, v);
			}, getBinary: function getBinary() {
				return q.SEGMENT();
			} };
	}
})(window, document, plupload);(function (d, a, b, c) {
	function e(f) {
		return a.getElementById(f);
	}b.runtimes.Html4 = b.addRuntime("html4", { getFeatures: function getFeatures() {
			return { multipart: true, triggerDialog: b.ua.gecko && d.FormData || b.ua.webkit };
		}, init: function init(f, g) {
			f.bind("Init", function (p) {
				var j = a.body,
				    n,
				    h = "javascript",
				    k,
				    x,
				    q,
				    z = [],
				    r = /MSIE/.test(navigator.userAgent),
				    t = [],
				    m = p.settings.filters,
				    o,
				    l,
				    s,
				    w;no_type_restriction: for (o = 0; o < m.length; o++) {
					l = m[o].extensions.split(/,/);for (w = 0; w < l.length; w++) {
						if (l[w] === "*") {
							t = [];break no_type_restriction;
						}s = b.mimeTypes[l[w]];if (s && b.inArray(s, t) === -1) {
							t.push(s);
						}
					}
				}t = t.join(",");function v() {
					var C, A, y, B;q = b.guid();z.push(q);C = a.createElement("form");C.setAttribute("id", "form_" + q);C.setAttribute("method", "post");C.setAttribute("enctype", "multipart/form-data");C.setAttribute("encoding", "multipart/form-data");C.setAttribute("target", p.id + "_iframe");C.style.position = "absolute";A = a.createElement("input");A.setAttribute("id", "input_" + q);A.setAttribute("type", "file");A.setAttribute("accept", t);A.setAttribute("size", 1);B = e(p.settings.browse_button);if (p.features.triggerDialog && B) {
						b.addEvent(e(p.settings.browse_button), "click", function (D) {
							if (!A.disabled) {
								A.click();
							}D.preventDefault();
						}, p.id);
					}b.extend(A.style, { width: "100%", height: "100%", opacity: 0, fontSize: "99px", cursor: "pointer" });b.extend(C.style, { overflow: "hidden" });y = p.settings.shim_bgcolor;if (y) {
						C.style.background = y;
					}if (r) {
						b.extend(A.style, { filter: "alpha(opacity=0)" });
					}b.addEvent(A, "change", function (G) {
						var E = G.target,
						    D,
						    F = [],
						    H;if (E.value) {
							e("form_" + q).style.top = -1048575 + "px";D = E.value.replace(/\\/g, "/");D = D.substring(D.length, D.lastIndexOf("/") + 1);F.push(new b.File(q, D));if (!p.features.triggerDialog) {
								b.removeAllEvents(C, p.id);
							} else {
								b.removeEvent(B, "click", p.id);
							}b.removeEvent(A, "change", p.id);v();if (F.length) {
								f.trigger("FilesAdded", F);
							}
						}
					}, p.id);C.appendChild(A);j.appendChild(C);p.refresh();
				}function u() {
					var y = a.createElement("div");y.innerHTML = '<iframe id="' + p.id + '_iframe" name="' + p.id + '_iframe" src="' + h + ':&quot;&quot;" style="display:none"></iframe>';n = y.firstChild;j.appendChild(n);b.addEvent(n, "load", function (D) {
						var E = D.target,
						    C,
						    A;if (!k) {
							return;
						}try {
							C = E.contentWindow.document || E.contentDocument || d.frames[E.id].document;
						} catch (B) {
							p.trigger("Error", { code: b.SECURITY_ERROR, message: b.translate("Security error."), file: k });return;
						}A = C.body.innerHTML;if (A) {
							k.status = b.DONE;k.loaded = 1025;k.percent = 100;p.trigger("UploadProgress", k);p.trigger("FileUploaded", k, { response: A });
						}
					}, p.id);
				}if (p.settings.container) {
					j = e(p.settings.container);if (b.getStyle(j, "position") === "static") {
						j.style.position = "relative";
					}
				}p.bind("UploadFile", function (y, B) {
					var C, A;if (B.status == b.DONE || B.status == b.FAILED || y.state == b.STOPPED) {
						return;
					}C = e("form_" + B.id);A = e("input_" + B.id);A.setAttribute("name", y.settings.file_data_name);C.setAttribute("action", y.settings.url);b.each(b.extend({ name: B.target_name || B.name }, y.settings.multipart_params), function (F, D) {
						var E = a.createElement("input");b.extend(E, { type: "hidden", name: D, value: F });C.insertBefore(E, C.firstChild);
					});k = B;e("form_" + q).style.top = -1048575 + "px";C.submit();
				});p.bind("FileUploaded", function (y) {
					y.refresh();
				});p.bind("StateChanged", function (y) {
					if (y.state == b.STARTED) {
						u();
					} else {
						if (y.state == b.STOPPED) {
							d.setTimeout(function () {
								b.removeEvent(n, "load", y.id);if (n.parentNode) {
									n.parentNode.removeChild(n);
								}
							}, 0);
						}
					}b.each(y.files, function (B, A) {
						if (B.status === b.DONE || B.status === b.FAILED) {
							var C = e("form_" + B.id);if (C) {
								C.parentNode.removeChild(C);
							}
						}
					});
				});p.bind("Refresh", function (A) {
					var G, B, C, D, y, H, I, F, E;G = e(A.settings.browse_button);if (G) {
						y = b.getPos(G, e(A.settings.container));H = b.getSize(G);I = e("form_" + q);F = e("input_" + q);b.extend(I.style, { top: y.y + "px", left: y.x + "px", width: H.w + "px", height: H.h + "px" });if (A.features.triggerDialog) {
							if (b.getStyle(G, "position") === "static") {
								b.extend(G.style, { position: "relative" });
							}E = parseInt(G.style.zIndex, 10);if (isNaN(E)) {
								E = 0;
							}b.extend(G.style, { zIndex: E });b.extend(I.style, { zIndex: E - 1 });
						}C = A.settings.browse_button_hover;D = A.settings.browse_button_active;B = A.features.triggerDialog ? G : I;if (C) {
							b.addEvent(B, "mouseover", function () {
								b.addClass(G, C);
							}, A.id);b.addEvent(B, "mouseout", function () {
								b.removeClass(G, C);
							}, A.id);
						}if (D) {
							b.addEvent(B, "mousedown", function () {
								b.addClass(G, D);
							}, A.id);b.addEvent(a.body, "mouseup", function () {
								b.removeClass(G, D);
							}, A.id);
						}
					}
				});f.bind("FilesRemoved", function (y, B) {
					var A, C;for (A = 0; A < B.length; A++) {
						C = e("form_" + B[A].id);if (C) {
							C.parentNode.removeChild(C);
						}
					}
				});f.bind("DisableBrowse", function (y, B) {
					var A = a.getElementById("input_" + q);if (A) {
						A.disabled = B;
					}
				});f.bind("Destroy", function (y) {
					var A,
					    B,
					    C,
					    D = { inputContainer: "form_" + q, inputFile: "input_" + q, browseButton: y.settings.browse_button };for (A in D) {
						B = e(D[A]);if (B) {
							b.removeAllEvents(B, y.id);
						}
					}b.removeAllEvents(a.body, y.id);b.each(z, function (F, E) {
						C = e("form_" + F);if (C) {
							j.removeChild(C);
						}
					});
				});v();
			});g({ success: true });
		} });
})(window, document, plupload);

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Constructor
// file is a SWFUpload file object
// targetID is the HTML element id attribute that the RamJetFileProgress HTML structure will be added to.
function RamJetFileProgress(file, targetID, width) {
	this.fileProgressID = file.id;
	var map = {
		'&': '&amp;',
		'<': '&lt;',
		'>': '&gt;',
		'"': '&quot;',
		"'": '&#x27;',
		"/": '&#x2F;'
	};
	var reg = /[&<>"'/]/ig;
	this.fileName = file.name.replace(reg, function (match) {
		return map[match];
	});

	this.fileProgressWrapper = jQuery("#" + this.fileProgressID);
	if (this.fileProgressWrapper.length == 0) {
		var progressHtml = "";
		progressHtml = progressHtml + '<div class="ramJetProgressWrapper" id="' + this.fileProgressID + '">';
		progressHtml = progressHtml + '<div class="progressContainer">';
		progressHtml = progressHtml + '<a href="#" class="progressCancel" style="display: none;"> </a>';
		progressHtml = progressHtml + '<div class="progressName">' + this.fileName + '</div>';
		progressHtml = progressHtml + '<div class="progressBar progressBarInProgress"/>';
		progressHtml = progressHtml + '<div class="progressBarStatus">&nbsp;</div>';
		progressHtml = progressHtml + '</div>';
		progressHtml = progressHtml + '</div>';
		var jProgressHtml = jQuery(progressHtml);
		if (width !== null && width !== undefined) {
			jProgressHtml.css("width", width);
		}
		jProgressHtml.insertBefore("#" + targetID);
		this.fileProgressWrapper = jQuery("#" + this.fileProgressID);
	}
	this.fileProgressElement = this.fileProgressWrapper.children(".progressContainer");
	this.fileProgressElement.find(".progressName").html(this.fileName);
}

RamJetFileProgress.prototype.setProgress = function (percentage) {
	this.fileProgressElement.attr("class", "progressContainer green");
	this.fileProgressElement.children(".progressBar").attr("class", "progressBar progressBarInProgress").css("width", percentage + "%");
};
RamJetFileProgress.prototype.setComplete = function (ms) {
	this.appear();
	ms = ms !== undefined ? ms : 10000;
	this.fileProgressElement.attr("class", "progressContainer blue");
	this.fileProgressElement.children(".progressBar").attr("class", "progressBar progressBarComplete").css("width", "");

	var oSelf = this;
	if (ms > 0) {
		setTimeout(function () {
			oSelf.disappear();
		}, ms);
	}
};
RamJetFileProgress.prototype.setError = function (ms) {
	this.appear();
	ms = ms !== undefined ? ms : 5000;

	this.fileProgressElement.attr("class", "progressContainer red");
	this.fileProgressElement.children(".progressBar").attr("class", "progressBar progressBarError").css("width", "");

	var oSelf = this;
	var cancelBtn = this.fileProgressElement.find(".progressCancel");
	cancelBtn.show();
	cancelBtn.click(function () {
		oSelf.disappear();
		return false;
	});
	if (ms > 0) {
		setTimeout(function () {
			oSelf.disappear();
		}, ms);
	}
};

RamJetFileProgress.prototype.setCancelled = function (ms) {
	ms = ms || 2000;
	this.appear();

	this.fileProgressElement.attr("class", "progressContainer red");
	this.fileProgressElement.children(".progressBar").attr("class", "progressBar progressBarError").css("width", "");

	var oSelf = this;
	setTimeout(function () {
		oSelf.disappear();
	}, ms);
};
RamJetFileProgress.prototype.setStatus = function (status) {
	this.fileProgressElement.find(".progressBarStatus").html(status);
};

RamJetFileProgress.prototype.setLabel = function (label) {
	this.fileProgressElement.find(".progressName").html(label);
};

// Show/Hide the cancel button
RamJetFileProgress.prototype.toggleCancel = function (show, swfUploadInstance) {
	var cancelBtn = this.fileProgressElement.find(".progressCancel");
	if (show) {
		cancelBtn.show();
	} else {
		cancelBtn.hide();
	}
	if (swfUploadInstance) {
		var fileID = this.fileProgressID;
		cancelBtn.click(function () {
			swfUploadInstance.cancelUpload(fileID);
			return false;
		});
	}
};

// Makes sure the RamJetFileProgress box is visible
RamJetFileProgress.prototype.appear = function () {
	this.fileProgressWrapper.show("slow");
};

// Fades out and clips away the RamJetFileProgress box.
RamJetFileProgress.prototype.disappear = function () {
	var wrapperToRemove = this.fileProgressWrapper;
	this.fileProgressWrapper.hide("slow", function () {
		wrapperToRemove.remove();
	});
};

module.exports = RamJetFileProgress;

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! picturefill - v3.0.2 - 2016-02-12
 * https://scottjehl.github.io/picturefill/
 * Copyright (c) 2016 https://github.com/scottjehl/picturefill/blob/master/Authors.txt; Licensed MIT
 */
/*! Gecko-Picture - v1.0
 * https://github.com/scottjehl/picturefill/tree/3.0/src/plugins/gecko-picture
 * Firefox's early picture implementation (prior to FF41) is static and does
 * not react to viewport changes. This tiny module fixes this.
 */
(function(window) {
	/*jshint eqnull:true */
	var ua = navigator.userAgent;

	if ( window.HTMLPictureElement && ((/ecko/).test(ua) && ua.match(/rv\:(\d+)/) && RegExp.$1 < 45) ) {
		addEventListener("resize", (function() {
			var timer;

			var dummySrc = document.createElement("source");

			var fixRespimg = function(img) {
				var source, sizes;
				var picture = img.parentNode;

				if (picture.nodeName.toUpperCase() === "PICTURE") {
					source = dummySrc.cloneNode();

					picture.insertBefore(source, picture.firstElementChild);
					setTimeout(function() {
						picture.removeChild(source);
					});
				} else if (!img._pfLastSize || img.offsetWidth > img._pfLastSize) {
					img._pfLastSize = img.offsetWidth;
					sizes = img.sizes;
					img.sizes += ",100vw";
					setTimeout(function() {
						img.sizes = sizes;
					});
				}
			};

			var findPictureImgs = function() {
				var i;
				var imgs = document.querySelectorAll("picture > img, img[srcset][sizes]");
				for (i = 0; i < imgs.length; i++) {
					fixRespimg(imgs[i]);
				}
			};
			var onResize = function() {
				clearTimeout(timer);
				timer = setTimeout(findPictureImgs, 99);
			};
			var mq = window.matchMedia && matchMedia("(orientation: landscape)");
			var init = function() {
				onResize();

				if (mq && mq.addListener) {
					mq.addListener(onResize);
				}
			};

			dummySrc.srcset = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";

			if (/^[c|i]|d$/.test(document.readyState || "")) {
				init();
			} else {
				document.addEventListener("DOMContentLoaded", init);
			}

			return onResize;
		})());
	}
})(window);

/*! Picturefill - v3.0.2
 * http://scottjehl.github.io/picturefill
 * Copyright (c) 2015 https://github.com/scottjehl/picturefill/blob/master/Authors.txt;
 *  License: MIT
 */

(function( window, document, undefined ) {
	// Enable strict mode
	"use strict";

	// HTML shim|v it for old IE (IE9 will still need the HTML video tag workaround)
	document.createElement( "picture" );

	var warn, eminpx, alwaysCheckWDescriptor, evalId;
	// local object for method references and testing exposure
	var pf = {};
	var isSupportTestReady = false;
	var noop = function() {};
	var image = document.createElement( "img" );
	var getImgAttr = image.getAttribute;
	var setImgAttr = image.setAttribute;
	var removeImgAttr = image.removeAttribute;
	var docElem = document.documentElement;
	var types = {};
	var cfg = {
		//resource selection:
		algorithm: ""
	};
	var srcAttr = "data-pfsrc";
	var srcsetAttr = srcAttr + "set";
	// ua sniffing is done for undetectable img loading features,
	// to do some non crucial perf optimizations
	var ua = navigator.userAgent;
	var supportAbort = (/rident/).test(ua) || ((/ecko/).test(ua) && ua.match(/rv\:(\d+)/) && RegExp.$1 > 35 );
	var curSrcProp = "currentSrc";
	var regWDesc = /\s+\+?\d+(e\d+)?w/;
	var regSize = /(\([^)]+\))?\s*(.+)/;
	var setOptions = window.picturefillCFG;
	/**
	 * Shortcut property for https://w3c.github.io/webappsec/specs/mixedcontent/#restricts-mixed-content ( for easy overriding in tests )
	 */
	// baseStyle also used by getEmValue (i.e.: width: 1em is important)
	var baseStyle = "position:absolute;left:0;visibility:hidden;display:block;padding:0;border:none;font-size:1em;width:1em;overflow:hidden;clip:rect(0px, 0px, 0px, 0px)";
	var fsCss = "font-size:100%!important;";
	var isVwDirty = true;

	var cssCache = {};
	var sizeLengthCache = {};
	var DPR = window.devicePixelRatio;
	var units = {
		px: 1,
		"in": 96
	};
	var anchor = document.createElement( "a" );
	/**
	 * alreadyRun flag used for setOptions. is it true setOptions will reevaluate
	 * @type {boolean}
	 */
	var alreadyRun = false;

	// Reusable, non-"g" Regexes

	// (Don't use \s, to avoid matching non-breaking space.)
	var regexLeadingSpaces = /^[ \t\n\r\u000c]+/,
	    regexLeadingCommasOrSpaces = /^[, \t\n\r\u000c]+/,
	    regexLeadingNotSpaces = /^[^ \t\n\r\u000c]+/,
	    regexTrailingCommas = /[,]+$/,
	    regexNonNegativeInteger = /^\d+$/,

	    // ( Positive or negative or unsigned integers or decimals, without or without exponents.
	    // Must include at least one digit.
	    // According to spec tests any decimal point must be followed by a digit.
	    // No leading plus sign is allowed.)
	    // https://html.spec.whatwg.org/multipage/infrastructure.html#valid-floating-point-number
	    regexFloatingPoint = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/;

	var on = function(obj, evt, fn, capture) {
		if ( obj.addEventListener ) {
			obj.addEventListener(evt, fn, capture || false);
		} else if ( obj.attachEvent ) {
			obj.attachEvent( "on" + evt, fn);
		}
	};

	/**
	 * simple memoize function:
	 */

	var memoize = function(fn) {
		var cache = {};
		return function(input) {
			if ( !(input in cache) ) {
				cache[ input ] = fn(input);
			}
			return cache[ input ];
		};
	};

	// UTILITY FUNCTIONS

	// Manual is faster than RegEx
	// http://jsperf.com/whitespace-character/5
	function isSpace(c) {
		return (c === "\u0020" || // space
		        c === "\u0009" || // horizontal tab
		        c === "\u000A" || // new line
		        c === "\u000C" || // form feed
		        c === "\u000D");  // carriage return
	}

	/**
	 * gets a mediaquery and returns a boolean or gets a css length and returns a number
	 * @param css mediaqueries or css length
	 * @returns {boolean|number}
	 *
	 * based on: https://gist.github.com/jonathantneal/db4f77009b155f083738
	 */
	var evalCSS = (function() {

		var regLength = /^([\d\.]+)(em|vw|px)$/;
		var replace = function() {
			var args = arguments, index = 0, string = args[0];
			while (++index in args) {
				string = string.replace(args[index], args[++index]);
			}
			return string;
		};

		var buildStr = memoize(function(css) {

			return "return " + replace((css || "").toLowerCase(),
				// interpret `and`
				/\band\b/g, "&&",

				// interpret `,`
				/,/g, "||",

				// interpret `min-` as >=
				/min-([a-z-\s]+):/g, "e.$1>=",

				// interpret `max-` as <=
				/max-([a-z-\s]+):/g, "e.$1<=",

				//calc value
				/calc([^)]+)/g, "($1)",

				// interpret css values
				/(\d+[\.]*[\d]*)([a-z]+)/g, "($1 * e.$2)",
				//make eval less evil
				/^(?!(e.[a-z]|[0-9\.&=|><\+\-\*\(\)\/])).*/ig, ""
			) + ";";
		});

		return function(css, length) {
			var parsedLength;
			if (!(css in cssCache)) {
				cssCache[css] = false;
				if (length && (parsedLength = css.match( regLength ))) {
					cssCache[css] = parsedLength[ 1 ] * units[parsedLength[ 2 ]];
				} else {
					/*jshint evil:true */
					try{
						cssCache[css] = new Function("e", buildStr(css))(units);
					} catch(e) {}
					/*jshint evil:false */
				}
			}
			return cssCache[css];
		};
	})();

	var setResolution = function( candidate, sizesattr ) {
		if ( candidate.w ) { // h = means height: || descriptor.type === 'h' do not handle yet...
			candidate.cWidth = pf.calcListLength( sizesattr || "100vw" );
			candidate.res = candidate.w / candidate.cWidth ;
		} else {
			candidate.res = candidate.d;
		}
		return candidate;
	};

	/**
	 *
	 * @param opt
	 */
	var picturefill = function( opt ) {

		if (!isSupportTestReady) {return;}

		var elements, i, plen;

		var options = opt || {};

		if ( options.elements && options.elements.nodeType === 1 ) {
			if ( options.elements.nodeName.toUpperCase() === "IMG" ) {
				options.elements =  [ options.elements ];
			} else {
				options.context = options.elements;
				options.elements =  null;
			}
		}

		elements = options.elements || pf.qsa( (options.context || document), ( options.reevaluate || options.reselect ) ? pf.sel : pf.selShort );

		if ( (plen = elements.length) ) {

			pf.setupRun( options );
			alreadyRun = true;

			// Loop through all elements
			for ( i = 0; i < plen; i++ ) {
				pf.fillImg(elements[ i ], options);
			}

			pf.teardownRun( options );
		}
	};

	/**
	 * outputs a warning for the developer
	 * @param {message}
	 * @type {Function}
	 */
	warn = ( window.console && console.warn ) ?
		function( message ) {
			console.warn( message );
		} :
		noop
	;

	if ( !(curSrcProp in image) ) {
		curSrcProp = "src";
	}

	// Add support for standard mime types.
	types[ "image/jpeg" ] = true;
	types[ "image/gif" ] = true;
	types[ "image/png" ] = true;

	function detectTypeSupport( type, typeUri ) {
		// based on Modernizr's lossless img-webp test
		// note: asynchronous
		var image = new window.Image();
		image.onerror = function() {
			types[ type ] = false;
			picturefill();
		};
		image.onload = function() {
			types[ type ] = image.width === 1;
			picturefill();
		};
		image.src = typeUri;
		return "pending";
	}

	// test svg support
	types[ "image/svg+xml" ] = document.implementation.hasFeature( "http://www.w3.org/TR/SVG11/feature#Image", "1.1" );

	/**
	 * updates the internal vW property with the current viewport width in px
	 */
	function updateMetrics() {

		isVwDirty = false;
		DPR = window.devicePixelRatio;
		cssCache = {};
		sizeLengthCache = {};

		pf.DPR = DPR || 1;

		units.width = Math.max(window.innerWidth || 0, docElem.clientWidth);
		units.height = Math.max(window.innerHeight || 0, docElem.clientHeight);

		units.vw = units.width / 100;
		units.vh = units.height / 100;

		evalId = [ units.height, units.width, DPR ].join("-");

		units.em = pf.getEmValue();
		units.rem = units.em;
	}

	function chooseLowRes( lowerValue, higherValue, dprValue, isCached ) {
		var bonusFactor, tooMuch, bonus, meanDensity;

		//experimental
		if (cfg.algorithm === "saveData" ){
			if ( lowerValue > 2.7 ) {
				meanDensity = dprValue + 1;
			} else {
				tooMuch = higherValue - dprValue;
				bonusFactor = Math.pow(lowerValue - 0.6, 1.5);

				bonus = tooMuch * bonusFactor;

				if (isCached) {
					bonus += 0.1 * bonusFactor;
				}

				meanDensity = lowerValue + bonus;
			}
		} else {
			meanDensity = (dprValue > 1) ?
				Math.sqrt(lowerValue * higherValue) :
				lowerValue;
		}

		return meanDensity > dprValue;
	}

	function applyBestCandidate( img ) {
		var srcSetCandidates;
		var matchingSet = pf.getSet( img );
		var evaluated = false;
		if ( matchingSet !== "pending" ) {
			evaluated = evalId;
			if ( matchingSet ) {
				srcSetCandidates = pf.setRes( matchingSet );
				pf.applySetCandidate( srcSetCandidates, img );
			}
		}
		img[ pf.ns ].evaled = evaluated;
	}

	function ascendingSort( a, b ) {
		return a.res - b.res;
	}

	function setSrcToCur( img, src, set ) {
		var candidate;
		if ( !set && src ) {
			set = img[ pf.ns ].sets;
			set = set && set[set.length - 1];
		}

		candidate = getCandidateForSrc(src, set);

		if ( candidate ) {
			src = pf.makeUrl(src);
			img[ pf.ns ].curSrc = src;
			img[ pf.ns ].curCan = candidate;

			if ( !candidate.res ) {
				setResolution( candidate, candidate.set.sizes );
			}
		}
		return candidate;
	}

	function getCandidateForSrc( src, set ) {
		var i, candidate, candidates;
		if ( src && set ) {
			candidates = pf.parseSet( set );
			src = pf.makeUrl(src);
			for ( i = 0; i < candidates.length; i++ ) {
				if ( src === pf.makeUrl(candidates[ i ].url) ) {
					candidate = candidates[ i ];
					break;
				}
			}
		}
		return candidate;
	}

	function getAllSourceElements( picture, candidates ) {
		var i, len, source, srcset;

		// SPEC mismatch intended for size and perf:
		// actually only source elements preceding the img should be used
		// also note: don't use qsa here, because IE8 sometimes doesn't like source as the key part in a selector
		var sources = picture.getElementsByTagName( "source" );

		for ( i = 0, len = sources.length; i < len; i++ ) {
			source = sources[ i ];
			source[ pf.ns ] = true;
			srcset = source.getAttribute( "srcset" );

			// if source does not have a srcset attribute, skip
			if ( srcset ) {
				candidates.push( {
					srcset: srcset,
					media: source.getAttribute( "media" ),
					type: source.getAttribute( "type" ),
					sizes: source.getAttribute( "sizes" )
				} );
			}
		}
	}

	/**
	 * Srcset Parser
	 * By Alex Bell |  MIT License
	 *
	 * @returns Array [{url: _, d: _, w: _, h:_, set:_(????)}, ...]
	 *
	 * Based super duper closely on the reference algorithm at:
	 * https://html.spec.whatwg.org/multipage/embedded-content.html#parse-a-srcset-attribute
	 */

	// 1. Let input be the value passed to this algorithm.
	// (TO-DO : Explain what "set" argument is here. Maybe choose a more
	// descriptive & more searchable name.  Since passing the "set" in really has
	// nothing to do with parsing proper, I would prefer this assignment eventually
	// go in an external fn.)
	function parseSrcset(input, set) {

		function collectCharacters(regEx) {
			var chars,
			    match = regEx.exec(input.substring(pos));
			if (match) {
				chars = match[ 0 ];
				pos += chars.length;
				return chars;
			}
		}

		var inputLength = input.length,
		    url,
		    descriptors,
		    currentDescriptor,
		    state,
		    c,

		    // 2. Let position be a pointer into input, initially pointing at the start
		    //    of the string.
		    pos = 0,

		    // 3. Let candidates be an initially empty source set.
		    candidates = [];

		/**
		* Adds descriptor properties to a candidate, pushes to the candidates array
		* @return undefined
		*/
		// (Declared outside of the while loop so that it's only created once.
		// (This fn is defined before it is used, in order to pass JSHINT.
		// Unfortunately this breaks the sequencing of the spec comments. :/ )
		function parseDescriptors() {

			// 9. Descriptor parser: Let error be no.
			var pError = false,

			// 10. Let width be absent.
			// 11. Let density be absent.
			// 12. Let future-compat-h be absent. (We're implementing it now as h)
			    w, d, h, i,
			    candidate = {},
			    desc, lastChar, value, intVal, floatVal;

			// 13. For each descriptor in descriptors, run the appropriate set of steps
			// from the following list:
			for (i = 0 ; i < descriptors.length; i++) {
				desc = descriptors[ i ];

				lastChar = desc[ desc.length - 1 ];
				value = desc.substring(0, desc.length - 1);
				intVal = parseInt(value, 10);
				floatVal = parseFloat(value);

				// If the descriptor consists of a valid non-negative integer followed by
				// a U+0077 LATIN SMALL LETTER W character
				if (regexNonNegativeInteger.test(value) && (lastChar === "w")) {

					// If width and density are not both absent, then let error be yes.
					if (w || d) {pError = true;}

					// Apply the rules for parsing non-negative integers to the descriptor.
					// If the result is zero, let error be yes.
					// Otherwise, let width be the result.
					if (intVal === 0) {pError = true;} else {w = intVal;}

				// If the descriptor consists of a valid floating-point number followed by
				// a U+0078 LATIN SMALL LETTER X character
				} else if (regexFloatingPoint.test(value) && (lastChar === "x")) {

					// If width, density and future-compat-h are not all absent, then let error
					// be yes.
					if (w || d || h) {pError = true;}

					// Apply the rules for parsing floating-point number values to the descriptor.
					// If the result is less than zero, let error be yes. Otherwise, let density
					// be the result.
					if (floatVal < 0) {pError = true;} else {d = floatVal;}

				// If the descriptor consists of a valid non-negative integer followed by
				// a U+0068 LATIN SMALL LETTER H character
				} else if (regexNonNegativeInteger.test(value) && (lastChar === "h")) {

					// If height and density are not both absent, then let error be yes.
					if (h || d) {pError = true;}

					// Apply the rules for parsing non-negative integers to the descriptor.
					// If the result is zero, let error be yes. Otherwise, let future-compat-h
					// be the result.
					if (intVal === 0) {pError = true;} else {h = intVal;}

				// Anything else, Let error be yes.
				} else {pError = true;}
			} // (close step 13 for loop)

			// 15. If error is still no, then append a new image source to candidates whose
			// URL is url, associated with a width width if not absent and a pixel
			// density density if not absent. Otherwise, there is a parse error.
			if (!pError) {
				candidate.url = url;

				if (w) { candidate.w = w;}
				if (d) { candidate.d = d;}
				if (h) { candidate.h = h;}
				if (!h && !d && !w) {candidate.d = 1;}
				if (candidate.d === 1) {set.has1x = true;}
				candidate.set = set;

				candidates.push(candidate);
			}
		} // (close parseDescriptors fn)

		/**
		* Tokenizes descriptor properties prior to parsing
		* Returns undefined.
		* (Again, this fn is defined before it is used, in order to pass JSHINT.
		* Unfortunately this breaks the logical sequencing of the spec comments. :/ )
		*/
		function tokenize() {

			// 8.1. Descriptor tokeniser: Skip whitespace
			collectCharacters(regexLeadingSpaces);

			// 8.2. Let current descriptor be the empty string.
			currentDescriptor = "";

			// 8.3. Let state be in descriptor.
			state = "in descriptor";

			while (true) {

				// 8.4. Let c be the character at position.
				c = input.charAt(pos);

				//  Do the following depending on the value of state.
				//  For the purpose of this step, "EOF" is a special character representing
				//  that position is past the end of input.

				// In descriptor
				if (state === "in descriptor") {
					// Do the following, depending on the value of c:

				  // Space character
				  // If current descriptor is not empty, append current descriptor to
				  // descriptors and let current descriptor be the empty string.
				  // Set state to after descriptor.
					if (isSpace(c)) {
						if (currentDescriptor) {
							descriptors.push(currentDescriptor);
							currentDescriptor = "";
							state = "after descriptor";
						}

					// U+002C COMMA (,)
					// Advance position to the next character in input. If current descriptor
					// is not empty, append current descriptor to descriptors. Jump to the step
					// labeled descriptor parser.
					} else if (c === ",") {
						pos += 1;
						if (currentDescriptor) {
							descriptors.push(currentDescriptor);
						}
						parseDescriptors();
						return;

					// U+0028 LEFT PARENTHESIS (()
					// Append c to current descriptor. Set state to in parens.
					} else if (c === "\u0028") {
						currentDescriptor = currentDescriptor + c;
						state = "in parens";

					// EOF
					// If current descriptor is not empty, append current descriptor to
					// descriptors. Jump to the step labeled descriptor parser.
					} else if (c === "") {
						if (currentDescriptor) {
							descriptors.push(currentDescriptor);
						}
						parseDescriptors();
						return;

					// Anything else
					// Append c to current descriptor.
					} else {
						currentDescriptor = currentDescriptor + c;
					}
				// (end "in descriptor"

				// In parens
				} else if (state === "in parens") {

					// U+0029 RIGHT PARENTHESIS ())
					// Append c to current descriptor. Set state to in descriptor.
					if (c === ")") {
						currentDescriptor = currentDescriptor + c;
						state = "in descriptor";

					// EOF
					// Append current descriptor to descriptors. Jump to the step labeled
					// descriptor parser.
					} else if (c === "") {
						descriptors.push(currentDescriptor);
						parseDescriptors();
						return;

					// Anything else
					// Append c to current descriptor.
					} else {
						currentDescriptor = currentDescriptor + c;
					}

				// After descriptor
				} else if (state === "after descriptor") {

					// Do the following, depending on the value of c:
					// Space character: Stay in this state.
					if (isSpace(c)) {

					// EOF: Jump to the step labeled descriptor parser.
					} else if (c === "") {
						parseDescriptors();
						return;

					// Anything else
					// Set state to in descriptor. Set position to the previous character in input.
					} else {
						state = "in descriptor";
						pos -= 1;

					}
				}

				// Advance position to the next character in input.
				pos += 1;

			// Repeat this step.
			} // (close while true loop)
		}

		// 4. Splitting loop: Collect a sequence of characters that are space
		//    characters or U+002C COMMA characters. If any U+002C COMMA characters
		//    were collected, that is a parse error.
		while (true) {
			collectCharacters(regexLeadingCommasOrSpaces);

			// 5. If position is past the end of input, return candidates and abort these steps.
			if (pos >= inputLength) {
				return candidates; // (we're done, this is the sole return path)
			}

			// 6. Collect a sequence of characters that are not space characters,
			//    and let that be url.
			url = collectCharacters(regexLeadingNotSpaces);

			// 7. Let descriptors be a new empty list.
			descriptors = [];

			// 8. If url ends with a U+002C COMMA character (,), follow these substeps:
			//		(1). Remove all trailing U+002C COMMA characters from url. If this removed
			//         more than one character, that is a parse error.
			if (url.slice(-1) === ",") {
				url = url.replace(regexTrailingCommas, "");
				// (Jump ahead to step 9 to skip tokenization and just push the candidate).
				parseDescriptors();

			//	Otherwise, follow these substeps:
			} else {
				tokenize();
			} // (close else of step 8)

		// 16. Return to the step labeled splitting loop.
		} // (Close of big while loop.)
	}

	/*
	 * Sizes Parser
	 *
	 * By Alex Bell |  MIT License
	 *
	 * Non-strict but accurate and lightweight JS Parser for the string value <img sizes="here">
	 *
	 * Reference algorithm at:
	 * https://html.spec.whatwg.org/multipage/embedded-content.html#parse-a-sizes-attribute
	 *
	 * Most comments are copied in directly from the spec
	 * (except for comments in parens).
	 *
	 * Grammar is:
	 * <source-size-list> = <source-size># [ , <source-size-value> ]? | <source-size-value>
	 * <source-size> = <media-condition> <source-size-value>
	 * <source-size-value> = <length>
	 * http://www.w3.org/html/wg/drafts/html/master/embedded-content.html#attr-img-sizes
	 *
	 * E.g. "(max-width: 30em) 100vw, (max-width: 50em) 70vw, 100vw"
	 * or "(min-width: 30em), calc(30vw - 15px)" or just "30vw"
	 *
	 * Returns the first valid <css-length> with a media condition that evaluates to true,
	 * or "100vw" if all valid media conditions evaluate to false.
	 *
	 */

	function parseSizes(strValue) {

		// (Percentage CSS lengths are not allowed in this case, to avoid confusion:
		// https://html.spec.whatwg.org/multipage/embedded-content.html#valid-source-size-list
		// CSS allows a single optional plus or minus sign:
		// http://www.w3.org/TR/CSS2/syndata.html#numbers
		// CSS is ASCII case-insensitive:
		// http://www.w3.org/TR/CSS2/syndata.html#characters )
		// Spec allows exponential notation for <number> type:
		// http://dev.w3.org/csswg/css-values/#numbers
		var regexCssLengthWithUnits = /^(?:[+-]?[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?(?:ch|cm|em|ex|in|mm|pc|pt|px|rem|vh|vmin|vmax|vw)$/i;

		// (This is a quick and lenient test. Because of optional unlimited-depth internal
		// grouping parens and strict spacing rules, this could get very complicated.)
		var regexCssCalc = /^calc\((?:[0-9a-z \.\+\-\*\/\(\)]+)\)$/i;

		var i;
		var unparsedSizesList;
		var unparsedSizesListLength;
		var unparsedSize;
		var lastComponentValue;
		var size;

		// UTILITY FUNCTIONS

		//  (Toy CSS parser. The goals here are:
		//  1) expansive test coverage without the weight of a full CSS parser.
		//  2) Avoiding regex wherever convenient.
		//  Quick tests: http://jsfiddle.net/gtntL4gr/3/
		//  Returns an array of arrays.)
		function parseComponentValues(str) {
			var chrctr;
			var component = "";
			var componentArray = [];
			var listArray = [];
			var parenDepth = 0;
			var pos = 0;
			var inComment = false;

			function pushComponent() {
				if (component) {
					componentArray.push(component);
					component = "";
				}
			}

			function pushComponentArray() {
				if (componentArray[0]) {
					listArray.push(componentArray);
					componentArray = [];
				}
			}

			// (Loop forwards from the beginning of the string.)
			while (true) {
				chrctr = str.charAt(pos);

				if (chrctr === "") { // ( End of string reached.)
					pushComponent();
					pushComponentArray();
					return listArray;
				} else if (inComment) {
					if ((chrctr === "*") && (str[pos + 1] === "/")) { // (At end of a comment.)
						inComment = false;
						pos += 2;
						pushComponent();
						continue;
					} else {
						pos += 1; // (Skip all characters inside comments.)
						continue;
					}
				} else if (isSpace(chrctr)) {
					// (If previous character in loop was also a space, or if
					// at the beginning of the string, do not add space char to
					// component.)
					if ( (str.charAt(pos - 1) && isSpace( str.charAt(pos - 1) ) ) || !component ) {
						pos += 1;
						continue;
					} else if (parenDepth === 0) {
						pushComponent();
						pos +=1;
						continue;
					} else {
						// (Replace any space character with a plain space for legibility.)
						chrctr = " ";
					}
				} else if (chrctr === "(") {
					parenDepth += 1;
				} else if (chrctr === ")") {
					parenDepth -= 1;
				} else if (chrctr === ",") {
					pushComponent();
					pushComponentArray();
					pos += 1;
					continue;
				} else if ( (chrctr === "/") && (str.charAt(pos + 1) === "*") ) {
					inComment = true;
					pos += 2;
					continue;
				}

				component = component + chrctr;
				pos += 1;
			}
		}

		function isValidNonNegativeSourceSizeValue(s) {
			if (regexCssLengthWithUnits.test(s) && (parseFloat(s) >= 0)) {return true;}
			if (regexCssCalc.test(s)) {return true;}
			// ( http://www.w3.org/TR/CSS2/syndata.html#numbers says:
			// "-0 is equivalent to 0 and is not a negative number." which means that
			// unitless zero and unitless negative zero must be accepted as special cases.)
			if ((s === "0") || (s === "-0") || (s === "+0")) {return true;}
			return false;
		}

		// When asked to parse a sizes attribute from an element, parse a
		// comma-separated list of component values from the value of the element's
		// sizes attribute (or the empty string, if the attribute is absent), and let
		// unparsed sizes list be the result.
		// http://dev.w3.org/csswg/css-syntax/#parse-comma-separated-list-of-component-values

		unparsedSizesList = parseComponentValues(strValue);
		unparsedSizesListLength = unparsedSizesList.length;

		// For each unparsed size in unparsed sizes list:
		for (i = 0; i < unparsedSizesListLength; i++) {
			unparsedSize = unparsedSizesList[i];

			// 1. Remove all consecutive <whitespace-token>s from the end of unparsed size.
			// ( parseComponentValues() already omits spaces outside of parens. )

			// If unparsed size is now empty, that is a parse error; continue to the next
			// iteration of this algorithm.
			// ( parseComponentValues() won't push an empty array. )

			// 2. If the last component value in unparsed size is a valid non-negative
			// <source-size-value>, let size be its value and remove the component value
			// from unparsed size. Any CSS function other than the calc() function is
			// invalid. Otherwise, there is a parse error; continue to the next iteration
			// of this algorithm.
			// http://dev.w3.org/csswg/css-syntax/#parse-component-value
			lastComponentValue = unparsedSize[unparsedSize.length - 1];

			if (isValidNonNegativeSourceSizeValue(lastComponentValue)) {
				size = lastComponentValue;
				unparsedSize.pop();
			} else {
				continue;
			}

			// 3. Remove all consecutive <whitespace-token>s from the end of unparsed
			// size. If unparsed size is now empty, return size and exit this algorithm.
			// If this was not the last item in unparsed sizes list, that is a parse error.
			if (unparsedSize.length === 0) {
				return size;
			}

			// 4. Parse the remaining component values in unparsed size as a
			// <media-condition>. If it does not parse correctly, or it does parse
			// correctly but the <media-condition> evaluates to false, continue to the
			// next iteration of this algorithm.
			// (Parsing all possible compound media conditions in JS is heavy, complicated,
			// and the payoff is unclear. Is there ever an situation where the
			// media condition parses incorrectly but still somehow evaluates to true?
			// Can we just rely on the browser/polyfill to do it?)
			unparsedSize = unparsedSize.join(" ");
			if (!(pf.matchesMedia( unparsedSize ) ) ) {
				continue;
			}

			// 5. Return size and exit this algorithm.
			return size;
		}

		// If the above algorithm exhausts unparsed sizes list without returning a
		// size value, return 100vw.
		return "100vw";
	}

	// namespace
	pf.ns = ("pf" + new Date().getTime()).substr(0, 9);

	// srcset support test
	pf.supSrcset = "srcset" in image;
	pf.supSizes = "sizes" in image;
	pf.supPicture = !!window.HTMLPictureElement;

	// UC browser does claim to support srcset and picture, but not sizes,
	// this extended test reveals the browser does support nothing
	if (pf.supSrcset && pf.supPicture && !pf.supSizes) {
		(function(image2) {
			image.srcset = "data:,a";
			image2.src = "data:,a";
			pf.supSrcset = image.complete === image2.complete;
			pf.supPicture = pf.supSrcset && pf.supPicture;
		})(document.createElement("img"));
	}

	// Safari9 has basic support for sizes, but does't expose the `sizes` idl attribute
	if (pf.supSrcset && !pf.supSizes) {

		(function() {
			var width2 = "data:image/gif;base64,R0lGODlhAgABAPAAAP///wAAACH5BAAAAAAALAAAAAACAAEAAAICBAoAOw==";
			var width1 = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
			var img = document.createElement("img");
			var test = function() {
				var width = img.width;

				if (width === 2) {
					pf.supSizes = true;
				}

				alwaysCheckWDescriptor = pf.supSrcset && !pf.supSizes;

				isSupportTestReady = true;
				// force async
				setTimeout(picturefill);
			};

			img.onload = test;
			img.onerror = test;
			img.setAttribute("sizes", "9px");

			img.srcset = width1 + " 1w," + width2 + " 9w";
			img.src = width1;
		})();

	} else {
		isSupportTestReady = true;
	}

	// using pf.qsa instead of dom traversing does scale much better,
	// especially on sites mixing responsive and non-responsive images
	pf.selShort = "picture>img,img[srcset]";
	pf.sel = pf.selShort;
	pf.cfg = cfg;

	/**
	 * Shortcut property for `devicePixelRatio` ( for easy overriding in tests )
	 */
	pf.DPR = (DPR  || 1 );
	pf.u = units;

	// container of supported mime types that one might need to qualify before using
	pf.types =  types;

	pf.setSize = noop;

	/**
	 * Gets a string and returns the absolute URL
	 * @param src
	 * @returns {String} absolute URL
	 */

	pf.makeUrl = memoize(function(src) {
		anchor.href = src;
		return anchor.href;
	});

	/**
	 * Gets a DOM element or document and a selctor and returns the found matches
	 * Can be extended with jQuery/Sizzle for IE7 support
	 * @param context
	 * @param sel
	 * @returns {NodeList|Array}
	 */
	pf.qsa = function(context, sel) {
		return ( "querySelector" in context ) ? context.querySelectorAll(sel) : [];
	};

	/**
	 * Shortcut method for matchMedia ( for easy overriding in tests )
	 * wether native or pf.mMQ is used will be decided lazy on first call
	 * @returns {boolean}
	 */
	pf.matchesMedia = function() {
		if ( window.matchMedia && (matchMedia( "(min-width: 0.1em)" ) || {}).matches ) {
			pf.matchesMedia = function( media ) {
				return !media || ( matchMedia( media ).matches );
			};
		} else {
			pf.matchesMedia = pf.mMQ;
		}

		return pf.matchesMedia.apply( this, arguments );
	};

	/**
	 * A simplified matchMedia implementation for IE8 and IE9
	 * handles only min-width/max-width with px or em values
	 * @param media
	 * @returns {boolean}
	 */
	pf.mMQ = function( media ) {
		return media ? evalCSS(media) : true;
	};

	/**
	 * Returns the calculated length in css pixel from the given sourceSizeValue
	 * http://dev.w3.org/csswg/css-values-3/#length-value
	 * intended Spec mismatches:
	 * * Does not check for invalid use of CSS functions
	 * * Does handle a computed length of 0 the same as a negative and therefore invalid value
	 * @param sourceSizeValue
	 * @returns {Number}
	 */
	pf.calcLength = function( sourceSizeValue ) {

		var value = evalCSS(sourceSizeValue, true) || false;
		if (value < 0) {
			value = false;
		}

		return value;
	};

	/**
	 * Takes a type string and checks if its supported
	 */

	pf.supportsType = function( type ) {
		return ( type ) ? types[ type ] : true;
	};

	/**
	 * Parses a sourceSize into mediaCondition (media) and sourceSizeValue (length)
	 * @param sourceSizeStr
	 * @returns {*}
	 */
	pf.parseSize = memoize(function( sourceSizeStr ) {
		var match = ( sourceSizeStr || "" ).match(regSize);
		return {
			media: match && match[1],
			length: match && match[2]
		};
	});

	pf.parseSet = function( set ) {
		if ( !set.cands ) {
			set.cands = parseSrcset(set.srcset, set);
		}
		return set.cands;
	};

	/**
	 * returns 1em in css px for html/body default size
	 * function taken from respondjs
	 * @returns {*|number}
	 */
	pf.getEmValue = function() {
		var body;
		if ( !eminpx && (body = document.body) ) {
			var div = document.createElement( "div" ),
				originalHTMLCSS = docElem.style.cssText,
				originalBodyCSS = body.style.cssText;

			div.style.cssText = baseStyle;

			// 1em in a media query is the value of the default font size of the browser
			// reset docElem and body to ensure the correct value is returned
			docElem.style.cssText = fsCss;
			body.style.cssText = fsCss;

			body.appendChild( div );
			eminpx = div.offsetWidth;
			body.removeChild( div );

			//also update eminpx before returning
			eminpx = parseFloat( eminpx, 10 );

			// restore the original values
			docElem.style.cssText = originalHTMLCSS;
			body.style.cssText = originalBodyCSS;

		}
		return eminpx || 16;
	};

	/**
	 * Takes a string of sizes and returns the width in pixels as a number
	 */
	pf.calcListLength = function( sourceSizeListStr ) {
		// Split up source size list, ie ( max-width: 30em ) 100%, ( max-width: 50em ) 50%, 33%
		//
		//                           or (min-width:30em) calc(30% - 15px)
		if ( !(sourceSizeListStr in sizeLengthCache) || cfg.uT ) {
			var winningLength = pf.calcLength( parseSizes( sourceSizeListStr ) );

			sizeLengthCache[ sourceSizeListStr ] = !winningLength ? units.width : winningLength;
		}

		return sizeLengthCache[ sourceSizeListStr ];
	};

	/**
	 * Takes a candidate object with a srcset property in the form of url/
	 * ex. "images/pic-medium.png 1x, images/pic-medium-2x.png 2x" or
	 *     "images/pic-medium.png 400w, images/pic-medium-2x.png 800w" or
	 *     "images/pic-small.png"
	 * Get an array of image candidates in the form of
	 *      {url: "/foo/bar.png", resolution: 1}
	 * where resolution is http://dev.w3.org/csswg/css-values-3/#resolution-value
	 * If sizes is specified, res is calculated
	 */
	pf.setRes = function( set ) {
		var candidates;
		if ( set ) {

			candidates = pf.parseSet( set );

			for ( var i = 0, len = candidates.length; i < len; i++ ) {
				setResolution( candidates[ i ], set.sizes );
			}
		}
		return candidates;
	};

	pf.setRes.res = setResolution;

	pf.applySetCandidate = function( candidates, img ) {
		if ( !candidates.length ) {return;}
		var candidate,
			i,
			j,
			length,
			bestCandidate,
			curSrc,
			curCan,
			candidateSrc,
			abortCurSrc;

		var imageData = img[ pf.ns ];
		var dpr = pf.DPR;

		curSrc = imageData.curSrc || img[curSrcProp];

		curCan = imageData.curCan || setSrcToCur(img, curSrc, candidates[0].set);

		// if we have a current source, we might either become lazy or give this source some advantage
		if ( curCan && curCan.set === candidates[ 0 ].set ) {

			// if browser can abort image request and the image has a higher pixel density than needed
			// and this image isn't downloaded yet, we skip next part and try to save bandwidth
			abortCurSrc = (supportAbort && !img.complete && curCan.res - 0.1 > dpr);

			if ( !abortCurSrc ) {
				curCan.cached = true;

				// if current candidate is "best", "better" or "okay",
				// set it to bestCandidate
				if ( curCan.res >= dpr ) {
					bestCandidate = curCan;
				}
			}
		}

		if ( !bestCandidate ) {

			candidates.sort( ascendingSort );

			length = candidates.length;
			bestCandidate = candidates[ length - 1 ];

			for ( i = 0; i < length; i++ ) {
				candidate = candidates[ i ];
				if ( candidate.res >= dpr ) {
					j = i - 1;

					// we have found the perfect candidate,
					// but let's improve this a little bit with some assumptions ;-)
					if (candidates[ j ] &&
						(abortCurSrc || curSrc !== pf.makeUrl( candidate.url )) &&
						chooseLowRes(candidates[ j ].res, candidate.res, dpr, candidates[ j ].cached)) {

						bestCandidate = candidates[ j ];

					} else {
						bestCandidate = candidate;
					}
					break;
				}
			}
		}

		if ( bestCandidate ) {

			candidateSrc = pf.makeUrl( bestCandidate.url );

			imageData.curSrc = candidateSrc;
			imageData.curCan = bestCandidate;

			if ( candidateSrc !== curSrc ) {
				pf.setSrc( img, bestCandidate );
			}
			pf.setSize( img );
		}
	};

	pf.setSrc = function( img, bestCandidate ) {
		var origWidth;
		img.src = bestCandidate.url;

		// although this is a specific Safari issue, we don't want to take too much different code paths
		if ( bestCandidate.set.type === "image/svg+xml" ) {
			origWidth = img.style.width;
			img.style.width = (img.offsetWidth + 1) + "px";

			// next line only should trigger a repaint
			// if... is only done to trick dead code removal
			if ( img.offsetWidth + 1 ) {
				img.style.width = origWidth;
			}
		}
	};

	pf.getSet = function( img ) {
		var i, set, supportsType;
		var match = false;
		var sets = img [ pf.ns ].sets;

		for ( i = 0; i < sets.length && !match; i++ ) {
			set = sets[i];

			if ( !set.srcset || !pf.matchesMedia( set.media ) || !(supportsType = pf.supportsType( set.type )) ) {
				continue;
			}

			if ( supportsType === "pending" ) {
				set = supportsType;
			}

			match = set;
			break;
		}

		return match;
	};

	pf.parseSets = function( element, parent, options ) {
		var srcsetAttribute, imageSet, isWDescripor, srcsetParsed;

		var hasPicture = parent && parent.nodeName.toUpperCase() === "PICTURE";
		var imageData = element[ pf.ns ];

		if ( imageData.src === undefined || options.src ) {
			imageData.src = getImgAttr.call( element, "src" );
			if ( imageData.src ) {
				setImgAttr.call( element, srcAttr, imageData.src );
			} else {
				removeImgAttr.call( element, srcAttr );
			}
		}

		if ( imageData.srcset === undefined || options.srcset || !pf.supSrcset || element.srcset ) {
			srcsetAttribute = getImgAttr.call( element, "srcset" );
			imageData.srcset = srcsetAttribute;
			srcsetParsed = true;
		}

		imageData.sets = [];

		if ( hasPicture ) {
			imageData.pic = true;
			getAllSourceElements( parent, imageData.sets );
		}

		if ( imageData.srcset ) {
			imageSet = {
				srcset: imageData.srcset,
				sizes: getImgAttr.call( element, "sizes" )
			};

			imageData.sets.push( imageSet );

			isWDescripor = (alwaysCheckWDescriptor || imageData.src) && regWDesc.test(imageData.srcset || "");

			// add normal src as candidate, if source has no w descriptor
			if ( !isWDescripor && imageData.src && !getCandidateForSrc(imageData.src, imageSet) && !imageSet.has1x ) {
				imageSet.srcset += ", " + imageData.src;
				imageSet.cands.push({
					url: imageData.src,
					d: 1,
					set: imageSet
				});
			}

		} else if ( imageData.src ) {
			imageData.sets.push( {
				srcset: imageData.src,
				sizes: null
			} );
		}

		imageData.curCan = null;
		imageData.curSrc = undefined;

		// if img has picture or the srcset was removed or has a srcset and does not support srcset at all
		// or has a w descriptor (and does not support sizes) set support to false to evaluate
		imageData.supported = !( hasPicture || ( imageSet && !pf.supSrcset ) || (isWDescripor && !pf.supSizes) );

		if ( srcsetParsed && pf.supSrcset && !imageData.supported ) {
			if ( srcsetAttribute ) {
				setImgAttr.call( element, srcsetAttr, srcsetAttribute );
				element.srcset = "";
			} else {
				removeImgAttr.call( element, srcsetAttr );
			}
		}

		if (imageData.supported && !imageData.srcset && ((!imageData.src && element.src) ||  element.src !== pf.makeUrl(imageData.src))) {
			if (imageData.src === null) {
				element.removeAttribute("src");
			} else {
				element.src = imageData.src;
			}
		}

		imageData.parsed = true;
	};

	pf.fillImg = function(element, options) {
		var imageData;
		var extreme = options.reselect || options.reevaluate;

		// expando for caching data on the img
		if ( !element[ pf.ns ] ) {
			element[ pf.ns ] = {};
		}

		imageData = element[ pf.ns ];

		// if the element has already been evaluated, skip it
		// unless `options.reevaluate` is set to true ( this, for example,
		// is set to true when running `picturefill` on `resize` ).
		if ( !extreme && imageData.evaled === evalId ) {
			return;
		}

		if ( !imageData.parsed || options.reevaluate ) {
			pf.parseSets( element, element.parentNode, options );
		}

		if ( !imageData.supported ) {
			applyBestCandidate( element );
		} else {
			imageData.evaled = evalId;
		}
	};

	pf.setupRun = function() {
		if ( !alreadyRun || isVwDirty || (DPR !== window.devicePixelRatio) ) {
			updateMetrics();
		}
	};

	// If picture is supported, well, that's awesome.
	if ( pf.supPicture ) {
		picturefill = noop;
		pf.fillImg = noop;
	} else {

		 // Set up picture polyfill by polling the document
		(function() {
			var isDomReady;
			var regReady = window.attachEvent ? /d$|^c/ : /d$|^c|^i/;

			var run = function() {
				var readyState = document.readyState || "";

				timerId = setTimeout(run, readyState === "loading" ? 200 :  999);
				if ( document.body ) {
					pf.fillImgs();
					isDomReady = isDomReady || regReady.test(readyState);
					if ( isDomReady ) {
						clearTimeout( timerId );
					}

				}
			};

			var timerId = setTimeout(run, document.body ? 9 : 99);

			// Also attach picturefill on resize and readystatechange
			// http://modernjavascript.blogspot.com/2013/08/building-better-debounce.html
			var debounce = function(func, wait) {
				var timeout, timestamp;
				var later = function() {
					var last = (new Date()) - timestamp;

					if (last < wait) {
						timeout = setTimeout(later, wait - last);
					} else {
						timeout = null;
						func();
					}
				};

				return function() {
					timestamp = new Date();

					if (!timeout) {
						timeout = setTimeout(later, wait);
					}
				};
			};
			var lastClientWidth = docElem.clientHeight;
			var onResize = function() {
				isVwDirty = Math.max(window.innerWidth || 0, docElem.clientWidth) !== units.width || docElem.clientHeight !== lastClientWidth;
				lastClientWidth = docElem.clientHeight;
				if ( isVwDirty ) {
					pf.fillImgs();
				}
			};

			on( window, "resize", debounce(onResize, 99 ) );
			on( document, "readystatechange", run );
		})();
	}

	pf.picturefill = picturefill;
	//use this internally for easy monkey patching/performance testing
	pf.fillImgs = picturefill;
	pf.teardownRun = noop;

	/* expose methods for testing */
	picturefill._ = pf;

	window.picturefillCFG = {
		pf: pf,
		push: function(args) {
			var name = args.shift();
			if (typeof pf[name] === "function") {
				pf[name].apply(pf, args);
			} else {
				cfg[name] = args[0];
				if (alreadyRun) {
					pf.fillImgs( { reselect: true } );
				}
			}
		}
	};

	while (setOptions && setOptions.length) {
		window.picturefillCFG.push(setOptions.shift());
	}

	/* expose picturefill */
	window.picturefill = picturefill;

	/* expose picturefill */
	if ( typeof module === "object" && typeof module.exports === "object" ) {
		// CommonJS, just export
		module.exports = picturefill;
	} else if ( true ) {
		// AMD support
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() { return picturefill; }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}

	// IE8 evals this sync, so it must be the last thing we do
	if ( !pf.supPicture ) {
		types[ "image/webp" ] = detectTypeSupport("image/webp", "data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA==" );
	}

} )( window, document );


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * sifter.js
 * Copyright (c) 2013 Brian Reavis & contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
 * file except in compliance with the License. You may obtain a copy of the License at:
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 *
 * @author Brian Reavis <brian@thirdroute.com>
 */

(function(root, factory) {
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof exports === 'object') {
		module.exports = factory();
	} else {
		root.Sifter = factory();
	}
}(this, function() {

	/**
	 * Textually searches arrays and hashes of objects
	 * by property (or multiple properties). Designed
	 * specifically for autocomplete.
	 *
	 * @constructor
	 * @param {array|object} items
	 * @param {object} items
	 */
	var Sifter = function(items, settings) {
		this.items = items;
		this.settings = settings || {diacritics: true};
	};

	/**
	 * Splits a search string into an array of individual
	 * regexps to be used to match results.
	 *
	 * @param {string} query
	 * @returns {array}
	 */
	Sifter.prototype.tokenize = function(query) {
		query = trim(String(query || '').toLowerCase());
		if (!query || !query.length) return [];

		var i, n, regex, letter;
		var tokens = [];
		var words = query.split(/ +/);

		for (i = 0, n = words.length; i < n; i++) {
			regex = escape_regex(words[i]);
			if (this.settings.diacritics) {
				for (letter in DIACRITICS) {
					if (DIACRITICS.hasOwnProperty(letter)) {
						regex = regex.replace(new RegExp(letter, 'g'), DIACRITICS[letter]);
					}
				}
			}
			tokens.push({
				string : words[i],
				regex  : new RegExp(regex, 'i')
			});
		}

		return tokens;
	};

	/**
	 * Iterates over arrays and hashes.
	 *
	 * ```
	 * this.iterator(this.items, function(item, id) {
	 *    // invoked for each item
	 * });
	 * ```
	 *
	 * @param {array|object} object
	 */
	Sifter.prototype.iterator = function(object, callback) {
		var iterator;
		if (is_array(object)) {
			iterator = Array.prototype.forEach || function(callback) {
				for (var i = 0, n = this.length; i < n; i++) {
					callback(this[i], i, this);
				}
			};
		} else {
			iterator = function(callback) {
				for (var key in this) {
					if (this.hasOwnProperty(key)) {
						callback(this[key], key, this);
					}
				}
			};
		}

		iterator.apply(object, [callback]);
	};

	/**
	 * Returns a function to be used to score individual results.
	 *
	 * Good matches will have a higher score than poor matches.
	 * If an item is not a match, 0 will be returned by the function.
	 *
	 * @param {object|string} search
	 * @param {object} options (optional)
	 * @returns {function}
	 */
	Sifter.prototype.getScoreFunction = function(search, options) {
		var self, fields, tokens, token_count;

		self        = this;
		search      = self.prepareSearch(search, options);
		tokens      = search.tokens;
		fields      = search.options.fields;
		token_count = tokens.length;

		/**
		 * Calculates how close of a match the
		 * given value is against a search token.
		 *
		 * @param {mixed} value
		 * @param {object} token
		 * @return {number}
		 */
		var scoreValue = function(value, token) {
			var score, pos;

			if (!value) return 0;
			value = String(value || '');
			pos = value.search(token.regex);
			if (pos === -1) return 0;
			score = token.string.length / value.length;
			if (pos === 0) score += 0.5;
			return score;
		};

		/**
		 * Calculates the score of an object
		 * against the search query.
		 *
		 * @param {object} token
		 * @param {object} data
		 * @return {number}
		 */
		var scoreObject = (function() {
			var field_count = fields.length;
			if (!field_count) {
				return function() { return 0; };
			}
			if (field_count === 1) {
				return function(token, data) {
					return scoreValue(data[fields[0]], token);
				};
			}
			return function(token, data) {
				for (var i = 0, sum = 0; i < field_count; i++) {
					sum += scoreValue(data[fields[i]], token);
				}
				return sum / field_count;
			};
		})();

		if (!token_count) {
			return function() { return 0; };
		}
		if (token_count === 1) {
			return function(data) {
				return scoreObject(tokens[0], data);
			};
		}

		if (search.options.conjunction === 'and') {
			return function(data) {
				var score;
				for (var i = 0, sum = 0; i < token_count; i++) {
					score = scoreObject(tokens[i], data);
					if (score <= 0) return 0;
					sum += score;
				}
				return sum / token_count;
			};
		} else {
			return function(data) {
				for (var i = 0, sum = 0; i < token_count; i++) {
					sum += scoreObject(tokens[i], data);
				}
				return sum / token_count;
			};
		}
	};

	/**
	 * Returns a function that can be used to compare two
	 * results, for sorting purposes. If no sorting should
	 * be performed, `null` will be returned.
	 *
	 * @param {string|object} search
	 * @param {object} options
	 * @return function(a,b)
	 */
	Sifter.prototype.getSortFunction = function(search, options) {
		var i, n, self, field, fields, fields_count, multiplier, multipliers, get_field, implicit_score, sort;

		self   = this;
		search = self.prepareSearch(search, options);
		sort   = (!search.query && options.sort_empty) || options.sort;

		/**
		 * Fetches the specified sort field value
		 * from a search result item.
		 *
		 * @param  {string} name
		 * @param  {object} result
		 * @return {mixed}
		 */
		get_field = function(name, result) {
			if (name === '$score') return result.score;
			return self.items[result.id][name];
		};

		// parse options
		fields = [];
		if (sort) {
			for (i = 0, n = sort.length; i < n; i++) {
				if (search.query || sort[i].field !== '$score') {
					fields.push(sort[i]);
				}
			}
		}

		// the "$score" field is implied to be the primary
		// sort field, unless it's manually specified
		if (search.query) {
			implicit_score = true;
			for (i = 0, n = fields.length; i < n; i++) {
				if (fields[i].field === '$score') {
					implicit_score = false;
					break;
				}
			}
			if (implicit_score) {
				fields.unshift({field: '$score', direction: 'desc'});
			}
		} else {
			for (i = 0, n = fields.length; i < n; i++) {
				if (fields[i].field === '$score') {
					fields.splice(i, 1);
					break;
				}
			}
		}

		multipliers = [];
		for (i = 0, n = fields.length; i < n; i++) {
			multipliers.push(fields[i].direction === 'desc' ? -1 : 1);
		}

		// build function
		fields_count = fields.length;
		if (!fields_count) {
			return null;
		} else if (fields_count === 1) {
			field = fields[0].field;
			multiplier = multipliers[0];
			return function(a, b) {
				return multiplier * cmp(
					get_field(field, a),
					get_field(field, b)
				);
			};
		} else {
			return function(a, b) {
				var i, result, a_value, b_value, field;
				for (i = 0; i < fields_count; i++) {
					field = fields[i].field;
					result = multipliers[i] * cmp(
						get_field(field, a),
						get_field(field, b)
					);
					if (result) return result;
				}
				return 0;
			};
		}
	};

	/**
	 * Parses a search query and returns an object
	 * with tokens and fields ready to be populated
	 * with results.
	 *
	 * @param {string} query
	 * @param {object} options
	 * @returns {object}
	 */
	Sifter.prototype.prepareSearch = function(query, options) {
		if (typeof query === 'object') return query;

		options = extend({}, options);

		var option_fields     = options.fields;
		var option_sort       = options.sort;
		var option_sort_empty = options.sort_empty;

		if (option_fields && !is_array(option_fields)) options.fields = [option_fields];
		if (option_sort && !is_array(option_sort)) options.sort = [option_sort];
		if (option_sort_empty && !is_array(option_sort_empty)) options.sort_empty = [option_sort_empty];

		return {
			options : options,
			query   : String(query || '').toLowerCase(),
			tokens  : this.tokenize(query),
			total   : 0,
			items   : []
		};
	};

	/**
	 * Searches through all items and returns a sorted array of matches.
	 *
	 * The `options` parameter can contain:
	 *
	 *   - fields {string|array}
	 *   - sort {array}
	 *   - score {function}
	 *   - filter {bool}
	 *   - limit {integer}
	 *
	 * Returns an object containing:
	 *
	 *   - options {object}
	 *   - query {string}
	 *   - tokens {array}
	 *   - total {int}
	 *   - items {array}
	 *
	 * @param {string} query
	 * @param {object} options
	 * @returns {object}
	 */
	Sifter.prototype.search = function(query, options) {
		var self = this, value, score, search, calculateScore;
		var fn_sort;
		var fn_score;

		search  = this.prepareSearch(query, options);
		options = search.options;
		query   = search.query;

		// generate result scoring function
		fn_score = options.score || self.getScoreFunction(search);

		// perform search and sort
		if (query.length) {
			self.iterator(self.items, function(item, id) {
				score = fn_score(item);
				if (options.filter === false || score > 0) {
					search.items.push({'score': score, 'id': id});
				}
			});
		} else {
			self.iterator(self.items, function(item, id) {
				search.items.push({'score': 1, 'id': id});
			});
		}

		fn_sort = self.getSortFunction(search, options);
		if (fn_sort) search.items.sort(fn_sort);

		// apply limits
		search.total = search.items.length;
		if (typeof options.limit === 'number') {
			search.items = search.items.slice(0, options.limit);
		}

		return search;
	};

	// utilities
	// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

	var cmp = function(a, b) {
		if (typeof a === 'number' && typeof b === 'number') {
			return a > b ? 1 : (a < b ? -1 : 0);
		}
		a = asciifold(String(a || ''));
		b = asciifold(String(b || ''));
		if (a > b) return 1;
		if (b > a) return -1;
		return 0;
	};

	var extend = function(a, b) {
		var i, n, k, object;
		for (i = 1, n = arguments.length; i < n; i++) {
			object = arguments[i];
			if (!object) continue;
			for (k in object) {
				if (object.hasOwnProperty(k)) {
					a[k] = object[k];
				}
			}
		}
		return a;
	};

	var trim = function(str) {
		return (str + '').replace(/^\s+|\s+$|/g, '');
	};

	var escape_regex = function(str) {
		return (str + '').replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
	};

	var is_array = Array.isArray || (typeof $ !== 'undefined' && $.isArray) || function(object) {
		return Object.prototype.toString.call(object) === '[object Array]';
	};

	var DIACRITICS = {
		'a': '[aÀÁÂÃÄÅàáâãäåĀāąĄ]',
		'c': '[cÇçćĆčČ]',
		'd': '[dđĐďĎð]',
		'e': '[eÈÉÊËèéêëěĚĒēęĘ]',
		'i': '[iÌÍÎÏìíîïĪī]',
		'l': '[lłŁ]',
		'n': '[nÑñňŇńŃ]',
		'o': '[oÒÓÔÕÕÖØòóôõöøŌō]',
		'r': '[rřŘ]',
		's': '[sŠšśŚ]',
		't': '[tťŤ]',
		'u': '[uÙÚÛÜùúûüůŮŪū]',
		'y': '[yŸÿýÝ]',
		'z': '[zŽžżŻźŹ]'
	};

	var asciifold = (function() {
		var i, n, k, chunk;
		var foreignletters = '';
		var lookup = {};
		for (k in DIACRITICS) {
			if (DIACRITICS.hasOwnProperty(k)) {
				chunk = DIACRITICS[k].substring(2, DIACRITICS[k].length - 1);
				foreignletters += chunk;
				for (i = 0, n = chunk.length; i < n; i++) {
					lookup[chunk.charAt(i)] = k;
				}
			}
		}
		var regexp = new RegExp('[' +  foreignletters + ']', 'g');
		return function(str) {
			return str.replace(regexp, function(foreignletter) {
				return lookup[foreignletter];
			}).toLowerCase();
		};
	})();


	// export
	// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

	return Sifter;
}));



/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * microplugin.js
 * Copyright (c) 2013 Brian Reavis & contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
 * file except in compliance with the License. You may obtain a copy of the License at:
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 *
 * @author Brian Reavis <brian@thirdroute.com>
 */

(function(root, factory) {
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof exports === 'object') {
		module.exports = factory();
	} else {
		root.MicroPlugin = factory();
	}
}(this, function() {
	var MicroPlugin = {};

	MicroPlugin.mixin = function(Interface) {
		Interface.plugins = {};

		/**
		 * Initializes the listed plugins (with options).
		 * Acceptable formats:
		 *
		 * List (without options):
		 *   ['a', 'b', 'c']
		 *
		 * List (with options):
		 *   [{'name': 'a', options: {}}, {'name': 'b', options: {}}]
		 *
		 * Hash (with options):
		 *   {'a': { ... }, 'b': { ... }, 'c': { ... }}
		 *
		 * @param {mixed} plugins
		 */
		Interface.prototype.initializePlugins = function(plugins) {
			var i, n, key;
			var self  = this;
			var queue = [];

			self.plugins = {
				names     : [],
				settings  : {},
				requested : {},
				loaded    : {}
			};

			if (utils.isArray(plugins)) {
				for (i = 0, n = plugins.length; i < n; i++) {
					if (typeof plugins[i] === 'string') {
						queue.push(plugins[i]);
					} else {
						self.plugins.settings[plugins[i].name] = plugins[i].options;
						queue.push(plugins[i].name);
					}
				}
			} else if (plugins) {
				for (key in plugins) {
					if (plugins.hasOwnProperty(key)) {
						self.plugins.settings[key] = plugins[key];
						queue.push(key);
					}
				}
			}

			while (queue.length) {
				self.require(queue.shift());
			}
		};

		Interface.prototype.loadPlugin = function(name) {
			var self    = this;
			var plugins = self.plugins;
			var plugin  = Interface.plugins[name];

			if (!Interface.plugins.hasOwnProperty(name)) {
				throw new Error('Unable to find "' +  name + '" plugin');
			}

			plugins.requested[name] = true;
			plugins.loaded[name] = plugin.fn.apply(self, [self.plugins.settings[name] || {}]);
			plugins.names.push(name);
		};

		/**
		 * Initializes a plugin.
		 *
		 * @param {string} name
		 */
		Interface.prototype.require = function(name) {
			var self = this;
			var plugins = self.plugins;

			if (!self.plugins.loaded.hasOwnProperty(name)) {
				if (plugins.requested[name]) {
					throw new Error('Plugin has circular dependency ("' + name + '")');
				}
				self.loadPlugin(name);
			}

			return plugins.loaded[name];
		};

		/**
		 * Registers a plugin.
		 *
		 * @param {string} name
		 * @param {function} fn
		 */
		Interface.define = function(name, fn) {
			Interface.plugins[name] = {
				'name' : name,
				'fn'   : fn
			};
		};
	};

	var utils = {
		isArray: Array.isArray || function(vArg) {
			return Object.prototype.toString.call(vArg) === '[object Array]';
		}
	};

	return MicroPlugin;
}));

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(3);

"use strict";

var PLUGIN_NAME = "pageloader";

var DEFAULTS = {
	animationSpeed: {
		hide: 500,
		show: 700
	},
	urlSuffix: '/index.shtml',
	eventPrefix: 'PAGELOADER',
	callback: function callback() {}
};

/**
 *
 * @param element
 * @param options
 * @constructor
 */
var PageLoader = function PageLoader(element, options) {
	this.element = element;
	this.$t = $(this.element);

	this.historySupported = 'pushState' in history;

	this.options = $.extend(true, {}, DEFAULTS, options);

	this._defaults = DEFAULTS;

	this.saveHistory_(window.location.pathname, document.title, true);

	this.bindEvents_();
};

PageLoader.prototype.bindEvents_ = function () {
	var self_ = this;

	/**
  * triggers after content is loaded, rendered and revealed
  */
	this.$t.on(self_.options.eventPrefix + '_COMPLETE', function (event, url, title, saveHistory) {

		if ($.isFunction(self_.options.callback)) {
			self_.options.callback.call(self_);
		}

		if (saveHistory) {
			self_.saveHistory_(url, title);
		} else {
			document.title = title;
		}
	});

	/**
  * history popstate
  */
	$(window).on('popstate.pageloader', function () {
		self_.$t.trigger(self_.options.eventPrefix + '_HISTORY_POPPED');
	});
};

/**
 *
 * @param url
 * @param selector
 * @param title
 * @param saveHistory
 */
PageLoader.prototype.loadPage = function (url, selector, title, saveHistory) {
	var self_ = this;

	this.$t.animate({
		opacity: 0
	}, this.options.animationSpeed.hide, function () {
		self_.$t.load(url + self_.options.urlSuffix + ' ' + selector, function () {
			self_.$t.animate({
				opacity: 1
			}, self_.options.animationSpeed.show, function () {
				self_.$t.trigger(self_.options.eventPrefix + '_COMPLETE', [url, title, saveHistory]);
			});
		});
	});
};

/**
 *
 * @param url
 * @param title
 * @param init
 * @returns {boolean}
 * @private
 */
PageLoader.prototype.saveHistory_ = function (url, title, init) {
	if (!this.historySupported) {
		return false;
	}

	var state = history.state || {};
	state.contentUrl = url;
	state.pageTitle = title;

	if (init) {
		history.replaceState(state, title, window.location.origin + url);
	} else {
		history.pushState(state, title, window.location.origin + url);
		document.title = title;
	}

	this.$t.trigger(this.options.eventPrefix + '_HISTORY_SAVED', [url, title]);
};

module.exports = PageLoader;

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _connectWebActions = __webpack_require__(407);

var _connectWebActions2 = _interopRequireDefault(_connectWebActions);

var _decorate = __webpack_require__(152);

var _autoTitleLinksWithBlankTarget = __webpack_require__(415);

var _autoTitleLinksWithBlankTarget2 = _interopRequireDefault(_autoTitleLinksWithBlankTarget);

var _safeBlankLinks = __webpack_require__(416);

var _safeBlankLinks2 = _interopRequireDefault(_safeBlankLinks);

var _index = __webpack_require__(417);

var _index2 = _interopRequireDefault(_index);

var _configureWebComponents = __webpack_require__(421);

var _configureWebComponents2 = _interopRequireDefault(_configureWebComponents);

var _configureWebActions = __webpack_require__(453);

var _configureWebActions2 = _interopRequireDefault(_configureWebActions);

__webpack_require__(457);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import 'bootstrap/collapse'; TODO - use this path if using BS4 bootstrap/js/dist/collapse

// import cookiesPolicy from 'fg-frontend/components/CookiesPolicy/index';
(0, _index2.default)({
  imgSrc: '/img/cookie-policy/cookie.png',
  disableRwdImg: false,
  enableTechnicalButton: true,
  messages: {
    en: {
      perex: 'This website uses cookies to provide social media functions and analyse the visit rate. By clicking on the "Enable all cookies" button, you agree to storage and use of cookies. Detailed information about cookies <a class="cookies-policy__link" href="/en/information-about-cookies">see here</a>.'
    }
  },
  settingsMessages: {
    en: {
      perex: 'You can set which cookies will be processed here. For more information, please go to <a class="cookies-settings__link" href="/en/information-about-cookies">Cookie information</a>'
    }
  }
});
// import phoneLink from 'fg-frontend/components/PhoneLink';

(0, _decorate.connectWebComponents)(_configureWebComponents2.default);
(0, _connectWebActions2.default)(_configureWebActions2.default, ['keyup']);
(0, _autoTitleLinksWithBlankTarget2.default)();
// phoneLink();

// Nastaveni atributu 'noopener' vsem target="_blank" odkazum, ktere ho nemaji
(0, _safeBlankLinks2.default)();

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.executeWebAction = undefined;

var _dataset = __webpack_require__(106);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } // 

var configureActionsInternal = void 0;

var executeWebAction = exports.executeWebAction = function executeWebAction(action, payload, event) {
  if (!configureActionsInternal) {
    throw new Error('Akce nejsou nastavené. Zavolejte funkci connectWebActions');
  }
  configureActionsInternal(action)(payload, event);
};

var handleActionEvent = function handleActionEvent(e) {
  var closest = e.target.closest ? e.target.closest('[data-action][data-action-trigger="' + e.type + '"]') : null;
  if (!closest) {
    return;
  }
  var dataset = (0, _dataset.getDataSet)(closest);
  var action = dataset.action;

  executeWebAction(action, dataset, e);
};

/**
 * Připojí na document listener na elementy, které mají na sobě data atributy data-action a data-action-trigger
 * Atributem data-action-trigger je definováno při jakém eventu se akce vykoná
 * Atributem data-action je definováno jaká akce se vykoná
 * Všechny data attributy jsou předány jako payload vykonávané akci
 * Je nasloucháno pouze na eventy 'click' a 'partialUpdateComplete', pokud
 * potřebujete naslouchat i na jiné eventy, tak je defitujte do parametru customEvents
 *
 */

exports.default = function (configureActions) {
  var customEvents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  configureActionsInternal = configureActions;
  var events = [
  // 'focus',
  // 'blur',
  // 'reset',
  // 'submit',
  // 'keydown',
  // 'keypress',
  // 'keyup',
  // 'mouseenter',
  // 'mouseover',
  // 'mousemove',
  // 'mousedown',
  // 'mouseup',
  // 'auxclick',
  'click',
  // 'change',
  // 'dblclick',
  // 'contextmenu',
  // 'wheel',
  // 'mouseleave',
  // 'mouseout',
  // 'select',
  // 'dragstart',
  // 'drag',
  // 'dragend',
  // 'dragenter',
  // 'dragover',
  // 'dragleave',
  // 'drop',
  // Partial update
  'partialUpdateComplete'].concat(_toConsumableArray(customEvents));
  events.forEach(function (event) {
    document.addEventListener(event, handleActionEvent);
  });
};

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// 

var decorateAdd = exports.decorateAdd = function decorateAdd(id, dataset, element) {
  return {
    type: 'DECORATE_ADD',
    payload: {
      id: id,
      dataset: dataset,
      element: element.cloneNode(true),
      // používá se zejména při lazy loadingu, kdy se ještě vkládá do domu než je komponenta načtená
      // to zabraňuje skákání a blikání stránky
      innerHTML: element.innerHTML
    }
  };
};

var decorateSetValue = exports.decorateSetValue = function decorateSetValue(id, value) {
  var fromHTMLParsing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    type: 'DECORATE_SET_VALUE',
    payload: { id: id, value: value, fromHTMLParsing: fromHTMLParsing }
  };
};

var decorateSetInstance = exports.decorateSetInstance = function decorateSetInstance(id, instance) {
  return {
    type: 'DECORATE_SET_INSTANCE',
    payload: { id: id, instance: instance }
  };
};

var decorateRemove = exports.decorateRemove = function decorateRemove(id) {
  return {
    type: 'DECORATE_REMOVE',
    payload: { id: id }
  };
};

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// 
var nextId = 0;

var getNextUniqueId = exports.getNextUniqueId = function getNextUniqueId() {
  nextId += 1;
  return "id" + nextId.toString(36);
};

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  alterHistory: false,
  onAlterHistory: null,
  clearCache: true,
  command: null,
  eventName: null,
  data: null,
  dataMerge: null,
  exceptParams: null,
  historyScope: 'allData',
  removeContainerWidgetData: null,
  replaceTargetContent: null,
  replaceContents: null,
  removeFormId: false,
  removeFormWidgetData: null,
  stopReplacement: false, // TODO @JNO
  suppressRedirect: false,
  suppressSubmitEvent: false,
  target: null,
  url: null,
  timeout: 60000,
  layoutContext: null,
  cache: false, // xhr cache
  generateReplacementContainer: true,
  formsChangesDetection: false,
  onFormsChangesDetect: null,
  onBeforeExecute: null,
  disposeAndDecorateLifecycle: true,
  includeToProgress: true,
  originalTarget: null,
  mergeWithTargetSettings: true,
  dataFromAllFormsInDocument: true,
  historyReplaceState: false,
  historyPopState: false,
  globalTarget: 'dynamicArea',
  scroll: false,
  scrollOffset: 25,
  scrollDuration: 200,
  rememberPagination: false,
  persistFocus: true,
  pick: null,
  moveUrlQueryParamsToFormDataOnPost: false,
  omit: null,
  headers: null,
  collectFormData: true
};

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = isEqual;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61), __webpack_require__(58)(module)))

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidForRefresh = exports.getRefreshEventsValidAttrs = exports.getNormalizedRefreshEvents = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; // 


var _string = __webpack_require__(107);

var _array = __webpack_require__(413);

var normalizeEvent = function normalizeEvent(event, type) {
  if ((typeof event === 'undefined' ? 'undefined' : _typeof(event)) === 'object') {
    // eslint-disable-next-line
    return normalizeObjectEvent(event);
  }

  event = event.replace(/ /g, '');
  var events = event.split(',');
  var typedEvents = void 0;
  if (type) {
    typedEvents = [];
    events.forEach(function (event) {
      typedEvents.push((0, _string.toCamelCase)(event + '-' + type));
    });
  }
  return typedEvents || events;
};

var normalizeObjectEvent = function normalizeObjectEvent(event) {
  var events = event.event;
  return normalizeEvent(events, event.type);
};

var getNormalizedRefreshEvents = exports.getNormalizedRefreshEvents = function getNormalizedRefreshEvents(refreshEvents) {
  var normalizedRefreshEvents = [];

  if (refreshEvents) {
    if (Array.isArray(refreshEvents)) {
      refreshEvents.forEach(function (refreshEvent) {
        normalizedRefreshEvents = normalizedRefreshEvents.concat(normalizeEvent(refreshEvent));
      });
    } else {
      normalizedRefreshEvents = normalizeEvent(refreshEvents);
    }
  }
  return normalizedRefreshEvents.map(function (event) {
    return event.toLowerCase();
  });
};

var separateAttrsFromObject = function separateAttrsFromObject(event, separatedAttrs) {
  var events = event.event;
  var eventsArray = normalizeEvent(events, event.type);
  var attrs = event.validAttributes;

  if (attrs) {
    eventsArray.forEach(function (event) {
      separatedAttrs[event] = attrs;
    });
  }
  return separatedAttrs;
};

var getRefreshEventsValidAttrs = exports.getRefreshEventsValidAttrs = function getRefreshEventsValidAttrs(eventName, refreshEvents) {
  var separatedAttrs = {};
  if (refreshEvents) {
    if (Array.isArray(refreshEvents)) {
      refreshEvents.forEach(function (refreshEvent) {
        if ((typeof refreshEvent === 'undefined' ? 'undefined' : _typeof(refreshEvent)) === 'object') {
          separatedAttrs = separateAttrsFromObject(refreshEvent, separatedAttrs);
        }
      });
    } else if ((typeof refreshEvents === 'undefined' ? 'undefined' : _typeof(refreshEvents)) === 'object') {
      separatedAttrs = separateAttrsFromObject(refreshEvents, separatedAttrs);
    }
  }

  return separatedAttrs[eventName] || null;
};

var isValidForRefresh = exports.isValidForRefresh = function isValidForRefresh(event, refreshEvents, valueForComparing) {
  var validAttrs = getRefreshEventsValidAttrs(event.type, refreshEvents);
  var eventAttrs = event.attr;
  if (validAttrs && event.attr) {
    var isValid = 1;
    Object.keys(validAttrs).forEach(function (key) {
      var eventAttr = eventAttrs[key];
      var value = validAttrs[key];
      value = value === '@value' ? valueForComparing : value;

      if (Array.isArray(value)) {
        value = value.map(function (item) {
          return item.toString();
        });
        if (Array.isArray(eventAttr)) {
          // eslint-disable-next-line
          isValid &= (0, _array.arrayContainsSameItem)(eventAttr, value);
        } else {
          // eslint-disable-next-line
          isValid &= value.includes(eventAttr);
        }
      } else {
        value = value.toString();
        if (Array.isArray(eventAttr)) {
          // eslint-disable-next-line
          isValid &= eventAttr.includes(value);
        } else {
          // eslint-disable-next-line
          isValid &= value == eventAttr;
        }
      }
    });
    return !!isValid;
  }
  return true;
};

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// 
var arrayContainsSameItem = exports.arrayContainsSameItem = function arrayContainsSameItem(arr1, arr2) {
  var found = false;
  for (var i = 0; i < arr2.length; i++) {
    if (arr1.indexOf(arr2[i]) > -1) {
      found = true;
      break;
    }
  }
  return found;
};

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule shallowEqual
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// 

var labels = {
  cs: 'Odkaz se otevře v novém okně',
  sk: 'Odkaz sa otvorí v novom okne',
  en: 'Link opens in a new window',
  'en-GB': 'Link opens in a new window',
  'en-US': 'Link opens in a new window',
  de: 'Link im neuen Fenster öffnen',
  bg: 'Отваря се връзката в нов прозорец',
  es: 'El enlace se abre en una nueva ventana',
  da: 'Link åbner i et nyt vindue',
  et: 'Link avaneb uues aknas',
  el: 'Ο σύνδεσμος ανοίγει σε νέο παράθυρο',
  fr: 'Lien ouvre dans une nouvelle fenêtre',
  ga: 'Osclaíonn an nasc i bhfuinneog nua',
  hr: 'Link se otvara u novom prozoru',
  it: 'Link si apre in una nuova finestra',
  lv: 'Saite atveras jaunā logā',
  lt: 'Nuoroda atsidaro naujame lange',
  hu: 'Hivatkozás megnyit egy új ablakban',
  mt: 'Link jiftaħ tieqa ġdida',
  nl: 'Link opent in een nieuw venster',
  pl: 'Otwiera link w nowym oknie',
  pt: 'O link se abre em uma nova janela',
  ro: 'Link deschide într-o fereastră nouă',
  sl: 'Povezava se odpre v novem oknu',
  fi: 'Linkki avautuu uuteen ikkunaan',
  sv: 'Länken öppnas i ett nytt fönster',
  ru: 'Ссылка откроется в новом окне'
};

var getLang = function getLang() {
  return document.documentElement.getAttribute('lang') || 'en';
};

/**
 Pokud máte na stránce anchor s target="blank" atributem, který nemá vyplněný title, nasadí se
 na něj automaticky titulek ve smyslu "Otevře se v novém okně"
 dle langu stránky (atribut html lang).
 Texty jsou definované ve třídě TargetBlankAutoTitle. Lze je definovat ručně při incicalizaci
 např:  autoTitleLinksWithBlankTarget({cs: 'Lorem ipsum', sk: 'Dolor sit'});

 Pro weby mimo standardní kolekci jazyků (en, de, sk, cz) doporučuji překlad korekturovat.
 Byl pouze automaticky přeložen.

 Korekturované překlady můžete dávat do issue https://ep.fg.cz/issues/60227

 Zkratky jazyků jsou z ISO 639-1 normy
 */

exports.default = function () {
  var optLabels = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  labels = _extends({}, labels, optLabels);
  document.addEventListener('mouseover', function (e) {
    var href = e.target.closest('a[target=_blank]:not([data-action])');
    if (href && href.getAttribute('title') == null) {
      href.setAttribute('title', labels[getLang()]);
    }
  });
};

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// 

/**
 * SafeBlankLinks: nastaveni atributu 'noopener' vsem target="_blank" odkazum, ktere ho nemaji
 *
 */

var checkNode = function checkNode(node) {
  if (node.nodeType === 1 || node.nodeType === 9) {
    var blankLinks = node.querySelectorAll('a[target="_blank"]:not([rel="noopener"])');
    [].concat(_toConsumableArray(blankLinks)).forEach(function (blankLink) {
      setRel(blankLink);
    });
  }
};
var setRel = function setRel(node) {
  if (node.nodeType === 1 && node.tagName === 'A' && node.target == '_blank' && node.rel != 'noopener') {
    node.rel = 'noopener';
  }
};

exports.default = function () {
  checkNode(document);

  if (window.MutationObserver) {
    var observer = new MutationObserver(function (mutations, observer) {
      for (var i = 0; i < mutations.length; i++) {
        for (var j = 0; j < mutations[i].addedNodes.length; j++) {
          checkNode(mutations[i].addedNodes[j]);
        }
      }
    });

    observer.observe(document.body, {
      atributes: false,
      childList: true,
      subtree: true
    });
  }
};

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _CookiesPolicy = __webpack_require__(418);

var _CookiesPolicy2 = _interopRequireDefault(_CookiesPolicy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _CookiesPolicy2.default;

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CookiePolicy = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * JS oznámení o použití cookies na webu
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

__webpack_require__(419);

var _motive = __webpack_require__(420);

var _motive2 = _interopRequireDefault(_motive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// eslint-disable-next-line no-unused-vars
var VERSION = '3.1.3';

var FRAGMENTS = {
  ACCEPT_ALL_BTN: '[data-fragment="cp.acceptAllBtn"]',
  ACCEPT_SELECTED_BTN: '[data-fragment="cp.acceptSelectedButton"]',
  CLOSE_BTN: '[data-fragment="cp.closeButton"]',
  OPEN_SETTINGS_BTN: '[data-fragment="cp.openSettingsButton"]',
  OPEN_SETTINGS_LINK: '[data-fragment="cp.openSettingsLink"]',
  PANE: '[data-fragment="cp.pane"]',
  SETTINGS: '[data-fragment="cp.settings"]',
  SETTINGS_CHECKBOX_ANALYTICS: '[data-fragment="cp.checkboxAnalytics"]',
  SETTINGS_CHECKBOX_ANALYTICS_MARKETING: '[data-fragment="cp.checkboxAnalyticsMarketing"]',
  SETTINGS_CHECKBOX_MARKETING: '[data-fragment="cp.checkboxMarketing"]',
  SETTINGS_CLOSE_BTN: '[data-fragment="cp.settingsCloseButton"]',
  SETTINGS_STATE_TEXT: '[data-fragment="cp.settingsStateText"]',
  TECHNICAL_BTN: '[data-fragment="cp.technicalButton"]'
};

var LEVEL = {
  CONFIG: 1, // uzivatel videl panel a chce nastavit uroven
  TECHNICAL: 2, // uz. souhlasi s technickymi cookies (min uroven po ulozeni nastaveni)
  ANALYTICS: 3, // uz. souhlasi s technickymi A analytickymi cookies (nepouzito)
  MARKETING: 4, // uz. souhlasi s technickymi A marketingovymi cookies
  ANALYTICS_MARKETING: 5 // uz. souhlasi s technickymi A analytickymi A marketingovymi cookies
};

/**
 * Deep merge of multiple Objects
 *
 * Examples:
 * obj = merge({x: {a: 2}}, {x: {b: 3}})                => { x: { a: 2, b: 3 } }
 * obj = merge({x: {a: 2}}, {x: {b: 3}}, {x: {a: 1}})   => { x: { a: 1, b: 3 } }

 * @return {{}}
 */
var merge = function merge() {
  var ret = {},
      i = 0,
      il = arguments.length,
      p = void 0;
  for (; i < il; i++) {
    for (p in arguments[i]) {
      try {
        if (arguments[i][p].constructor == Object) {
          ret[p] = merge(ret[p], arguments[i][p]);
        } else {
          ret[p] = arguments[i][p];
        }
      } catch (e) {
        ret[p] = arguments[i][p];
      }
    }
  }
  return ret;
};

window.dataLayer = window.dataLayer || [];
var gtag = function gtag() {
  window.dataLayer.push(arguments);
};

var CookiePolicy = exports.CookiePolicy = function () {
  function CookiePolicy(props) {
    _classCallCheck(this, CookiePolicy);

    if (!navigator.cookieEnabled) {
      return false;
    }

    this.state = {
      accepted: false
    };

    this.props = this.constructor.defaultProps;
    this.props = merge(this.props, props);

    this.element = document.querySelector(this.props.container);

    this.objects = {};

    this.objects.isExcluded = false;
    if (this.props.excludedSelectors.length > 0) {
      this.isExcluded();
      if (this.objects.isExcluded) {
        return false;
      }
    }

    // both objects – pane & settings
    this.objects.acceptAllButtons = null;

    // pane objects
    this.objects.closeButton = null;
    this.objects.openSettingsButton = null;
    this.objects.pane = null;
    this.objects.technicalButton = null;

    // settings object
    this.objects.openSettingsLinks = null;
    this.objects.settings = null;
    this.objects.settingsClose = null;
    this.objects.settingsCheckboxAnalytics = null;
    this.objects.settingsCheckboxAnalyticsMarketing = null;
    this.objects.settingsCheckboxMarketing = null;
    this.objects.settingsStateText = null;

    this.handleAcceptSelectedClick = this.handleAcceptSelectedClick.bind(this);
    this.handleChangeCheckboxState = this.handleChangeCheckboxState.bind(this);
    this.handleCloseSettingsClick = this.handleCloseSettingsClick.bind(this);
    this.handleSubmitLevel = this.handleSubmitLevel.bind(this);
    this.handleOpenSettingsClick = this.handleOpenSettingsClick.bind(this);
    this.handleClosePolicyClick = this.handleClosePolicyClick.bind(this);

    this.init();
  }

  _createClass(CookiePolicy, [{
    key: 'init',
    value: function init() {
      this.checkAcceptedCookie();
      this.renderNewGtmContainer();

      /**
       * pokud jsem nedal souhlas se zpracovanim cookies a nenacházím na stránce informace o cookies, vyrenderuj panel
       */
      if ((!this.state.accepted || this.state.accepted <= LEVEL.CONFIG) && !this.element.classList.contains(this.props.excludedCPClassName)) {
        this.renderPane();

        this.objects.pane = this.element.querySelector(FRAGMENTS.PANE);
        this.objects.closeButton = this.element.querySelector(FRAGMENTS.CLOSE_BTN);
        this.objects.openSettingsButton = this.element.querySelector(FRAGMENTS.OPEN_SETTINGS_BTN);
        this.objects.technicalButton = this.element.querySelector(FRAGMENTS.TECHNICAL_BTN);

        this.bindPaneEvents();
      }

      /**
       * pokud jsem na stránce, kde nerenderuju cookie lištu, tak odeber excludedCPClassName
       */
      if (this.element.classList.contains(this.props.excludedCPClassName)) {
        this.element.classList.remove(this.props.excludedCPClassName);
      }

      /**
       * vyrenderuj settings vždy, když bude vyrenderovaný obsah panelu (cookiePolicy panel)
       * nebo když na stránce najdeš fragment na nastavení-cookies
       */
      if (this.objects.openSettingsButton || this.element.querySelectorAll(FRAGMENTS.OPEN_SETTINGS_LINK) && this.element.querySelectorAll(FRAGMENTS.OPEN_SETTINGS_LINK).length > 0) {
        this.renderSettings();

        this.objects.acceptAllButtons = this.element.querySelectorAll(FRAGMENTS.ACCEPT_ALL_BTN);
        this.objects.acceptSelectedButton = this.element.querySelector(FRAGMENTS.ACCEPT_SELECTED_BTN);
        this.objects.openSettingsLinks = this.element.querySelectorAll(FRAGMENTS.OPEN_SETTINGS_LINK);
        this.objects.settings = this.element.querySelector(FRAGMENTS.SETTINGS);
        this.objects.settingsCheckboxAnalytics = this.element.querySelector(FRAGMENTS.SETTINGS_CHECKBOX_ANALYTICS);
        this.objects.settingsCheckboxAnalyticsMarketing = this.element.querySelector(FRAGMENTS.SETTINGS_CHECKBOX_ANALYTICS_MARKETING);
        this.objects.settingsCheckboxMarketing = this.element.querySelector(FRAGMENTS.SETTINGS_CHECKBOX_MARKETING);
        this.objects.settingsStateText = this.element.querySelector(FRAGMENTS.SETTINGS_STATE_TEXT);
        this.objects.settingsClose = this.element.querySelector(FRAGMENTS.SETTINGS_CLOSE_BTN);

        this.bindSettingsEvents();
        this.loadCheckboxState();
      }
    }
  }, {
    key: 'setState',
    value: function setState(newState) {
      this.state = _extends({}, this.state, newState);
    }

    // eslint-disable-next-line class-methods-use-this,no-unused-vars

  }, {
    key: 'update',
    value: function update(prevState) {}
  }, {
    key: 'renderPane',
    value: function renderPane() {
      var pane = this.buildPaneCode();
      if (this.props.position === 'bottom') {
        this.element.insertAdjacentHTML('beforeend', pane);
      } else {
        this.element.insertAdjacentHTML('afterbegin', pane);
      }
    }
  }, {
    key: 'renderSettings',
    value: function renderSettings() {
      var settings = this.buildSettingsCode();
      if (this.props.position === 'bottom') {
        this.element.insertAdjacentHTML('beforeend', settings);
      } else {
        this.element.insertAdjacentHTML('afterbegin', settings);
      }
    }
  }, {
    key: 'bindPaneEvents',
    value: function bindPaneEvents() {
      // Event listener na tlačítko `Povolit všechny cookie` je až uvnitř funkce `bindSettingsEvents`

      if (this.objects.closeButton) {
        this.objects.closeButton.addEventListener('click', this.handleClosePolicyClick);
      }

      if (this.objects.openSettingsButton) {
        this.objects.openSettingsButton.addEventListener('click', this.handleOpenSettingsClick);
      }

      if (this.objects.technicalButton) {
        this.objects.technicalButton.addEventListener('click', this.handleSubmitLevel(LEVEL.TECHNICAL));
      }
    }
  }, {
    key: 'bindSettingsEvents',
    value: function bindSettingsEvents() {
      var _this = this;

      if (this.objects.acceptAllButtons) {
        this.objects.acceptAllButtons.forEach(function (acceptAllBtn) {
          acceptAllBtn.addEventListener('click', _this.handleSubmitLevel(LEVEL.ANALYTICS_MARKETING));
        });
      }

      if (this.objects.openSettingsLinks) {
        this.objects.openSettingsLinks.forEach(function (openSettingsLink) {
          openSettingsLink.addEventListener('click', _this.handleOpenSettingsClick);
        });
      }

      if (this.objects.settingsClose) {
        this.objects.settingsClose.addEventListener('click', this.handleCloseSettingsClick);
      }

      if (this.objects.acceptSelectedButton) {
        this.objects.acceptSelectedButton.addEventListener('click', this.handleAcceptSelectedClick);
      }

      if (this.objects.settingsCheckboxAnalytics) {
        this.objects.settingsCheckboxAnalytics.addEventListener('click', this.handleChangeCheckboxState);
      }

      if (this.objects.settingsCheckboxMarketing) {
        this.objects.settingsCheckboxMarketing.addEventListener('click', this.handleChangeCheckboxState);
      }

      if (this.objects.settingsCheckboxAnalyticsMarketing) {
        this.objects.settingsCheckboxAnalyticsMarketing.addEventListener('click', this.handleChangeCheckboxState);
      }
    }
  }, {
    key: 'checkAcceptedCookie',
    value: function checkAcceptedCookie() {
      var actualLevel = this.readCookie(this.props.cookieName) || false;
      this.setState({
        accepted: actualLevel
      });
    }
  }, {
    key: 'loadCheckboxState',
    value: function loadCheckboxState() {
      var cookieLevel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.accepted;

      if (this.objects.settingsCheckboxAnalytics && (cookieLevel === LEVEL.ANALYTICS || cookieLevel === LEVEL.ANALYTICS_MARKETING)) {
        this.setCheckboxState(this.objects.settingsCheckboxAnalytics);
      }
      if (this.objects.settingsCheckboxMarketing && (cookieLevel === LEVEL.MARKETING || cookieLevel === LEVEL.ANALYTICS_MARKETING)) {
        this.setCheckboxState(this.objects.settingsCheckboxMarketing);
      }
      if (this.objects.settingsCheckboxAnalyticsMarketing && cookieLevel === LEVEL.ANALYTICS_MARKETING) {
        this.setCheckboxState(this.objects.settingsCheckboxAnalyticsMarketing);
      }
    }
  }, {
    key: 'setCheckboxState',
    value: function setCheckboxState(checkboxElement) {
      var checkboxText = checkboxElement.parentNode.querySelector(FRAGMENTS.SETTINGS_STATE_TEXT);

      checkboxElement.checked = true;
      checkboxText.innerText = this.props.settingsMessages[this.props.lang].checkboxStateOn;
    }
  }, {
    key: 'handleChangeCheckboxState',
    value: function handleChangeCheckboxState(e) {
      var eventTargetParent = e.target.parentNode;
      var checkboxText = eventTargetParent.querySelector(FRAGMENTS.SETTINGS_STATE_TEXT);

      if (e.target.checked) {
        checkboxText.innerText = this.props.settingsMessages[this.props.lang].checkboxStateOn;
      } else {
        checkboxText.innerText = this.props.settingsMessages[this.props.lang].checkboxStateOff;
      }
    }
  }, {
    key: 'handleSubmitLevel',
    value: function handleSubmitLevel(level) {
      var _this2 = this;

      // eslint-disable-next-line no-unused-vars
      return function (e) {
        // e.preventDefault();
        _this2.setCookie(_this2.props.cookieName, level);
        _this2.pushActiveStateToGTM();
        _this2.renderNewGtmContainer();
        _this2.hidePane();
        _this2.handleCloseSettingsClick();
        _this2.loadCheckboxState(level);
      };
    }
  }, {
    key: 'handleAcceptSelectedClick',
    value: function handleAcceptSelectedClick(e) {
      e.preventDefault();
      var stateAnalytics = false;
      var stateMarketing = false;
      var stateAnalyticsMarketing = false;
      var cookieLevel = LEVEL.TECHNICAL;

      if (this.objects.settingsCheckboxAnalytics) {
        stateAnalytics = this.objects.settingsCheckboxAnalytics.checked;
      }
      if (this.objects.settingsCheckboxMarketing) {
        stateMarketing = this.objects.settingsCheckboxMarketing.checked;
      }
      if (this.objects.settingsCheckboxAnalyticsMarketing) {
        stateAnalyticsMarketing = this.objects.settingsCheckboxAnalyticsMarketing.checked;
      }

      if (stateAnalytics) cookieLevel = LEVEL.ANALYTICS;
      if (stateMarketing) cookieLevel = LEVEL.MARKETING;
      if (stateAnalytics && stateMarketing || stateAnalyticsMarketing) cookieLevel = LEVEL.ANALYTICS_MARKETING;

      this.handleSubmitLevel(cookieLevel)();
    }
  }, {
    key: 'handleOpenSettingsClick',
    value: function handleOpenSettingsClick(e) {
      e.preventDefault();
      this.objects.settings.classList.add(this.props.activeSettingsClassName);
    }
  }, {
    key: 'handleCloseSettingsClick',
    value: function handleCloseSettingsClick() {
      this.objects.settings.classList.remove(this.props.activeSettingsClassName);
    }
  }, {
    key: 'handleClosePolicyClick',
    value: function handleClosePolicyClick() {
      this.objects.pane.classList.add(this.props.hiddenClassName);
    }
  }, {
    key: 'buildPaneCode',
    value: function buildPaneCode() {
      return this.props.template(_extends({
        imgSrc: this.props.imgSrc,
        enableCloseButton: this.props.enableCloseButton,
        enableImg: this.props.enableImg,
        enableTechnicalButton: this.props.enableTechnicalButton,
        disableRwdImg: this.props.disableRwdImg && this.props.enableImg ? this.props.disableRwdImgClassName : '',
        enableModal: this.props.enableModal ? this.props.enableModalClassName : ''
      }, this.props.messages[this.props.lang]));
    }
  }, {
    key: 'buildSettingsCode',
    value: function buildSettingsCode() {
      return this.props.settingsTemplate(_extends({
        enableSplitGTMContainer: this.props.enableSplitGTMContainer
      }, this.props.settingsMessages[this.props.lang]));
    }
  }, {
    key: 'readCookie',
    value: function readCookie() {
      var cookieName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.cookieName;

      var match = document.cookie.match(new RegExp(cookieName + '=([^;]+)'));
      if (match) return parseInt(match[1], 10);
      return -1;
    }
  }, {
    key: 'setCookie',
    value: function setCookie() {
      var cookieName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.cookieName;
      var cookieValue = arguments[1];
      var _props = this.props,
          cookieLifetime = _props.cookieLifetime,
          enableIframe = _props.enableIframe;

      var d = new Date();
      var expires = new Date(d.setTime(d.getTime() + cookieLifetime * 24 * 60 * 60 * 1000));
      var lifetime = cookieLifetime > 0 ? ';expires=' + expires.toUTCString() : '';
      var secure = location.protocol === 'https:' ? ';secure' : '';
      var sameSiteNone = location.protocol === 'https:' ? ';SameSite=None' : '';
      document.cookie = cookieName + '=' + cookieValue.toString() + lifetime + ';path=/' + secure + (enableIframe ? sameSiteNone : '');
    }
  }, {
    key: 'hidePane',
    value: function hidePane() {
      if (this.objects.pane) {
        this.objects.pane.classList.add(this.props.hiddenClassName);
      }
    }
  }, {
    key: 'pushActiveStateToGTM',
    value: function pushActiveStateToGTM() {
      var cookieLevel = this.readCookie(this.props.cookieName);
      var level = {
        security_storage: 'granted',
        functionality_storage: 'granted',
        personalization_storage: 'granted',
        analytics_storage: cookieLevel === 3 || cookieLevel === 5 ? 'granted' : 'denied',
        ad_storage: cookieLevel === 4 || cookieLevel === 5 ? 'granted' : 'denied'
      };

      gtag('consent', 'update', level);
      dataLayer.push({
        event: 'consent_update',
        consent: level
      });
    }
  }, {
    key: 'renderNewGtmContainer',
    value: function renderNewGtmContainer() {
      if (this.props.enableOneGTMContainer) return;

      var cookieLevel = this.readCookie(this.props.cookieName);

      /**
       * Analytics kontejner se vyrenderuje pouze, když cookie level je 3 nebo 5
       * a zároveň musí být props `enableSplitGTMContainer` na true
       */
      if ((cookieLevel === LEVEL.ANALYTICS || cookieLevel === LEVEL.ANALYTICS_MARKETING) && this.props.enableSplitGTMContainer) {
        var gtmId = document.documentElement.dataset.gtmAnalytics;
        if (gtmId && gtmId !== '!NOTSET!') {
          var gtmScript = document.createElement('script');
          gtmScript.text = this.props.gtmCodeTemplate(gtmId);
          document.body.appendChild(gtmScript);
        } else {
          console.error('GTM container for analytics tags is not set!');
        }
      }

      /**
       * Marketing kontejner se vyrenderuje pouze, když cookie level je 4 nebo 5
       */
      if (cookieLevel === LEVEL.MARKETING || cookieLevel === LEVEL.ANALYTICS_MARKETING) {
        var _gtmId = document.documentElement.dataset.gtmMarketing;
        if (_gtmId && _gtmId !== '!NOTSET!') {
          var _gtmScript = document.createElement('script');
          _gtmScript.text = this.props.gtmCodeTemplate(_gtmId);
          document.body.appendChild(_gtmScript);
        } else {
          console.error('GTM container for marketing tags is not set!');
        }
      }
    }
  }, {
    key: 'isExcluded',
    value: function isExcluded() {
      var _this3 = this;

      [].concat(_toConsumableArray(this.props.excludedSelectors)).find(function (excludedSelector) {
        if (document.querySelector(excludedSelector)) {
          _this3.objects.isExcluded = true;
        }
        return _this3.objects.isExcluded;
      });
    }
  }]);

  return CookiePolicy;
}();

CookiePolicy.defaultProps = {
  activeSettingsClassName: 'cookies-settings--active',
  disableRwdImg: true,
  disableRwdImgClassName: 'cookies-policy--disable-rwd-img',
  enableCloseButton: false,
  enableIframe: false,
  enableImg: true,
  enableModal: false,
  enableModalClassName: 'cookies-policy--modal',
  enableOneGTMContainer: false,
  enableSplitGTMContainer: false,
  enableTechnicalButton: false,
  excludedSelectors: [],
  hiddenClassName: 'cookies-policy--hidden',
  imgSrc: _motive2.default,
  template: function template(data) {
    return '\n      <section class="cookies-policy ' + data.disableRwdImg + ' ' + data.enableModal + '" data-fragment="cp.pane">\n        <div class="cookies-policy__container">\n          ' + (data.enableCloseButton ? '<button class="cookies-policy__btn-close" data-fragment="cp.closeButton"><span class="cookies-policy__btn-close-text">' + data.closeBtn + '</span></button>' : '') + '\n          ' + (data.enableImg ? '<header class="cookies-policy__header"><img class="cookies-policy__img" src="' + data.imgSrc + '" alt="" /></header>' : '') + '\n          <div class="cookies-policy__main">\n            <h2 class="cookies-policy__heading">' + data.heading + '</h2>\n            <p class="cookies-policy__perex">' + data.perex + '</p>\n            <div class="cookies-policy__buttons">\n              <button class="cookies-policy__btn cookies-policy__btn--secondary" data-fragment="cp.openSettingsButton">' + data.settingsBtn + '</button>\n              ' + (data.enableTechnicalButton ? '<button class="cookies-policy__btn cookies-policy__btn--technical" data-fragment="cp.technicalButton">' + data.technicalBtn + '</button>' : '') + '\n              <button class="cookies-policy__btn cookies-policy__btn--primary" data-fragment="cp.acceptAllBtn">' + data.acceptAllBtn + '</button>\n            </div>\n          </div>\n        </div>\n      </section>';
  },
  settingsTemplate: function settingsTemplate(settingsData) {
    return '\n      <section class="cookies-settings" data-fragment="cp.settings">\n        <div class="cookies-settings__container">\n          <header class="cookies-settings__header">\n            <button class="cookies-settings__btn-close" data-fragment="cp.settingsCloseButton"><span class="cookies-settings__btn-close-text">' + settingsData.closeBtn + '</span></button>\n            <h2 class="cookies-settings__heading">' + settingsData.heading + '</h2>\n            <p class="cookies-settings__perex">' + settingsData.perex + '</p>\n            <div class="cookies-settings__buttons">\n              <button class="cookies-settings__btn cookies-settings__btn--primary" data-fragment="cp.acceptAllBtn">' + settingsData.acceptAllBtn + '</button>\n            </div>\n          </header>\n          <div class="cookies-settings__main">\n            <section class="cookies-settings__section">\n              <header class="cookies-settings__section-header">\n                <h3 class="cookies-settings__section-title">' + settingsData.technicalTitle + '</h3>\n                <div class="cookies-settings__section-state-container">\n                  <span class="cookies-settings__section-state cookies-settings__section-state--on">' + settingsData.technicalState + '</span>\n                </div>\n              </header>\n              <div class="cookies-settings__section-main">\n                <p class="cookies-settings__section-perex">' + settingsData.technicalPerex + '</p>\n              </div>\n            </section>\n            ' + (settingsData.enableSplitGTMContainer ? '\n            <section class="cookies-settings__section">\n               <header class="cookies-settings__section-header">\n                 <h3 class="cookies-settings__section-title">' + settingsData.analyticsTitle + '</h3>\n                 <div class="cookies-settings__section-state-container">\n                   <input id="analytics-cookies" class="cookies-settings__checkbox" type="checkbox" name="analyticsCookies" value="analyticsCookies" data-fragment="cp.checkboxAnalytics">\n                   <label class="cookies-settings__label cookies-settings__section-state" for="analytics-cookies"><span class="cookies-settings__switch"></span><span class="cookies-settings__section-state-text" data-fragment="cp.settingsStateText">' + settingsData.checkboxStateOff + '</span></label>\n                 </div>\n               </header>\n               <div class="cookies-settings__section-main">\n                 <p class="cookies-settings__section-perex">' + settingsData.analyticsPerex + '</p>\n               </div>\n            </section>\n            <section class="cookies-settings__section">\n              <header class="cookies-settings__section-header">\n                <h3 class="cookies-settings__section-title">' + settingsData.marketingTitle + '</h3>\n                <div class="cookies-settings__section-state-container">\n                  <input id="marketing-cookies" class="cookies-settings__checkbox" type="checkbox" name="marketingCookies" value="marketingCookies" data-fragment="cp.checkboxMarketing">\n                  <label class="cookies-settings__label cookies-settings__section-state" for="marketing-cookies"><span class="cookies-settings__switch"></span><span class="cookies-settings__section-state-text" data-fragment="cp.settingsStateText">' + settingsData.checkboxStateOff + '</span></label>\n                </div>\n              </header>\n              <div class="cookies-settings__section-main">\n                <p class="cookies-settings__section-perex">' + settingsData.marketingPerex + '</p>\n              </div>\n            </section>' : '\n            <section class="cookies-settings__section cookies-settings__section--analytics-marketing">\n              <header class="cookies-settings__section-header">\n                <h3 class="cookies-settings__section-title">' + settingsData.analyticsMarketingTitle + '</h3>\n                <div class="cookies-settings__section-state-container">\n                  <input id="analytics-marketing-cookies" class="cookies-settings__checkbox" type="checkbox" name="analyticsMarketingCookies" value="analyticsMarketingCookies" data-fragment="cp.checkboxAnalyticsMarketing">\n                  <label class="cookies-settings__label cookies-settings__section-state" for="analytics-marketing-cookies"><span class="cookies-settings__switch"></span><span class="cookies-settings__section-state-text" data-fragment="cp.settingsStateText">' + settingsData.checkboxStateOff + '</span></label>\n                </div>\n              </header>\n              <div class="cookies-settings__section-main">\n                <h4 class="cookies-settings__section-sub-title">' + settingsData.analyticsTitle + '</h4>\n                <p class="cookies-settings__section-perex">' + settingsData.analyticsPerex + '</p>\n              </div>\n              <div class="cookies-settings__section-main">\n                <h4 class="cookies-settings__section-sub-title">' + settingsData.marketingTitle + '</h4>\n                <p class="cookies-settings__section-perex">' + settingsData.marketingPerex + '</p>\n              </div>\n            </section>') + '\n          </div>\n          <div class="cookies-settings__footer">\n              <button class="cookies-settings__btn cookies-settings__btn--secondary" data-fragment="cp.acceptSelectedButton">' + settingsData.acceptSelectedBtn + '</button>\n            </div>\n        </div>\n      </section>';
  },
  messages: {
    cs: {
      heading: 'Nastavení cookies: Aby&nbsp;web fungoval, jak&nbsp;má',
      perex: 'Chceme, aby&nbsp;pro&nbsp;vás&nbsp;bylo procházení webu co&nbsp;nejpříjemnější. Proto používáme soubory cookies, které ho&nbsp;pomáhají neustále rozvíjet a&nbsp;zlepšovat. Navíc nám&nbsp;a&nbsp;našim partnerům umožňují zobrazovat relevantní obsah jen&nbsp;pro&nbsp;vás. Ke&nbsp;zpracování některých cookies potřebujeme váš&nbsp;souhlas, který nám&nbsp;dáte kliknutím na&nbsp;„Povolit všechny cookies“. Nastavení si&nbsp;můžete kdykoliv upravit. Poskytnuté informace jsou v&nbsp;bezpečí a&nbsp;nedostane se&nbsp;k&nbsp;nim, kdo&nbsp;nemá. Více najdete na&nbsp;stránce <a class="cookies-policy__link" href="/cs/informace-o-cookies">Informace o&nbsp;cookies</a>.',
      closeBtn: 'Zavřít',
      settingsBtn: 'Podrobné nastavení',
      technicalBtn: 'Pouze technické cookies',
      acceptAllBtn: 'Povolit všechny cookies'
    },
    en: {
      heading: 'Keeping your site working well',
      perex: 'This website uses cookies to provide social media functions and analyse the visit rate. By clicking on the "Enable all cookies" button, you agree to storage and use of cookies. Detailed information about cookies <a class="cookies-policy__link" href="/en/cookie-information">see here</a>.',
      closeBtn: 'Close',
      settingsBtn: 'Cookies settings',
      technicalBtn: 'Only technical cookies',
      acceptAllBtn: 'Enable all cookies'
    },
    de: {
      heading: 'Damit die Website richtig funktioniert',
      perex: 'Diese Website verwendet Cookies, um Funktionen für soziale Medien anbieten zu können und die Zugriffe auf unsere Website zu analysieren. Mit dem Klicken auf den Button „Alle Cookies zulassen“ stimmen Sie der Speicherung und Verwendung von Cookies zu. Ausführliche Informationen über Cookies finden <a class="cookies-policy__link" href="/de/informationen-uber-cookies">Sie hier</a>.',
      closeBtn: 'Schließen',
      settingsBtn: 'Cookies-Einstellungen',
      technicalBtn: 'Nur technische Cookies',
      acceptAllBtn: 'Alle Cookies zulassen'
    },
    sk: {
      heading: 'Aby web fungoval tak, ako má',
      perex: 'Tento web používa na poskytovanie funkcií sociálnych médií a analýzu návštevnosti súbory cookie. Kliknutím na tlačidlo „Povoliť všetky súbory  cookie“ súhlasíte s ukladaním a používaním súborov cookie. Detailné informácie o súboroch cookie <a class="cookies-policy__link" href="/sk/informacie-o-cookies">nájdete tu</a>.',
      closeBtn: 'Zavrieť',
      settingsBtn: 'Nastavenie súborov cookie',
      technicalBtn: 'Iba technické cookies',
      acceptAllBtn: 'Povoliť všetky súbory cookie'
    },
    ru: {
      heading: 'Чтобы веб-сайт работал как положено',
      perex: 'Этот сайт использует файлы cookie для обеспечения функций социальных сетей и анализа трафика. Нажав на кнопку «Разрешить все файлы cookie», Вы соглашаетесь на хранение и использование файлов cookie. Подробную информацию о файлах cookie <a class="cookies-policy__link" href="/ru/cookie-information">можно найти здесь</a>.',
      closeBtn: 'Закрыть',
      settingsBtn: 'Настройки файлов cookies',
      technicalBtn: 'Только технические куки',
      acceptAllBtn: 'Разрешить все файлы cookies'
    },
    es: {
      heading: 'Para que la web funcione como es debido',
      perex: 'Para poder funcionar con redes sociales y para el análisis del número de visitas, esta web utiliza archivos cookies. Al hacer clic en el botón "Permitir todas las cookies", usted acepta el almacenamiento y el uso de cookies. La información detallada sobre los cookies se encuentra <a class="cookies-policy__link" href="/es/informacion-sobre-cookies">aquí</a>.',
      closeBtn: 'Cerrar',
      settingsBtn: 'Configuración de cookies',
      technicalBtn: 'Solo cookies técnicas',
      acceptAllBtn: 'Permitir todas las cookies'
    },
    hu: {
      heading: 'Hogy a webhely megfelelően működjön',
      perex: 'Ez a webhely a közösségimédia-funkciók biztosításához és a látogatottság elemzéséhez sütiket használ. Az „Összes süti engedélyezése” gombra kattintva jóváhagyhatja a sütik mentését és használatát. A sütikről <a class="cookies-policy__link" href="/hu/informacio-a-sutikrol">itt találhat</a> részletes információkat.',
      closeBtn: 'Bezárás',
      settingsBtn: 'Sütik beállítása',
      technicalBtn: 'Csak technikai sütik',
      acceptAllBtn: 'Összes süti engedélyezése'
    },
    pl: {
      heading: 'By strona internetowa działała, jak należy',
      perex: 'Ta strona internetowa w celu zapewnienia funkcji mediów społecznościowych i analizy frekwencji korzysta z plików cookies. Klikając na przycisk „Zezwól na wszystkie pliki cookies“, wyrażasz zgodę na zapisywanie i używanie plików cookies. Informacje szczegółowe o plikach cookies <a class="cookies-policy__link" href="/pl/informacje-o-cookie">znajdziesz tutaj</a>.',
      closeBtn: 'Zamknij',
      settingsBtn: 'Ustawienia plików cookies',
      technicalBtn: 'Tylko techniczne pliki cookie',
      acceptAllBtn: 'Zezwól na wszystkie pliki cookies'
    },
    fr: {
      heading: 'Pour que le site web fonctionne correctement',
      perex: 'Ce site utilise des cookies pour offrir des fonctionnalités relatives aux médias sociaux et analyser le trafic sur le site web. Cliquez sur « Autoriser tous les cookies » afin d’autoriser le stockage et l’utilisation des fichiers cookies. Des informations détaillées sur les cookies <a class="cookies-policy__link" href="/fr/informations-sur-les-cookies">Des informations détaillées sur les cookies</a>.',
      closeBtn: 'Fermer',
      settingsBtn: 'Gestion des cookies',
      technicalBtn: 'Cookies techniques uniquement',
      acceptAllBtn: 'Autoriser tous les cookies'
    },
    it: {
      heading: 'Per garantire il corretto funzionamento del sito web',
      perex: 'Questo sito web utilizza i cookie per fornire funzionalità dei social media e per monitorare gli accessi. Cliccando sul tasto “Accetta tutti i cookie” consenti di salvare e di utilizzare i file cookie. Informazioni dettagliate sui cookie <a class="cookies-policy__link" href="/it/informazioni-sui-cookie">puoi trovare qui</a>.',
      closeBtn: 'Chiudi',
      settingsBtn: 'Impostazione dei cookie',
      technicalBtn: 'Solo cookie tecnici',
      acceptAllBtn: 'Accetta tutti i cookie'
    }
  },
  settingsMessages: {
    cs: {
      heading: 'Nastavení cookies',
      perex: 'Zde si můžete nastavit, jaké soubory cookies budeme zpracovávat. Více informací najdete na stránce <a class="cookies-settings__link" href="/cs/informace-o-cookies">Informace o cookies.</a>',
      acceptAllBtn: 'Povolit všechny cookies',
      acceptSelectedBtn: 'Povolit vybrané cookies',
      checkboxStateOff: 'Vypnuto',
      checkboxStateOn: 'Zapnuto',
      closeBtn: 'Zavřít',
      technicalTitle: 'Technické cookies',
      technicalPerex: 'Jsou nutné k&nbsp;tomu, abychom vám&nbsp;zobrazili naše webové stránky a&nbsp;fungovaly vám&nbsp;tak, jak&nbsp;mají. Tyto cookies jsou&nbsp;povinné a&nbsp;nelze je&nbsp;vypnout.',
      technicalState: 'Vždy zapnuto',
      analyticsMarketingTitle: 'Analytické a&nbsp;marketingové cookies',
      analyticsTitle: 'Analytické cookies',
      analyticsPerex: 'Pomáhají analyzovat, jak&nbsp;fungují naše webové stránky z&nbsp;hlediska chování návštěvníků a&nbsp;podle toho web&nbsp;případně přizpůsobovat a&nbsp;měnit.',
      marketingTitle: 'Marketingové cookies',
      marketingPerex: 'Díky těmto cookies můžeme my&nbsp;nebo třetí strany po&nbsp;vaší návštěvě přizpůsobit nabídku našich služeb. Tato nabídka se&nbsp;vám&nbsp;potom může zobrazovat i&nbsp;mimo naše webové stránky.'
    },
    en: {
      heading: 'Cookies settings',
      perex: 'You can set which cookies will be processed here. For more information, please go to <a class="cookies-settings__link" href="/en/cookie-information">Cookie information</a>',
      acceptAllBtn: 'Enable all cookies',
      acceptSelectedBtn: 'Enable selected cookies',
      checkboxStateOff: 'OFF',
      checkboxStateOn: 'ON',
      closeBtn: 'Close',
      technicalTitle: 'Technical cookies',
      technicalPerex: 'Technical cookies are necessary for the website to be displayed and operate properly.',
      technicalState: 'Always ON',
      analyticsMarketingTitle: 'Analytical and marketing cookies',
      analyticsTitle: 'Analytical cookies',
      analyticsPerex: 'Analytical cookies help to analyze how our website works in terms of visitor behavior and to adapt and change the website accordingly.',
      marketingTitle: 'Marketing cookies',
      marketingPerex: 'Thanks to these cookies, we or third parties can customize the offer of our services after your visit. This offer can then be displayed outside of our website.'
    },
    de: {
      heading: 'Cookies-Einstellungen',
      perex: 'Hier können Sie einstellen, welche Cookies von uns verarbeitet werden. Mehr Informationen finden Sie unter <a class="cookies-settings__link" href="/de/informationen-uber-cookies">Informationen über cookies</a>',
      acceptAllBtn: 'Alle Cookies zulassen',
      acceptSelectedBtn: 'Ausgewählte Cookies zulassen',
      checkboxStateOff: 'Ausgeschaltet',
      checkboxStateOn: 'Eingeschaltet',
      closeBtn: 'Schließen',
      technicalTitle: 'Technische Cookies',
      technicalPerex: 'Sie sind erforderlich, damit wir Ihnen unsere Website anzeigen können und damit diese ordnungsgemäß funktioniert.',
      technicalState: 'Immer eingeschaltet',
      analyticsMarketingTitle: 'Analytische und marketing Cookies',
      analyticsTitle: 'Analytische Cookies',
      analyticsPerex: 'Mit ihrer Hilfe analysieren wir, wie unsere Website im Hinblick auf das Besucherverhalten funktioniert, und passen sie entsprechend an und verändern sie.',
      marketingTitle: 'Marketing Cookies',
      marketingPerex: 'Dank dieser Cookies können wir oder Dritte unser Dienstleistungsangebot nach Ihrem Besuch anpassen. Dieses Angebot kann Ihnen dann außerhalb unserer Website angezeigt werden.'
    },
    sk: {
      heading: 'Nastavenie súborov cookie',
      perex: 'Tu si môžete nastaviť, aké súbory cookie budeme spracovávať. Viac informácií nájdete na stránke <a class="cookies-settings__link" href="/sk/informacie-o-cookies">Informácie o cookies</a>',
      acceptAllBtn: 'Povoliť všetky súbory cookie',
      acceptSelectedBtn: 'Povoliť vybrané súbory cookie',
      checkboxStateOff: 'Vypnuté',
      checkboxStateOn: 'Zapnuté',
      closeBtn: 'Zavrieť',
      technicalTitle: 'Technické cookies',
      technicalPerex: 'Sú potrebné na to, aby sme vám zobrazili naše webové stránky a fungovali vám tak, ako majú.',
      technicalState: 'Vždy zapnuté',
      analyticsMarketingTitle: 'Analytické a&nbsp;marketingové cookies',
      analyticsTitle: 'Analytické cookies',
      analyticsPerex: 'Pomáhajú analyzovať, ako fungujú naše webové stránky z hľadiska správania sa návštevníkov a podľa toho web prípadne prispôsobovať a meniť.',
      marketingTitle: 'Marketingové cookies',
      marketingPerex: 'Vďaka týmto cookies môžeme my alebo tretej strany po vašej návšteve prispôsobiť ponuku našich služieb. Táto ponuka sa vám potom môže zobrazovať aj mimo naše webové stránky.'
    },
    ru: {
      heading: 'Настройки файлов cookies',
      perex: 'Здесь вы можете указать, какие файлы cookie мы будем обрабатывать. Более подробную информацию см. на странице <a class="cookies-settings__link" href="/ru/cookie-information">использованием cookies</a>',
      acceptAllBtn: 'Разрешить все файлы cookies',
      acceptSelectedBtn: 'Разрешить выбранные файлы cookie',
      checkboxStateOff: 'Выключено',
      checkboxStateOn: 'Включено',
      closeBtn: 'Закрыть',
      technicalTitle: 'Технические файлы cookie',
      technicalPerex: 'Они необходимы для того, чтобы наш сайт отображался и работал должным образом.',
      technicalState: 'Всегда включено',
      analyticsMarketingTitle: 'Аналитические и маркетинговые файлы cookie',
      analyticsTitle: 'Аналитические файлы cookie',
      analyticsPerex: 'Они помогают нам анализировать работу нашего сайта с точки зрения поведения посетителей, а также соответствующим образом приспосабливать и изменять его.',
      marketingTitle: 'Маркетинговые файлы cookie',
      marketingPerex: 'Эти файлы cookie позволяют нам или третьим лицам приспосабливать наши предложения услуг после вашего посещения. Затем это предложение может быть показано вам и за пределами нашего сайта.'
    },
    es: {
      heading: 'Configuración de cookies',
      perex: 'Aquí puede configurar los archivos cookies que trataremos. Encontrará más información en la página <a class="cookies-settings__link" href="/es/informacion-sobre-cookies">Información sobre cookies</a>',
      acceptAllBtn: 'Permitir todas las cookies',
      acceptSelectedBtn: 'Permitir las cookies seleccionadas',
      checkboxStateOff: 'Denegados',
      checkboxStateOn: 'Permitidos',
      closeBtn: 'Cerrar',
      technicalTitle: 'Cookies técnicas',
      technicalPerex: 'Son necesarias para que nuestra página web se visualice y funcione como es debido.',
      technicalState: 'Permitidos siempre',
      analyticsMarketingTitle: 'Cookies analíticas y de marketing',
      analyticsTitle: 'Cookies analíticas',
      analyticsPerex: 'Nos ayudan a analizar como funciona nuestra página web en términos del comportamiento de los visitantes y adaptarla y modificarla en consecuencia.',
      marketingTitle: 'Cookies de marketing',
      marketingPerex: 'Estos cookies nos permiten a nosotros o a terceros adaptar nuestra oferta de servicios después de su visita. Puede que esta propuesta se muestre incluso fuera de nuestra página web.'
    },
    hu: {
      heading: 'Sütik beállítása',
      perex: 'Itt állíthatja be, hogy milyen sütifájlokat használhatunk. További információk <a class="cookies-settings__link" href="/hu/informacio-a-sutikrol">Információk a sutikrol</a>',
      acceptAllBtn: 'Összes süti engedélyezése',
      acceptSelectedBtn: 'Kiválasztott sütik engedélyezése',
      checkboxStateOff: 'Kikapcsolva',
      checkboxStateOn: 'Bekapcsolva',
      closeBtn: 'Bezárás',
      technicalTitle: 'Technikai sütik',
      technicalPerex: 'Ahhoz szükségesek, hogy weboldalaink az elvárt módon jelenjenek meg és működjenek.',
      technicalState: 'Mindig bekapcsolva',
      analyticsMarketingTitle: 'Analitikus és marketingsütik',
      analyticsTitle: 'Analitikus sütik',
      analyticsPerex: 'Annak elemzését segítik, hogy weboldalaink a látogatók viselkedése/szokásai szempontjából hogyan működnek, illetve adott esetben támogatják a webhely ez alapján történő testreszabását és módosítását.',
      marketingTitle: 'Marketingsütik',
      marketingPerex: 'Lehetővé teszik számunkra vagy harmadik fél számára szolgáltatásaink kínálatának testreszabását az Ön látogatását követően. Ezzel a kínálattal azután weboldalainkon kívül is találkozhat.'
    },
    pl: {
      heading: 'Ustawienia plików cookies',
      perex: 'Tutaj możesz ustawić, jakie pliki cookie będziemy przetwarzać. Więcej informacji znajdziesz na stronie <a class="cookies-settings__link" href="/pl/informacje-o-cookie">Informacje o cookies</a>',
      acceptAllBtn: 'Zezwól na wszystkie pliki cookies',
      acceptSelectedBtn: 'Zezwól na wybrane pliki cookie',
      checkboxStateOff: 'Wyłączone',
      checkboxStateOn: 'Włączone',
      closeBtn: 'Zamknij',
      technicalTitle: 'Techniczne pliki cookies',
      technicalPerex: 'Są one niezbędne do tego, by wyświetlała Ci się nasza strona internetowa oraz by działała prawidłowo.',
      technicalState: 'Zawsze włączone',
      analyticsMarketingTitle: 'Analityczne i marketingowe pliki cookies',
      analyticsTitle: 'Analityczne pliki cookies',
      analyticsPerex: 'Pomagają analizować sposób działania naszej strony internetowej pod kątem zachowań odwiedzających oraz w jej ewentualnym dostosowaniu i zmianach.',
      marketingTitle: 'Marketingowe pliki cookies',
      marketingPerex: 'Dzięki tym plikom cookies my lub osoby trzecie możemy dostosować ofertę naszych usług po Twojej wizycie. Oferta ta może Ci się potem wyświetlać także poza naszą stroną internetową.'
    },
    fr: {
      heading: 'Gestion des cookies',
      perex: 'En cliquant ici, vous pouvez paramétrer les cookies à déposer sur votre ordinateur que nous utilisons à des fins d’analyse et de suivi. Pour plus d’informations, veuillez consulter la page <a class="cookies-settings__link" href="/fr/informations-sur-les-cookies">Informations sur les cookies</a>',
      acceptAllBtn: 'Autoriser tous les cookies',
      acceptSelectedBtn: 'Autoriser les cookies sélectionnés',
      checkboxStateOff: 'Désactivé',
      checkboxStateOn: 'Activé',
      closeBtn: 'Fermer',
      technicalTitle: 'Cookies techniques',
      technicalPerex: 'Ces cookies sont nécessaires à l’affichage et au fonctionnement optimal de notre site web.',
      technicalState: 'Toujours activé',
      analyticsMarketingTitle: 'Cookies analytiques et de marketing',
      analyticsTitle: 'Cookies analytiques',
      analyticsPerex: 'Ces cookies nous permettent d’analyser le fonctionnement de notre site web en termes de comportements des visiteurs, et, le cas échéant, personnaliser ou modifier le site web en fonction des informations collectées.',
      marketingTitle: 'Cookies marketing',
      marketingPerex: 'Ces cookies permettent à notre société ou à des tiers de personnaliser l’offre de prestations proposées suite à votre visite du site web. Cette offre peut ultérieurement s’afficher même en dehors de notre site web.'
    },
    it: {
      heading: 'Impostazione dei cookie',
      perex: 'Qui è possibile impostare quali cookie verranno utilizzati.  Per maggiori dettagli, vedere la pagina <a class="cookies-settings__link" href="/it/informazioni-sui-cookie">Informazioni sui cookie</a>',
      acceptAllBtn: 'Accetta tutti i cookie',
      acceptSelectedBtn: 'Accetta i cookie selezionati',
      checkboxStateOff: 'Disattivato',
      checkboxStateOn: 'Attivato',
      closeBtn: 'Chiudi',
      technicalTitle: 'Cookie tecnici',
      technicalPerex: 'Sono necessari per visualizzare il nostro sito web e garantirne il corretto funzionamento.',
      technicalState: 'Sempre attivo',
      analyticsMarketingTitle: 'Cookie analitici e di marketing',
      analyticsTitle: 'Cookie analitici',
      analyticsPerex: 'Aiutano ad analizzare il funzionamento del nostro sito web per quanto riguarda il comportamento dei visitatori e ad adattare e cambiare il sito in base a queste informazioni.',
      marketingTitle: 'Cookie di marketing',
      marketingPerex: 'Questi cookie consentono a noi o a terzi di adattare la nostra offerta di servizi dopo la tua visita. Questa offerta può essere visualizzata anche al di fuori del nostro sito web.'
    }
  },

  // no need to edit, there are always default values
  container: 'body',
  cookieName: 'fg_cookie_policy_accepted',
  cookieLifetime: 365,
  excludedCPClassName: 'js_hideCookiePolicy',
  gtmCodeTemplate: function gtmCodeTemplate(gtmId) {
    return '(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({\'gtm.start\':\nnew Date().getTime(),event:\'gtm.js\'});var f=d.getElementsByTagName(s)[0],\nj=d.createElement(s),dl=l!=\'dataLayer\'?\'&l=\'+l:\'\';j.async=true;j.src=\n\'//www.googletagmanager.com/gtm.js?id=\'+i+dl;f.parentNode.insertBefore(j,f);\n})(window,document,\'script\',\'dataLayer\',\'' + gtmId + '\');';
  },
  lang: 'cs',
  position: 'bottom'
};

exports.default = function (props) {
  return new CookiePolicy(_extends({
    lang: window.projectConfig.lang || 'cs'
  }, props));
};

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1749448655924
      var cssReload = require("!../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "779d5c48c64bc02fcc75f2248ee5e195.gif";

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AddSvgIconSprite = __webpack_require__(422);

var _AddSvgIconSprite2 = _interopRequireDefault(_AddSvgIconSprite);

var _LazyImage = __webpack_require__(423);

var _LazyImage2 = _interopRequireDefault(_LazyImage);

var _Tabs = __webpack_require__(426);

var _Tabs2 = _interopRequireDefault(_Tabs);

var _BudgetKnob = __webpack_require__(427);

var _BudgetKnob2 = _interopRequireDefault(_BudgetKnob);

var _BudgetRange = __webpack_require__(428);

var _BudgetRange2 = _interopRequireDefault(_BudgetRange);

var _SelectTabs = __webpack_require__(429);

var _SelectTabs2 = _interopRequireDefault(_SelectTabs);

var _ProductCategorySliderSticky = __webpack_require__(430);

var _ProductCategorySliderSticky2 = _interopRequireDefault(_ProductCategorySliderSticky);

var _Awards = __webpack_require__(431);

var _Awards2 = _interopRequireDefault(_Awards);

var _GoBack = __webpack_require__(432);

var _GoBack2 = _interopRequireDefault(_GoBack);

var _HpAwards = __webpack_require__(433);

var _HpAwards2 = _interopRequireDefault(_HpAwards);

var _SecondaryNavigation = __webpack_require__(451);

var _SecondaryNavigation2 = _interopRequireDefault(_SecondaryNavigation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
  switch (props.decorator || props.is) {
    // case 'RadioSelect':
    // case 'CheckboxSelect':
    //   return RadioSelect;
    // case 'SocialShare':
    //   return SocialShare;
    // case 'GtmHandler':
    //   return GtmHandler;
    // case 'TriggerInViewport':
    //   return TriggerInViewport;
    // case 'Form':
    //   return Form;
    case 'UniversalPaginationButton':
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 494));
    case 'AddSvgIconSprite':
      return _AddSvgIconSprite2.default;
    case 'LazyImage':
      return _LazyImage2.default;
    case 'Tabs':
      return _Tabs2.default;
    case 'BudgetKnob':
      return _BudgetKnob2.default;
    case 'BudgetRange':
      return _BudgetRange2.default;
    case 'SelectTabs':
      return _SelectTabs2.default;
    case 'ProductCategorySliderSticky':
      return _ProductCategorySliderSticky2.default;
    case 'Awards':
      return _Awards2.default;
    case 'GoBack':
      return _GoBack2.default;
    case "HpAwards":
      return _HpAwards2.default;
    case 'GoogleRecaptcha':
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 495));
    case 'SecondaryNavigation':
      return _SecondaryNavigation2.default;
    // case 'PromoSlider':
    //   return PromoSlider;

    default:
      console.log('Unknown component ' + (props.decorator || props.is));
      return null;
  }
};
// import PromoSlider from "./components/PromoSlider";
// COMMON: Komponenta pro sestavení subnavigace

// import RadioSelect from 'fg-frontend/src/components/RadioSelect';
// import Form from 'fg-frontend/src/components/Form';
// import SocialShare from 'fg-frontend/components/SocialShare';
// import GtmHandler from './components/GtmHandler';
// import TriggerInViewport from './components/TriggerInViewport';

// COMMON: Komponenta pro AJAX nacteni SVG spritu

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _WebComponent2 = __webpack_require__(15);

var _WebComponent3 = _interopRequireDefault(_WebComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Ajaxing SVG sprite

var AddSvgIconSprite = function (_WebComponent) {
  _inherits(AddSvgIconSprite, _WebComponent);

  function AddSvgIconSprite() {
    _classCallCheck(this, AddSvgIconSprite);

    return _possibleConstructorReturn(this, (AddSvgIconSprite.__proto__ || Object.getPrototypeOf(AddSvgIconSprite)).apply(this, arguments));
  }

  _createClass(AddSvgIconSprite, [{
    key: 'didMount',
    value: function didMount() {
      var xhr = new XMLHttpRequest();
      var container = this.element;
      var path = container.getAttribute('data-url');

      if ('withCredentials' in xhr) {
        xhr.withCredentials;
        xhr.open('GET', path, true);
      } else if (typeof XDomainRequest != 'undefined') {
        xhr = new XDomainRequest();
        xhr.open('GET', path);
      } else {
        document.body.className += ' no-svg-sprite';
      }

      xhr.onload = function () {
        container.innerHTML = xhr.responseText;
      };

      xhr.onerror = function () {
        document.body.className += ' no-svg-sprite';
      };

      setTimeout(function () {
        xhr.send();
      }, 0);
    }
  }]);

  return AddSvgIconSprite;
}(_WebComponent3.default);

exports.default = AddSvgIconSprite;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _WebComponent2 = __webpack_require__(15);

var _WebComponent3 = _interopRequireDefault(_WebComponent2);

var _vanillaLazyload = __webpack_require__(424);

var _vanillaLazyload2 = _interopRequireDefault(_vanillaLazyload);

var _configureLazyLoad = __webpack_require__(425);

var _configureLazyLoad2 = _interopRequireDefault(_configureLazyLoad);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Only initialize it one time for the entire application
if (!document.lazyLoadInstance) {
  document.lazyLoadInstance = new _vanillaLazyload2.default(_configureLazyLoad2.default);
}

var LazyImage = function (_WebComponent) {
  _inherits(LazyImage, _WebComponent);

  function LazyImage() {
    _classCallCheck(this, LazyImage);

    return _possibleConstructorReturn(this, (LazyImage.__proto__ || Object.getPrototypeOf(LazyImage)).apply(this, arguments));
  }

  _createClass(LazyImage, [{
    key: "didMount",
    value: function didMount() {
      document.lazyLoadInstance.update();
    }
  }]);

  return LazyImage;
}(_WebComponent3.default);

exports.default = LazyImage;

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;function _extends(){return(_extends=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t}).apply(this,arguments)}function _typeof(t){return(_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}!function(t,e){"object"===( false?"undefined":_typeof(exports))&&"undefined"!=typeof module?module.exports=e(): true?!(__WEBPACK_AMD_DEFINE_FACTORY__ = (e),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):t.LazyLoad=e()}(this,function(){"use strict";var t="undefined"!=typeof window,e=t&&!("onscroll"in window)||"undefined"!=typeof navigator&&/(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent),n=t&&"IntersectionObserver"in window,o=t&&"classList"in document.createElement("p"),r={elements_selector:"img",container:e||t?document:null,threshold:300,thresholds:null,data_src:"src",data_srcset:"srcset",data_sizes:"sizes",data_bg:"bg",class_loading:"loading",class_loaded:"loaded",class_error:"error",load_delay:0,auto_unobserve:!0,callback_enter:null,callback_exit:null,callback_reveal:null,callback_loaded:null,callback_error:null,callback_finish:null},a=function(t,e){return t.getAttribute("data-"+e)},s=function(t,e,n){var o="data-"+e;null!==n?t.setAttribute(o,n):t.removeAttribute(o)},i=function(t){return"true"===a(t,"was-processed")},c=function(t,e){return s(t,"ll-timeout",e)},l=function(t){return a(t,"ll-timeout")},u=function(t,e){var n,o=new t(e);try{n=new CustomEvent("LazyLoad::Initialized",{detail:{instance:o}})}catch(t){(n=document.createEvent("CustomEvent")).initCustomEvent("LazyLoad::Initialized",!1,!1,{instance:o})}window.dispatchEvent(n)};var d=function(t,e){t&&t(e)},f=function(t,e){t._loadingCount+=e,0===t._elements.length&&0===t._loadingCount&&d(t._settings.callback_finish)},_=function(t){for(var e,n=[],o=0;e=t.children[o];o+=1)"SOURCE"===e.tagName&&n.push(e);return n},v=function(t,e,n){n&&t.setAttribute(e,n)},b=function(t,e){v(t,"sizes",a(t,e.data_sizes)),v(t,"srcset",a(t,e.data_srcset)),v(t,"src",a(t,e.data_src))},g={IMG:function(t,e){var n=t.parentNode;n&&"PICTURE"===n.tagName&&_(n).forEach(function(t){b(t,e)});b(t,e)},IFRAME:function(t,e){v(t,"src",a(t,e.data_src))},VIDEO:function(t,e){_(t).forEach(function(t){v(t,"src",a(t,e.data_src))}),v(t,"src",a(t,e.data_src)),t.load()}},m=function(t,e){var n,o,r=e._settings,s=t.tagName,i=g[s];if(i)return i(t,r),f(e,1),void(e._elements=(n=e._elements,o=t,n.filter(function(t){return t!==o})));!function(t,e){var n=a(t,e.data_src),o=a(t,e.data_bg);n&&(t.style.backgroundImage='url("'.concat(n,'")')),o&&(t.style.backgroundImage=o)}(t,r)},h=function(t,e){o?t.classList.add(e):t.className+=(t.className?" ":"")+e},p=function(t,e,n){t.addEventListener(e,n)},y=function(t,e,n){t.removeEventListener(e,n)},E=function(t,e,n){y(t,"load",e),y(t,"loadeddata",e),y(t,"error",n)},w=function(t,e,n){var r=n._settings,a=e?r.class_loaded:r.class_error,s=e?r.callback_loaded:r.callback_error,i=t.target;!function(t,e){o?t.classList.remove(e):t.className=t.className.replace(new RegExp("(^|\\s+)"+e+"(\\s+|$)")," ").replace(/^\s+/,"").replace(/\s+$/,"")}(i,r.class_loading),h(i,a),d(s,i),f(n,-1)},k=function(t,e){var n=function n(r){w(r,!0,e),E(t,n,o)},o=function o(r){w(r,!1,e),E(t,n,o)};!function(t,e,n){p(t,"load",e),p(t,"loadeddata",e),p(t,"error",n)}(t,n,o)},I=["IMG","IFRAME","VIDEO"],L=function(t,e){var n=e._observer;z(t,e),n&&e._settings.auto_unobserve&&n.unobserve(t)},x=function(t){var e=l(t);e&&(clearTimeout(e),c(t,null))},A=function(t,e){var n=e._settings.load_delay,o=l(t);o||(o=setTimeout(function(){L(t,e),x(t)},n),c(t,o))},z=function(t,e,n){var o=e._settings;!n&&i(t)||(I.indexOf(t.tagName)>-1&&(k(t,e),h(t,o.class_loading)),m(t,e),function(t){s(t,"was-processed","true")}(t),d(o.callback_reveal,t),d(o.callback_set,t))},O=function(t){return!!n&&(t._observer=new IntersectionObserver(function(e){e.forEach(function(e){return function(t){return t.isIntersecting||t.intersectionRatio>0}(e)?function(t,e){var n=e._settings;d(n.callback_enter,t),n.load_delay?A(t,e):L(t,e)}(e.target,t):function(t,e){var n=e._settings;d(n.callback_exit,t),n.load_delay&&x(t)}(e.target,t)})},{root:(e=t._settings).container===document?null:e.container,rootMargin:e.thresholds||e.threshold+"px"}),!0);var e},N=function(t,e){this._settings=function(t){return _extends({},r,t)}(t),this._loadingCount=0,O(this),this.update(e)};return N.prototype={update:function(t){var n=this,o=this._settings,r=t||o.container.querySelectorAll(o.elements_selector);this._elements=function(t){return t.filter(function(t){return!i(t)})}(Array.prototype.slice.call(r)),!e&&this._observer?this._elements.forEach(function(t){n._observer.observe(t)}):this.loadAll()},destroy:function(){var t=this;this._observer&&(this._elements.forEach(function(e){t._observer.unobserve(e)}),this._observer=null),this._elements=null,this._settings=null},load:function(t,e){z(t,this,e)},loadAll:function(){var t=this;this._elements.forEach(function(e){L(e,t)})}},t&&function(t,e){if(e)if(e.length)for(var n,o=0;n=e[o];o+=1)u(t,n);else u(t,e)}(N,window.lazyLoadOptions),N});
//# sourceMappingURL=lazyload.min.js.map


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  element_selector: ".lazy",
  class_loading: "lazy--loading",
  class_loaded: "lazy--loaded",
  class_error: "lazy--error"
};

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _WebComponent2 = __webpack_require__(15);

var _WebComponent3 = _interopRequireDefault(_WebComponent2);

var _classNames = __webpack_require__(77);

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var fragments = {
  TAB: '[data-fragment="Tabs.tab"]',
  SLIDER: '[data-fragment="Tabs.slider"]',
  PANE: '[data-fragment="Tabs.pane"]'
};

var Tabs = function (_WebComponent) {
  _inherits(Tabs, _WebComponent);

  function Tabs(props) {
    _classCallCheck(this, Tabs);

    var _this = _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, props));

    _this.handleClickAction = function (e) {
      setTimeout(function () {
        window.setMatrixHeight();
      }, 100);
      _this.setState({
        activeTab: e.target
      });
      setTimeout(function () {
        _this.setState({
          sliderWidth: e.target.clientWidth,
          sliderLeft: e.target.offsetLeft
        });
      }, 50);
      for (var i = 0; i < _this.panes.length; i++) {
        if (_this.panes[i].getAttribute('id') === e.target.dataset.target) {
          _this.setState({
            activePane: _this.panes[i]
          });
        }
      }
    };

    _this.state = {
      sliderWidth: 0,
      sliderLeft: 0,
      activeTab: null,
      activePane: null
    };
    return _this;
  }

  _createClass(Tabs, [{
    key: 'didMount',
    value: function didMount() {
      var _this2 = this;

      this.on('click', fragments.TAB, this.handleClickAction);
      this.slider = this.element.querySelector(fragments.SLIDER);
      this.tabs = this.element.querySelectorAll(fragments.TAB);
      this.panes = this.element.querySelectorAll(fragments.PANE);

      var _loop = function _loop(i) {
        if (_this2.tabs[i].classList.contains('tabs__nav-item--active')) {
          _this2.setState({
            activeTab: _this2.tabs[i]
          });
          setTimeout(function () {
            _this2.setState({
              sliderWidth: _this2.tabs[i].clientWidth,
              sliderLeft: _this2.tabs[i].offsetLeft
            });
          }, 50);
        }
      };

      for (var i = 0; i < this.tabs.length; i++) {
        _loop(i);
      }
      for (var i = 0; i < this.panes.length; i++) {
        if (this.panes[i].classList.contains('tabs__pane--active')) {
          this.setState({
            activePane: this.panes[i]
          });
        }
      }
      window.addEventListener('resize', this.onResize.bind(this));
    }
  }, {
    key: 'onResize',
    value: function onResize() {
      this.setState({
        sliderWidth: this.state.activeTab.clientWidth,
        sliderLeft: this.state.activeTab.offsetLeft
      });
    }
  }, {
    key: 'update',
    value: function update() {
      var _state = this.state,
          activeTab = _state.activeTab,
          sliderWidth = _state.sliderWidth,
          sliderLeft = _state.sliderLeft,
          activePane = _state.activePane;

      for (var i = 0; i < this.tabs.length; i++) {
        this.tabs[i].classList.remove('tabs__nav-item--active');
      }
      for (var _i = 0; _i < this.panes.length; _i++) {
        this.panes[_i].classList.remove('tabs__pane--active');
      }
      (0, _classNames2.default)(activeTab, {
        'tabs__nav-item--active': true
      });
      (0, _classNames2.default)(activePane, {
        'tabs__pane--active': true
      });
      this.slider.style.width = sliderWidth + 'px';
      this.slider.style.left = sliderLeft + 'px';
    }
  }]);

  return Tabs;
}(_WebComponent3.default);

exports.default = Tabs;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _WebComponent2 = __webpack_require__(15);

var _WebComponent3 = _interopRequireDefault(_WebComponent2);

var _classNames = __webpack_require__(77);

var _classNames2 = _interopRequireDefault(_classNames);

var _anime = __webpack_require__(162);

var _anime2 = _interopRequireDefault(_anime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var fragments = {
  CONTAINER: '[data-fragment="BudgetKnob.container"]',
  KNOB: '[data-fragment="BudgetKnob.knob"]',
  HANDLE: '[data-fragment="BudgetKnob.handle"]',
  LEVEL: '[data-fragment="BudgetKnob.level"]',
  BUDGET: '[data-fragment="BudgetKnob.budget"]',
  INFO: '[data-fragment="BudgetKnob.info"]',
  BUTTON: '[data-fragment="BudgetKnob.button"]'
};

var BudgetKnob = function (_WebComponent) {
  _inherits(BudgetKnob, _WebComponent);

  function BudgetKnob(props) {
    _classCallCheck(this, BudgetKnob);

    var _this = _possibleConstructorReturn(this, (BudgetKnob.__proto__ || Object.getPrototypeOf(BudgetKnob)).call(this, props));

    _this.startMoving = function () {
      _this.setState({
        moving: true
      });
    };

    _this.stopMoving = function () {
      if (_this.state.moving && !_this.state.snapping) {
        _this.setState({
          moving: false
        });
        _this.snapTo(_this.state.activeRealAngle);
        _this.gaDataLayerStop();
      }
    };

    _this.gaDataLayerStop = function () {
      var tabsNavItemActive = document.querySelector('.tabs__nav-item--active');
      var fgBudgetCategory = '';
      if (tabsNavItemActive) {
        fgBudgetCategory = tabsNavItemActive.innerHTML;
      }
      dataLayer.push({
        'event': 'fgWebBudgetTool',
        'fgBudget': _this.budget.innerHTML.replace(/ /g, ''),
        'fgBudgetCategory': fgBudgetCategory
      });
    };

    _this.move = function (e) {
      e.preventDefault();
      if (_this.state.moving && !_this.state.snapping) {
        var angle = _this.calcAngle(e);
        if (angle >= -30 && angle <= 210) {
          _this.knob.style.transform = 'rotateZ(' + angle + 'deg)';
        } else if (angle < -30) {
          _this.knob.style.transform = 'rotateZ(-30deg)';
          angle = -30;
        } else if (angle > 210) {
          _this.knob.style.transform = 'rotateZ(210deg)';
          angle = 210;
        }
        _this.setState({
          realAngle: angle,
          fakeAngle: _this.calcFakeAngle(angle)
        });
        _this.setLevels();
      }
    };

    _this.calcAngle = function (e) {
      var res = 0;
      var mouseX = null;
      var mouseY = null;
      if (e.type === "mousemove") {
        mouseX = e.clientX;
        mouseY = e.clientY;
      } else if (e.type === "touchmove") {
        mouseX = e.touches[0].clientX;
        mouseY = e.touches[0].clientY;
      }
      var centerOffsetX = _this.container.getBoundingClientRect().left + _this.knob.clientWidth / 2 - mouseX;
      var centerOffsetY = _this.container.getBoundingClientRect().top + _this.knob.clientHeight / 2 - mouseY;
      var angle = Math.atan2(centerOffsetY, centerOffsetX) * 180 / Math.PI;
      if (angle < -90 && angle >= -180) {
        res = 360 + angle;
      } else {
        res = angle;
      }
      return res;
    };

    _this.calcFakeAngle = function (realAngle) {
      return realAngle + 30;
    };

    _this.calcRealAngle = function (fakeAngle) {
      return fakeAngle - 30;
    };

    _this.setLevels = function () {
      var partialAngle = 240 / 16;
      var reachedAngle = 0;
      for (var i = 0; i < _this.levels.length; i++) {
        reachedAngle = partialAngle * i;
        if (_this.state.fakeAngle >= reachedAngle - 1) {
          _this.levels[i].classList.add('budget-knob__level--reached');
        } else {
          _this.levels[i].classList.remove('budget-knob__level--reached');
        }
        if (reachedAngle > _this.state.fakeAngle - partialAngle / 2 && reachedAngle < _this.state.fakeAngle + partialAngle / 2) {
          _this.levels[i].classList.add('budget-knob__level--active');
          if (_this.levels[i].dataset.info) {
            var _loop = function _loop(j) {
              if (_this.levels[i].dataset.info === _this.info[j].getAttribute('id')) {
                _this.info[j].classList.add('budget-knob__info--active');
                setTimeout(function () {
                  _this.info[j].classList.add('budget-knob__info--animate');
                }, 50);
                var button = _this.info[j].querySelector(fragments.BUTTON);
                var buttonHref = _this.state.buttonLink + '&frm.expectedBudget=' + (i + 1);
                if (_this.externalButtons.length > 0) {
                  for (var k = 0; k < _this.externalButtons.length; k++) {
                    _this.externalButtons[k].setAttribute('href', buttonHref);
                  }
                }
                button.setAttribute('href', buttonHref);
              } else {
                _this.info[j].classList.remove('budget-knob__info--active');
                _this.info[j].classList.remove('budget-knob__info--animate');
              }
            };

            for (var j = 0; j < _this.info.length; j++) {
              _loop(j);
            }
          }
          _this.setState({
            activeRealAngle: _this.calcRealAngle(reachedAngle),
            budget: _this.levels[i].dataset.budget
          });
        } else {
          _this.levels[i].classList.remove('budget-knob__level--active');
        }
      }
    };

    _this.snapTo = function (levelAngle) {
      _this.setState({
        snapping: true
      });
      (0, _anime2.default)({
        targets: _this.knob,
        rotateZ: levelAngle,
        duration: 500
      });
      setTimeout(function () {
        _this.setState({
          snapping: false
        }, 500);
      });
    };

    _this.goTo = function (e) {
      var realAngle = _this.calcRealAngle(e.target.fakeAngle);
      _this.setState({
        fakeAngle: e.target.fakeAngle,
        activeRealAngle: realAngle,
        realAngle: realAngle,
        snapping: true
      });
      (0, _anime2.default)({
        targets: _this.knob,
        rotateZ: realAngle,
        duration: 300,
        easing: 'easeOutQuad'
      });
      _this.setLevels();
      setTimeout(function () {
        _this.setState({
          snapping: false
        });
      }, 1000);
    };

    _this.state = {
      moving: false,
      realAngle: 0,
      fakeAngle: 0,
      activeRealAngle: 0,
      snapping: false,
      budget: 0,
      buttonLink: null
    };
    _this.startMoving = _this.startMoving.bind(_this);
    _this.stopMoving = _this.stopMoving.bind(_this);
    _this.move = _this.move.bind(_this);
    _this.calcAngle = _this.calcAngle.bind(_this);
    _this.calcFakeAngle = _this.calcFakeAngle.bind(_this);
    _this.calcRealAngle = _this.calcRealAngle.bind(_this);
    _this.setLevels = _this.setLevels.bind(_this);
    _this.snapTo = _this.snapTo.bind(_this);
    _this.goTo = _this.goTo.bind(_this);
    return _this;
  }

  _createClass(BudgetKnob, [{
    key: 'didMount',
    value: function didMount() {
      this.container = this.element.querySelector(fragments.CONTAINER);
      this.knob = this.element.querySelector(fragments.KNOB);
      this.handle = this.element.querySelector(fragments.HANDLE);
      this.budget = this.element.querySelector(fragments.BUDGET);
      this.levels = this.element.querySelectorAll(fragments.LEVEL);
      this.info = this.element.querySelectorAll(fragments.INFO);
      this.button = this.element.querySelector(fragments.BUTTON);
      this.externalButtons = document.querySelectorAll('.js_budget-configurator-button');
      this.on('mousedown', fragments.HANDLE, this.startMoving);
      this.on('touchstart', fragments.HANDLE, this.startMoving);
      window.addEventListener('mouseup', this.stopMoving);
      window.addEventListener('touchend', this.stopMoving);
      window.addEventListener('mousemove', this.move);
      this.on('touchmove', fragments.HANDLE, this.move);
      this.on('click', fragments.LEVEL, this.goTo);
      for (var i = 0; i < this.levels.length; i++) {
        var partialAngle = 240 / 16;
        this.levels[i].fakeAngle = partialAngle * i;
        if (this.levels[i].dataset.active) {
          this.setState({
            realAngle: this.calcRealAngle(partialAngle * i),
            fakeAngle: partialAngle * i,
            activeRealAngle: this.calcRealAngle(partialAngle * i)
          });
        }
      }
      this.setState({
        buttonLink: this.button.getAttribute('href')
      });
      this.setLevels();
      this.snapTo(this.state.activeRealAngle);
    }
  }, {
    key: 'update',
    value: function update() {
      var moving = this.state.moving;

      (0, _classNames2.default)(this.handle, {
        'active': moving
      });
      this.budget.innerHTML = this.state.budget;
    }
  }]);

  return BudgetKnob;
}(_WebComponent3.default);

exports.default = BudgetKnob;

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _WebComponent2 = __webpack_require__(15);

var _WebComponent3 = _interopRequireDefault(_WebComponent2);

var _classNames = __webpack_require__(77);

var _classNames2 = _interopRequireDefault(_classNames);

var _anime = __webpack_require__(162);

var _anime2 = _interopRequireDefault(_anime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var fragments = {
  INPUT: '[data-fragment="BudgetRange.input"]',
  HANDLE: '[data-fragment="BudgetRange.handle"]',
  HANDLE_VALUE: '[data-fragment="BudgetRange.handleValue"]',
  RANGE: '[data-fragment="BudgetRange.range"]',
  LEVEL: '[data-fragment="BudgetRange.level"]',
  INFO: '[data-fragment="BudgetRange.info"]'
};

var BudgetRange = function (_WebComponent) {
  _inherits(BudgetRange, _WebComponent);

  function BudgetRange(props) {
    _classCallCheck(this, BudgetRange);

    var _this = _possibleConstructorReturn(this, (BudgetRange.__proto__ || Object.getPrototypeOf(BudgetRange)).call(this, props));

    _this.init = function () {
      var activeLevel = null;
      var levelCount = 0;
      var levelCountPosition = 0;
      var queryString = window.location.search;
      var urlParams = new URLSearchParams(queryString);
      var expectedBudget = urlParams.get('frm.expectedBudget');
      if (expectedBudget) {
        activeLevel = _this.levels[parseInt(expectedBudget) - 1];
        levelCountPosition = parseInt(expectedBudget);
      } else {
        for (var i = 0; i < _this.levels.length; i++) {
          levelCount++;
          if (_this.levels[i].dataset.active) {
            activeLevel = _this.levels[i];
            levelCountPosition = levelCount;
          }
        }
      }
      _this.handleValue.innerHTML = activeLevel.dataset.budget;
      _this.setState({
        rangeLeft: _this.range.getBoundingClientRect().left,
        levelWidth: _this.levels[0].getBoundingClientRect().width,
        rangeWidth: _this.range.offsetWidth
      });
      var leftPosition = levelCountPosition * (_this.state.levelWidth + 3) - _this.state.levelWidth / 2 - _this.handle.offsetWidth / 2;
      _this.handle.style.left = leftPosition + 'px';
      _this.setState({
        handlePosition: leftPosition + _this.handle.offsetWidth / 2
      });
      _this.setLevels();
    };

    _this.redraw = function () {
      if (_this.state.windowWidth !== window.innerWidth) {
        _this.init();
        _this.setState({
          windowWidth: window.innerWidth
        });
        _this.setLevels();
      }
    };

    _this.startMoving = function (e) {
      _this.setState({
        moving: true,
        handleMouseOffset: _this.handle.getBoundingClientRect().left - _this.getMouseX(e)
      });
    };

    _this.stopMoving = function () {
      if (_this.state.moving) {
        _this.setState({
          moving: false
        });
        _this.snapTo(_this.state.handleSnap);
      }
    };

    _this.move = function (e) {
      e.preventDefault();
      if (_this.state.moving) {
        var left = _this.getMouseX(e) - _this.state.rangeLeft + _this.state.handleMouseOffset;
        var leftBoundary = Math.round(-1 * (_this.handle.offsetWidth / 2) + _this.state.levelWidth / 2);
        var rightBoundary = Math.round(_this.state.rangeWidth - _this.state.levelWidth / 2 - _this.handle.offsetWidth / 2);
        if (left < leftBoundary) {
          _this.handle.style.left = leftBoundary + 'px';
          _this.setState({
            handlePosition: leftBoundary + _this.handle.offsetWidth / 2
          });
        } else if (left > rightBoundary) {
          _this.handle.style.left = rightBoundary + 'px';
          _this.setState({
            handlePosition: rightBoundary + _this.handle.offsetWidth / 2
          });
        } else {
          _this.handle.style.left = left + 'px';
          _this.setState({
            handlePosition: left + _this.handle.offsetWidth / 2
          });
        }
        _this.setLevels();
      }
    };

    _this.setLevels = function () {
      var currency = _this.props.currency;

      var levelSize = _this.state.levelWidth + 3;
      var reachedLevelMin = 0;
      var reachedLevelMax = 0;
      for (var i = 0; i < _this.levels.length; i++) {
        reachedLevelMin = levelSize * i;
        reachedLevelMax = reachedLevelMin + levelSize;
        if (_this.state.handlePosition > reachedLevelMin && _this.state.handlePosition <= reachedLevelMax) {
          _this.levels[i].classList.add('budget-range__level--active');
          _this.handleValue.innerHTML = _this.levels[i].dataset.budget;
          _this.input.setAttribute('value', _this.levels[i].dataset.budget + ' ' + currency);
          if (_this.levels[i].dataset.info) {
            for (var j = 0; j < _this.info.length; j++) {
              if (_this.levels[i].dataset.info === _this.info[j].getAttribute('id')) {
                _this.info[j].classList.add('budget-range__info--active');
              } else {
                _this.info[j].classList.remove('budget-range__info--active');
              }
            }
          }
          _this.setState({
            handleSnap: Math.round(reachedLevelMin + (levelSize - 3) / 2 - _this.handle.offsetWidth / 2)
          });
        } else {
          _this.levels[i].classList.remove('budget-range__level--active');
        }
      }
    };

    _this.getMouseX = function (e) {
      if (e.type === 'mousemove' || e.type === 'mousedown') {
        return e.clientX;
      } else if (e.type === 'touchmove' || e.type === 'touchstart') {
        return e.touches[0].clientX;
      }
    };

    _this.snapTo = function (position) {
      (0, _anime2.default)({
        targets: _this.handle,
        left: position,
        duration: 200,
        easing: 'easeOutQuad'
      });
    };

    _this.goTo = function (e) {
      var activeLevel = e.target;
      _this.handleValue.innerHTML = activeLevel.dataset.budget;
      var leftPosition = activeLevel.getBoundingClientRect().left - _this.state.rangeLeft + _this.state.levelWidth / 2 - _this.handle.offsetWidth / 2;
      (0, _anime2.default)({
        targets: _this.handle,
        left: leftPosition,
        duration: 200,
        easing: 'easeOutQuad'
      });
      _this.setState({
        handlePosition: leftPosition + _this.handle.offsetWidth / 2
      });
      _this.setLevels();
    };

    _this.state = {
      moving: false,
      rangeLeft: 0,
      handleMouseOffset: 0,
      levelWidth: 0,
      rangeWidth: 0,
      handlePosition: 0,
      handleSnap: 0,
      windowWidth: 0
    };
    _this.startMoving = _this.startMoving.bind(_this);
    _this.stopMoving = _this.stopMoving.bind(_this);
    _this.move = _this.move.bind(_this);
    _this.getMouseX = _this.getMouseX.bind(_this);
    _this.setLevels = _this.setLevels.bind(_this);
    _this.init = _this.init.bind(_this);
    _this.redraw = _this.redraw.bind(_this);
    _this.snapTo = _this.snapTo.bind(_this);
    _this.goTo = _this.goTo.bind(_this);
    return _this;
  }

  _createClass(BudgetRange, [{
    key: 'didMount',
    value: function didMount() {
      this.input = this.element.querySelector(fragments.INPUT);
      this.handle = this.element.querySelector(fragments.HANDLE);
      this.handleValue = this.element.querySelector(fragments.HANDLE_VALUE);
      this.range = this.element.querySelector(fragments.RANGE);
      this.levels = this.element.querySelectorAll(fragments.LEVEL);
      this.info = this.element.querySelectorAll(fragments.INFO);
      this.on('mousedown', fragments.HANDLE, this.startMoving);
      this.on('touchstart', fragments.HANDLE, this.startMoving);
      window.addEventListener('mouseup', this.stopMoving);
      window.addEventListener('touchend', this.stopMoving);
      window.addEventListener('mousemove', this.move);
      this.on('touchmove', fragments.HANDLE, this.move);
      window.addEventListener('resize', this.redraw);
      this.on('click', fragments.LEVEL, this.goTo);
      this.setState({
        windowWidth: window.innerWidth
      });
      this.init();
    }
  }, {
    key: 'update',
    value: function update() {
      var moving = this.state.moving;

      (0, _classNames2.default)(this.handle, {
        active: moving
      });
    }
  }]);

  return BudgetRange;
}(_WebComponent3.default);

exports.default = BudgetRange;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _WebComponent2 = __webpack_require__(15);

var _WebComponent3 = _interopRequireDefault(_WebComponent2);

var _classNames = __webpack_require__(77);

var _classNames2 = _interopRequireDefault(_classNames);

var _jquery = __webpack_require__(3);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

__webpack_require__(150);
var isMobile = __webpack_require__(151);

var fragments = {
  PANE: '[data-fragment="SelectTabs.pane"]',
  SELECT: '[data-fragment="SelectTabs.select"]'
};

var SelectTabs = function (_WebComponent) {
  _inherits(SelectTabs, _WebComponent);

  function SelectTabs(props) {
    _classCallCheck(this, SelectTabs);

    var _this = _possibleConstructorReturn(this, (SelectTabs.__proto__ || Object.getPrototypeOf(SelectTabs)).call(this, props));

    _this.switchTab = function (e) {
      var noneSelected = true;
      for (var i = 0; i < _this.panes.length; i++) {
        if (_this.panes[i].dataset.value === e.target.value) {
          _this.setState({
            activePane: _this.panes[i]
          });
          noneSelected = false;
        }
      }
      if (noneSelected) {
        _this.setState({
          activePane: null
        });
      }
    };

    _this.setFromURL = function () {
      var queryString = window.location.search;
      var urlParams = new URLSearchParams(queryString);
      var inquiryTarget = urlParams.get('frm.inquiryTarget');
      for (var i = 0; i < _this.panes.length; i++) {
        if (_this.panes[i].dataset.value === inquiryTarget) {
          _this.setState({
            activePane: _this.panes[i]
          });
        }
      }
    };

    _this.state = {
      activePane: null
    };
    _this.switchTab = _this.switchTab.bind(_this);
    _this.setFromURL = _this.setFromURL.bind(_this);
    return _this;
  }

  _createClass(SelectTabs, [{
    key: 'didMount',
    value: function didMount() {
      this.panes = this.element.querySelectorAll(fragments.PANE);
      if (!isMobile.phone && !isMobile.tablet) {
        this.select = (0, _jquery2.default)(fragments.SELECT).selectize();
        this.select.on('change', this.switchTab);
      } else {
        this.select = document.body.querySelector(fragments.SELECT);
        this.select.addEventListener('change', this.switchTab);
      }
      this.setFromURL();
    }
  }, {
    key: 'update',
    value: function update() {
      var activePane = this.state.activePane;

      for (var i = 0; i < this.panes.length; i++) {
        this.panes[i].classList.remove('select-tabs__pane--active');
      }
      if (activePane) {
        (0, _classNames2.default)(activePane, {
          'select-tabs__pane--active': true
        });
      }
    }
  }]);

  return SelectTabs;
}(_WebComponent3.default);

exports.default = SelectTabs;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _WebComponent2 = __webpack_require__(15);

var _WebComponent3 = _interopRequireDefault(_WebComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var fragments = {
  CONTENT: '[data-fragment="ProductCategorySliderSticky.content"]',
  SLIDER: '[data-fragment="ProductCategorySliderSticky.slider"]',
  REFERENCE: '[data-fragment="ProductCategorySliderSticky.reference"]'
};

var ProductCategorySliderSticky = function (_WebComponent) {
  _inherits(ProductCategorySliderSticky, _WebComponent);

  function ProductCategorySliderSticky(props) {
    _classCallCheck(this, ProductCategorySliderSticky);

    return _possibleConstructorReturn(this, (ProductCategorySliderSticky.__proto__ || Object.getPrototypeOf(ProductCategorySliderSticky)).call(this, props));
  }

  _createClass(ProductCategorySliderSticky, [{
    key: 'didMount',
    value: function didMount() {
      var _this2 = this;

      var _props = this.props,
          stickyClass = _props.stickyClass,
          stayBottomClass = _props.stayBottomClass;


      this.content = this.element.querySelector(fragments.CONTENT);
      this.slider = this.element.querySelector(fragments.SLIDER);
      this.reference = this.element.querySelector(fragments.REFERENCE);

      document.addEventListener('scroll', function () {
        if (_this2.content.getBoundingClientRect().top < 0 && _this2.reference.getBoundingClientRect().top > 720) {
          _this2.slider.classList.add(stickyClass);
        } else {
          _this2.slider.classList.remove(stickyClass);
        }
        if (_this2.reference.getBoundingClientRect().top <= 720) {
          _this2.slider.classList.add(stayBottomClass);
        } else {
          _this2.slider.classList.remove(stayBottomClass);
        }
      });
    }
  }]);

  return ProductCategorySliderSticky;
}(_WebComponent3.default);

ProductCategorySliderSticky.defaultProps = {
  stickyClass: 'category-product-slider--sticky',
  stayBottomClass: 'category-product-slider--stay-bottom'
};

exports.default = ProductCategorySliderSticky;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _WebComponent2 = __webpack_require__(15);

var _WebComponent3 = _interopRequireDefault(_WebComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var fragments = {
	COL_REVERSE: '[data-fragment="Awards.colReverse"]',
	SHOW_MORE_PRICE: '[data-fragment="Awards.showMorePrice"]',
	SHOW_MORE_ROWS_IN_BLOCK: '[data-fragment="Awards.showMoreRowsInBlock"]',
	YEAR_CONTENT: '[data-fragment="Awards.yearContent"]'
};

var Awards = function (_WebComponent) {
	_inherits(Awards, _WebComponent);

	function Awards(props) {
		_classCallCheck(this, Awards);

		var _this = _possibleConstructorReturn(this, (Awards.__proto__ || Object.getPrototypeOf(Awards)).call(this, props));

		_this.initCol = function () {
			for (var i = 0; i < _this.awardsYearBlockReverse.length; i++) {
				if (window.innerWidth > 1052) {
					_this.colReverse.appendChild(_this.awardsYearBlockReverse[i]);
				} else {
					var colId = parseInt(_this.awardsYearBlockReverse[i].getAttribute('data-col-id')) - 1;
					var previousCol = _this.element.querySelector('.awards-year__block[data-col-id="' + colId + '"]');
					_this.insertAfter(_this.awardsYearBlockReverse[i], previousCol);
				}
			}
		};

		_this.handleClickOnShowMorePrice = function (e) {
			e.preventDefault();
			var awardsYearFirstBlockHide = _this.element.querySelector(_this.hideClass);
			if (awardsYearFirstBlockHide) {
				var colId = parseInt(awardsYearFirstBlockHide.getAttribute('data-col-id'));
				for (var i = 0; i < _this.showItem; i++) {
					var awardsYearBlockHide = _this.element.querySelector('.awards-year__block[data-col-id="' + colId + '"]');
					if (awardsYearBlockHide) {
						awardsYearBlockHide.classList.remove(_this.hideClass.substring(1));
					}
					colId++;
				}
			}
			if (_this.element.querySelectorAll(_this.hideClass).length === 0) {
				e.target.style.display = 'none';
			}
		};

		_this.handleClickOnShowMoreRowsInBlock = function (e) {
			e.preventDefault();

			var parentElement = e.target.parentElement.offsetParent;
			console.log(parentElement);
			var hideElements = parentElement.querySelectorAll('.hide');

			for (var i = 0; i < hideElements.length; i++) {
				hideElements[i].classList.remove('hide');
			}

			e.target.style.display = 'none';
		};

		_this.insertAfter = function (newNode, existingNode) {
			existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
		};

		return _this;
	}

	_createClass(Awards, [{
		key: 'didMount',
		value: function didMount() {
			var hideClass = this.props.hideClass;


			this.hideClass = hideClass;

			this.awardsYearBlockReverse = this.element.querySelectorAll('.awards-year__block--reverse');

			// this.yearContentElement = this.element.querySelector(fragments.YEAR_CONTENT);

			this.colReverse = this.element.querySelector(fragments.COL_REVERSE);

			// this.showItem = parseInt(this.yearContentElement.getAttribute('data-show-item'));

			this.on('click', fragments.SHOW_MORE_PRICE, this.handleClickOnShowMorePrice);
			this.on('click', fragments.SHOW_MORE_ROWS_IN_BLOCK, this.handleClickOnShowMoreRowsInBlock);
			this.initCol();
			window.addEventListener('resize', this.initCol);
		}
	}]);

	return Awards;
}(_WebComponent3.default);

Awards.defaultProps = {
	hideClass: '.awards-year__block--hide'
};

exports.default = Awards;

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _WebComponent2 = __webpack_require__(15);

var _WebComponent3 = _interopRequireDefault(_WebComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var fragments = {
    LINK: '[data-fragment="GoBack.link"]'
};

var GoBack = function (_WebComponent) {
    _inherits(GoBack, _WebComponent);

    function GoBack() {
        _classCallCheck(this, GoBack);

        return _possibleConstructorReturn(this, (GoBack.__proto__ || Object.getPrototypeOf(GoBack)).apply(this, arguments));
    }

    _createClass(GoBack, [{
        key: 'didMount',
        value: function didMount() {
            this.link = this.element.querySelector(fragments.LINK);

            if (document.referrer.split('/')[2] === window.location.host && window.history.length > 1) {
                this.link.addEventListener('click', function (e) {
                    e.preventDefault();
                    window.history.back();
                });
            }
        }
    }]);

    return GoBack;
}(_WebComponent3.default);

exports.default = GoBack;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _WebComponent2 = __webpack_require__(15);

var _WebComponent3 = _interopRequireDefault(_WebComponent2);

var _isEqual = __webpack_require__(434);

var _isEqual2 = _interopRequireDefault(_isEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}

var HpAwards = function (_WebComponent) {
  _inherits(HpAwards, _WebComponent);

  function HpAwards(props) {
    _classCallCheck(this, HpAwards);

    var _this = _possibleConstructorReturn(this, (HpAwards.__proto__ || Object.getPrototypeOf(HpAwards)).call(this, props));

    _this.objects = {};

    _this.state = {
      isDown: false,
      startX: null,
      scrollLeft: null
    };

    _this.handleStart = _this.handleStart.bind(_this);
    _this.handleEnd = _this.handleEnd.bind(_this);
    _this.handleCancel = _this.handleCancel.bind(_this);
    _this.handleMove = _this.handleMove.bind(_this);
    return _this;
  }

  _createClass(HpAwards, [{
    key: 'didMount',
    value: function didMount() {
      this.objects.startEventType = 'mousedown';
      this.objects.endEventType = 'mouseup';
      this.objects.cancelEventType = 'mouseleave';
      this.objects.moveEventType = 'mousemove';

      if (isTouchDevice()) {
        this.objects.startEventType = 'touchstart';
        this.objects.endEventType = 'touchend';
        this.objects.cancelEventType = 'touchcancel';
        this.objects.moveEventType = 'touchmove';
      }

      this.on(this.objects.startEventType, this.handleStart);
      this.on(this.objects.endEventType, this.handleEnd);
      this.on(this.objects.cancelEventType, this.handleCancel);
      this.on(this.objects.moveEventType, this.handleMove);
    }
  }, {
    key: 'update',
    value: function update(prevProps, prevState) {
      var isDown = this.state.isDown;
      var prevIsDown = prevState.isDown;


      if (!(0, _isEqual2.default)(isDown, prevIsDown)) {
        this.updateIsDown();
      }
    }
  }, {
    key: 'updateIsDown',
    value: function updateIsDown() {
      var activeClassName = this.props.activeClassName;
      var isDown = this.state.isDown;


      if (isDown) {
        this.element.classList.add(activeClassName);
      } else {
        this.element.classList.remove(activeClassName);
      }
    }
  }, {
    key: 'handleStart',
    value: function handleStart(e) {
      var pageX = isTouchDevice() ? e.touches[0].pageX : e.pageX;
      this.setState({
        isDown: true,
        startX: pageX - this.element.offsetLeft,
        scrollLeft: this.element.scrollLeft
      });
    }
  }, {
    key: 'handleEnd',
    value: function handleEnd() {
      this.finishedHandle();
    }
  }, {
    key: 'handleCancel',
    value: function handleCancel() {
      this.finishedHandle();
    }
  }, {
    key: 'handleMove',
    value: function handleMove(e) {
      var _state = this.state,
          isDown = _state.isDown,
          startX = _state.startX,
          scrollLeft = _state.scrollLeft;


      if (!isDown) return;
      e.preventDefault();

      var pageX = isTouchDevice() ? e.touches[0].pageX : e.pageX;
      var x = pageX - this.element.offsetLeft;
      var walk = (x - startX) * 3;
      this.element.scrollLeft = scrollLeft - walk;
    }
  }, {
    key: 'finishedHandle',
    value: function finishedHandle() {
      this.setState({
        isDown: false
      });
    }
  }]);

  return HpAwards;
}(_WebComponent3.default);

HpAwards.defaultProps = {
  activeClassName: 'active'
};
exports.default = HpAwards;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(435),
    bindCallback = __webpack_require__(449);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent. If `customizer` is provided it's invoked to compare values.
 * If `customizer` returns `undefined` comparisons are handled by the method
 * instead. The `customizer` is bound to `thisArg` and invoked with up to
 * three arguments: (value, other [, index|key]).
 *
 * **Note:** This method supports comparing arrays, booleans, `Date` objects,
 * numbers, `Object` objects, regexes, and strings. Objects are compared by
 * their own, not inherited, enumerable properties. Functions and DOM nodes
 * are **not** supported. Provide a customizer function to extend support
 * for comparing other values.
 *
 * @static
 * @memberOf _
 * @alias eq
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize value comparisons.
 * @param {*} [thisArg] The `this` binding of `customizer`.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'user': 'fred' };
 * var other = { 'user': 'fred' };
 *
 * object == other;
 * // => false
 *
 * _.isEqual(object, other);
 * // => true
 *
 * // using a customizer callback
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqual(array, other, function(value, other) {
 *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
 *     return true;
 *   }
 * });
 * // => true
 */
function isEqual(value, other, customizer, thisArg) {
  customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
  var result = customizer ? customizer(value, other) : undefined;
  return  result === undefined ? baseIsEqual(value, other, customizer) : !!result;
}

module.exports = isEqual;


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(436),
    isObject = __webpack_require__(78),
    isObjectLike = __webpack_require__(59);

/**
 * The base implementation of `_.isEqual` without support for `this` binding
 * `customizer` functions.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparing values.
 * @param {boolean} [isLoose] Specify performing partial comparisons.
 * @param {Array} [stackA] Tracks traversed `value` objects.
 * @param {Array} [stackB] Tracks traversed `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
}

module.exports = baseIsEqual;


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

var equalArrays = __webpack_require__(437),
    equalByTag = __webpack_require__(439),
    equalObjects = __webpack_require__(440),
    isArray = __webpack_require__(112),
    isTypedArray = __webpack_require__(448);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparing objects.
 * @param {boolean} [isLoose] Specify performing partial comparisons.
 * @param {Array} [stackA=[]] Tracks traversed `value` objects.
 * @param {Array} [stackB=[]] Tracks traversed `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = arrayTag,
      othTag = arrayTag;

  if (!objIsArr) {
    objTag = objToString.call(object);
    if (objTag == argsTag) {
      objTag = objectTag;
    } else if (objTag != objectTag) {
      objIsArr = isTypedArray(object);
    }
  }
  if (!othIsArr) {
    othTag = objToString.call(other);
    if (othTag == argsTag) {
      othTag = objectTag;
    } else if (othTag != objectTag) {
      othIsArr = isTypedArray(other);
    }
  }
  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && !(objIsArr || objIsObj)) {
    return equalByTag(object, other, objTag);
  }
  if (!isLoose) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
    }
  }
  if (!isSameTag) {
    return false;
  }
  // Assume cyclic values are equal.
  // For more information on detecting circular references see https://es5.github.io/#JO.
  stackA || (stackA = []);
  stackB || (stackB = []);

  var length = stackA.length;
  while (length--) {
    if (stackA[length] == object) {
      return stackB[length] == other;
    }
  }
  // Add `object` and `other` to the stack of traversed objects.
  stackA.push(object);
  stackB.push(other);

  var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);

  stackA.pop();
  stackB.pop();

  return result;
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

var arraySome = __webpack_require__(438);

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparing arrays.
 * @param {boolean} [isLoose] Specify performing partial comparisons.
 * @param {Array} [stackA] Tracks traversed `value` objects.
 * @param {Array} [stackB] Tracks traversed `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
  var index = -1,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
    return false;
  }
  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index],
        result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;

    if (result !== undefined) {
      if (result) {
        continue;
      }
      return false;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (isLoose) {
      if (!arraySome(other, function(othValue) {
            return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
          })) {
        return false;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
      return false;
    }
  }
  return true;
}

module.exports = equalArrays;


/***/ }),
/* 438 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 439 */
/***/ (function(module, exports) {

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    stringTag = '[object String]';

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag) {
  switch (tag) {
    case boolTag:
    case dateTag:
      // Coerce dates and booleans to numbers, dates to milliseconds and booleans
      // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
      return +object == +other;

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case numberTag:
      // Treat `NaN` vs. `NaN` as equal.
      return (object != +object)
        ? other != +other
        : object == +other;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings primitives and string
      // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
      return object == (other + '');
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

var keys = __webpack_require__(441);

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparing values.
 * @param {boolean} [isLoose] Specify performing partial comparisons.
 * @param {Array} [stackA] Tracks traversed `value` objects.
 * @param {Array} [stackB] Tracks traversed `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
  var objProps = keys(object),
      objLength = objProps.length,
      othProps = keys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isLoose) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  var skipCtor = isLoose;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key],
        result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;

    // Recursively compare objects (susceptible to call stack limits).
    if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
      return false;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (!skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      return false;
    }
  }
  return true;
}

module.exports = equalObjects;


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(163),
    isArrayLike = __webpack_require__(164),
    isObject = __webpack_require__(78),
    shimKeys = __webpack_require__(446);

/* Native method references for those with the same name as other `lodash` methods. */
var nativeKeys = getNative(Object, 'keys');

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
var keys = !nativeKeys ? shimKeys : function(object) {
  var Ctor = object == null ? undefined : object.constructor;
  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
      (typeof object != 'function' && isArrayLike(object))) {
    return shimKeys(object);
  }
  return isObject(object) ? nativeKeys(object) : [];
};

module.exports = keys;


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(443),
    isObjectLike = __webpack_require__(59);

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = isNative;


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(78);

/** `Object#toString` result references. */
var funcTag = '[object Function]';

/** Used for native method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 which returns 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

module.exports = isFunction;


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(445);

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

module.exports = getLength;


/***/ }),
/* 445 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var isArguments = __webpack_require__(165),
    isArray = __webpack_require__(112),
    isIndex = __webpack_require__(166),
    isLength = __webpack_require__(60),
    keysIn = __webpack_require__(447);

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A fallback implementation of `Object.keys` which creates an array of the
 * own enumerable property names of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function shimKeys(object) {
  var props = keysIn(object),
      propsLength = props.length,
      length = propsLength && object.length;

  var allowIndexes = !!length && isLength(length) &&
    (isArray(object) || isArguments(object));

  var index = -1,
      result = [];

  while (++index < propsLength) {
    var key = props[index];
    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = shimKeys;


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var isArguments = __webpack_require__(165),
    isArray = __webpack_require__(112),
    isIndex = __webpack_require__(166),
    isLength = __webpack_require__(60),
    isObject = __webpack_require__(78);

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  if (object == null) {
    return [];
  }
  if (!isObject(object)) {
    object = Object(object);
  }
  var length = object.length;
  length = (length && isLength(length) &&
    (isArray(object) || isArguments(object)) && length) || 0;

  var Ctor = object.constructor,
      index = -1,
      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
      result = Array(length),
      skipIndexes = length > 0;

  while (++index < length) {
    result[index] = (index + '');
  }
  for (var key in object) {
    if (!(skipIndexes && isIndex(key, length)) &&
        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = keysIn;


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var isLength = __webpack_require__(60),
    isObjectLike = __webpack_require__(59);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dateTag] = typedArrayTags[errorTag] =
typedArrayTags[funcTag] = typedArrayTags[mapTag] =
typedArrayTags[numberTag] = typedArrayTags[objectTag] =
typedArrayTags[regexpTag] = typedArrayTags[setTag] =
typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

/** Used for native method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
function isTypedArray(value) {
  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
}

module.exports = isTypedArray;


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(450);

/**
 * A specialized version of `baseCallback` which only supports `this` binding
 * and specifying the number of arguments to provide to `func`.
 *
 * @private
 * @param {Function} func The function to bind.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {number} [argCount] The number of arguments to provide to `func`.
 * @returns {Function} Returns the callback.
 */
function bindCallback(func, thisArg, argCount) {
  if (typeof func != 'function') {
    return identity;
  }
  if (thisArg === undefined) {
    return func;
  }
  switch (argCount) {
    case 1: return function(value) {
      return func.call(thisArg, value);
    };
    case 3: return function(value, index, collection) {
      return func.call(thisArg, value, index, collection);
    };
    case 4: return function(accumulator, value, index, collection) {
      return func.call(thisArg, accumulator, value, index, collection);
    };
    case 5: return function(value, other, key, object, source) {
      return func.call(thisArg, value, other, key, object, source);
    };
  }
  return function() {
    return func.apply(thisArg, arguments);
  };
}

module.exports = bindCallback;


/***/ }),
/* 450 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument provided to it.
 *
 * @static
 * @memberOf _
 * @category Utility
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.identity(object) === object;
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _WebComponent2 = __webpack_require__(15);

var _WebComponent3 = _interopRequireDefault(_WebComponent2);

var _jquery = __webpack_require__(3);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(452);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SecondaryNavigation = function (_WebComponent) {
  _inherits(SecondaryNavigation, _WebComponent);

  function SecondaryNavigation() {
    _classCallCheck(this, SecondaryNavigation);

    return _possibleConstructorReturn(this, (SecondaryNavigation.__proto__ || Object.getPrototypeOf(SecondaryNavigation)).apply(this, arguments));
  }

  _createClass(SecondaryNavigation, [{
    key: 'didMount',
    value: function didMount() {
      (0, _jquery2.default)(this.element).secondaryNavigation();
    }
  }]);

  return SecondaryNavigation;
}(_WebComponent3.default);

exports.default = SecondaryNavigation;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


$.fn.secondaryNavigation = function (options) {
  var defaults = {
    container: 'anchor-secondary-navigation__list',
    itemClass: 'anchor-secondary-navigation__item',
    linkClass: 'anchor-secondary-navigation__link',
    selector: '[data-navigation-id]'
  };
  var o = $.extend({}, defaults, options);
  var items = $(o.selector);
  var itemList = [];
  items.each(function () {
    var name = $(this).data('navigationName');
    var id = $(this).data('navigationId');
    itemList.push({ name: name, id: id });
  });
  var htmlString = '<ul class="' + o.container + '">';
  itemList.forEach(function (item) {
    var currentURL = window.location.origin + window.location.pathname; // získání aktuální URL bez parametrů a kotvy
    htmlString += '<li class="' + o.itemClass + '"><a class="' + o.linkClass + '" href="' + currentURL + '#' + item.id + '">' + item.name + '</a></li>';
  });
  htmlString += '</ul>';
  $(this).html(htmlString);
  return false;
};

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _goBack = __webpack_require__(454);

var _goBack2 = _interopRequireDefault(_goBack);

var _toggleClass = __webpack_require__(455);

var _toggleClass2 = _interopRequireDefault(_toggleClass);

var _scrollToHref = __webpack_require__(456);

var _scrollToHref2 = _interopRequireDefault(_scrollToHref);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (action) {
	switch (action) {
		case 'goBack':
			return _goBack2.default;
		case 'toggleClass':
			return _toggleClass2.default;
		case 'scrollToHref':
			return _scrollToHref2.default;
		default:
			console.log('Unknown action');
			return null;
	}
};

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (props, e) {
    e.preventDefault();
    if (document.referrer.split('/')[2] === window.location.host) {
        var useFallbackHref = true;
        window.onbeforeunload = function () {
            useFallbackHref = false;
        };
        window.history.back();

        setTimeout(function () {
            if (useFallbackHref) {
                window.location.href = e.target.href;
            }
        }, 100);
    } else {
        if (e.target.href) {
            window.location.href = e.target.href;
        }
    }
};

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (props, e) {
  e.stopPropagation();
  var actionClass = props.actionClass,
      actionTarget = props.actionTarget,
      _props$separator = props.separator,
      separator = _props$separator === undefined ? ';' : _props$separator;
  var target = e.target;


  if (actionTarget) {
    var targetSet = actionTarget.split(separator);
    targetSet.forEach(function (element) {
      return document.querySelector(element).classList.toggle(actionClass);
    });
  }
};

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function (props, e) {
	var target = document.querySelector(e.target.getAttribute('href'));

	if (target) {
		e.preventDefault();
		target.scrollIntoView({ behavior: 'smooth' });
	}
};

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var jQuery = __webpack_require__(3);

var _require = __webpack_require__(76),
    dispatchEvent = _require.dispatchEvent;

/**
 * Live validation client side jQuery plugin. Server side is backed up with RamJet validation servlet that responds to
 * the client request with validation results.
 *
 * Usage:
 *
 * $("#form").liveValidation({ ... settings ... });
 *
 * All inputs in the specified form are then automatically enriched with live validation controls unless they are disabled
 * or marked with class "noLiveValidation".
 *
 * --------------------------------------------------------------------------------------------------------------------
 * Custom settings:
 * --------------------------------------------------------------------------------------------------------------------
 * validationUrlHandler(location): function returning URL to the validation servlet -
 *                                 BY DEFAULT its the current page location that has replaces /qf/ fragment
 *                                 with /validate/ fragment
 * replaceHandler(widget):         function that replaces contents of the inline messages containers
 *                                 widget parameter contains JSON results for particular widget (see API section)
 *                                 BY DEFAULT it simply replaces contents with jQuery.html() method call,
 *                                 see $.liveValidation.predefinedMethods for other ways of replacing messages contents
 * preventSubmitOnErrors:          set to true if you want to prevent user to submit form if there are known validation
 *                                 errors, for most cases it requires one additional AJAX call on form submit request
 *                                 (note: by setting true you'll also prevent double form submits)
 *                                 BY DEFAULT false
 * showTipsInInputs:               fills input[type=text] and textarea contents with their title attribute if there is any
 *                                 when user enters particular field hint content value is removed
 *                                 there is always class "hintDisplayed" present on the input if it contains hint value
 *                                 BY DEFAULT true
 * failedCallback(settings, liveValidationManager, form, jqXHR, textStatus, errorThrown):
 *                                 callback called on server error - failing to process validation request
 *                                 BY DEFAULT no function
 * successCallback(settings, liveValidationManager, form, xhr, textStatus, result):
 *                                 callback called on server validation result (also with widget errors) - success in this
 *                                 case means, that server successfuly processed our validation request
 *                                 BY DEFAULT no function
 * validationNotNecessaryHandler(event):
 *                                 callback called on field validation request when value hasn't changed against last
 *                                 validated value
 *                                 BY DEFAULT only logs event skip
 * minimalWaitInterval:            minimal time interval between validation calls (to prevent server overhead)
 *                                 requests on the server are always performed in serial way (one after another) with
 *                                 minimal time distance of minimalWaitInterval value
 *                                 BY DEFAULT 1000ms
 * fixedOffset:                    allows to specify a value that will be added to input offset when scrollIntoView
 *                                 is about to occur - handy when you have floating menu, that doesn't count to input
 *                                 offset
 *                                 BY DEFAULT 0
 *
 * --------------------------------------------------------------------------------------------------------------------
 * Events:
 * --------------------------------------------------------------------------------------------------------------------
 * validationFailed          - invoked on form element in case it contains ANY widget with visible validation error
 * validationPassed          - invoked on form element in case it contains NO widget with visible validation error (but
 *                             there might be validation errors not yet revealed to the user because he hasn't visited the input)
 * validationPassedForWidget - invoked on each validated widget element when live validation passes WITHOUT ERROR
 * validationFailedForWidget - invoked on each validated widget element when live validation fails WITH ERROR
 * requestValidation         - trigger this event manually on any monitored form input element to trigger live validation check
 *
 * --------------------------------------------------------------------------------------------------------------------
 * API documentation:
 * --------------------------------------------------------------------------------------------------------------------
 *
 * Request - POST with there arguments:
 * Live-Validation-Context-Id:         unique validation context id - identificator for stored server side
 *                                            validation context, that is in sync with client side
 * Live-Validation-Form:               id of the user input container (ie HTML form) that represents
 *                                            scope of the validation
 * Live-Validation-Requested-Widgets:  semicolon delimited list of widgets, that have changed values and should
 *                                            be repopulated on server and whose inline messages should be rendered
 *                                            on return
 *
 * + standard submit data for all input widgets and submit button
 *
 * Response JSON:
 *
 * {
 *   "data": {
 *      "requires": string, // one of values: nothing, convertedData, validatedData - represents what level of validation
 *                          // server requests for invoking particular event
 *      "validationContextId": string, // unique validation context id - identificator for stored server side
 *                                     // validation context, that is in sync with client side
 *        "widgets": {
 *           "widgetName": {
 *              "hasErrors": boolean, // true if widget data are invalid
 *              "hasInfos": boolean,  // true if server side has any comment to widget data
 *              "hasMessages": boolean, // true if messages property is not empty (see next row)
 *              "messages": string, // contains message rendered on the server side that is connected to this widget
 *              "validatedValue": string, // contains last value validated by server (connected with these results)
 *              "widgetId": string, // contains normalized widget id (ie id attribute of the HTML input element)
 *              "widgetInputName": string, // contains widget name (ie name attribute of the HTML input element)
 *              "widgetMessageId": string, // contains normalized id of widget messages subwidget (ie id attribute of inline messages component)
 *              "widgetName": string // contains absolute id of the widget
 *          },
 *          ... more widgets ...
 *      }
 *   },
 *   "error": boolean, // returns true if there was error while processing validation request
 *   "errorMessage": string, // contains string explaining the error on server
 *   "ok": boolean // return true if there was no error while processing validation request
 *  }
 *
 * @author Jan Novotny
 * @version 1.0
 */


(function ($) {

  $.liveValidationManager = function () {
    //contains all current validation requests
    this.widgetValidationRequests = [];
    //contains all validation requests since last successful call to server
    this.pendingWidgetValidationRequests = [];
    //true / false if there is XHR request pending
    this.xhrRunning = false;
    //contains timestamp of the last server call
    this.lastServerCall = null;
    //this global variable holds current validationContextId negotiated with the server
    this.validationContextId = null;
    //contains reference to pending validation call
    this.timeoutSet = null;
    //contains flag if submit is being processed
    this.submitInProcess = false;
    //contains information about last validated values for each input
    this.validatedValues = {};
    //contains all DOM elements that has been already visited by user
    this.visitedInputs = {};
    this.visitedInputIds = {};
    //contains last server call result
    this.lastValidationResult = null;
    //contains all validated widget messages
    this.widgetMessages = {};
    //force submit (will skip error validation)
    this.forceSubmit = false;
    //stores information about last clicked button (used for postponed submits)
    this.clickedEvent = null;
  };

  $.liveValidationManager.prototype = {

    /**
     * Logs a text into the firebug.
     * @param text
     */
    _log: function _log(text) {
      if ($.log === undefined) {
        if (window.console) {
          window.console.log(text);
        }
      } else {
        $.log(text);
      }
    },

    /**
     * Returns true if it is necessary to call server validation. Return true only if there has been some activity
     * in input widgets.
     * @param settings
     * @param form
     */
    _validationNecessary: function _validationNecessary(settings, form) {
      return this.widgetValidationRequests.length > 0 || this.validationContextId === null;
    },

    /**
     * Executes ajax call - if partialUpdate is on the same page it uses its queue to synchronize requests.
     *
     * @param settings
     */
    _ajax: function _ajax(settings) {
      if ($.partialUpdate && $.partialUpdate.ajaxManager) {
        settings.clearCache = true;
        $.partialUpdate.ajaxManager.executeAjaxCall(settings);
      } else {
        $.ajax(settings);
      }
    },

    _startServerCall: function _startServerCall() {
      this.xhrRunning = true;
      this._log("Validation request running ...");
      this.lastServerCall = new Date();
      //copy all current requests and empty the queue
      var validatedWidgets = this.widgetValidationRequests;
      this.pendingWidgetValidationRequests = this.widgetValidationRequests;
      this.widgetValidationRequests = [];
      return validatedWidgets;
    },

    _displayContainerStatus: function _displayContainerStatus(containerStatus, form, settings) {
      if (containerStatus && $("#" + containerStatus.widgetMessageId).length > 0) {
        if (this.validationBeforeSubmitRequested) {
          settings.replaceHandler.call(this, containerStatus, form);
          $.liveValidation.predefinedMethods.containerMessagesAnimator(containerStatus, settings);
          return true;
        } else {
          $("#" + containerStatus.widgetMessageId, form).empty();
          return false;
        }
      }
      return false;
    },

    _successFinishServerCall: function _successFinishServerCall(settings, form, result, textStatus, xhr) {
      this.xhrRunning = false;
      this._log("Validation request finished.");
      if (result.error === true) {
        //copy back widgets that should have been validated and were not
        for (var i in this.pendingWidgetValidationRequests) {
          var requestedAgain = false;
          var pendingWidgetValidationRequest = this.pendingWidgetValidationRequests[i];
          for (var j in this.widgetValidationRequests) {
            var currentValidationRequest = this.widgetValidationRequests[j];
            if (currentValidationRequest === pendingWidgetValidationRequest) {
              requestedAgain = true;
              break;
            }
          }
          if (!requestedAgain) {
            this.widgetValidationRequests.push(pendingWidgetValidationRequest);
          }
        }
        //handle error
        if (result.errorMessage.indexOf("Error 01") > -1) {
          this._log("Validation context id " + this.validationContextId + " no longer exists. Initiating new context handshake.");
          this.validationContextId = null;
          this._validateOnServer(settings, form);
        } else if (result.errorMessage.indexOf("Error 04") > -1) {
          this._log("Form state " + this.validationContextId + " no longer exists. " + "Live validation context cannot be recreated - server side already released all connected " + "resources and page must be refreshed entirely.");
          this.validationContextId = null;
        } else if (result.errorMessage.indexOf("Error 02") > -1) {
          this._log("Parallel server call occured. Issuing new call with timeout.");
          setTimeout(this._validateOnServer.call(this, settings, form), 200);
        } else {
          this._log("Unknown error on server: " + result.errorMessage);
          //call callback function if required
          if ($.isFunction(settings.failedCallback)) {
            settings.failedCallback(settings, form, xhr, "500", result.errorMessage);
          }
        }
      } else {
        if (this.validationContextId === null) {
          this.validationContextId = result.data.validationContextId;
        }
        //render messages
        var anyFormErrors = false;

        //this closure has logic content only on second and subsequent calls
        //it marks widget DOM element with error class and triggers events for them
        var handleUpdate = function handleUpdate(widget) {
          var widgetRef = $("#" + widget.widgetId, form);
          var widgetRefCnt = $("#" + widget.widgetId + "__container", form);
          if (widgetRefCnt.length === 0 && widget.widgetId.match(/[\w\d_]+?-\d+/)) {
            var lastDash = widget.widgetId.lastIndexOf('-');
            widgetRefCnt = $("#" + widget.widgetId.substr(0, lastDash) + "__container" + widget.widgetId.substr(lastDash), form);
          }
          if (widgetRefCnt.length === 0) {
            widgetRefCnt = widgetRef.parents(".errorContainer");
          }
          if (widgetRefCnt.length === 0) {
            widgetRefCnt = widgetRef;
          }
          if (widget.hasErrors) {
            if (settings.fieldErrorClass) {
              widgetRefCnt.addClass(settings.fieldErrorClass, true);
            }
            if (settings.fieldOkClass) {
              widgetRefCnt.removeClass(settings.fieldOkClass);
            }
            if (settings.fieldWarningClass) {
              widgetRefCnt.removeClass(settings.fieldWarningClass);
            }
          } else if (widget.hasInfos) {
            if (settings.fieldWarningClass) {
              widgetRefCnt.addClass(settings.fieldWarningClass, true);
            }
            if (settings.fieldErrorClass) {
              widgetRefCnt.removeClass(settings.fieldErrorClass);
            }
            if (settings.fieldOkClass) {
              widgetRefCnt.removeClass(settings.fieldOkClass);
            }
          } else {
            if (settings.fieldOkClass) {
              widgetRefCnt.addClass(settings.fieldOkClass, true);
            }
            if (settings.fieldErrorClass) {
              widgetRefCnt.removeClass(settings.fieldErrorClass);
            }
            if (settings.fieldWarningClass) {
              widgetRefCnt.removeClass(settings.fieldWarningClass);
            }
          }
          if (this.containerStatusDisplayed) {
            $("#" + widget.widgetMessageId, form).empty();
          } else {
            if (true === widget.hasMessages) {
              this.widgetMessages[widget.widgetId] = widget.messages;
              settings.replaceHandler.call(this, widget, form);
            }
          }
        };

        this.containerStatusDisplayed = this._displayContainerStatus(result.data.containerStatus, form, settings);
        $(form).trigger('afterServerValidation', [result.data]);
        dispatchEvent($(form)[0], 'afterServerValidation', { data: result.data });
        for (var validatedWidget in result.data.widgets) {
          //iterate over all widgets and fire events for them and examine their result
          var widget = result.data.widgets[validatedWidget];
          var widgetRef = $("#" + widget.widgetId, form);
          var wasChanged = this.validatedValues[widget.widgetInputName] !== widget.validatedValue;
          this.validatedValues[widget.widgetInputName] = widget.validatedValue;
          anyFormErrors = anyFormErrors || widget.hasErrors;
          //visualize error / info only for already visited widgets
          if (this.visitedInputs[widget.widgetInputName] === true) {
            //also
            handleUpdate.call(this, widget);
            for (var messageKey in widget.keyedMessages) {
              var widgetVariant = jQuery.extend(true, {}, widget, {
                widgetId: widget.widgetId + "-" + messageKey,
                widgetMessageId: widget.widgetMessageId + "-" + messageKey,
                messages: widget.keyedMessages[messageKey],
                hasErrors: widget.hasKeyedErrors[messageKey]
              });
              anyFormErrors = anyFormErrors || widget.hasKeyedErrors[messageKey];
              var visitedInputId = this.visitedInputIds[widget.widgetInputName];
              if (visitedInputId && visitedInputId[widgetVariant.widgetId] === true) {
                handleUpdate.call(this, widgetVariant);
              }
            }
          } else {
            for (var messageKey in widget.keyedMessages) {
              anyFormErrors = anyFormErrors || widget.hasKeyedErrors[messageKey];
            }
          }
          //we trigger validation only if value of the widget changed
          if (wasChanged) {
            if (widget.hasErrors) {
              widgetRef.trigger("validationFailedForWidget", widget.widgetId);
            } else {
              widgetRef.trigger("validationPassedForWidget", widget.widgetId);
            }
          }
        }

        this.lastValidationResult = result;
        if (anyFormErrors) {
          $(form).trigger("validationFailed", [result.data, this.lastRequestValidationInput]);
        } else {
          $(form).trigger("validationPassed", [result.data, this.lastRequestValidationInput]);
        }
        //call callback function if required
        if ($.isFunction(settings.successCallback)) {
          settings.successCallback(settings, this, form, xhr, textStatus, result);
        }
      }
    },

    _failureFinishServerCall: function _failureFinishServerCall(settings, form, jqXHR, textStatus, errorThrown) {
      this._log("Failed to validate: " + textStatus + "(" + errorThrown + ")");
      this.xhrRunning = false;
      //call callback function if required
      if ($.isFunction(settings.failedCallback)) {
        settings.failedCallback(settings, this, form, jqXHR, textStatus, errorThrown);
      }
    },

    /**
     * Tweaked jQuery serialize array including file types.
     * @param node
     */
    _specificSerializeArray: function _specificSerializeArray(settings, node, namePattern) {
      return node.map(function () {
        return this.elements ? jQuery.makeArray(this.elements) : this;
      }).filter(function () {
        return this.name && (!namePattern || this.name.match(namePattern)) && !this.disabled && (this.checked || /select|textarea/i.test(this.nodeName) || /text|hidden|password|search|file|number|email|url|tel|range|date|month|week|time|datetime|datetime-local|color/i.test(this.type));
      }).map(function (i, elem) {
        var val = jQuery(this).val();
        if (elem.type === 'file') {
          val = [].concat(_toConsumableArray(elem.files)).map(function (_ref) {
            var name = _ref.name;
            return 'C:/fakepath/' + name;
          });
        }
        if (settings.showTipsInInputs === true && (elem.type === "text" || /textarea/i.test(this.nodeName))) {
          if (val === elem.title) {
            val = "";
          }
        }
        return val === null ? null : jQuery.isArray(val) ? jQuery.map(val, function (val, i) {
          return { name: elem.name, value: val };
        }) : { name: elem.name, value: val };
      }).get();
    },

    /**
     * This function will call server logic for validation results.
     * @param settings
     * @param form
     */
    _validateOnServer: function _validateOnServer(settings, form) {
      var validatedWidgets = this._startServerCall();

      //prepare form data for validation along with context id
      var ajaxData;
      if (this.validationContextId === null) {
        ajaxData = this._specificSerializeArray(settings, $(form));
      } else {
        ajaxData = this._specificSerializeArray(settings, $(form), new RegExp('^(?!frm\.).+'));
        ajaxData[ajaxData.length] = {
          name: "Live-Validation-Context-Id",
          value: this.validationContextId
        };
        if (this.clickedEvent) {
          ajaxData[ajaxData.length] = {
            name: this.clickedEvent.target.name,
            value: this.clickedEvent.target.value
          };
        }
      }
      var widgetNames = "";
      var processedNames = {};
      for (var i = 0; i < validatedWidgets.length; i++) {
        var validatedWidget = validatedWidgets[i];
        var widgetName = typeof validatedWidget === "string" ? validatedWidget : $(validatedWidget).attr("name");
        if (processedNames[widgetName] !== true) {
          processedNames[widgetName] = true;
          var dataIndex = widgetName.indexOf("!");
          var inputElement = dataIndex === -1 ? $(form).find("*[name=\"" + widgetName + "\"]") : $(form).find("*[name^=\"" + widgetName.substr(0, dataIndex) + "!\"]");
          var inputElementValue = this._specificSerializeArray(settings, inputElement);
          for (var j = 0; j < inputElementValue.length; j++) {
            ajaxData.push(inputElementValue[j]);
          }
          //complete concatenated string of all widgets that needs to be validated
          if (widgetNames.length > 0) {
            widgetNames += ";";
          }
          widgetNames += widgetName;
        }
      }
      ajaxData[ajaxData.length] = {
        name: "Live-Validation-Requested-Widgets",
        value: widgetNames
      };
      ajaxData[ajaxData.length] = {
        name: "Live-Validation-Form",
        value: $(form).attr("id")
      };
      if (settings.ramJetLayoutContext) {
        ajaxData[ajaxData.length] = {
          name: 'ramJetLayoutContext',
          value: settings.ramJetLayoutContext
        };
      }
      //derive target url from current location
      var validationUrl = settings.validationUrlHandler(window.location);
      var liveValidationMgr = this;

      //call server finally
      this._ajax({
        type: "POST",
        url: validationUrl,
        data: ajaxData,
        dataType: 'json',
        success: function success(result, textStatus, xhr) {
          liveValidationMgr._successFinishServerCall.call(liveValidationMgr, settings, form, result, textStatus, xhr);
        },
        error: function error(jqXHR, textStatus, errorThrown) {
          liveValidationMgr._failureFinishServerCall.call(liveValidationMgr, settings, form, jqXHR, textStatus, errorThrown);
        }
      });
    },

    /**
     * Returns true if any errors are present or form has not been yet checked.
     * @param settings
     * @param form
     */
    _anyErrorsPresent: function _anyErrorsPresent(settings, form) {
      var errorsPresent = this.lastValidationResult === null;
      if (errorsPresent === false) {
        var widgetData = this.lastValidationResult.data.widgets;
        for (var widgetStatusKey in widgetData) {
          if (widgetData[widgetStatusKey].hasErrors === true) {
            errorsPresent = true;
          }
        }
      }
      return errorsPresent;
    },

    /**
     * Method executes form submit.
     * @param event
     * @param form
     * @param callback
     */
    _executePostponedSubmit: function _executePostponedSubmit(event, form, callback) {
      if ($.isFunction(callback)) {
        if (callback(event, form) === false) {
          return false;
        }
      }
      if (this.clickedEvent) {
        var clickedEvent = this.clickedEvent;
        var clickedButton = null;
        if (clickedEvent.target.tagName.toLowerCase() === 'input' || clickedEvent.target.tagName.toLowerCase() === 'button') {
          clickedButton = clickedEvent.target;
        } else {
          var parents = $(clickedEvent.target).parents('input, button');
          if (parents.length > 0) {
            clickedButton = parents.get(0);
          }
        }
        if (clickedButton !== null) {
          if (clickedButton.tagName.toLowerCase() === 'button' || clickedButton.tagName.toLowerCase() === 'input' && clickedButton.type.toLowerCase() === "submit") {
            $("<input id=\"" + clickedButton.id + "_ramJetLiveValidationFakeInput\" type=\"hidden\" name=\"" + clickedButton.name + "\" value=\"" + clickedButton.value + "\"/>").appendTo(form);
            form.submit();
            //we have to remove created hidden fields in order to clear battleground for cases when someone other stops submitting the form
            //or submit leads to the standalone window and original DOM is reused for other submits
            $("#" + clickedButton.id + "_ramJetLiveValidationFakeInput").remove();
          } else if (clickedButton.tagName.toLowerCase() === 'input' && clickedButton.type.toLowerCase() === "image") {
            var elementOffset = $(clickedEvent.target).offset();
            $("<input id=\"" + clickedButton.id + "_ramJetLiveValidationFakeInputX\" type=\"hidden\" name=\"" + clickedButton.name + ".x\" value=\"" + Math.round(clickedEvent.pageX - elementOffset.left) + "\"/>").appendTo(form);
            $("<input id=\"" + clickedButton.id + "_ramJetLiveValidationFakeInputY\" type=\"hidden\" name=\"" + clickedButton.name + ".y\" value=\"" + Math.round(clickedEvent.pageY - elementOffset.top) + "\"/>").appendTo(form);
            form.submit();
            //we have to remove created hidden fields in order to clear battleground for cases when someone other stops submitting the form
            //or submit leads to the standalone window and original DOM is reused for other submits
            $("#" + clickedButton.id + "_ramJetLiveValidationFakeInputX").remove();
            $("#" + clickedButton.id + "_ramJetLiveValidationFakeInputY").remove();
          }
        } else {
          form.submit();
        }
      }
    },

    /**
     * Focuses first input that has error registered.
     *
     * @param settings
     * @param form
     */
    _focusOnFirstError: function _focusOnFirstError(settings, form) {
      if (this.lastValidationResult) {
        var indexedInputRegex = /.*?-(\d+)$/;
        var widgetInputIndex = {};
        var widgetStatuses = this.lastValidationResult.data.widgets;
        for (var widgetName in widgetStatuses) {
          var widgetStatus = widgetStatuses[widgetName];
          widgetInputIndex[widgetStatus.widgetInputName] = widgetStatus;
        }
        var inputs = $(form).find("input, select, textarea").not(":submit, :reset, :image, [disabled]");
        for (var i = 0; i < inputs.length; i++) {
          var input = inputs.get(i);
          var matches = indexedInputRegex.exec(input.id);
          var indexed = matches !== null;
          var widgetResult = widgetInputIndex[input.name];
          if (widgetResult && widgetResult.hasErrors && (!indexed || widgetResult.hasKeyedErrors[matches[1]])) {

            var fixedOffset = settings && settings.fixedOffset ? settings.fixedOffset : 0;
            var wantedScrollTop = $(input).offset().top + fixedOffset;
            if ($(window).scrollTop() > wantedScrollTop) {
              $('html, body').animate({
                scrollTop: wantedScrollTop
              }, 250);
            }

            input.focus();
            return;
          }
        }
      }
    },

    /**
     * Registers input as visited.
     * @param inputName
     * @param inputId
     */
    _registerVisitedInput: function _registerVisitedInput(inputName, inputId) {
      var dataDelimiter = inputName.indexOf("!");
      if (dataDelimiter > -1) {
        var data = inputName.substr(dataDelimiter + 1);
        var dataInId = "-" + data;
        var idDataDelimiter = inputId.lastIndexOf(dataInId);
        inputName = inputName.substr(0, dataDelimiter);
        if (idDataDelimiter > -1) {
          inputId = inputId.substr(0, idDataDelimiter + dataInId.length);
        }
      }
      this.visitedInputs[inputName] = true;
      var widgetIds = this.visitedInputIds[inputName];
      if (!widgetIds) {
        widgetIds = {};
        this.visitedInputIds[inputName] = widgetIds;
      }
      if (inputId) {
        widgetIds[inputId] = true;
      }
    },

    /**
     * This method is called when UI input element gets modified and should be validated against backend logic.
     * @param settings
     */
    requestValidation: function requestValidation(settings, event) {
      var inputName = event.target.name;
      var inputId = event.target.id;
      var validatedValue = this.validatedValues[inputName];

      this.lastRequestValidationInput = inputName;

      var isAlreadyValidatedValue = function isAlreadyValidatedValue(value) {
        if (validatedValue === undefined) {
          validatedValue = "";
        }
        return validatedValue === value;
      };

      var findInValues = function findInValues(name, values) {
        for (var i in values) {
          var item = values[i];
          if (item.name === name) {
            return item;
          }
        }
        return null;
      };
      var getNewValue = function getNewValue() {
        var jForm = $(event.target).parents("form");
        var inputName = event.target.name;
        var dataIndex = inputName.indexOf("!");
        var inputElement = dataIndex === -1 ? jForm.find("*[name=\"" + inputName + "\"]") : jForm.find("*[name^=\"" + inputName.substr(0, dataIndex) + "!\"]");
        var value = this._specificSerializeArray(settings, inputElement);
        var joinedValue = "";
        var dataIndexes = [];
        for (var i = 0; i < inputElement.length; i++) {
          var element = inputElement.get(i);
          var elementName = element.name;
          var elementDataIndex = elementName.indexOf("!");
          var extractedValue;
          if (elementDataIndex === -1) {
            extractedValue = findInValues(elementName, value);
          } else {
            var elementDataIndexValue = elementName.substr(elementDataIndex + 1);
            if (dataIndexes[elementDataIndexValue] === true) {
              continue;
            } else {
              dataIndexes[elementDataIndexValue] = true;
              extractedValue = findInValues(elementName, value);
            }
          }
          if (joinedValue !== "") {
            joinedValue += "|";
          }
          joinedValue += extractedValue ? extractedValue.value : "";
        }
        return joinedValue;
      };
      var newValue = getNewValue.call(this);
      if (settings.showTipsInInputs === true && newValue === $(event.target).attr("title")) {
        newValue = "";
      }

      var doValidateFunction = function doValidateFunction() {
        for (var i = 0; i < this.widgetValidationRequests.length; i++) {
          if (this.widgetValidationRequests[i] === event.target) {
            return;
          }
        }
        if (true !== this.visitedInputs[inputName]) {
          this._log("Requested first validation for: " + inputName + "(value: " + newValue + ")");
        } else {
          this._log("Requested validation for: " + inputName + "(old value: " + validatedValue + ", new value: " + newValue + ")");
        }
        this._registerVisitedInput.call(this, inputName, inputId);
        this.widgetValidationRequests.push(event.target);
        this.validate(settings, $(event.target).parents("form"));
      };

      var type = event.target.type.toLocaleLowerCase();
      var checkableAndEmpty = ("checkbox" === type || "radio" === type) && !event.target.checked;
      var alreadyValidated = isAlreadyValidatedValue(newValue);
      var notVisitedYet = this.visitedInputs[inputName] !== true;
      if (!alreadyValidated || notVisitedYet || alreadyValidated && checkableAndEmpty) {
        doValidateFunction.call(this);
      } else {
        if (settings.validationNotNecessaryHandler.call(this, event)) {
          doValidateFunction.call(this);
        }
      }
    },

    /**
     * This method is called when form is requested to be submitted.
     * @param settings
     * @param event
     * @param data
     * @param defferedLambda
     */
    requestSubmit: function requestSubmit(settings, event, data, defferedLambda) {
      if (data && data === $.partialUpdate && !defferedLambda) {
        return true;
      }
      var executePostponedLogic = defferedLambda;
      if (settings.preventSubmitOnErrors && this.forceSubmit === false) {
        if (!executePostponedLogic) {
          executePostponedLogic = function executePostponedLogic() {
            liveValidationMgr._executePostponedSubmit.call(liveValidationMgr, event, form, settings.successCallback);
          };
        }

        if (this.submitInProcess === false) {
          var liveValidationMgr = this;
          var form = event.target.tagName.toLocaleLowerCase() === "form" ? $(event.target) : $(event.target).parents("form");
          liveValidationMgr._registerVisitedInput(form.attr("name"), form.attr("id"));
          liveValidationMgr.widgetValidationRequests.push(form.get(0));
          liveValidationMgr.validationBeforeSubmitRequested = true;
          //test whether validation isn't already running
          if (liveValidationMgr.xhrRunning === true) {
            //postpone late validation
            if (liveValidationMgr.timeoutSet !== null) {
              clearTimeout(liveValidationMgr.timeoutSet);
            }
            liveValidationMgr._log("Postponing submit handling - validation is currently running ...");
            liveValidationMgr.timeoutSet = setTimeout(function () {
              if (liveValidationMgr.requestSubmit(settings, event, data, defferedLambda)) {
                liveValidationMgr.forceSubmit = true;
                liveValidationMgr.submitInProcess = true;
                executePostponedLogic();
              }
            }, 300);
            event.preventDefault();
            event.stopPartialUpdate = true;
            return false;
          } else {
            //execute immediately
            if (liveValidationMgr.lastValidationResult) {
              //register all error widgets that has no error messages displayed next to them
              var widgetData = liveValidationMgr.lastValidationResult.data.widgets;
              for (var widgetStatusKey in widgetData) {
                var widgetStatus = widgetData[widgetStatusKey];
                liveValidationMgr._registerVisitedInput.call(liveValidationMgr, widgetStatus.widgetInputName);
                form.find("input, select, textarea").each(function () {
                  liveValidationMgr._registerVisitedInput.call(liveValidationMgr, widgetStatus.widgetInputName, $(this).attr("id"));
                });
                liveValidationMgr.widgetValidationRequests.push(widgetStatus.widgetInputName);
              }
              //execute post after validation has been performed
              dispatchEvent($(form)[0], 'beforeServerValidation');
              liveValidationMgr._validateOnServer($.extend({
                successCallback: function successCallback(settings, mgr, form, xhr, textStatus, result) {
                  if (liveValidationMgr._anyErrorsPresent.call(liveValidationMgr, settings, form) === false) {
                    liveValidationMgr._log.call(liveValidationMgr, "No errors in form found ... continuing with submit.");
                    liveValidationMgr.forceSubmit = true;
                    liveValidationMgr.submitInProcess = true;
                    executePostponedLogic();
                  } else if (liveValidationMgr.lastValidationResult.data.requires === "nothing") {
                    liveValidationMgr._log.call(liveValidationMgr, "This kind of event doesn't require validation ... continuing with submit.");
                    liveValidationMgr.forceSubmit = true;
                    liveValidationMgr.submitInProcess = true;
                    executePostponedLogic();
                  } else {
                    if (!liveValidationMgr.containerStatusDisplayed) {
                      liveValidationMgr._focusOnFirstError.call(liveValidationMgr, settings, form);
                    }
                    liveValidationMgr.validationBeforeSubmitRequested = false;
                  }
                },
                failedCallback: function failedCallback() {
                  liveValidationMgr._executePostponedSubmit.call(liveValidationMgr, event, form, settings.failedCallback);
                }
              }, settings), form);
              event.preventDefault();
              event.stopPartialUpdate = true;
              return false;
            } else {
              //validation results not available, rather submit form and let server validate
              return true;
            }
          }
        } else {
          //submit is already being processed
          event.preventDefault();
          event.stopPartialUpdate = true;
          return false;
        }
      }
    },

    /**
     * This method is called when form is about to be submited.
     * @param settings
     * @param form
     */
    validate: function validate(settings, form) {
      if (this._validationNecessary(settings, form)) {
        var tooEarly = this.lastServerCall !== null && new Date().getTime() < this.lastServerCall.getTime() + settings.minimalWaitInterval;
        if (this.xhrRunning || tooEarly) {
          //postpone call to next time frame
          if (this.timeoutSet === null) {
            var liveValidationMgr = this;
            this.timeoutSet = setTimeout(function () {
              liveValidationMgr.timeoutSet = null;
              liveValidationMgr.validate(settings, form);
            }, this.lastServerCall.getTime() - new Date().getTime() + 1);
          }
        } else {
          this._validateOnServer(settings, form);
        }
      }
    }
  };

  $.liveValidation = {
    predefinedMethods: {

      /**
       * Animates container message errors if any.
       * @param containerStatus
       * @param settings
       */
      containerMessagesAnimator: function containerMessagesAnimator(containerStatus, settings) {
        setTimeout(function () {
          $("#" + containerStatus.widgetMessageId).on("click", "a[data-focus]", function (event) {
            var input = $("#" + $(event.target).attr("data-focus"));
            var fixedOffset = settings && settings.fixedOffset ? settings.fixedOffset : 0;
            var wantedScrollTop = $(input).offset().top + (fixedOffset ? parseInt(fixedOffset) : 0);
            if ($(window).scrollTop() > wantedScrollTop) {
              $('html, body').animate({
                scrollTop: wantedScrollTop
              }, 250);
            }
            input.focus();
            event.preventDefault();
            return false;
          });
        }, 250);
      },

      /**
       * Performs simple messages replace.
       * @param status
       * @param form
       */
      simpleReplace: function simpleReplace(status, form) {
        $("#" + status.widgetMessageId, form).replaceWith(status.messages);
      },

      /**
       * Performs simple messages replace with animation.
       * @param status
       */
      simpleAnimatedReplace: function simpleAnimatedReplace(status) {
        var $widgetMessages = $("#" + status.widgetMessageId);
        $widgetMessages.hide("normal", function () {
          $widgetMessages.replaceWith(status.messages).show("normal");
        });
      },

      /**
       * Logs information that validation would be skipped (not necessary as value has not changed)
       * @param event
       */
      simpleValidationNotNecessaryHandler: function simpleValidationNotNecessaryHandler(event) {
        this._log("Validated value hasn't changed - validation request stopped for: " + event.target.id);
        return false;
      }

    }
  };

  $.fn.liveValidation = function (settings) {
    //noinspection MagicNumberJS
    var finalSettings = $.extend({
      preventSubmitOnErrors: false,
      validationUrlHandler: function validationUrlHandler(location) {
        return location.href.replace("/qf/", "/validate/");
      },
      replaceHandler: $.liveValidation.predefinedMethods.simpleReplace,
      validationNotNecessaryHandler: $.liveValidation.predefinedMethods.simpleValidationNotNecessaryHandler,
      minimalWaitInterval: 1000,
      fieldErrorClass: "error",
      fieldWarningClass: null,
      fieldOkClass: null,
      ramJetLayoutContext: null
    }, settings);

    var hasPlaceholderSupport = function () {
      var input = document.createElement('input');
      return 'placeholder' in input;
    }();
    var useHtml5Placeholders = hasPlaceholderSupport && finalSettings.showTipsInInputs === true;
    if (useHtml5Placeholders) {
      finalSettings.showTipsInInputs = false;
    }

    //bind handlers to inputs and buttons in forms
    return this.each(function () {
      var innerLvForms = $(this).find("form");
      var lvForms = $(this).filter("form").add(innerLvForms);
      lvForms.each(function () {
        if (!$(this).data("liveValidation")) {
          var liveValidationMgr = new $.liveValidationManager();
          // doplnění finalSettings do instance liveValidace
          liveValidationMgr.finalSettings = finalSettings;
          $(this).data("liveValidation", liveValidationMgr);
          // hints part
          if (finalSettings.showTipsInInputs === true) {
            var removeHintFct = function removeHintFct() {
              var me = $(this);
              if (me.val() === me.attr("title")) {
                me.val("").removeClass("hintDisplayed");
              }
            };
            var addHintFct = function addHintFct() {
              var me = $(this);
              if (me.val() === "" && !(me.get(0) === document.activeElement)) {
                me.val(me.attr("title")).addClass("hintDisplayed");
              }
            };
            $("input:text, textarea", this).on("focus", removeHintFct).on("blur", addHintFct).each(function () {
              addHintFct.call(this);
            });
            //after partial update replacement immediately fill in hints
            $(this).bind("afterContentsReplaced", function () {
              $("input:text, textarea", this).each(function () {
                addHintFct.call(this);
              });
            });
            $(this).bind("validationFailed", function () {
              $("input:text, textarea", this).each(function () {
                addHintFct.call(this);
              });
            });
            $(this).submit(function (event, data) {
              $("input:text, textarea", this).each(function () {
                removeHintFct.call(this);
              });
            });
          } else if (useHtml5Placeholders === true) {
            $("input:text, textarea", this).each(function () {
              var $this = $(this);
              if ($this.attr("title") === $this.attr("placeholder")) {
                $this.removeAttr("title");
              }
            });
          }

          //validation part
          liveValidationMgr.validate(finalSettings, this);
          var triggerRequestValidation = function triggerRequestValidation() {
            var jThis = $(this);
            if (jThis.not(":button, :reset, :submit, :hidden, :image, [disabled], .noLiveValidation, .customValidationTrigger").length === 1) {
              jThis.trigger("requestValidation");
            }
          };
          $(this).on("requestValidation", function (event) {
            liveValidationMgr.requestValidation(finalSettings, event);
          });
          $(this).on("blur", "input:not(:file,:radio,:checkbox)", function () {
            triggerRequestValidation.call(this);
          });
          $(this).on("change", "input:file", function () {
            triggerRequestValidation.call(this);
          });
          $(this).on("blur", "select", function () {
            triggerRequestValidation.call(this);
          });
          $(this).on("blur", "textarea", function () {
            triggerRequestValidation.call(this);
          });
          $(this).on("click", ":submit, :image", function (event) {
            var targetType = event.target.tagName.toLowerCase();
            if (targetType === "input" || targetType === "button") {
              liveValidationMgr.clickedEvent = event;
            } else {
              var parentButton = $(event.target).parents("input, button");
              if (parentButton.length > 0) {
                liveValidationMgr.clickedEvent = event;
              }
            }
          });
          $(this).on("click", ":checkbox", function () {
            triggerRequestValidation.call(this);
          });
          $(this).on("change", "select, :radio", function () {
            triggerRequestValidation.call(this);
          });
          $(this).bind("beforeContentsReplaced", function (event, result, textStatus, xhr, settings, container) {
            $(container).find("input, select, textarea").each(function () {
              var inputName = $(this).attr("name");
              if (liveValidationMgr.visitedInputs[inputName] === true) {
                liveValidationMgr.visitedInputs[inputName] = false;
                liveValidationMgr.visitedInputIds[inputName] = {};
                liveValidationMgr._log.call(liveValidationMgr, "Removing input " + inputName + " from visited ones - it gets replaced by partial update.");
              }
            });
          });
          $(this).submit(function (event, data, defferedLamda) {
            var targetType = event.target.tagName.toLowerCase();
            if (targetType === "input" || targetType === "button") {
              liveValidationMgr.clickedEvent = event;
            } else {
              var parentButton = $(event.target).parents("input, button");
              if (parentButton.length > 0) {
                liveValidationMgr.clickedEvent = event;
              }
            }
            return liveValidationMgr.requestSubmit(finalSettings, event, data, defferedLamda);
          });
        }
      });
    });
  };
})(jQuery);

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _PartialUpdateSettings = __webpack_require__(51);

var _eventsFromDOMDatasetsRegister = __webpack_require__(158);

var _connectLinksListeners = __webpack_require__(160);

var _connectLinksListeners2 = _interopRequireDefault(_connectLinksListeners);

var _connectFormsSubmitListeners = __webpack_require__(161);

var _connectFormsSubmitListeners2 = _interopRequireDefault(_connectFormsSubmitListeners);

var _connectHistory = __webpack_require__(159);

var _connectHistory2 = _interopRequireDefault(_connectHistory);

var _partialUpdate = __webpack_require__(45);

var _CursorSpinner = __webpack_require__(168);

__webpack_require__(459);

var _jquery = __webpack_require__(3);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// nastavení defaultních vlastností partial updatu
(0, _PartialUpdateSettings.setPartialUpdateDefaultSettings)({
  onChangeXHRQueue: _CursorSpinner.onChangeXHRQueue,
  // využívá se pro manipulaci s historií
  // je potřeba mít na všech stránkách jsPartialUpdate s id,
  // kde je nastaveno <partialUpdateAlterHistory>true</partialUpdateAlterHistory>
  globalTarget: 'dynamicArea',
  suppressRedirect: true
});


document.addEventListener('partialUpdateComplete', function (_ref) {
  var _ref$detail = _ref.detail,
      settings = _ref$detail.settings,
      hasError = _ref$detail.hasError,
      newAccessibleTarget = _ref$detail.newAccessibleTarget;
  var type = settings.type,
      url = settings.url,
      focusFirstInput = settings.focusFirstInput,
      target = settings.target;

  // zafocusovani do prvnihu inputu

  if (focusFirstInput && target) {
    var firstInput = document.getElementById(target).querySelector('input[type=text], textarea');
    if (firstInput) {
      firstInput.focus();
    }
  }

  // po jakémkoliv přihlášení přes partial update se zaktualizují widgety související s přihlášením
  if (type === 'POST' && !hasError && url.startsWith('/qf/' + window.projectConfig.lang + '/ramjet/performLogin')) {
    var includeTargets = ['userMenu', 'userLists'].filter(function (targetId) {
      return document.getElementById(targetId) != null;
    });
    var locationTargets = ['partialUpdateContainer'].filter(function (targetId) {
      return document.getElementById(targetId) != null;
    });

    // include widgety
    if (includeTargets.length > 0) {
      (0, _partialUpdate.execute)({
        url: '/qf/' + window.projectConfig.lang + '/ramjet/include',
        target: includeTargets
      });
    }
    // PU obsah stranky
    if (locationTargets.length > 0) {
      (0, _partialUpdate.execute)({
        url: location.href,
        target: locationTargets
      });
    }
  }
});

// osetreni fullPageRedirect stranek z pohledu window.history - odkomentujte, pokud NEJSOU zapnute turbolinks
/*document.addEventListener('beforeFullPageRedirect', (event) => {
  event.preventDefault();
  history.replaceState( {} , '', event.detail.location );
  window.location = event.detail.location;
});*/

(0, _eventsFromDOMDatasetsRegister.partialUpdateConnectDatasetListeners)(['slideStop']);
(0, _connectFormsSubmitListeners2.default)();
(0, _connectLinksListeners2.default)({
  alterHistory: true
});
(0, _connectHistory2.default)();

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// deprecated - use SimpleCollapse component!

/**
 * zjednodušené un/collapse . Použití:
 * $('body').simpleCollapse({
 	selector: '.js_open-by-href'
 });

 <a href="#target" class="js_open-by-href"></a>
 <div id="#target"></div>

 možnost uložení do cookie a podle ní znovu otevřít / zavřít příslušný collapsovatelný container
 - zapíná se pomocí data-store-cookie="ID_COOKIE"
 */

var $ = __webpack_require__(3);
__webpack_require__(460);

'use strict';

var PLUGIN_NAME = 'simpleCollapse';

var DEFAULTS = {
	selector: '',
	type: 'href', // href | data-href
	offsetY: -10,
	restoreState: true, // pokud je true, provede se nacteni stavu z cookie v JS, pokud false predpoklada se implementovana logika na serveru
	collapseOnClickOutside: false // collapse pri kliknuti mimo komponentu
};

var SimpleCollapse = function SimpleCollapse(selector, options) {
	this.$t = $(selector);
	this.options = $.extend(true, {}, DEFAULTS, options);
	this._defaults = DEFAULTS;
	this.initialise_();
};

SimpleCollapse.prototype.initialise_ = function () {
	this.state = false;

	var dataRestoreState_ = $(this.options.selector).data('simple-collapse-restore-state');
	if (typeof dataRestoreState_ != 'undefined') {
		this.options.restoreState = String(dataRestoreState_) == 'true';
	}

	if (this.options.restoreState) {
		this.restoreCollapseStates_();
	}

	if (this.options.selector && this.options.selector != '') {
		this.bindEvents_();
	}
};

SimpleCollapse.prototype.bindEvents_ = function () {
	var self_ = this;

	/**
  * bind anchors
  */

	// do collapse on clicking outside element - if enabled
	if (this.options.collapseOnClickOutside) {
		$(window).on('click', function (event) {
			var target = self_.$t.find(self_.options.selector);
			if (target.hasClass('active') && self_.$t.has(event.target).length == 0) {
				target.trigger('click');
			}
		});
	}

	this.$t.on('click', this.options.selector, function (event) {
		event.preventDefault();
		event.stopPropagation();

		// toggle
		var target = self_.getTargetByType_(event.currentTarget);

		$(event.currentTarget).addClass('active-animating');
		$(target).slideToggle({
			complete: function complete(a, jumpedToEnd) {
				$(event.currentTarget).removeClass('active-animating');
				if (self_.options.onAfterOpen && $(target).is(":visible")) {
					self_.options.onAfterOpen();
				}
			}
		});
		$(event.currentTarget).toggleClass('active');

		if ($(event.currentTarget).hasClass('active')) {
			self_.state = true;
		} else {
			self_.state = false;
		}
		self_.setLinkText_($(this));

		// store state to cookie
		var cookieStoreRequired = !!$(event.currentTarget).data('storeCookie');
		if (cookieStoreRequired) {
			var cookieName = $(event.currentTarget).data('storeCookie');
			$.cookie(cookieName, self_.state, { expires: 7, path: '/' });
		};

		// bootstrap slider relayout
		$('.js_bootstrap-slider-input').trigger('EDEESHOP_BOOTSTRAP_SLIDER_RELAYOUT');
	});

	if (self_.options.restoreState) {
		$(document).off('ajaxComplete.simpleCollapse').on('ajaxComplete.simpleCollapse', function () {
			self_.restoreCollapseStates_();
		});
	}
};

SimpleCollapse.prototype.restoreCollapseStates_ = function () {
	var self_ = this;

	$(this.options.selector, this.$t).each(function (index, item) {
		var $item = $(item);

		var cookieRestore = !!$item.data('storeCookie');
		var restore = false;
		if (cookieRestore) {
			restore = $.cookie($item.data('storeCookie'));
		}

		if (restore === 'true') {
			self_.state = true;
			$(self_.getTargetByType_(item)).show();
			$item.addClass('active');
			self_.setLinkText_($item);
		} else if (restore === 'false') {
			self_.state = false;
			$(self_.getTargetByType_(item)).hide();
			$item.removeClass('active');
			self_.setLinkText_($item);
		}
	});
};

SimpleCollapse.prototype.getTargetByType_ = function (el) {
	var result = '';
	switch (this.options.type) {
		case 'data-href':
			result = $(el).attr('data-href');
			break;
		case 'href':
		default:
			result = $(el).attr('href');
			break;
	}
	return result;
};

SimpleCollapse.prototype.setLinkText_ = function (el) {
	var self_ = this,
	    textLabel_;

	if (self_.state) {
		textLabel_ = el.data('simple-collapse-active');
	} else {
		textLabel_ = el.data('simple-collapse-default');
	}

	if (typeof textLabel_ != 'undefined') {
		el.text(textLabel_);
	}
};

/**
 * decide, which methods will be "public"
 */
var API = {};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 * 		if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 * 		if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function (value) {
	var args = arguments;

	return this.each(function () {
		var $this = $(this);

		// get plugin instance
		var plugin = $this.data('plugin_' + PLUGIN_NAME);

		// if there's not, create one
		if (!plugin) {
			plugin = new SimpleCollapse(this, value);
			$this.data('plugin_' + PLUGIN_NAME, plugin);
		}
		// if there is and first parameter is in predefined API methods, call it with rest of params
		else if (API[value]) {
				plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
			}
	});
};

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var jQuery = __webpack_require__(3);

/**
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

/**
 * Create a cookie with the given name and value and other optional parameters.
 *
 * @example $.cookie('the_cookie', 'the_value');
 * @desc Set the value of a cookie.
 * @example $.cookie('the_cookie', 'the_value', { expires: 7, path: '/', domain: 'jquery.com', secure: true });
 * @desc Create a cookie with all available options.
 * @example $.cookie('the_cookie', 'the_value');
 * @desc Create a session cookie.
 * @example $.cookie('the_cookie', null);
 * @desc Delete a cookie by passing null as value. Keep in mind that you have to use the same path and domain
 *       used when the cookie was set.
 *
 * @param String name The name of the cookie.
 * @param String value The value of the cookie.
 * @param Object options An object literal containing key/value pairs to provide optional cookie attributes.
 * @option Number|Date expires Either an integer specifying the expiration date from now on in days or a Date object.
 *                             If a negative value is specified (e.g. a date in the past), the cookie will be deleted.
 *                             If set to null or omitted, the cookie will be a session cookie and will not be retained
 *                             when the the browser exits.
 * @option String path The value of the path atribute of the cookie (default: path of page that created the cookie).
 * @option String domain The value of the domain attribute of the cookie (default: domain of page that created the cookie).
 * @option Boolean secure If true, the secure attribute of the cookie will be set and the cookie transmission will
 *                        require a secure protocol (like HTTPS).
 * @type undefined
 *
 * @name $.cookie
 * @cat Plugins/Cookie
 * @author Klaus Hartl/klaus.hartl@stilbuero.de
 */

/**
 * Get the value of a cookie with the given name.
 *
 * @example $.cookie('the_cookie');
 * @desc Get the value of a cookie.
 *
 * @param String name The name of the cookie.
 * @return The value of the cookie.
 * @type String
 *
 * @name $.cookie
 * @cat Plugins/Cookie
 * @author Klaus Hartl/klaus.hartl@stilbuero.de
 */
jQuery.cookie = function (name, value, options, codeURI) {
    var doCodeURI = true;

    if (typeof codeURI != 'undefined') {
        doCodeURI = codeURI;
    }
    if (typeof value != 'undefined') {
        // name and value given, set cookie
        options = options || {};
        if (value === null) {
            value = '';
            options.expires = -1;
        }
        var expires = '';
        if (options.expires && (typeof options.expires == 'number' || options.expires.toUTCString)) {
            var date;
            if (typeof options.expires == 'number') {
                date = new Date();
                date.setTime(date.getTime() + options.expires * 24 * 60 * 60 * 1000);
            } else {
                date = options.expires;
            }
            expires = '; expires=' + date.toUTCString(); // use expires attribute, max-age is not supported by IE
        }
        // CAUTION: Needed to parenthesize options.path and options.domain
        // in the following expressions, otherwise they evaluate to undefined
        // in the packed version for some reason...
        var path = options.path ? '; path=' + options.path : '';
        var domain = options.domain ? '; domain=' + options.domain : '';
        var secure = options.secure ? '; secure' : '';

        if (doCodeURI) {
            value = encodeURIComponent(value);
        }

        document.cookie = [name, '=', value, expires, path, domain, secure].join('');
    } else {
        // only name given, get cookie
        var cookieValue = null;
        if (document.cookie && document.cookie != '') {
            var cookies = document.cookie.split(';');
            for (var i = 0; i < cookies.length; i++) {
                var cookie = jQuery.trim(cookies[i]);
                // Does this cookie string begin with the name we want?
                if (cookie.substring(0, name.length + 1) == name + '=') {
                    if (doCodeURI) {
                        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                    } else {
                        cookieValue = cookie.substring(name.length + 1);
                    }
                    break;
                }
            }
        }
        return cookieValue;
    }
};

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// web.js